
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fWKP5", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $536332286f9d55b5$export$90dcee7ddb8a0c0c);
const $536332286f9d55b5$var$globalObj = window || $parcel$global;
const $536332286f9d55b5$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
const $536332286f9d55b5$export$90dcee7ddb8a0c0c = (healthcheck = $536332286f9d55b5$var$defaultHealthcheck)=>{
    $536332286f9d55b5$var$globalObj.performHealthcheck = healthcheck;
};

});

parcelRegister("13dJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $52aa3988c26d718d$export$2e2bcd8739ae039);

var $9Szlh = parcelRequire("9Szlh");

var $gQdiM = parcelRequire("gQdiM");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$52aa3988c26d718d$export$2e2bcd8739ae039 = {
    install: (args)=>{
        // @ts-expect-error - TS2322 - Type '{ flags?: boolean | undefined; navigation?: boolean | undefined; renderNavigation: (() => any) | (() => void); upflow?: boolean | undefined; heartbeat?: boolean | undefined; profileCardNextLegacy?: boolean | undefined; ... 4 more ...; searchDwellTimeComponent?: boolean | undefined; }' is not assignable to type 'GlobalArgs'.
        const argsWithDefaults = {
            renderNavigation: $gQdiM.default,
            ...args
        };
        (0, $9Szlh.default).install(argsWithDefaults);
    }
};

});
parcelRegister("9Szlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $576e35908a4913e8$export$2e2bcd8739ae039);

var $jFHCE = parcelRequire("jFHCE");

var $JdXiI = parcelRequire("JdXiI");

var $hWeHP = parcelRequire("hWeHP");

var $k2wyf = parcelRequire("k2wyf");

var $82Phg = parcelRequire("82Phg");

const $576e35908a4913e8$var$renderEngagementMessages = ()=>{
    (parcelRequire("lshWh"));
};

const $576e35908a4913e8$var$renderProfileCardNextLegacy = ()=>{
    (parcelRequire("2bhSk"));
};

const $576e35908a4913e8$var$renderHeartbeat = ()=>{
    (parcelRequire("krIXg"));
};

const $576e35908a4913e8$var$loadUpFlowAPI = ()=>(parcelRequire("9qKSM"));

const $576e35908a4913e8$var$installConnectModules = ()=>(parcelRequire("eGXOi"));
const $576e35908a4913e8$var$markSafeForAnalytics = (str)=>str || null;
const $576e35908a4913e8$var$renderSearchDwellTimeComponent = ()=>{
    const searchSessionId = (0, $hWeHP.default)('ajs-search-session-id');
    const containerId = (0, $hWeHP.default)('ajs-search-container-id');
    const objectId = (0, $hWeHP.default)('ajs-search-object-id');
    const objectType = (0, $hWeHP.default)('ajs-search-content-type');
    (0, $JdXiI.default)([
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ]);
    (0, $82Phg.default)('search-dwell-time', $576e35908a4913e8$var$markSafeForAnalytics(searchSessionId), {
        containerId: $576e35908a4913e8$var$markSafeForAnalytics(containerId),
        objectId: $576e35908a4913e8$var$markSafeForAnalytics(objectId),
        objectType: $576e35908a4913e8$var$markSafeForAnalytics(objectType),
        actionSubject: $576e35908a4913e8$var$markSafeForAnalytics(objectType),
        source: $576e35908a4913e8$var$markSafeForAnalytics(objectType)
    });
};
const $576e35908a4913e8$var$installHighPriorityApps = (args)=>{
    // @ts-expect-error - TS2304 - Cannot find name 'JiraContextContainer'.
    const priorityApps = [];
    if (args.flags) priorityApps.push((0, $k2wyf.renderFlags)());
    if (args.navigation) priorityApps.push(args.renderNavigation());
    return priorityApps;
};
const $576e35908a4913e8$var$installLowPriorityApps = (args)=>{
    if (args.upflow) $576e35908a4913e8$var$loadUpFlowAPI();
    if (args.profileCardNextLegacy) $576e35908a4913e8$var$renderProfileCardNextLegacy();
    if (args.connectModules) $576e35908a4913e8$var$installConnectModules();
    if (args.engagementMessages) $576e35908a4913e8$var$renderEngagementMessages();
    if (args.heartbeat) $576e35908a4913e8$var$renderHeartbeat();
    if (args.searchDwellTimeComponent) $576e35908a4913e8$var$renderSearchDwellTimeComponent();
};
const $576e35908a4913e8$var$installAppsWithPriorityOrder = async (args)=>{
    await Promise.all($576e35908a4913e8$var$installHighPriorityApps({
        flags: args.flags,
        navigation: args.navigation,
        renderNavigation: args.renderNavigation
    }));
    $576e35908a4913e8$var$installLowPriorityApps((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(args, [
        'flags',
        'navigation',
        'renderNavigation'
    ]));
};
const $576e35908a4913e8$var$defaultArgs = {
    flags: true,
    navigation: true,
    upflow: true,
    profileCardNextLegacy: true,
    heartbeat: true,
    connectModules: true,
    engagementMessages: true,
    searchDwellTimeComponent: true,
    renderNavigation: ()=>null
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$576e35908a4913e8$export$2e2bcd8739ae039 = {
    install: (args)=>{
        const argsWithDefaults = {
            ...$576e35908a4913e8$var$defaultArgs,
            ...args
        };
        // @ts-expect-error - TS2345 - Argument of type '{ flags: boolean; navigation: boolean; renderNavigation: (() => any) | (() => null); upflow: boolean; heartbeat: boolean; profileCardNextLegacy: boolean; connectModules: boolean; originTracing?: boolean | undefined; engagementMessages: boolean; searchDwellTimeComponent: boolean; }' is not assignable to parameter of type 'GlobalArgs'.
        $576e35908a4913e8$var$installAppsWithPriorityOrder(argsWithDefaults);
    },
    installHighPriorityApps: (args)=>{
        const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
            ...$576e35908a4913e8$var$defaultArgs,
            ...args
        };
        $576e35908a4913e8$var$installHighPriorityApps({
            flags: flags,
            navigation: navigation,
            renderNavigation: renderNavigation
        });
    },
    installLowPriorityApps: (args)=>{
        const installArgs = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))({
            ...$576e35908a4913e8$var$defaultArgs,
            ...args
        }, [
            'flags',
            'navigation',
            'renderNavigation'
        ]);
        $576e35908a4913e8$var$installLowPriorityApps(installArgs);
    }
};

});
parcelRegister("jFHCE", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $2yYrH = parcelRequire("2yYrH");

var $4qFnH = parcelRequire("4qFnH");

var $inlCv = parcelRequire("inlCv");

var $9Zabf = parcelRequire("9Zabf");

var $3w8z0 = parcelRequire("3w8z0");

var $lgI96 = parcelRequire("lgI96");

var $a5UJr = parcelRequire("a5UJr");
/** Used to compose bitmasks for cloning. */ var $e523af2690bc0ff7$var$CLONE_DEEP_FLAG = 1, $e523af2690bc0ff7$var$CLONE_FLAT_FLAG = 2, $e523af2690bc0ff7$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $e523af2690bc0ff7$var$omit = $lgI96(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $lylkU(paths, function(path) {
        path = $inlCv(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $9Zabf(object, $a5UJr(object), result);
    if (isDeep) result = $2yYrH(result, $e523af2690bc0ff7$var$CLONE_DEEP_FLAG | $e523af2690bc0ff7$var$CLONE_FLAT_FLAG | $e523af2690bc0ff7$var$CLONE_SYMBOLS_FLAG, $3w8z0);
    var length = paths.length;
    while(length--)$4qFnH(result, paths[length]);
    return result;
});
module.exports = $e523af2690bc0ff7$var$omit;

});
parcelRegister("4qFnH", function(module, exports) {

var $inlCv = parcelRequire("inlCv");

var $1ilzu = parcelRequire("1ilzu");

var $cbuUm = parcelRequire("cbuUm");

var $9IlW0 = parcelRequire("9IlW0");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3399b090996478d5$var$baseUnset(object, path) {
    path = $inlCv(path, object);
    object = $cbuUm(object, path);
    return object == null || delete object[$9IlW0($1ilzu(path))];
}
module.exports = $3399b090996478d5$var$baseUnset;

});
parcelRegister("cbuUm", function(module, exports) {

var $5BbSa = parcelRequire("5BbSa");

var $1FqKq = parcelRequire("1FqKq");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $8dee7cd279693843$var$parent(object, path) {
    return path.length < 2 ? object : $5BbSa(object, $1FqKq(path, 0, -1));
}
module.exports = $8dee7cd279693843$var$parent;

});


parcelRegister("3w8z0", function(module, exports) {

var $dtLJW = parcelRequire("dtLJW");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $28fb00d591f4ccb5$var$customOmitClone(value) {
    return $dtLJW(value) ? undefined : value;
}
module.exports = $28fb00d591f4ccb5$var$customOmitClone;

});

parcelRegister("lgI96", function(module, exports) {

var $aX8Tx = parcelRequire("aX8Tx");

var $cMrjq = parcelRequire("cMrjq");

var $hC3zk = parcelRequire("hC3zk");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $f7bd5604b58f6516$var$flatRest(func) {
    return $hC3zk($cMrjq(func, undefined, $aX8Tx), func + '');
}
module.exports = $f7bd5604b58f6516$var$flatRest;

});


parcelRegister("JdXiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $1745b16040d0e430$export$2e2bcd8739ae039);

var $KQtrs = parcelRequire("KQtrs");

var $jFHCE = parcelRequire("jFHCE");
var /**
 * Use to remove query params from url without reload or change history
 * One use case is to remove any tracking id from the url to avoid problems in copy & paste urls or sharing links between users
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$1745b16040d0e430$export$2e2bcd8739ae039 = (paramsToStrip)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($KQtrs))).parse(window.location.href, true);
        const strippedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(parsedUrl.query || {}, paramsToStrip);
        let strippedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($KQtrs))).format({
            ...parsedUrl,
            search: undefined,
            query: strippedQuery
        });
        // we don't want to encode : to %3A in connect project pages
        const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search);
        if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.history.replaceState({}, '', strippedUrl);
    } catch (e) {
    /* uri might be malformed */ }
};

});

parcelRegister("k2wyf", function(module, exports) {

$parcel$export(module.exports, "renderFlags", () => $63a4d32205620443$export$b6228dc14c5adf51);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $eSnSE = parcelRequire("eSnSE");

var $4QIXk = parcelRequire("4QIXk");

var $xvuCV = parcelRequire("xvuCV");

var $1PSAp = parcelRequire("1PSAp");

var $bQWwW = parcelRequire("bQWwW");
const $63a4d32205620443$var$throwError = (message)=>{
    const error = new Error(message);
    (0, $eSnSE.default).safeErrorWithoutCustomerData('flags.entry', message, error);
    throw error;
};
const $63a4d32205620443$var$getContainer = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let container = document.getElementById('flags');
    if (container == null) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        container = document.createElement('div');
        container.id = 'flags';
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body.appendChild(container);
        else $63a4d32205620443$var$throwError('document.body was not found whilst trying to create the flags container');
    }
    return container;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $63a4d32205620443$var$Flags = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("3QD9g")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $63a4d32205620443$var$AfterPaintFlags = (0, $bQWwW.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("3QD9g")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
});
const $63a4d32205620443$export$b6228dc14c5adf51 = ()=>(0, $aQK2r.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QIXk.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: "flags-entry"
    }, __SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63a4d32205620443$var$AfterPaintFlags, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63a4d32205620443$var$Flags, null)))), $63a4d32205620443$var$getContainer());

});
parcelRegister("4QIXk", function(module, exports) {

$parcel$export(module.exports, "JiraContextContainer", () => $abeaaabc4415d61a$export$6f7845cc5e693f16);

var $eJOHy = parcelRequire("eJOHy");

var $2I68T = parcelRequire("2I68T");

var $4qiFT = parcelRequire("4qiFT");

var $7lk3V = parcelRequire("7lk3V");

var $k9PyW = parcelRequire("k9PyW");

var $hWeHP = parcelRequire("hWeHP");

var $3nRRD = parcelRequire("3nRRD");

var $iOVHp = parcelRequire("iOVHp");

var $fEmyV = parcelRequire("fEmyV");

var $4xbv3 = parcelRequire("4xbv3");

var $5HFSX = parcelRequire("5HFSX");

var $g9Vr6 = parcelRequire("g9Vr6");

var $lvKO5 = parcelRequire("lvKO5");

var $hw1Vu = parcelRequire("hw1Vu");
const $abeaaabc4415d61a$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: (0, $fEmyV.routeAnalyticsAttributes)
    }, children);

const $abeaaabc4415d61a$export$6f7845cc5e693f16 = (props)=>{
    const state = {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        messages: (parcelRequire("hXmA9"))
    };
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($abeaaabc4415d61a$var$ContextualAnalyticsDataFeatureFlagged, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextContainer), {
        isGlobal: true,
        getMeta: (0, $hWeHP.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lvKO5.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nRRD.IntlProvider), {
            messages: state.messages,
            locale: (0, $4qiFT.standardizeLocale)(tenantContext.locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2I68T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lk3V.default), {
            orgId: orgId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k9PyW.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HFSX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iOVHp.ModalContextProvider), null, props.children)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hw1Vu.LoadingPhaseManager), null));
};

});
parcelRegister("k9PyW", function(module, exports) {

$parcel$export(module.exports, "ExperienceTrackerProvider", () => $f93b157208a07da2$export$6f49c95a810d59fa);

var $eJOHy = parcelRequire("eJOHy");

var $87Obl = parcelRequire("87Obl");
var $40f0Z = parcelRequire("40f0Z");

var $50BUM = parcelRequire("50BUM");
const $f93b157208a07da2$var$useUnmount = (callback)=>(0, $eJOHy.useEffect)(()=>callback, [
        callback
    ]);
const $f93b157208a07da2$export$6f49c95a810d59fa = ({ children: children })=>{
    const [experienceTracker] = (0, $eJOHy.useState)(new (0, $87Obl.ExperienceTracker)());
    const [cleanupSliSub] = (0, $eJOHy.useState)(()=>experienceTracker.subscribe((0, $50BUM.sliSubscriber)));
    const cleanup = (0, $eJOHy.useCallback)(()=>{
        cleanupSliSub();
    }, [
        cleanupSliSub
    ]);
    $f93b157208a07da2$var$useUnmount(cleanup);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $40f0Z.ExperienceTrackerContext).Provider, {
        value: experienceTracker
    }, children);
};

});
parcelRegister("87Obl", function(module, exports) {

$parcel$export(module.exports, "ExperienceTracker", () => $e3c01902df0392f9$export$12b6b072930fd68f);

var $3qVEN = parcelRequire("3qVEN");
class $e3c01902df0392f9$export$12b6b072930fd68f {
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $3qVEN.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
}

});
parcelRegister("3qVEN", function(module, exports) {

$parcel$export(module.exports, "Experience", () => $31fcf153f689662c$export$c90b54e658fc4d7c);

var $dIA8z = parcelRequire("dIA8z");
function $31fcf153f689662c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $31fcf153f689662c$export$c90b54e658fc4d7c {
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this._hasStopped = false;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $31fcf153f689662c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $31fcf153f689662c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $dIA8z.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $31fcf153f689662c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
}

});
parcelRegister("dIA8z", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeoutError", () => $4ec3f2426402f580$export$d27a2b6293f7631c);
class $4ec3f2426402f580$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}

});



parcelRegister("50BUM", function(module, exports) {

$parcel$export(module.exports, "sliSubscriber", () => $b6949126dda90aac$export$db0b99fe17114899);

var $2Mqjh = parcelRequire("2Mqjh");

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");

const $b6949126dda90aac$var$transformApplication = (application)=>{
    switch(application){
        case 0, $bRJAs.JIRA_SOFTWARE:
            return 'jira-software';
        case 0, $bRJAs.JIRA_PRODUCT_DISCOVERY:
            return 'jira-product-discovery';
        case 0, $bRJAs.JIRA_CORE:
            return 'jira-core';
        case 0, $bRJAs.JIRA_SERVICE_DESK:
            return 'jira-servicedesk';
        case 0, $bRJAs.JIRA_PORTFOLIO:
            return 'jira-portfolio';
        default:
            return 'unknown';
    }
};
const $b6949126dda90aac$var$transformEdition = (edition)=>{
    switch(edition){
        case 0, $a9ldn.FREE_EDITION:
            return 'jedi';
        case 0, $a9ldn.STANDARD_EDITION:
            return 'standard';
        case 0, $a9ldn.PREMIUM_EDITION:
            return 'premium';
        case 0, $a9ldn.UNLICENSED:
            return 'unlicensed';
        default:
            return 'unknown';
    }
};
const $b6949126dda90aac$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
        source: 'ui',
        action: action,
        actionSubject: 'ui',
        attributes: {
            ...additionalAttributes,
            // any attribute on top of this is overridable by any tracker
            task: experience,
            reason: location,
            analyticsSource: analyticsSource,
            application: $b6949126dda90aac$var$transformApplication(application),
            edition: $b6949126dda90aac$var$transformEdition(edition),
            ...errorMessage && {
                errorMessage: errorMessage
            }
        }
    });
const $b6949126dda90aac$var$reportSli = (experienceDescription)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const event = $b6949126dda90aac$var$createAnalyticsEvent(experienceDescription);
        const clientInstance = client.getInstance();
        clientInstance.sendOperationalEvent(event);
    });
};
const $b6949126dda90aac$export$db0b99fe17114899 = (event)=>{
    const { name: name, action: action } = event;
    // @ts-expect-error - TS2339 - Property 'disableSli' does not exist on type '{}'. | TS2339 - Property 'analyticsSource' does not exist on type '{}'. | TS2339 - Property 'application' does not exist on type '{}'. | TS2339 - Property 'edition' does not exist on type '{}'. | TS2339 - Property 'location' does not exist on type '{}'.
    const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
    if (disableSli) return;
    switch(action){
        case 0, $f17fa9e5c82da056$export$627ef4c1ed2d7a9a:
            $b6949126dda90aac$var$reportSli({
                experience: name,
                action: (0, $f17fa9e5c82da056$export$627ef4c1ed2d7a9a),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $f17fa9e5c82da056$export$b48b3d1872522384:
            $b6949126dda90aac$var$reportSli({
                experience: name,
                action: (0, $f17fa9e5c82da056$export$b48b3d1872522384),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                ...event.error && {
                    errorMessage: String(event.error)
                },
                additionalAttributes: additionalAttributes
            });
            break;
        case 0, $f17fa9e5c82da056$export$aeeb00d0845d24d8:
            $b6949126dda90aac$var$reportSli({
                experience: name,
                action: (0, $f17fa9e5c82da056$export$aeeb00d0845d24d8),
                analyticsSource: analyticsSource,
                application: application,
                edition: edition,
                location: location,
                additionalAttributes: additionalAttributes
            });
            break;
        default:
    }
};

});
const $f17fa9e5c82da056$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $f17fa9e5c82da056$export$b48b3d1872522384 = 'taskFail';
const $f17fa9e5c82da056$export$aeeb00d0845d24d8 = 'taskAbort';



parcelRegister("3nRRD", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $d9df13873493f54a$export$480518999dfc4151);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
const $d9df13873493f54a$export$480518999dfc4151 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4nehu.default), {
        ...props,
        defaultLocale: props.locale
    }, children);

});

parcelRegister("iOVHp", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $0dd8465d29e789ed$export$7c9538f5f3c365e9);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $7lK6t = parcelRequire("7lK6t");
const $0dd8465d29e789ed$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $eJOHy.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $eJOHy.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $0dd8465d29e789ed$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $eJOHy.useRef)(1);
    const [modals, setModals] = (0, $eJOHy.useState)([]);
    const modalContext = (0, $eJOHy.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lK6t.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, modals.map((modal)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0dd8465d29e789ed$var$RenderModal, {
            key: modal.key,
            modal: modal
        });
    })));
}

});
parcelRegister("7lK6t", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $da1586d597fd06a3$export$ab57792b9b6974a6);

var $eJOHy = parcelRequire("eJOHy");
const $da1586d597fd06a3$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    openModal: ()=>{}
});

});


parcelRegister("fEmyV", function(module, exports) {

$parcel$export(module.exports, "routeAnalyticsAttributes", () => $4b8de68fd53e342b$export$c71778b3a4356b04);

var $kQnVX = parcelRequire("kQnVX");

var $7A5g5 = parcelRequire("7A5g5");
const $4b8de68fd53e342b$export$c71778b3a4356b04 = Object.defineProperties({}, {
    routeName: {
        enumerable: true,
        get: (0, $kQnVX.getRouteName)
    },
    userLocation: {
        enumerable: true,
        get: (0, $kQnVX.getUserLocation)
    },
    previousSubProduct: {
        enumerable: true,
        get: (0, $kQnVX.getPreviousSubProduct)
    },
    isProjectAdmin: {
        enumerable: true,
        get: (0, $7A5g5.getIsProjectAdmin)
    }
});

});
parcelRegister("7A5g5", function(module, exports) {

$parcel$export(module.exports, "getIsProjectAdmin", () => $f0c7b3bdfa17e57f$export$34ff06260ad17f2b);
$parcel$export(module.exports, "setIsProjectAdmin", () => $f0c7b3bdfa17e57f$export$d53e6d79d3fa5f31);
let $f0c7b3bdfa17e57f$var$projectAdmin = null;
const $f0c7b3bdfa17e57f$export$34ff06260ad17f2b = ()=>{
    // Initialised as null, this likely means we aren't in a
    // project route and the listener hasn't been rendered
    if ($f0c7b3bdfa17e57f$var$projectAdmin == null || !$f0c7b3bdfa17e57f$var$projectAdmin.loading && $f0c7b3bdfa17e57f$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
    if ($f0c7b3bdfa17e57f$var$projectAdmin.loading === true) return 'LOADING';
    return Boolean($f0c7b3bdfa17e57f$var$projectAdmin.isProjectAdmin);
};
const $f0c7b3bdfa17e57f$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
    $f0c7b3bdfa17e57f$var$projectAdmin = projectAdminState;
};

});


parcelRegister("5HFSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ec104d1917a5703$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useJiraRelayEnvironmentProvider", () => $2ec104d1917a5703$export$83fb48644dee72f0);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");
function $2ec104d1917a5703$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.RelayEnvironmentProvider), {
        environment: (0, $7zZ4w.default)()
    }, children);
}
function $2ec104d1917a5703$export$83fb48644dee72f0() {
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return (0, $eJOHy.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("7zZ4w", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf162cdbeeb2a572$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/relay-runtime

var $37Ewn = parcelRequire("37Ewn");

var $ecdTx = parcelRequire("ecdTx");
let $cf162cdbeeb2a572$var$relayEnvironment;
function $cf162cdbeeb2a572$export$2e2bcd8739ae039() {
    if (!$cf162cdbeeb2a572$var$relayEnvironment) {
        const environmentConfig = (0, $ecdTx.getRelayEnvironmentConfig)();
        $cf162cdbeeb2a572$var$relayEnvironment = new (0, $37Ewn.Environment)(environmentConfig);
    }
    return $cf162cdbeeb2a572$var$relayEnvironment;
}

});
parcelRegister("ecdTx", function(module, exports) {

$parcel$export(module.exports, "getRelayEnvironmentConfig", () => $3a6af9693868c9f1$export$a451c85db2d1cda3);

var $hUl5a = parcelRequire("hUl5a");

var $fFqgB = parcelRequire("fFqgB");

var $lmvVe = parcelRequire("lmvVe");
const $3a6af9693868c9f1$export$a451c85db2d1cda3 = ()=>(0, $lmvVe.getDefaultRelayEnvironmentConfig)({
        network: (0, $fFqgB.getNetwork)(),
        log: (0, $hUl5a.default),
        requiredFieldLogger: $hUl5a.requiredFieldLogger
    });

});
parcelRegister("hUl5a", function(module, exports) {

$parcel$export(module.exports, "requiredFieldLogger", () => $8e53fb941ae19e72$export$1ab8b98d209afe85);
$parcel$export(module.exports, "default", () => $8e53fb941ae19e72$export$2e2bcd8739ae039);

var $2QO3b = parcelRequire("2QO3b");

var $eSnSE = parcelRequire("eSnSE");

var $7oY9g = parcelRequire("7oY9g");
const $8e53fb941ae19e72$var$RELAY_CLIENT_ID = 'AGG';
const $8e53fb941ae19e72$var$LOG_NAMESPACE = `relay.${$8e53fb941ae19e72$var$RELAY_CLIENT_ID}.error.graphql`;
const $8e53fb941ae19e72$var$requests = {};
const $8e53fb941ae19e72$var$queries = {};
const $8e53fb941ae19e72$var$resources = {};
const $8e53fb941ae19e72$var$executes = {};
const $8e53fb941ae19e72$var$CLEANUP_TIMEOUT = 300000; // 5 minutes
const $8e53fb941ae19e72$export$1ab8b98d209afe85 = (event)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData($8e53fb941ae19e72$var$LOG_NAMESPACE, '[relay required field error]', {
        kind: event.kind,
        owner: event.owner,
        fieldPath: event.fieldPath,
        message: event.kind === 'relay_resolver.error' ? event.error?.message : null
    });
};
const $8e53fb941ae19e72$var$getResponseSize = (resp)=>{
    if (resp.data === undefined) return 0;
    try {
        return JSON.stringify(resp.data).length;
    } catch (e) {
        return 0;
    }
};
function $8e53fb941ae19e72$export$2e2bcd8739ae039(event) {
    if ((0, $7oY9g.default)('relay_log')) return;
    switch(event.name){
        // NETWORK
        case 'network.start':
            {
                const networkStart = performance.now();
                const { networkRequestId: networkRequestId } = event;
                const { name: name } = event.params;
                const requestInfo = $8e53fb941ae19e72$var$requests[networkRequestId];
                if (requestInfo == null) {
                    const newRequestInfo = {
                        name: name,
                        flushes: [],
                        start: networkStart,
                        networkStart: networkStart
                    };
                    $8e53fb941ae19e72$var$queries[name] = newRequestInfo;
                    $8e53fb941ae19e72$var$requests[networkRequestId] = newRequestInfo;
                    setTimeout(()=>{
                        delete $8e53fb941ae19e72$var$requests[networkRequestId];
                        delete $8e53fb941ae19e72$var$queries[name];
                    }, $8e53fb941ae19e72$var$CLEANUP_TIMEOUT);
                } else requestInfo.networkStart = networkStart;
                break;
            }
        case 'network.next':
            {
                const requestInfo = $8e53fb941ae19e72$var$requests[event.networkRequestId];
                if (requestInfo != null) {
                    const { response: response } = event;
                    const addFlush = (resp)=>{
                        if (resp.data !== null) {
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const res = resp;
                            const flush = {
                                label: res.label != null ? res.label : 'root',
                                time: performance.now(),
                                size: $8e53fb941ae19e72$var$getResponseSize(res)
                            };
                            requestInfo.flushes?.push(flush);
                        }
                    };
                    Array.isArray(response) ? response.forEach(addFlush) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    addFlush(response);
                }
                break;
            }
        case 'network.error':
            {
                const info = $8e53fb941ae19e72$var$requests[event.networkRequestId];
                if (info != null) info.error = event.error;
                break;
            }
        case 'network.info':
            break;
        case 'network.complete':
            {
                const requestInfo = $8e53fb941ae19e72$var$requests[event.networkRequestId];
                const networkComplete = performance.now();
                if (requestInfo != null) {
                    const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                    requestInfo.size = size;
                    requestInfo.networkComplete = networkComplete;
                    requestInfo.flushes = [];
                    (0, $2QO3b.addSpanToAll)('relay', requestInfo.name, [
                        {
                            name: 'network'
                        }
                    ], requestInfo.start, requestInfo.networkComplete, size);
                }
                break;
            }
        case 'network.unsubscribe':
            break;
        // SUSPENSE
        case 'suspense.fragment':
            break;
        case 'suspense.query':
            break;
        // QUERY
        case 'queryresource.fetch':
            {
                const { node: node } = event.operation.root;
                const fetchStart = performance.now();
                // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                if (node.name != null) {
                    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                    const { name: name } = node;
                    const requestInfo = $8e53fb941ae19e72$var$queries[name];
                    if (requestInfo != null) {
                        requestInfo.fetchStart = fetchStart;
                        $8e53fb941ae19e72$var$resources[event.resourceID] = requestInfo;
                    } else {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: fetchStart,
                            fetchStart: fetchStart
                        };
                        $8e53fb941ae19e72$var$queries[name] = newRequestInfo;
                        $8e53fb941ae19e72$var$resources[event.resourceID] = newRequestInfo;
                        setTimeout(()=>{
                            // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'NormalizationSelectableNode'.
                            delete $8e53fb941ae19e72$var$queries[node.name];
                        }, $8e53fb941ae19e72$var$CLEANUP_TIMEOUT);
                    }
                    setTimeout(()=>{
                        delete $8e53fb941ae19e72$var$resources[event.resourceID];
                    }, $8e53fb941ae19e72$var$CLEANUP_TIMEOUT);
                }
                break;
            }
        case 'queryresource.retain':
            {
                const requestInfo = $8e53fb941ae19e72$var$resources[event.resourceID];
                if (requestInfo != null && event.profilerContext != null) {
                    requestInfo.end = performance.now();
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    const context = event.profilerContext;
                    context?.retainQuery?.(requestInfo);
                }
                break;
            }
        // EXECUTE
        case 'execute.start':
            $8e53fb941ae19e72$var$executes[event.executeId] = {
                name: event.params.name,
                kind: event.params.operationKind,
                start: performance.now(),
                duration: 0
            };
            break;
        case 'execute.next.start':
            $8e53fb941ae19e72$var$executes[event.executeId].start = performance.now();
            break;
        case 'execute.next.end':
            {
                const now = performance.now();
                const duration = now - $8e53fb941ae19e72$var$executes[event.executeId].start;
                $8e53fb941ae19e72$var$executes[event.executeId].end = now;
                $8e53fb941ae19e72$var$executes[event.executeId].duration = duration;
                break;
            }
        case 'execute.async.module':
            break;
        case 'execute.error':
            delete $8e53fb941ae19e72$var$executes[event.executeId];
            break;
        case 'execute.complete':
            {
                const op = $8e53fb941ae19e72$var$executes[event.executeId];
                if (op != null) {
                    op.end = performance.now();
                    delete $8e53fb941ae19e72$var$executes[event.executeId];
                }
                break;
            }
        // STORE
        case 'store.publish':
            break;
        case 'store.snapshot':
            break;
        case 'store.restore':
            break;
        case 'store.gc.start':
            break;
        case 'store.gc.end':
            break;
        case 'store.gc.interrupted':
            break;
        // FLUSH
        case 'store.notify.start':
            break;
        case 'store.notify.complete':
            break;
        case 'store.notify.subscription':
            break;
        // ENTRYPOINT
        case 'entrypoint.root.consume':
            break;
        default:
            break;
    }
}

});

parcelRegister("fFqgB", function(module, exports) {

$parcel$export(module.exports, "getNetwork", () => $011c53ed09976f9f$export$7de4970ebfd8206d);

var $37Ewn = parcelRequire("37Ewn");

var $j0pwn = parcelRequire("j0pwn");

var $208o0 = parcelRequire("208o0");

var $lLNFn = parcelRequire("lLNFn");
const $011c53ed09976f9f$export$7de4970ebfd8206d = ()=>{
    if ((0, $lLNFn.isSSR)()) (0, $37Ewn.Network).create((0, $j0pwn.fetch));
    return (0, $37Ewn.Network).create((0, $j0pwn.fetch), (0, $208o0.subscribe));
};

});
parcelRegister("j0pwn", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $8376cd7c57be1686$export$e7aa7bc5c1b3cfb3);

var $7jTnu = parcelRequire("7jTnu");

var $kuzN3 = parcelRequire("kuzN3");

var $kdR84 = parcelRequire("kdR84");
const $8376cd7c57be1686$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    return (0, $7jTnu.fg)('jfp-magma-support-defer') ? (0, $kuzN3.fetch)(request, variables, cacheConfig) : (0, $kdR84.fetch)(request, variables, cacheConfig);
};

});
parcelRegister("kuzN3", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $259e287b96eb4f75$export$e7aa7bc5c1b3cfb3);

var $jPROM = parcelRequire("jPROM");

var $37Ewn = parcelRequire("37Ewn");

var $7jTnu = parcelRequire("7jTnu");

var $hbF3h = parcelRequire("hbF3h");

var $dSA8H = parcelRequire("dSA8H");

var $g1oKu = parcelRequire("g1oKu");

var $7797X = parcelRequire("7797X");

var $iFeTU = parcelRequire("iFeTU");

var $cvB0A = parcelRequire("cvB0A");

var $ePvyd = parcelRequire("ePvyd");

var $icl1h = parcelRequire("icl1h");

var $jHI6h = parcelRequire("jHI6h");

var $jOs4m = parcelRequire("jOs4m");

var $fGcgi = parcelRequire("fGcgi");

var $1uIew = parcelRequire("1uIew");

var $4Yjc9 = parcelRequire("4Yjc9");

var $jC6NO = parcelRequire("jC6NO");

var $c2hs9 = parcelRequire("c2hs9");

var $ll6Lf = parcelRequire("ll6Lf");
// @ts-expect-error the global is placed there by bifrost SSR. See src/entry-fs/util/render.tsx
const $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $259e287b96eb4f75$var$moduleID = 'relay-fetch';
const $259e287b96eb4f75$export$497933998e10dba1 = (request, variables, cacheConfig)=>{
    if (!(0, $7jTnu.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $ll6Lf.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $37Ewn.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $c2hs9.getLoggingAndMetricsHelper)(loggingMetadata);
    function augmentResponse(response) {
        (0, $jHI6h.addTraceId)(queryName, (0, $ll6Lf.getTraceIdFromExtensions)(response));
        (0, $ePvyd.putExtensions)(queryName, response.extensions);
    }
    function validateResponse(response) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
        const errors = response.errors || undefined;
        if (errors != null) {
            const requestId = response?.extensions?.gateway?.request_id;
            if (!(0, $ll6Lf.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
            (0, $g1oKu.captureErrors)(errors, {
                operationName: queryName,
                requestId: requestId
            });
            if ((0, $g1oKu.isUnauthenticated)(errors)) return false;
        }
        return true;
    }
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    const earlyScriptPromise = !false && (0, $cvB0A.claimEarlyScriptPromise)((0, $cvB0A.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    return (0, $37Ewn.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$259e287b96eb4f75$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) {
                    sink.next(payload);
                    // write cache query response on SSR
                    if (false && requestID != null) (0, $iFeTU.getQueryResponseCache)().appendWithMetadata(requestID, variables, payload, loggingMetadata);
                }
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // On client...
            if (!false && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = (0, $iFeTU.getQueryResponseCache)().get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(ssrCache)) {
                    (0, $iFeTU.getQueryResponseCache)().delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $fGcgi.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $fGcgi.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                // We didn't receive everything!
                                const err = new (0, $1uIew.default)(424, `Incomplete handover for relay fetch: ${reason}`);
                                err.name = 'ServerToClientError';
                                loggingAndMetrics.logError(err);
                                sink.error(err, false);
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            const endpoint = (0, $icl1h.getAggEndpoint)(request, cacheConfig);
            const body = (0, $icl1h.getRequestBody)(request, variables);
            const fetchOverNetwork = (0, $4Yjc9.buildGraphqlFetch)(endpoint, (0, $ll6Lf.generateOptions)({
                body: body
            }, endpoint));
            const initialSource = ()=>!false && earlyScriptPromise ? (0, $4Yjc9.withErrorHandling)(earlyScriptPromise) : (0, $4Yjc9.withErrorHandling)(fetchOverNetwork());
            const responses = (0, $4Yjc9.processMultipartPromise)(()=>(0, $dSA8H.retryOnError)(initialSource, {
                    retryFunc: ()=>(0, $4Yjc9.withErrorHandling)(fetchOverNetwork()),
                    retryPredicate: (0, $ll6Lf.shouldRetry),
                    retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                }));
            // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
            // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
            let responseShouldHang = false;
            let firstResponseUsed = false;
            let resolveFirstResponse;
            const firstResponse = new Promise((resolve)=>{
                resolveFirstResponse = resolve;
            });
            responses.subscribe({
                start: ()=>{
                    if (requestID != null) {
                        if (false) {
                            // so that SSR SPA knows it is safe to render
                            const renderAfterThisResponse = $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                            (0, $7797X.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                        } else (0, $7797X.QueryPromisesMap).set(requestID, firstResponse);
                        (0, $7797X.CompletedQueryPromisesMap).set(requestID, completedResponse);
                    }
                },
                next: (response)=>{
                    if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                        // Send the response payload to a side-channel.
                        // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                        (0, $jOs4m.registerEvent)({
                            id: sinkID,
                            name: 'default',
                            args: [
                                response
                            ]
                        });
                        if ('hasNext' in response && response.hasNext === false) finalise();
                        // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                        return;
                    }
                    if (!firstResponseUsed) {
                        firstResponseUsed = true;
                        // according to spec, we can assume the first response is a GraphQLSingularResponse.
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const singularResponse = response;
                        augmentResponse(singularResponse);
                        if (!validateResponse(singularResponse)) {
                            //  Short circuit operation and handle the unauthorized errors.
                            (0, $jC6NO.showUnauthenticatedFlag)(queryName);
                            responseShouldHang = true;
                            return;
                        }
                        enforceNonNullability(singularResponse);
                    }
                    handleResponse(response);
                    // signal that the initial response has been received
                    resolveFirstResponse();
                    // After the initial response, further responses are sent through a side-channel.
                    if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                },
                error: (error)=>{
                    if (!firstResponseUsed) firstResponseUsed = true;
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                },
                complete: ()=>{
                    if (responseShouldHang) return;
                    finalise();
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};
const $259e287b96eb4f75$export$ba44fb13c7d47c03 = (request, variables, cacheConfig)=>{
    if (!(0, $7jTnu.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $ll6Lf.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $37Ewn.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $c2hs9.getLoggingAndMetricsHelper)(loggingMetadata);
    function augmentResponse(response) {
        (0, $jHI6h.addTraceId)(queryName, (0, $ll6Lf.getTraceIdFromExtensions)(response));
        (0, $ePvyd.putExtensions)(queryName, response.extensions);
    }
    function validateResponse(response) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
        const errors = response.errors || undefined;
        if (errors != null) {
            const requestId = response?.extensions?.gateway?.request_id;
            if (!(0, $ll6Lf.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
            (0, $g1oKu.captureErrors)(errors, {
                operationName: queryName,
                requestId: requestId
            });
            if ((0, $g1oKu.isUnauthenticated)(errors)) return false;
        }
        return true;
    }
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    const earlyScriptPromise = !false && (0, $cvB0A.claimEarlyScriptPromise)((0, $cvB0A.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    return (0, $37Ewn.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$259e287b96eb4f75$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $icl1h.getAggEndpoint)(request, cacheConfig);
                const body = (0, $icl1h.getRequestBody)(request, variables);
                const fetchOverNetwork = (0, $4Yjc9.buildGraphqlFetch)(endpoint, (0, $ll6Lf.generateOptions)({
                    body: body
                }, endpoint));
                const initialSource = ()=>!false && earlyScriptPromise ? (0, $4Yjc9.withErrorHandling)(earlyScriptPromise) : (0, $4Yjc9.withErrorHandling)(fetchOverNetwork());
                const responses = (0, $4Yjc9.processMultipartPromise)(()=>(0, $dSA8H.retryOnError)(initialSource, {
                        retryFunc: ()=>(0, $4Yjc9.withErrorHandling)(fetchOverNetwork()),
                        retryPredicate: (0, $ll6Lf.shouldRetry),
                        retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                        onRetry: loggingAndMetrics.logErrorRetry
                    }));
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (false) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $7797X.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $7797X.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $7797X.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (response)=>{
                        if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $jOs4m.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (!validateResponse(singularResponse)) {
                                //  Short circuit operation and handle the unauthorized errors.
                                (0, $jC6NO.showUnauthenticatedFlag)(queryName);
                                responseShouldHang = true;
                                return;
                            }
                            enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (false && requestID != null) (0, $iFeTU.getQueryResponseCache)().appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (false && $259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!false && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = (0, $iFeTU.getQueryResponseCache)().get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(ssrCache)) {
                    (0, $iFeTU.getQueryResponseCache)().delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($259e287b96eb4f75$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $fGcgi.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $fGcgi.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                // We didn't receive everything!
                                const err = new (0, $1uIew.default)(424, `Incomplete handover for relay fetch: ${reason}`);
                                err.name = 'ServerToClientError';
                                loggingAndMetrics.logError(err);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};
const $259e287b96eb4f75$export$e7aa7bc5c1b3cfb3 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('relay-defer-retry-support'), $259e287b96eb4f75$export$ba44fb13c7d47c03, $259e287b96eb4f75$export$497933998e10dba1);

});
parcelRegister("dSA8H", function(module, exports) {

$parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", () => $6a9ace25950bdc28$export$81189edc9b923717);
$parcel$export(module.exports, "retryOnError", () => $6a9ace25950bdc28$export$f859c88bfac2cf2c);
const $6a9ace25950bdc28$export$81189edc9b923717 = 1;
const $6a9ace25950bdc28$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $6a9ace25950bdc28$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $6a9ace25950bdc28$export$81189edc9b923717 ? $6a9ace25950bdc28$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};

});

parcelRegister("g1oKu", function(module, exports) {

$parcel$export(module.exports, "startCaptureGraphQlErrors", () => $9437769c7fa7dcb6$export$c211170518c6d0f6);
$parcel$export(module.exports, "stopCaptureGraphQlErrors", () => $9437769c7fa7dcb6$export$e0491a0d974dadfa);
$parcel$export(module.exports, "captureErrors", () => $9437769c7fa7dcb6$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isUnauthenticated", () => $9437769c7fa7dcb6$export$1724ecfee73c4768);
/**
 * Utility methods to capture GraphQl errors and expose them to the frontend for reporting.
 * ```
 * Sample usage:
 * const id = startErrorCapture();
 * ...
 * const errors = stopErrorCapture(id);
 * ```
 */ 
var $aXKmr = parcelRequire("aXKmr");
const $9437769c7fa7dcb6$var$errorCollector = new Map();
const $9437769c7fa7dcb6$export$da396ad2a542b095 = 120000; // 2min
const $9437769c7fa7dcb6$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $9437769c7fa7dcb6$var$errorCollector.delete(key);
    }, $9437769c7fa7dcb6$export$da396ad2a542b095);
};
const $9437769c7fa7dcb6$export$c211170518c6d0f6 = (key = (0, $aXKmr.v4)())=>{
    $9437769c7fa7dcb6$var$errorCollector.set(key, []);
    $9437769c7fa7dcb6$var$scheduleCleanup(key);
    return key;
};
const $9437769c7fa7dcb6$export$e0491a0d974dadfa = (key)=>{
    const errors = $9437769c7fa7dcb6$var$errorCollector.get(key);
    $9437769c7fa7dcb6$var$errorCollector.delete(key);
    return errors || [];
};
const $9437769c7fa7dcb6$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $9437769c7fa7dcb6$var$errorCollector.forEach((value, key)=>{
        $9437769c7fa7dcb6$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $9437769c7fa7dcb6$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};

});

parcelRegister("7797X", function(module, exports) {

$parcel$export(module.exports, "QueryPromisesMap", () => $bf318a7d5922e713$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $bf318a7d5922e713$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $bf318a7d5922e713$export$607b80f5bc6e396d = new Map();
const $bf318a7d5922e713$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("iFeTU", function(module, exports) {

$parcel$export(module.exports, "getQueryResponseCache", () => $4724696bda51657e$export$3233e692a93c0cfd);

var $1rzja = parcelRequire("1rzja");

var $9Dhvc = parcelRequire("9Dhvc");

var $LFmXM = parcelRequire("LFmXM");

var $37Ewn = parcelRequire("37Ewn");

var $eSnSE = parcelRequire("eSnSE");

var $1uIew = parcelRequire("1uIew");

var $dJ436 = parcelRequire("dJ436");
function $4724696bda51657e$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $37Ewn.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $4724696bda51657e$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
const $4724696bda51657e$export$da2711d74cd28aed = [
    'fetchModulesV2Query'
];
class $4724696bda51657e$export$be21c283b097d175 extends (0, $37Ewn.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!false) setTimeout(()=>{
            this.logUnusedPayloadErrors();
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    logUnusedPayloadErrors() {
        const loggedQueries = new Set();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'. | TS7006 - Parameter 'response' implicitly has an 'any' type. | TS7006 - Parameter 'key' implicitly has an 'any' type.
        this._responses.forEach((response, key)=>{
            const queryID = $4724696bda51657e$export$1e65e863cf3a0f21(key);
            const metadata = this.requestMetadata.get(queryID);
            const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                queryName: 'unknown',
                operationKind: 'unknown'
            };
            if (!loggedQueries.has(queryName) && !$4724696bda51657e$export$da2711d74cd28aed.includes(queryName)) {
                loggedQueries.add(queryName);
                const error = new (0, $dJ436.UnusedRelayResponseError)(queryID);
                const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $1uIew.default) ? 'network' : 'unknown';
                // Log any errors even in SSR
                (0, $eSnSE.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                    message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($1rzja)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
                        'name'
                    ], null)
                });
            }
        });
    }
    /**
	 * @deprecated only sets a single response; does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/jira-s2c-server-dispatcher/src/index.tsx"}.
	 */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
	 * Stores a GraphQLRepsonse along with metadata about the call.
	 * If called multiple times (such as when incremental payloads are received),
	 * will update the stored response to be an array of GraphQLSingularResponse objects,
	 * which Relay is happy to handle.
	 * @deprecated works, but does not work well if requests use defer or stream.
	 *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/jira-s2c-server-dispatcher/src/index.tsx"}.
	 */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
	 * Deletes a request from the store, if found.
	 *
	 * IMPORTANT: Make sure DELETE method always has tests that include get/set
	 * to ensure our `getCacheKey` matches Relay's.
	 *
	 * @returns {boolean} indicating if an entry in the cache was deleted
	 */ delete(queryID, variables) {
        const cacheKey = $4724696bda51657e$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $4724696bda51657e$export$3233e692a93c0cfd = (0, $LFmXM.default)(()=>new $4724696bda51657e$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    }));
const $4724696bda51657e$export$94e535e06b7ade61 = ()=>$4724696bda51657e$export$3233e692a93c0cfd().serialize();

});
parcelRegister("dJ436", function(module, exports) {

$parcel$export(module.exports, "UnusedRelayResponseError", () => $94c71fb7abd30376$export$8431e42d062de453);
class $94c71fb7abd30376$export$8431e42d062de453 extends Error {
    constructor(queryID){
        super(`Relay Query ${queryID} was made during SSR but never used in the browser`), this.name = 'UnusedRelayResponseError';
    }
}

});


parcelRegister("cvB0A", function(module, exports) {

$parcel$export(module.exports, "getEarlyScriptPromiseKey", () => $87a950ddd1dc6c27$export$1102c06c7da91223);
$parcel$export(module.exports, "claimEarlyScriptPromise", () => $87a950ddd1dc6c27$export$828ac0325bce4536);
$parcel$export(module.exports, "putEarlyScriptPromise", () => $87a950ddd1dc6c27$export$e1336d32be02faf4);
const $87a950ddd1dc6c27$export$b5fbc1430cbfd6e1 = (value)=>value;
const $87a950ddd1dc6c27$export$6d670d323806bb37 = new Map();
const $87a950ddd1dc6c27$export$1102c06c7da91223 = (params, variables)=>{
    if (params.name === 'mainIssueAggQuery') return `${params.name}|${params.id}|${variables?.cloudId}|${variables?.issueKey}`;
    const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
    const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
    return `${params.name}|${String(queryId)}|${serializedVariables}`;
};
const $87a950ddd1dc6c27$export$828ac0325bce4536 = (key)=>{
    const result = $87a950ddd1dc6c27$export$6d670d323806bb37.get(key);
    if (result != null) $87a950ddd1dc6c27$export$6d670d323806bb37.delete(key);
    return result;
};
const $87a950ddd1dc6c27$export$e1336d32be02faf4 = (key, promise)=>{
    if (!$87a950ddd1dc6c27$export$6d670d323806bb37.has(key)) $87a950ddd1dc6c27$export$6d670d323806bb37.set(key, promise);
};

});

parcelRegister("jOs4m", function(module, exports) {

$parcel$export(module.exports, "registerEvent", () => $5f3b0214908d5373$export$bd50bc4cd3c601ee);
const $5f3b0214908d5373$var$events = [];
const $5f3b0214908d5373$export$bd50bc4cd3c601ee = (event)=>{
    $5f3b0214908d5373$var$events.push(event);
};
/**
 * Take all events registered so far, return them, and clear the list.
 */ const $5f3b0214908d5373$export$3c7145db84d4587c = ()=>{
    return $5f3b0214908d5373$var$events.splice(0, $5f3b0214908d5373$var$events.length);
};

});

parcelRegister("fGcgi", function(module, exports) {

$parcel$export(module.exports, "getClientDispatcher", () => $9695bc99f48d9222$export$5bb012cf9b3a5452);


var $f3qnT = parcelRequire("f3qnT");
let $9695bc99f48d9222$var$dispatcher;
const $9695bc99f48d9222$export$5bb012cf9b3a5452 = ()=>{
    if (!$9695bc99f48d9222$var$dispatcher) {
        $9695bc99f48d9222$var$dispatcher = new (0, $f3qnT.ClientDispatcher)();
        // Handle the server hangup scenarios
        $9695bc99f48d9222$var$dispatcher.register((0, $a7124bed15c191d7$export$eb5d9c90d65c7fea), $9695bc99f48d9222$var$dispatcher._abort.bind($9695bc99f48d9222$var$dispatcher));
    }
    return $9695bc99f48d9222$var$dispatcher;
};

});
const $a7124bed15c191d7$export$eb5d9c90d65c7fea = 'ClientDispatcher';

parcelRegister("f3qnT", function(module, exports) {

$parcel$export(module.exports, "ClientDispatcher", () => $844caee9d5549f15$export$3f5ba18eb97af725);
class $844caee9d5549f15$export$3f5ba18eb97af725 {
    #handlers;
    #queuedPayloads;
    #abortReason;
    #abortHandlers;
    constructor(){
        this.#handlers = new Map();
        this.#abortHandlers = new Map();
        this.#queuedPayloads = new Map();
    }
    /**
	 * Ingest a payload from the server.
	 * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
	 * @param payload - The payload to ingest.
	 */ ingest(payload) {
        const handler = this.#handlers.get(payload.id);
        if (handler) this.#exec(handler, payload);
        else {
            const queue = this.#queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.#queuedPayloads.set(payload.id, queue);
        }
    }
    /**
	 * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when the event is ingested.
	 */ register(id, callback) {
        this.#handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.#queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.#exec(callback, payload));
            this.#queuedPayloads.delete(id);
        }
    }
    /**
	 * Unregister a callback for a given event.
	 * @param id
	 */ unregister(id) {
        this.#handlers.delete(id);
        this.#queuedPayloads.delete(id);
    }
    /**
	 * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
	 * @param id - The event ID to register for.
	 * @param callback - The callback to trigger when abort detected.
	 */ onAbort(id, callback) {
        if (this.#abortReason) this.#exec(callback, {
            args: [
                this.#abortReason
            ]
        });
        else this.#abortHandlers.set(id, callback);
    }
    /**
	 * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
	 * @private
	 * @param props
	 */ _abort(props) {
        this.#abortReason = props;
        this.#abortHandlers.forEach((handler)=>{
            this.#exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.#abortHandlers = new Map();
    }
    /**
	 * Execute a callback with the given payload.
	 * @param callback - The callback to execute.
	 * @param payload - The payload to execute the callback with.
	 */ #exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("4Yjc9", function(module, exports) {

$parcel$export(module.exports, "processMultipartPromise", () => $c10481344656009f$export$f76505a7f2969e4e);
$parcel$export(module.exports, "withErrorHandling", () => $c10481344656009f$export$c874c20f7c9f97c);
$parcel$export(module.exports, "buildGraphqlFetch", () => $c10481344656009f$export$744180da2870332e);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $1O6Yz = parcelRequire("1O6Yz");

var $37Ewn = parcelRequire("37Ewn");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");

var $1oMOM = parcelRequire("1oMOM");


var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");
function $c10481344656009f$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
/**
 * Processes a chunk of multipart data and emits parsed JSON payloads to the observer
 * Uses a more memory-efficient approach by processing chunks directly
 */ function $c10481344656009f$var$processChunk(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [, body] = part.split(/\r?\n\r?\n/);
            if (body) try {
                const jsonData = JSON.parse(body.trim());
                observer.next(jsonData);
            } catch (error) {
                observer.error(new Error(`Invalid JSON: ${error instanceof Error ? error.message : String(error)}`));
            }
        }
    }
    // Return the last part which might be incomplete
    return parts[parts.length - 1];
}
/**
 * Processes a ReadableStream of multipart data with improved memory efficiency
 */ async function $c10481344656009f$var$processStream(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $c10481344656009f$var$processChunk(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $c10481344656009f$var$processChunk(incompleteChunk, boundaryString, observer);
    observer.complete();
}
function $c10481344656009f$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $c10481344656009f$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const decoder = new TextDecoder('utf-8');
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        async function* streamReader() {
            // @ts-expect-error a Response object in Node is streamable
            for await (const chunk of response.body){
                const newText = decoder.decode(chunk, {
                    stream: true
                });
                yield newText;
            }
        }
        $c10481344656009f$var$processStream(streamReader(), boundary, observer).catch((error)=>observer.error(error));
    } catch (e) {
        observer.error(new Error('Failed to read from response body', {
            cause: e
        }));
    }
}
function $c10481344656009f$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>observer.next(data)).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $c10481344656009f$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>observer.error(error));
}
function $c10481344656009f$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $37Ewn.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === (0, $44ccf6b895337c89$export$3288b14b6745c572)) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $c10481344656009f$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $c10481344656009f$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $c10481344656009f$var$handleMultipartResponse(response, observer);
            else observer.error(new Error(`Unsupported content type: ${contentType}`));
        }).catch((error)=>observer.error(error));
    });
}
function $c10481344656009f$export$c874c20f7c9f97c(source) {
    return source.then((0, $jGzN3.handleErrors)).catch((0, $jGzN3.handleNetworkErrors));
}
const $c10481344656009f$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
function $c10481344656009f$export$744180da2870332e(url, options) {
    const acceptableFormats = [
        'application/graphql-response+json',
        'application/json',
        'multipart/mixed; deferSpec=20220824'
    ];
    const postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: (0, $7jTnu.fg)('relay-defer-format-header-fix') ? $c10481344656009f$var$relayDeferAcceptableFormats.join(', ') : acceptableFormats.join(', ')
        }
    };
    const composedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))((0, $1oMOM.getDefaultOptions)(url), options, postOptions);
    const fetchUrl = (0, $i4YfB.getReroutableURL)(url);
    const fetchHeaders = (0, $3WOLx.applyObservabilityHeaders)(url, composedOptions);
    return ()=>fetch(fetchUrl, fetchHeaders);
}
function $c10481344656009f$export$2586da7b5f4b5763(url, options) {
    const fetchFn = $c10481344656009f$export$744180da2870332e(url, options);
    return $c10481344656009f$export$f76505a7f2969e4e(()=>$c10481344656009f$export$c874c20f7c9f97c(fetchFn()));
}

});
parcelRegister("i4YfB", function(module, exports) {

$parcel$export(module.exports, "getReroutableURL", () => $fe763424b1b1bc45$export$23769875e8eebaf6);

var $jknD8 = parcelRequire("jknD8");
// FIXME: Pillar to define entire URL, not just hostname.
const $fe763424b1b1bc45$var$LOCAL_URL = new URL(`${'http'}://${(0, $jknD8.getDevHostname)()}:${(0, $jknD8.getProxyServerPort)()}`);
function $fe763424b1b1bc45$export$23769875e8eebaf6(pathOrURL) {
    // For local development environment only, otherwise removed during the bundling process
    if (globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT ?? false) try {
        const u = new URL(pathOrURL, $fe763424b1b1bc45$var$LOCAL_URL.href);
        u.host = $fe763424b1b1bc45$var$LOCAL_URL.host;
        u.protocol = $fe763424b1b1bc45$var$LOCAL_URL.protocol;
        return u.href;
    } catch (e) {
        // When the URL constructor has `base` set, and `pathOrUrl` is always a string,
        // no string can trigger this catch block.
        // Just in case, log the error to help with debugging.
        // eslint-disable-next-line no-console
        console.error('Failed to parse URL: ', pathOrURL, e);
    }
    return pathOrURL;
}

});
parcelRegister("jknD8", function(module, exports) {

$parcel$export(module.exports, "getDevHostname", () => $5afe5c3b08b92ffc$export$a6aba27c4797e08b);
$parcel$export(module.exports, "getProxyServerPort", () => $5afe5c3b08b92ffc$export$6819122a922c6aaf);
/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */ const $5afe5c3b08b92ffc$export$a6aba27c4797e08b = ()=>{
    const envDns = globalThis.localDevContext?.RDE_DNS ?? undefined;
    return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
};
function $5afe5c3b08b92ffc$export$6819122a922c6aaf() {
    const serverPort = globalThis.localDevContext?.__PILLAR_PROXY_SERVER_PORT ?? undefined;
    return serverPort ? parseInt(serverPort, 10) : 9000;
}

});


const $44ccf6b895337c89$export$ff39ebd4bb12b718 = 201;
const $44ccf6b895337c89$export$3288b14b6745c572 = 204;
const $44ccf6b895337c89$export$9de493bcd9b1d977 = 400;
const $44ccf6b895337c89$export$67d19e9a991baa07 = 401;
const $44ccf6b895337c89$export$a3269a3914b007e3 = 403;
const $44ccf6b895337c89$export$8bca792d963eb0ef = 404;
const $44ccf6b895337c89$export$4a3cb39801694eee = 407;
const $44ccf6b895337c89$export$fa405bbf47d510e2 = 408;
const $44ccf6b895337c89$export$c09e7ea0fc79f34f = 409;
const $44ccf6b895337c89$export$5244030134e99 = 412;
const $44ccf6b895337c89$export$f90ac1df0b60853d = 413;
const $44ccf6b895337c89$export$a447d0a965e16776 = 422;
const $44ccf6b895337c89$export$3b48aba8957000cd = 426;
const $44ccf6b895337c89$export$6763168a631449a2 = 429;
const $44ccf6b895337c89$export$e813cd7045fcc98d = 500;
const $44ccf6b895337c89$export$2ce38d41a306034e = 502;
const $44ccf6b895337c89$export$974c37534b0191b1 = 503;
const $44ccf6b895337c89$export$5400e8dddac3fcf3 = 504;

parcelRegister("jGzN3", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrorFromServer", () => $3bd0eafe49859925$export$8e9baed7697e4959);
$parcel$export(module.exports, "handleNetworkErrors", () => $3bd0eafe49859925$export$b47ad9bdf9122b88);
$parcel$export(module.exports, "handleErrors", () => $3bd0eafe49859925$export$1e36de371b2e3d5a);
$parcel$export(module.exports, "applyErrorHandling", () => $3bd0eafe49859925$export$e174dc943a170ff);
$parcel$export(module.exports, "performGetRequest", () => $3bd0eafe49859925$export$4a53ae1be8ec80c7);
$parcel$export(module.exports, "performPutRequest", () => $3bd0eafe49859925$export$9ead1f9103e6de6b);
$parcel$export(module.exports, "performPostRequest", () => $3bd0eafe49859925$export$692a4d9808143175);
$parcel$export(module.exports, "performDeleteRequest", () => $3bd0eafe49859925$export$8ef51cba9d28f819);
$parcel$export(module.exports, "performPatchRequest", () => $3bd0eafe49859925$export$52be6ab13d7e758d);
$parcel$export(module.exports, "performGetRequestWithRetry", () => $3bd0eafe49859925$export$659b5ee69e6eb976);
$parcel$export(module.exports, "performPutRequestWithRetry", () => $3bd0eafe49859925$export$d7b48b2904a5d812);
$parcel$export(module.exports, "performPostRequestWithRetry", () => $3bd0eafe49859925$export$a5717cbee13f28b7);


var $7oY9g = parcelRequire("7oY9g");

var $1oMOM = parcelRequire("1oMOM");

var $1uIew = parcelRequire("1uIew");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");

var $dSA8H = parcelRequire("dSA8H");

var $7AheX = parcelRequire("7AheX");
/**
 * Transform object with field errors from JIRA to an array of FieldValidationErrors
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3bd0eafe49859925$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
            field: field,
            error: fieldErrors[field]
        }));
const $3bd0eafe49859925$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
    const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
    const fieldErrorsJson = json.errors ?? json.fieldErrors;
    const fieldErrors = fieldErrorsJson ? $3bd0eafe49859925$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
    return new (0, $1uIew.ValidationError)(message, fieldErrors, statusCode, traceId, json);
};
const $3bd0eafe49859925$var$putOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'PUT'
};
const $3bd0eafe49859925$var$postOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'POST'
};
const $3bd0eafe49859925$var$deleteOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'DELETE'
};
const $3bd0eafe49859925$var$patchOptions = {
    ...(0, $1oMOM.defaultOptions),
    method: 'PATCH'
};
const $3bd0eafe49859925$export$b47ad9bdf9122b88 = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $3bd0eafe49859925$export$1e36de371b2e3d5a = (response)=>{
    const traceId = (0, $7AheX.getTraceId)(response);
    // CONTENT_TOO_LARGE errorMessage is used for Hard Limits and, we don't want to override the error message
    if ((0, $44ccf6b895337c89$export$9de493bcd9b1d977) === response.status || (0, $44ccf6b895337c89$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
        throw $3bd0eafe49859925$export$8e9baed7697e4959(errorContent, response.status, traceId);
    });
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $1uIew.default)(response.status, `Error server response: ${response.status}`, traceId, response);
        else throw new (0, $1uIew.default)(response.status, `Error server response: ${response.status}`, undefined, response);
    }
    return response;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3bd0eafe49859925$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $44ccf6b895337c89$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
const $3bd0eafe49859925$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$22411cbfb09a5c5c = (url, options)=>{
    const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
    const executeRequest = ()=>$3bd0eafe49859925$export$e174dc943a170ff(fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, requestOptions)));
    if ((0, $7oY9g.default)('platform_fetch_retries')) return executeRequest();
    return (0, $dSA8H.retryOnError)(executeRequest, {
        retryFunc: executeRequest,
        retryPredicate: retryPredicate,
        retryAttempts: retryAttempts,
        onRetry: onRetry
    });
};
const $3bd0eafe49859925$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...(0, $1oMOM.defaultOptions),
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...$3bd0eafe49859925$var$putOptions,
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$692a4d9808143175 = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...$3bd0eafe49859925$var$postOptions,
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...$3bd0eafe49859925$var$deleteOptions,
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, {
        ...$3bd0eafe49859925$var$patchOptions,
        ...options
    })).then($3bd0eafe49859925$export$1e36de371b2e3d5a).then($3bd0eafe49859925$var$processResponseFromServer).catch($3bd0eafe49859925$export$b47ad9bdf9122b88);
const $3bd0eafe49859925$export$659b5ee69e6eb976 = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...(0, $1oMOM.defaultOptions),
        ...options
    });
const $3bd0eafe49859925$export$d7b48b2904a5d812 = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...$3bd0eafe49859925$var$putOptions,
        ...options
    });
const $3bd0eafe49859925$export$a5717cbee13f28b7 = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...$3bd0eafe49859925$var$postOptions,
        ...options
    });
const $3bd0eafe49859925$export$6d01bf1146815b9b = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...$3bd0eafe49859925$var$deleteOptions,
        ...options
    });
const $3bd0eafe49859925$export$560989ee94ad2a20 = (url, options)=>$3bd0eafe49859925$export$22411cbfb09a5c5c(url, {
        ...$3bd0eafe49859925$var$patchOptions,
        ...options
    });

});
parcelRegister("7AheX", function(module, exports) {

$parcel$export(module.exports, "getTraceId", () => $42a7ebcad5498881$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $42a7ebcad5498881$export$b569b31eebca952d);

var $ee0TI = parcelRequire("ee0TI");
const $42a7ebcad5498881$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $ee0TI.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $42a7ebcad5498881$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $ee0TI.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("ee0TI", function(module, exports) {

$parcel$export(module.exports, "TRACE_ID_HEADER", () => $f102330ef4989ccd$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $f102330ef4989ccd$export$830a89e935012abe);
const $f102330ef4989ccd$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $f102330ef4989ccd$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $f102330ef4989ccd$export$830a89e935012abe = [
    $f102330ef4989ccd$export$4b69438fb7c7b9b2,
    $f102330ef4989ccd$var$TRACE_ID_HEADER_MICROS
];

});




parcelRegister("jC6NO", function(module, exports) {

$parcel$export(module.exports, "showUnauthenticatedFlag", () => $82aff5bc2beb8971$export$758fcc357484571e);

var $bILK0 = parcelRequire("bILK0");

var $2Mqjh = parcelRequire("2Mqjh");

var $eeSEl = parcelRequire("eeSEl");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $82aff5bc2beb8971$var$reloadPage = ()=>window.location.reload();
const $82aff5bc2beb8971$var$sendAnalyticEvent = (operationName)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'showed',
            actionSubject: 'unauthorizedFlag',
            attributes: {
                operation: operationName
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $82aff5bc2beb8971$var$sendLoginClickEvent = (operationName)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        if (!analyticsClient) return;
        analyticsClient.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'loginButton',
            attributes: {
                operation: operationName,
                source: globalThis.window?.location?.pathname ?? '',
                referrer: globalThis.document?.referrer ?? '',
                timestamp: new Date().toISOString(),
                userAgent: globalThis.navigator?.userAgent ?? ''
            },
            source: 'jiraRelayFetch'
        });
    });
};
const $82aff5bc2beb8971$export$758fcc357484571e = (operationName)=>{
    (0, $bILK0.showFlag)({
        type: 'error',
        title: (0, $eeSEl.default).title,
        description: (0, $eeSEl.default).description,
        messageId: 'relay-fetch.services.error-flags.show-flag.error.show-unauthenticated-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $eeSEl.default).login,
                onClick: ()=>{
                    $82aff5bc2beb8971$var$sendLoginClickEvent(operationName);
                    $82aff5bc2beb8971$var$reloadPage();
                }
            }
        ]
    });
    $82aff5bc2beb8971$var$sendAnalyticEvent(operationName);
};

});
parcelRegister("bILK0", function(module, exports) {

$parcel$export(module.exports, "showFlag", () => $403f7f6a1013a11d$export$e12b2cc6b75b006b);
$parcel$export(module.exports, "dismissFlag", () => $403f7f6a1013a11d$export$900a08a292ad23cd);
$parcel$export(module.exports, "flagService", () => $403f7f6a1013a11d$export$dbb055af53fd81a0);
$parcel$export(module.exports, "useFlagsService", () => $403f7f6a1013a11d$export$eee61a1aafe3884);
$parcel$export(module.exports, "useFlagService", () => $403f7f6a1013a11d$export$dc4f8132c3090b32);
$parcel$export(module.exports, "isDismissFlag", () => $403f7f6a1013a11d$export$14b1864d9cf0809f);
$parcel$export(module.exports, "isFlagComponent", () => $403f7f6a1013a11d$export$d84ce5adcee46025);
$parcel$export(module.exports, "isBatchAction", () => $403f7f6a1013a11d$export$c126d8b307b8ab86);

var $90d5q = parcelRequire("90d5q");

var $9YEIT = parcelRequire("9YEIT");

var $PC9Lc = parcelRequire("PC9Lc");

var $hrodw = parcelRequire("hrodw");
const $403f7f6a1013a11d$export$e12b2cc6b75b006b = (0, $9YEIT.default)((0, $PC9Lc.store).dispatch);
const $403f7f6a1013a11d$export$900a08a292ad23cd = (0, $90d5q.default)((0, $PC9Lc.store).dispatch);
const $403f7f6a1013a11d$var$dismissFlagById = (id)=>{
    $403f7f6a1013a11d$export$900a08a292ad23cd((0, $90d5q.dismissFlag)(id));
};
const $403f7f6a1013a11d$var$hasFlag = (id)=>Boolean((0, $PC9Lc.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
const $403f7f6a1013a11d$export$dbb055af53fd81a0 = {
    showFlag: $403f7f6a1013a11d$export$e12b2cc6b75b006b,
    dismissFlag: $403f7f6a1013a11d$export$900a08a292ad23cd
};
const $403f7f6a1013a11d$export$eee61a1aafe3884 = ()=>({
        showFlag: $403f7f6a1013a11d$export$e12b2cc6b75b006b,
        dismissFlag: $403f7f6a1013a11d$var$dismissFlagById,
        hasFlag: $403f7f6a1013a11d$var$hasFlag
    });
const $403f7f6a1013a11d$export$dc4f8132c3090b32 = ()=>$403f7f6a1013a11d$export$dbb055af53fd81a0;
const $403f7f6a1013a11d$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $hrodw.DISMISS_COMMAND);
const $403f7f6a1013a11d$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
const $403f7f6a1013a11d$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
const $403f7f6a1013a11d$export$63ffd7d99470afd4 = (flag)=>!$403f7f6a1013a11d$export$14b1864d9cf0809f(flag) && !$403f7f6a1013a11d$export$d84ce5adcee46025(flag) && !$403f7f6a1013a11d$export$cd5f9f2b991b82d9(flag);
const $403f7f6a1013a11d$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);

});
parcelRegister("90d5q", function(module, exports) {

$parcel$export(module.exports, "dismissFlag", () => $638868b8945d44f6$export$900a08a292ad23cd);
$parcel$export(module.exports, "default", () => $638868b8945d44f6$export$2e2bcd8739ae039);

var $3SCOM = parcelRequire("3SCOM");

var $hrodw = parcelRequire("hrodw");
const $638868b8945d44f6$export$900a08a292ad23cd = (flagId)=>({
        command: (0, $hrodw.DISMISS_COMMAND),
        id: flagId
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$638868b8945d44f6$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
        dispatch((0, $3SCOM.dismissFlagAction)(action.id));
    };

});
parcelRegister("3SCOM", function(module, exports) {

$parcel$export(module.exports, "SHOW", () => $ab52ddfb3f71a238$export$9d04158a25ce4cd);
$parcel$export(module.exports, "show", () => $ab52ddfb3f71a238$export$57bf213be019eeb0);
$parcel$export(module.exports, "DISMISS_INSTANCE", () => $ab52ddfb3f71a238$export$b31a07d2e6382678);
$parcel$export(module.exports, "dismiss", () => $ab52ddfb3f71a238$export$abf286bbe7073aba);
$parcel$export(module.exports, "DISMISS_FLAG", () => $ab52ddfb3f71a238$export$1eb56620df104bf);
$parcel$export(module.exports, "dismissFlagAction", () => $ab52ddfb3f71a238$export$4818b3c52448050d);
$parcel$export(module.exports, "RESET", () => $ab52ddfb3f71a238$export$4a991c87e640ef77);
$parcel$export(module.exports, "reset", () => $ab52ddfb3f71a238$export$aad8462122ac592b);
const $ab52ddfb3f71a238$export$9d04158a25ce4cd = 'state.SHOW';
const $ab52ddfb3f71a238$export$57bf213be019eeb0 = (payload)=>({
        type: $ab52ddfb3f71a238$export$9d04158a25ce4cd,
        payload: payload
    });
const $ab52ddfb3f71a238$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
const $ab52ddfb3f71a238$export$abf286bbe7073aba = (payload)=>({
        type: $ab52ddfb3f71a238$export$b31a07d2e6382678,
        payload: payload
    });
const $ab52ddfb3f71a238$export$1eb56620df104bf = 'state.DISMISS_FLAG';
const $ab52ddfb3f71a238$export$4818b3c52448050d = (payload)=>({
        type: $ab52ddfb3f71a238$export$1eb56620df104bf,
        payload: payload
    });
const $ab52ddfb3f71a238$export$4a991c87e640ef77 = 'state.RESET';
const $ab52ddfb3f71a238$export$aad8462122ac592b = ()=>({
        type: $ab52ddfb3f71a238$export$4a991c87e640ef77
    });

});

parcelRegister("hrodw", function(module, exports) {

$parcel$export(module.exports, "DISMISS_COMMAND", () => $f63dfcdfd8451c1b$export$e705274c5e156b93);
$parcel$export(module.exports, "toFlagId", () => $f63dfcdfd8451c1b$export$8184bc29de2aea90);
$parcel$export(module.exports, "fromFlagId", () => $f63dfcdfd8451c1b$export$188cdb77b72629d7);
const $f63dfcdfd8451c1b$export$e705274c5e156b93 = 'DISMISS';
const $f63dfcdfd8451c1b$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
const $f63dfcdfd8451c1b$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();

});


parcelRegister("9YEIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bab8f4a2dc29320$export$2e2bcd8739ae039);

var $aXKmr = parcelRequire("aXKmr");

var $3SCOM = parcelRequire("3SCOM");

var $hrodw = parcelRequire("hrodw");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2bab8f4a2dc29320$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
        // Flag is of type FlagComponent
        if (typeof flag === 'function') {
            dispatch((0, $3SCOM.show)(flag));
            return undefined;
        }
        const flagId = flag.id || (0, $hrodw.toFlagId)((0, $aXKmr.v4)());
        const newFlag = {
            ...flag,
            id: flagId
        };
        dispatch((0, $3SCOM.show)(newFlag));
        return flagId;
    };

});

parcelRegister("PC9Lc", function(module, exports) {

$parcel$export(module.exports, "store", () => $8b98e66ebdeeac00$export$6f57813fe9f31bf9);

var $eexGj = parcelRequire("eexGj");
const $8b98e66ebdeeac00$export$6f57813fe9f31bf9 = (0, $eexGj.createStore)();

});
parcelRegister("eexGj", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $03757ac17ecb5523$export$f51a9068ac82ea43);

var $gs6vs = parcelRequire("gs6vs");

var $kC33T = parcelRequire("kC33T");
const $03757ac17ecb5523$export$f51a9068ac82ea43 = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'flags',
        rootReducer: $kC33T.default,
        rootEpic: rootEpic
    });

});
parcelRegister("gs6vs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5fb2723e7e827ee$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7HHI1 = parcelRequire("7HHI1");

var $dFg4o = parcelRequire("dFg4o");

var $4tM8k = parcelRequire("4tM8k");

var $abRw5 = parcelRequire("abRw5");

var $kqAfW = parcelRequire("kqAfW");

var $i1nY5 = parcelRequire("i1nY5");

var /**
 * Initializes a Redux store with configurations for state management and middleware integration.
 * It addresses serialization challenges with non-serializable entities and enhances debugging capabilities.
 * The custom action listener middleware offers additional control over action dispatches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5fb2723e7e827ee$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
    const actionListenerMiddleware = new (0, $i1nY5.default)();
    middlewares.push(actionListenerMiddleware.perform);
    if ((0, $abRw5.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("f8FDM"));
        middlewares.push(logger);
    }
    if (rootEpic) middlewares.push((0, $4tM8k.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
        dependencies: rootEpicDependencies
    } : undefined));
    const store = (0, $7HHI1.createStore)((0, $dFg4o.enableBatching)(rootReducer), initialState, (0, $kqAfW.default)({
        name: appName,
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; serialize: { replacer: (key: any, value: any) => any; }; }' is not assignable to parameter of type 'DevtoolsConfig'.
        serialize: {
            // Replacer function is necessary to fix redux-devtools because some actions and state are React Elements
            // and the default serialization gets into a loop in a circular dependency somewhere in internal React properties.
            // https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#serialize
            // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
            replacer: (key, value)=>{
                if (/*#__PURE__*/ (0, $eJOHy.isValidElement)(value)) {
                    // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    if (value.type && value.type.displayName) // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'string | JSXElementConstructor<any>'.
                    return `React Element <${value.type.displayName}>`;
                    return 'React Element';
                }
                // The benefit of using React + Redux + declarative API is that there is no more need to save DOM elements in store!
                // ... yet we still do. So when that happens, Redux devtools sometimes crashes because it tries to serialize circular DOM structure.
                if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                return value;
            }
        }
    })((0, $7HHI1.compose)(...enhancers, (0, $7HHI1.applyMiddleware)(...middlewares))));
    store.addActionListener = actionListenerMiddleware.add;
    store.removeActionListener = actionListenerMiddleware.remove;
    return store;
};

});
parcelRegister("abRw5", function(module, exports) {

$parcel$export(module.exports, "debugEnabled", () => $bfde42121ad38c1d$export$342c99cc1e9bc5c6);
const $bfde42121ad38c1d$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);

});

parcelRegister("kqAfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f35d50b3b5f50f$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");
var // An extended version of redux's 'compose' method, that
// will use redux devtools chrome extension if available
// https://github.com/zalmoxisus/redux-devtools-extension
//
// The 'devtoolsConfig' parameter is an object adhering to the following API:
// https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
// eslint-disable-next-line jira/import/no-anonymous-default-export
$f0f35d50b3b5f50f$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    const config = {
        ...devtoolsConfig
    };
    if (config.name != null && config.instanceId == null) config.instanceId = config.name;
    return 0, $7HHI1.compose;
};

});

parcelRegister("i1nY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d528e7f36d931b18$export$2e2bcd8739ae039);
class $d528e7f36d931b18$export$2e2bcd8739ae039 {
    constructor(){
        this.listeners = [];
        this.add = (listener)=>{
            this.listeners.push(listener);
        };
        this.remove = (listener)=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
        // @ts-expect-error - TS2315 - Type 'Middleware' is not generic.
        this.perform = (api)=>(next)=>(action)=>{
                    const result = next(action);
                    this.listeners.forEach((listener)=>listener(action, api.getState()));
                    return result;
                };
    }
}

});


parcelRegister("kC33T", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee5563a0f3de215$export$2e2bcd8739ae039);

var $a6gy0 = parcelRequire("a6gy0");

var $aXKmr = parcelRequire("aXKmr");

var $3SCOM = parcelRequire("3SCOM");
const $cee5563a0f3de215$var$defaultState = {
    flags: []
};
var /**
 * Manages the state transitions of a notification system by handling actions such as showing
 * new notifications, dismissing notifications (either individually or by type), and
 * resetting to the default state. It uniquely prioritizes high-priority notifications,
 * ensuring they are displayed before low-priority ones, enhancing the user's
 * attention to critical alerts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$cee5563a0f3de215$export$2e2bcd8739ae039 = (state = $cee5563a0f3de215$var$defaultState, action)=>{
    switch(action.type){
        case 0, $3SCOM.SHOW:
            {
                // If flag is of type FlagComponent, it is treated as high priority
                const [lowPriorityFlags, highPriorityFlags] = (0, (/*@__PURE__*/$parcel$interopDefault($a6gy0)))([
                    {
                        id: (0, $aXKmr.v4)(),
                        flag: action.payload
                    },
                    ...state.flags
                ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                const flags = [
                    ...highPriorityFlags,
                    ...lowPriorityFlags
                ];
                return {
                    ...state,
                    flags: flags
                };
            }
        case 0, $3SCOM.DISMISS_INSTANCE:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                };
            }
        case 0, $3SCOM.DISMISS_FLAG:
            {
                const id = action.payload;
                return {
                    ...state,
                    flags: state.flags.filter((flagInstance)=>{
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        if (flagInstance.flag.id) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'Flag'.
                        return flagInstance.flag.id !== id;
                        return true;
                    })
                };
            }
        case 0, $3SCOM.RESET:
            return $cee5563a0f3de215$var$defaultState;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});




parcelRegister("eeSEl", function(module, exports) {

$parcel$export(module.exports, "default", () => $97602d570e003f87$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $97602d570e003f87$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "relay-fetch.services.error-flags.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "relay-fetch.services.error-flags.description",
        "defaultMessage": "Looks like you've been signed out. Try logging in again. "
    },
    login: {
        "id": "relay-fetch.services.error-flags.login",
        "defaultMessage": "Log in"
    }
});

});


parcelRegister("c2hs9", function(module, exports) {

$parcel$export(module.exports, "getLoggingAndMetricsHelper", () => $3d28a75f7345d649$export$726e1df8186bb981);

var $1rzja = parcelRequire("1rzja");

var $9Dhvc = parcelRequire("9Dhvc");

var $jPROM = parcelRequire("jPROM");

var $eSnSE = parcelRequire("eSnSE");

var $1uIew = parcelRequire("1uIew");
const $3d28a75f7345d649$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
const $3d28a75f7345d649$export$726e1df8186bb981 = (graphqlDetails)=>{
    const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
    const logErrorRetry = (error, retryAttempt)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
            'statusCode'
        ], null);
        const errorType = error instanceof (0, $1uIew.default) ? 'network' : 'unknown';
        // Log any errors even in SSR
        (0, $eSnSE.default).safeErrorWithoutCustomerData($3d28a75f7345d649$var$LOG_NAMESPACE, `[${errorType} error]`, {
            message: `[${(0, (/*@__PURE__*/$parcel$interopDefault($1rzja)))(errorType)} error]: ${error?.message ?? ''}`,
            errorType: errorType,
            statusCode: statusCode,
            queryName: queryName,
            operationKind: operationKind,
            errorName: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(error, [
                'name'
            ], null),
            retryAttempt: retryAttempt
        });
    };
    return {
        logNonBreakingErrors: (errors, requestId)=>{
            if (false || (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(errors) || !Array.isArray(errors)) return;
            errors.forEach((error)=>{
                error && (0, $eSnSE.default).safeErrorWithoutCustomerData($3d28a75f7345d649$var$LOG_NAMESPACE, '[graphql error]', {
                    queryName: queryName,
                    operationKind: operationKind,
                    errorType: 'graphql',
                    message: error.message,
                    requestId: requestId
                });
            });
        },
        logError: logErrorRetry,
        logErrorRetry: logErrorRetry
    };
};

});

parcelRegister("ll6Lf", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $b1384809f654b8cb$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "blocklist", () => $b1384809f654b8cb$export$c5c28c9e707bcda1);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $b1384809f654b8cb$export$9dec0f42cc67f6ab);
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $b1384809f654b8cb$export$eefb7f54c3b07211);
$parcel$export(module.exports, "generateOptions", () => $b1384809f654b8cb$export$c21133b4499f5374);
$parcel$export(module.exports, "shouldRetry", () => $b1384809f654b8cb$export$7bfea3c3d460ecd8);

var $jPROM = parcelRequire("jPROM");

var $1O6Yz = parcelRequire("1O6Yz");

var $7jTnu = parcelRequire("7jTnu");

var $8RHPx = parcelRequire("8RHPx");

var $8lcvP = parcelRequire("8lcvP");

var $1uIew = parcelRequire("1uIew");

var $1oMOM = parcelRequire("1oMOM");

var $dSA8H = parcelRequire("dSA8H");

var $kIz4h = parcelRequire("kIz4h");

var $cIIZL = parcelRequire("cIIZL");

var $aYncF = parcelRequire("aYncF");

var $hWeHP = parcelRequire("hWeHP");
let $b1384809f654b8cb$var$redirecting = false;
const $b1384809f654b8cb$export$ae8f795c4c44d494 = ()=>{
    $b1384809f654b8cb$var$redirecting = false;
};
const $b1384809f654b8cb$var$markAsRedirecting = ()=>{
    $b1384809f654b8cb$var$redirecting = true;
};
if (typeof window !== 'undefined') // Mark as redirecting, when we're unloading the page to prevent double/unwatend redirection.
window.addEventListener('beforeunload', ()=>{
    if ((0, $7jTnu.fg)('hot-117634-firefox-redirection-issue-fix')) $b1384809f654b8cb$var$markAsRedirecting();
});
const $b1384809f654b8cb$var$redirect = ()=>{
    const identity = (0, $8RHPx.getATLContextDomain)('id');
    // Hardcoding to Jira as this will be the only adopter of this service for now.
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href)}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = redirectUrl;
};
const $b1384809f654b8cb$export$b8dbb7d6029c5413 = ()=>{
    if (!false && !$b1384809f654b8cb$var$redirecting) {
        const heartbeatService = (0, $8lcvP.getInstance)();
        if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
            if ((0, $7jTnu.fg)('hot-117634-firefox-redirection-issue-fix')) {
                if (!$b1384809f654b8cb$var$redirecting) $b1384809f654b8cb$var$redirect();
            } else $b1384809f654b8cb$var$redirect();
            // Set flag to prevent multiple redirects
            $b1384809f654b8cb$var$markAsRedirecting();
        }
    }
    return $b1384809f654b8cb$var$redirecting;
};
const $b1384809f654b8cb$export$c5c28c9e707bcda1 = [
    'issueAggQuery'
];
const $b1384809f654b8cb$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
    if (operationKind === 'query') return 0, $dSA8H.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
const $b1384809f654b8cb$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
const $b1384809f654b8cb$export$c21133b4499f5374 = (options = {}, url = null)=>{
    // the token fetcher returns undefined if no cookie value was found, also in SSR cookies are unavailable
    const csrfToken = !false ? (0, $kIz4h.default)() : undefined;
    // If we don't get a token, there is no point trying to add the csrf header
    const csrfTokenHeader = (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(csrfToken) ? {} : {
        'atl-xsrf-token': csrfToken
    };
    let atlAttribution = {};
    if ((0, $7jTnu.fg)('pass_extra_headers_to_agg')) {
        if ((0, $7jTnu.fg)('relay-defer-retry-support')) {
            const avpWorkspaceId = (0, $hWeHP.default)('ajs-avp-workspace-id');
            const cloudId = (0, $hWeHP.default)('ajs-cloud-id');
            atlAttribution = {
                atlWorkspaceId: avpWorkspaceId,
                tenantId: cloudId,
                product: 'Atlassian Jira',
                businessUnit: 'Engineering-Atlassian Jira',
                service: 'afm-frontend',
                team: 'Atlassian Jira'
            };
        } else {
            const tenantContext = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
            atlAttribution = {
                atlWorkspaceId: tenantContext.avpWorkspaceId,
                tenantId: tenantContext.cloudId,
                product: 'Atlassian Jira',
                businessUnit: 'Engineering-Atlassian Jira',
                service: 'afm-frontend',
                team: 'Atlassian Jira'
            };
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, {
        // We have to provide general options here or the headers we provide will override the default ones found
        // here /src/packages/platform/utils/fetch/src/utils/requests.js due to a shallow merge
        ...(0, $1oMOM.getDefaultOptions)(url),
        ...options
    }, {
        headers: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $cIIZL.default).join(','),
            'atl-attribution': JSON.stringify(atlAttribution),
            ...csrfTokenHeader
        }
    });
};
const $b1384809f654b8cb$export$7bfea3c3d460ecd8 = (error)=>{
    if (error instanceof (0, $1uIew.default)) return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};

});
parcelRegister("cIIZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c69dc0ed7f858e$export$2e2bcd8739ae039);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $d9c69dc0ed7f858e$export$2e2bcd8739ae039 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs'
];

});



parcelRegister("kdR84", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $4faf0d1ae15fc4dc$export$e7aa7bc5c1b3cfb3);

var $jPROM = parcelRequire("jPROM");

var $37Ewn = parcelRequire("37Ewn");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $dSA8H = parcelRequire("dSA8H");

var $g1oKu = parcelRequire("g1oKu");

var $7797X = parcelRequire("7797X");

var $iFeTU = parcelRequire("iFeTU");

var $cvB0A = parcelRequire("cvB0A");

var $ePvyd = parcelRequire("ePvyd");

var $icl1h = parcelRequire("icl1h");

var $jHI6h = parcelRequire("jHI6h");

var $jC6NO = parcelRequire("jC6NO");

var $c2hs9 = parcelRequire("c2hs9");

var $ll6Lf = parcelRequire("ll6Lf");
const $4faf0d1ae15fc4dc$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
    if (!(0, $7jTnu.fg)('remove_heartbeat_service_from_jira_relay_fetch')) {
        const redirecting = (0, $ll6Lf.checkAuthentication)();
        if (redirecting) // Hang the request if we are redirecting - should be cleared on redirect
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return (0, $37Ewn.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const earlyScriptPromise = !false && (0, $cvB0A.claimEarlyScriptPromise)((0, $cvB0A.getEarlyScriptPromiseKey)(request, variables)) || undefined;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = (0, $c2hs9.getLoggingAndMetricsHelper)(loggingMetadata);
    return (0, $37Ewn.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            const endpoint = (0, $icl1h.getAggEndpoint)(request, cacheConfig);
            const body = (0, $icl1h.getRequestBody)(request, variables);
            let ssrCache = null;
            if (!false && requestID != null) ssrCache = (0, $iFeTU.getQueryResponseCache)().get(requestID, variables);
            // On client read cache from window.SPA_STATE if available
            if (!false && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(ssrCache)) {
                sink.next(ssrCache);
                if (requestID != null) (0, $iFeTU.getQueryResponseCache)().delete(requestID, variables);
                sink.complete();
                return;
            }
            const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $dSA8H.retryOnError)(()=>(0, $jGzN3.applyErrorHandling)(earlyScriptPromise), {
                retryFunc: ()=>(0, $jGzN3.performPostRequest)(endpoint, (0, $ll6Lf.generateOptions)({
                        body: body
                    }, endpoint)),
                retryPredicate: (0, $ll6Lf.shouldRetry),
                retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: loggingAndMetrics.logErrorRetry
            });
            // Throws HttpError
            const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $jGzN3.performPostRequestWithRetry)(endpoint, {
                ...(0, $ll6Lf.generateOptions)({
                    body: body
                }, endpoint),
                retryPredicate: (0, $ll6Lf.shouldRetry),
                retryAttempts: (0, $ll6Lf.getRetryAttemptsForQuery)(queryName, operationKind),
                onRetry: (error, attempt)=>{
                    loggingAndMetrics.logErrorRetry(error, attempt);
                }
            }));
            promise.then((response)=>{
                (0, $jHI6h.addTraceId)(queryName, (0, $ll6Lf.getTraceIdFromExtensions)(response));
                (0, $ePvyd.putExtensions)(queryName, response.extensions);
                // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'GraphQLSingularResponse'.
                const errors = response.errors || undefined;
                if (errors != null) {
                    const requestId = response?.extensions?.gateway?.request_id;
                    if (!(0, $ll6Lf.blocklist).includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                    (0, $g1oKu.captureErrors)(errors, {
                        operationName: queryName,
                        requestId: requestId
                    });
                    if ((0, $g1oKu.isUnauthenticated)(errors)) {
                        //  Short circuit operation and handle the unauthorized errors.
                        (0, $jC6NO.showUnauthenticatedFlag)(queryName);
                        // Surprise behaviour: the observable should hang indefinitely here!
                        // At least, that is the expectation of existing code; see src/packages/issue/issue-view/src/integration-tests/experience-tracking/view.cy-integration.tsx
                        // Which assumes that the operation never completes, so relay never receives a (null) response, so it never complains about the data.
                        // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                        return;
                    }
                }
                if (response.data && (response.data.jira === null || response.data.customerService === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
                // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
                // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
                // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
                response.data = null;
                // cache query response on SSR
                if (false && requestID != null) (0, $iFeTU.getQueryResponseCache)().setWithMetadata(requestID, variables, response, loggingMetadata);
                sink.next(response);
                sink.complete();
            })// We don't await the promise so the catch block below is never
            // triggered so we need an independent catch on the promise
            .catch((error)=>{
                loggingAndMetrics.logError(error);
                sink.error(error);
            });
            if (requestID != null) // todo: stop sending the value of the promise to QueryPromisesMap. Might happen as part of cleaning up the feature gate for defer support writ large.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $7797X.QueryPromisesMap).set(requestID, promise);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};

});


parcelRegister("208o0", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $8a31979205723cc3$export$ec068583843480e7);

var $37Ewn = parcelRequire("37Ewn");

var $gYnSx = parcelRequire("gYnSx");

var $i3pnC = parcelRequire("i3pnC");

var $cgjj3 = parcelRequire("cgjj3");

var $kQnVX = parcelRequire("kQnVX");
const $8a31979205723cc3$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $37Ewn.Observable).create((sink)=>{
        const client = (0, $i3pnC.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            query: '',
            operationName: operationName,
            variables: variables,
            extensions: {
                pq: id
            }
        };
        let requestId;
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                // @ts-expect-error agg prop is missing on generic "extensions" type
                const aggRequestId = value?.extensions?.gateway?.request_id;
                requestId = aggRequestId ?? requestId;
                // @ts-expect-error incompatible types between two libraries
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = (0, $cgjj3.getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, $kQnVX.getUserLocation)()
                };
                sink.error(errorInfo);
                (0, $gYnSx.default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraRelaySubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    });

});
parcelRegister("i3pnC", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $8b503e440384fada$export$6bb76d6eba7e258c);

var $aP5Ku = parcelRequire("aP5Ku");

var $7oY9g = parcelRequire("7oY9g");

var $cIIZL = parcelRequire("cIIZL");


var $lWYYe = parcelRequire("lWYYe");
let $8b503e440384fada$var$client;
const $8b503e440384fada$export$6bb76d6eba7e258c = ()=>{
    if ((0, $lWYYe.isSSR)() || (0, $7oY9g.default)('graphql_subscriptions')) return null;
    if (!$8b503e440384fada$var$client) $8b503e440384fada$var$client = (0, $aP5Ku.createClient)({
        url: (0, $lWYYe.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $4e27773d74c87757$export$8b012b965402e06a),
        retryAttempts: (0, $4e27773d74c87757$export$bf6cd96e19b2987f),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $cIIZL.default).join(',')
        }
    });
    return $8b503e440384fada$var$client;
};
const $8b503e440384fada$export$2f0afd443356d36f = ()=>{
    $8b503e440384fada$var$client = null;
};

});
const $4e27773d74c87757$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $4e27773d74c87757$export$bf6cd96e19b2987f = 100;
const $4e27773d74c87757$export$1ad8434180c5936c = 300000; // 5m

parcelRegister("lWYYe", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $96dd7559b248a0eb$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $96dd7559b248a0eb$export$29a72e89601dfc59);
const $96dd7559b248a0eb$export$48d7c418edadb60c = ()=>false ?? false;
const $96dd7559b248a0eb$export$29a72e89601dfc59 = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("cgjj3", function(module, exports) {

$parcel$export(module.exports, "getSinkError", () => $97d53ef8026102d6$export$ece4736473c28965);

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $Bakwk = parcelRequire("Bakwk");
const $97d53ef8026102d6$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        if ((0, $7jTnu.fg)('issue-jsc-2856-investigate-subscription-undefined')) (0, $eSnSE.default).unsafeErrorWithCustomerData('graphql.subscription.getSinkError', `subscription undefined error ${(0, $Bakwk.stringifyEvent)(error)}`);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});
parcelRegister("Bakwk", function(module, exports) {

$parcel$export(module.exports, "stringifyEvent", () => $6d3fbda8473a46a1$export$6b599d9330014be8);
// some logs for investigation purpose, to be removed by 29/07/2025
/* eslint-disable guard-for-in */ function $6d3fbda8473a46a1$export$6b599d9330014be8(object, depth = 0, maxDepth = 2) {
    // go through max 2 levels of circular references
    if (depth > maxDepth) return 'Object';
    const obj = {};
    for(const key in object){
        // @ts-expect-error - TS7053
        let value = object[key];
        // @ts-expect-error - TS2339
        if (value instanceof Node) value = {
            id: value.id
        };
        else if (value instanceof Window) value = 'Window';
        else if (value instanceof Object) value = $6d3fbda8473a46a1$export$6b599d9330014be8(value, depth + 1, maxDepth);
        // @ts-expect-error - TS7053
        obj[key] = value;
    }
    return depth ? obj : JSON.stringify(obj);
}

});



parcelRegister("lLNFn", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $96879960c01891ca$export$48d7c418edadb60c);
const $96879960c01891ca$export$48d7c418edadb60c = ()=>false ?? false;

});





parcelRegister("hw1Vu", function(module, exports) {

$parcel$export(module.exports, "LoadingPhaseManager", () => $76a270903de176ca$export$6e4bfef9e80c7eb0);

var $eJOHy = parcelRequire("eJOHy");

var $8CQpJ = parcelRequire("8CQpJ");
const $76a270903de176ca$export$6e4bfef9e80c7eb0 = ()=>{
    const { startNextPhase: startNextPhase } = (0, $8CQpJ.useLazyPhase)();
    (0, $eJOHy.useEffect)(()=>{
        /**
     * Only start next phase if we are not in the SPA, because there is a second
     * LoadingPhaseManager specifically for the SPA, and we want it to transition at the correct time.
     * If we start this here inside the SPA, we will start RLL next phase and get lazyAfterPaint
     * bundles too early.
     */ if (__SPA__) return;
        /* Outside the SPA, we don't currently have a good proxy for page loads.
     * So for now we start the "after paint" phase a few seconds after mounting.
     */ setTimeout(()=>{
            performance.mark('rll-after-paint-phase');
            startNextPhase();
        }, 2000);
    }, [
        startNextPhase
    ]);
    return null;
};

});

parcelRegister("hXmA9", function(module, exports) {
module.exports = __LANG;

});


parcelRegister("xvuCV", function(module, exports) {

$parcel$export(module.exports, "FlagsBoundary", () => $04814a5dcc217132$export$8b4a0fffcddd96f4);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");
const $04814a5dcc217132$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, children));

});

parcelRegister("1PSAp", function(module, exports) {

$parcel$export(module.exports, "StrictMode", () => $e2fd64c5ded33d14$export$5f8d39834fd61797);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");
const $e2fd64c5ded33d14$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = !(0, $7jTnu.fg)('jira-enable-strict-mode');
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled by default
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).StrictMode, null, children);
};

});

parcelRegister("3QD9g", function(module, exports) {

let $2cd4987bbf37ae49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2cd4987bbf37ae49$var$load("5kmxd").then(()=>parcelRequire('2VCXr'));

});


parcelRegister("82Phg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da55c420010ab57$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $1PSAp = parcelRequire("1PSAp");

var $96Fb4 = parcelRequire("96Fb4");
const $4da55c420010ab57$var$getPlaceholder = (placeholderId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const existingPlaceholder = document.getElementById(placeholderId);
    if (existingPlaceholder) return existingPlaceholder;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const div = document.createElement('div');
    div.id = placeholderId;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.body.appendChild(div);
    else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
    return div;
};
const $4da55c420010ab57$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
    if (placeholder && sessionId) (0, $aQK2r.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $96Fb4.default), {
        sessionId: sessionId,
        data: data
    })), $4da55c420010ab57$var$getPlaceholder(placeholder));
};
var $4da55c420010ab57$export$2e2bcd8739ae039 = $4da55c420010ab57$var$renderDwellTimeComponent;

});
parcelRegister("96Fb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $778b4a13c0a09b07$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $BwaQq = parcelRequire("BwaQq");

var $7iHUq = parcelRequire("7iHUq");


var $2x61s = parcelRequire("2x61s");
const $778b4a13c0a09b07$var$defaultSource = 'dwellComponent';
const $778b4a13c0a09b07$var$defaultActionSubject = 'dwellComponent';
const $778b4a13c0a09b07$var$getDwellComponent = (source, actionSubject)=>(0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $BwaQq.AnalyticsSubject)(actionSubject || $778b4a13c0a09b07$var$defaultActionSubject), (0, $BwaQq.AnalyticsSource)(source || $778b4a13c0a09b07$var$defaultSource, (0, $466f60259c330878$export$f636b5b56f1d624a)))((0, $2x61s.default));
class $778b4a13c0a09b07$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props) {
        const { data: data } = props;
        return {
            DwellTimeComponent: $778b4a13c0a09b07$var$getDwellComponent(data.source, data.actionSubject)
        };
    }
    constructor(props){
        super(props);
        this.state = {
            DwellTimeComponent: null
        };
    }
    render() {
        const { sessionId: sessionId, data: data } = this.props;
        const { DwellTimeComponent: DwellTimeComponent } = this.state;
        const enrichedData = {
            ...data,
            source: data && data.source || $778b4a13c0a09b07$var$defaultSource,
            actionSubject: data && data.actionSubject || $778b4a13c0a09b07$var$defaultActionSubject
        };
        if (sessionId && DwellTimeComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DwellTimeComponent, {
            sessionId: sessionId,
            data: enrichedData
        }));
        return null;
    }
}

});
parcelRegister("eq3Hf", function(module, exports) {

var $lH6wc = parcelRequire("lH6wc");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var $a7f65c72bfe5b7ea$var$flow = $lH6wc();
module.exports = $a7f65c72bfe5b7ea$var$flow;

});
parcelRegister("lH6wc", function(module, exports) {

var $iTpII = parcelRequire("iTpII");

var $lgI96 = parcelRequire("lgI96");

var $2GK2O = parcelRequire("2GK2O");

var $asy1v = parcelRequire("asy1v");

var $4sprp = parcelRequire("4sprp");

var $74osV = parcelRequire("74osV");
/** Error message constants. */ var $fcb2ab89fd3879f0$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $fcb2ab89fd3879f0$var$WRAP_CURRY_FLAG = 8, $fcb2ab89fd3879f0$var$WRAP_PARTIAL_FLAG = 32, $fcb2ab89fd3879f0$var$WRAP_ARY_FLAG = 128, $fcb2ab89fd3879f0$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function $fcb2ab89fd3879f0$var$createFlow(fromRight) {
    return $lgI96(function(funcs) {
        var length = funcs.length, index = length, prereq = $iTpII.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError($fcb2ab89fd3879f0$var$FUNC_ERROR_TEXT);
            if (prereq && !wrapper && $asy1v(func) == 'wrapper') var wrapper = new $iTpII([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = $asy1v(func), data = funcName == 'wrapper' ? $2GK2O(func) : undefined;
            if (data && $74osV(data[0]) && data[1] == ($fcb2ab89fd3879f0$var$WRAP_ARY_FLAG | $fcb2ab89fd3879f0$var$WRAP_CURRY_FLAG | $fcb2ab89fd3879f0$var$WRAP_PARTIAL_FLAG | $fcb2ab89fd3879f0$var$WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[$asy1v(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && $74osV(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && $4sprp(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = $fcb2ab89fd3879f0$var$createFlow;

});
parcelRegister("iTpII", function(module, exports) {

var $b7PJS = parcelRequire("b7PJS");

var $iSWBo = parcelRequire("iSWBo");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $dc11508658975546$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$dc11508658975546$var$LodashWrapper.prototype = $b7PJS($iSWBo.prototype);
$dc11508658975546$var$LodashWrapper.prototype.constructor = $dc11508658975546$var$LodashWrapper;
module.exports = $dc11508658975546$var$LodashWrapper;

});
parcelRegister("iSWBo", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $dbfaba4a3b3a815b$var$baseLodash() {
// No operation performed.
}
module.exports = $dbfaba4a3b3a815b$var$baseLodash;

});


parcelRegister("2GK2O", function(module, exports) {

var $giyy7 = parcelRequire("giyy7");

var $12DRg = parcelRequire("12DRg");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $1f533870d3d62e5d$var$getData = !$giyy7 ? $12DRg : function(func) {
    return $giyy7.get(func);
};
module.exports = $1f533870d3d62e5d$var$getData;

});
parcelRegister("giyy7", function(module, exports) {

var $hWTvf = parcelRequire("hWTvf");
/** Used to store function metadata. */ var $bdd9209418d26c19$var$metaMap = $hWTvf && new $hWTvf;
module.exports = $bdd9209418d26c19$var$metaMap;

});


parcelRegister("asy1v", function(module, exports) {

var $lPnRE = parcelRequire("lPnRE");
/** Used for built-in method references. */ var $79d6e934e9859363$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $79d6e934e9859363$var$hasOwnProperty = $79d6e934e9859363$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $79d6e934e9859363$var$getFuncName(func) {
    var result = func.name + '', array = $lPnRE[result], length = $79d6e934e9859363$var$hasOwnProperty.call($lPnRE, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $79d6e934e9859363$var$getFuncName;

});
parcelRegister("lPnRE", function(module, exports) {
/** Used to lookup unminified function names. */ var $fe40df58a594c3c0$var$realNames = {};
module.exports = $fe40df58a594c3c0$var$realNames;

});


parcelRegister("74osV", function(module, exports) {

var $ab1mA = parcelRequire("ab1mA");

var $2GK2O = parcelRequire("2GK2O");

var $asy1v = parcelRequire("asy1v");

var $4ODiF = parcelRequire("4ODiF");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $525be278ce84eab2$var$isLaziable(func) {
    var funcName = $asy1v(func), other = $4ODiF[funcName];
    if (typeof other != 'function' || !(funcName in $ab1mA.prototype)) return false;
    if (func === other) return true;
    var data = $2GK2O(other);
    return !!data && func === data[0];
}
module.exports = $525be278ce84eab2$var$isLaziable;

});
parcelRegister("ab1mA", function(module, exports) {

var $b7PJS = parcelRequire("b7PJS");

var $iSWBo = parcelRequire("iSWBo");
/** Used as references for the maximum length and index of an array. */ var $768bfd3243192c62$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $768bfd3243192c62$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $768bfd3243192c62$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$768bfd3243192c62$var$LazyWrapper.prototype = $b7PJS($iSWBo.prototype);
$768bfd3243192c62$var$LazyWrapper.prototype.constructor = $768bfd3243192c62$var$LazyWrapper;
module.exports = $768bfd3243192c62$var$LazyWrapper;

});

parcelRegister("4ODiF", function(module, exports) {

var $ab1mA = parcelRequire("ab1mA");

var $iTpII = parcelRequire("iTpII");

var $iSWBo = parcelRequire("iSWBo");

var $4sprp = parcelRequire("4sprp");

var $7gKgM = parcelRequire("7gKgM");

var $8gTTQ = parcelRequire("8gTTQ");
/** Used for built-in method references. */ var $381a5122a63b198d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $381a5122a63b198d$var$hasOwnProperty = $381a5122a63b198d$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $381a5122a63b198d$var$lodash(value) {
    if ($7gKgM(value) && !$4sprp(value) && !(value instanceof $ab1mA)) {
        if (value instanceof $iTpII) return value;
        if ($381a5122a63b198d$var$hasOwnProperty.call(value, '__wrapped__')) return $8gTTQ(value);
    }
    return new $iTpII(value);
}
// Ensure wrappers are instances of `baseLodash`.
$381a5122a63b198d$var$lodash.prototype = $iSWBo.prototype;
$381a5122a63b198d$var$lodash.prototype.constructor = $381a5122a63b198d$var$lodash;
module.exports = $381a5122a63b198d$var$lodash;

});
parcelRegister("8gTTQ", function(module, exports) {

var $ab1mA = parcelRequire("ab1mA");

var $iTpII = parcelRequire("iTpII");

var $k4ZVz = parcelRequire("k4ZVz");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $605b2de1cde3289a$var$wrapperClone(wrapper) {
    if (wrapper instanceof $ab1mA) return wrapper.clone();
    var result = new $iTpII(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $k4ZVz(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $605b2de1cde3289a$var$wrapperClone;

});





parcelRegister("BwaQq", function(module, exports) {

$parcel$export(module.exports, "AnalyticsSource", () => $38148dc6317877af$export$6890652a1aff7d1c);
$parcel$export(module.exports, "AnalyticsSubject", () => $38148dc6317877af$export$ec9f54bd4341ceb);

var $dUaMU = parcelRequire("dUaMU");
const $38148dc6317877af$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $dUaMU.default)({
            source: `${name}${type}`
        })(WrappedComponent);
const $38148dc6317877af$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $dUaMU.default)({
            actionSubject: name,
            attributes: attributes
        })(WrappedComponent);

});

// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("2x61s", function(module, exports) {

$parcel$export(module.exports, "default", () => $68505db1eb5cfa8c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $khgKq = parcelRequire("khgKq");

var $aBFKZ = parcelRequire("aBFKZ");

var $2ZYsz = parcelRequire("2ZYsz");
class $68505db1eb5cfa8c$export$1c7ccff61c195c75 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { data: data, sessionId: sessionId } = this.props;
        // @ts-expect-error - TS2741 - Property 'prototype' is missing in type 'DwellTimeHelper' but required in type 'typeof DwellTimeHelper'.
        this.dwellHelper = new (0, $khgKq.default)(this.sendDwellEvent, data, sessionId);
        // @ts-expect-error - TS2339 - Property 'start' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.start();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) // @ts-expect-error - TS2339 - Property 'newPage' does not exist on type 'typeof DwellTimeHelper'.
        this.dwellHelper.newPage(this.props.data, this.props.sessionId);
    }
    componentWillUnmount() {
        if (this.dwellHelper) {
            // @ts-expect-error - TS2339 - Property 'stop' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.stop();
            // @ts-expect-error - TS2339 - Property 'destroy' does not exist on type 'typeof DwellTimeHelper'.
            this.dwellHelper.destroy();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, this.props.children);
    }
    constructor(...args){
        super(...args), this.sendDwellEvent = (payload)=>(0, $2ZYsz.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
    }
}
var $68505db1eb5cfa8c$export$2e2bcd8739ae039 = (0, $aBFKZ.default)('dwellTime', {
    onDwell: 'dwelled'
})($68505db1eb5cfa8c$export$1c7ccff61c195c75);

});
parcelRegister("aBFKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86225f230220e152$export$2e2bcd8739ae039);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");
const $86225f230220e152$export$871de8747c9eaa88 = (props)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            ...result,
            [key]: {
                action: props[key]
            }
        }), {});
/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $86225f230220e152$var$componentWithAnalytics(componentName, eventActions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(WrappedComponent) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $dUaMU.default)({
            componentName: componentName
        })((0, $4J0ad.default)($86225f230220e152$export$871de8747c9eaa88(eventActions))(WrappedComponent));
    };
}
var $86225f230220e152$export$2e2bcd8739ae039 = $86225f230220e152$var$componentWithAnalytics;

});

parcelRegister("2ZYsz", function(module, exports) {

$parcel$export(module.exports, "fireTrackAnalytics", () => $1abd420c0e1cdad5$export$13990ad4625571ed);

var $9pL9Y = parcelRequire("9pL9Y");

var $iM63C = parcelRequire("iM63C");

var $5nSuO = parcelRequire("5nSuO");
const $1abd420c0e1cdad5$var$isNotUndefined = (a)=>a !== undefined;
const $1abd420c0e1cdad5$var$mapPayload = (payload)=>{
    const context = (0, $5nSuO.default)(payload);
    const { action: action, actionSubjectId: actionSubjectId } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))({
        ...context,
        ...context.attributes,
        attributes: undefined,
        action: action,
        actionSubjectId: actionSubjectId
    }, $1abd420c0e1cdad5$var$isNotUndefined);
};
const $1abd420c0e1cdad5$export$13990ad4625571ed = (event, payload)=>{
    event.update({
        ...$1abd420c0e1cdad5$var$mapPayload(payload),
        analyticsType: (0, $iM63C.TRACK_EVENT_TYPE)
    }).fire();
};

});
parcelRegister("5nSuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff538d0ffacbfcb$export$2e2bcd8739ae039);

var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");
var // AnalyticsDataPayload is cast to inexact type so that it can also accept subtypes
// eslint-disable-next-line jira/import/no-anonymous-default-export
$fff538d0ffacbfcb$export$2e2bcd8739ae039 = (payload)=>{
    const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
        tags: tags,
        containerId: containerId,
        containers: containers,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
};

});





parcelRegister("lshWh", function(module, exports) {

let $f9ea20cca70f462f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f9ea20cca70f462f$var$load("ffQaD"),
    $f9ea20cca70f462f$var$load("kvRbA"),
    $f9ea20cca70f462f$var$load("76n7a"),
    $f9ea20cca70f462f$var$load("l253H"),
    $f9ea20cca70f462f$var$load("4MgLp")
]).then(()=>parcelRequire('hog0p'));

});

parcelRegister("2bhSk", function(module, exports) {

let $196a798224265efc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $196a798224265efc$var$load("ffQaD"),
    $196a798224265efc$var$load("kvRbA"),
    $196a798224265efc$var$load("kVX56"),
    $196a798224265efc$var$load("cQ657")
]).then(()=>parcelRequire('hWg6N'));

});

parcelRegister("krIXg", function(module, exports) {

let $ee29336346b2c843$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ee29336346b2c843$var$load("8hXQt").then(()=>parcelRequire('7Y0pd'));

});

parcelRegister("9qKSM", function(module, exports) {

let $6ddae8a76eda4331$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6ddae8a76eda4331$var$load("d6oIh"),
    $6ddae8a76eda4331$var$load("ffQaD"),
    $6ddae8a76eda4331$var$load("kvRbA"),
    $6ddae8a76eda4331$var$load("76n7a"),
    $6ddae8a76eda4331$var$load("l253H"),
    $6ddae8a76eda4331$var$load("3yAl4"),
    $6ddae8a76eda4331$var$load("jbxE1"),
    $6ddae8a76eda4331$var$load("7imUH"),
    $6ddae8a76eda4331$var$load("isfJL"),
    $6ddae8a76eda4331$var$load("b3QiB"),
    $6ddae8a76eda4331$var$load("kNFvF"),
    $6ddae8a76eda4331$var$load("fliVL"),
    $6ddae8a76eda4331$var$load("7mIf9"),
    $6ddae8a76eda4331$var$load("jXweD"),
    $6ddae8a76eda4331$var$load("kVX56"),
    $6ddae8a76eda4331$var$load("9FYK6")
]).then(()=>parcelRequire('bGpt9'));

});

parcelRegister("eGXOi", function(module, exports) {

let $ab2361fbd4f6f4f2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab2361fbd4f6f4f2$var$load("hIs61").then(()=>parcelRequire('aWV53'));

});


parcelRegister("gQdiM", function(module, exports) {

$parcel$export(module.exports, "renderPageContainer", () => $a2ef109ff22e24b4$export$53746a9158b8b9c8);
$parcel$export(module.exports, "default", () => $a2ef109ff22e24b4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $aYncF = parcelRequire("aYncF");

var $2dBpR = parcelRequire("2dBpR");

var $1qbKn = parcelRequire("1qbKn");

var $3KIqP = parcelRequire("3KIqP");

var $hWeHP = parcelRequire("hWeHP");
parcelRequire("lXp9u");

var $kQnVX = parcelRequire("kQnVX");

var $1PSAp = parcelRequire("1PSAp");

var $e8u2a = parcelRequire("e8u2a");

var $b2uWc = parcelRequire("b2uWc");

var $9wUjG = parcelRequire("9wUjG");

var $lZMpx = parcelRequire("lZMpx");

var $9aXOX = parcelRequire("9aXOX");

var $gOhgJ = parcelRequire("gOhgJ");

var $e43Ye = parcelRequire("e43Ye");
var $30bwc = parcelRequire("30bwc");

// Trigger async import asap, no need for RLL as SSR renders without too
const $a2ef109ff22e24b4$var$pageContainerImport = (parcelRequire("5lCDr"));

var $hXmA9 = parcelRequire("hXmA9");
const $a2ef109ff22e24b4$export$53746a9158b8b9c8 = async ({ App: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'ComponentType<any>'.
App = null, containerId: containerId = 'navigation-app', onLoad: onLoad, pageType: pageType = 'legacy-page' } = {})=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const container = document.getElementById(containerId);
    if (container) {
        const { default: PageContainerV2 } = await $a2ef109ff22e24b4$var$pageContainerImport;
        (0, $gOhgJ.LooselyLazy).init({
            mode: 'RENDER',
            crossOrigin: 'anonymous'
        });
        const tenantContext = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
        $parcel$global.__NAV_VERSION__ = '3.0.0';
        (0, $3KIqP.initPlatformFeatureFlags)((0, $9aXOX.visualRefreshResolverOverride));
        const history = (0, $e43Ye.createLegacyHistory)();
        const routes = (0, $9wUjG.getLegacyRoutes)();
        const matchedRoute = (0, $30bwc.default)(routes, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.pathname, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.search, '');
        (0, $kQnVX.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
        const resourceContext = (0, $lZMpx.getSpaRouterContext)({
            tenantContext: tenantContext
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resourceData = window.SKELETON_NAVIGATION;
        const LegacyRouter = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b2uWc.Router), {
                history: history,
                routes: routes,
                resourceContext: resourceContext,
                resourceData: resourceData
            }, children);
        const placeholders = (0, $2dBpR.getPlaceholdersFromHTML)();
        (0, $aQK2r.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1PSAp.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dBpR.EntryPointPlaceholderContext).Provider, {
            value: placeholders
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(PageContainerV2, {
            id: "jira.entry.legacy",
            locale: tenantContext.locale,
            messages: $hXmA9,
            onLoad: onLoad,
            Router: LegacyRouter,
            routerLinkComponent: (0, $e8u2a.JiraRouterLinkConfiguration),
            pageType: pageType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), {
            id: "jira.route-app.legacy-bootstrap"
        }, App ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(App, null) : null)))), container);
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a2ef109ff22e24b4$export$2e2bcd8739ae039 = ()=>{
    const isGlobalSidebarEnabled = (0, $hWeHP.default)('ajs-global-sidebar-enabled') === 'true';
    if (!isGlobalSidebarEnabled) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (document.getElementById('navigation-app')) $a2ef109ff22e24b4$export$53746a9158b8b9c8();
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener('DOMContentLoaded', ()=>$a2ef109ff22e24b4$export$53746a9158b8b9c8());
};

});
parcelRegister("2dBpR", function(module, exports) {

$parcel$export(module.exports, "getPlaceholdersFromHTML", () => $8022a3e2b790699e$export$9e9f35acc3af3a9a);
$parcel$export(module.exports, "EntryPointPlaceholderContext", () => $8022a3e2b790699e$export$b5b377bb81310c48);
$parcel$export(module.exports, "EntryPointReferencePlaceholder", () => $8022a3e2b790699e$export$35247b69e0cfe74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $7jTnu = parcelRequire("7jTnu");

var $f2JN3 = parcelRequire("f2JN3");
const $8022a3e2b790699e$var$styles = {
    root: "_1e0c1bgi"
};
const $8022a3e2b790699e$var$Placeholder = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-concurrent-fix-entrypoint-placeholder'), (0, $ch9En.PlaceholderWithNativeSuspense), (0, $ch9En.default));
function $8022a3e2b790699e$export$9e9f35acc3af3a9a() {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return new Map(Array.from(placeholders, (el)=>[
            el.dataset.epPlaceholderId,
            el.innerHTML
        ]));
}
const $8022a3e2b790699e$export$b5b377bb81310c48 = /*#__PURE__*/ (0, $eJOHy.createContext)(new Map());
function $8022a3e2b790699e$export$35247b69e0cfe74({ children: children, entryPointReference: entryPointReference, fallback: originalFallback, name: name, ...placeholderProps }) {
    const hasMounted = (0, $eJOHy.useRef)(false);
    // using useState to ensure the entryPointReference is loaded synchronously
    // for the initial render (enabling SSR)
    const [component] = (0, $eJOHy.useState)(()=>{
        if (entryPointReference) try {
            return entryPointReference.getComponent();
        } catch (thrown) {
            return undefined;
        }
    });
    const placeholders = (0, $eJOHy.useContext)($8022a3e2b790699e$export$b5b377bb81310c48);
    const ssrFallback = placeholders.get(name);
    const [fallback, setFallback] = (0, $eJOHy.useState)(!ssrFallback || component ? originalFallback : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: ssrFallback
        },
        "data-ep-placeholder-id": name,
        className: (0, $hcewu.default)([
            $8022a3e2b790699e$var$styles.root
        ])
    }));
    const lastOriginalFallback = (0, $eJOHy.useRef)(originalFallback);
    lastOriginalFallback.current = originalFallback;
    const resetFallback = (0, $eJOHy.useCallback)(()=>{
        if (placeholders.has(name)) {
            placeholders.delete(name);
            setFallback(lastOriginalFallback.current);
        }
    }, [
        name,
        placeholders,
        setFallback
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // reset the fallback when the entrypoint reference changes
        if (hasMounted.current) resetFallback();
    }, [
        entryPointReference,
        resetFallback
    ]);
    (0, $eJOHy.useEffect)(()=>{
        hasMounted.current = true;
        // reset fallback on unmount
        return resetFallback;
    }, [
        resetFallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8022a3e2b790699e$var$Placeholder, {
        fallback: fallback,
        name: name,
        ...placeholderProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-ep-placeholder-id": name,
        className: (0, $hcewu.default)([
            $8022a3e2b790699e$var$styles.root
        ])
    }, children));
}

});

parcelRegister("3KIqP", function(module, exports) {

$parcel$export(module.exports, "initPlatformFeatureFlags", () => $ed64a16fdeb4cbad$export$2d291317456ada16);

var $eGOwo = parcelRequire("eGOwo");

var $7jTnu = parcelRequire("7jTnu");

var $bi9FK = parcelRequire("bi9FK");
const $ed64a16fdeb4cbad$export$2d291317456ada16 = ([isOverride, resolver])=>{
    (0, $eGOwo.setBooleanFeatureFlagResolver)((flagKey)=>// disable existence check as platform feature >flags< might not be gates
        (0, $7jTnu.withoutFeatureExistenceCheck)(()=>isOverride(flagKey) ? resolver(flagKey) : (0, $7jTnu.fg)(flagKey) || (0, $bi9FK.ff)(flagKey)));
};

});
parcelRegister("bi9FK", function(module, exports) {

$parcel$export(module.exports, "ff", () => $af7a0b2e539364ac$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $af7a0b2e539364ac$export$757bc67afadef4a0);
$parcel$export(module.exports, "getFeatureFlagValue", () => $af7a0b2e539364ac$export$7064bb599f663d7e);

var $4iJGP = parcelRequire("4iJGP");

var $6eHOp = parcelRequire("6eHOp");

var $9DwQv = parcelRequire("9DwQv");

var $4ajKf = parcelRequire("4ajKf");
function $af7a0b2e539364ac$export$a6dcfcb59016e126(featureFlagName, defaultValue) {
    const client = (0, $4ajKf.getFeatureFlagClient)();
    const flag = client.getFlagEvaluation(featureFlagName, {
        default: defaultValue
    });
    if (!flag) return defaultValue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return flag.value;
}
const $af7a0b2e539364ac$var$getBooleanFeatureFlagUsingClient = (featureFlagName, defaultValue)=>{
    const client = (0, $4ajKf.getFeatureFlagClient)();
    return client.getBooleanValue(featureFlagName, {
        default: defaultValue,
        shouldTrackExposureEvent: false
    });
};
const $af7a0b2e539364ac$var$getMultivariateFeatureFlagUsingClient = (featureFlagName, defaultValue, possibleValues)=>{
    const client = (0, $4ajKf.getFeatureFlagClient)();
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'T'.
    return client.getVariantValue(featureFlagName, {
        default: defaultValue,
        // @ts-expect-error - TS2322 - Type 'T[]' is not assignable to type 'string[]'.
        oneOf: possibleValues,
        shouldTrackExposureEvent: false
    });
};
/**
 * The feature flag client can be configured to fire automatic exposure events when evaluating
 * feature flag values. For the Track All Changes project, we need all flag evaluations to go
 * through this client so that we can collect these events for all feature flags.
 * See https://hello.atlassian.net/browse/FD-18145 for more information.
 */ const $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations = ()=>(0, $9DwQv.isAutomaticExposureCollectionEnabled)();
const $af7a0b2e539364ac$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$var$getBooleanFeatureFlagUsingClient : (0, $6eHOp.ff);
    const value = impl(featureFlagName, defaultValue);
    (0, $4iJGP.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
};
function $af7a0b2e539364ac$export$757bc67afadef4a0(featureFlagName, defaultValue, possibleValues) {
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$var$getMultivariateFeatureFlagUsingClient : (0, $6eHOp.getMultivariateFeatureFlag);
    const value = impl(featureFlagName, defaultValue, possibleValues);
    (0, $4iJGP.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
}
function $af7a0b2e539364ac$export$7064bb599f663d7e(featureFlagName, defaultValue) {
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$export$a6dcfcb59016e126 : (0, $6eHOp.getFeatureFlagValue);
    const value = impl(featureFlagName, defaultValue);
    (0, $4iJGP.addFeatureFlagAccessed)(featureFlagName, value);
    return impl(featureFlagName, defaultValue);
}

});
parcelRegister("6eHOp", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagValue", () => $da6d0b5f6a4027e4$export$7064bb599f663d7e);
$parcel$export(module.exports, "ff", () => $da6d0b5f6a4027e4$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $da6d0b5f6a4027e4$export$757bc67afadef4a0);

var $j500r = parcelRequire("j500r");

var $574hj = parcelRequire("574hj");
function $da6d0b5f6a4027e4$export$7064bb599f663d7e(featureFlagName, defaultValue) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (typeof (0, $j500r._haveValuesArrived) !== 'undefined' && !(0, $j500r._haveValuesArrived)() && globalVar.__SSR_IS_FAST_META_ENABLED__ && typeof globalVar.__SSR_SYNC_FF__ === 'function') {
        const flagInSSR = globalVar.__SSR_SYNC_FF__(featureFlagName, defaultValue);
        return flagInSSR;
    }
    return (0, $574hj.parseFeatureFlagValue)((0, $j500r.default)(), featureFlagName, defaultValue);
}
const $da6d0b5f6a4027e4$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const flagValue = $da6d0b5f6a4027e4$export$7064bb599f663d7e(featureFlagName, defaultValue);
    const isValid = typeof flagValue === 'boolean';
    return isValid ? flagValue : defaultValue;
};
const $da6d0b5f6a4027e4$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues)=>{
    const flagValue = $da6d0b5f6a4027e4$export$7064bb599f663d7e(featureFlagName, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    defaultValue);
    const isValid = typeof flagValue === 'string' && possibleValues.includes(flagValue);
    return isValid ? flagValue : defaultValue;
};

});
parcelRegister("574hj", function(module, exports) {

$parcel$export(module.exports, "parseFeatureFlagValue", () => $3610b104b5ef47fc$export$cd8c68e04b9439b5);
function $3610b104b5ef47fc$export$cd8c68e04b9439b5(featureFlags, featureFlagName, defaultValue) {
    const flagValue = featureFlags[featureFlagName];
    if (flagValue === undefined) return defaultValue;
    if (typeof flagValue === 'object' && 'value' in flagValue) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return flagValue.value;
    // This _should never happen_, but we need to validate it to remove
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return flagValue;
}

});


parcelRegister("9DwQv", function(module, exports) {

$parcel$export(module.exports, "isAutomaticExposureCollectionEnabled", () => $deb32d3e51fbc689$export$cf2aaf3c58e46848);
const $deb32d3e51fbc689$export$c9c75778ebadb3f1 = ()=>100;
const $deb32d3e51fbc689$export$cf2aaf3c58e46848 = ()=>true;

});

parcelRegister("4ajKf", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagClient", () => $236e6674104348c2$export$43a6e0552eef5ca9);

var $LFmXM = parcelRequire("LFmXM");
parcelRequire("3HGde");
var $luZJ4 = parcelRequire("luZJ4");

var $j500r = parcelRequire("j500r");

var $2Mqjh = parcelRequire("2Mqjh");
const $236e6674104348c2$var$getAnalyticsClientInstance = ()=>(0, $2Mqjh.getAnalyticsWebClientPromise)().then((analyticsClient)=>analyticsClient.getInstance());
const $236e6674104348c2$var$createFeatureFlagClient = ()=>{
    const client = new (0, $luZJ4.default)({
        analyticsHandler: {
            sendOperationalEvent: async (event)=>{
                if (!false) $236e6674104348c2$var$getAnalyticsClientInstance().then((analyticsClient)=>{
                    // SSR doesn't have an analytics client
                    if (!analyticsClient) return;
                    // customize event data here if needed
                    analyticsClient.sendOperationalEvent(event);
                });
            }
        },
        flags: undefined
    });
    return client;
};
const $236e6674104348c2$var$featureFlagClient = $236e6674104348c2$var$createFeatureFlagClient();
const $236e6674104348c2$var$getFeatureFlags = ()=>{
    const flags = (0, $j500r.default)();
    if (Object.keys(flags).length === 0) {
        if (false) {
            const err = new Error("Feature flags are not available yet. The feature flag client can't be initialized");
            // print out the stack trace for SSR, so we can have better understanding on
            // which module is using the client too early.
            // in SSR, we use bunyan to replace the console.error, so we can use the standard
            // log format for apps.
            // eslint-disable-next-line no-console
            console.error({
                err: err
            });
        } else // eslint-disable-next-line no-console
        console.error("Feature flags are not available yet. The feature flag client can't be initialized");
    }
    return flags;
};
const $236e6674104348c2$var$configureFeatureFlagClient = ()=>{
    const flags = $236e6674104348c2$var$getFeatureFlags();
    // @ts-expect-error - TS2345 - Argument of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/utils/feature-flagging-using-meta/src/common/types").Flags' is not assignable to parameter of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@atlaskit/feature-flag-client/dist/types/types").Flags'.
    $236e6674104348c2$var$featureFlagClient.setFlags(flags);
    if (!false) $236e6674104348c2$var$featureFlagClient.setIsAutomaticExposuresEnabled(true);
    return $236e6674104348c2$var$featureFlagClient;
};
// NOTE: `memoizeOne` is doing unnecessary checks, what we need in this file is
// a simple local variable implementation, if local variable doesn't exist then
// create it.
const $236e6674104348c2$var$getMemoizedFeatureFlagClient = (0, $LFmXM.default)($236e6674104348c2$var$configureFeatureFlagClient);
let $236e6674104348c2$var$builtFeatureFlagClient;
const $236e6674104348c2$export$43a6e0552eef5ca9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled === true) {
        if (typeof $236e6674104348c2$var$builtFeatureFlagClient === 'undefined' || globalVar.invalidateFeatureFlagsClient_DO_NOT_USE === true) {
            globalVar.invalidateFeatureFlagsClient_DO_NOT_USE = false;
            $236e6674104348c2$var$builtFeatureFlagClient = (0, $LFmXM.default)($236e6674104348c2$var$configureFeatureFlagClient);
        }
        return $236e6674104348c2$var$builtFeatureFlagClient();
    }
    return $236e6674104348c2$var$getMemoizedFeatureFlagClient();
};

});
parcelRegister("3HGde", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("luZJ4")).default);

var $luZJ4 = parcelRequire("luZJ4");

var $l27Vv = parcelRequire("l27Vv");

});
parcelRegister("luZJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcf7b7e4d681358f$export$2e2bcd8739ae039);

var $l27Vv = parcelRequire("l27Vv");

var $bLeeC = parcelRequire("bLeeC");

var $dfMe6 = parcelRequire("dfMe6");

var $51ACz = parcelRequire("51ACz");
class $bcf7b7e4d681358f$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $bLeeC.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $bLeeC.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $51ACz.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $dfMe6.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $l27Vv.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $l27Vv.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $l27Vv.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $bLeeC.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $bLeeC.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $l27Vv.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $bLeeC.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $l27Vv.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("l27Vv", function(module, exports) {

$parcel$export(module.exports, "ExposureTriggerReason", () => $525fe1842dde9869$export$2c20ffeba7dbc068);
var $525fe1842dde9869$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("bLeeC", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $22c42206e3495b7d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $22c42206e3495b7d$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $22c42206e3495b7d$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $22c42206e3495b7d$export$891630e169ca14a4);
const $22c42206e3495b7d$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $22c42206e3495b7d$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $22c42206e3495b7d$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $22c42206e3495b7d$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $22c42206e3495b7d$var$validateFlag = (flagKey, flag)=>{
    if ($22c42206e3495b7d$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $22c42206e3495b7d$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$22c42206e3495b7d$var$validateFlag(key, flags[key]));
};

});

parcelRegister("dfMe6", function(module, exports) {

$parcel$export(module.exports, "default", () => $97cdc47b760aea4d$export$2e2bcd8739ae039);
const $97cdc47b760aea4d$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $97cdc47b760aea4d$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $97cdc47b760aea4d$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("51ACz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4565132a6dc98d6b$export$2e2bcd8739ae039);

var $l27Vv = parcelRequire("l27Vv");
class $4565132a6dc98d6b$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $l27Vv.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $l27Vv.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});






parcelRegister("lXp9u", function(module, exports) {
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $awqaz = parcelRequire("awqaz");

if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("3avtZ"));
    const isDevMode = false;
    (0, $awqaz.default).devtools = isDevMode && (()=>({
            serialize: {
                // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
                replacer: (key, value)=>value instanceof HTMLElement ? {
                        data: {
                            tagName: value.tagName,
                            className: value.className,
                            id: value.id,
                            __SANITIZED__: true
                        },
                        __serializedType__: 'HTMLElement'
                    } : value
            }
        }));
    (0, $awqaz.default).batchUpdates = !false;
    Object.freeze((0, $awqaz.default));
    $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
}

});
parcelRegister("3avtZ", function(module, exports) {
const $24eaba0df287b1ab$var$style = document.createElement('style');
$24eaba0df287b1ab$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ul style:first-child~*+ul,ol ul:not(:first-child),ol style:first-child~*+ul,ul ol:not(:first-child),ul style:first-child~*+ol,ol ol:not(:first-child),ol style:first-child~*+ol{margin-top:var(--ds-space-050,4px)}p:first-child,style:first-child+p,ul:first-child,style:first-child+ul,ol:first-child,style:first-child+ol,dl:first-child,style:first-child+dl,h1:first-child,style:first-child+h1,h2:first-child,style:first-child+h2,h3:first-child,style:first-child+h3,h4:first-child,style:first-child+h4,h5:first-child,style:first-child+h5,h6:first-child,style:first-child+h6,blockquote:first-child,style:first-child+blockquote,pre:first-child,style:first-child+pre,form:first-child,style:first-child+form,table:first-child,style:first-child+table{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,ui-monospace,Menlo,"Segoe UI Mono","Ubuntu Mono",monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{color-scheme:light}[data-color-mode=dark]{color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,style:first-child+td,th:first-child,style:first-child+th{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,"Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
document.querySelector('head').appendChild($24eaba0df287b1ab$var$style);

});


parcelRegister("e8u2a", function(module, exports) {

$parcel$export(module.exports, "JiraRouterLinkConfiguration", () => $c164f32528a2f211$export$a580704a2f3cfca);

var $eJOHy = parcelRequire("eJOHy");

var $c9uTK = parcelRequire("c9uTK");

var $jiTA8 = parcelRequire("jiTA8");

var $7jTnu = parcelRequire("7jTnu");
const $c164f32528a2f211$export$a580704a2f3cfca = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
    const isEmbedMode = (0, $jiTA8.useIsEmbedMode)() && (0, $7jTnu.fg)('jira_nin_smart_link');
    if (// Links can be initially rendered with `href` not defined in some cases
    !href || typeof href === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ref: ref,
        href: href || '#',
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
        ref: ref,
        href: href.href,
        to: href.to,
        replace: href.replace,
        params: href.params,
        query: href.query,
        prefetch: href.prefetch,
        ...rest,
        ...isEmbedMode && {
            target: '_blank',
            rel: 'noopener'
        }
    }, children);
});

});
parcelRegister("jiTA8", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedMode", () => $e5c1436c84fc3f86$export$1b3c1ba6ee047da9);

var $eJOHy = parcelRequire("eJOHy");

var $Xckw8 = parcelRequire("Xckw8");

var $Xckw8 = parcelRequire("Xckw8");
const $e5c1436c84fc3f86$export$1b3c1ba6ee047da9 = ()=>(0, $eJOHy.useContext)((0, $Xckw8.EmbedModeContext));

});
parcelRegister("Xckw8", function(module, exports) {

$parcel$export(module.exports, "EmbedModeContext", () => $afaa80f88033d8aa$export$5eb07b3c7c0b0771);
$parcel$export(module.exports, "EmbedModeProvider", () => $afaa80f88033d8aa$export$9daaf42d62e1c430);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");
const $afaa80f88033d8aa$export$5eb07b3c7c0b0771 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const { Provider: $afaa80f88033d8aa$var$Provider } = $afaa80f88033d8aa$export$5eb07b3c7c0b0771;
const $afaa80f88033d8aa$var$handleEmbedLinkClick = (e)=>{
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $7jTnu.fg)('jira_nin_smart_link') && (0, $7jTnu.fg)('jsc_nin_smart_link_fast_follows')) {
        if (e.target instanceof Element) {
            const anchor = e.target.closest('a'); // Find closest parent anchor (including the target itself)
            if (anchor && anchor.target !== '_blank') // link
            anchor.target = '_blank';
        }
    } else {
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') // link
        eventTarget.target = '_blank';
    }
};
// When issue view is loaded within an iframe, it needs to follow the proper
// element elevation principles, found here: https://hello.atlassian.net/wiki/spaces/~460573267/pages/2355983526/Jira+Dark+Mode+-+UI+Guidelines#Element-elevation-basics
// Unfortunately the current elevation is set in the global-container, which is loaded before this Provider so
// we have to override the overrider to ensure that the proper elevation is set
const $afaa80f88033d8aa$var$DarkModeMonolithStyleOverride = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("style", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `
                    #jira-frontend {
                        background: ${"var(--ds-surface-overlay, #FFFFFF)"};
                    }
                `
        }
    });
const $afaa80f88033d8aa$export$9daaf42d62e1c430 = ({ children: children })=>{
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', $afaa80f88033d8aa$var$handleEmbedLinkClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', $afaa80f88033d8aa$var$handleEmbedLinkClick);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($afaa80f88033d8aa$var$DarkModeMonolithStyleOverride, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($afaa80f88033d8aa$var$Provider, {
        value: true
    }, children));
};

});



parcelRegister("b2uWc", function(module, exports) {

$parcel$export(module.exports, "Router", () => $c986d3ecfee6a30f$export$55185c17a0fcbe46);

var $eJOHy = parcelRequire("eJOHy");

var $bkb9R = parcelRequire("bkb9R");

var $69eg7 = parcelRequire("69eg7");
const $c986d3ecfee6a30f$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    const pluginsWithOverride = (0, $69eg7.usePlugins)({
        resourceContext: props.resourceContext,
        resourceData: props.resourceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bkb9R.Router), {
        plugins: pluginsWithOverride,
        ...props
    }, children);
};

});
parcelRegister("69eg7", function(module, exports) {

$parcel$export(module.exports, "usePlugins", () => $e6f8221df2b34d82$export$c41e96fd89bc6106);

var $eJOHy = parcelRequire("eJOHy");

var $l7yIU = parcelRequire("l7yIU");

var $7zZ4w = parcelRequire("7zZ4w");

var $lvKO5 = parcelRequire("lvKO5");

var $9NORu = parcelRequire("9NORu");
const $e6f8221df2b34d82$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    // make sure "plugins" are created only once, ignore prop change/rerender
    const [pluginsWithOverride] = (0, $eJOHy.useState)(()=>{
        const jiraPlugins = [];
        const resourcesPlugin = (0, $9NORu.createResourcesPlugin)({
            context: resourceContext,
            resourceData: resourceData
        });
        jiraPlugins.push(resourcesPlugin);
        jiraPlugins.push((0, $l7yIU.createEntryPointsPlugin)({
            environment: (0, $7zZ4w.default)(),
            entryPointParams: {
                tenantContext: tenantContext
            }
        }));
        return jiraPlugins;
    });
    return pluginsWithOverride;
};

});
parcelRegister("l7yIU", function(module, exports) {

$parcel$export(module.exports, "createEntryPointsPlugin", () => $876ec2c11a9ab638$export$33586718f82f356f);

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $fdqlv = parcelRequire("fdqlv");

var $jgV2J = parcelRequire("jgV2J");

var $4h7KW = parcelRequire("4h7KW");

var $i0DIU = parcelRequire("i0DIU");

var $2SVUj = parcelRequire("2SVUj");
const $876ec2c11a9ab638$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
        id: 'entry-points-plugin',
        routeLoad: ({ context: context })=>{
            const entryPoint = context.route.entryPoint?.();
            const prefetchingRoute = (0, $jgV2J.getPrefetchingRoute)();
            let entryPointReference = null;
            if (entryPoint) {
                // check if route EntryPoint is already prefetched right before being loaded
                if (prefetchingRoute && (0, $fdqlv.isSameRouteMatch)({
                    prevContextMatch: prefetchingRoute.routerContext.match,
                    nextContextMatch: context.match
                }) && !(0, $fdqlv.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                else {
                    const entryPointParamsWithContext = {
                        context: context,
                        ...entryPointParams
                    };
                    const loadEntryPointsWithContext = ()=>(0, $j4oe4.loadEntryPoint)({
                            getEnvironment: ()=>environment
                        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                        entryPoint, entryPointParamsWithContext);
                    entryPointReference = false && (0, $7jTnu.fg)('jira-ssr-prevent-prewarming-entrypoint-in-prefetch') ? (0, $2SVUj.default)(entryPoint, entryPointParamsWithContext, loadEntryPointsWithContext) : loadEntryPointsWithContext();
                }
            }
            // saving entryPointReference helps to prevent cases when same EntryPoint is fetched multiple times
            // important when fetchPolicy=network-only is used
            (0, $jgV2J.getEntryPointsStore)().actions.setLastLoadedRoute({
                route: context.route,
                entryPointReference: entryPointReference
            });
            return {
                entryPoint: entryPointReference
            };
        },
        routePrefetch: ({ nextContext: nextContext })=>{
            const entryPoint = nextContext.route.entryPoint?.();
            if (entryPoint) {
                const prevPrefetchingRoute = (0, $jgV2J.getPrefetchingRoute)();
                // check if EntryPoint is already prefetched and not expired
                if (prevPrefetchingRoute && (0, $fdqlv.isSameRouteMatch)({
                    prevContextMatch: prevPrefetchingRoute.routerContext.match,
                    nextContextMatch: nextContext.match
                }) && !(0, $fdqlv.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                const entryPointReference = (0, $j4oe4.loadEntryPoint)({
                    getEnvironment: ()=>environment
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                entryPoint, {
                    context: nextContext,
                    ...entryPointParams
                });
                (0, $jgV2J.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: (0, $fdqlv.getExpiresAt)(),
                    entryPointReference: entryPointReference
                });
            } else (0, $jgV2J.getEntryPointsStore)().actions.setPrefetchingRoute({
                routerContext: nextContext,
                expiresAt: 0,
                entryPointReference: null
            });
        },
        waitForEntryPoint: ()=>{
            const lastLoadedRoute = (0, $jgV2J.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $4h7KW.waitForEntryPoint)(entryPointReference);
            return Promise.resolve();
        },
        getStats: async ()=>{
            const lastLoadedRoute = (0, $jgV2J.getLastLoadedRoute)();
            const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
            if (entryPointReference) return (0, $i0DIU.getEntryPointStats)(entryPointReference);
            return [];
        }
    });

});
parcelRegister("fdqlv", function(module, exports) {

$parcel$export(module.exports, "getExpiresAt", () => $d7fcca574f4da31a$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "isExpired", () => $d7fcca574f4da31a$export$57947cfd429801a2);
$parcel$export(module.exports, "isSameRouteMatch", () => $d7fcca574f4da31a$export$5997e70fc4543270);
const $d7fcca574f4da31a$export$37d3126be6549b13 = 10000;
const $d7fcca574f4da31a$export$b65d7ba7fbf150f1 = ()=>$d7fcca574f4da31a$export$37d3126be6549b13 + Date.now();
const $d7fcca574f4da31a$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
const $d7fcca574f4da31a$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $d7fcca574f4da31a$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $d7fcca574f4da31a$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $d7fcca574f4da31a$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});

parcelRegister("jgV2J", function(module, exports) {

$parcel$export(module.exports, "useLastLoadedRoute", () => $998a919eec0f86c9$export$895238443fc3eae4);
$parcel$export(module.exports, "getEntryPointsStore", () => $998a919eec0f86c9$export$fe654a734624d17f);
$parcel$export(module.exports, "getLastLoadedRoute", () => $998a919eec0f86c9$export$5763b2305b3056df);
$parcel$export(module.exports, "getPrefetchingRoute", () => $998a919eec0f86c9$export$7e18f3e3cbd04326);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $14kUX = parcelRequire("14kUX");
const $998a919eec0f86c9$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
        setState({
            lastLoadedRoute: {
                route: route,
                entryPointReference: entryPointReference
            }
        });
    };
const $998a919eec0f86c9$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
        setState({
            prefetchingRoute: {
                routerContext: routerContext,
                expiresAt: expiresAt,
                entryPointReference: entryPointReference
            }
        });
    };
const $998a919eec0f86c9$var$actions = {
    setLastLoadedRoute: $998a919eec0f86c9$export$1cec83a23d40a9fa,
    setPrefetchingRoute: $998a919eec0f86c9$export$bb3dc9c55f78173e
};
const $998a919eec0f86c9$var$EntryPointsStore = (0, $GtRbT.createStore)({
    initialState: {
        lastLoadedRoute: null,
        prefetchingRoute: null
    },
    actions: $998a919eec0f86c9$var$actions,
    name: 'react-resource-router/entry-points'
});
const $998a919eec0f86c9$export$895238443fc3eae4 = (0, $iJq0l.createHook)($998a919eec0f86c9$var$EntryPointsStore, {
    selector: (state)=>state.lastLoadedRoute
});
const $998a919eec0f86c9$export$fe654a734624d17f = ()=>(0, $14kUX.defaultRegistry).getStore($998a919eec0f86c9$var$EntryPointsStore);
const $998a919eec0f86c9$export$b28ecd0e4705f6b7 = ()=>$998a919eec0f86c9$export$fe654a734624d17f().storeState.getState();
const $998a919eec0f86c9$export$5763b2305b3056df = ()=>$998a919eec0f86c9$export$b28ecd0e4705f6b7().lastLoadedRoute;
const $998a919eec0f86c9$export$7e18f3e3cbd04326 = ()=>$998a919eec0f86c9$export$b28ecd0e4705f6b7().prefetchingRoute;

});

parcelRegister("4h7KW", function(module, exports) {

$parcel$export(module.exports, "waitForEntryPoint", () => $a184a76db2ef2fa5$export$944f853f194e5dd5);

var $7797X = parcelRequire("7797X");
const $a184a76db2ef2fa5$export$944f853f194e5dd5 = (entryPointConfig)=>{
    const promises = [];
    try {
        entryPointConfig.getComponent();
    } catch (err) {
        if (err instanceof Promise) promises.push(err);
        else throw err;
    }
    const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
    if (queries) Object.keys(queries).forEach((key)=>{
        if (queries[key].id) {
            const queryPromise = (0, $7797X.QueryPromisesMap).get(String(queries[key].id));
            if (queryPromise) promises.push(queryPromise);
        }
    });
    if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
        const nestedEntryPointPromise = $a184a76db2ef2fa5$export$944f853f194e5dd5(entryPoints[key]);
        promises.push(nestedEntryPointPromise);
    });
    return Promise.allSettled(promises);
};

});

parcelRegister("i0DIU", function(module, exports) {

$parcel$export(module.exports, "getEntryPointStats", () => $58eb3ec1d460bae6$export$ee016802bdebb378);

var $7797X = parcelRequire("7797X");
const $58eb3ec1d460bae6$export$14ba46fa7bd4c0a9 = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
const $58eb3ec1d460bae6$export$982a0a12103fb99f = async (promise)=>{
    if (!promise) return 'resolved';
    try {
        if (await Promise.race([
            promise,
            Promise.resolve('timeout')
        ]) === 'timeout') return 'pending';
        return 'resolved';
    } catch (e) {
        return 'rejected';
    }
};
const $58eb3ec1d460bae6$var$getEntrypointQueryState = async (queryId)=>{
    const queryPromise = (0, $7797X.QueryPromisesMap).get(queryId);
    return {
        queryId: queryId,
        status: await $58eb3ec1d460bae6$export$982a0a12103fb99f(queryPromise)
    };
};
const $58eb3ec1d460bae6$export$ee016802bdebb378 = (entryPointConfig)=>{
    const result = [];
    const analyseEntrypoint = ({ queries: queries, entryPoints: entryPoints })=>{
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) result.push($58eb3ec1d460bae6$var$getEntrypointQueryState(String(queries[key].id)));
        });
        if (entryPoints) Object.entries(entryPoints).forEach(([, entryPoint])=>{
            analyseEntrypoint(entryPoint);
        });
    };
    analyseEntrypoint(entryPointConfig);
    return Promise.all(result);
};

});

parcelRegister("2SVUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbdf54c610441d8$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7jTnu = parcelRequire("7jTnu");

var $hu2rE = parcelRequire("hu2rE");

var $72rfN = parcelRequire("72rfN");

var $j9bXh = parcelRequire("j9bXh");

// eslint-disable-next-line jira/jira-ssr/wrong-entrypoint-usage
const $2fbdf54c610441d8$var$DummyAsyncModule = (0, $hu2rE.JSResourceForUserVisible)(()=>Promise.resolve((parcelRequire("j9bXh"))), {
    moduleId: "7d80bb6f",
    moduleName: "ReactFragment",
    priority: "userVisible"
} // using a real async import to make the js-resource transformers/babel-plugins happy
);
$2fbdf54c610441d8$var$DummyAsyncModule.getModuleIfRequired = ()=>(0, $j9bXh.default); // prevent attempts to fetch the module async at all

/**
 * Run a given loadEntryPoint function without loading the entrypoint modules, then load them right afterwards.
 *
 * This is to prevent triggering the loading of entrypoints modules inline with the data fetching.
 * When JS modules are inline-required (such as in SSR when async modules are converted to inline-requires)
 * this leads to inline-evaluating all dependencies for large component modules before kicking off the data for them.
 * This causes a measurable performance hit (~20-80ms in many cases) before we even kick off critical data fetches.
 *
 * Deferring the module loading until after the data fetching allows the module execution to occur in the less critical
 * idle time while waiting for data fetches to return.
 */ function $2fbdf54c610441d8$var$loadEntryPointDataThenModules(entryPoint, entryPointParams, loadEntryPointCallback) {
    const originalModulesByEntrypointRef = new Map();
    (0, $72rfN.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
        originalModulesByEntrypointRef.set(loopingEntryPoint, loopingEntryPoint.root);
        // eslint-disable-next-line no-param-reassign
        loopingEntryPoint.root = $2fbdf54c610441d8$var$DummyAsyncModule;
    });
    try {
        return loadEntryPointCallback();
    } finally{
        (0, $72rfN.default)(entryPoint, entryPointParams, (loopingEntryPoint)=>{
            const originalModule = originalModulesByEntrypointRef.get(loopingEntryPoint);
            if (!originalModule) throw new Error('Original module not found for entrypoint');
            // eslint-disable-next-line no-param-reassign
            loopingEntryPoint.root = originalModule;
        });
        // Kicks off the loading of the original modules as they would have, but after the data fetches have been started
        // Without this, entrypoints may have trouble rendering
        // Wrap it in a promise to prevent it from affecting timers that start synchronously after this function
        Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("j9bXh")));
        }).then((res)=>originalModulesByEntrypointRef.forEach((entryPointModule)=>{
                // Essentially we've updated the JSResourceReference in react-async to have the right types
                // but react-entrypoint takes the types from @types/react-relay which lacks the new methods
                // So instead of adjusting it for everyone, manually casting it here reduces the blast radius significantly
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const typedEntryPointModule = entryPointModule;
                if (typedEntryPointModule.getPriority() !== 'userVisible' && (0, $7jTnu.fg)('jfp-magma-remove-non-uservisible-content-runtime')) // console logging so we can track it in SSR as fireErrorAnalytics is not available
                // eslint-disable-next-line no-console
                console.log(JSON.stringify({
                    message: 'Wrong entrypoint priority has been used',
                    path: typedEntryPointModule.getModulePath(),
                    priority: typedEntryPointModule.getPriority()
                }));
                const jsModule = entryPointModule.getModuleIfRequired();
                if (jsModule != null) return;
                entryPointModule.load();
            }));
    }
}
var $2fbdf54c610441d8$export$2e2bcd8739ae039 = $2fbdf54c610441d8$var$loadEntryPointDataThenModules;

});
parcelRegister("hu2rE", function(module, exports) {

$parcel$export(module.exports, "JSResourceForUserVisible", () => $da03f6095fd9183e$export$58f934f3d33a84b6);

var $8MX4m = parcelRequire("8MX4m");

var $jkRyu = parcelRequire("jkRyu");

var $dsHGc = parcelRequire("dsHGc");
const $da03f6095fd9183e$var$cache = (0, $8MX4m.createCache)(new Map());
function $da03f6095fd9183e$export$58f934f3d33a84b6(loader, opts) {
    return $da03f6095fd9183e$var$cache.get(opts.moduleId, ()=>(0, $jkRyu.PreloadableJSResource)(()=>(0, $dsHGc.postTask)(loader, {
                priority: 'user-blocking'
            }), opts));
}

});

parcelRegister("72rfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $323aa376cd597090$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Recursively run through all nested entrypoints with a given callback
 */ function $323aa376cd597090$var$forAllEntryPoints(entryPoint, entryPointParams, callback) {
    callback(entryPoint);
    const preloadProps = entryPoint.getPreloadProps(entryPointParams);
    const entryPoints = preloadProps.entryPoints;
    if (!entryPoints) return;
    Object.values(entryPoints).forEach(({ entryPoint: nestedEntryPoint, entryPointParams: nestedParams })=>{
        if (nestedEntryPoint) $323aa376cd597090$var$forAllEntryPoints(nestedEntryPoint, nestedParams, callback);
    });
}
var $323aa376cd597090$export$2e2bcd8739ae039 = $323aa376cd597090$var$forAllEntryPoints;

});

parcelRegister("j9bXh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f91987f11478cff3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $f91987f11478cff3$var$ReactFragment = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
var $f91987f11478cff3$export$2e2bcd8739ae039 = $f91987f11478cff3$var$ReactFragment;

});



parcelRegister("9NORu", function(module, exports) {

$parcel$export(module.exports, "createResourcesPlugin", () => $35412eb3a33b365b$export$23ed892c481a96fe);

var $uCHeL = parcelRequire("uCHeL");

var $dqruy = parcelRequire("dqruy");
const $35412eb3a33b365b$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $35412eb3a33b365b$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $uCHeL.getResourceStore)().actions;
    const nextResources = (0, $dqruy.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $35412eb3a33b365b$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $uCHeL.getResourceStore)().actions;
    const nextResources = (0, $dqruy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $35412eb3a33b365b$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $uCHeL.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $35412eb3a33b365b$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $35412eb3a33b365b$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $35412eb3a33b365b$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $uCHeL.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $uCHeL.getResourceStore)().actions;
            const nextResources = (0, $dqruy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $uCHeL.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("dqruy", function(module, exports) {

$parcel$export(module.exports, "getResourcesForNextLocation", () => $1a8b7e47babf72f8$export$7cbbc763e2f3d65d);

var $hzgsc = parcelRequire("hzgsc");

var $8Jtan = parcelRequire("8Jtan");
const $1a8b7e47babf72f8$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $8Jtan.routeHasResources)(nextRoute)) return [];
    if ((0, $8Jtan.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $hzgsc.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $hzgsc.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("hzgsc", function(module, exports) {

$parcel$export(module.exports, "getResourceIdentifier", () => $729abb4a5d40de0d$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $729abb4a5d40de0d$export$cd7fbe7e979df558);
const $729abb4a5d40de0d$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $729abb4a5d40de0d$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$729abb4a5d40de0d$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("8Jtan", function(module, exports) {

$parcel$export(module.exports, "routeHasResources", () => $5cc875e1fdc3f713$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $5cc875e1fdc3f713$export$221027ff1aa38f82);
const $5cc875e1fdc3f713$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $5cc875e1fdc3f713$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});





parcelRegister("9wUjG", function(module, exports) {

$parcel$export(module.exports, "getLegacyRoutes", () => $73402c46c145abb2$export$26f94fc240f0d1ea);

var $9NmsS = parcelRequire("9NmsS");

var $6tSfI = parcelRequire("6tSfI");

var $cpLuR = parcelRequire("cpLuR");

var $hTn5h = parcelRequire("hTn5h");

var $53afF = parcelRequire("53afF");

var $bDdfi = parcelRequire("bDdfi");

var $3aSjH = parcelRequire("3aSjH");

var $2Sujg = parcelRequire("2Sujg");

var $392g2 = parcelRequire("392g2");

var $7j1iv = parcelRequire("7j1iv");

var $6U4RT = parcelRequire("6U4RT");

var $5h6kW = parcelRequire("5h6kW");

var $hhFBc = parcelRequire("hhFBc");

var $krVQS = parcelRequire("krVQS");

var $7WXQd = parcelRequire("7WXQd");

var $7JPxp = parcelRequire("7JPxp");

var $k34zk = parcelRequire("k34zk");

var $jcL7x = parcelRequire("jcL7x");

var $h2n1r = parcelRequire("h2n1r");

var $gtzhv = parcelRequire("gtzhv");

var $aLMek = parcelRequire("aLMek");

var $91XPM = parcelRequire("91XPM");

var $3Mqis = parcelRequire("3Mqis");

var $62ivL = parcelRequire("62ivL");

var $fufI0 = parcelRequire("fufI0");

var $hH0zn = parcelRequire("hH0zn");

var $5lZQR = parcelRequire("5lZQR");

var $83qWW = parcelRequire("83qWW");

var $T1dvB = parcelRequire("T1dvB");

var $gYqAI = parcelRequire("gYqAI");

var $1rErS = parcelRequire("1rErS");

var $9NDvE = parcelRequire("9NDvE");

var $effUy = parcelRequire("effUy");

var $69omQ = parcelRequire("69omQ");

var $l7ZAX = parcelRequire("l7ZAX");

var $fH85f = parcelRequire("fH85f");

var $3McBT = parcelRequire("3McBT");

var $cOPPu = parcelRequire("cOPPu");

var $9px2T = parcelRequire("9px2T");

var $j5kwX = parcelRequire("j5kwX");

var $8PgUz = parcelRequire("8PgUz");

var $dn8g8 = parcelRequire("dn8g8");

var $bidOp = parcelRequire("bidOp");

var $5bHK3 = parcelRequire("5bHK3");

var $ktEsE = parcelRequire("ktEsE");

var $22SFa = parcelRequire("22SFa");

var $7j07r = parcelRequire("7j07r");

var $hZhdy = parcelRequire("hZhdy");

var $kIGfb = parcelRequire("kIGfb");

var $99HLd = parcelRequire("99HLd");

var $eDlwW = parcelRequire("eDlwW");

var $i2l2X = parcelRequire("i2l2X");

var $fivSn = parcelRequire("fivSn");

var $3wKhX = parcelRequire("3wKhX");

var $cmefl = parcelRequire("cmefl");

var $ihtJL = parcelRequire("ihtJL");

var $lu5oo = parcelRequire("lu5oo");

var $7zpYc = parcelRequire("7zpYc");

var $8Mzfn = parcelRequire("8Mzfn");

var $huZ9p = parcelRequire("huZ9p");

var $iorJC = parcelRequire("iorJC");

var $i0Hvl = parcelRequire("i0Hvl");

var $dMa7J = parcelRequire("dMa7J");

var $1mEkb = parcelRequire("1mEkb");

var $6lhom = parcelRequire("6lhom");

var $aTQG3 = parcelRequire("aTQG3");

var $cYYHw = parcelRequire("cYYHw");

var $kF7Lh = parcelRequire("kF7Lh");

var $eeg6o = parcelRequire("eeg6o");

var $e1IYH = parcelRequire("e1IYH");

var $4mwkU = parcelRequire("4mwkU");

var $kE2d6 = parcelRequire("kE2d6");

var $ad39g = parcelRequire("ad39g");

var $7mhuF = parcelRequire("7mhuF");

var $h5nWA = parcelRequire("h5nWA");

var $6a3fB = parcelRequire("6a3fB");

var $6882f = parcelRequire("6882f");

var $26rp0 = parcelRequire("26rp0");

var $57B98 = parcelRequire("57B98");

var $up4vn = parcelRequire("up4vn");

var $8BXQZ = parcelRequire("8BXQZ");

var $2BIMj = parcelRequire("2BIMj");

var $4CJ3w = parcelRequire("4CJ3w");

var $eIvZR = parcelRequire("eIvZR");

var $8a334 = parcelRequire("8a334");

var $5w3KH = parcelRequire("5w3KH");

var $bYTPy = parcelRequire("bYTPy");

var $45dSt = parcelRequire("45dSt");

var $h7nx5 = parcelRequire("h7nx5");

var $VU3Sv = parcelRequire("VU3Sv");

var $16s17 = parcelRequire("16s17");

var $5rBfu = parcelRequire("5rBfu");

var $2vFcC = parcelRequire("2vFcC");

var $iw65Q = parcelRequire("iw65Q");

var $82jfc = parcelRequire("82jfc");

var $fsAzL = parcelRequire("fsAzL");

var $dw3Lv = parcelRequire("dw3Lv");

var $gX9nI = parcelRequire("gX9nI");

var $26CXx = parcelRequire("26CXx");

var $a0Vt3 = parcelRequire("a0Vt3");

var $asVNC = parcelRequire("asVNC");

var $7olX6 = parcelRequire("7olX6");

var $gTfP2 = parcelRequire("gTfP2");

var $lnUYw = parcelRequire("lnUYw");

var $4qhMs = parcelRequire("4qhMs");

var $98bLG = parcelRequire("98bLG");

var $9yLXc = parcelRequire("9yLXc");

var $fK8Na = parcelRequire("fK8Na");

var $bPQBZ = parcelRequire("bPQBZ");

var $quVRm = parcelRequire("quVRm");

var $lus0a = parcelRequire("lus0a");

var $9Hzvs = parcelRequire("9Hzvs");

var $jjhsN = parcelRequire("jjhsN");

var $3Ce1y = parcelRequire("3Ce1y");

var $hahBd = parcelRequire("hahBd");

var $1fhQ0 = parcelRequire("1fhQ0");

var $6Hth2 = parcelRequire("6Hth2");

var $7QZSt = parcelRequire("7QZSt");

var $sRxbJ = parcelRequire("sRxbJ");

var $fpvqi = parcelRequire("fpvqi");

var $lk87Q = parcelRequire("lk87Q");

var $ddTL8 = parcelRequire("ddTL8");

var $1mGBY = parcelRequire("1mGBY");

var $cbLe1 = parcelRequire("cbLe1");

var $gGGZ4 = parcelRequire("gGGZ4");

var $bCuzN = parcelRequire("bCuzN");

var $nYwoX = parcelRequire("nYwoX");

var $6vj5T = parcelRequire("6vj5T");

var $kSikr = parcelRequire("kSikr");

var $hXqaO = parcelRequire("hXqaO");

var $gRK6u = parcelRequire("gRK6u");

var $9JZc6 = parcelRequire("9JZc6");

var $ivQwe = parcelRequire("ivQwe");

var $5Ivpf = parcelRequire("5Ivpf");

var $1Tehl = parcelRequire("1Tehl");

var $dJWtX = parcelRequire("dJWtX");

var $aaJF7 = parcelRequire("aaJF7");

var $4m94G = parcelRequire("4m94G");

var $g5WsZ = parcelRequire("g5WsZ");

var $iHmm8 = parcelRequire("iHmm8");

var $famXV = parcelRequire("famXV");

var $5fVfO = parcelRequire("5fVfO");

var $7tjoT = parcelRequire("7tjoT");

var $gzBNt = parcelRequire("gzBNt");

var $eXRbc = parcelRequire("eXRbc");

var $dSQ0S = parcelRequire("dSQ0S");

var $fvbLJ = parcelRequire("fvbLJ");

var $dQh8f = parcelRequire("dQh8f");

var $gdeBt = parcelRequire("gdeBt");

var $6nkSg = parcelRequire("6nkSg");

var $3oiql = parcelRequire("3oiql");

var $6RA6R = parcelRequire("6RA6R");

var $1XHLb = parcelRequire("1XHLb");

var $ddtkm = parcelRequire("ddtkm");

var $g5O1X = parcelRequire("g5O1X");

var $d6CiY = parcelRequire("d6CiY");

var $2Qjmz = parcelRequire("2Qjmz");

var $fZo08 = parcelRequire("fZo08");

var $PQv9I = parcelRequire("PQv9I");

var $KpHH4 = parcelRequire("KpHH4");

var $4kVCN = parcelRequire("4kVCN");

var $8a0lz = parcelRequire("8a0lz");

var $c7OfH = parcelRequire("c7OfH");

var $8K8iS = parcelRequire("8K8iS");

var $bEivV = parcelRequire("bEivV");

var $hrgNn = parcelRequire("hrgNn");

var $ftzyX = parcelRequire("ftzyX");

var $a5xQ5 = parcelRequire("a5xQ5");

var $i70uT = parcelRequire("i70uT");

var $82bzz = parcelRequire("82bzz");

var $dfOxZ = parcelRequire("dfOxZ");

var $ZVj0Y = parcelRequire("ZVj0Y");

var $aN61m = parcelRequire("aN61m");

var $5OZoa = parcelRequire("5OZoa");

var $z3tMU = parcelRequire("z3tMU");

var $fSyZo = parcelRequire("fSyZo");

var $iBhRd = parcelRequire("iBhRd");

var $3ftuD = parcelRequire("3ftuD");

var $9ra6q = parcelRequire("9ra6q");

var $lCq28 = parcelRequire("lCq28");

var $bS277 = parcelRequire("bS277");

var $aTlDP = parcelRequire("aTlDP");

var $jJoxI = parcelRequire("jJoxI");

var $7ipQX = parcelRequire("7ipQX");

var $cTtpr = parcelRequire("cTtpr");

var $8JhHW = parcelRequire("8JhHW");

var $5Mjim = parcelRequire("5Mjim");

var $5N6Ai = parcelRequire("5N6Ai");

var $3xHNV = parcelRequire("3xHNV");

var $aw4rz = parcelRequire("aw4rz");

var $ihO2a = parcelRequire("ihO2a");

var $5tskD = parcelRequire("5tskD");

var $9r2BL = parcelRequire("9r2BL");

var $g3Gcc = parcelRequire("g3Gcc");

var $2IYDs = parcelRequire("2IYDs");

var $d4f3b = parcelRequire("d4f3b");

var $dLnvu = parcelRequire("dLnvu");

var $kzPtB = parcelRequire("kzPtB");

var $6X7m6 = parcelRequire("6X7m6");

var $iuhZT = parcelRequire("iuhZT");

var $663l0 = parcelRequire("663l0");

var $1d8tj = parcelRequire("1d8tj");

var $al2YQ = parcelRequire("al2YQ");

var $4AaBy = parcelRequire("4AaBy");

var $b3dlc = parcelRequire("b3dlc");

var $gGs6c = parcelRequire("gGs6c");

var $fLdjP = parcelRequire("fLdjP");

var $kXp5o = parcelRequire("kXp5o");

var $e4ly7 = parcelRequire("e4ly7");

var $chIgP = parcelRequire("chIgP");

var $f4kmu = parcelRequire("f4kmu");

var $j7WGc = parcelRequire("j7WGc");

var $gYhfA = parcelRequire("gYhfA");

var $8yWy6 = parcelRequire("8yWy6");

var $iM79t = parcelRequire("iM79t");

var $7aCB2 = parcelRequire("7aCB2");

var $4bLXR = parcelRequire("4bLXR");

var $kxhjT = parcelRequire("kxhjT");

var $eqVHn = parcelRequire("eqVHn");

var $cwou1 = parcelRequire("cwou1");

var $5vmJQ = parcelRequire("5vmJQ");

var $5PqnJ = parcelRequire("5PqnJ");

var $02xNS = parcelRequire("02xNS");

var $hBetR = parcelRequire("hBetR");

var $3xDJx = parcelRequire("3xDJx");

var $9pzoA = parcelRequire("9pzoA");

var $5jfUQ = parcelRequire("5jfUQ");

var $kvIY1 = parcelRequire("kvIY1");

var $5KgFH = parcelRequire("5KgFH");

var $bRjLJ = parcelRequire("bRjLJ");

var $gBz9X = parcelRequire("gBz9X");

var $kWcpN = parcelRequire("kWcpN");

var $lssFA = parcelRequire("lssFA");

var $bdfNi = parcelRequire("bdfNi");

var $2HKmQ = parcelRequire("2HKmQ");

var $jVhaC = parcelRequire("jVhaC");

var $6zufk = parcelRequire("6zufk");

var $5RKia = parcelRequire("5RKia");

var $kPM2h = parcelRequire("kPM2h");

var $bcJKE = parcelRequire("bcJKE");

var $3W2Ej = parcelRequire("3W2Ej");

var $19juL = parcelRequire("19juL");

var $2I8dT = parcelRequire("2I8dT");

var $2y7lL = parcelRequire("2y7lL");

var $g33BY = parcelRequire("g33BY");

var $66kD6 = parcelRequire("66kD6");

var $fXeFO = parcelRequire("fXeFO");

var $kH2f8 = parcelRequire("kH2f8");

var $dyd45 = parcelRequire("dyd45");

var $ip9nB = parcelRequire("ip9nB");

var $1gXQh = parcelRequire("1gXQh");

var $aGLmH = parcelRequire("aGLmH");

var $2leDl = parcelRequire("2leDl");

var $51bMt = parcelRequire("51bMt");
const $73402c46c145abb2$export$d47aca795954578 = ()=>[
        (0, $dLnvu.legacyJsdGettingStartedRouteEntry),
        (0, $d4f3b.legacyJsdCustomersRouteEntry),
        (0, $6X7m6.legacyJsdKnowledgeRouteEntry),
        (0, $663l0.legacyJsdQueuesManageRouteEntry),
        (0, $iuhZT.legacyJsdQueuesRouteEntry),
        (0, $1d8tj.legacyJsdReportsCustomRouteEntry),
        (0, $al2YQ.legacyJsdReportsRouteEntry),
        (0, $b3dlc.legacyJsdSettingsLanguageRouteEntry),
        (0, $gGs6c.legacyJsdSettingsLanguagePagesRouteEntry),
        (0, $kzPtB.legacyJsdJiraAutomationRouteEntry),
        (0, $fLdjP.legacyJsdWidgetsRouteEntry),
        (0, $4AaBy.legacyJsdSettingsFallbackRouteEntry),
        (0, $6U4RT.legacyCustomReportRouteEntry),
        (0, $bDdfi.legacyBacklogRouteEntry),
        (0, $3aSjH.legacyBoardRapidViewRouteEntry),
        (0, $2Sujg.legacyBoardRouteEntry),
        (0, $53afF.legacyAllReportsRouteEntry),
        (0, $fH85f.globalIssueNavigatorRouteEntry),
        (0, $69omQ.globalIssueNavigatorBrowseRouteEntry),
        (0, $l7ZAX.globalIssueNavigatorRedirectRouteEntry),
        (0, $2IYDs.legacyIssueRouteEntry),
        (0, $e4ly7.legacyPinRouteEntry),
        (0, $gYhfA.legacyProjectReleasesRouteEntry),
        (0, $iM79t.legacyProjectReleasesNoteRouteEntry),
        (0, $8yWy6.legacyProjectReleasesNoteConfigRouteEntry),
        (0, $j7WGc.legacyProjectReleasesBambooRouteEntry),
        (0, $3W2Ej.legacyReportsAverageAgeRouteEntry),
        (0, $2I8dT.legacyReportsCreatedVsResolvedRouteEntry),
        (0, $g33BY.legacyReportsPieRouteEntry),
        (0, $66kD6.legacyReportsRecentlyCreatedRouteEntry),
        (0, $fXeFO.legacyReportsResolutionTimeRouteEntry),
        (0, $kH2f8.legacyReportsSingleLevelGroupByRouteEntry),
        (0, $dyd45.legacyReportsTimeSinceRouteEntry),
        (0, $ip9nB.legacyReportsTimeTrackingReportRouteEntry),
        (0, $2y7lL.legacyReportsDeveloperWorkloadRouteEntry),
        (0, $1gXQh.legacyReportsVersionWorkloadRouteEntry),
        (0, $aGLmH.legacyReportsWorkloadPieRouteEntry),
        (0, $19juL.legacyReportsConfigRouteEntry),
        (0, $7j1iv.legacyConnectProjectRouteEntry),
        (0, $bdfNi.legacyProjectSettingsPeopleRouteEntry),
        (0, $5RKia.legacyProjectSettingsSummaryRouteEntry),
        (0, $bRjLJ.legacyProjectSettingsIssueTypesRouteEntry),
        (0, $5KgFH.legacyProjectSettingsIssueTypesAssociateRouteEntry),
        (0, $9pzoA.legacyProjectSettingsIssueLayoutRouteEntry),
        (0, $bcJKE.legacyProjectSettingsWorkflowsRouteEntry),
        (0, $kPM2h.legacyProjectSettingsWorkflowsAssociateRouteEntry),
        (0, $6zufk.legacyProjectSettingsScreensRouteEntry),
        (0, $jVhaC.legacyProjectSettingsScreensAssociateRouteEntry),
        (0, $3xDJx.legacyProjectSettingsFieldsRouteEntry),
        (0, $hBetR.legacyProjectSettingsFieldsAssociateRouteEntry),
        (0, $lssFA.legacyProjectSettingsOpsgenieRouteEntry),
        (0, $2HKmQ.legacyProjectSettingsPermissionsRouteEntry),
        (0, $kvIY1.legacyProjectSettingsIssueSecurityRouteEntry),
        (0, $5jfUQ.legacyProjectSettingsIssueSecurityAssociateRouteEntry),
        (0, $kWcpN.legacyProjectSettingsNotificationsRouteEntry),
        (0, $gBz9X.legacyProjectSettingsNotificationsAssociateRouteEntry),
        (0, $cwou1.legacyProjectSettingsConfigRouteEntry),
        (0, $02xNS.legacyProjectSettingsEditRouteEntry),
        (0, $5vmJQ.legacyProjectSettingsDeleteRouteEntry),
        (0, $4bLXR.legacyProjectSettingsCollectorsRouteEntry),
        (0, $7aCB2.legacyProjectSettingsCollectorsAddRouteEntry),
        (0, $kxhjT.legacyProjectSettingsCollectorsHelpRouteEntry),
        (0, $eqVHn.legacyProjectSettingsCollectorsViewRouteEntry),
        (0, $5PqnJ.legacyProjectSettingsDevRouteEntry),
        (0, $hhFBc.legacyDashboardsConfigureRouteEntry),
        (0, $7WXQd.dashboardsDirectoryRouteEntry),
        (0, $5h6kW.legacyDashboardsAddRouteEntry),
        (0, $7JPxp.legacyDashboardsEditRouteEntry),
        (0, $krVQS.legacyDashboardsDeleteRouteEntry),
        (0, $k34zk.legacyDashboardsRestoreRouteEntry),
        (0, $83qWW.legacyGinManageRouteEntry),
        (0, $aLMek.legacyGinBulkeditRouteEntry),
        (0, $gtzhv.legacyGinBulkRouteEntry),
        (0, $5lZQR.legacyGinIssueMoveRouteEntry),
        (0, $1rErS.legacyGinSubtaskActionRouteEntry),
        (0, $3Mqis.legacyGinIssueCloneRouteEntry),
        (0, $91XPM.legacyGinIssueAssignRouteEntry),
        (0, $fufI0.legacyGinIssueCreateRouteEntry),
        (0, $62ivL.legacyGinIssueConvertRouteEntry),
        (0, $hH0zn.legacyGinIssueEditRouteEntry),
        (0, $9NDvE.legacyGinWatchersIssueRouteEntry),
        (0, $h2n1r.legacyGinActionRouteEntry),
        (0, $gYqAI.legacyGinSubscriptionsRouteEntry),
        (0, $T1dvB.legacyGinSubscriptionEditRouteEntry),
        (0, $chIgP.legacyPortfolioPagesRouteEntry),
        (0, $f4kmu.legacyPortfolioTeamRouteEntry),
        (0, $gdeBt.globalSettingsSystemApplicationViewRouteEntry),
        (0, $fvbLJ.globalSettingsSystemApplicationAdvancedRouteEntry),
        (0, $dQh8f.globalSettingsSystemApplicationEditRouteEntry),
        (0, $3oiql.globalSettingsSystemAuditingRouteEntry),
        (0, $5N6Ai.globalSettingsSystemRolesViewRouteEntry),
        (0, $5Mjim.globalSettingsSystemRolesUsageRouteEntry),
        (0, $aTlDP.globalSettingsSystemRolesActorsRouteEntry),
        (0, $jJoxI.globalSettingsSystemRolesActorsGroupsRouteEntry),
        (0, $7ipQX.globalSettingsSystemRolesActorsUsersRouteEntry),
        (0, $8JhHW.globalSettingsSystemRolesEditRouteEntry),
        (0, $cTtpr.globalSettingsSystemRolesDeleteRouteEntry),
        (0, $lCq28.globalSettingsSystemProjectDeleteRouteEntry),
        (0, $9ra6q.globalSettingsSystemProjectAssignSecurityRouteEntry),
        (0, $3ftuD.globalSettingsSystemPermissionsRouteEntry),
        (0, $6RA6R.globalSettingsSystemCollectorsRouteEntry),
        (0, $1XHLb.globalSettingsSystemDefaultSettingsRouteEntry),
        (0, $82bzz.globalSettingsSystemLookRouteEntry),
        (0, $fZo08.globalSettingsSystemExportRouteEntry),
        (0, $PQv9I.globalSettingsSystemGlobalPermissionsRouteEntry),
        (0, $bEivV.globalSettingsSystemImportExternalRouteEntry),
        (0, $hrgNn.globalSettingsSystemImportExternalPagesRouteEntry),
        (0, $8K8iS.globalSettingsSystemImportCsvRouteEntry),
        (0, $ftzyX.globalSettingsSystemImportJsonRouteEntry),
        (0, $a5xQ5.globalSettingsSystemImportTrelloRouteEntry),
        (0, $c7OfH.globalSettingsSystemImportCloudRouteEntry),
        (0, $8a0lz.globalSettingsSystemImportBulkRouteEntry),
        (0, $effUy.globalAutomationRouteEntry),
        (0, $fSyZo.globalSettingsSystemMailSettingsRouteEntry),
        (0, $5OZoa.globalSettingsSystemMailOutgoingRouteEntry),
        (0, $ZVj0Y.globalSettingsSystemMailDeleteMailHandlerRouteEntry),
        (0, $aN61m.globalSettingsSystemMailIncomingRouteEntry),
        (0, $dfOxZ.globalSettingsSystemMailAddRouteEntry),
        (0, $iBhRd.globalSettingsSystemMailVerifyRouteEntry),
        (0, $z3tMU.globalSettingsSystemMailSendRouteEntry),
        (0, $4kVCN.globalSettingsSystemHelperPermissionRouteEntry),
        (0, $KpHH4.globalSettingsSystemHelperNotificationRouteEntry),
        (0, $ihO2a.globalSettingsSystemSharedFiltersRouteEntry),
        (0, $aw4rz.globalSettingsSystemSharedDashboardsRouteEntry),
        (0, $6nkSg.globalSettingsSystemAttachmentsRouteEntry),
        (0, $2Qjmz.globalSettingsSystemEventsRouteEntry),
        (0, $ddtkm.globalSettingsSystemEventsAddRouteEntry),
        (0, $g5O1X.globalSettingsSystemEventsDeleteRouteEntry),
        (0, $d6CiY.globalSettingsSystemEventsEditRouteEntry),
        (0, $5tskD.globalSettingsSystemUserInterfaceDashboardEditRouteEntry),
        (0, $9r2BL.globalSettingsSystemUserInterfacePreferencesRouteEntry),
        (0, $g3Gcc.globalSettingsSystemWebhooksRouteEntry),
        (0, $3xHNV.globalSettingsSystemServicesRouteEntry),
        (0, $i70uT.globalSettingsSystemLexorankRouteEntry),
        (0, $1Tehl.globalSettingsProductsAccessRouteEntry),
        (0, $7tjoT.globalSettingsProductsSoftwareConfigRouteEntry),
        (0, $dJWtX.globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry),
        (0, $famXV.globalSettingsProductsSdconfigRouteEntry),
        (0, $5fVfO.globalSettingsProductsSdmailRouteEntry),
        (0, $aaJF7.globalSettingsProductsApplinksRouteEntry),
        (0, $g5WsZ.globalSettingsProductsDvcsRouteEntry),
        (0, $4m94G.globalSettingsProductsDvcsBitbucketRouteEntry),
        (0, $iHmm8.globalSettingsProductsJsdStatusRouteEntry),
        (0, $dSQ0S.globalSettingsProjectsCategoriesViewRouteEntry),
        (0, $eXRbc.globalSettingsProjectsCategoriesEditRouteEntry),
        (0, $gzBNt.globalSettingsProjectsCategoriesDeleteRouteEntry),
        (0, $sRxbJ.globalSettingsIssuesTypesEditRouteEntry),
        (0, $7QZSt.globalSettingsIssuesTypesDeleteRouteEntry),
        (0, $fpvqi.globalSettingsIssuesTypesMigrateRouteEntry),
        (0, $hXqaO.globalSettingsIssuesTypesTranslationsRouteEntry),
        (0, $cbLe1.globalSettingsIssuesTypesSchemesOptionRouteEntry),
        (0, $lk87Q.globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry),
        (0, $ddTL8.globalSettingsIssuesTypesSchemesAssociateRouteEntry),
        (0, $1mGBY.globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry),
        (0, $bidOp.globalSettingsIssueSubtasksRouteEntry),
        (0, $hahBd.globalSettingsIssuesSubtasksDisableRouteEntry),
        (0, $1fhQ0.globalSettingsIssuesSubtasksEditRouteEntry),
        (0, $6Hth2.globalSettingsIssuesSubtasksTranlationsRouteEntry),
        (0, $2leDl.workflowDesignerRouteEntry),
        (0, $ktEsE.globalSettingsIssueWorkflowRouteEntry),
        (0, $9JZc6.globalSettingsIssuesWorkflowTransitionRouteEntry),
        (0, $gRK6u.globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry),
        (0, $ivQwe.globalSettingsIssuesWorkflowsImportRouteEntry),
        (0, $22SFa.globalSettingsIssueWorkflowSchemesRouteEntry),
        (0, $5Ivpf.globalSettingsIssuesWorkflowsSchemesEditRouteEntry),
        (0, $6lhom.globalSettingsIssuesFieldViewRouteEntry),
        (0, $fivSn.globalSettingsIssuesFieldAddRouteEntry),
        (0, $cmefl.globalSettingsIssuesFieldConfigureRouteEntry),
        (0, $3wKhX.globalSettingsIssuesFieldConfigureEditRouteEntry),
        (0, $7zpYc.globalSettingsIssuesFieldEditRouteEntry),
        (0, $ihtJL.globalSettingsIssuesFieldCopyRouteEntry),
        (0, $lu5oo.globalSettingsIssuesFieldDeleteRouteEntry),
        (0, $8Mzfn.globalSettingsIssuesFieldSchemesAddRouteEntry),
        (0, $huZ9p.globalSettingsIssuesFieldSchemesConfigureRouteEntry),
        (0, $dMa7J.globalSettingsIssuesFieldSchemesEditRouteEntry),
        (0, $1mEkb.globalSettingsIssuesFieldSchemesEditItemRouteEntry),
        (0, $iorJC.globalSettingsIssuesFieldSchemesCopyRouteEntry),
        (0, $i0Hvl.globalSettingsIssuesFieldSchemesDeleteRouteEntry),
        (0, $gGGZ4.globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry),
        (0, $kSikr.globalSettingsIssuesTypesScreenSchemesEntityRouteEntry),
        (0, $6vj5T.globalSettingsIssuesTypesScreenSchemesEditRouteEntry),
        (0, $bCuzN.globalSettingsIssuesTypesScreenSchemesCopyRouteEntry),
        (0, $nYwoX.globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry),
        (0, $j5kwX.globalSettingsCustomFieldsRouteEntry),
        (0, $hZhdy.globalSettingsIssuesCustomFieldsConfigRouteEntry),
        (0, $99HLd.globalSettingsIssuesCustomFieldsEditRouteEntry),
        (0, $i2l2X.globalSettingsIssuesCustomFieldsTranslateRouteEntry),
        (0, $kIGfb.globalSettingsIssuesCustomFieldsDeleteRouteEntry),
        (0, $eDlwW.globalSettingsIssuesCustomFieldsManageRouteEntry),
        (0, $7j07r.globalSettingsIssuesCustomFieldsAssociateRouteEntry),
        (0, $cpLuR.globalSettingsIssuesExplicitFieldAssociationRouteEntry),
        (0, $dn8g8.globalSettingsFieldLayoutsRouteEntry),
        (0, $aTQG3.globalSettingsIssuesFieldlayoutsConfigRouteEntry),
        (0, $h5nWA.globalSettingsIssuesFieldviewRouteEntry),
        (0, $cYYHw.globalSettingsIssuesFieldlayoutsCopyRouteEntry),
        (0, $eeg6o.globalSettingsIssuesFieldlayoutsEditRouteEntry),
        (0, $kF7Lh.globalSettingsIssuesFieldlayoutsDeleteRouteEntry),
        (0, $8PgUz.globalSettingsFieldLayoutSchemesRouteEntry),
        (0, $e1IYH.globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry),
        (0, $7mhuF.globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry),
        (0, $4mwkU.globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry),
        (0, $ad39g.globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry),
        (0, $kE2d6.globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry),
        (0, $5bHK3.globalSettingsIssueTimeTrackingRouteEntry),
        (0, $57B98.globalSettingsIssuesLinkTypesRouteEntry),
        (0, $6882f.globalSettingsIssuesLinkTypesActivateRouteEntry),
        (0, $26rp0.globalSettingsIssuesLinkTypesDeactivateRouteEntry),
        (0, $8BXQZ.globalSettingsIssuesLinktypesEditRouteEntry),
        (0, $up4vn.globalSettingsIssuesLinktypesDeleteRouteEntry),
        (0, $jjhsN.globalSettingsIssuesStatusesRouteEntry),
        (0, $3Ce1y.globalSettingsIssuesStatusesTranslationsRouteEntry),
        (0, $gTfP2.globalSettingsIssuesResolutionsRouteEntry),
        (0, $lnUYw.globalSettingsIssuesResolutionsTranslationsRouteEntry),
        (0, $a0Vt3.globalSettingsIssuesResolutionsDefaultRouteEntry),
        (0, $7olX6.globalSettingsIssuesResolutionsEditRouteEntry),
        (0, $asVNC.globalSettingsIssuesResolutionsDeleteRouteEntry),
        (0, $gX9nI.globalSettingsIssuesPrioritiesRouteEntry),
        (0, $26CXx.globalSettingsIssuesPrioritiesTranslationsRouteEntry),
        (0, $6a3fB.globalSettingsIssuesGeneralTranslationsRouteEntry),
        (0, $dw3Lv.globalSettingsIssuesPrioritiesEditRouteEntry),
        (0, $fsAzL.globalSettingsIssuesPrioritiesDeleteRouteEntry),
        (0, $82jfc.globalSettingsIssuesPrioritiesDefaultRouteEntry),
        (0, $9Hzvs.globalSettingsIssuesSecuritySchemesRouteEntry),
        (0, $4qhMs.globalSettingsIssuesSecurityEditRouteEntry),
        (0, $98bLG.globalSettingsIssuesSecurityLevelAddRouteEntry),
        (0, $fK8Na.globalSettingsIssuesSecurityLevelEditRouteEntry),
        (0, $9yLXc.globalSettingsIssuesSecurityLevelDeleteRouteEntry),
        (0, $bPQBZ.globalSettingsIssuesSecuritySchemesAddRouteEntry),
        (0, $lus0a.globalSettingsIssuesSecuritySchemesEditRouteEntry),
        (0, $quVRm.globalSettingsIssuesSecuritySchemesDeleteRouteEntry),
        (0, $45dSt.globalSettingsIssuesNotificationViewRouteEntry),
        (0, $8a334.globalSettingsIssuesNotificationSchemeAddRouteEntry),
        (0, $bYTPy.globalSettingsIssuesNotificationSchemeEditRouteEntry),
        (0, $5w3KH.globalSettingsIssuesNotificationSchemeDeleteRouteEntry),
        (0, $2BIMj.globalSettingsIssuesNotificationAddRouteEntry),
        (0, $eIvZR.globalSettingsIssuesNotificationEditRouteEntry),
        (0, $4CJ3w.globalSettingsIssuesNotificationDeleteRouteEntry),
        (0, $2vFcC.globalSettingsIssuesPermissionsSchemesRouteEntry),
        (0, $VU3Sv.globalSettingsIssuesPermissionsSchemesAddRouteEntry),
        (0, $h7nx5.globalSettingsIssuesPermissionsEditRouteEntry),
        (0, $5rBfu.globalSettingsIssuesPermissionsSchemesEditRouteEntry),
        (0, $iw65Q.globalSettingsIssuesPermissionsSchemesProjectRouteEntry),
        (0, $16s17.globalSettingsIssuesPermissionsSchemesDeleteRouteEntry),
        (0, $hTn5h.addonsEmceePublicRouteEntry),
        (0, $cOPPu.emceeAppRouteEntry),
        (0, $9px2T.manageAppsRouteEntry),
        (0, $3McBT.globalSettingsAddonsOauthRouteEntry),
        (0, $bS277.globalSettingsSystemProjectSelectRouteEntry),
        (0, $kXp5o.legacyPersonalSettingsAccessTokensRouteEntry),
        (0, $392g2.legacyConnectGeneralRouteEntry),
        (0, $jcL7x.legacyFallbackRouteEntry)
    ];
const $73402c46c145abb2$export$26f94fc240f0d1ea = ()=>$73402c46c145abb2$export$d47aca795954578().map((0, $51bMt.default)).map((route)=>({
            ...route,
            group: 'legacy',
            component: route.component || (0, $6tSfI.LegacyPage),
            resources: [
                ...new Set([
                    ...(0, $9NmsS.getNavigationResources)(),
                    ...route.resources ? route.resources : []
                ])
            ]
        }));

});
parcelRegister("9NmsS", function(module, exports) {

$parcel$export(module.exports, "getModernIssueTransitionResources", () => $740db98e3f182ede$export$e1afa08027b1e44b);
$parcel$export(module.exports, "getNavigationResources", () => $740db98e3f182ede$export$75cffd1aaecf4a2c);
$parcel$export(module.exports, "getUserBoardNavigationResources", () => $740db98e3f182ede$export$c57dc1ea7f76f91f);
$parcel$export(module.exports, "getNavigationSidebarPlanResources", () => $740db98e3f182ede$export$af2259a87f79645d);
$parcel$export(module.exports, "getNavigationSidebarProductsSettingResource", () => $740db98e3f182ede$export$a103e99ad51f7bc3);
$parcel$export(module.exports, "getNavigationSidebarProjectSettingsResource", () => $740db98e3f182ede$export$808691f5a412afa3);
// eslint-disable-next-line jira/import-whitelist

var $hTrTW = parcelRequire("hTrTW");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $hHbzj = parcelRequire("hHbzj");

var $3luhJ = parcelRequire("3luhJ");

var $4HvIf = parcelRequire("4HvIf");

var $cY5nO = parcelRequire("cY5nO");

var $43SpR = parcelRequire("43SpR");

var $6JmRt = parcelRequire("6JmRt");

var $8J0lu = parcelRequire("8J0lu");

var $6zXPf = parcelRequire("6zXPf");

var $SPYRa = parcelRequire("SPYRa");

var $5MeEd = parcelRequire("5MeEd");

var $9CgFv = parcelRequire("9CgFv");

var $graie = parcelRequire("graie");

var $4VIcO = parcelRequire("4VIcO");


var $7JXbP = parcelRequire("7JXbP");

var $dRfS0 = parcelRequire("dRfS0");

var $7KVqh = parcelRequire("7KVqh");

var $5yVUD = parcelRequire("5yVUD");

var $aYBjl = parcelRequire("aYBjl");

var $1gbqq = parcelRequire("1gbqq");

var $enHI7 = parcelRequire("enHI7");

var $dfh4P = parcelRequire("dfh4P");

var $5zQIb = parcelRequire("5zQIb");

var $cqUpU = parcelRequire("cqUpU");

var $dZRaT = parcelRequire("dZRaT");

var $2emAF = parcelRequire("2emAF");

var $bvwBX = parcelRequire("bvwBX");

var $68g4a = parcelRequire("68g4a");

var $lb6FK = parcelRequire("lb6FK");

var $cxQGT = parcelRequire("cxQGT");

var $aUy7d = parcelRequire("aUy7d");

var $5L7qx = parcelRequire("5L7qx");

var $5fjzQ = parcelRequire("5fjzQ");

var $l1VxS = parcelRequire("l1VxS");

var $hXbwo = parcelRequire("hXbwo");

var $lzT4f = parcelRequire("lzT4f");
const $740db98e3f182ede$var$inExperimentCohortJiraSideNavMSRExperiment = ()=>{
    // We need to use UNSAFE_noExposureExp to check if jira-side-nav experiment is enabled without firing exposure events
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [sideNavExpConfig] = (0, $epTsa.UNSAFE_noExposureExp)('post_office_jira_side_nav_exp_msr_vs_no_rec');
    return sideNavExpConfig.get('isEnabled', false);
};
const $740db98e3f182ede$var$conditionalPostOfficeJiraSideNavResource = (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('post_office_ssr_jira_side_nav_enabled') && $740db98e3f182ede$var$inExperimentCohortJiraSideNavMSRExperiment(), (0, $5fjzQ.postOfficeJiraSideNavResource));
const $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4Resource = (0, $5L7qx.resourceWithCondition2)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('post_office_ssr_jira_side_nav_enabled') && (0, $7jTnu.fg)('post-office-jira-side-nav-in-nav4'), (0, $5fjzQ.postOfficeJiraSideNavResource));
const $740db98e3f182ede$var$isModernIssueTransitionSettingEnabled = ()=>{
    return (0, $epTsa.expVal)('jira_issue_transition_screen_modernisation_toggle', 'value', 'OFF') !== 'OFF';
};
const $740db98e3f182ede$var$conditionalGicOptInStatusResource = (0, $5L7qx.resourceWithCondition)(()=>(0, $7jTnu.fg)('render_modern_global_issue_create_modal_experience'), (0, $dRfS0.gicOptInStatusResources));
const $740db98e3f182ede$var$conditionalIssueTransitionOptInStatusResource = (0, $5L7qx.resourceWithCondition)($740db98e3f182ede$var$isModernIssueTransitionSettingEnabled, (0, $aYBjl.issueTransitionOptInStatusResource));
const $740db98e3f182ede$export$e1afa08027b1e44b = ()=>[
        $740db98e3f182ede$var$conditionalIssueTransitionOptInStatusResource,
        (0, $5yVUD.issueTransitionChangeboardingPreferencesResource)
    ];
const $740db98e3f182ede$var$getConditionalOperationsJiraSideNavResource = ()=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('operations_ssr_jira_side_nav_enabled'), (0, $4VIcO.getConsolidationStateResource)(), (0, $l1VxS.createResource)({
        type: `${(0, $f8747ec2695de8a7$export$25ee35b01de9d734)}_NOOP`,
        getKey: ()=>`${0, $f8747ec2695de8a7$export$25ee35b01de9d734}_NOOP`,
        getData: async ()=>null,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: false
    }));
// There is a best effort duplicate removal in the `getRoutes` function but it
// only works if the resources have the same instance. b/c resourceWithCondition2
// will create a new reference each time it is run, by keeping this outside the
// route factory, we can ensure that the duplicate removal works when it is used
// in multiple places.
const $740db98e3f182ede$var$getDedupableConditionalResources = (isUsingSidebarEntrypoint)=>{
    const resources = [
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $43SpR.sidebarNav4UiStateResource)),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $8J0lu.topNav4UIStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('navx-global-side-nav'), (0, $6JmRt.navPlatformSidebarResource)),
        $740db98e3f182ede$var$getConditionalOperationsJiraSideNavResource()
    ];
    if (isUsingSidebarEntrypoint) // We don't want sidebarNav4Resource loaded for entrypoints otherwise we end up with a client side api call
    // when we don't need it as SSR will have loaded the data already.
    return resources;
    resources.push((0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $43SpR.sidebarNav4Resource)));
    return resources;
};
const $740db98e3f182ede$export$75cffd1aaecf4a2c = ({ isUsingSidebarEntrypoint: isUsingSidebarEntrypoint } = {})=>[
        (0, $dfh4P.navigationUiStateResource),
        (0, $SPYRa.navigationPlansVisibilityResource),
        (0, $aUy7d.userHomepageResource),
        $740db98e3f182ede$var$conditionalGicOptInStatusResource,
        (0, $hTrTW.announcementBannerSettingsV4Resource),
        (0, $5MeEd.getConsentBannerUserPreferencesResource)(),
        (0, $graie.consolidationUserStateResource),
        ...$740db98e3f182ede$var$getDedupableConditionalResources(isUsingSidebarEntrypoint),
        (0, $cxQGT.themePreferenceResource),
        ...$740db98e3f182ede$export$e1afa08027b1e44b(),
        (0, $cqUpU.persistentIssueCreateModalViewResource),
        (0, $7JXbP.gicSmartFieldsFeatureResource),
        (0, $7KVqh.incomingMailServerExpiryStatusResource),
        (0, $lb6FK.rovoEntitlementResource),
        (0, $68g4a.jpdRecommendationDismissedResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended'), (0, $bvwBX.fetchUserTraitsResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended'), (0, $2emAF.fetchSiteTraitsResource)),
        $740db98e3f182ede$var$conditionalPostOfficeJiraSideNavResource,
        $740db98e3f182ede$var$conditionalPostOfficeJiraSideNav4Resource,
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-glance-panel'), (0, $hXbwo.previewPanelStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementGpEndDateResource))
    ];
const $740db98e3f182ede$export$c57dc1ea7f76f91f = ()=>[
        (0, $3luhJ.staticJSWUserBoardSidebarNavigationResource)
    ];
const $740db98e3f182ede$export$af2259a87f79645d = ()=>[
        (0, $4HvIf.staticPlanSidebarNavigationResource)
    ];
const $740db98e3f182ede$export$a103e99ad51f7bc3 = ()=>[
        (0, $enHI7.navigationSidebarGlobalResource),
        (0, $4VIcO.getConsolidationStateResource)(),
        (0, $9CgFv.checkApiKeyManagementKeysResource)()
    ];
const $740db98e3f182ede$export$808691f5a412afa3 = ()=>[
        (0, $5zQIb.newIssueViewTransitionLockInStatusResource),
        (0, $1gbqq.navigationSidebarAutomationLegacyEnabledResource),
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $hHbzj.forgeProjectSettingsModuleResource),
        (0, $cY5nO.staticProjectSettingsSidebarConnectAddonsNavigationResource)
    ];

});
parcelRegister("hTrTW", function(module, exports) {

$parcel$export(module.exports, "announcementBannerSettingsV4Resource", () => $fdbec7ae7de702d4$export$8fbe7f8de07afffd);
$parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", () => $fdbec7ae7de702d4$export$6fb72f4a0c177494);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $afWl0 = parcelRequire("afWl0");

var $aNgkQ = parcelRequire("aNgkQ");

var $4m9Yk = parcelRequire("4m9Yk");
const $fdbec7ae7de702d4$export$2a421cd16fa9a95a = (0, $l1VxS.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $aNgkQ.get)(),
            (0, $4m9Yk.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $fdbec7ae7de702d4$export$8fbe7f8de07afffd = (0, $l1VxS.createResource)({
    type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
    getKey: ()=>'settings',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const [settings, hashIdLastDimissed] = await Promise.all([
            (0, $afWl0.get)(),
            (0, $4m9Yk.get)(atlassianAccountId)
        ]);
        return {
            ...settings,
            isDismissable: isAnonymous ? false : settings?.isDismissable,
            isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
        };
    },
    maxAge: 900000
});
const $fdbec7ae7de702d4$export$43d4950a3e443fd3 = ()=>(0, $eJrcF.useResource)($fdbec7ae7de702d4$export$2a421cd16fa9a95a);
const $fdbec7ae7de702d4$export$6fb72f4a0c177494 = ()=>(0, $eJrcF.useResource)($fdbec7ae7de702d4$export$8fbe7f8de07afffd);

});
parcelRegister("afWl0", function(module, exports) {

$parcel$export(module.exports, "get", () => $a655d50edc5c2e0f$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $a655d50edc5c2e0f$export$adaa4cf7ef1b65be);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $a655d50edc5c2e0f$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $jGzN3.performGetRequest)('/rest/internal/4/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            content: '',
            bgColor: 'grey',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $gYnSx.default)({
            meta: {
                id: 'settingsV4Get',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};
const $a655d50edc5c2e0f$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $jGzN3.performPostRequest)('/rest/internal/4/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'settingsV4Set',
                packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                teamName: 'jira-cosmos'
            },
            error: error
        });
        throw error;
    }
};

});

parcelRegister("aNgkQ", function(module, exports) {

$parcel$export(module.exports, "get", () => $9bda889693371947$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $9bda889693371947$export$adaa4cf7ef1b65be);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

const $9bda889693371947$export$3988ae62b71be9a3 = async ()=>{
    try {
        return await (0, $jGzN3.performGetRequest)('/rest/internal/3/announcement-banner');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 403 - banner is set to private and user is anonymous
        if (error.statusCode === 403) return {
            message: '',
            isEnabled: false,
            isDismissable: false,
            visibility: 'private',
            hashId: ''
        };
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'settingsGet',
            packageName: (0, $51e9357f231e05fa$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $9bda889693371947$export$adaa4cf7ef1b65be = async (body)=>{
    try {
        return await (0, $jGzN3.performPostRequest)('/rest/internal/3/announcement-banner', {
            body: JSON.stringify(body)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'settingsSet',
            packageName: (0, $51e9357f231e05fa$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
const $51e9357f231e05fa$export$b8b9d90f9e5bd72b = '@jira/admin-pages__system-announcement-banner-resources';
const $51e9357f231e05fa$export$5e0c0e8c940630f8 = 'private';
const $51e9357f231e05fa$export$1d5a5b6462188eb3 = 'public';


parcelRegister("4m9Yk", function(module, exports) {

$parcel$export(module.exports, "get", () => $fff37efd18b27481$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $fff37efd18b27481$export$adaa4cf7ef1b65be);

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

const $fff37efd18b27481$var$key = 'announcementBannerDismissedLast';
const $fff37efd18b27481$export$3988ae62b71be9a3 = async (accoundId)=>{
    try {
        return accoundId != null ? (await (0, $FppkK.getUserProperty)(accoundId, $fff37efd18b27481$var$key)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'userDismissGet',
            packageName: (0, $51e9357f231e05fa$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};
const $fff37efd18b27481$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
    try {
        return await (0, $FppkK.setUserProperties)(accoundId, $fff37efd18b27481$var$key, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'userDismissSet',
            packageName: (0, $51e9357f231e05fa$export$b8b9d90f9e5bd72b)
        });
        throw error;
    }
};

});
parcelRegister("FppkK", function(module, exports) {

$parcel$export(module.exports, "getUserPropertiesUrl", () => $0d0742b19f86216d$export$f474e53c8191800a);
$parcel$export(module.exports, "setUserProperties", () => $0d0742b19f86216d$export$d0e176862bf869b8);
$parcel$export(module.exports, "getUserProperty", () => $0d0742b19f86216d$export$b3126db2ef6e34ed);

var $1uIew = parcelRequire("1uIew");

var $jDtQA = parcelRequire("jDtQA");

var $i4YfB = parcelRequire("i4YfB");

var $7jTnu = parcelRequire("7jTnu");
const $0d0742b19f86216d$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute = (accountId, propertyKey)=>{
    const path = $0d0742b19f86216d$export$f474e53c8191800a(accountId, propertyKey);
    return (0, $7jTnu.fg)('magma-3429_banners_in_modern_ssr') ? (0, $i4YfB.getReroutableURL)(path) : path;
};
const $0d0742b19f86216d$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>{
    const url = $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $jDtQA.getDefaultOptions)(url),
        method: 'PUT',
        body: data
    });
};
const $0d0742b19f86216d$export$b3126db2ef6e34ed = (accountId, propertyKey)=>{
    const url = $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, (0, $jDtQA.getDefaultOptions)(url)).then((res)=>{
        if (res.status === 200) return res.json();
        return res.text().then((errResp)=>{
            throw new (0, $1uIew.default)(res.status, errResp);
        });
    }).then((data)=>data.value);
};
const $0d0742b19f86216d$export$4c4183b491dea321 = (accountId, propertyKey)=>{
    const url = $0d0742b19f86216d$var$getUserPropertiesUrlWithReroute(accountId, propertyKey);
    return fetch(url, {
        ...(0, $jDtQA.getDefaultOptions)(url),
        method: 'DELETE'
    });
};

});
parcelRegister("jDtQA", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $ac99da9d2792d561$export$430a3269e24b912e);

var $3WOLx = parcelRequire("3WOLx");
function $ac99da9d2792d561$export$430a3269e24b912e(url) {
    const options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    return url ? (0, $3WOLx.applyObservabilityHeaders)(url, options) : options;
}
const $ac99da9d2792d561$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        'x-atlassian-force-account-id': 'true',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ]
    }
};

});




parcelRegister("hHbzj", function(module, exports) {

$parcel$export(module.exports, "forgeAdminModuleResource", () => $7eeccaa3259d40ce$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $7eeccaa3259d40ce$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $7eeccaa3259d40ce$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeProjectModuleResourceOnNav3Only", () => $7eeccaa3259d40ce$export$9f19b684a7493211);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $7eeccaa3259d40ce$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $7eeccaa3259d40ce$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $7eeccaa3259d40ce$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $7eeccaa3259d40ce$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $7eeccaa3259d40ce$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $7eeccaa3259d40ce$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $7eeccaa3259d40ce$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $7eeccaa3259d40ce$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $7eeccaa3259d40ce$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $7eeccaa3259d40ce$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $7eeccaa3259d40ce$export$e6be2f0ca0849869);

var $4sqLM = parcelRequire("4sqLM");

var $7jTnu = parcelRequire("7jTnu");

var $fohjD = parcelRequire("fohjD");

var $dhAnj = parcelRequire("dhAnj");

var $6zXPf = parcelRequire("6zXPf");

var $fcQiO = parcelRequire("fcQiO");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $aOcSy = parcelRequire("aOcSy");
const $7eeccaa3259d40ce$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $fohjD.PROJECT_PAGE_MODULE),
        (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $fcQiO.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $7eeccaa3259d40ce$export$b9489d8c5c5e3626 = (0, $l1VxS.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.ADMIN_PAGE_MODULE], (0, $aOcSy.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$dcc98f4b36ce9223 = ()=>[
        $7eeccaa3259d40ce$export$b9489d8c5c5e3626
    ];
const $7eeccaa3259d40ce$export$72db683c2914a65e = (0, $l1VxS.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PROJECT_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$9f19b684a7493211 = (0, $5L7qx.resourceWithCondition2)(()=>!((0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('perf-push-big-components-nav-remove-resources')), $7eeccaa3259d40ce$export$72db683c2914a65e);
const $7eeccaa3259d40ce$export$7523db37432ba090 = (0, $l1VxS.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.BACKLOG_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$cfd99f451b423d3a = (0, $l1VxS.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.BOARD_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$7b639f33f086f9f1 = (0, $l1VxS.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.SPRINT_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$8a5aed164e925eb6 = (0, $l1VxS.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$ec3265610584f9ce = ()=>[
        $7eeccaa3259d40ce$export$8a5aed164e925eb6
    ];
const $7eeccaa3259d40ce$export$7a928d209faf75f = (0, $l1VxS.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$e81e11bbc3239153 = ()=>(0, $eJrcF.useResource)($7eeccaa3259d40ce$export$7a928d209faf75f);
const $7eeccaa3259d40ce$export$97b0827022fdafe3 = (0, $l1VxS.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.GLOBAL_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$80b2f91dabb3dd65 = ()=>[
        $7eeccaa3259d40ce$export$97b0827022fdafe3
    ];
const $7eeccaa3259d40ce$export$ebf5369e4dcfad00 = (0, $l1VxS.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$e6be2f0ca0849869 = (0, $l1VxS.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $dhAnj.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_NAVIGATION)
        }).then(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (modules)=>modules[0, $fohjD.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $7eeccaa3259d40ce$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $4sqLM.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("4sqLM", function(module, exports) {

$parcel$export(module.exports, "alphabeticalSort", () => $b0b7341e5e59d415$export$89a1f01f2a7cb2a1);

var $eSnSE = parcelRequire("eSnSE");
const $b0b7341e5e59d415$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $eSnSE.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("fohjD", function(module, exports) {

$parcel$export(module.exports, "STAGING_ENVIRONMENT", () => $21d9ac84d0c10ee4$export$71acbd662c478c42);
$parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", () => $21d9ac84d0c10ee4$export$978072fd3fd149);
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", () => $21d9ac84d0c10ee4$export$ebc15d9cebfd6063);
$parcel$export(module.exports, "BACKLOG_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$516a8fb49ad5d50e);
$parcel$export(module.exports, "BOARD_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$6cc3a1f2111dee11);
$parcel$export(module.exports, "SPRINT_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$cfb15d127f20a01f);
$parcel$export(module.exports, "ISSUE_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$fcc4a18f46f80f16);
$parcel$export(module.exports, "COMMAND_PALETTE_MODULE", () => $21d9ac84d0c10ee4$export$65ebd2e1f63d2992);
$parcel$export(module.exports, "ISSUE_GLANCE_MODULE", () => $21d9ac84d0c10ee4$export$259bab989b0129d0);
$parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", () => $21d9ac84d0c10ee4$export$75f224942f595e13);
$parcel$export(module.exports, "ISSUE_PANEL_MODULE", () => $21d9ac84d0c10ee4$export$ba0968f9752844);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_ACTION_MODULE", () => $21d9ac84d0c10ee4$export$7e2136b4285d29f5);
$parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", () => $21d9ac84d0c10ee4$export$cc20a5638825fbb0);
$parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", () => $21d9ac84d0c10ee4$export$9069d4b945c3d532);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $21d9ac84d0c10ee4$export$811b7f067a43b422);
$parcel$export(module.exports, "CUSTOM_FIELD_MODULE", () => $21d9ac84d0c10ee4$export$e3887d6bafe8a17);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", () => $21d9ac84d0c10ee4$export$7b7866c04a2ad947);
$parcel$export(module.exports, "ADMIN_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$52e4945e96bd2aa0);
$parcel$export(module.exports, "PERSONAL_SETTINGS_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$a8cd23a3cbda9d58);
$parcel$export(module.exports, "PROJECT_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$151b03356f566603);
$parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$ea0d6ac082b0d636);
$parcel$export(module.exports, "GLOBAL_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$31ac745ab2add7cc);
$parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", () => $21d9ac84d0c10ee4$export$353acf28daa75c79);
$parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", () => $21d9ac84d0c10ee4$export$25627f012b21b0b9);
$parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", () => $21d9ac84d0c10ee4$export$42d6a8740fd42e58);
$parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", () => $21d9ac84d0c10ee4$export$a7186e5a73395db4);
$parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", () => $21d9ac84d0c10ee4$export$8fbcfe84dc845d17);
$parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", () => $21d9ac84d0c10ee4$export$8af4cb794979f60d);
$parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", () => $21d9ac84d0c10ee4$export$5592ab836d562168);
$parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", () => $21d9ac84d0c10ee4$export$842eb4236828ac9);
$parcel$export(module.exports, "SUPPORTED_MODULES", () => $21d9ac84d0c10ee4$export$9b1a91242ce2a1b7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $21d9ac84d0c10ee4$export$2b8aeda236486576);
$parcel$export(module.exports, "ENTRY_POINT_VIEW", () => $21d9ac84d0c10ee4$export$c41ce1ec1ea6e73d);
$parcel$export(module.exports, "ENTRY_POINT_CREATE", () => $21d9ac84d0c10ee4$export$b37d58c3ed77c139);
$parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", () => $21d9ac84d0c10ee4$export$ab94dbd1d02ac251);
$parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", () => $21d9ac84d0c10ee4$export$b6a67a3131c6c48d);
$parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", () => $21d9ac84d0c10ee4$export$b75dc2bfd20898fe);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", () => $21d9ac84d0c10ee4$export$8e96118a698216cb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", () => $21d9ac84d0c10ee4$export$9b72a8e9b92658fb);
$parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", () => $21d9ac84d0c10ee4$export$2d6539e7d0553ae7);
$parcel$export(module.exports, "SOURCE_UNKNOWN", () => $21d9ac84d0c10ee4$export$ecbd7135d66cb322);
$parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", () => $21d9ac84d0c10ee4$export$61d882aa7aba51c);
$parcel$export(module.exports, "SOURCE_ISSUE_VIEW", () => $21d9ac84d0c10ee4$export$46cb92762d68a048);
$parcel$export(module.exports, "SOURCE_NAVIGATION", () => $21d9ac84d0c10ee4$export$fe90e46aea58e30b);
$parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", () => $21d9ac84d0c10ee4$export$c5ccbdb9893f2a6a);
$parcel$export(module.exports, "SOURCE_ROUTER", () => $21d9ac84d0c10ee4$export$eae46a3c13473a8d);
$parcel$export(module.exports, "SOURCE_LEGACY", () => $21d9ac84d0c10ee4$export$ac11ee191d09688f);
$parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", () => $21d9ac84d0c10ee4$export$4346e4e240c84319);
$parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", () => $21d9ac84d0c10ee4$export$d719bb340dc354e4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", () => $21d9ac84d0c10ee4$export$4b6228758e800433);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", () => $21d9ac84d0c10ee4$export$70495c8cc141a7a4);
$parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", () => $21d9ac84d0c10ee4$export$bc3d408418fdf9d2);
$parcel$export(module.exports, "getEmptyExtensionsObject", () => $21d9ac84d0c10ee4$export$218a328f66b86f7d);
$parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", () => $21d9ac84d0c10ee4$export$3193d714ab54ee26);
$parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $21d9ac84d0c10ee4$export$df7774a415710cce);
$parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", () => $21d9ac84d0c10ee4$export$51ab2784839ce348);
const $21d9ac84d0c10ee4$export$9af0088c49bdedb = 'PRODUCTION';
const $21d9ac84d0c10ee4$export$71acbd662c478c42 = 'STAGING';
const $21d9ac84d0c10ee4$export$978072fd3fd149 = 'DEVELOPMENT';
const $21d9ac84d0c10ee4$export$ebc15d9cebfd6063 = 'default';
const $21d9ac84d0c10ee4$export$516a8fb49ad5d50e = 'jira:backlogAction';
const $21d9ac84d0c10ee4$export$6cc3a1f2111dee11 = 'jira:boardAction';
const $21d9ac84d0c10ee4$export$cfb15d127f20a01f = 'jira:sprintAction';
const $21d9ac84d0c10ee4$export$fcc4a18f46f80f16 = 'jira:issueAction';
const $21d9ac84d0c10ee4$export$65ebd2e1f63d2992 = 'jira:command';
const $21d9ac84d0c10ee4$export$259bab989b0129d0 = 'jira:issueGlance';
const $21d9ac84d0c10ee4$export$75f224942f595e13 = 'jira:issueContext';
const $21d9ac84d0c10ee4$export$ba0968f9752844 = 'jira:issuePanel';
const $21d9ac84d0c10ee4$export$7e2136b4285d29f5 = 'jira:issueNavigatorAction';
const $21d9ac84d0c10ee4$export$cc20a5638825fbb0 = 'jira:issueActivity';
const $21d9ac84d0c10ee4$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
const $21d9ac84d0c10ee4$export$811b7f067a43b422 = 'jira:uiModifications';
const $21d9ac84d0c10ee4$export$e3887d6bafe8a17 = 'jira:customField';
const $21d9ac84d0c10ee4$export$7b7866c04a2ad947 = 'jira:customFieldType';
const $21d9ac84d0c10ee4$export$52e4945e96bd2aa0 = 'jira:adminPage';
const $21d9ac84d0c10ee4$export$a8cd23a3cbda9d58 = 'jira:personalSettingsPage';
const $21d9ac84d0c10ee4$export$151b03356f566603 = 'jira:projectPage';
const $21d9ac84d0c10ee4$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
const $21d9ac84d0c10ee4$export$31ac745ab2add7cc = 'jira:globalPage';
const $21d9ac84d0c10ee4$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
const $21d9ac84d0c10ee4$export$25627f012b21b0b9 = 'jira:dashboardGadget';
const $21d9ac84d0c10ee4$export$42d6a8740fd42e58 = 'jira:workflowValidator';
const $21d9ac84d0c10ee4$export$a7186e5a73395db4 = 'jira:workflowCondition';
const $21d9ac84d0c10ee4$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
const $21d9ac84d0c10ee4$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
const $21d9ac84d0c10ee4$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
const $21d9ac84d0c10ee4$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
const $21d9ac84d0c10ee4$export$9b1a91242ce2a1b7 = [
    $21d9ac84d0c10ee4$export$516a8fb49ad5d50e,
    $21d9ac84d0c10ee4$export$65ebd2e1f63d2992,
    $21d9ac84d0c10ee4$export$6cc3a1f2111dee11,
    $21d9ac84d0c10ee4$export$cfb15d127f20a01f,
    $21d9ac84d0c10ee4$export$fcc4a18f46f80f16,
    $21d9ac84d0c10ee4$export$259bab989b0129d0,
    $21d9ac84d0c10ee4$export$75f224942f595e13,
    $21d9ac84d0c10ee4$export$7e2136b4285d29f5,
    $21d9ac84d0c10ee4$export$ba0968f9752844,
    $21d9ac84d0c10ee4$export$cc20a5638825fbb0,
    $21d9ac84d0c10ee4$export$9069d4b945c3d532,
    $21d9ac84d0c10ee4$export$811b7f067a43b422,
    $21d9ac84d0c10ee4$export$e3887d6bafe8a17,
    $21d9ac84d0c10ee4$export$7b7866c04a2ad947,
    $21d9ac84d0c10ee4$export$52e4945e96bd2aa0,
    $21d9ac84d0c10ee4$export$a8cd23a3cbda9d58,
    $21d9ac84d0c10ee4$export$151b03356f566603,
    $21d9ac84d0c10ee4$export$ea0d6ac082b0d636,
    $21d9ac84d0c10ee4$export$31ac745ab2add7cc,
    $21d9ac84d0c10ee4$export$353acf28daa75c79,
    $21d9ac84d0c10ee4$export$25627f012b21b0b9,
    $21d9ac84d0c10ee4$export$8af4cb794979f60d,
    $21d9ac84d0c10ee4$export$5592ab836d562168,
    $21d9ac84d0c10ee4$export$842eb4236828ac9,
    $21d9ac84d0c10ee4$export$42d6a8740fd42e58,
    $21d9ac84d0c10ee4$export$a7186e5a73395db4,
    $21d9ac84d0c10ee4$export$8fbcfe84dc845d17
];
const $21d9ac84d0c10ee4$export$2b8aeda236486576 = 'edit';
const $21d9ac84d0c10ee4$export$c41ce1ec1ea6e73d = 'view';
const $21d9ac84d0c10ee4$export$b37d58c3ed77c139 = 'create';
const $21d9ac84d0c10ee4$export$ab94dbd1d02ac251 = 'contextConfig';
const $21d9ac84d0c10ee4$export$b6a67a3131c6c48d = 'none';
const $21d9ac84d0c10ee4$export$b75dc2bfd20898fe = 5;
const $21d9ac84d0c10ee4$export$8e96118a698216cb = 'native';
const $21d9ac84d0c10ee4$export$9b72a8e9b92658fb = 'basic';
const $21d9ac84d0c10ee4$export$2d6539e7d0553ae7 = 'blank';
const $21d9ac84d0c10ee4$export$ecbd7135d66cb322 = 'unknownSource';
const $21d9ac84d0c10ee4$export$61d882aa7aba51c = 'global-issue-create';
const $21d9ac84d0c10ee4$export$46cb92762d68a048 = 'issue-view';
const $21d9ac84d0c10ee4$export$fe90e46aea58e30b = 'navigation';
const $21d9ac84d0c10ee4$export$c5ccbdb9893f2a6a = 'full-page-app';
const $21d9ac84d0c10ee4$export$eae46a3c13473a8d = 'router';
const $21d9ac84d0c10ee4$export$ac11ee191d09688f = 'legacy';
const $21d9ac84d0c10ee4$export$4346e4e240c84319 = 'organization-panel';
const $21d9ac84d0c10ee4$export$d719bb340dc354e4 = 'assets-import-type';
const $21d9ac84d0c10ee4$export$4b6228758e800433 = 'jira';
const $21d9ac84d0c10ee4$export$70495c8cc141a7a4 = 'jsm';
const $21d9ac84d0c10ee4$export$bc3d408418fdf9d2 = 'cmdb';
const $21d9ac84d0c10ee4$export$a48dade1864725a = {
    jiraBacklogAction: [],
    jiraBoardAction: [],
    jiraSprintAction: [],
    jiraIssueAction: [],
    jiraIssueContext: [],
    jiraIssueGlance: [],
    jiraIssuePanel: [],
    jiraIssueNavigatorAction: [],
    jiraIssueActivity: [],
    jiraIssueViewBackgroundScript: [],
    jiraCustomField: [],
    jiraCustomFieldType: [],
    jiraUiModifications: [],
    jiraAdminPage: [],
    jiraGlobalPage: [],
    jiraPersonalSettingsPage: [],
    jiraProjectPage: [],
    jiraProjectSettingsPage: [],
    jiraDashboardBackgroundScript: [],
    jiraDashboardGadget: [],
    jiraServiceManagementQueuePage: [],
    jiraServiceManagementOrganizationPanel: [],
    jiraServiceManagementAssetsImportType: [],
    jiraWorkflowValidator: [],
    jiraWorkflowCondition: [],
    jiraWorkflowPostFunction: [],
    jiraCommand: []
};
/**
 * The above EMPTY_EXTENSIONS_OBJECT sometimes is mutated.
 * @see getEmptyExtensionsObject
 */ const $21d9ac84d0c10ee4$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
    ...$21d9ac84d0c10ee4$export$a48dade1864725a
};
const $21d9ac84d0c10ee4$export$218a328f66b86f7d = ()=>({
        ...$21d9ac84d0c10ee4$var$STABLE_EMPTY_EXTENSIONS_OBJECT
    });
const $21d9ac84d0c10ee4$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $21d9ac84d0c10ee4$export$df7774a415710cce = 'com.atlassian.forge:';
const $21d9ac84d0c10ee4$export$51ab2784839ce348 = `${$21d9ac84d0c10ee4$export$df7774a415710cce}${$21d9ac84d0c10ee4$export$3193d714ab54ee26}`;

});

parcelRegister("dhAnj", function(module, exports) {

$parcel$export(module.exports, "fetchModules", () => $ccf944db3861cc5e$export$24d8e11b15325c53);

var $c8VEk = parcelRequire("c8VEk");

var $j4oe4 = parcelRequire("j4oe4");

var $7jTnu = parcelRequire("7jTnu");

var $a1pDt = parcelRequire("a1pDt");

var $ayoPl = parcelRequire("ayoPl");

var $9gq2c = parcelRequire("9gq2c");

var $b6ojT = parcelRequire("b6ojT");

var $fohjD = parcelRequire("fohjD");

var $7zZ4w = parcelRequire("7zZ4w");

var $c8VEk = parcelRequire("c8VEk");

var $lB0Td = parcelRequire("lB0Td");

var $TUft0 = parcelRequire("TUft0");

var $aiU3I = parcelRequire("aiU3I");
const $ccf944db3861cc5e$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, $fohjD.SOURCE_UNKNOWN) } = params;
    if (!(0, $lB0Td.canFetchForgeModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous
    })) return (0, $TUft0.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $ayoPl.measureExecutionTimeMetrics)(()=>$ccf944db3861cc5e$export$9f9fdbce0829073d(params));
        if (Math.random() * 100 < (0, $9gq2c.FORGE_SAMPLING_RATE)) (0, $b6ojT.fireInitializationFetchFinishedEvent)(source);
        return (0, $TUft0.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $a1pDt.getErrorType)(error);
        (0, $b6ojT.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($ccf944db3861cc5e$export$458cbcb6374269d2.includes(errorType)) return (0, $TUft0.toMappedExtensions)(types, []);
        throw error;
    }
};
function $ccf944db3861cc5e$export$9f9fdbce0829073d(props) {
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    const operationName = (0, $c8VEk.default).params.name;
    const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, $aiU3I.trackGraphQLErrors)(operationName);
    let extensions;
    return new Promise((resolve, reject)=>{
        const subscription = (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $c8VEk.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes,
            includeModuleId: (0, $7jTnu.fg)('forge-extensions-module-id-for-relay')
        }).subscribe({
            next: (response)=>{
                stopGraphQLErrorTracking();
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const responseExtensions = response.jira?.forge?.extensions;
                // @ts-expect-error - TODO: new genereated type is incompatible with it
                extensions = responseExtensions?.concat().map((ext)=>({
                        ...ext,
                        moduleId: ext.moduleId ?? null
                    })) || null;
            },
            error: (error)=>{
                stopGraphQLErrorTracking();
                reject(error);
                subscription.unsubscribe();
            },
            complete: ()=>{
                // If there is a GraphQL error and extensions are `null`, it means a critical error has happened, and we have to reject the promise.
                // However, if the list of extensions is present in the response, it shouldn't be considered an error.
                const graphQLError = getGraphQLError();
                if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                else resolve(extensions || []);
                subscription.unsubscribe();
            }
        });
    });
}
const $ccf944db3861cc5e$export$458cbcb6374269d2 = [
    (0, $a1pDt.FAILED_TO_FETCH),
    (0, $a1pDt.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $a1pDt.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("c8VEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f691a859de7e35$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<65fdc39e22800ca49612b9334bcb8eee>>
 * @relayHash aa40c90903e47de315699de2ec5782c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b12b6105b2132d43c112090236c6be48401ba3a6ade76a8ddabd15f77ae4e7e2
const $59f691a859de7e35$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeModuleId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "condition": "includeHidden",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeScopes",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "condition": "includeModuleId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "moduleId"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "concreteType": "JiraUserAppAccess",
                                    "kind": "LinkedField",
                                    "name": "userAccess",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasAccess"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "inScopeEUD"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                    "kind": "LinkedField",
                                    "name": "installationConfig",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchModulesV2Query",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchModulesV2Query",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "id": "b12b6105b2132d43c112090236c6be48401ba3a6ade76a8ddabd15f77ae4e7e2",
            "metadata": {},
            "name": "fetchModulesV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$59f691a859de7e35$var$node.hash = "dc31e587ad9ce88caeb86481fbd6aa8d";
var $59f691a859de7e35$export$2e2bcd8739ae039 = $59f691a859de7e35$var$node;

});

parcelRegister("a1pDt", function(module, exports) {

$parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", () => $418aaf9ffa32ce25$export$23de3198bfe70090);
$parcel$export(module.exports, "FAILED_TO_FETCH", () => $418aaf9ffa32ce25$export$f52aa41ccd776f01);
$parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", () => $418aaf9ffa32ce25$export$31d2ab0be67934f0);
$parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", () => $418aaf9ffa32ce25$export$89a175d4190df42e);
$parcel$export(module.exports, "userConsentErrorRegex", () => $418aaf9ffa32ce25$export$dddade71b333c01d);
$parcel$export(module.exports, "getErrorType", () => $418aaf9ffa32ce25$export$e19f9f08a6d79fd2);


var $8KUFq = parcelRequire("8KUFq");

var $5Z6L0 = parcelRequire("5Z6L0");

var $7Jk3f = parcelRequire("7Jk3f");
const $418aaf9ffa32ce25$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $418aaf9ffa32ce25$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $418aaf9ffa32ce25$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $418aaf9ffa32ce25$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $418aaf9ffa32ce25$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $418aaf9ffa32ce25$export$89a175d4190df42e = 'Invoke value functions failed:';
const $418aaf9ffa32ce25$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $418aaf9ffa32ce25$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if ((0, $7Jk3f.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $418aaf9ffa32ce25$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $418aaf9ffa32ce25$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    // Tracked GraphQL errors contain useful info about internal errors like status codes
    // We want to categorize them more precisely, because some error types aren't SLO critical.
    if (error instanceof (0, $5Z6L0.TrackedGraphQLError)) {
        if (error.statusCode && error.statusCode >= 400) return error.statusCode === 429 ? $418aaf9ffa32ce25$export$7a1bd8c001e7e9c : `ERROR_SERVER_RESPONSE_${error.statusCode}`;
        return 'TRACKED_GRAPHQL_ERROR';
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $418aaf9ffa32ce25$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.') || /Extension ".*" could not be invoked as it does not reference a function or an endpoint/i.test(message)) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($418aaf9ffa32ce25$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($418aaf9ffa32ce25$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $44ccf6b895337c89$export$9de493bcd9b1d977);
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $44ccf6b895337c89$export$fa405bbf47d510e2);
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $418aaf9ffa32ce25$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($418aaf9ffa32ce25$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($418aaf9ffa32ce25$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $8KUFq.isClientFetchError)(error)) return $418aaf9ffa32ce25$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("5Z6L0", function(module, exports) {

$parcel$export(module.exports, "TrackedGraphQLError", () => $4ea9e19fe27d2302$export$f2062ad173e74c75);
class $4ea9e19fe27d2302$export$f2062ad173e74c75 extends Error {
    constructor(errorMessage, errors, traceIds){
        super(errorMessage), this.errorMessage = errorMessage, this.errors = errors, this.traceIds = traceIds;
        this.errors = errors;
        // Get first trace id
        this.traceId = traceIds?.[0];
        // Get first status code
        this.statusCode = errors?.map((graphQLError)=>graphQLError && 'extensions' in graphQLError ? graphQLError?.extensions?.statusCode : null).filter(Boolean)?.[0];
        // Combine error messages
        this.message = errors?.map((graphQLError)=>graphQLError?.message).filter(Boolean).join('; ') ?? errorMessage;
    }
}

});


parcelRegister("ayoPl", function(module, exports) {

$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $8f610b55c617371f$export$a859f6866f4653e0);

var $aXKmr = parcelRequire("aXKmr");

var $9gq2c = parcelRequire("9gq2c");

var $lHD3D = parcelRequire("lHD3D");
const $8f610b55c617371f$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, $aXKmr.v4)();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $9gq2c.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
};

});
parcelRegister("9gq2c", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $27592f25cbe551e4$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_TRIGGER", () => $27592f25cbe551e4$export$ed63b053e04e26df);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $27592f25cbe551e4$export$725bacc669333eef);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $27592f25cbe551e4$export$d920cee73ec094d0);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $27592f25cbe551e4$export$f048d91ccaf92408);
$parcel$export(module.exports, "UI_ACTIONS", () => $27592f25cbe551e4$export$2b7367f125154866);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $27592f25cbe551e4$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $27592f25cbe551e4$export$2af0438304d7c4b2);
// TODO ARKEN-359: uniformise GASv3/BM3 keys to use kebab lowercase
const $27592f25cbe551e4$export$f892f621fb508154 = 'jiraForgeUi';
const $27592f25cbe551e4$export$273f5980517336e2 = 'jiraforgeui';
const $27592f25cbe551e4$export$ed63b053e04e26df = 'trigger';
const $27592f25cbe551e4$export$725bacc669333eef = 'extension';
const $27592f25cbe551e4$export$d920cee73ec094d0 = 10;
const $27592f25cbe551e4$export$f048d91ccaf92408 = {
    FORGE_MODULES: {
        FETCH_TIME: `${$27592f25cbe551e4$export$273f5980517336e2}.forge-modules.fetch-time`,
        LOAD_TIME: `${$27592f25cbe551e4$export$273f5980517336e2}.forge-modules.load-time`
    },
    REAL_TIME_ISSUE_EVENTS: {
        INVOKE_TIME: `${$27592f25cbe551e4$export$273f5980517336e2}.real-time-issue-events.invoke-time`
    },
    MARKS: {
        TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
        TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
        ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
    }
};
const $27592f25cbe551e4$export$2b7367f125154866 = {
    CLICKED: 'clicked',
    SELECTED: 'selected',
    CANCELED: 'canceled',
    ACTION_CLICKED: 'action clicked',
    COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
    PIN_UNPIN_CLICKED: 'pin-unpin clicked',
    REMOVE_CLICKED: 'remove clicked'
};
const $27592f25cbe551e4$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    SUCCEEDED: 'succeeded',
    CALLED: 'called',
    INITIALIZED: 'initialized',
    EDIT_FAILED: 'edit failed',
    ACTION_FAILED: 'action failed',
    SAVE_FAILED: 'save failed',
    REMOVE_FAILED: 'remove failed',
    UPDATE_FAILED: 'update failed'
};
const $27592f25cbe551e4$export$2af0438304d7c4b2 = {
    EDITED: 'edited',
    SAVED: 'saved',
    REMOVED: 'removed',
    ACTION_SUCCEED: 'action succeed',
    UPDATE_SUCCEED: 'update succeed'
};

});

parcelRegister("lHD3D", function(module, exports) {

$parcel$export(module.exports, "forgeModulesConcurrentFetchTime", () => $9103e0edbbdf20b7$export$c3d8833fbea3e976);
$parcel$export(module.exports, "forgeModulesConcurrentLoadTime", () => $9103e0edbbdf20b7$export$292f3b557281044f);
$parcel$export(module.exports, "realTimeIssueEventInvokeTime", () => $9103e0edbbdf20b7$export$89ace7e2bb7d7685);
$parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", () => $9103e0edbbdf20b7$export$94f65f3b2556df23);
$parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", () => $9103e0edbbdf20b7$export$116d5e25caf0018d);
$parcel$export(module.exports, "customFieldPageSegmentLoadMetric", () => $9103e0edbbdf20b7$export$3bd38623c2543fc0);
$parcel$export(module.exports, "customFieldInteractionMetric", () => $9103e0edbbdf20b7$export$a318f99472db73c8);

var $hqYEY = parcelRequire("hqYEY");

var $gPCSe = parcelRequire("gPCSe");

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $9gq2c = parcelRequire("9gq2c");
const $9103e0edbbdf20b7$export$c3d8833fbea3e976 = (0, $hqYEY.metrics).concurrent.custom({
    key: (0, $9gq2c.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
});
const $9103e0edbbdf20b7$export$292f3b557281044f = (0, $hqYEY.metrics).concurrent.custom({
    key: (0, $9gq2c.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
});
const $9103e0edbbdf20b7$export$89ace7e2bb7d7685 = new (0, $f39LL.UFOExperience)((0, $9gq2c.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});
async function $9103e0edbbdf20b7$export$94f65f3b2556df23(startMark, endMark, fn) {
    if (false || (0, $gPCSe.default).getEntriesByName(startMark).length > 0 || (0, $gPCSe.default).getEntriesByName(endMark).length > 0) return fn();
    (0, $gPCSe.default).mark(startMark);
    const result = await fn();
    (0, $gPCSe.default).mark(endMark);
    return result;
}
const $9103e0edbbdf20b7$export$116d5e25caf0018d = (metric, additionalTimings)=>{
    additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
            ...(0, $gPCSe.default).getEntriesByName(startMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: cleanStart,
                    cleanEnd: undefined
                })),
            ...(0, $gPCSe.default).getEntriesByName(endMark).map((entry)=>({
                    name: entry.name,
                    startTime: entry.startTime,
                    cleanStart: undefined,
                    cleanEnd: cleanEnd
                }))
        ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
        metric.mark(name, startTime);
        if (cleanStart || cleanEnd) (0, $gPCSe.default).clearMarks(name);
    });
};
const $9103e0edbbdf20b7$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $hqYEY.metrics).pageSegmentLoad({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings,
            {
                key: 'tti',
                startMark: (0, $9gq2c.PERFORMANCE_KEYS).MARKS.TTI_START,
                endMark: (0, $9gq2c.PERFORMANCE_KEYS).MARKS.TTI_END
            }
        ]
    });
const $9103e0edbbdf20b7$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $hqYEY.metrics).interaction({
        key: 'forge-custom-field',
        timings: [
            ...additionalTimings
        ]
    });

});


parcelRegister("b6ojT", function(module, exports) {

$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $b46b77cba3fc4937$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $b46b77cba3fc4937$export$b5ca88b1053f1ad0);
$parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", () => $b46b77cba3fc4937$export$e914f7df1e4ad79b);
$parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", () => $b46b77cba3fc4937$export$b274c658390b491b);

var $5IiZP = parcelRequire("5IiZP");

var $1GZq2 = parcelRequire("1GZq2");
const $b46b77cba3fc4937$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $b46b77cba3fc4937$export$917d0643b0111a02 = (0, $5IiZP.toEventId)('issueViewInitialization');
const $b46b77cba3fc4937$export$43e875fd63e64525 = (0, $5IiZP.toEventId)('fetchModulesInitialization');
const $b46b77cba3fc4937$export$132ca822850e455f = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $b46b77cba3fc4937$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $b46b77cba3fc4937$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$e914f7df1e4ad79b = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $b46b77cba3fc4937$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$b274c658390b491b = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $b46b77cba3fc4937$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});
parcelRegister("5IiZP", function(module, exports) {

$parcel$export(module.exports, "toEventId", () => $f4ec6f2be36576de$export$75e84ef5a3771f9a);
const $f4ec6f2be36576de$export$75e84ef5a3771f9a = (value)=>value;

});

parcelRegister("1GZq2", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $08a88d513347b1c2$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireUiEvent", () => $08a88d513347b1c2$export$bed7f228c94e5f2a);
$parcel$export(module.exports, "fireTrackEvent", () => $08a88d513347b1c2$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $08a88d513347b1c2$export$390a62413962e4f0);

var $2Mqjh = parcelRequire("2Mqjh");

var $9gq2c = parcelRequire("9gq2c");

var $lHVmb = parcelRequire("lHVmb");

var $e6Fnd = parcelRequire("e6Fnd");

var $esfNg = parcelRequire("esfNg");
const $08a88d513347b1c2$var$createAnalyticsProps = ({ id: id, source: // Since source is required in sendOperationalEvent and sendUIEvent we need to pass here a fallback
// in case source is not provided
source = 'unknownSource', action: action, attributes: attributes })=>({
        actionSubject: `${0, $9gq2c.PACKAGE_NAME_GASV3}.${id}`,
        attributes: (0, $lHVmb.createAttributes)(attributes),
        source: source,
        action: action
    });
const $08a88d513347b1c2$var$getAnalyticsClient = async ()=>(await (0, $2Mqjh.getAnalyticsWebClientPromise)()).getInstance();
const $08a88d513347b1c2$var$sendOperationalEvent = async (props)=>(await $08a88d513347b1c2$var$getAnalyticsClient()).sendOperationalEvent($08a88d513347b1c2$var$createAnalyticsProps(props));
const $08a88d513347b1c2$var$sendUiEvent = async (props)=>(await $08a88d513347b1c2$var$getAnalyticsClient()).sendUIEvent($08a88d513347b1c2$var$createAnalyticsProps(props));
const $08a88d513347b1c2$var$sendTrackEvent = async (props)=>(await $08a88d513347b1c2$var$getAnalyticsClient()).sendTrackEvent($08a88d513347b1c2$var$createAnalyticsProps(props));
const $08a88d513347b1c2$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$08a88d513347b1c2$var$sendOperationalEvent({
        ...eventProps,
        source: (0, $lHVmb.parseSource)(source),
        action: action
    });
const $08a88d513347b1c2$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$08a88d513347b1c2$var$sendUiEvent({
        ...eventProps,
        source: (0, $lHVmb.parseSource)(source),
        action: action
    });
const $08a88d513347b1c2$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$08a88d513347b1c2$var$sendTrackEvent({
        ...eventProps,
        source: (0, $lHVmb.parseSource)(source),
        action: action
    });
const $08a88d513347b1c2$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
        $08a88d513347b1c2$export$a1fb57756f0de62b(action, {
            id: id,
            attributes: attributes,
            source: source
        }),
        attributes?.error && (0, $e6Fnd.logError)((0, $e6Fnd.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $esfNg.isSynthetic)().toString()}, id=${id}, source=${(0, $lHVmb.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
    ]);

});
parcelRegister("lHVmb", function(module, exports) {

$parcel$export(module.exports, "parseSource", () => $9bd51fd7ce296308$export$e98201ef9a88ba70);
$parcel$export(module.exports, "createAttributes", () => $9bd51fd7ce296308$export$c7c9603a6b1fd815);

var $3rsPO = parcelRequire("3rsPO");

var $hWeHP = parcelRequire("hWeHP");

var $bor34 = parcelRequire("bor34");

var $a1pDt = parcelRequire("a1pDt");

var $esfNg = parcelRequire("esfNg");
const $9bd51fd7ce296308$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
const $9bd51fd7ce296308$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error?.message
    });
const $9bd51fd7ce296308$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: (0, $esfNg.isSynthetic)(),
        isOverridingFragments: (0, $bor34.isOverridingFragments)(),
        isSSR: false,
        shard: (0, $hWeHP.default)('ajs-shard') || '',
        region: (0, $hWeHP.default)('ajs-region') || ''
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = $9bd51fd7ce296308$export$e98201ef9a88ba70(source);
        if (error) {
            attributes.error = $9bd51fd7ce296308$export$78c6267359db7e73(error);
            attributes.errorType = (0, $a1pDt.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3rsPO)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};

});
parcelRegister("bor34", function(module, exports) {

$parcel$export(module.exports, "isOverridingFragments", () => $67dfabecb1e685f2$export$1d1321d2b374d697);

var $7jTnu = parcelRequire("7jTnu");
const $67dfabecb1e685f2$export$1d1321d2b374d697 = ()=>{
    if ((0, $7jTnu.fg)('is_overriding_fragments_analytics_prop')) {
        const re = /^(JF-TEST|MRJF-BB(\d+)?-\d+)$/;
        const buildKey = typeof window !== 'undefined' ? window?.BUILD_KEY : globalThis?.BUILD_KEY;
        return buildKey ? re.test(buildKey) : false;
    }
    if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
    if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+|MRJF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
    return false;
};

});

parcelRegister("esfNg", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $f87e848916480251$export$947749d756ccb0a);

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");
const $f87e848916480251$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $hWeHP.default)('ajs-is-synthetic') === 'true' || (0, $7jTnu.fg)('forge_ui_synthetic_check');

});


parcelRegister("e6Fnd", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_UTIL", () => $f2ad15b7ec81ba1d$export$d1e4f308040bb0d5);
$parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", () => $f2ad15b7ec81ba1d$export$36f315a5c6daf40b);
$parcel$export(module.exports, "logError", () => $f2ad15b7ec81ba1d$export$58da9968c3170cb1);

var $eSnSE = parcelRequire("eSnSE");

var $9gq2c = parcelRequire("9gq2c");
const $f2ad15b7ec81ba1d$export$e31edcd35abe3bb1 = 'environment-mapping';
const $f2ad15b7ec81ba1d$export$d1e4f308040bb0d5 = 'analytics';
const $f2ad15b7ec81ba1d$export$36f315a5c6daf40b = 'custom-field-object-type';
const $f2ad15b7ec81ba1d$export$6ee8198f29fffdb4 = {
    [$f2ad15b7ec81ba1d$export$d1e4f308040bb0d5]: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
    [$f2ad15b7ec81ba1d$export$e31edcd35abe3bb1]: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
    [$f2ad15b7ec81ba1d$export$36f315a5c6daf40b]: `${(0, $9gq2c.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
};
const $f2ad15b7ec81ba1d$export$58da9968c3170cb1 = (key, message, event)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData($f2ad15b7ec81ba1d$export$6ee8198f29fffdb4[key], message, event);
};

});



parcelRegister("lB0Td", function(module, exports) {

$parcel$export(module.exports, "canFetchForgeModules", () => $482882859bcd0b72$export$bb3a4a3b8e654c08);
const $482882859bcd0b72$export$bb3a4a3b8e654c08 = ({ isAnonymous: isAnonymous, cloudId: cloudId })=>{
    /**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */ if (String(cloudId) === 'bob') return false;
    /**
	 * Similarly to the `bob` tenant situation above, we don't want to fetch Forge modules on monolith webdriver tests,
	 * that are also started with `./jmake run ci`, but this time with a valid `cloudId`.
	 * The reason for that is the heartbeat service that is not available in there, which leads to the login page redirects.
	 */ if (!false && $482882859bcd0b72$export$489a82a1efc4cd04().endsWith('.atl-test.space')) return false;
    // There is no anonymous access for now
    return !isAnonymous;
};
const $482882859bcd0b72$export$489a82a1efc4cd04 = ()=>window.location.hostname;

});

parcelRegister("TUft0", function(module, exports) {

$parcel$export(module.exports, "toMappedExtensions", () => $e072eb0063339dc0$export$e073e0c0d1c23345);

var $7jTnu = parcelRequire("7jTnu");
function $e072eb0063339dc0$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
    const result = Object.fromEntries(requestedModules.map((type)=>[
            type,
            []
        ]));
    const extensions = (0, $7jTnu.fg)('forge-extensions-module-id-for-relay') ? $e072eb0063339dc0$export$acd8ca2c14bd2aa4(returnedExtensions) : returnedExtensions;
    extensions.forEach((extension)=>{
        result[extension.type]?.push(extension);
    });
    // There is no better way to work this out and preserve a generic object response
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return result;
}
function $e072eb0063339dc0$export$acd8ca2c14bd2aa4(extensions) {
    return extensions.map(({ moduleId: moduleId, ...rest })=>({
            ...rest,
            id: moduleId ?? rest.id.replace(/-+\d+$/, ''),
            moduleId: moduleId
        }));
}

});

parcelRegister("aiU3I", function(module, exports) {

$parcel$export(module.exports, "trackGraphQLErrors", () => $0e4de19c3dd7a13b$export$a5c00ff206a4c88b);

var $g1oKu = parcelRequire("g1oKu");

var $5Z6L0 = parcelRequire("5Z6L0");

var $jHI6h = parcelRequire("jHI6h");
function $0e4de19c3dd7a13b$export$a5c00ff206a4c88b(operationName) {
    const queryId = (0, $g1oKu.startCaptureGraphQlErrors)();
    (0, $jHI6h.startCapturingTraceIds)(operationName);
    return {
        stopGraphQLErrorTracking: ()=>(0, $jHI6h.stopCapturingTraceIds)(operationName),
        getGraphQLError: ()=>$0e4de19c3dd7a13b$var$getGraphQLError(queryId, operationName)
    };
}
function $0e4de19c3dd7a13b$var$getGraphQLError(key, operationName) {
    const errors = (0, $g1oKu.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
    if (errors.length) return new (0, $5Z6L0.TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, $jHI6h.getTraceIds)(operationName));
    return undefined;
}

});


parcelRegister("fcQiO", function(module, exports) {

$parcel$export(module.exports, "getProjectKeyOrId", () => $45133b0b69e21626$export$43cde151f667c69e);
$parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", () => $45133b0b69e21626$export$b87af5b274141bd6);

var $bBtQo = parcelRequire("bBtQo");
const $45133b0b69e21626$export$43cde151f667c69e = (match)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, match.query);
    return projectKey || projectId || '';
};
const $45133b0b69e21626$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};

});
parcelRegister("bBtQo", function(module, exports) {

$parcel$export(module.exports, "getProjectIdOrKey", () => $0bc483932e4540b9$export$c072f183553fb7ea);
$parcel$export(module.exports, "getProjectKeyId", () => $0bc483932e4540b9$export$1f7213d0f9054f06);
const $0bc483932e4540b9$export$89040d072f281f85 = (query)=>query?.selectedProjectId || query?.pid || query?.projectId || query?.['project.id'];
const $0bc483932e4540b9$export$667f2a0f99c75faa = (match, query)=>match?.params.projectKey || query?.projectKey || query?.['project.key'] || (match.params?.issueKey || '').split('-')[0];
const $0bc483932e4540b9$export$c072f183553fb7ea = (match, query)=>$0bc483932e4540b9$export$89040d072f281f85(query) || $0bc483932e4540b9$export$667f2a0f99c75faa(match, query);
const $0bc483932e4540b9$export$1f7213d0f9054f06 = (match, query)=>{
    // handle reports legacy url or project settings details
    const projectId = $0bc483932e4540b9$export$89040d072f281f85(query);
    const projectKey = $0bc483932e4540b9$export$667f2a0f99c75faa(match, query);
    return {
        projectKey: projectKey,
        projectId: projectId
    };
};

});


parcelRegister("5L7qx", function(module, exports) {

$parcel$export(module.exports, "resourceWithCondition", () => $e024e4a1466467c1$export$cac04afc5a06c544);
$parcel$export(module.exports, "resourceWithCondition2", () => $e024e4a1466467c1$export$78488a529a07cd46);
$parcel$export(module.exports, "browserOnlyResourceWithCondition", () => $e024e4a1466467c1$export$5284559c6d2f1a7b);

var $cJYBV = parcelRequire("cJYBV");
const $e024e4a1466467c1$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
        get type () {
            return conditionGetter() ? resourceTrue.type : (0, $cJYBV.RESOURCE_TYPE_NOOP);
        },
        getKey: resourceTrue.getKey,
        get maxAge () {
            return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
        },
        getData: (routerContext, storeContext)=>conditionGetter() ? resourceTrue.getData(routerContext, storeContext) : Promise.resolve(null),
        maxCache: resourceTrue.maxCache,
        get isBrowserOnly () {
            return resourceTrue.isBrowserOnly;
        },
        get depends () {
            return resourceTrue.depends;
        },
        get skipBrowser () {
            return resourceTrue.skipBrowser;
        }
    };
const $e024e4a1466467c1$export$fbf6681b373be4c4 = (resource, amendments = {})=>// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
    resource && // IMPORTANT - resources can be falsy in SSR "routes" build
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.defineProperties({}, {
        ...Object.getOwnPropertyDescriptors(resource),
        ...Object.getOwnPropertyDescriptors(amendments)
    });
const $e024e4a1466467c1$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $e024e4a1466467c1$export$fbf6681b373be4c4(itemTrue, {
    getKey: ()=>'DEGENERATE_KEY',
    getData: ()=>null,
    maxAge: Number.MAX_SAFE_INTEGER
}))=>// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
    itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
    Object.defineProperties({}, Object.fromEntries([
        ...Object.keys(itemTrue),
        ...Object.keys(itemFalse)
    ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
            key,
            {
                configurable: false,
                enumerable: true,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
                get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
            }
        ])));
const $e024e4a1466467c1$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
        ...resource,
        get isBrowserOnly () {
            return !!conditionGetter();
        }
    };

});
parcelRegister("cJYBV", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NOOP", () => $36187b280b89d04f$export$eb37f5d331ea4de4);
$parcel$export(module.exports, "MIN_MAX_AGE", () => $36187b280b89d04f$export$5664a170ac5a9781);
const $36187b280b89d04f$export$eb37f5d331ea4de4 = 'NOOP';
const $36187b280b89d04f$export$5664a170ac5a9781 = 5000;

});


parcelRegister("aOcSy", function(module, exports) {

$parcel$export(module.exports, "uniqueExtensionsFilter", () => $a0b01b44bfd87d67$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $a0b01b44bfd87d67$export$1eefd1d9cde49fd5);

var $jOCpp = parcelRequire("jOCpp");

var $ePLco = parcelRequire("ePLco");
const $a0b01b44bfd87d67$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $a0b01b44bfd87d67$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});
parcelRegister("jOCpp", function(module, exports) {

var $1lM9j = parcelRequire("1lM9j");

var $1txRh = parcelRequire("1txRh");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $e6d07b03a10f7aee$var$uniqBy(array, iteratee) {
    return array && array.length ? $1txRh(array, $1lM9j(iteratee, 2)) : [];
}
module.exports = $e6d07b03a10f7aee$var$uniqBy;

});

parcelRegister("ePLco", function(module, exports) {

$parcel$export(module.exports, "parseExtensionId", () => $763cc49eecef8327$export$bae42cbaf7fa3e1b);
$parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", () => $763cc49eecef8327$export$a92b17288693d366);
const $763cc49eecef8327$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const [, appId, envId] = extensionId.split('/');
    return {
        appId: appId,
        envId: envId
    };
};
const $763cc49eecef8327$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');

});



parcelRegister("3luhJ", function(module, exports) {

$parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", () => $f503c22a7b6ca0ef$export$5839dd8142de842e);

var $eSnSE = parcelRequire("eSnSE");

var $2at4v = parcelRequire("2at4v");

var $l1VxS = parcelRequire("l1VxS");

var $j3MZT = parcelRequire("j3MZT");
const $f503c22a7b6ca0ef$export$5839dd8142de842e = (0, $l1VxS.createResource)({
    type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        if (boardId == null) return null;
        try {
            const response = await (0, $j3MZT.fetchUserBoardNavigationData)(boardId);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
            return null;
        }
    },
    maxAge: 300000
});

});
parcelRegister("2at4v", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $68611441a9f8281f$export$557c2f222778cea6);
const $68611441a9f8281f$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];

});

parcelRegister("j3MZT", function(module, exports) {

$parcel$export(module.exports, "fetchUserBoardNavigationData", () => $071e1177268b0d4d$export$306fb49fca60b34);

var $jGzN3 = parcelRequire("jGzN3");
const $071e1177268b0d4d$export$306fb49fca60b34 = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $jGzN3.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
};

});


parcelRegister("4HvIf", function(module, exports) {

$parcel$export(module.exports, "staticPlanSidebarNavigationResource", () => $88524b29244ca76c$export$e7e6c1b9d8d5ea7);
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router

var $l1VxS = parcelRequire("l1VxS");

var $4q1H4 = parcelRequire("4q1H4");
const $88524b29244ca76c$var$getRouterKey = (match)=>{
    if (match.url.includes('/plans/')) return `planId-${match.params.planId || ''}-scenarioId-${match.params.scenarioId || ''}`;
    return 'none';
};
const $88524b29244ca76c$export$e7e6c1b9d8d5ea7 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PLAN',
    getKey: ({ match: match })=>$88524b29244ca76c$var$getRouterKey(match),
    getData: async ({ match: { params: { planId: planId, scenarioId: scenarioId } } })=>{
        if (planId == null || scenarioId == null) return null;
        return (0, $4q1H4.fetchPlanSidebarNavInfo)(planId, scenarioId);
    },
    maxAge: 300000
});

});
parcelRegister("4q1H4", function(module, exports) {

$parcel$export(module.exports, "fetchPlanSidebarNavInfo", () => $9360532f5ab456b0$export$a49729698cfc5310);

var $jGzN3 = parcelRequire("jGzN3");
const $9360532f5ab456b0$var$requestSideBarInfo = (planId, scenarioId)=>(0, $jGzN3.performGetRequest)(`/rest/jpo/1.0/navigation/plans/${planId}/scenarios/${scenarioId}`);
const $9360532f5ab456b0$export$a49729698cfc5310 = (planId, scenarioId)=>{
    if (planId == null || planId.trim() === '') throw new Error('Plan cannot be loaded without a planId');
    if (scenarioId == null || scenarioId.trim() === '') throw new Error('Plan cannot be loaded without a scenarioId');
    return $9360532f5ab456b0$var$requestSideBarInfo(planId, scenarioId);
};

});


parcelRegister("cY5nO", function(module, exports) {

$parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", () => $8255136ae0c43529$export$e4bf33528101348c);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", () => $8255136ae0c43529$export$2d5a704ae6f6b050);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $jfYJb = parcelRequire("jfYJb");
const $8255136ae0c43529$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $8255136ae0c43529$export$e4bf33528101348c = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$8255136ae0c43529$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $8255136ae0c43529$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
        return navInfo;
    },
    maxAge: 300000
});
const $8255136ae0c43529$export$2d5a704ae6f6b050 = ()=>(0, $eJrcF.useResource)($8255136ae0c43529$export$e4bf33528101348c);

});
parcelRegister("jfYJb", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", () => $8ad6472209454f53$export$b15f9f5cf6db359e);

var $jGzN3 = parcelRequire("jGzN3");
const $8ad6472209454f53$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
    if (projectKeyOrId == null) throw new Error('invalid identifier specified');
    return (0, $jGzN3.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
};

});


parcelRegister("43SpR", function(module, exports) {

$parcel$export(module.exports, "sidebarNav4Resource", () => $dbd1c384f9b07eb1$export$7648dc6f76f4f83d);
$parcel$export(module.exports, "sidebarNav4UiStateResource", () => $dbd1c384f9b07eb1$export$a46129bd512544d7);

var $h4Bzb = parcelRequire("h4Bzb");

var $kWbWF = parcelRequire("kWbWF");

var $b1DBy = parcelRequire("b1DBy");

var $9FYIg = parcelRequire("9FYIg");

var $bBIDB = parcelRequire("bBIDB");

var $hOoYL = parcelRequire("hOoYL");

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");

var $7jTnu = parcelRequire("7jTnu");
const $dbd1c384f9b07eb1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
const $dbd1c384f9b07eb1$export$7648dc6f76f4f83d = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_${$dbd1c384f9b07eb1$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
        const initialSelectedPath = (0, $kWbWF.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $bBIDB.default),
            variables: {
                cloudId: cloudId,
                isAppsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_APPS)),
                isFiltersExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $fKh2A.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $7Cu03.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString(),
                isAnonymous: (0, $7jTnu.fg)('firing_empty_query_on_sidebar_for_anonymous_users') && isAnonymous
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});
const $dbd1c384f9b07eb1$export$a46129bd512544d7 = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $hOoYL.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("h4Bzb", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_APP_MENU_ID", () => $330926e53d81707a$export$1bb3d16bc95080e3);
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID_TO_APS_KEY", () => $330926e53d81707a$export$3b4ca8d4d769a311);
$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $330926e53d81707a$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $330926e53d81707a$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $330926e53d81707a$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $330926e53d81707a$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $330926e53d81707a$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $330926e53d81707a$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $330926e53d81707a$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $330926e53d81707a$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $330926e53d81707a$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $330926e53d81707a$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $330926e53d81707a$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $330926e53d81707a$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $330926e53d81707a$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $330926e53d81707a$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $330926e53d81707a$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $330926e53d81707a$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $330926e53d81707a$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $330926e53d81707a$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $330926e53d81707a$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $330926e53d81707a$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_COMMUNICATION", () => $330926e53d81707a$export$feed0c05fb1a4af);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $330926e53d81707a$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $330926e53d81707a$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $330926e53d81707a$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $330926e53d81707a$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $330926e53d81707a$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $330926e53d81707a$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $330926e53d81707a$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $330926e53d81707a$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $330926e53d81707a$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $330926e53d81707a$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", () => $330926e53d81707a$export$11fcdf33179ef88e);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_HUBS", () => $330926e53d81707a$export$d69bec513af84431);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE_ANALYTICS", () => $330926e53d81707a$export$1d260f51eeaab73d);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $330926e53d81707a$export$80dc576e446bdb6b);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_ASSETS", () => $330926e53d81707a$export$5aa3e4dd37f372d5);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_GOALS", () => $330926e53d81707a$export$7986b535c183c592);
$parcel$export(module.exports, "MENU_ID_COMMUNICATIONS_STAKEHOLDERS", () => $330926e53d81707a$export$784c436fb3f51c19);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_CONFLUENCE", () => $330926e53d81707a$export$c093b87743053085);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_LOOM", () => $330926e53d81707a$export$e316a54b33dbe500);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_PROJECTS", () => $330926e53d81707a$export$8ceb414d866f12fc);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_TEAMS", () => $330926e53d81707a$export$804187987544d0f8);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_OPSGENIE", () => $330926e53d81707a$export$83352ab9064f1723);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $330926e53d81707a$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $330926e53d81707a$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $330926e53d81707a$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $330926e53d81707a$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $330926e53d81707a$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $330926e53d81707a$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $330926e53d81707a$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $330926e53d81707a$export$100a1a639a0db980);
const $330926e53d81707a$export$1bb3d16bc95080e3 = {
    GLOBAL_APP_GOALS: 'jira.sidebar.globalApp.goals',
    GLOBAL_APP_ASSETS: 'jira.sidebar.globalApp.assets',
    // Global App Shortcuts for Platform Component
    GLOBAL_APP_CONFLUENCE: 'jira.sidebar.globalApp.confluence',
    GLOBAL_APP_LOOM: 'jira.sidebar.globalApp.loom',
    GLOBAL_APP_PROJECTS: 'jira.sidebar.globalApp.projects',
    GLOBAL_APP_TEAMS: 'jira.sidebar.globalApp.teams',
    GLOBAL_APP_OPSGENIE: 'jira.sidebar.globalApp.opsgenie'
};
const $330926e53d81707a$export$3b4ca8d4d769a311 = {
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_CONFLUENCE]: 'CONFLUENCE',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_LOOM]: 'LOOM',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_GOALS]: 'GOALS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_PROJECTS]: 'PROJECTS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_TEAMS]: 'TEAMS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_OPSGENIE]: 'OPSGENIE'
};
const $330926e53d81707a$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    COMMUNICATION: 'jira.sidebar.communication',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps',
    CUSTOMER_SERVICE: 'jira.sidebar.customerService',
    CUSTOMER_HUBS: 'jira.sidebar.customerHubs',
    CUSTOMER_SERVICE_ANALYTICS: 'jira.sidebar.customerServiceAnalytics',
    ...$330926e53d81707a$export$1bb3d16bc95080e3
};
const $330926e53d81707a$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_OPERATIONS: (projectKey)=>`proj-${projectKey}-ops`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_DASHBOARDS: (projectKey)=>`proj-${projectKey}-dashboards`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    ISSUE: (id)=>`issue_${id}`,
    ARCHIVED_WORK_ITEMS: (id)=>`archived_work_items_${id}`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $330926e53d81707a$export$441cd608ea3204f4 = $330926e53d81707a$export$7838b734e4cd5e8d.APPS;
const $330926e53d81707a$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $330926e53d81707a$export$75c65bfc98b3a6e1 = $330926e53d81707a$export$7838b734e4cd5e8d.ASSETS;
const $330926e53d81707a$export$8a0af92d49f1d13d = 'asst_schm';
const $330926e53d81707a$export$a09300d15acc958a = 'asst_rprt';
const $330926e53d81707a$export$4d718fbd418eef5c = 'board-view-all';
const $330926e53d81707a$export$dd009509c2dabb5e = $330926e53d81707a$export$7838b734e4cd5e8d.DASHBOARDS;
const $330926e53d81707a$export$d3da0455b4200fb2 = 'dash-view';
const $330926e53d81707a$export$b9dd2b5309d19763 = 'dash-view-starred';
const $330926e53d81707a$export$3d81af172a8e3c57 = $330926e53d81707a$export$7838b734e4cd5e8d.FILTERS;
const $330926e53d81707a$export$1e2599eaf0039a97 = 'filt-search';
const $330926e53d81707a$export$53d274d993c9d5b5 = 'filt-view-all';
const $330926e53d81707a$export$7661ea763be69cfa = 'filt-view-starred';
const $330926e53d81707a$export$47c6ce6a83a59eab = $330926e53d81707a$export$7838b734e4cd5e8d.GOALS;
const $330926e53d81707a$export$ef89639b7d9c162a = $330926e53d81707a$export$7838b734e4cd5e8d.OPERATIONS;
const $330926e53d81707a$export$af4ab6d4e920522a = 'ops-alrt';
const $330926e53d81707a$export$25c40acb2c53a294 = 'ops-over';
const $330926e53d81707a$export$c7d8892f1628b844 = 'ops-rprt';
const $330926e53d81707a$export$bb19a52e3df99541 = 'ops-oncl';
const $330926e53d81707a$export$3bd12c092f8db11b = $330926e53d81707a$export$7838b734e4cd5e8d.OVERVIEWS;
const $330926e53d81707a$export$feed0c05fb1a4af = $330926e53d81707a$export$7838b734e4cd5e8d.COMMUNICATION;
const $330926e53d81707a$export$f2533da33c749933 = $330926e53d81707a$export$7838b734e4cd5e8d.PLANS;
const $330926e53d81707a$export$8468c5b6648f4f1f = 'plan-view-all';
const $330926e53d81707a$export$fed17b4c0866b97d = 'proj-app';
const $330926e53d81707a$export$9c5278bd360a285 = $330926e53d81707a$export$7838b734e4cd5e8d.PROJECTS;
const $330926e53d81707a$export$85389c606bb641dd = 'proj-view-all';
const $330926e53d81707a$export$4a1974b63c858e9c = 'proj-view-starred';
const $330926e53d81707a$export$692b796030a796f3 = $330926e53d81707a$export$7838b734e4cd5e8d.RECENT;
const $330926e53d81707a$export$cdc80d4b5ce0c6a = $330926e53d81707a$export$7838b734e4cd5e8d.ROADMAPS;
const $330926e53d81707a$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $330926e53d81707a$export$5637ca42a4d77f32 = $330926e53d81707a$export$7838b734e4cd5e8d.STARRED;
const $330926e53d81707a$export$d4f6fcf571f9c50 = $330926e53d81707a$export$7838b734e4cd5e8d.TEAMS;
const $330926e53d81707a$export$11fcdf33179ef88e = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
const $330926e53d81707a$export$d69bec513af84431 = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_HUBS;
const $330926e53d81707a$export$1d260f51eeaab73d = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_SERVICE_ANALYTICS;
const $330926e53d81707a$export$80dc576e446bdb6b = 'yrwk';
const $330926e53d81707a$export$5aa3e4dd37f372d5 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_ASSETS;
const $330926e53d81707a$export$7986b535c183c592 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_GOALS;
const $330926e53d81707a$export$784c436fb3f51c19 = 'comm-stkhldr';
const $330926e53d81707a$export$205988f610130417 = 'comm-stkhldr-grp';
const $330926e53d81707a$export$c093b87743053085 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_CONFLUENCE;
const $330926e53d81707a$export$e316a54b33dbe500 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_LOOM;
const $330926e53d81707a$export$8ceb414d866f12fc = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_PROJECTS;
const $330926e53d81707a$export$804187987544d0f8 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_TEAMS;
const $330926e53d81707a$export$83352ab9064f1723 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_OPSGENIE;
const $330926e53d81707a$export$79c15668ed799a1b = 'sd-sett-acc';
const $330926e53d81707a$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $330926e53d81707a$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $330926e53d81707a$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $330926e53d81707a$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $330926e53d81707a$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $330926e53d81707a$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $330926e53d81707a$export$100a1a639a0db980 = 'sd-sett-ops';

});

parcelRegister("kWbWF", function(module, exports) {

$parcel$export(module.exports, "getInitialSelectedPath", () => $6793867fe071cdbb$export$39f409bc5f59c5e);
/**
 * Why do we need the initialSelectedPath? It all stems from the workaround that Nav4 uses
 * to SSR the initial sidebar semi-correctly, while pretending to lazy-load everything else.
 *
 * Ideally we would be able to pre-load entrypoints that we know we need to load, and lazy-load
 * the rest. This would support SSR and be performant.
 * Unfortunately, unless all of the Jira routes are loaded via entry-points, we cannot use this approach.
 *
 * The workaround is to use Relay variables to tell Relay what data to preload, and then load
 * the corresponding UI component directly (not via an entrypoint) when we have the data for it.
 * When we don't have the preloaded data, we lazy load __the same component via an entrypoint__.
 * In other words, we sacrifice bundle size (by directly including the component for the data-available
 * case), in order to get SSR benefits.
 *
 * A consequence of this approach is we have two versions of the top-level menu item components - the
 * regular version (called *Landing) and the entrypoint version (called *Default). When navigating,
 * the router's state would change, causing the components to switch around. In the UI, this would
 * cause ExpandableMenuItem components to collapse, when they were open before navigating.
 *
 * To work around THIS problem, we store a computed-version of the initial state of the router, and
 * then query this value when deciding which component to show (the *Landing or the *Default). Because if
 * the initial state doesn't change, our components won't switch around after the first render.
 */ 
var $bx11l = parcelRequire("bx11l");

var $kg9Uh = parcelRequire("kg9Uh");
const $6793867fe071cdbb$export$39f409bc5f59c5e = (0, (/*@__PURE__*/$parcel$interopDefault($bx11l)))((0, $kg9Uh.routeToSelectedPath));

});
parcelRegister("kg9Uh", function(module, exports) {

$parcel$export(module.exports, "routeToSelectedPath", () => $b1359280a8973d4c$export$a92474c098a1fd13);
$parcel$export(module.exports, "useRouteToSelectedPath", () => $b1359280a8973d4c$export$a086f1986cac3253);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $7jTnu = parcelRequire("7jTnu");

var $kfvK2 = parcelRequire("kfvK2");

var $K1AKP = parcelRequire("K1AKP");

var $5APJC = parcelRequire("5APJC");

var $bb1Lz = parcelRequire("bb1Lz");

var $hXLQ4 = parcelRequire("hXLQ4");

var $gUBBs = parcelRequire("gUBBs");

var $7ened = parcelRequire("7ened");

var $kyqLB = parcelRequire("kyqLB");

var $3NLYz = parcelRequire("3NLYz");

var $eC071 = parcelRequire("eC071");

var $3233g = parcelRequire("3233g");

var $nPGhK = parcelRequire("nPGhK");

var $7krAP = parcelRequire("7krAP");

var $6ofXP = parcelRequire("6ofXP");
function $b1359280a8973d4c$export$a92474c098a1fd13(routeContext) {
    const routeName = routeContext.route.name;
    if ((0, $kyqLB.topLevelConverter).routes.has(routeName)) return (0, $kyqLB.topLevelConverter).convert(routeContext);
    if ((0, $K1AKP.appsConverter).routes.has(routeName)) return (0, $K1AKP.appsConverter).convert(routeContext);
    if ((0, $5APJC.assetsConverter).routes.has(routeName)) return (0, $5APJC.assetsConverter).convert(routeContext);
    if ((0, $bb1Lz.dashboardsConverter).routes.has(routeName)) return (0, $bb1Lz.dashboardsConverter).convert(routeContext);
    if ((0, $hXLQ4.filtersConverter).routes.has(routeName)) return (0, $hXLQ4.filtersConverter).convert(routeContext);
    if ((0, $gUBBs.operationsConverter).routes.has(routeName)) return (0, $gUBBs.operationsConverter).convert(routeContext);
    if ((0, $7ened.communicationsConverter).routes.has(routeName)) return (0, $7ened.communicationsConverter).convert(routeContext);
    if ((0, $3NLYz.overviewsConverter).routes.has(routeName)) return (0, $3NLYz.overviewsConverter).convert(routeContext);
    if ((0, $3NLYz.overviewsConverter).routes.has(routeName)) return (0, $3NLYz.overviewsConverter).convert(routeContext);
    if ((0, $eC071.plansConverter).routes.has(routeName)) return (0, $eC071.plansConverter).convert(routeContext);
    if ((0, $3233g.projectsConverter).routes.has(routeName)) return (0, $3233g.projectsConverter).convert(routeContext);
    if ((0, $nPGhK.roadmapsConverter).routes.has(routeName)) return (0, $nPGhK.roadmapsConverter).convert(routeContext);
    if ((0, $7krAP.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $7krAP.serviceManagementProjectSettingsConverter).convert(routeContext);
    if ((0, $7jTnu.fg)('jcs_master_flag')) {
        if ((0, $6ofXP.customerServiceConverter).routes.has(routeName)) return (0, $6ofXP.customerServiceConverter).convert(routeContext);
    }
    return [];
}
function $b1359280a8973d4c$export$216c13b87ae41e0b(state) {
    const routeName = state.route.name;
    const match = state.match;
    const query = state.query;
    if ((0, $kyqLB.topLevelConverter).routes.has(routeName)) return (0, $kyqLB.topLevelConverter).convertNew({
        routeName: routeName
    });
    if ((0, $K1AKP.appsConverter).routes.has(routeName)) return (0, $K1AKP.appsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $5APJC.assetsConverter).routes.has(routeName)) return (0, $5APJC.assetsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $bb1Lz.dashboardsConverter).routes.has(routeName)) return (0, $bb1Lz.dashboardsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $hXLQ4.filtersConverter).routes.has(routeName)) return (0, $hXLQ4.filtersConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $gUBBs.operationsConverter).routes.has(routeName)) return (0, $gUBBs.operationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $7ened.communicationsConverter).routes.has(routeName)) return (0, $7ened.communicationsConverter).convertNew({
        routeName: routeName,
        query: query
    });
    if ((0, $3NLYz.overviewsConverter).routes.has(routeName)) return (0, $3NLYz.overviewsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $eC071.plansConverter).routes.has(routeName)) return (0, $eC071.plansConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $3233g.projectsConverter).routes.has(routeName)) return (0, $3233g.projectsConverter).convertNew({
        routeName: routeName,
        match: match,
        query: query
    });
    if ((0, $nPGhK.roadmapsConverter).routes.has(routeName)) return (0, $nPGhK.roadmapsConverter).convertNew({
        routeName: routeName,
        match: match
    });
    if ((0, $7krAP.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $7krAP.serviceManagementProjectSettingsConverter).convertNew({
        routeName: routeName
    });
    if ((0, $7jTnu.fg)('jcs_master_flag')) {
        if ((0, $6ofXP.customerServiceConverter).routes.has(routeName)) return (0, $6ofXP.customerServiceConverter).convertNew({
            routeName: routeName
        });
    }
    return [];
}
function $b1359280a8973d4c$export$8eb45058a3aef67f() {
    return (0, $eJOHy.useState)(()=>{
        const selectedPath = $b1359280a8973d4c$export$216c13b87ae41e0b((0, $kfvK2.getRouterState)());
        return {
            initialSelectedPath: selectedPath,
            selectedPath: selectedPath
        };
    });
}
function $b1359280a8973d4c$export$a086f1986cac3253() {
    const [selectedPathData, setSelectedPathData] = $b1359280a8973d4c$export$8eb45058a3aef67f();
    (0, $eJOHy.useEffect)(()=>(0, $kfvK2.addRouteListener)((state)=>{
            const nextSelectedPath = $b1359280a8973d4c$export$216c13b87ae41e0b(state);
            const pathIsDifferent = (0, $7jTnu.fg)('jira-concurrent-nav4-fix-selected-path') ? !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextSelectedPath, selectedPathData.selectedPath) // Since this is an array and not a primitive, we need to do an isEqual check
             : nextSelectedPath !== selectedPathData.selectedPath;
            if (pathIsDifferent) setSelectedPathData({
                initialSelectedPath: selectedPathData.initialSelectedPath,
                selectedPath: nextSelectedPath
            });
        }), [
        selectedPathData.initialSelectedPath,
        selectedPathData.selectedPath,
        setSelectedPathData
    ]);
    return selectedPathData;
}

});
parcelRegister("K1AKP", function(module, exports) {

$parcel$export(module.exports, "appsConverter", () => $e565dec3d2a1a779$export$d017a63045c88c47);

var $h4Bzb = parcelRequire("h4Bzb");
// TODO: verify these routes
const $e565dec3d2a1a779$var$UNCERTAIN_APPS_SECTION_ROUTES = [
    'connect-general',
    'connect-general-invalid',
    'legacy-connect-general',
    'legacy-connect-project',
    /**
	 * This one tricky, and I wish it was documented somewhere, so here you go:
	 * Among different Connect app types, there are global Connect apps and JSM Connect apps (project apps).
	 * The URL of the global app looks like this:
	 *   `/plugins/servlet/ac/catlassian/catlassian-page?project.key=IP&project.id=10154`
	 * The URL of the JSM project app looks like this (there is also another URL pattern, but it is not relevant to this case):
	 *   `/plugins/servlet/ac/catlassian/catlassian-page-A?project.key=IP&project.id=10154&servicedesk.serviceDeskId=31`
	 * They have different route names and differ only by the `servicedesk.serviceDeskId` query parameter.
	 * But here's the catch: the global app URL can also contain a `servicedesk.serviceDeskId` query parameter,
	 * it is enough for the user to navigate to a specific JSM route in order for that JSM project to be saved as the most recent project,
	 * and it looks like Connect adds that most recent project context to the URL.
	 * Once that happens, the global app route is no longer matched, the JSM one is, which brings a lot of confusion since at this point
	 * we have no idea whether the "Apps" section should be expanded or the "Projects" one, since it is possible the app lives in either of those.
	 * You can navigate to the JSW project in order to override the JSM one and that query param will disappear from the global app URL.
	 * So what we are doing here? We are adding the route to the list of global Connect apps (just like its route name suggests) and potentially return a false positive value.
	 * Later on in the code we are going to check whether the app is global or not based on the data we have (the list of apps) and fix that.
	 */ 'connect-general-service-desk-project',
    'connect-project'
];
const $e565dec3d2a1a779$var$CERTAIN_APPS_SECTION_ROUTES = [
    'forge-spa-global',
    'marketplace-index',
    'forge-spa-personal-settings'
];
const $e565dec3d2a1a779$export$66b32f6f30eb4b4 = new Set([
    ...$e565dec3d2a1a779$var$UNCERTAIN_APPS_SECTION_ROUTES,
    ...$e565dec3d2a1a779$var$CERTAIN_APPS_SECTION_ROUTES
]);
function $e565dec3d2a1a779$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_APPS)
    ];
    return $e565dec3d2a1a779$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e565dec3d2a1a779$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_APPS)
    ];
    return $e565dec3d2a1a779$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $e565dec3d2a1a779$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'marketplace-index':
            path.push((0, $h4Bzb.MENU_ID_APP_MARKETPLACE_DISCOVER));
            break;
        case 'connect-general':
        case 'connect-general-invalid':
        case 'forge-spa-global':
        case 'forge-spa-personal-settings':
        case 'legacy-connect-general':
            path.push((0, $h4Bzb.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
            break;
        case 'connect-project':
        case 'legacy-connect-project':
            {
                const { projectKey: projectKey } = match.params;
                return [
                    (0, $h4Bzb.MENU_ID_PROJECTS),
                    (0, $h4Bzb.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        case 'connect-general-service-desk-project':
            {
                const { projectKey: projectKey } = query;
                return [
                    (0, $h4Bzb.MENU_ID_PROJECTS),
                    (0, $h4Bzb.ENTITY_ID).PROJECT(projectKey || '')
                ];
            }
        default:
            break;
    }
    return path;
}
const $e565dec3d2a1a779$export$d017a63045c88c47 = {
    routes: $e565dec3d2a1a779$export$66b32f6f30eb4b4,
    convert: $e565dec3d2a1a779$var$convert,
    convertNew: $e565dec3d2a1a779$var$convertNew
};

});

parcelRegister("5APJC", function(module, exports) {

$parcel$export(module.exports, "assetsConverter", () => $9795614a2d6fbb83$export$6cfeba0849032a84);

var $h4Bzb = parcelRequire("h4Bzb");
const $9795614a2d6fbb83$var$routes = new Set([
    'assets',
    'assets-configure',
    'assets-data-manager-getting-started',
    'assets-data-manager-object-classes',
    'assets-data-manager-data-source',
    'assets-data-manager-object-class-view',
    'assets-object',
    'assets-schema',
    'assets-schema-configuration',
    'assets-object-type-configuration',
    'assets-reports',
    'assets-reports-default-redirect',
    'assets-reports-unsubscribe',
    'servicedesk-cmdb-assets',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration',
    'servicedesk-cmdb-assets-reports',
    'servicedesk-cmdb-assets-reports-default-redirect',
    'servicedesk-cmdb-assets-reports-unsubscribe',
    'servicedesk-cmdb-insight',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-cmdb-object-schema-configuration',
    'servicedesk-cmdb-object-type-configuration'
]);
function $9795614a2d6fbb83$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [
        (0, $h4Bzb.MENU_ID_ASSETS)
    ];
    return $9795614a2d6fbb83$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $9795614a2d6fbb83$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_ASSETS)
    ];
    return $9795614a2d6fbb83$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $9795614a2d6fbb83$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'servicedesk-cmdb-assets':
        case 'servicedesk-cmdb-object':
        case 'servicedesk-cmdb-object-schema':
        case 'servicedesk-cmdb-object-schema-configuration':
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_SCHEMAS));
            break;
        // Duplicate route-names of the above routes
        // eslint-disable-next-line no-duplicate-case
        case 'servicedesk-cmdb-object':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-schema-configuration':
        // eslint-disable-next-line no-duplicate-case, no-fallthrough
        case 'servicedesk-cmdb-object-type-configuration':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_SCHEMAS));
            break;
        case 'servicedesk-cmdb-assets-reports':
        case 'servicedesk-cmdb-assets-reports-default-redirect':
        case 'servicedesk-cmdb-assets-reports-unsubscribe':
            path.push((0, $h4Bzb.MENU_ID_ASSETS_REPORTS));
            break;
        default:
            break;
    }
    return path;
}
const $9795614a2d6fbb83$export$6cfeba0849032a84 = {
    routes: $9795614a2d6fbb83$var$routes,
    convert: $9795614a2d6fbb83$var$convert,
    convertNew: $9795614a2d6fbb83$var$convertNew
};

});

parcelRegister("bb1Lz", function(module, exports) {

$parcel$export(module.exports, "dashboardsConverter", () => $6dd0e62f793ca557$export$6468819b4be328b1);

var $h4Bzb = parcelRequire("h4Bzb");
const $6dd0e62f793ca557$var$routes = new Set([
    'dashboards-directory',
    'dashboard-edit',
    'dashboard-view',
    'dashboard-wallboard'
]);
function $6dd0e62f793ca557$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_DASHBOARDS)
    ];
    return $6dd0e62f793ca557$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6dd0e62f793ca557$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_DASHBOARDS)
    ];
    return $6dd0e62f793ca557$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $6dd0e62f793ca557$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'dashboards-directory':
            path.push((0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL));
            break;
        case 'dashboard-wallboard':
            query.dashboardId && path.push((0, $h4Bzb.ENTITY_ID).DASHBOARD(query.dashboardId));
            break;
        default:
            {
                const dashboardId = match.params.dashboardId;
                if (dashboardId === 'last-visited') // This is not really correct. The problem is we cannot tell what the true dashboardId is in this case.
                path.push((0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL));
                else dashboardId && path.push((0, $h4Bzb.ENTITY_ID).DASHBOARD(dashboardId));
                break;
            }
    }
    return path;
}
const $6dd0e62f793ca557$export$6468819b4be328b1 = {
    routes: $6dd0e62f793ca557$var$routes,
    convert: $6dd0e62f793ca557$var$convert,
    convertNew: $6dd0e62f793ca557$var$convertNew
};

});

parcelRegister("hXLQ4", function(module, exports) {

$parcel$export(module.exports, "filtersConverter", () => $54344df55ab10983$export$6e91331b5debb7c8);

var $h4Bzb = parcelRequire("h4Bzb");
const $54344df55ab10983$var$routes = new Set([
    'filters-directory',
    'global-issue-navigator',
    'global-issue-navigator-browse-issue-redirect',
    'issue',
    'legacy-gin',
    'legacy-gin-issue',
    'legacy-gin-subscriptions'
]);
function $54344df55ab10983$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query, match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_FILTERS)
    ];
    return $54344df55ab10983$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $54344df55ab10983$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_FILTERS)
    ];
    return $54344df55ab10983$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $54344df55ab10983$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'filters-directory':
            path.push((0, $h4Bzb.MENU_ID_FILTERS_VIEW_ALL));
            break;
        case 'issue':
            {
                const filterId = query.filter || query.filterId;
                if (filterId) path.push((0, $h4Bzb.ENTITY_ID).FILTER(filterId));
                else if (match.params?.issueKey) {
                    const [projectKey] = (match.params?.issueKey || '').split('-'); // For this route to match, the issueKey will never be blank
                    return [
                        (0, $h4Bzb.MENU_ID_PROJECTS),
                        (0, $h4Bzb.ENTITY_ID).PROJECT(projectKey)
                    ];
                }
                break;
            }
        default:
            {
                const filterId = query.filter || query.filterId;
                // Search filters URL
                if (filterId === undefined) path.push((0, $h4Bzb.MENU_ID_FILTERS_SEARCH));
                else // The rest of the URLs are using a filter ID.
                // Test this case: https://buglow-jsw.jira-dev.com/secure/ViewSubscriptions.jspa?filterId=10007
                path.push((0, $h4Bzb.ENTITY_ID).FILTER(filterId));
                break;
            }
    }
    return path;
}
const $54344df55ab10983$export$6e91331b5debb7c8 = {
    routes: $54344df55ab10983$var$routes,
    convert: $54344df55ab10983$var$convert,
    convertNew: $54344df55ab10983$var$convertNew
};

});

parcelRegister("gUBBs", function(module, exports) {

$parcel$export(module.exports, "operationsConverter", () => $8e03b266511d8843$export$7fc92455d5020e1);

var $7jTnu = parcelRequire("7jTnu");

var $h4Bzb = parcelRequire("h4Bzb");
const $8e03b266511d8843$var$routes = new Set([
    'eoc-automations',
    'eoc-custom-roles',
    'eoc-global-alerts',
    'eoc-global-alerts-redirect',
    'eoc-global-alert-detail',
    'eoc-global-group-detail',
    'eoc-global-reports',
    'eoc-global-report-dashboard',
    'eoc-heartbeats',
    'eoc-global-heartbeats',
    'eoc-maintenance',
    'eoc-on-call',
    'eoc-on-call-redirect',
    'eoc-overview',
    'eoc-overview-all-teams',
    'eoc-permissions',
    'eoc-reports',
    'eoc-reports-team',
    'eoc-reports-unsubscribe',
    'eoc-schedules',
    'eoc-team-alerts',
    'eoc-team-alert-detail',
    'eoc-team-alert-issue-syncing',
    'eoc-team-alert-issue-syncing-create',
    'eoc-team-alert-issue-syncing-detail',
    'eoc-team-group-detail',
    'eoc-team-integrations',
    'eoc-team-integration-create',
    'eoc-team-integration-detail',
    'eoc-team-integration-list',
    'eoc-team-integration-log',
    'eoc-team-policies',
    'eoc-who-is-on-call',
    'eoc-global-escalations'
]);
function $8e03b266511d8843$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_OPERATIONS)
    ];
    return $8e03b266511d8843$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $8e03b266511d8843$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_OPERATIONS)
    ];
    return $8e03b266511d8843$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $8e03b266511d8843$var$convertRouteToPath(args) {
    const { routeName: routeName, query: query, path: path } = args;
    switch(routeName){
        case 'eoc-who-is-on-call':
            path.push((0, $h4Bzb.MENU_ID_OPS_ON_CALL));
            break;
        case 'eoc-global-alerts':
        case 'eoc-global-alerts-redirect':
        case 'eoc-global-alert-detail':
            {
                path.push((0, $h4Bzb.MENU_ID_OPS_ALERTS));
                if ((0, $7jTnu.fg)('operations_nav4_remaining_items')) {
                    const { query: alarmQueue = '', view: view, filter: savedSearchId } = query;
                    view && path.push((0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(savedSearchId || alarmQueue));
                    break;
                }
                const { query: alarmQueue = '', view: view } = query;
                view && path.push((0, $h4Bzb.ENTITY_ID).ALARM_QUEUE(alarmQueue));
                break;
            }
        case 'eoc-global-reports':
        case 'eoc-global-report-dashboard':
        case 'eoc-reports-unsubscribe':
            path.push((0, $h4Bzb.MENU_ID_OPS_REPORTS));
            break;
        case 'eoc-automations':
        case 'eoc-global-group-detail':
        case 'eoc-heartbeats':
        case 'eoc-maintenance':
        case 'eoc-permissions':
        case 'eoc-on-call':
        case 'eoc-on-call-redirect':
        case 'eoc-overview':
        case 'eoc-overview-all-teams':
        case 'eoc-reports':
        case 'eoc-reports-team':
        case 'eoc-schedules':
        case 'eoc-team-group-detail':
        case 'eoc-team-alerts':
        case 'eoc-team-alert-detail':
        case 'eoc-team-policies':
        case 'eoc-team-alert-issue-syncing':
        case 'eoc-team-alert-issue-syncing-create':
        case 'eoc-team-alert-issue-syncing-detail':
        case 'eoc-team-integrations':
        case 'eoc-team-integration-create':
        case 'eoc-team-integration-detail':
        case 'eoc-team-integration-list':
        case 'eoc-team-integration-log':
            path.push((0, $h4Bzb.MENU_ID_OPS_OVERVIEW));
            break;
        default:
            break;
    }
    return path;
}
const $8e03b266511d8843$export$7fc92455d5020e1 = {
    routes: $8e03b266511d8843$var$routes,
    convert: $8e03b266511d8843$var$convert,
    convertNew: $8e03b266511d8843$var$convertNew
};

});

parcelRegister("7ened", function(module, exports) {

$parcel$export(module.exports, "communicationsConverter", () => $7c2dc732420a76b8$export$e136020d3142ef55);

var $h4Bzb = parcelRequire("h4Bzb");
const $7c2dc732420a76b8$var$routes = new Set([
    'communications-stakeholder-groups',
    'communications-stakeholders'
]);
function $7c2dc732420a76b8$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_COMMUNICATION)
    ];
    return $7c2dc732420a76b8$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $7c2dc732420a76b8$var$convertNew(args) {
    const { routeName: routeName, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_COMMUNICATION)
    ];
    return $7c2dc732420a76b8$var$convertRouteToPath({
        routeName: routeName,
        query: query,
        path: path
    });
}
function $7c2dc732420a76b8$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'communications-stakeholder-groups':
            path.push((0, $h4Bzb.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        case 'communications-stakeholders':
            path.push((0, $h4Bzb.MENU_ID_COMMUNICATIONS_STAKEHOLDERS));
            break;
        default:
            break;
    }
    return path;
}
const $7c2dc732420a76b8$export$e136020d3142ef55 = {
    routes: $7c2dc732420a76b8$var$routes,
    convert: $7c2dc732420a76b8$var$convert,
    convertNew: $7c2dc732420a76b8$var$convertNew
};

});

parcelRegister("kyqLB", function(module, exports) {

$parcel$export(module.exports, "topLevelConverter", () => $b77c4adb83be0f6d$export$a33f2d74a674bf8a);

var $h4Bzb = parcelRequire("h4Bzb");
const $b77c4adb83be0f6d$var$routes = new Set([
    'your-work',
    'people-index'
]);
function $b77c4adb83be0f6d$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $b77c4adb83be0f6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $b77c4adb83be0f6d$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $b77c4adb83be0f6d$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $b77c4adb83be0f6d$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'your-work':
            path.push((0, $h4Bzb.MENU_ID_YOUR_WORK));
            break;
        case 'people-index':
            path.push((0, $h4Bzb.MENU_ID_TEAMS));
            break;
        default:
    }
    return path;
}
const $b77c4adb83be0f6d$export$a33f2d74a674bf8a = {
    routes: $b77c4adb83be0f6d$var$routes,
    convert: $b77c4adb83be0f6d$var$convert,
    convertNew: $b77c4adb83be0f6d$var$convertNew
};

});

parcelRegister("3NLYz", function(module, exports) {

$parcel$export(module.exports, "overviewsConverter", () => $3ffa2483d2986bd3$export$5469f6c6536ca9c5);

var $h4Bzb = parcelRequire("h4Bzb");
const $3ffa2483d2986bd3$var$routes = new Set([
    'classic-business-overview-calendar',
    'classic-business-overview-redirect',
    'classic-business-overview-summary',
    'classic-business-overview-timeline'
]);
function $3ffa2483d2986bd3$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_OVERVIEWS)
    ];
    return $3ffa2483d2986bd3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $3ffa2483d2986bd3$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_OVERVIEWS)
    ];
    return $3ffa2483d2986bd3$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $3ffa2483d2986bd3$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    routeName;
    {
        const { overviewId: overviewId } = match.params;
        overviewId && path.push((0, $h4Bzb.ENTITY_ID).OVERVIEW(overviewId));
    }
    return path;
}
const $3ffa2483d2986bd3$export$5469f6c6536ca9c5 = {
    routes: $3ffa2483d2986bd3$var$routes,
    convert: $3ffa2483d2986bd3$var$convert,
    convertNew: $3ffa2483d2986bd3$var$convertNew
};

});

parcelRegister("eC071", function(module, exports) {

$parcel$export(module.exports, "plansConverter", () => $c10f9c452f3404f9$export$3bde637b58016d1);

var $h4Bzb = parcelRequire("h4Bzb");
const $c10f9c452f3404f9$var$routes = new Set([
    'plans-directory',
    'software-advanced-roadmaps',
    'software-advanced-roadmaps-getting-started-redirect',
    'software-advanced-roadmaps-setup',
    'software-plan-calendar',
    'software-plan-dependencies',
    'software-plan-increment',
    'software-plan-increments',
    'software-plan-releases',
    'software-plan-summary',
    'software-plan-teams',
    'software-plan-timeline',
    'trashed-plan-direct-link',
    'software-plan-upsell'
]);
function $c10f9c452f3404f9$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_PLANS)
    ];
    return $c10f9c452f3404f9$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $c10f9c452f3404f9$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_PLANS)
    ];
    return $c10f9c452f3404f9$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $c10f9c452f3404f9$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'plans-directory':
        case 'software-advanced-roadmaps-getting-started-redirect':
            path.push((0, $h4Bzb.MENU_ID_PLANS_VIEW_ALL));
            break;
        case 'trashed-plan-direct-link':
            break;
        default:
            {
                const { planId: planId } = match.params;
                planId && path.push((0, $h4Bzb.ENTITY_ID).PLAN(planId));
            }
    }
    return path;
}
const $c10f9c452f3404f9$export$3bde637b58016d1 = {
    routes: $c10f9c452f3404f9$var$routes,
    convert: $c10f9c452f3404f9$var$convert,
    convertNew: $c10f9c452f3404f9$var$convertNew
};

});

parcelRegister("3233g", function(module, exports) {

$parcel$export(module.exports, "projectsConverter", () => $9cfe72e927f4264e$export$c41b724886e5872b);

var $7jTnu = parcelRequire("7jTnu");

var $h4Bzb = parcelRequire("h4Bzb");
const $9cfe72e927f4264e$var$routes = new Set([
    'browse-project-redirect',
    'legacy-all-reports',
    'projects-directory',
    'issue-navigator',
    'issue-navigator-core',
    'project-components',
    'project-not-found',
    'project-versions',
    'software-version-detail',
    'software-version-detail-no-tab-path',
    'forge-spa-project',
    'forge-spa-project-servicedesk',
    'forge-spa-servicedesk-queue',
    'polaris-ideas',
    'polaris-onboarding',
    'opsgenie-schedule',
    'issue-navigator-classic',
    'project-pages',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-report',
    'software-backlog',
    'software-boards',
    'software-calendar',
    'software-calendar-classic',
    'classic-software-proforma-issue-forms-direct',
    'software-code',
    'software-code-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-form',
    'software-form-classic',
    'software-form-builder',
    'software-form-builder-classic',
    'software-form-submit',
    'software-form-submit-classic',
    'software-form-submit-embed',
    'software-form-submit-public',
    'software-form-submit-classic-embed',
    'software-form-submit-classic-public',
    'software-goals',
    'software-goals-classic',
    'software-incidents',
    'software-incidents-classic',
    'software-issue-navigator',
    'software-list',
    'software-list-classic',
    'software-periscope',
    'software-periscope-classic',
    'software-reports',
    'software-reports-boardless',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-cycle-time',
    'software-reports-cycle-time-classic',
    'software-reports-deployment-frequency',
    'software-reports-deployment-frequency-classic',
    'software-reports-velocity',
    'software-reports-velocity-cmp',
    'software-security',
    'software-security-classic',
    'software-summary',
    'software-summary-embed',
    'software-summary-classic',
    'software-summary-classic-embed',
    'software-timeline',
    'software-timeline-classic',
    'software-view-not-found',
    'software-view-not-found-classic',
    'software-board-view-not-found',
    'software-board-view-not-found-classic',
    'knowledge-hub-all-articles',
    'kb-article-embed-editor',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-all-categories',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-suggested-topics',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'notification-logs',
    'servicedesk-atlassian-analytics',
    'servicedesk-boards',
    'servicedesk-calendar',
    'servicedesk-project-summary',
    'servicedesk-change-calendar',
    'servicedesk-connect-project',
    'servicedesk-customers-v2',
    'servicedesk-customer-details',
    'servicedesk-customer-service-escalations',
    'servicedesk-customer-service-products',
    'servicedesk-getting-started-page',
    'servicedesk-issue',
    'servicedesk-issues',
    'servicedesk-list',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-organizations',
    'servicedesk-organization-details',
    'servicedesk-organization_v2',
    'servicedesk-queues-practice-custom-board',
    'servicedesk-queues-practice-custom-calendar',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-manage-view',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-board',
    'servicedesk-queues-custom-calendar',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-custom-issue-detail',
    'servicedesk-queues-edit',
    'servicedesk-practice-views-config',
    'servicedesk-queues-views-config',
    'servicedesk-queues-issue',
    'servicedesk-queues-manage-view',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-avp-project-dashboards-editable',
    'servicedesk-avp-project-dashboards-list',
    'servicedesk-services',
    'servicedesk-service-details',
    'classic-business-approvals',
    'classic-business-attachments',
    'classic-business-board',
    'classic-business-calendar',
    'classic-business-form',
    'classic-business-form-builder',
    'classic-business-form-submit',
    'classic-business-form-submit-public',
    'classic-business-list',
    'classic-business-shortcut',
    'classic-business-summary',
    'classic-business-timeline',
    'classic-business-view-not-found',
    'classic-business-redirect',
    'inbox',
    'inbox-classic'
]);
const $9cfe72e927f4264e$var$routesWithArchivedWorkItemsRoute = new Set($9cfe72e927f4264e$var$routes);
$9cfe72e927f4264e$var$routesWithArchivedWorkItemsRoute.add('archived-issues-directory').add('classic-business-archived-work-items').add('servicedesk-archived-work-items').add('software-archived-work-items-classic').add('software-archived-work-items');
function $9cfe72e927f4264e$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match, query: query } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_PROJECTS)
    ];
    return $9cfe72e927f4264e$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $9cfe72e927f4264e$var$convertNew(args) {
    const { routeName: routeName, match: match, query: query } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_PROJECTS)
    ];
    return $9cfe72e927f4264e$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        query: query,
        path: path
    });
}
function $9cfe72e927f4264e$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, query: query, path: path } = args;
    switch(routeName){
        case 'polaris-onboarding':
            break;
        case 'projects-directory':
            path.push((0, $h4Bzb.MENU_ID_PROJECTS_VIEW_ALL));
            break;
        case 'forge-spa-project':
        case 'forge-spa-project-servicedesk':
        case 'forge-spa-servicedesk-queue':
            {
                const { projectKey: projectKey, appId: appId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                path.push((0, $h4Bzb.MENU_ID_PROJECT_APPS));
                appId && path.push((0, $h4Bzb.ENTITY_ID).APP(appId));
                break;
            }
        case 'knowledge-hub-all-articles':
        case 'kb-article-embed-editor':
        case 'knowledge-hub-article-in-category':
        case 'knowledge-hub-browse-all-articles':
        case 'knowledge-hub-browse-all-categories':
        case 'knowledge-hub-browse-view-article':
        case 'knowledge-hub-category':
        case 'knowledge-hub-category-page':
        case 'knowledge-hub-drafts':
        case 'knowledge-hub-suggested-topics':
        case 'knowledge-hub-landing':
        case 'knowledge-hub-search':
        case 'knowledge-hub-setup':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                break;
            }
        case 'servicedesk-getting-started-page':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                break;
            }
        case 'notification-logs':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                break;
            }
        case 'servicedesk-project-summary':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                break;
            }
        case 'servicedesk-boards':
            {
                const { projectKey: projectKey, boardId: boardId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_VIEWS(projectKey));
                boardId && path.push((0, $h4Bzb.ENTITY_ID).BOARD(boardId));
                break;
            }
        case 'servicedesk-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_VIEWS(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-change-calendar':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                break;
            }
        case 'servicedesk-organizations':
        case 'servicedesk-organization-details':
        case 'servicedesk-organization_v2':
        case 'servicedesk-customers-v2':
        case 'servicedesk-customer-details':
        case 'servicedesk-customer-service-products':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                break;
            }
        case 'servicedesk-customer-service-escalations':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                break;
            }
        case 'servicedesk-kb-requests-reports':
        case 'servicedesk-kb-requests-reports-time-scale-issue':
        case 'servicedesk-kb-requests-reports-time-scale':
        case 'servicedesk-reports':
        case 'servicedesk-reports-custom':
        case 'servicedesk-reports-custom-create':
        case 'servicedesk-reports-custom-edit':
        case 'servicedesk-reports-custom-time-scale-issue':
        case 'servicedesk-reports-custom-time-scale':
        case 'servicedesk-reports-satisfaction':
        case 'servicedesk-reports-satisfaction-time-scale-issue':
        case 'servicedesk-reports-satisfaction-time-scale':
        case 'servicedesk-reports-type':
        case 'servicedesk-reports-workload':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_REPORTS(projectKey));
                break;
            }
        case 'servicedesk-avp-project-dashboards-editable':
        case 'servicedesk-avp-project-dashboards-list':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_DASHBOARDS(projectKey));
                break;
            }
        case 'servicedesk-oncall-schedule':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                break;
            }
        case 'servicedesk-issues':
            {
                const { projectKey: projectKey } = match.params;
                const filterId = query.filter || query.filterId;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                if (projectKey && filterId) {
                    path.push((0, $h4Bzb.ENTITY_ID).PROJECT_FILTERS(projectKey));
                    path.push((0, $h4Bzb.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                }
                break;
            }
        case 'servicedesk-queues-practice-custom-board':
        case 'servicedesk-queues-practice-custom-calendar':
        case 'servicedesk-practice-custom-and-issue':
        case 'servicedesk-practice-edit':
        case 'servicedesk-practice-issue':
        case 'servicedesk-practice-landing':
        case 'servicedesk-practice-manage-view':
        case 'servicedesk-practice-views-config':
        case 'servicedesk-practice-new':
            {
                const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && practiceType && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                queueId && path.push((0, $h4Bzb.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-addon':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-custom-calendar':
        case 'servicedesk-queues-custom-view':
        case 'servicedesk-queues-edit':
        case 'servicedesk-queues-issue':
        case 'servicedesk-queues-manage-view':
        case 'servicedesk-queues-views-config':
        case 'servicedesk-queues-new':
            {
                const { projectKey: projectKey, queueId: queueId } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $h4Bzb.ENTITY_ID).QUEUE(queueId));
                break;
            }
        case 'servicedesk-queues-custom-issue-detail':
            {
                const { projectKey: projectKey, queueId: queueId, issueKey: issueKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_QUEUES(projectKey));
                queueId && path.push((0, $h4Bzb.ENTITY_ID).QUEUE(queueId));
                issueKey && path.push((0, $h4Bzb.ENTITY_ID).ISSUE(issueKey));
                break;
            }
        case 'servicedesk-services':
        case 'servicedesk-service-details':
            {
                const { projectKey: projectKey } = match.params;
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT_SERVICES(projectKey));
                break;
            }
        default:
            {
                const { projectKey: projectKey, formId: formId } = match.params;
                let { boardId: boardId } = match.params;
                if ((0, $7jTnu.fg)('blu-7733-jracloud-94629-connect-tab')) {
                    const rapidViewBoard = query.rapidView ? query.rapidView : null;
                    boardId = rapidViewBoard || boardId || null;
                }
                projectKey && path.push((0, $h4Bzb.ENTITY_ID).PROJECT(projectKey));
                boardId && path.push((0, $h4Bzb.ENTITY_ID).BOARD(boardId));
                formId && path.push((0, $h4Bzb.ENTITY_ID).FORM(formId));
            }
    }
    if ((0, $7jTnu.fg)('fix-operations-menu-item-deselected-bug')) {
        const { projectKey: projectKey } = match.params;
        if ((routeName === 'servicedesk-change-calendar' || routeName === 'servicedesk-services' || routeName === 'servicedesk-service-details') && projectKey) path.push((0, $h4Bzb.ENTITY_ID).PROJECT_OPERATIONS(projectKey));
    }
    return path;
}
const $9cfe72e927f4264e$export$c41b724886e5872b = {
    get routes () {
        return (0, $7jTnu.fg)('ken_1984_archive_route_support_sidebar') ? $9cfe72e927f4264e$var$routesWithArchivedWorkItemsRoute : $9cfe72e927f4264e$var$routes;
    },
    convert: $9cfe72e927f4264e$var$convert,
    convertNew: $9cfe72e927f4264e$var$convertNew
};

});

parcelRegister("nPGhK", function(module, exports) {

$parcel$export(module.exports, "roadmapsConverter", () => $dd242add0bed8a4a$export$5761942b1e0c2dd0);

var $h4Bzb = parcelRequire("h4Bzb");
const $dd242add0bed8a4a$var$routes = new Set([
    'polaris-collections'
]);
function $dd242add0bed8a4a$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const { match: match } = routeContext;
    const path = [
        (0, $h4Bzb.MENU_ID_ROADMAPS)
    ];
    return $dd242add0bed8a4a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $dd242add0bed8a4a$var$convertNew(args) {
    const { routeName: routeName, match: match } = args;
    const path = [
        (0, $h4Bzb.MENU_ID_ROADMAPS)
    ];
    return $dd242add0bed8a4a$var$convertRouteToPath({
        routeName: routeName,
        match: match,
        path: path
    });
}
function $dd242add0bed8a4a$var$convertRouteToPath(args) {
    const { routeName: routeName, match: match, path: path } = args;
    switch(routeName){
        case 'polaris-collections':
            {
                const collectionId = match.params.collectionUUID;
                if (collectionId) path.push((0, $h4Bzb.ENTITY_ID).ROADMAP(collectionId));
                else path.push((0, $h4Bzb.MENU_ID_ROADMAPS_VIEW_ALL));
                break;
            }
        default:
    }
    return path;
}
const $dd242add0bed8a4a$export$5761942b1e0c2dd0 = {
    routes: $dd242add0bed8a4a$var$routes,
    convert: $dd242add0bed8a4a$var$convert,
    convertNew: $dd242add0bed8a4a$var$convertNew
};

});

parcelRegister("7krAP", function(module, exports) {

$parcel$export(module.exports, "serviceManagementProjectSettingsConverter", () => $7d0a8f331dc5ad04$export$dd307ede503fe0e);

var $7xaze = parcelRequire("7xaze");

var $6WtFe = parcelRequire("6WtFe");

var $iPhgi = parcelRequire("iPhgi");

var $flolB = parcelRequire("flolB");

var $9CHTy = parcelRequire("9CHTy");

var $9zBC5 = parcelRequire("9zBC5");

var $7g1XK = parcelRequire("7g1XK");

var $hCTNK = parcelRequire("hCTNK");

var $kTJYz = parcelRequire("kTJYz");

var $azYhY = parcelRequire("azYhY");

var $cX4Fw = parcelRequire("cX4Fw");

var $eaMHj = parcelRequire("eaMHj");

var $huYm9 = parcelRequire("huYm9");

var $kDkUg = parcelRequire("kDkUg");

var $9Box0 = parcelRequire("9Box0");

var $306id = parcelRequire("306id");

var $2TwJc = parcelRequire("2TwJc");

var $84Gb2 = parcelRequire("84Gb2");

var $499r8 = parcelRequire("499r8");

var $ie5KY = parcelRequire("ie5KY");

var $jUN5r = parcelRequire("jUN5r");

var $buW1x = parcelRequire("buW1x");

var $dOEVM = parcelRequire("dOEVM");

var $7B6GN = parcelRequire("7B6GN");

var $9pooG = parcelRequire("9pooG");

var $ihecD = parcelRequire("ihecD");

var $4XctI = parcelRequire("4XctI");

var $loMl1 = parcelRequire("loMl1");

var $37gZV = parcelRequire("37gZV");

var $azX7D = parcelRequire("azX7D");

var $3EnHO = parcelRequire("3EnHO");

var $cdHCV = parcelRequire("cdHCV");

var $csrcH = parcelRequire("csrcH");

var $idiiX = parcelRequire("idiiX");

var $hsEQN = parcelRequire("hsEQN");

var $jmJlK = parcelRequire("jmJlK");

var $88a5z = parcelRequire("88a5z");

var $jOpgR = parcelRequire("jOpgR");

var $h4Bzb = parcelRequire("h4Bzb");
const $7d0a8f331dc5ad04$var$routes = new Set([
    'legacy-project-settings-fields',
    'legacy-project-settings-issue-security',
    'legacy-project-settings-issue-types',
    'legacy-project-settings-notifications',
    'legacy-project-settings-people',
    'legacy-project-settings-permissions',
    'legacy-project-settings-screens',
    'legacy-project-settings-workflows',
    'legacy-project-settings-workflows-associate',
    'project-settings-automation',
    'servicedesk-sla-settings',
    (0, $flolB.projectSettingsServicedeskAutomationSummaryRoute).name,
    (0, $9CHTy.projectSettingsServicedeskAccessRoute).name,
    (0, $kTJYz.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
    (0, $kDkUg.projectSettingsServicedeskCustomerPermissionsRoute).name,
    (0, $2TwJc.projectSettingsServicedeskFeedbackRoute).name,
    (0, $84Gb2.projectSettingsServicedeskFieldsRoute).name,
    (0, $7B6GN.projectSettingsServicedeskProformaProjectFormsRoute).name,
    (0, $9pooG.projectSettingsServicedeskItsmTicketTypesConfigRoute).name,
    (0, $eaMHj.projectSettingsServicedeskChatRoute).name,
    (0, $9Box0.projectSettingsServicedeskEmailRoute).name,
    (0, $306id.projectSettingsServicedeskExternalLinksRoute).name,
    (0, $dOEVM.projectSettingsServicedeskPortalSettingsRoute).name,
    (0, $ihecD.projectSettingsServicedeskWidgetRoute).name,
    (0, $7g1XK.projectSettingsServicedeskChangeManagementRoute).name,
    (0, $499r8.projectSettingsServicedeskIncidentManagementRoute).name,
    (0, $huYm9.projectSettingsServicedeskClassicAppsRoute).name,
    (0, $hCTNK.projectSettingsServicedeskChannelsChatRoute).name,
    (0, $cX4Fw.projectSettingsServicedeskChannelsWidgetRoute).name,
    (0, $6WtFe.projectSettingsServicedeskNotificationsEmailRoute).name,
    (0, $iPhgi.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
    (0, $buW1x.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
    (0, $9zBC5.projectSettingsServicedeskAppsFieldsRoute).name,
    (0, $cdHCV.projectSettingsServicedeskCustomerNotificationsRoute).name,
    (0, $csrcH.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
    (0, $idiiX.projectSettingsServicedeskKbRoute).name,
    (0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute).name,
    (0, $88a5z.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
    (0, $jOpgR.servicedeskWorkflowConfigRoute).name,
    (0, $jUN5r.projectSettingsServicedeskIssuetypesRoute).name,
    (0, $azYhY.projectSettingsServicedeskChannelsPortalRoute).name,
    (0, $7xaze.projectSettingsServicedeskAutomationRoute).name,
    (0, $hsEQN.servicedeskSlaSettingsRoute).name,
    (0, $ie5KY.projectSettingsServicedeskInternalNotificationsNextGenRoute).name,
    (0, $loMl1.landingPageRoute).name,
    (0, $37gZV.browseConversationsRoute).name,
    (0, $azX7D.browseIntentsRoute).name,
    (0, $3EnHO.browseStandardFlowsRoute).name,
    (0, $4XctI.virtualAgentSettingsRoute).name
]);
function $7d0a8f331dc5ad04$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $7d0a8f331dc5ad04$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $7d0a8f331dc5ad04$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $7d0a8f331dc5ad04$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $7d0a8f331dc5ad04$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        // Access Menu
        case 'legacy-project-settings-people':
        case (0, $9CHTy.projectSettingsServicedeskAccessRoute).name:
        case (0, $kDkUg.projectSettingsServicedeskCustomerPermissionsRoute).name:
        case (0, $kTJYz.projectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
        case 'legacy-project-settings-permissions':
        case 'legacy-project-settings-issue-security':
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_ACCESS));
            break;
        // Request Management -> Request types menu
        case (0, $9pooG.projectSettingsServicedeskItsmTicketTypesConfigRoute).name:
        case (0, $88a5z.projectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $h4Bzb.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
            break;
        // Request Management
        case (0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute).name:
        case (0, $7B6GN.projectSettingsServicedeskProformaProjectFormsRoute).name:
        case 'legacy-project-settings-workflows':
        case (0, $jOpgR.servicedeskWorkflowConfigRoute).name:
        case 'legacy-project-settings-workflows-associate':
        case 'servicedesk-sla-settings':
        case (0, $hsEQN.servicedeskSlaSettingsRoute).name:
        case (0, $2TwJc.projectSettingsServicedeskFeedbackRoute).name:
        case 'legacy-project-settings-issue-types':
        case (0, $jUN5r.projectSettingsServicedeskIssuetypesRoute).name:
        case 'legacy-project-settings-fields':
        case (0, $84Gb2.projectSettingsServicedeskFieldsRoute).name:
        case 'legacy-project-settings-screens':
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
            break;
        // Automation
        case 'project-settings-automation':
        case (0, $flolB.projectSettingsServicedeskAutomationSummaryRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_AUTOMATION));
            break;
        // Channels and self-service
        case (0, $dOEVM.projectSettingsServicedeskPortalSettingsRoute).name:
        case (0, $azYhY.projectSettingsServicedeskChannelsPortalRoute).name:
        case (0, $9Box0.projectSettingsServicedeskEmailRoute).name:
        case (0, $eaMHj.projectSettingsServicedeskChatRoute).name:
        case (0, $ihecD.projectSettingsServicedeskWidgetRoute).name:
        case (0, $idiiX.projectSettingsServicedeskKbRoute).name:
        case (0, $306id.projectSettingsServicedeskExternalLinksRoute).name:
        case (0, $hCTNK.projectSettingsServicedeskChannelsChatRoute).name:
        case (0, $cX4Fw.projectSettingsServicedeskChannelsWidgetRoute).name:
        case (0, $4XctI.virtualAgentSettingsRoute).name:
        case (0, $loMl1.landingPageRoute).name:
        case (0, $37gZV.browseConversationsRoute).name:
        case (0, $azX7D.browseIntentsRoute).name:
        case (0, $3EnHO.browseStandardFlowsRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
            break;
        // Operations
        case (0, $7g1XK.projectSettingsServicedeskChangeManagementRoute).name:
        case (0, $499r8.projectSettingsServicedeskIncidentManagementRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_OPERATIONS));
            break;
        // Notifications
        case 'legacy-project-settings-notifications':
        case (0, $cdHCV.projectSettingsServicedeskCustomerNotificationsRoute).name:
        case (0, $buW1x.projectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
        case (0, $csrcH.projectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
        case (0, $6WtFe.projectSettingsServicedeskNotificationsEmailRoute).name:
        case (0, $iPhgi.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
        case (0, $ie5KY.projectSettingsServicedeskInternalNotificationsNextGenRoute).name:
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
            break;
        // Apps
        case (0, $huYm9.projectSettingsServicedeskClassicAppsRoute).name:
        case (0, $9zBC5.projectSettingsServicedeskAppsFieldsRoute).name:
            // ADD rest of the apps here
            path.push((0, $h4Bzb.MENU_ID_SD_SETTINGS_APPS));
            break;
        default:
            break;
    }
    return path;
}
const $7d0a8f331dc5ad04$export$dd307ede503fe0e = {
    routes: $7d0a8f331dc5ad04$var$routes,
    convert: $7d0a8f331dc5ad04$var$convert,
    convertNew: $7d0a8f331dc5ad04$var$convertNew
};

});
parcelRegister("7xaze", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", () => $74c18d3f7e20f44d$export$1a2228d5e07202a0);
const $74c18d3f7e20f44d$export$1a2228d5e07202a0 = {
    name: 'project-settings-automation',
    path: '/jira/servicedesk/projects/:projectKey/settings/automate'
};

});

parcelRegister("6WtFe", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", () => $dd3281251f67d1d8$export$1f37a1aff4f594af);
const $dd3281251f67d1d8$export$1f37a1aff4f594af = {
    name: 'project-settings-servicedesk-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
    exact: true
};

});

parcelRegister("iPhgi", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", () => $e2d116eeed869549$export$40539cb16771014e);
const $e2d116eeed869549$export$40539cb16771014e = {
    name: 'project-settings-servicedesk-notifications-notification-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/notification-email',
    exact: true
};

});

parcelRegister("flolB", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAutomationSummaryRoute", () => $e924041ee9cf8148$export$165d82a2618e4d99);
const $e924041ee9cf8148$export$165d82a2618e4d99 = {
    name: 'project-settings-servicedesk-automation-summary',
    path: '/jira/servicedesk/projects/:projectKey/settings/automation'
};

});

parcelRegister("9CHTy", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAccessRoute", () => $494393447df36998$export$6473a81f1ee460ef);
const $494393447df36998$export$6473a81f1ee460ef = {
    name: 'project-settings-servicedesk-access',
    path: '/jira/servicedesk/projects/:projectKey/settings/access',
    exact: true
};

});

parcelRegister("9zBC5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskAppsFieldsRoute", () => $7eac910e270d98a7$export$bb46672b3fb14eec);
const $7eac910e270d98a7$export$bb46672b3fb14eec = {
    name: 'project-settings-servicedesk-apps-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps/app-fields',
    exact: true
};

});

parcelRegister("7g1XK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChangeManagementRoute", () => $852fc1870396df0f$export$1444ee3eb63a2ffc);
const $852fc1870396df0f$export$1444ee3eb63a2ffc = {
    name: 'project-settings-servicedesk-change-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/change-management',
    exact: true
};

});

parcelRegister("hCTNK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsChatRoute", () => $cf62c7fefbad1b1f$export$be5ad475040cd044);
const $cf62c7fefbad1b1f$export$be5ad475040cd044 = {
    name: 'project-settings-servicedesk-channels-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/chat',
    exact: true
};

});

parcelRegister("kTJYz", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPermissionsNextGenRoute", () => $f1625153a3fc4be1$export$5fb39a9d3820886c);
const $f1625153a3fc4be1$export$5fb39a9d3820886c = {
    name: 'project-settings-servicedesk-channels-permissions-next-gen',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/customer-permissions',
    exact: true
};

});

parcelRegister("azYhY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsPortalRoute", () => $bf04ae1978c865f7$export$8f4234e4e79e03);
const $bf04ae1978c865f7$export$8f4234e4e79e03 = {
    name: 'project-settings-servicedesk-channels-portal',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/portal-settings',
    exact: true
};

});

parcelRegister("cX4Fw", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChannelsWidgetRoute", () => $bbc98215303aabc7$export$c66db54872d3b51c);
const $bbc98215303aabc7$export$c66db54872d3b51c = {
    name: 'project-settings-servicedesk-channels-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/channels/widget',
    exact: true
};

});

parcelRegister("eaMHj", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskChatRoute", () => $db76c9323340b2b3$export$b22ac188582d1dbd);
const $db76c9323340b2b3$export$b22ac188582d1dbd = {
    name: 'project-settings-servicedesk-chat',
    path: '/jira/servicedesk/projects/:projectKey/settings/chat',
    exact: true
};

});

parcelRegister("huYm9", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskClassicAppsRoute", () => $9871f373036dc5dd$export$2b65324bb87228c5);
const $9871f373036dc5dd$export$2b65324bb87228c5 = {
    name: 'project-settings-servicedesk-classic-apps',
    path: '/jira/servicedesk/projects/:projectKey/settings/apps',
    exact: true
};

});

parcelRegister("kDkUg", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerPermissionsRoute", () => $9ff9cc4235e57156$export$d8ed4a1eb0c01b5a);
const $9ff9cc4235e57156$export$d8ed4a1eb0c01b5a = {
    name: 'project-settings-servicedesk-customer-permissions',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-permissions',
    exact: true
};

});

parcelRegister("9Box0", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskEmailRoute", () => $cc88ee571b3cf336$export$d7d111417bfcd900);
const $cc88ee571b3cf336$export$d7d111417bfcd900 = {
    name: 'project-settings-servicedesk-email',
    path: '/jira/servicedesk/projects/:projectKey/settings/email',
    exact: true
};

});

parcelRegister("306id", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskExternalLinksRoute", () => $e5f40259a6056a55$export$2ec1a0d49a1f6ac2);
const $e5f40259a6056a55$export$2ec1a0d49a1f6ac2 = {
    name: 'project-settings-servicedesk-external-links',
    path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
    exact: true
};

});

parcelRegister("2TwJc", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFeedbackRoute", () => $a927b1b6a51288e0$export$f21485e31d7839aa);
const $a927b1b6a51288e0$export$f21485e31d7839aa = {
    name: 'project-settings-servicedesk-feedback',
    path: '/jira/servicedesk/projects/:projectKey/settings/feedback-settings'
};

});

parcelRegister("84Gb2", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskFieldsRoute", () => $c2df9347b08a45ce$export$44f665a50373c681);
const $c2df9347b08a45ce$export$44f665a50373c681 = {
    name: 'project-settings-servicedesk-fields',
    path: '/jira/servicedesk/projects/:projectKey/settings/fields',
    exact: true
};

});

parcelRegister("499r8", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIncidentManagementRoute", () => $2fa916512590f19d$export$f91bd0bb0d4783ff);
const $2fa916512590f19d$export$f91bd0bb0d4783ff = {
    name: 'project-settings-servicedesk-incident-management',
    path: '/jira/servicedesk/projects/:projectKey/settings/incident-management',
    exact: true
};

});

parcelRegister("ie5KY", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskInternalNotificationsNextGenRoute", () => $b1e3a423a8f43b26$export$5db62792327950b4);
const $b1e3a423a8f43b26$export$5db62792327950b4 = {
    name: 'project-settings-servicedesk-internal-notifications-nextGen',
    path: '/jira/servicedesk/projects/:projectKey/settings/internal-notifications'
};

});

parcelRegister("jUN5r", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskIssuetypesRoute", () => $855f65ce7afe991a$export$2ffcb2e92bb4950b);
const $855f65ce7afe991a$export$2ffcb2e92bb4950b = {
    name: 'project-settings-servicedesk-issuetypes',
    path: '/jira/servicedesk/projects/:projectKey/settings/issuetypes/:issueTypeId?',
    exact: true
};

});

parcelRegister("buW1x", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsInternalNotificationsRoute", () => $691e3ad540e16e7f$export$5108e41f558ecf03);
const $691e3ad540e16e7f$export$5108e41f558ecf03 = {
    name: 'project-settings-servicedesk-notifications-internal-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/internal-notifications'
};

});

parcelRegister("dOEVM", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskPortalSettingsRoute", () => $0a55881c22b9f361$export$7593a7e4a6fc0aaf);
const $0a55881c22b9f361$export$7593a7e4a6fc0aaf = {
    name: 'project-settings-servicedesk-portal-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/portal-settings/:subPath(portal-groups)?',
    exact: true
};

});

parcelRegister("7B6GN", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskProformaProjectFormsRoute", () => $692ad077baa2d08a$export$ee87e5f9754e3600);
const $692ad077baa2d08a$export$ee87e5f9754e3600 = {
    name: 'project-settings-servicedesk-proforma-project-forms',
    path: '/jira/servicedesk/projects/:projectKey/settings/forms',
    exact: true
};

});

parcelRegister("9pooG", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskItsmTicketTypesConfigRoute", () => $360e2c2f6b3ef4cd$export$52596d9b432829c);
const $360e2c2f6b3ef4cd$export$52596d9b432829c = {
    exact: true,
    name: 'project-settings-servicedesk-itsm-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/category/:practice'
};

});

parcelRegister("ihecD", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskWidgetRoute", () => $ebdcd6c0fa97846d$export$ac674ffd39608325);
const $ebdcd6c0fa97846d$export$ac674ffd39608325 = {
    name: 'project-settings-servicedesk-widget',
    path: '/jira/servicedesk/projects/:projectKey/settings/widget',
    exact: true
};

});

parcelRegister("4XctI", function(module, exports) {

$parcel$export(module.exports, "virtualAgentSettingsRoute", () => $10f406c20ca6a562$export$80422a49e17dfd6b);
const $10f406c20ca6a562$export$80422a49e17dfd6b = {
    name: 'project-settings-servicedesk-virtual-agent-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
    exact: true
};

});

parcelRegister("loMl1", function(module, exports) {

$parcel$export(module.exports, "landingPageRoute", () => $a59bf5c45457fa62$export$8c051c399fd812a5);
const $a59bf5c45457fa62$export$8c051c399fd812a5 = {
    // We name this virtualagentonboarding without the "-" as otherwise it would trigger
    // the nesting stack, which we don't want for onboarding
    name: 'project-settings-servicedesk-virtualagentonboarding',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent'
};

});

parcelRegister("37gZV", function(module, exports) {

$parcel$export(module.exports, "browseConversationsRoute", () => $ceaa8b7bf0ef893e$export$c8ff4cf64e5540ec);
const $ceaa8b7bf0ef893e$export$c8ff4cf64e5540ec = {
    name: 'project-settings-servicedesk-virtualagent-browseconversations',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/conversations'
};

});

parcelRegister("azX7D", function(module, exports) {

$parcel$export(module.exports, "browseIntentsRoute", () => $2161d9d9dd4bb376$export$3e227412713bc57f);
const $2161d9d9dd4bb376$export$3e227412713bc57f = {
    name: 'project-settings-servicedesk-virtualagent-browse-intents',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents'
};

});

parcelRegister("3EnHO", function(module, exports) {

$parcel$export(module.exports, "browseStandardFlowsRoute", () => $5947d66ca945bddb$export$fd091ba8fa858397);
const $5947d66ca945bddb$export$fd091ba8fa858397 = {
    name: 'project-settings-servicedesk-virtualagent-standard-flows',
    exact: true,
    path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows'
};

});

parcelRegister("cdHCV", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskCustomerNotificationsRoute", () => $3097aecf5b1470cb$export$176d388c5b23978e);
const $3097aecf5b1470cb$export$176d388c5b23978e = {
    name: 'project-settings-servicedesk-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/customer-notifications'
};

});

parcelRegister("csrcH", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskNotificationsCustomerNotificationsRoute", () => $825ea2891dbc89b5$export$6ce57d409e1934f2);
const $825ea2891dbc89b5$export$6ce57d409e1934f2 = {
    name: 'project-settings-servicedesk-notifications-customer-notifications',
    path: '/jira/servicedesk/projects/:projectKey/settings/notifications/customer-notifications'
};

});

parcelRegister("idiiX", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskKbRoute", () => $552f05c4b16ed42f$export$725fadff9ae82302);
const $552f05c4b16ed42f$export$725fadff9ae82302 = {
    name: 'project-settings-servicedesk-kb',
    path: '/jira/servicedesk/projects/:projectKey/settings/confluence-kb',
    exact: true
};

});

parcelRegister("hsEQN", function(module, exports) {

$parcel$export(module.exports, "servicedeskSlaSettingsRoute", () => $e9bc452ea345b3c1$export$bfbf66468910573e);
const $e9bc452ea345b3c1$export$bfbf66468910573e = {
    name: 'servicedesk-sla-settings',
    path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
};

});

parcelRegister("jmJlK", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskTicketTypesConfigRoute", () => $439c11180176b27d$export$31f95ad4356ce017);
const $439c11180176b27d$export$31f95ad4356ce017 = {
    exact: true,
    name: 'project-settings-servicedesk-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types'
};

});

parcelRegister("88a5z", function(module, exports) {

$parcel$export(module.exports, "projectSettingsServicedeskUnassignedTicketTypesConfigRoute", () => $69c1533799a2149a$export$8c897f53ff36fa6b);
const $69c1533799a2149a$export$8c897f53ff36fa6b = {
    exact: true,
    name: 'project-settings-servicedesk-unassigned-ticket-types-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned'
};

});

parcelRegister("jOpgR", function(module, exports) {

$parcel$export(module.exports, "servicedeskWorkflowConfigRoute", () => $7521baf68ef87a51$export$ecc771c0ee86ccb8);
const $7521baf68ef87a51$export$ecc771c0ee86ccb8 = {
    name: 'project-settings-servicedesk-workflow-scheme-config',
    path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
    exact: true
};

});


parcelRegister("6ofXP", function(module, exports) {

$parcel$export(module.exports, "customerServiceConverter", () => $2cdb1f0dd4092ebc$export$8e632ccd3e33c9f1);

var $7jTnu = parcelRequire("7jTnu");

var $h4Bzb = parcelRequire("h4Bzb");
const $2cdb1f0dd4092ebc$var$routes = new Set([
    'customer-service-helpcenter'
]);
function $2cdb1f0dd4092ebc$var$convert(routeContext) {
    const routeName = routeContext.route.name;
    const path = [];
    return $2cdb1f0dd4092ebc$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $2cdb1f0dd4092ebc$var$convertNew(args) {
    const { routeName: routeName } = args;
    const path = [];
    return $2cdb1f0dd4092ebc$var$convertRouteToPath({
        routeName: routeName,
        path: path
    });
}
function $2cdb1f0dd4092ebc$var$convertRouteToPath(args) {
    const { routeName: routeName, path: path } = args;
    switch(routeName){
        case 'customer-service-helpcenter':
            path.push((0, $7jTnu.fg)('jcs_project_type_m3') ? (0, $h4Bzb.MENU_ID_CUSTOMER_HUBS) : (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE));
            break;
        default:
    }
    return path;
}
const $2cdb1f0dd4092ebc$export$8e632ccd3e33c9f1 = {
    routes: $2cdb1f0dd4092ebc$var$routes,
    convert: $2cdb1f0dd4092ebc$var$convert,
    convertNew: $2cdb1f0dd4092ebc$var$convertNew
};

});



parcelRegister("b1DBy", function(module, exports) {

$parcel$export(module.exports, "isSelectedPath", () => $7fd392c392ccabb1$export$cdcd6885320eec31);

var $aLENQ = parcelRequire("aLENQ");
function $7fd392c392ccabb1$export$cdcd6885320eec31(path, ...args) {
    const next = (menuId)=>{
        return (0, $aLENQ.isMenuIdList)(menuId) ? (0, $aLENQ.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
    };
    if (args.length === 0) return next;
    return next(args[0]);
}

});
parcelRegister("aLENQ", function(module, exports) {

$parcel$export(module.exports, "toMenuIdFromMenuIdList", () => $d932814a3842588f$export$253323efd0c41e72);
$parcel$export(module.exports, "isMenuIdList", () => $d932814a3842588f$export$abdb8aa7ce9ed1ed);
$parcel$export(module.exports, "toMenuIdList", () => $d932814a3842588f$export$d8e017f58178e379);
const $d932814a3842588f$var$MENU_ID_DELIM = '   '; // Three spaces
function $d932814a3842588f$export$253323efd0c41e72(menuIds) {
    return menuIds.join($d932814a3842588f$var$MENU_ID_DELIM);
}
function $d932814a3842588f$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
    return maybeMenuIdList.indexOf($d932814a3842588f$var$MENU_ID_DELIM) !== -1;
}
function $d932814a3842588f$export$d8e017f58178e379(menuIdList) {
    return menuIdList.split($d932814a3842588f$var$MENU_ID_DELIM);
}

});


parcelRegister("9FYIg", function(module, exports) {

$parcel$export(module.exports, "RELAY_RESOURCE_TYPE", () => $f6c4de4a04897ac4$export$c6c8c12c0f1d8e54);
$parcel$export(module.exports, "createRelayResource", () => $f6c4de4a04897ac4$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $f6c4de4a04897ac4$export$42ca7b248c7aaee);

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");

var $6uWhG = parcelRequire("6uWhG");

var $7zZ4w = parcelRequire("7zZ4w");

var $g1oKu = parcelRequire("g1oKu");

var $7797X = parcelRequire("7797X");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $jHI6h = parcelRequire("jHI6h");
const $f6c4de4a04897ac4$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
const $f6c4de4a04897ac4$var$getData = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
    const measureName = `relay_resource_get_data:${type}`;
    const startMark = `relay_resource_get_data:${type}:start`;
    const endMark = `relay_resource_get_data:${type}:end`;
    (0, $6uWhG.setMark)(startMark);
    const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
    // loadQuery returns not a Promise, but Observable.
    // Resource waits until query Observable is completed and returns a queryReference
    // later queryReference could be used by usePreloadedQuery
    const queryReference = (0, $6uWhG.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $j4oe4.loadQuery)((0, $7zZ4w.default)(), parameters, variables || {}, options));
    if (false && queryReference.id != null) {
        const promise = (0, $7797X.QueryPromisesMap).get(queryReference.id);
        if (promise) return promise.then(()=>{
            (0, $6uWhG.setMark)(endMark);
            (0, $6uWhG.setMeasure)(measureName, startMark, endMark);
            /**
				 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
				 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
				 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
				 * as well as subsequent fetches made by route transitions between spa-apps.
				 */ if (captureErrors) (0, $g1oKu.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
            if (captureTraceIds) (0, $jHI6h.startCapturingTraceIds)(queryReference.name);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return queryReference;
        });
    }
    if (queryReference.id != null) (0, $7797X.QueryPromisesMap).get(queryReference.id)?.then(()=>{
        (0, $6uWhG.setMark)(endMark);
        (0, $6uWhG.setMeasure)(measureName, startMark, endMark);
    });
    /**
	 * We want to store HTTP codes from fetch response so that we can use it to report SLA correctly.
	 * (Unfortunately errors thrown by relay client validation doesn't include HTTP codes at the moment, so we have to store it ourselves)
	 * Starting to capture errors here ensures we capture errors for the early fetch of the query on initial page load,
	 * as well as subsequent fetches made by route transitions between spa-apps.
	 */ if (captureErrors) (0, $g1oKu.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
    if (captureTraceIds) (0, $jHI6h.startCapturingTraceIds)(queryReference.name);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return queryReference;
};
const $f6c4de4a04897ac4$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $l1VxS.createResource)({
        type: `${$f6c4de4a04897ac4$export$c6c8c12c0f1d8e54}_${type}`,
        getKey: (routerContext, customContext)=>{
            const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
            // When providing an async query via `loadParameters` instead of getQuery's config, the query ID is not known upfront and so cannot be contributed to the resource key
            if (!preloadableRequest) return JSON.stringify(variables || {});
            let queryId;
            let params;
            // sources: https://github.com/facebook/relay/blob/4b78c7dd27b286f9ee8f5b993ccb160163956999/packages/react-relay/relay-hooks/loadQuery.js#L273
            // @ts-expect-error - TS2339 - Property 'kind' does not exist on type 'GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>'.
            if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                const preloadableConcreteRequest = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                preloadableRequest;
                ({ params: params } = preloadableConcreteRequest);
                ({ id: queryId } = params);
            } else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const graphQlTaggedNode = preloadableRequest;
                const request = (0, $37Ewn.getRequest)(graphQlTaggedNode);
                params = request.params;
                queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            }
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            return $f6c4de4a04897ac4$var$getData({
                routerContext: routerContext,
                customContext: customContext,
                type: type,
                getQuery: getQuery,
                captureErrors: captureErrors,
                captureTraceIds: captureTraceIds
            });
        },
        maxAge: 0,
        isBrowserOnly: isBrowserOnly
    });
const $f6c4de4a04897ac4$export$1cc887c62079ea32 = $f6c4de4a04897ac4$var$createRelayResourceImpl;
const $f6c4de4a04897ac4$export$bbe949b85c06f763 = $f6c4de4a04897ac4$var$createRelayResourceImpl;
const $f6c4de4a04897ac4$export$42ca7b248c7aaee = (resource, options)=>{
    const { data: queryReference, loading: loading, promise: promise } = (0, $eJrcF.useResource)(resource);
    if (options?.suspendWhenLoading && loading) throw promise;
    return {
        queryReference: queryReference
    };
};

});

parcelRegister("bBIDB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c207eec2783a5a9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af5c5c60aad0447f7acc8aecd166d3c6>>
 * @relayHash bf2661491690007d60fd7741160e29de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5f2bc29cc2c8d92d51002371cc1a1a42592b5893c9cf605830e5d5e0cabf8fa

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $l5K2d = parcelRequire("l5K2d");

var $5moL7 = parcelRequire("5moL7");

var $7m7yY = parcelRequire("7m7yY");

var $lhtKZ = parcelRequire("lhtKZ");

var $jhhgp = parcelRequire("jhhgp");

var $eSxxM = parcelRequire("eSxxM");

var $em6ga = parcelRequire("em6ga");

var $eEnEt = parcelRequire("eEnEt");
const $9c207eec2783a5a9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = [
        v11 /*: any*/ 
    ], v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "label"
    }, v15 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v16 = {
        "kind": "ScalarField",
        "name": "url"
    }, v17 = {
        "order": "DESC"
    }, v18 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v20 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v21 = {
        "kind": "ScalarField",
        "name": "status"
    }, v22 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v23 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "name"
    }, v25 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v27 = [
        v16 /*: any*/ 
    ], v28 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v29 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v27 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v28 /*: any*/ 
        ]
    }, v30 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v31 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v32 = {
        "alias": "editProjectConfig",
        "args": v30 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v31 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v33 = {
        "args": v30 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v31 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v34 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v35 = {
        "alias": "editPermission",
        "args": v30 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v31 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v36 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v37 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ], v38 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
        "kind": "Condition",
        "passingValue": false,
        "selections": v37 /*: any*/ 
    }, v39 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": v37 /*: any*/ 
    }, v40 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v37 /*: any*/ 
    }, v41 = [
        v10 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ ,
        v22 /*: any*/ ,
        v23 /*: any*/ ,
        v24 /*: any*/ ,
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v29 /*: any*/ ,
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ 
    ], v42 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v43 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v44 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v41 /*: any*/ 
            }
        ]
    }, v45 = [
        v44 /*: any*/ ,
        v42 /*: any*/ 
    ], v46 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v47 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v48 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v10 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v49 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v13 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v26 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v27 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v28 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v28 /*: any*/ 
            ]
        }
    ], v50 = [
        v10 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ConfigurableMenuItems"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "L1MenuItemsQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudID",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "navKey",
                                            "value": "NAV_SIDEBAR"
                                        }
                                    ],
                                    "concreteType": "JiraUserNavigationConfiguration",
                                    "kind": "LinkedField",
                                    "name": "userNavigationConfiguration",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraConfigurableNavigationItem",
                                            "kind": "LinkedField",
                                            "name": "navItems",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "menuId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVisible"
                                                }
                                            ]
                                        },
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isProjectsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsProjectsExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canCreateProject",
                                    "args": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "CREATE_PROJECT"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "shouldDisplay",
                                            "args": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                                                }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isFiltersExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsFiltersExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isAppsExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "globalAppNavigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appType"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        },
                                                                        v15 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ ,
                                                                                        v16 /*: any*/ ,
                                                                                        v15 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "settingsUrl"
                                                                        },
                                                                        v16 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isPlansExpanded",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": "hasIsPlansExpanded",
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                },
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "JiraAdvancedRoadmapsNavigation",
                                    "kind": "LinkedField",
                                    "name": "advancedRoadmapsNavigation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasEditPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasCreateSamplePlanPermissions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasGlobalPlansAdminPermissions"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraWorkManagementLicensing",
                                            "kind": "LinkedField",
                                            "name": "jwmLicensing",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "currentUserSeatEdition"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "favouriteProjects",
                                                    "args": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "sort": v17 /*: any*/ ,
                                                                "type": "PROJECT"
                                                            }
                                                        },
                                                        v18 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraFavouriteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "favourites",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraFavouriteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v41 /*: any*/ ,
                                                                            "type": "JiraProject"
                                                                        },
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v42 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        v11 /*: any*/ ,
                                                        v43 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "recentProjects",
                                                    "plural": false,
                                                    "selections": v45 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GrowthRecQuery",
                                                    "kind": "LinkedField",
                                                    "name": "growthRecommendations",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "fields": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "product",
                                                                            "value": "jira"
                                                                        },
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "tenantId",
                                                                            "variableName": "cloudId"
                                                                        },
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "useCase",
                                                                            "value": "jiraProjectMenuRecommendations"
                                                                        }
                                                                    ],
                                                                    "kind": "ObjectValue",
                                                                    "name": "context"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 2
                                                                }
                                                            ],
                                                            "kind": "LinkedField",
                                                            "name": "recommendations",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v13 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "entityId"
                                                                                        }
                                                                                    ],
                                                                                    "type": "GrowthRecJiraTemplateRecommendation"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "GrowthRecRecommendations"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "entityAri",
                                                            "variableName": "entityAriProjects"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "ownerAri",
                                                            "variableName": "ownerAri"
                                                        }
                                                    ],
                                                    "concreteType": "SettingsNavigationCustomisation",
                                                    "kind": "LinkedField",
                                                    "name": "settings_navigationCustomisation",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "SettingsDisplayPropertyConnection",
                                                            "kind": "LinkedField",
                                                            "name": "properties",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SettingsDisplayProperty",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "key"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraProjectsSidebarMenu",
                                            "kind": "LinkedField",
                                            "name": "jira_projectsSidebarMenu",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "mostRecent",
                                                    "plural": false,
                                                    "selections": v41 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "mostRecentFromHistory",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v29 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v35 /*: any*/ ,
                                                        v36 /*: any*/ ,
                                                        v38 /*: any*/ ,
                                                        v39 /*: any*/ ,
                                                        v40 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        v18 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "favourites",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v42 /*: any*/ 
                                                    ],
                                                    "storageKey": "favourites(first:15)"
                                                },
                                                {
                                                    "args": [
                                                        v43 /*: any*/ 
                                                    ],
                                                    "concreteType": "JiraProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "recents",
                                                    "plural": false,
                                                    "selections": v45 /*: any*/ ,
                                                    "storageKey": "recents(first:20)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasMore"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouriteLimit"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "recentLimit"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayMode"
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteFilters",
                                            "args": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v17 /*: any*/ ,
                                                        "type": "FILTER"
                                                    }
                                                },
                                                v18 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v42 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentFilters",
                                            "args": [
                                                v11 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "FILTER"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v24 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v26 /*: any*/ ,
                                                                                v47 /*: any*/ ,
                                                                                v48 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraFilter",
                                                                            "abstractKey": "__isJiraFilter"
                                                                        }
                                                                    ],
                                                                    "type": "JiraCustomFilter"
                                                                },
                                                                v28 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v42 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraSystemFilterConnection",
                                            "kind": "LinkedField",
                                            "name": "systemFilters",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilterEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSystemFilter",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v46 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": "favouritePlans",
                                            "args": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v17 /*: any*/ ,
                                                        "type": "PLAN"
                                                    }
                                                },
                                                v18 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v49 /*: any*/ 
                                                },
                                                v42 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "recentPlans",
                                            "args": [
                                                v11 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "types",
                                                    "value": [
                                                        "PLAN"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "JiraSearchableEntityConnection",
                                            "kind": "LinkedField",
                                            "name": "recentItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSearchableEntityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v49 /*: any*/ 
                                                },
                                                v42 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isOperationsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "OpsgenieQuery",
                                    "kind": "LinkedField",
                                    "name": "opsgenie",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "OpsgenieSavedSearches",
                                            "kind": "LinkedField",
                                            "name": "savedSearches",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "sharedWithMe",
                                                    "plural": true,
                                                    "selections": v50 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "OpsgenieSavedSearch",
                                                    "kind": "LinkedField",
                                                    "name": "createdByMe",
                                                    "plural": true,
                                                    "selections": v50 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isOverviewsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v12 /*: any*/ ,
                                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                            "kind": "LinkedField",
                                            "name": "jwmOverviews",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraWorkManagementGiraOverview",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v10 /*: any*/ ,
                                                                v24 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f5f2bc29cc2c8d92d51002371cc1a1a42592b5893c9cf605830e5d5e0cabf8fa",
            "metadata": {},
            "name": "L1MenuItemsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $l5K2d.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $7m7yY.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $em6ga.default)
            }
        }
    };
}();
$9c207eec2783a5a9$var$node.hash = "fffe23a56118d84dd30e01387c939a22";
var $9c207eec2783a5a9$export$2e2bcd8739ae039 = $9c207eec2783a5a9$var$node;

});
parcelRegister("9zQGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d4cac831a774767$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $4d4cac831a774767$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
    }
};

});

parcelRegister("dtG0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $63f7d731301be654$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $63f7d731301be654$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('blu-6315-display-settings-a-part-1', 'isEnabled', false);
    }
};

});

parcelRegister("cli8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4603c488541d3d8$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $d4603c488541d3d8$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false);
    }
};

});

parcelRegister("l5K2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef97bb84d17cf29$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $3ef97bb84d17cf29$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('blu-7436-separate-growth-rec');
    }
};

});

parcelRegister("5moL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6adb616ba86c8a9a$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $6adb616ba86c8a9a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('blu-8022_refactor_jpd_project_menu_to_common');
    }
};

});

parcelRegister("7m7yY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c894ab891a883b9$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $7jTnu = parcelRequire("7jTnu");
var $7c894ab891a883b9$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended');
    }
};

});

parcelRegister("lhtKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a53aade22d0a15d3$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $a53aade22d0a15d3$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jcs_project_type_m3');
    }
};

});

parcelRegister("jhhgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d2e2844d6132da$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $27d2e2844d6132da$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('allow_end_users_to_access_custom_templates');
    }
};

});

parcelRegister("eSxxM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f962c415abaf11a$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $6f962c415abaf11a$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jsm_aiiy_for_nav_item_sidebar');
    }
};

});

parcelRegister("em6ga", function(module, exports) {

$parcel$export(module.exports, "default", () => $db0bf42d04d7e409$export$2e2bcd8739ae039);
// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>

var $7jTnu = parcelRequire("7jTnu");
var $db0bf42d04d7e409$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('project-actions-sync-iv-llc');
    }
};

});

parcelRegister("eEnEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb512a18f102874$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");
var $7cb512a18f102874$export$2e2bcd8739ae039 = {
    get () {
        return (0, $epTsa.expVal)('blu-6987-display-settings-post-ga-experiment', 'isEnabled', false) || (0, $epTsa.expVal)('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false);
    }
};

});


parcelRegister("hOoYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c09a8bcbde12b5a5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5115ff33a71779ea2998875f4e37eb58>>
 * @relayHash 2166d8d37d2e3ef4bf77f06d60ad7574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3
const $c09a8bcbde12b5a5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v3 = {
        "kind": "ScalarField",
        "name": "leftSidebarWidth"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarSelectorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b9bc3c19d8a70692e667edf5f8ab33de07cbacfb0efd83cfedbe8b4e1690d6c3",
            "metadata": {},
            "name": "sidebarSelectorQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c09a8bcbde12b5a5$var$node.hash = "87261aab5010f6e217d4869107282805";
var $c09a8bcbde12b5a5$export$2e2bcd8739ae039 = $c09a8bcbde12b5a5$var$node;

});

parcelRegister("fKh2A", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAri", () => $b7685ed214380de6$export$d53f27b41a9a02bb);

var $02tnb = parcelRequire("02tnb");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/navigation-settings/manifest.ts
var $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $02tnb.JiraNavigationSettingsAriResourceOwner),
    resourceType: (0, $02tnb.JiraNavigationSettingsAriResourceType),
    resourceIdSlug: "activation/{activationId}/{navigationSettingScope}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        navigationSettingScope: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/navigation-settings/index.ts
var $b7685ed214380de6$export$d53f27b41a9a02bb = class _JiraNavigationSettingsAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._navigationSettingScope = opts.resourceIdSegmentValues.navigationSettingScope;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get navigationSettingScope() {
        return this._navigationSettingScope;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.qualifier,
            platformQualifier: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.resourceOwner,
            resourceType: $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.navigationSettingScope}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                navigationSettingScope: opts.navigationSettingScope
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $b7685ed214380de6$var$jiraNavigationSettingsAriStaticOpts);
        return new _JiraNavigationSettingsAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            navigationSettingScope: this.navigationSettingScope
        };
    }
};

});
parcelRegister("02tnb", function(module, exports) {

$parcel$export(module.exports, "JiraNavigationSettingsAriResourceOwner", () => $0076f8d914be1751$export$a71eb7f052c3a8f1);
$parcel$export(module.exports, "JiraNavigationSettingsAriResourceType", () => $0076f8d914be1751$export$8c9eb6c30d1db6dc);
// src/jira/navigation-settings/types.ts
var $0076f8d914be1751$export$a71eb7f052c3a8f1 = "jira", $0076f8d914be1751$export$8c9eb6c30d1db6dc = "navigation-settings";

});


parcelRegister("7Cu03", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAri", () => $58c35a58a97fa779$export$1e9d09c2be53e55e);

var $6A8mn = parcelRequire("6A8mn");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/identity/user/manifest.ts
var $58c35a58a97fa779$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6A8mn.IdentityUserAriResourceOwner),
    resourceType: (0, $6A8mn.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $58c35a58a97fa779$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._userId = opts.resourceIdSegmentValues.userId;
    }
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $58c35a58a97fa779$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $58c35a58a97fa779$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $58c35a58a97fa779$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $58c35a58a97fa779$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $58c35a58a97fa779$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $58c35a58a97fa779$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
};

});
parcelRegister("6A8mn", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAriResourceOwner", () => $4cac96fbba13502a$export$b4c14c54282a779d);
$parcel$export(module.exports, "IdentityUserAriResourceType", () => $4cac96fbba13502a$export$e9b50e20f4fbfb71);
// src/identity/user/types.ts
var $4cac96fbba13502a$export$b4c14c54282a779d = "identity", $4cac96fbba13502a$export$e9b50e20f4fbfb71 = "user";

});



parcelRegister("6JmRt", function(module, exports) {

$parcel$export(module.exports, "navPlatformSidebarResource", () => $096168d79e374d02$export$b22e51bad3fbae1b);

var $h4Bzb = parcelRequire("h4Bzb");

var $kWbWF = parcelRequire("kWbWF");

var $b1DBy = parcelRequire("b1DBy");

var $9FYIg = parcelRequire("9FYIg");

var $fKh2A = parcelRequire("fKh2A");

var $7Cu03 = parcelRequire("7Cu03");

var $goBB5 = parcelRequire("goBB5");

var $QuA6u = parcelRequire("QuA6u");
const $096168d79e374d02$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM = 'RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM';
const $096168d79e374d02$export$b22e51bad3fbae1b = (0, $9FYIg.createRelayResource)({
    type: $096168d79e374d02$var$RESOURCE_TYPE_SIDEBAR_NAV_PLATFORM,
    getQuery: (routerContext, { tenantContext: { cloudId: cloudId, activationId: activationId, atlassianAccountId: atlassianAccountId } })=>{
        const initialSelectedPath = (0, $kWbWF.getInitialSelectedPath)(routerContext);
        return {
            parameters: (0, $QuA6u.default),
            variables: {
                cloudId: cloudId,
                entityAriUserSideNavSettings: (0, $goBB5.JiraWorkspaceAri).create({
                    siteId: cloudId,
                    activationId: activationId
                }).toString(),
                isAppsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_APPS)),
                isFiltersExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_FILTERS)),
                isPlansExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PLANS)),
                isProjectsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_PROJECTS)),
                isOperationsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OPERATIONS)),
                isOverviewsExpanded: (0, $b1DBy.isSelectedPath)(initialSelectedPath, (0, $h4Bzb.MENU_ID_OVERVIEWS)),
                entityAriProjects: (0, $fKh2A.JiraNavigationSettingsAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    navigationSettingScope: 'projects'
                }).toString(),
                ownerAri: atlassianAccountId && (0, $7Cu03.IdentityUserAri).create({
                    userId: atlassianAccountId
                }).toString()
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
});

});
parcelRegister("goBB5", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAri", () => $befc0d413a701cce$export$d4d0794234e3fd53);

var $1JOdS = parcelRequire("1JOdS");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/workspace/manifest.ts
var $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $1JOdS.JiraWorkspaceAriResourceOwner),
    resourceType: (0, $1JOdS.JiraWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/jira/workspace/index.ts
var $befc0d413a701cce$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $befc0d413a701cce$var$jiraWorkspaceAriStaticOpts);
        return new _JiraWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
};

});
parcelRegister("1JOdS", function(module, exports) {

$parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", () => $1440f3a3433d3385$export$e52ccdf6abac8896);
$parcel$export(module.exports, "JiraWorkspaceAriResourceType", () => $1440f3a3433d3385$export$669cd5f7b3746bb);
// src/jira/workspace/types.ts
var $1440f3a3433d3385$export$e52ccdf6abac8896 = "jira", $1440f3a3433d3385$export$669cd5f7b3746bb = "workspace";

});


parcelRegister("QuA6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $765bd4a1f1362765$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f381bcabf660e0b13afd7025463417b>>
 * @relayHash 5c1fa445aa4e469803b219f299280891
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 51fd23c7c1b6a162136410388294ddc049cc4f80e1e9f721a60c94d43661d41f

var $9zQGn = parcelRequire("9zQGn");

var $dtG0v = parcelRequire("dtG0v");

var $cli8x = parcelRequire("cli8x");

var $l5K2d = parcelRequire("l5K2d");

var $5moL7 = parcelRequire("5moL7");

var $7m7yY = parcelRequire("7m7yY");

var $lhtKZ = parcelRequire("lhtKZ");

var $jhhgp = parcelRequire("jhhgp");

var $eSxxM = parcelRequire("eSxxM");

var $em6ga = parcelRequire("em6ga");

var $eEnEt = parcelRequire("eEnEt");
const $765bd4a1f1362765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriProjects"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAriUserSideNavSettings"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isAppsExpanded"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isFiltersExpanded"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOperationsExpanded"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isOverviewsExpanded"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isPlansExpanded"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isProjectsExpanded"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v10 = {
        "kind": "Variable",
        "name": "ownerAri",
        "variableName": "ownerAri"
    }, v11 = {
        "concreteType": "SettingsDisplayPropertyConnection",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "SettingsDisplayProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = {
        "kind": "ScalarField",
        "name": "label"
    }, v17 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v18 = {
        "kind": "ScalarField",
        "name": "url"
    }, v19 = {
        "order": "DESC"
    }, v20 = {
        "kind": "Literal",
        "name": "first",
        "value": 15
    }, v21 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v23 = {
        "kind": "ScalarField",
        "name": "name"
    }, v24 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v25 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v12 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCustomFilter"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v28 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v29 = {
        "kind": "Literal",
        "name": "first",
        "value": 20
    }, v30 = [
        v12 /*: any*/ ,
        v23 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "alertSearchQuery"
        }
    ], v31 = [
        v18 /*: any*/ 
    ], v32 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v15 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "planId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReadOnly"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "planStatus"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "scenarioId"
                                },
                                v12 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": v31 /*: any*/ ,
                                    "type": "JiraSoftwareBuiltInNavigationItem"
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraPlan"
                },
                v27 /*: any*/ 
            ]
        }
    ], v33 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v34 = {
        "kind": "ScalarField",
        "name": "status"
    }, v35 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v36 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v38 = {
        "kind": "LinkedField",
        "name": "defaultNavigationItem",
        "plural": false,
        "selections": [
            v15 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v31 /*: any*/ ,
                "type": "JiraNavigationItem",
                "abstractKey": "__isJiraNavigationItem"
            },
            v27 /*: any*/ 
        ]
    }, v39 = [
        {
            "kind": "Literal",
            "name": "type",
            "value": "EDIT_PROJECT_CONFIG"
        }
    ], v40 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v41 = {
        "alias": "editProjectConfig",
        "args": v39 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v40 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v42 = {
        "args": v39 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v40 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v43 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v44 = {
        "alias": "editPermission",
        "args": v39 /*: any*/ ,
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": v40 /*: any*/ ,
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v45 = {
        "kind": "ScalarField",
        "name": "softwareBoardCount"
    }, v46 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ], v47 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx",
        "kind": "Condition",
        "passingValue": false,
        "selections": v46 /*: any*/ 
    }, v48 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": v46 /*: any*/ 
    }, v49 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v46 /*: any*/ 
    }, v50 = [
        v12 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v23 /*: any*/ ,
        v37 /*: any*/ ,
        v24 /*: any*/ ,
        v38 /*: any*/ ,
        v41 /*: any*/ ,
        v42 /*: any*/ ,
        v43 /*: any*/ ,
        v44 /*: any*/ ,
        v45 /*: any*/ ,
        v47 /*: any*/ ,
        v48 /*: any*/ ,
        v49 /*: any*/ 
    ], v51 = {
        "concreteType": "JiraProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v50 /*: any*/ 
            }
        ]
    }, v52 = [
        v51 /*: any*/ ,
        v28 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GSNForContentSidebarQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useNetworkSideNavUserData"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Apps"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Filters"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Operations"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Overviews"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Plans"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "Nav4Projects"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "GSNForContentSidebarQuery",
            "selections": [
                {
                    "alias": "userSideNavSettings",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAriUserSideNavSettings"
                        },
                        v10 /*: any*/ 
                    ],
                    "concreteType": "SettingsNavigationCustomisation",
                    "kind": "LinkedField",
                    "name": "settings_navigationCustomisation",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItemConnection",
                            "kind": "LinkedField",
                            "name": "sidebar",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SettingsMenuItem",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "menuId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "visible"
                                        }
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isAppsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraNavigationItemConnection",
                                    "kind": "LinkedField",
                                    "name": "globalAppNavigationItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNavigationItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v16 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appId"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "appType"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "envLabel"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "iconUrl"
                                                                },
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAppSection",
                                                                    "kind": "LinkedField",
                                                                    "name": "sections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAppNavigationItemNestedLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v16 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "settingsUrl"
                                                                },
                                                                v18 /*: any*/ 
                                                            ],
                                                            "type": "JiraAppNavigationItem"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isFiltersExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsFiltersExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraWorkManagementGiraOverviewConnection",
                            "kind": "LinkedField",
                            "name": "jwmOverviews",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ]
                        },
                        {
                            "condition": "isProjectsExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsProjectsExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "alias": "canCreateProject",
                            "args": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "CREATE_PROJECT"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "canPerform"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "shouldDisplay",
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "VIEW_PROJECT_CREATION_ENTRY"
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "canPerform"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isPlansExpanded",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "hasIsPlansExpanded",
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "JiraAdvancedRoadmapsNavigation",
                            "kind": "LinkedField",
                            "name": "advancedRoadmapsNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasEditPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCreateSamplePlanPermissions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasGlobalPlansAdminPermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isFiltersExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v19 /*: any*/ ,
                                                "type": "FILTER"
                                            }
                                        },
                                        v20 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        v21 /*: any*/ ,
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                v23 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentFilters",
                                    "args": [
                                        v13 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "FILTER"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v22 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v23 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraFilter",
                                                                    "abstractKey": "__isJiraFilter"
                                                                }
                                                            ],
                                                            "type": "JiraCustomFilter"
                                                        },
                                                        v27 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraSystemFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "systemFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSystemFilter",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v23 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v24 /*: any*/ ,
                                                                v25 /*: any*/ ,
                                                                v26 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOperationsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "OpsgenieQuery",
                            "kind": "LinkedField",
                            "name": "opsgenie",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "OpsgenieSavedSearches",
                                    "kind": "LinkedField",
                                    "name": "savedSearches",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "sharedWithMe",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "OpsgenieSavedSearch",
                                            "kind": "LinkedField",
                                            "name": "createdByMe",
                                            "plural": true,
                                            "selections": v30 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isOverviewsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementGiraOverviewConnection",
                                    "kind": "LinkedField",
                                    "name": "jwmOverviews",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraWorkManagementGiraOverviewEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraWorkManagementGiraOverview",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isPlansExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "favouritePlans",
                                    "args": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": v19 /*: any*/ ,
                                                "type": "PLAN"
                                            }
                                        },
                                        v20 /*: any*/ 
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v28 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "recentPlans",
                                    "args": [
                                        v13 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "PLAN"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraSearchableEntityConnection",
                                    "kind": "LinkedField",
                                    "name": "recentItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSearchableEntityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isProjectsExpanded",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraWorkManagementLicensing",
                                    "kind": "LinkedField",
                                    "name": "jwmLicensing",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "currentUserSeatEdition"
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "favouriteProjects",
                                            "args": [
                                                v13 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "sort": v19 /*: any*/ ,
                                                        "type": "PROJECT"
                                                    }
                                                },
                                                v20 /*: any*/ 
                                            ],
                                            "concreteType": "JiraFavouriteConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v15 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v50 /*: any*/ ,
                                                                    "type": "JiraProject"
                                                                },
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v13 /*: any*/ ,
                                                v29 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recentProjects",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "GrowthRecQuery",
                                            "kind": "LinkedField",
                                            "name": "growthRecommendations",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "fields": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "product",
                                                                    "value": "jira"
                                                                },
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "tenantId",
                                                                    "variableName": "cloudId"
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "useCase",
                                                                    "value": "jiraProjectMenuRecommendations"
                                                                }
                                                            ],
                                                            "kind": "ObjectValue",
                                                            "name": "context"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 2
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "recommendations",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "entityId"
                                                                                }
                                                                            ],
                                                                            "type": "GrowthRecJiraTemplateRecommendation"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GrowthRecRecommendations"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "entityAri",
                                                    "variableName": "entityAriProjects"
                                                },
                                                v10 /*: any*/ 
                                            ],
                                            "concreteType": "SettingsNavigationCustomisation",
                                            "kind": "LinkedField",
                                            "name": "settings_navigationCustomisation",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v14 /*: any*/ ,
                                    "concreteType": "JiraProjectsSidebarMenu",
                                    "kind": "LinkedField",
                                    "name": "jira_projectsSidebarMenu",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecent",
                                            "plural": false,
                                            "selections": v50 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "mostRecentFromHistory",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v48 /*: any*/ ,
                                                v49 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                v20 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "favourites",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v51 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ],
                                            "storageKey": "favourites(first:15)"
                                        },
                                        {
                                            "args": [
                                                v29 /*: any*/ 
                                            ],
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "recents",
                                            "plural": false,
                                            "selections": v52 /*: any*/ ,
                                            "storageKey": "recents(first:20)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasMore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "favouriteLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "recentLimit"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayMode"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "51fd23c7c1b6a162136410388294ddc049cc4f80e1e9f721a60c94d43661d41f",
            "metadata": {},
            "name": "GSNForContentSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": (0, $jhhgp.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6315displaysettingsapart1relayprovider": (0, $dtG0v.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6987displaysettingspostgaexperimentrelayprovider": (0, $cli8x.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationprojectsfieldsnav4sidebarrelayprovider": (0, $eEnEt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu7436separategrowthrecrelayprovider": (0, $l5K2d.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgrowthrecommendationsrelayprovider": (0, $7m7yY.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": (0, $lhtKZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu8022refactorjpdprojectmenutocommonrelayprovidertsx": (0, $5moL7.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": (0, $eSxxM.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarexperimentrelayprovider": (0, $9zQGn.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": (0, $em6ga.default)
            }
        }
    };
}();
$765bd4a1f1362765$var$node.hash = "1f851aebed21c153d2ce5eab4dad43e3";
var $765bd4a1f1362765$export$2e2bcd8739ae039 = $765bd4a1f1362765$var$node;

});


parcelRegister("8J0lu", function(module, exports) {

$parcel$export(module.exports, "topNav4UIStateResource", () => $0edd5604b861f0e1$export$2d81c2e40eea9fba);

var $9FYIg = parcelRequire("9FYIg");

var $54NUw = parcelRequire("54NUw");
const $0edd5604b861f0e1$export$2d81c2e40eea9fba = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_TOPNAV_UI_STATE_RELAY`,
    getQuery: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous, atlassianAccountId: atlassianAccountId } })=>({
            parameters: (0, $54NUw.default),
            variables: {
                cloudId: cloudId,
                isAnonymous: isAnonymous,
                atlassianAccountId: atlassianAccountId ?? ''
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("54NUw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d713ab7eb601b870$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<391e7740c7b99e475c4d071b74c06f09>>
 * @relayHash 43ca389fcb5965c44ec53c6ce4601d19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f8502149e58521990a2dbe3a4c17f2996f15bd289242e8eda23c25e8f61acb3
const $d713ab7eb601b870$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "isLeftSidebarCollapsed"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AtlassianNavigationNav4Query",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4Profile"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "Nav4NotificationsData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AtlassianNavigationNav4Query",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "atlassianAccountId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "email"
                                        }
                                    ],
                                    "type": "AtlassianAccountUser"
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "InfluentsNotificationQuery",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "unseenNotificationCount"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3f8502149e58521990a2dbe3a4c17f2996f15bd289242e8eda23c25e8f61acb3",
            "metadata": {},
            "name": "AtlassianNavigationNav4Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d713ab7eb601b870$var$node.hash = "90dcffc913e3e3d03ddfcca18a50a500";
var $d713ab7eb601b870$export$2e2bcd8739ae039 = $d713ab7eb601b870$var$node;

});


parcelRegister("SPYRa", function(module, exports) {

$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $fdcc63ef33fd0b8d$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $fdcc63ef33fd0b8d$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $fdcc63ef33fd0b8d$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $fdcc63ef33fd0b8d$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $fdcc63ef33fd0b8d$export$54805a2120a31ad0);

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $fdcc63ef33fd0b8d$export$fa475a9581133779 = (0, $l1VxS.createResource)({
    type: (0, $19cf35753fa41a8f$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $1Ozm9.default)('/rest/jpo/1.0/navigation/simple');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $19cf35753fa41a8f$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity
});
const $fdcc63ef33fd0b8d$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $fdcc63ef33fd0b8d$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $fdcc63ef33fd0b8d$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $fdcc63ef33fd0b8d$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
parcelRegister("1Ozm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce52bb22689abcd$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $1oMOM = parcelRequire("1oMOM");

var $1uIew = parcelRequire("1uIew");

var $i4YfB = parcelRequire("i4YfB");

var $3WOLx = parcelRequire("3WOLx");

var $7AheX = parcelRequire("7AheX");
var /**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param {string} url - to fetch the JSON from
 * @param {object} options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$7ce52bb22689abcd$export$2e2bcd8739ae039 = (url, options = {})=>fetch((0, $i4YfB.getReroutableURL)(url), (0, $3WOLx.applyObservabilityHeaders)(url, (0, $iWqim.merge)((0, $1oMOM.defaultOptions), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $7AheX.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $1uIew.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $1uIew.default)(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });

});

const $19cf35753fa41a8f$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $19cf35753fa41a8f$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("5MeEd", function(module, exports) {

$parcel$export(module.exports, "getConsentBannerUserPreferencesResource", () => $1f6c6844ab578de1$export$a40d52e504d1db7c);
$parcel$export(module.exports, "useConsentBannerUserPreferencesResource", () => $1f6c6844ab578de1$export$5bc7e83e85567fb4);
// eslint-disable-next-line jira/import-whitelist

var $2hz3A = parcelRequire("2hz3A");

var $9YRcI = parcelRequire("9YRcI");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $7jTnu = parcelRequire("7jTnu");

const $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceOld = (0, $l1VxS.createResource)({
    type: (0, $e5cddec8694808c6$export$c5397b7748ed6c7b),
    getKey: ()=>(0, $e5cddec8694808c6$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_COOKIE_KEY));
        const fallbackConsentToken = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken) return {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken
        };
        const data = await (0, $jGzN3.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: true
});
const $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceNew = (0, $l1VxS.createResource)({
    type: (0, $e5cddec8694808c6$export$f0cdd7d2fbfd00ff),
    getKey: ()=>(0, $e5cddec8694808c6$export$4a9dd42dbc707155),
    getData: async ()=>{
        const consentToken = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_COOKIE_KEY), true);
        const fallbackConsentToken = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), true);
        const shouldShowBannerBit = (0, $9YRcI.getCookie)((0, $2hz3A.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), true);
        const shouldShowBanner = shouldShowBannerBit !== undefined && shouldShowBannerBit !== null ? !!Number(shouldShowBannerBit) : undefined;
        // If we have cached cookie data, bundle it up, with a potential fallback token
        if (consentToken) return {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken,
            shouldShowBanner: shouldShowBanner
        };
        const data = await (0, $jGzN3.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
        return data;
    },
    maxAge: 900000,
    isBrowserOnly: false
});
const $1f6c6844ab578de1$export$a40d52e504d1db7c = ()=>{
    if ((0, $7jTnu.fg)('jfp-magma-ssr-iv-cookie-consent-banner')) return $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceNew;
    return $1f6c6844ab578de1$var$consentBannerUserPreferencesResourceOld;
};
const $1f6c6844ab578de1$export$5bc7e83e85567fb4 = ()=>(0, $eJrcF.useResource)($1f6c6844ab578de1$export$a40d52e504d1db7c());

});
parcelRegister("9YRcI", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $cab6b0210ca24ec3$export$4be65e66cfa2648a);

var $2p0jb = parcelRequire("2p0jb");
function $cab6b0210ca24ec3$export$4be65e66cfa2648a(key) {
    return key ? (0, $2p0jb.getCookie)(key) : (0, $2p0jb.getCookie)();
}

});

const $e5cddec8694808c6$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $e5cddec8694808c6$export$f0cdd7d2fbfd00ff = 'CONSENT_BANNER_USER_PREFERENCES_SSR';
const $e5cddec8694808c6$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';


parcelRegister("9CgFv", function(module, exports) {

$parcel$export(module.exports, "checkApiKeyManagementKeysResource", () => $8298e40e8fde4c1d$export$b16eaa5246afc9b6);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $9ppkU = parcelRequire("9ppkU");

var $dI30d = parcelRequire("dI30d");


var $l1VxS = parcelRequire("l1VxS");

const $8298e40e8fde4c1d$var$fetchCheckApiKeyManagementKeys = async (accountId, isSiteAdmin, isTransitioning, appPermissions)=>{
    if (!isTransitioning || !isSiteAdmin || appPermissions && appPermissions.hasServiceDeskAccess === false) return Promise.resolve(false);
    return (0, $9ppkU.eocFetch)(`/api-keys/web/check?accountId=${accountId}`).then(({ data: data })=>data);
};
const $8298e40e8fde4c1d$var$resource = (0, $l1VxS.createResource)({
    type: (0, $f417dca27ced17c4$export$5879151f0d972f18),
    getKey: ()=>'check-api-key-management-keys',
    getData: async ({ dependencies: dependencies }, { tenantContext: { atlassianAccountId: atlassianAccountId, appPermissions: appPermissions, isSiteAdmin: isSiteAdmin } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const tenantInfo = await dependencies[0, $f8747ec2695de8a7$export$25ee35b01de9d734]?.promise;
        const isTransitioning = (0, $dI30d.checkIsTransitioning)(tenantInfo);
        return $8298e40e8fde4c1d$var$fetchCheckApiKeyManagementKeys(atlassianAccountId, isSiteAdmin, isTransitioning, appPermissions);
    },
    maxAge: Infinity,
    isBrowserOnly: true,
    depends: [
        (0, $f8747ec2695de8a7$export$25ee35b01de9d734)
    ]
});
const $8298e40e8fde4c1d$export$b16eaa5246afc9b6 = ()=>$8298e40e8fde4c1d$var$resource;

});
parcelRegister("9ppkU", function(module, exports) {

$parcel$export(module.exports, "eocFetch", () => $6655053aa9252cd7$export$212b9c60150b5a0a);

var $eGOwo = parcelRequire("eGOwo");

var $fiPhB = parcelRequire("fiPhB");

var $2QO3b = parcelRequire("2QO3b");

var $1boDC = parcelRequire("1boDC");

var $fR4Ty = parcelRequire("fR4Ty");
const $6655053aa9252cd7$export$212b9c60150b5a0a = (input, init)=>{
    let headers = init?.headers ?? {};
    let body = init?.body;
    // If there is no Content-Type we should add application/json
    // and if the body is not in the BodyInit format we should stringify it
    // Native fetch accepts headers as [['key1','value1'],['key2', 'value2']] so we don't want to modify header or body in this case
    if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
        body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
    }
    if (typeof input === 'string') {
        input = (0, $fR4Ty.withPrefix)(input, init);
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $fiPhB.getActiveTraceHttpRequestHeaders)(input),
            ...headers
        };
    } else {
        input = {
            ...input,
            url: (0, $fR4Ty.withPrefix)(input.url, init)
        };
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('trace_id_header_update_in_the_eoc_fetch')) headers = {
            ...(0, $fiPhB.getActiveTraceHttpRequestHeaders)(input.url),
            ...headers
        };
    }
    const errorTransformer = init?.errorTransformer ?? (0, $fR4Ty.defaultErrorTransformer);
    const startTime = performance.now();
    return fetch(input, {
        headers: headers,
        ...init,
        body: body
    }).catch((error)=>{
        throw new (0, $1boDC.NetworkError)(error.name, error);
    }).then((response)=>{
        if (!response.ok) throw new (0, $1boDC.HTTPError)(response);
        const sanitizedUrl = (0, $fR4Ty.sanitizeUrlString)((0, $fR4Ty.getRequestUrl)(input));
        (0, $2QO3b.addSpanToAll)('fetch', sanitizedUrl, [
            {
                name: 'network'
            }
        ], startTime, performance.now());
        switch(init?.responseType){
            case undefined:
            case 'json':
                return response.json();
            case 'blob':
                return response.blob();
            case 'text':
                return response.text();
            case 'headers':
                return response;
        }
    }).catch((error)=>{
        if ((0, $1boDC.isNetworkError)(error)) {
            // Put it through the transformer and throw it when ready. Note that
            // it is still safe to throw in the transformer, it will just chain up
            // on the following handlers as usual.
            const transformerResult = errorTransformer(error);
            if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                throw finalError;
            });
            else throw transformerResult;
        }
        throw error;
    });
};

});
parcelRegister("1boDC", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $58266db8ddf521d5$export$bae979e68e4dc802);
$parcel$export(module.exports, "HTTPError", () => $58266db8ddf521d5$export$aa9d629c530f62a7);
$parcel$export(module.exports, "StreamedHTTPError", () => $58266db8ddf521d5$export$c30b5b02747d791c);
$parcel$export(module.exports, "isHTTPError", () => $58266db8ddf521d5$export$6b7a49ce9c98a2f);
$parcel$export(module.exports, "isNetworkError", () => $58266db8ddf521d5$export$476aa014e2fd89d5);
$parcel$export(module.exports, "isStreamedHTTPError", () => $58266db8ddf521d5$export$4f52fcea95c8f97d);

var $h7mJ2 = parcelRequire("h7mJ2");
class $58266db8ddf521d5$export$bae979e68e4dc802 extends Error {
    constructor(name, cause){
        super('Network Error!'), this.name = name, this.cause = cause;
    }
}
class $58266db8ddf521d5$export$aa9d629c530f62a7 extends $58266db8ddf521d5$export$bae979e68e4dc802 {
    constructor(response){
        // It is important to note that this can be shown to the user if the
        // default transformer is not used for some reason and the thrown error's
        // message is left as is.
        super((0, $h7mJ2.ERROR_NAMES).HTTPError);
        this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
        this.response = response;
    }
}
class $58266db8ddf521d5$export$c30b5b02747d791c extends $58266db8ddf521d5$export$aa9d629c530f62a7 {
    constructor(cause, data, message){
        super(cause.response), this.cause = cause, this.data = data, this.message = message;
        this.message = message;
        this.name = (0, $h7mJ2.ERROR_NAMES).StreamedHTTPError;
    }
}
const $58266db8ddf521d5$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $58266db8ddf521d5$export$aa9d629c530f62a7 || [
        (0, $h7mJ2.ERROR_NAMES).HTTPError,
        (0, $h7mJ2.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $58266db8ddf521d5$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $58266db8ddf521d5$export$bae979e68e4dc802 || [
        (0, $h7mJ2.ERROR_NAMES).NetworkError,
        (0, $h7mJ2.ERROR_NAMES).HTTPError,
        (0, $h7mJ2.ERROR_NAMES).StreamedHTTPError
    ].includes(candidate.name);
const $58266db8ddf521d5$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $58266db8ddf521d5$export$c30b5b02747d791c || candidate?.name === (0, $h7mJ2.ERROR_NAMES).StreamedHTTPError;

});
parcelRegister("h7mJ2", function(module, exports) {

$parcel$export(module.exports, "ERROR_NAMES", () => $560dfbaa32da471b$export$daceac3b97803ce1);
var $560dfbaa32da471b$export$daceac3b97803ce1 = /*#__PURE__*/ function(ERROR_NAMES) {
    ERROR_NAMES["HTTPError"] = "HTTPError";
    ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
    ERROR_NAMES["NetworkError"] = "NetworkError";
    return ERROR_NAMES;
}({});

});


parcelRegister("fR4Ty", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $436864c0a0a0e09b$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "withPrefix", () => $436864c0a0a0e09b$export$44188c5f179c4553);
$parcel$export(module.exports, "defaultErrorTransformer", () => $436864c0a0a0e09b$export$270fcc0e5df09fdd);
$parcel$export(module.exports, "jsmErrorTransformer", () => $436864c0a0a0e09b$export$994cc82144d28ded);
$parcel$export(module.exports, "getRequestUrl", () => $436864c0a0a0e09b$export$14619c0eed01a470);
$parcel$export(module.exports, "sanitizeUrlString", () => $436864c0a0a0e09b$export$ceb09b958e605eff);

var $j9wsO = parcelRequire("j9wsO");

var $1boDC = parcelRequire("1boDC");

let $436864c0a0a0e09b$var$metaCloudId;
let $436864c0a0a0e09b$var$isJSMAvailable = true;
function $436864c0a0a0e09b$export$c47913ca32a5c6f7(name) {
    const globalVariable = window ?? $parcel$global;
    if ((0, $j9wsO.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
    if ($436864c0a0a0e09b$var$metaCloudId) return $436864c0a0a0e09b$var$metaCloudId;
    if ($436864c0a0a0e09b$var$isJSMAvailable) {
        const element = document.querySelector(`meta[name="${name}"]`);
        $436864c0a0a0e09b$var$metaCloudId = element?.getAttribute('content') ?? undefined;
        $436864c0a0a0e09b$var$isJSMAvailable = !!$436864c0a0a0e09b$var$metaCloudId;
    }
    return $436864c0a0a0e09b$var$metaCloudId;
}
function $436864c0a0a0e09b$export$5a75f4aeb58ba80f(id) {
    $436864c0a0a0e09b$var$metaCloudId = id;
}
function $436864c0a0a0e09b$export$44188c5f179c4553(input, init) {
    if (init?.exactUrl) return input;
    // If current env is not opsgenie, we will add cloud id to base url of request.
    if (window.__OG__) return '/webapi' + input;
    const cloudId = $436864c0a0a0e09b$export$c47913ca32a5c6f7('ajs-cloud-id');
    if (cloudId) return (0, $1921e606163d25bf$export$3414665826fa030e) + cloudId + input;
    return input;
}
// https://www.rfc-editor.org/rfc/rfc9110.html#section-8.3
// This is not a full implementation, but should skip any unknown parameters
// and match the charset if it exists. In case there are multiple (which shouldn't) we still
// match the first occurence. If only application/json is returned, utf-8 is
// assumed as we will try to parse it as utf-8 json. This is probably our best
// guess without too much effort here.
const $436864c0a0a0e09b$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
const $436864c0a0a0e09b$export$270fcc0e5df09fdd = (e)=>{
    if (e instanceof (0, $1boDC.HTTPError)) {
        const contentType = e.response.headers.get('Content-Type');
        // The content type is application/json, and it is highly likely utf-8 encoded
        if (contentType && $436864c0a0a0e09b$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $1boDC.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
        // For anything else, try to interpret it as utf8 text as best effort.
        return e.response.text().then((message)=>new (0, $1boDC.StreamedHTTPError)(e, message, message));
    }
    return e;
};
const $436864c0a0a0e09b$export$994cc82144d28ded = (error)=>{
    if (error instanceof (0, $1boDC.HTTPError)) {
        const contentType = error.response.headers.get('Content-Type');
        if (contentType && $436864c0a0a0e09b$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $1boDC.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
        return error.response.text().then((message)=>new (0, $1boDC.StreamedHTTPError)(error, message, message));
    }
    return error;
};
const $436864c0a0a0e09b$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
const $436864c0a0a0e09b$export$ceb09b958e605eff = (url)=>{
    const urlWithoutQueryParams = url.replace(/\?.*$/, '');
    const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
    return urlWithoutUUIDs;
};

});
parcelRegister("j9wsO", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $8da7becb91021908$export$6acf61af03e62db);
const $8da7becb91021908$export$6acf61af03e62db = ()=>{
    try {
        //@ts-ignore: It defined from webpack on the Jira
        return false;
    } catch (error) {
        return globalThis.false ?? false;
    }
};

});

const $1921e606163d25bf$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';



parcelRegister("dI30d", function(module, exports) {

$parcel$export(module.exports, "checkShouldUseJSM", () => $18fe81d8bf210fd5$export$5e0f3a0d8463fa21);
$parcel$export(module.exports, "checkIsTransitioning", () => $18fe81d8bf210fd5$export$d2f281fd4bf10855);
$parcel$export(module.exports, "checkIsConsolidated", () => $18fe81d8bf210fd5$export$57f75aebff17dd1e);
$parcel$export(module.exports, "checkIsTransitioned", () => $18fe81d8bf210fd5$export$b6461b23ee0e1471);
$parcel$export(module.exports, "checkIsTransitionEligible", () => $18fe81d8bf210fd5$export$24040115cac5fdc3);
$parcel$export(module.exports, "checkShouldAccessUnlockOperations", () => $18fe81d8bf210fd5$export$cd227238525e8d57);
$parcel$export(module.exports, "checkIsOpsAdmin", () => $18fe81d8bf210fd5$export$66a96ac2f07f6730);

var $htDO2 = parcelRequire("htDO2");

const $18fe81d8bf210fd5$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $htDO2.ConsolidationState).NOT_CONSOLIDATED;
};
const $18fe81d8bf210fd5$export$d2f281fd4bf10855 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).TRANSITIONING;
};
const $18fe81d8bf210fd5$export$57f75aebff17dd1e = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? tenantInfo === (0, $htDO2.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).CONSOLIDATED;
};
const $18fe81d8bf210fd5$export$b6461b23ee0e1471 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).TRANSITIONED;
};
const $18fe81d8bf210fd5$export$24040115cac5fdc3 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState === (0, $htDO2.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $73b7e0580d88d09b$export$650f6934db1290c1);
};
const $18fe81d8bf210fd5$export$cd227238525e8d57 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return tenantInfo.consolidationState !== (0, $htDO2.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $73b7e0580d88d09b$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $73b7e0580d88d09b$export$a101f3562b5f0742));
};
const $18fe81d8bf210fd5$export$66a96ac2f07f6730 = (tenantInfo)=>{
    if (!tenantInfo) return false;
    return typeof tenantInfo === 'string' ? false : Boolean(tenantInfo.isAdmin);
};

});
parcelRegister("htDO2", function(module, exports) {

$parcel$export(module.exports, "ConsolidationState", () => $ec93a9f74251e3bc$export$9ef498b0a11fd37d);
const $ec93a9f74251e3bc$export$9ef498b0a11fd37d = {
    NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
    TRANSITIONING: 'TRANSITIONING',
    TRANSITIONED: 'TRANSITIONED',
    CONSOLIDATED: 'CONSOLIDATED'
};

});

const $73b7e0580d88d09b$export$650f6934db1290c1 = 'cohort3';
const $73b7e0580d88d09b$export$a101f3562b5f0742 = 'cohort3.5';


const $f8747ec2695de8a7$export$25ee35b01de9d734 = 'EOC_TENANT';

const $f417dca27ced17c4$export$5879151f0d972f18 = 'EOC_CHECK_API_KEY';


parcelRegister("graie", function(module, exports) {

$parcel$export(module.exports, "consolidationUserStateResource", () => $eafdd622df1b4c6c$export$4b870505c49999ef);

var $gYnSx = parcelRequire("gYnSx");

var $l1VxS = parcelRequire("l1VxS");

var $6HiIf = parcelRequire("6HiIf");

const $eafdd622df1b4c6c$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
const $eafdd622df1b4c6c$export$4b870505c49999ef = (0, $l1VxS.createResource)({
    type: $eafdd622df1b4c6c$var$RESOURCE_KEY,
    getKey: ()=>$eafdd622df1b4c6c$var$RESOURCE_KEY,
    getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $6HiIf.getOgConsolidationUserState)(accountId).catch((error)=>{
            (0, $gYnSx.default)({
                meta: {
                    id: 'consolidationUserStateResource',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }),
    maxAge: Infinity
});

});
parcelRegister("6HiIf", function(module, exports) {

$parcel$export(module.exports, "getOgConsolidationUserState", () => $ee117a4359e29127$export$df7594d56c9ebe57);

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $4I3Mw = parcelRequire("4I3Mw");
const $ee117a4359e29127$export$df7594d56c9ebe57 = (accountId)=>{
    if (!accountId) return Promise.resolve((0, $4I3Mw.ERROR_CONSOLIDATION_USER_STATE));
    return (0, $FppkK.getUserProperty)(accountId, (0, $4I3Mw.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
        if (!val || typeof val !== 'object') {
            (0, $gYnSx.default)({
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                    teamName: 'alexstrasza'
                },
                error: new (0, $1uIew.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                sendToPrivacyUnsafeSplunk: true
            });
            return 0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE;
        }
        if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
            ...(0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE),
            ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE), key)))
        };
        if (!Object.keys((0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) // Missing properties will happen when adding new properties to the type,
        // we are making sure they are filled in from the defaults
        return {
            ...(0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE),
            ...val
        };
        return val;
    }).catch((error)=>{
        // Property not saved yet, so we return the default values
        if (error instanceof (0, $1uIew.default) && error.statusCode === 404) return 0, $4I3Mw.DEFAULT_CONSOLIDATION_USER_STATE;
        throw error;
    });
};

});
parcelRegister("4I3Mw", function(module, exports) {

$parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", () => $afdd30cff85a4099$export$1980758e2622af02);
$parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", () => $afdd30cff85a4099$export$51d9907e9d716d);
$parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", () => $afdd30cff85a4099$export$23da4710c3a29eae);
const $afdd30cff85a4099$export$1980758e2622af02 = 'eoc_consolidation_user_state';
const $afdd30cff85a4099$export$51d9907e9d716d = {
    isPromotionBannerDismissed: false,
    isWelcomeModalDisplayed: false,
    isTransitionHomeHidden: false,
    isTransitionBannerDismissed: false,
    isBroadcastWidgetDismissed: false,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: false
};
const $afdd30cff85a4099$export$23da4710c3a29eae = {
    isPromotionBannerDismissed: true,
    isWelcomeModalDisplayed: true,
    isTransitionHomeHidden: true,
    isTransitionBannerDismissed: true,
    isBroadcastWidgetDismissed: true,
    transitionBannerDismissedAt: null,
    isBenefitModalDismissed: true
};

});



parcelRegister("4VIcO", function(module, exports) {

$parcel$export(module.exports, "getConsolidationStateResource", () => $f31902774f5ce285$export$a6cf5054d4f9f5dd);
// eoc-fetch is already being used in eoc resources, so there is no reason not
// to override the whitelist here.
// eslint-disable-next-line jira/import-whitelist

var $9ppkU = parcelRequire("9ppkU");

var $7jTnu = parcelRequire("7jTnu");

var $l1VxS = parcelRequire("l1VxS");

var $hbF3h = parcelRequire("hbF3h");

var $htDO2 = parcelRequire("htDO2");

const $f31902774f5ce285$export$de6c19ae237c1eb9 = (cloudId, atlassianAccountId, isAnonymous, appPermissions)=>{
    let url = (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? '/internal/v1/users/ops-user-info' : '/internal/v1/customers/tenant-info';
    if (cloudId) url = `${url}/${cloudId}`;
    else throw new Error('No tenant info exists.');
    let promise;
    if (appPermissions && appPermissions.hasServiceDeskAccess === false || isAnonymous) {
        promise = new Promise((resolve)=>{
            resolve({
                consolidationState: (0, $htDO2.ConsolidationState).NOT_CONSOLIDATED,
                ...(0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? {
                    isAdmin: false
                } : {}
            });
        });
        return promise;
    }
    if ((0, $7jTnu.fg)('operations-tenant-info-endpoint-update')) url = `${url}/${atlassianAccountId}`;
    if (false) promise = (0, $9ppkU.eocFetch)(url, {
        exactUrl: true,
        headers: {
            'x-ssr-service-name': (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? 'og-apps-user-int-api' : 'og-customer-int-api'
        }
    });
    else {
        const clientUrl = (0, $7jTnu.fg)('operations-tenant-info-endpoint-update') ? '/v1/users/ops-user-info' : '/v1/customers/tenant-info';
        promise = (0, $9ppkU.eocFetch)(clientUrl).then(({ data: data })=>data);
    }
    return promise;
};
const $f31902774f5ce285$var$getConsolidationStateResourceFactory = (forceBrowser = false)=>(0, $l1VxS.createResource)({
        type: (0, $f8747ec2695de8a7$export$25ee35b01de9d734),
        getKey: ()=>'tenantInformation',
        getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions, atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>$f31902774f5ce285$export$de6c19ae237c1eb9(cloudId, atlassianAccountId, isAnonymous, appPermissions),
        maxAge: Infinity,
        isBrowserOnly: forceBrowser
    });
const $f31902774f5ce285$var$consolidationResourceForceBrowser = $f31902774f5ce285$var$getConsolidationStateResourceFactory(true);
const $f31902774f5ce285$var$consolidationResourceDontForceBrowser = $f31902774f5ce285$var$getConsolidationStateResourceFactory(false);
const $f31902774f5ce285$var$getConsolidationStateResourceNew = (forceBrowser = false)=>{
    /**
	 * This needs to return the same resource instance each time (based on args) or else we end up with many unnecessary re-renders
	 */ return forceBrowser ? $f31902774f5ce285$var$consolidationResourceForceBrowser : $f31902774f5ce285$var$consolidationResourceDontForceBrowser;
};
const $f31902774f5ce285$export$a6cf5054d4f9f5dd = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jfp-magma-stability-check-nav4-batch-1'), $f31902774f5ce285$var$getConsolidationStateResourceNew, $f31902774f5ce285$var$getConsolidationStateResourceFactory);

});

parcelRegister("7JXbP", function(module, exports) {

$parcel$export(module.exports, "gicSmartFieldsFeatureResource", () => $be15d6a6239426da$export$ee94bb1f59b07e35);
$parcel$export(module.exports, "useIsSmartFieldsOptIn", () => $be15d6a6239426da$export$3870b1ff1b155c73);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $9DB7T = parcelRequire("9DB7T");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $be15d6a6239426da$export$ee94bb1f59b07e35 = (0, $l1VxS.createResource)({
    type: (0, $a6fb1066b3f16ba9$export$6f0555de4f60e84e),
    getKey: ()=>(0, $a6fb1066b3f16ba9$export$7e7d7930e22ba39f),
    getData: async ()=>{
        try {
            const data = await (0, $9DB7T.userPreferenceAPI).get((0, $a6fb1066b3f16ba9$export$b94951a11282ae6a));
            if (!data) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If value has never been set, we expect a 404
            if (error.statusCode === 404) return {
                hasUserOptedOut: false,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            };
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'gicSmartFieldsFeatureResource',
                    packageName: (0, $a6fb1066b3f16ba9$export$b8b9d90f9e5bd72b),
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            hasUserOptedOut: false,
            hasUserDismissedReadMore: false,
            hasUserDismissedGicOnboarding: false
        };
    },
    maxAge: Number.MAX_VALUE
});
const $be15d6a6239426da$export$3870b1ff1b155c73 = ()=>{
    const { data: data, update: update, loading: loading } = (0, $eJrcF.useResource)($be15d6a6239426da$export$ee94bb1f59b07e35);
    const currentOptInStatus = typeof data?.hasUserOptedOut === 'boolean' ? !data.hasUserOptedOut : true;
    const currentDismissedReadMore = typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false;
    const currentDismissedGicOnboarding = typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false;
    const dismissReadMore = (0, $eJOHy.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                hasUserDismissedReadMore: true,
                ...previousData?.hasUserDismissedGicOnboarding ? {
                    hasUserDismissedGicOnboarding: previousData.hasUserDismissedGicOnboarding
                } : {
                    hasUserDismissedGicOnboarding: false
                }
            }));
    }, [
        update
    ]);
    const dismissGicOnboarding = (0, $eJOHy.useCallback)(()=>{
        update((previousData)=>({
                ...previousData?.hasUserOptedOut ? {
                    hasUserOptedOut: previousData.hasUserOptedOut
                } : {
                    hasUserOptedOut: false
                },
                ...previousData?.hasUserDismissedReadMore ? {
                    hasUserDismissedReadMore: previousData.hasUserDismissedReadMore
                } : {
                    hasUserDismissedReadMore: false
                },
                hasUserDismissedGicOnboarding: true
            }));
    }, [
        update
    ]);
    return {
        isSmartFieldsOptIn: loading ? null : currentOptInStatus,
        isSmartFieldDismissedReadMore: loading ? null : currentDismissedReadMore,
        isSmartFieldsGicOnboardingDismissed: loading ? null : currentDismissedGicOnboarding,
        dismissReadMore: dismissReadMore,
        dismissGicOnboarding: dismissGicOnboarding,
        loading: loading
    };
};

});
parcelRegister("9DB7T", function(module, exports) {

$parcel$export(module.exports, "userPreferenceAPI", () => $0f97d523fbd91473$export$4f7929ca6b50a436);


var $jGzN3 = parcelRequire("jGzN3");
const $0f97d523fbd91473$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
const $0f97d523fbd91473$var$get = async (key)=>{
    try {
        const result = await (0, $jGzN3.performGetRequest)($0f97d523fbd91473$var$url(key));
        return result?.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === (0, $44ccf6b895337c89$export$8bca792d963eb0ef)) return null;
        throw error;
    }
};
const $0f97d523fbd91473$var$set = (key, value)=>(0, $jGzN3.performPutRequest)($0f97d523fbd91473$var$url(key), {
        body: JSON.stringify({
            value: value
        })
    });
const $0f97d523fbd91473$var$remove = (key)=>(0, $jGzN3.performDeleteRequest)($0f97d523fbd91473$var$url(key));
const $0f97d523fbd91473$export$4f7929ca6b50a436 = {
    get: $0f97d523fbd91473$var$get,
    set: $0f97d523fbd91473$var$set,
    remove: $0f97d523fbd91473$var$remove
};

});

const $a6fb1066b3f16ba9$export$6f0555de4f60e84e = 'RESOURCE_TYPE_GIC_SMART_FIELDS';
const $a6fb1066b3f16ba9$export$7e7d7930e22ba39f = 'gsf-opt-out-resource-key'; // value is global for user
const $a6fb1066b3f16ba9$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $a6fb1066b3f16ba9$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGicSmartFields';


parcelRegister("dRfS0", function(module, exports) {

$parcel$export(module.exports, "gicOptInStatusResources", () => $30cdb61faaf8fbb9$export$14c89b6b6a261524);

var $eSnSE = parcelRequire("eSnSE");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");


const $30cdb61faaf8fbb9$export$14c89b6b6a261524 = (0, $l1VxS.createResource)({
    type: (0, $3fe8c5f6b0b2dbf8$export$fe522736b61f6709),
    getKey: ()=>'gic_optin_status',
    getData: async ()=>{
        let gicOptInStatus = null;
        try {
            gicOptInStatus = await (0, $jGzN3.performGetRequest)('/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e.statusCode !== 404) (0, $eSnSE.default).safeErrorWithoutCustomerData('spa.router.resources.navigation.gicVisibility', 'getGICVisibility', e);
        }
        return {
            gicOptInStatus: gicOptInStatus ?? {
                isEnabled: false
            }
        };
    },
    maxAge: Number.MAX_VALUE
});

});
const $3fe8c5f6b0b2dbf8$export$fe522736b61f6709 = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';


parcelRegister("7KVqh", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RESPONSE", () => $9ec642d55d80db11$export$32d9db53927095d3);
$parcel$export(module.exports, "incomingMailServerExpiryStatusResource", () => $9ec642d55d80db11$export$369caf52ed1ad2b1);
$parcel$export(module.exports, "useIncomingMailExpiryStatus", () => $9ec642d55d80db11$export$283aa034b7d4e2a0);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $9ec642d55d80db11$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $jGzN3.performGetRequest)((0, $8e8a9e94fa1c2865$export$5bf8eb915287f5f4));
const $9ec642d55d80db11$export$32d9db53927095d3 = {
    isAdmin: false,
    showBanner: true,
    OauthTypes: [
        'GMAIL_OAUTH'
    ]
};
const $9ec642d55d80db11$export$369caf52ed1ad2b1 = (0, $l1VxS.createResource)({
    type: (0, $8e8a9e94fa1c2865$export$3b9494e0dfc4de09),
    getKey: ()=>(0, $8e8a9e94fa1c2865$export$f2f2f265ccc09f82),
    getData: async ()=>{
        let incomingMailServerExpiryStatus = null;
        try {
            incomingMailServerExpiryStatus = await $9ec642d55d80db11$var$fetchGetIncomingMailServerExpiryStatus();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'incomingMailServerExpiryStatus',
                    packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                    teamName: 'maverick'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $9ec642d55d80db11$export$32d9db53927095d3
        };
    },
    maxAge: 3600000
});
const $9ec642d55d80db11$export$283aa034b7d4e2a0 = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $eJrcF.useResource)($9ec642d55d80db11$export$369caf52ed1ad2b1);
    const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $eJOHy.useState)(()=>{
        if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
        return $9ec642d55d80db11$export$32d9db53927095d3;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eJOHy.useState)('not started');
    (0, $eJOHy.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.incomingMailServerExpiryStatus) {
            setResponseStatusGet('success');
            setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.incomingMailServerExpiryStatus
    ]);
    return {
        responseStatus: responseStatusGet,
        state: incomingMailServerExpiryStatus
    };
};

});
const $8e8a9e94fa1c2865$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $8e8a9e94fa1c2865$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $8e8a9e94fa1c2865$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';


parcelRegister("5yVUD", function(module, exports) {

$parcel$export(module.exports, "issueTransitionChangeboardingPreferencesResource", () => $ac40f8141f9f880e$export$1b6468a6eb7d9b09);
$parcel$export(module.exports, "useIssueTransitionChangeboardingPreferences", () => $ac40f8141f9f880e$export$e21c345b2538e96e);

var $eJOHy = parcelRequire("eJOHy");

var $exWdq = parcelRequire("exWdq");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $k1FO2 = parcelRequire("k1FO2");
const $ac40f8141f9f880e$export$1b6468a6eb7d9b09 = (0, $l1VxS.createResource)({
    type: (0, $k1FO2.RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES),
    getKey: ()=>(0, $k1FO2.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY),
    getData: async ()=>{
        let modalViewCount = 0;
        try {
            const apiResult = await (0, $jGzN3.performGetRequest)((0, $k1FO2.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API));
            if ((0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'value') || !(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'benefitsModalValue')) {
                    const error = new Error('Invalid preference value');
                    (0, $gYnSx.default)({
                        meta: {
                            id: 'issueTransitionChangeboardingPreferencesResource',
                            packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
                return {
                    numberOfTimesUserHasSeenChangeboarding: Number(apiResult.value) || 0,
                    benefitsModal: {
                        isDisabled: apiResult?.benefitsModal?.isDisabled || false,
                        nextDateToShowBenefitsModal: apiResult?.benefitsModal?.nextDateToShowBenefitsModal || null
                    }
                };
            }
            if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'value')) {
                const error = new Error('Invalid preference value');
                (0, $gYnSx.default)({
                    meta: {
                        id: 'issueTransitionChangeboardingPreferencesResource',
                        packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } else {
                modalViewCount = Number(apiResult.value);
                return {
                    numberOfTimesUserHasSeenChangeboarding: modalViewCount
                };
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) {
                if ((0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) return {
                    numberOfTimesUserHasSeenChangeboarding: 0,
                    benefitsModal: {
                        isDisabled: false,
                        nextDateToShowBenefitsModal: null
                    }
                };
                return {
                    numberOfTimesUserHasSeenChangeboarding: 0
                };
            }
            (0, $gYnSx.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesResource',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            numberOfTimesUserHasSeenChangeboarding: modalViewCount,
            benefitsModal: {
                isDisabled: true,
                nextDateToShowBenefitsModal: null
            }
        };
    }
});
const $ac40f8141f9f880e$export$e21c345b2538e96e = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $eJrcF.useResource)($ac40f8141f9f880e$export$1b6468a6eb7d9b09);
    const [issueTransitionChangeboardingPreference, setIssueTransitionChangeboardingPreference] = (0, $eJOHy.useState)(()=>{
        if ((0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) return {
            numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
            benefitsModal: {
                isDisabled: Boolean(data?.benefitsModal?.isDisabled),
                nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
            }
        };
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') return data.numberOfTimesUserHasSeenChangeboarding;
        return 0, $k1FO2.USER_SEEN_CARDINALITY_UNKNOWN;
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eJOHy.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eJOHy.useState)('not started');
    const updateIssueTranstitionChangeboardingPreferences = (0, $eJOHy.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        const body = typeof updates !== 'number' && (0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal') ? {
            value: updates?.numberOfTimesUserHasSeenChangeboarding,
            benefitsModal: {
                isDisabled: updates?.benefitsModal?.isDisabled,
                nextDateToShowBenefitsModal: updates?.benefitsModal?.nextDateToShowBenefitsModal
            }
        } : {
            value: updates
        };
        try {
            await (0, $jGzN3.performPutRequest)((0, $k1FO2.ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API), {
                body: JSON.stringify(body)
            });
            setResponseStatusPut('success');
            let updateData;
            if (typeof updates !== 'number' && (0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates?.numberOfTimesUserHasSeenChangeboarding,
                benefitsModal: {
                    isDisabled: updates?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(updates?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            };
            if (typeof updates === 'number') updateData = {
                numberOfTimesUserHasSeenChangeboarding: updates
            };
            update(()=>updateData);
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'issueTransitionChangeboardingPreferencesUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionChangeboardingPreferences',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if ((0, $7jTnu.fg)('modern_issue_transition_enable_benefits_modal')) {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference({
                numberOfTimesUserHasSeenChangeboarding: Number(data?.numberOfTimesUserHasSeenChangeboarding),
                benefitsModal: {
                    isDisabled: data?.benefitsModal?.isDisabled || false,
                    nextDateToShowBenefitsModal: String(data?.benefitsModal?.nextDateToShowBenefitsModal) || null
                }
            });
            return;
        }
        if (typeof data?.numberOfTimesUserHasSeenChangeboarding === 'number') {
            setResponseStatusGet('success');
            setIssueTransitionChangeboardingPreference(data?.numberOfTimesUserHasSeenChangeboarding);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.numberOfTimesUserHasSeenChangeboarding,
        data?.benefitsModal?.isDisabled,
        data?.benefitsModal?.nextDateToShowBenefitsModal
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionChangeboardingPreference
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTranstitionChangeboardingPreferences
        }
    };
};

});
parcelRegister("exWdq", function(module, exports) {

var $1X4n0 = parcelRequire("1X4n0");

var $hnizX = parcelRequire("hnizX");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $a9714e29aa3d67ff$var$has(object, path) {
    return object != null && $hnizX(object, path, $1X4n0);
}
module.exports = $a9714e29aa3d67ff$var$has;

});
parcelRegister("1X4n0", function(module, exports) {
/** Used for built-in method references. */ var $16beb0f0df9137a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $16beb0f0df9137a5$var$hasOwnProperty = $16beb0f0df9137a5$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $16beb0f0df9137a5$var$baseHas(object, key) {
    return object != null && $16beb0f0df9137a5$var$hasOwnProperty.call(object, key);
}
module.exports = $16beb0f0df9137a5$var$baseHas;

});


parcelRegister("k1FO2", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES", () => $913722475ca36197$export$d66d4b761db3d20f);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_STATUS_RESOURCE_KEY", () => $913722475ca36197$export$79fd70b908f71ddd);
$parcel$export(module.exports, "ISSUE_TRANSITION_CHANGEBOARDING_PREFERENCES_VISIBILITY_API", () => $913722475ca36197$export$e5007258addba8aa);
$parcel$export(module.exports, "USER_SEEN_CARDINALITY_UNKNOWN", () => $913722475ca36197$export$91880069e7e73b18);
$parcel$export(module.exports, "DURATION_IN_DAYS_DEFAULT", () => $913722475ca36197$export$9ccdfd91f2512a27);
const $913722475ca36197$export$d66d4b761db3d20f = 'issue_transition_changeboarding_preferences';
const $913722475ca36197$export$79fd70b908f71ddd = 'issue_transition_changeboarding_preferences_status';
const $913722475ca36197$export$e5007258addba8aa = '/rest/api/3/mypreferences?key=jira.its.changeboarding.preferences';
const $913722475ca36197$export$91880069e7e73b18 = -1;
const $913722475ca36197$export$9ccdfd91f2512a27 = 14;

});


parcelRegister("aYBjl", function(module, exports) {

$parcel$export(module.exports, "issueTransitionOptInStatusResource", () => $85b874e0c5483f16$export$5fbcf4d7a6d9c477);
$parcel$export(module.exports, "useIssueTransitionLabsOptIn", () => $85b874e0c5483f16$export$bc11d4816053db5c);

var $eJOHy = parcelRequire("eJOHy");

var $lopBx = parcelRequire("lopBx");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $804bQ = parcelRequire("804bQ");
/*
 * API Contract: https://hello.atlassian.net/wiki/spaces/JIE/pages/2983777277/Issue+Transition+Jira+Labs+Toggle+for+Legacy+Experience+Backend+API#API-Contract
 */ const $85b874e0c5483f16$var$fetchGetIssueTransitionOptInState = async ()=>(0, $jGzN3.performGetRequest)((0, $873d221d3411e09a$export$466b1c60da56c8ca));
const $85b874e0c5483f16$export$5fbcf4d7a6d9c477 = (0, $l1VxS.createResource)({
    type: (0, $873d221d3411e09a$export$eb01e12fc3db65c0),
    getKey: ()=>(0, $873d221d3411e09a$export$a964df7bc15d81e),
    getData: async ()=>{
        let issueTransitionOptInStatus = null;
        const isModernIssueTransitionSRBCohort = (0, $7jTnu.fg)('issue-transition-customisation-for-srb') || (0, $lopBx.isFedRamp)();
        const isModernITSRenderEnabled = (0, $7jTnu.fg)('render-modern-issue-transition') || (0, $lopBx.isFedRamp)();
        if (!isModernITSRenderEnabled) return {
            issueTransitionOptInStatus: {
                isEnabled: false,
                expiryTime: -1
            }
        };
        if (isModernIssueTransitionSRBCohort) return {
            issueTransitionOptInStatus: {
                isEnabled: true
            }
        };
        try {
            issueTransitionOptInStatus = await $85b874e0c5483f16$var$fetchGetIssueTransitionOptInState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (error.statusCode === 404) (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'issueTransitionOptInStatusResource',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        return {
            issueTransitionOptInStatus: issueTransitionOptInStatus ?? (0, $804bQ.default)()
        };
    },
    maxAge: Number.MAX_VALUE
});
const $85b874e0c5483f16$var$fetchModifyIssueTransitionOptInState = async (payload)=>(0, $jGzN3.performPutRequest)((0, $873d221d3411e09a$export$466b1c60da56c8ca), {
        body: JSON.stringify(payload)
    });
const $85b874e0c5483f16$export$bc11d4816053db5c = ()=>{
    const { data: data, loading: loadingGetResource, error: errorGetResource, update: update } = (0, $eJrcF.useResource)($85b874e0c5483f16$export$5fbcf4d7a6d9c477);
    const [issueTransitionLabsOptInState, setIssueTransitionOptInState] = (0, $eJOHy.useState)(()=>{
        if (data?.issueTransitionOptInStatus) return data.issueTransitionOptInStatus;
        return (0, $804bQ.default)();
    });
    const [responseStatusGet, setResponseStatusGet] = (0, $eJOHy.useState)('not started');
    const [responseStatusPut, setResponseStatusPut] = (0, $eJOHy.useState)('not started');
    const updateIssueTransitionOptInStatus = (0, $eJOHy.useCallback)(async (updates)=>{
        let response = 'loading';
        setResponseStatusPut('loading');
        try {
            const updatedPreferences = await $85b874e0c5483f16$var$fetchModifyIssueTransitionOptInState(updates);
            setResponseStatusPut('success');
            update(()=>({
                    issueTransitionOptInStatus: updatedPreferences
                }));
            response = 'success';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gYnSx.default)({
                error: err,
                meta: {
                    id: 'issueTransitionOptInStatusUpdate',
                    packageName: 'jiraRouterResourcesIssueTransitionLabsOptIn',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setResponseStatusPut('error');
            response = 'error';
        }
        return response;
    }, [
        update
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (loadingGetResource) {
            setResponseStatusGet('loading');
            return;
        }
        if (errorGetResource) {
            setResponseStatusGet('error');
            return;
        }
        if (data?.issueTransitionOptInStatus) {
            setResponseStatusGet('success');
            setIssueTransitionOptInState(data.issueTransitionOptInStatus);
        }
    }, [
        loadingGetResource,
        errorGetResource,
        data?.issueTransitionOptInStatus
    ]);
    return {
        stateGet: {
            responseStatus: responseStatusGet,
            state: issueTransitionLabsOptInState
        },
        stateUpdate: {
            responseStatus: responseStatusPut,
            setState: updateIssueTransitionOptInStatus
        }
    };
};

});
const $873d221d3411e09a$export$eb01e12fc3db65c0 = 'issue_transition_opt_in';
const $873d221d3411e09a$export$a964df7bc15d81e = 'issue_transition_labs_opt_in_status';
const $873d221d3411e09a$export$466b1c60da56c8ca = '/rest/greenhopper/1.0/profile/labs-panel/modern-its-visibility';
const $873d221d3411e09a$export$880a78695d76498e = 8;

parcelRegister("804bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce05f913d0b3b9bd$export$2e2bcd8739ae039);

var $lopBx = parcelRequire("lopBx");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");
const $ce05f913d0b3b9bd$var$getDefaultIssueTransitionLabsOptInState = ()=>{
    const isModernITSRenderEnabled = (0, $7jTnu.fg)('render-modern-issue-transition') || (0, $lopBx.isFedRamp)();
    if (!isModernITSRenderEnabled) return {
        isEnabled: false,
        expiryTime: -1
    };
    const isModernIssueTransitionSRBCohort = (0, $7jTnu.fg)('issue-transition-customisation-for-srb') || (0, $lopBx.isFedRamp)();
    if (isModernIssueTransitionSRBCohort) return {
        isEnabled: true
    };
    return (0, $epTsa.expValEquals)('jira_issue_transition_screen_modernisation_toggle', 'value', 'BY_DEFAULT_USER_OPT_OUT') ? {
        isEnabled: false,
        expiryTime: -1
    } : {
        isEnabled: true
    };
};
var $ce05f913d0b3b9bd$export$2e2bcd8739ae039 = $ce05f913d0b3b9bd$var$getDefaultIssueTransitionLabsOptInState;

});


parcelRegister("1gbqq", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarAutomationLegacyEnabledResource", () => $bc0dbb530def7b92$export$fa191d7d71460a98);

var $aYncF = parcelRequire("aYncF");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

const $bc0dbb530def7b92$export$fa191d7d71460a98 = (0, $l1VxS.createResource)({
    type: (0, $bb95cd42467ae698$export$fd4fc70ec71927d1),
    getKey: ({ query: query })=>`jsm-legacy-automation-enabled-${query.projectKey}`,
    getData: async (_, { tenantContext: { licensedProducts: licensedProducts } })=>{
        const defaultValue = {
            enabled: true
        };
        if (!licensedProducts || !licensedProducts[(0, $aYncF.LICENSED_PRODUCTS).JIRA_SERVICEDESK]) return defaultValue;
        const { enabled: enabled } = await (0, $jGzN3.performGetRequest)('/rest/servicedesk/automation/1/legacy/state');
        return {
            enabled: enabled
        };
    },
    maxAge: Infinity
});

});
const $bb95cd42467ae698$export$fd4fc70ec71927d1 = 'AUTOMATION_IS_LEGACY_ENABLED';


parcelRegister("enHI7", function(module, exports) {

$parcel$export(module.exports, "navigationSidebarGlobalResource", () => $ef90c1839bc063ef$export$44e7ad3c66a3f25f);

var $i2m1e = parcelRequire("i2m1e");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

const $ef90c1839bc063ef$export$44e7ad3c66a3f25f = (0, $l1VxS.createResource)({
    type: (0, $70d26b9165f63401$export$fa5743fc6a1da5d8),
    getKey: ({ match: match, query: query })=>{
        // Refresh the data if the project key or id changes
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        return projectKey || projectId || '__state';
    },
    getData: async ({ match: match, query: query }, _storeContext)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const scope = {
            projectKey: projectKey,
            projectId: projectId
        };
        const response = await (0, $i2m1e.fetchSidebarConfig)(scope, false);
        return {
            response: response,
            scope: scope
        };
    },
    maxAge: 300000
});

});
parcelRegister("i2m1e", function(module, exports) {

$parcel$export(module.exports, "fetchSidebarConfig", () => $fab8a685dab84ca5$export$d1d13c4b972a22f1);

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");
const $fab8a685dab84ca5$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';

const $fab8a685dab84ca5$var$fetchUsingProtobuf = async (url)=>{
    try {
        const fetchProtobuf = await (parcelRequire("lXhex"));
        if (!fetchProtobuf) (0, $eSnSE.default).safeErrorWithoutCustomerData($fab8a685dab84ca5$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
        return fetchProtobuf.default(url);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData($fab8a685dab84ca5$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
        throw err;
    }
};
const $fab8a685dab84ca5$export$94e808b2557f52e = (requestQuery, version = '2', queryParams)=>{
    const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
    const params = {
        exclude: [
            'webItems.reports',
            'webItems.home',
            'webItems.gin',
            exclude
        ].filter(Boolean).join(',')
    };
    let path = '';
    if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
    else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
    else if (identifierValue != null) path = `project/${identifierValue}`;
    else {
        path = 'product';
        const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
        // Connect apps rely on project context even for the global/product scoped webItems
        const projectIdOrKey = projectId || projectKey;
        if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
    }
    const queryString = [
        new URLSearchParams(params).toString(),
        queryParams
    ].filter(Boolean).join('&');
    return `/rest/navigation/${version}/${path}?${queryString}`;
};
const $fab8a685dab84ca5$export$d1d13c4b972a22f1 = async (requestQuery, isServer, queryParams)=>{
    if (isServer) {
        const protoUrl = $fab8a685dab84ca5$export$94e808b2557f52e(requestQuery, '2.1', queryParams);
        return $fab8a685dab84ca5$var$fetchUsingProtobuf(protoUrl);
    }
    const sidebarUrl = $fab8a685dab84ca5$export$94e808b2557f52e(requestQuery, undefined, queryParams);
    return (0, $1Ozm9.default)(sidebarUrl);
};

});
parcelRegister("lXhex", function(module, exports) {

let $ffbc79e2be46dfa4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ffbc79e2be46dfa4$var$load("3LEU2").then(()=>parcelRequire('fPrr3'));

});


const $70d26b9165f63401$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';


parcelRegister("dfh4P", function(module, exports) {

$parcel$export(module.exports, "navigationUiStateResource", () => $51dec11bee852c78$export$14c178691841b423);
// eslint-disable-next-line jira/import-whitelist

var $LFmXM = parcelRequire("LFmXM");

var $l1VxS = parcelRequire("l1VxS");

var $9uKgD = parcelRequire("9uKgD");

const $51dec11bee852c78$var$getNavigationUiStateMemoized = (0, $LFmXM.default)((atlassianAccountId)=>(0, $9uKgD.getNavigationUiState)({
        tenantContext: {
            atlassianAccountId: atlassianAccountId
        }
    }));
const $51dec11bee852c78$export$14c178691841b423 = (0, $l1VxS.createResource)({
    type: 'RESOURCE_TYPE_NAVIGATION_UI',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$51dec11bee852c78$var$getNavigationUiStateMemoized(atlassianAccountId),
    maxAge: Infinity
});

});
parcelRegister("9uKgD", function(module, exports) {

$parcel$export(module.exports, "getNavigationUiState", () => $c6be53465a9fed60$export$29999268b070c9bd);

var $FppkK = parcelRequire("FppkK");


var $fwMnB = parcelRequire("fwMnB");
const $c6be53465a9fed60$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
    const { atlassianAccountId: accountId } = tenantContext;
    let uiState = await (0, $fwMnB.queryLocalStorage)();
    if (uiState || !accountId) return uiState;
    try {
        uiState = await (0, $FppkK.getUserProperty)(accountId, (0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8));
        // @ts-expect-error - TS2345 - Argument of type 'UIControllerShape | undefined' is not assignable to parameter of type 'UIControllerShape'.
        (0, $fwMnB.updateLocalStorageData)(uiState);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // Don't log the error on purpose. This is very frequent for some reason :(
    }
    return uiState;
};

});
const $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $1ebe0101b6fb87b8$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';

parcelRegister("fwMnB", function(module, exports) {

$parcel$export(module.exports, "queryLocalStorage", () => $04a476f65e66d73c$export$e192dcb908272d5);
$parcel$export(module.exports, "updateLocalStorageData", () => $04a476f65e66d73c$export$ec13c725e067146a);

var $12DRg = parcelRequire("12DRg");

var $7jTnu = parcelRequire("7jTnu");

var $eSnSE = parcelRequire("eSnSE");

var $dnU6V = parcelRequire("dnU6V");

const $04a476f65e66d73c$var$localStorageProvider = (0, $dnU6V.createLocalStorageProvider)('', false);
const $04a476f65e66d73c$export$e7db3fa51c63bc5c = ()=>{
    if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
    return {
        setItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        getItem: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    };
};
const $04a476f65e66d73c$var$queryLocalStorageSync = ()=>{
    const localStorage = $04a476f65e66d73c$export$e7db3fa51c63bc5c();
    const item = (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $04a476f65e66d73c$var$localStorageProvider.get((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8)) : localStorage.getItem((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8));
    if (!false && item) try {
        return JSON.parse(item);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $1ebe0101b6fb87b8$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
    }
};
const $04a476f65e66d73c$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
        const item = $04a476f65e66d73c$var$queryLocalStorageSync();
        resolve(item);
    });
const $04a476f65e66d73c$export$ec13c725e067146a = (data)=>{
    const localStorage = $04a476f65e66d73c$export$e7db3fa51c63bc5c();
    (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $04a476f65e66d73c$var$localStorageProvider.set((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(data)) : localStorage.setItem((0, $1ebe0101b6fb87b8$export$3e8fc5ba7287b4a8), JSON.stringify(data));
};

});
parcelRegister("dnU6V", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageProvider", () => $f14a980fc91d9f61$export$697e65b1658f821b);
$parcel$export(module.exports, "createLocalExpirableStorageProvider", () => $f14a980fc91d9f61$export$59acef2b3ab1df90);

var $5PQOA = parcelRequire("5PQOA");

var $iuNRp = parcelRequire("iuNRp");

var $itkIt = parcelRequire("itkIt");
const $f14a980fc91d9f61$export$697e65b1658f821b = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix, shouldSerialize = true)=>(0, $iuNRp.createStorageProvider)((0, $iuNRp.WebStorageType).LocalStorage, appPrefix, (0, $itkIt.makeLocalStore)(), shouldSerialize));
const $f14a980fc91d9f61$export$59acef2b3ab1df90 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix)=>{
    return (0, $iuNRp.createExpirableStorageProvider)((0, $iuNRp.WebStorageType).LocalStorage, appPrefix, (0, $itkIt.makeLocalExpirableStore)());
});

});
parcelRegister("iuNRp", function(module, exports) {

$parcel$export(module.exports, "plugins", () => $33d1e266f2cf3989$export$8b3ca321c77fdea6);
$parcel$export(module.exports, "WebStorageType", () => $33d1e266f2cf3989$export$259e3a861f28589b);
$parcel$export(module.exports, "createStorageProvider", () => $33d1e266f2cf3989$export$8441605555fbd60c);
$parcel$export(module.exports, "createExpirableStorageProvider", () => $33d1e266f2cf3989$export$b793a81cf479272a);

var $fsdQg = parcelRequire("fsdQg");

var $48TwY = parcelRequire("48TwY");

var $7jTnu = parcelRequire("7jTnu");

var $fCQ2g = parcelRequire("fCQ2g");
const $33d1e266f2cf3989$export$8b3ca321c77fdea6 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($fsdQg))),
    (0, $fCQ2g.default)
];
const $33d1e266f2cf3989$export$259e3a861f28589b = {
    LocalStorage: 'LocalStorage',
    SessionStorage: 'SessionStorage'
};
const $33d1e266f2cf3989$export$8441605555fbd60c = (storageType, appPrefix = '', // eslint-disable-next-line @typescript-eslint/no-explicit-any
store, shouldSerialize = true)=>{
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>appPrefix?.trim().length ? `${appPrefix}.${key}` : key;
    const storageAPI = storageType === $33d1e266f2cf3989$export$259e3a861f28589b.LocalStorage ? (0, $48TwY.AtlBrowserStorageLocal) : (0, $48TwY.AtlBrowserStorageSession);
    const browserStorage = storageType === $33d1e266f2cf3989$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setItem(prefixedKey, storageValue);
                } else namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const storageValue = shouldSerialize ? JSON.stringify(value) : value;
                    storageAPI.setStrictlyNecessaryItem(prefixedKey, storageValue);
                } else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error setting item in storage:', err);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let item;
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    // When the feature flag is enabled
                    if (appPrefix?.trim().length) {
                        // Case 1: App prefix exists (all the existing usages of jira-browser-storage-providers had app prefix)
                        item = storageAPI.getItem(prefixedKey);
                        if (typeof item === 'undefined' || item === null) {
                            // Check old store when data not found in new storage
                            const itemFromOldStore = namespacedStore.get(key);
                            if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                                // Migrate data from old store to new storage
                                const stringValue = JSON.stringify(itemFromOldStore);
                                storageAPI.setItem(prefixedKey, stringValue);
                                return itemFromOldStore;
                            }
                        }
                        if (typeof item === 'string') // If data found in new storage, return it
                        return shouldSerialize ? JSON.parse(item) : item;
                    }
                    // Case 2: No app prefix
                    item = storageAPI.getItem(prefixedKey);
                    if (typeof item === 'undefined' || item === null) {
                        // Check browser's localStorage for the key
                        const itemFromNativeBrowserStorage = browserStorage?.getItem(key);
                        if (typeof itemFromNativeBrowserStorage !== 'undefined' && itemFromNativeBrowserStorage !== null) {
                            // Migrate data to new storage
                            storageAPI.setItem(prefixedKey, itemFromNativeBrowserStorage);
                            return itemFromNativeBrowserStorage;
                        }
                    }
                    if (typeof item === 'string') // If data found in new storage, return it
                    return shouldSerialize ? JSON.parse(item) : item;
                } else return namespacedStore.get(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting item from storage:', err);
            }
        },
        remove: (key)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey); // remove data from new store
                    namespacedStore.remove(key); // remove data from old store as well
                } else namespacedStore.remove(key);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error removing item from storage:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access clearStorageValues method.');
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            if (!appPrefix) throw Error('appPrefix is necessary to access getNamespaceKeysLength method.');
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};
const $33d1e266f2cf3989$export$b793a81cf479272a = (storageType, appPrefix, // eslint-disable-next-line @typescript-eslint/no-explicit-any
store)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const namespacedStore = store.namespace(appPrefix);
    const getKeyWithPrefix = (key)=>`${appPrefix}.${key}`;
    const storageAPI = storageType === $33d1e266f2cf3989$export$259e3a861f28589b.LocalStorage ? (0, $48TwY.AtlBrowserStorageLocal) : (0, $48TwY.AtlBrowserStorageSession);
    const browserStorage = storageType === $33d1e266f2cf3989$export$259e3a861f28589b.LocalStorage ? globalThis.localStorage : globalThis.sessionStorage;
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: (key, value, expiration)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    const item = {
                        value: value,
                        expiration: expiration
                    };
                    const serializedValue = JSON.stringify(item);
                    storageAPI.setItem(prefixedKey, serializedValue);
                } else namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setStrictlyNecessaryItem: (key, value, expiration)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                const item = {
                    value: value,
                    expiration: expiration
                };
                const serializedValue = JSON.stringify(item);
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) storageAPI.setStrictlyNecessaryItem(prefixedKey, serializedValue);
                else // this has to be done when setStrictlyNecessaryItem comes into usage, and it should have a fallback when FG is turned off
                namespacedStore.set(key, value, expiration);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error setting item with key=${key}:`, error);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        get: (key)=>{
            try {
                let itemStr;
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const item = {
                                value: itemFromOldStore,
                                expiration: namespacedStore.getExpiration(key)
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return itemFromOldStore;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return;
                        }
                        return item.value;
                    }
                } else {
                    itemStr = namespacedStore.get(key);
                    return itemStr;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting item with key=${key}:`, error);
            }
        },
        getExpiration: (key)=>{
            try {
                const prefixedKey = getKeyWithPrefix(key);
                let itemStr;
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    itemStr = storageAPI.getItem(prefixedKey);
                    if (!itemStr) {
                        // check in the old store
                        const itemFromOldStore = namespacedStore.get(key);
                        if (typeof itemFromOldStore !== 'undefined' && itemFromOldStore !== null) {
                            const expiration = namespacedStore.getExpiration(key);
                            const item = {
                                value: itemFromOldStore,
                                expiration: expiration
                            };
                            storageAPI.setItem(prefixedKey, JSON.stringify(item)); // migrate to new store with new key
                            return expiration;
                        }
                    } else {
                        // check if the item is expired
                        const item = JSON.parse(itemStr);
                        if (item.expiration && item.expiration < Date.now()) {
                            storageAPI.removeItem(prefixedKey);
                            return undefined;
                        }
                        return item.expiration;
                    }
                } else return namespacedStore.getExpiration(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error getting expiration for item with key=${key}:`, error);
                return undefined;
            }
        },
        remove: (key)=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    const prefixedKey = getKeyWithPrefix(key);
                    storageAPI.removeItem(prefixedKey);
                    namespacedStore.remove(key);
                } else namespacedStore.remove(key);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Error removing item with key=${key}:`, error);
            }
        },
        removeExpiredKeys: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    for(let i = 0; i < storageAPI.length(); i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) {
                            const itemStr = storageAPI.getItem(key);
                            if (itemStr) {
                                const item = JSON.parse(itemStr);
                                if (item.expiration && item.expiration < Date.now()) {
                                    storageAPI.removeItem(key);
                                    i--;
                                }
                            }
                        }
                    }
                    namespacedStore.removeExpiredKeys(); // clean up old keys too
                } else namespacedStore.removeExpiredKeys();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error removing expired keys:', error);
            }
        },
        // Clears all the keys specific to the appPrefix
        clearStorageValues: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) for(let i = 0; i < storageAPI.length(); i++){
                    const key = storageAPI.key(i);
                    if (key && key.startsWith(`${appPrefix}.`)) {
                        storageAPI.removeItem(key);
                        i--;
                    }
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage values:', err);
            }
        },
        // Clears the complete storage
        clearAll: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    storageAPI.clear();
                    // clean up old keys too
                    namespacedStore.clearAll();
                } else namespacedStore.clearAll();
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error clearing storage:', err);
            }
        },
        length: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) return storageAPI.length();
                return browserStorage?.length || 0;
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error('Error getting storage length:', err);
                return 0;
            }
        },
        // unstable use it only if its absolutely necessary
        getPrefixedKeysLength: ()=>{
            try {
                if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) {
                    // For browser storage API
                    let count = 0;
                    const totalLength = storageAPI.length() || 0;
                    for(let i = 0; i < totalLength; i++){
                        const key = storageAPI.key(i);
                        if (key && key.startsWith(`${appPrefix}.`)) count++;
                    }
                    return count;
                }
                // For store library using native storage
                let count = 0;
                const totalLength = browserStorage?.length || 0;
                const namespacePrefix = `__storejs_${appPrefix}_`;
                for(let i = 0; i < totalLength; i++){
                    const key = browserStorage?.key(i);
                    if (key && key.startsWith(namespacePrefix)) count++;
                }
                return count;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error counting namespace keys:', error);
                return 0;
            }
        }
    };
};

});
parcelRegister("fCQ2g", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f4c9f88e8601068$export$2e2bcd8739ae039);

var $gYnSx = parcelRequire("gYnSx");

var $3YqQf = parcelRequire("3YqQf");
/**
 * Enhances storage operations with automated cleanup capabilities. This includes tracking
 * item timestamps for age-based cleanup, handling storage limits by removing older items,
 * and providing utility functions for managing storage contents. Designed to ensure
 * efficient use of storage space without manual intervention.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4f4c9f88e8601068$var$cleanUpPlugin() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $3YqQf.NAMESPACE));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function set(superFn, key, val) {
        try {
            if (!self.hasNamespace((0, $3YqQf.NAMESPACE))) timestamps.set(key, Date.now());
            superFn();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // storage is full. Relevant only for localStorage
            if (e.code === (0, $3YqQf.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $3YqQf.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                // 22 - the correct code most browsers use
                // 1014 - Firefox's code
                (0, $gYnSx.default)({
                    meta: {
                        id: 'browserLocalStorageFullError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        namespace: self._namespacePrefix
                    },
                    error: e,
                    skipSentry: true
                });
                if (self.cleanWhenFull()) self.set(superFn, key, val);
            } else {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'storageCleanupPluginError',
                        packageName: 'jiraBrowserStorageProviders',
                        teamName: 'magma'
                    },
                    attributes: {
                        isLegacyFunction: false
                    },
                    error: e
                });
                throw e;
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function remove(superFn, key) {
        if (!self.hasNamespace((0, $3YqQf.NAMESPACE))) timestamps.remove(key);
        return superFn();
    }
    // quite stupid way of getting totals, but current library supports only this.each()
    function getTotalCount() {
        let count = 0;
        self.each(()=>{
            count += 1;
        });
        return count;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function cleanWhenFull(superFn, minAge = (0, $3YqQf.FOUR_WEEKS)) {
        const currTime = Date.now();
        const numKeysBefore = self.getTotalCount();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        self.each((_value, key)=>{
            // return correct value for current collection
            // and return null for timestamps collection
            const created = !self.hasNamespace((0, $3YqQf.NAMESPACE)) ? timestamps.get(key) : null;
            if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
        });
        const itemsRemovedCount = numKeysBefore - self.getTotalCount();
        if (!itemsRemovedCount && minAge - (0, $3YqQf.ONE_WEEK) >= (0, $3YqQf.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $3YqQf.ONE_WEEK));
        return itemsRemovedCount === 0;
    }
    return {
        set: set,
        remove: remove,
        cleanWhenFull: cleanWhenFull,
        getTotalCount: getTotalCount
    };
}
var $4f4c9f88e8601068$export$2e2bcd8739ae039 = $4f4c9f88e8601068$var$cleanUpPlugin;

});
parcelRegister("3YqQf", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE", () => $9a0e43db8e6f79e8$export$6aad947bda0f3f46);
$parcel$export(module.exports, "ONE_WEEK", () => $9a0e43db8e6f79e8$export$8187f416f1cc43d8);
$parcel$export(module.exports, "FOUR_WEEKS", () => $9a0e43db8e6f79e8$export$6e952fa7d47190cf);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", () => $9a0e43db8e6f79e8$export$da99ebca8f453abd);
$parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", () => $9a0e43db8e6f79e8$export$ea28dfd9333cda2d);
const $9a0e43db8e6f79e8$export$6aad947bda0f3f46 = 'timestamps';
const $9a0e43db8e6f79e8$export$8187f416f1cc43d8 = 604800000;
const $9a0e43db8e6f79e8$export$6e952fa7d47190cf = 4 * $9a0e43db8e6f79e8$export$8187f416f1cc43d8;
const $9a0e43db8e6f79e8$export$da99ebca8f453abd = 22;
const $9a0e43db8e6f79e8$export$ea28dfd9333cda2d = 1014;

});



parcelRegister("itkIt", function(module, exports) {

$parcel$export(module.exports, "makeLocalStore", () => $987a5374f8deacb5$export$b2631085fe8db7af);
$parcel$export(module.exports, "isLocalStorageAvailable", () => $987a5374f8deacb5$export$117a30df0da2af20);
$parcel$export(module.exports, "makeLocalExpirableStore", () => $987a5374f8deacb5$export$cf816b43e73de947);

var $fsdQg = parcelRequire("fsdQg");

var $252Bx = parcelRequire("252Bx");

var $02LWr = parcelRequire("02LWr");

var $jdVjN = parcelRequire("jdVjN");

var $jZWi5 = parcelRequire("jZWi5");

var $iuNRp = parcelRequire("iuNRp");
const $987a5374f8deacb5$export$b2631085fe8db7af = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($jdVjN))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], (0, $iuNRp.plugins));
const $987a5374f8deacb5$export$117a30df0da2af20 = ()=>typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
const $987a5374f8deacb5$export$cf816b43e73de947 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($jdVjN))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fsdQg))),
        (0, (/*@__PURE__*/$parcel$interopDefault($252Bx)))
    ]);

});





parcelRegister("5zQIb", function(module, exports) {

$parcel$export(module.exports, "newIssueViewTransitionLockInStatusResource", () => $26da57008bc6c8b7$export$babbf5bfbc4d268c);
$parcel$export(module.exports, "DEFAULT_TO_OLD_ISSUE_VIEW", () => $26da57008bc6c8b7$export$f269c0bf10ad77e2);
$parcel$export(module.exports, "useNewIssueViewLockedInStatus", () => $26da57008bc6c8b7$export$3b09097f2a423abd);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $26da57008bc6c8b7$export$babbf5bfbc4d268c = (0, $l1VxS.createResource)({
    type: (0, $04dbca965a7f77be$export$fdb92aeacda42553),
    getKey: ()=>'newIssueViewTransitionLockingStatus',
    getDataLoader: ()=>(parcelRequire("7hVBt")),
    maxAge: Number.MAX_VALUE
});
const $26da57008bc6c8b7$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $26da57008bc6c8b7$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $26da57008bc6c8b7$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';
const $26da57008bc6c8b7$export$3b09097f2a423abd = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $eJrcF.useResource)($26da57008bc6c8b7$export$babbf5bfbc4d268c);

});
const $04dbca965a7f77be$export$fdb92aeacda42553 = 'NEW_ISSUE_VIEW_LOCK_IN_STATUS';

parcelRegister("7hVBt", function(module, exports) {

let $54e6cdc84b10f0fb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $54e6cdc84b10f0fb$var$load("5oPus").then(()=>parcelRequire('1YfCq'));

});


parcelRegister("cqUpU", function(module, exports) {

$parcel$export(module.exports, "persistentIssueCreateModalViewResource", () => $ca7e29547f8b9439$export$266a039a005e8314);

var $l1VxS = parcelRequire("l1VxS");


const $ca7e29547f8b9439$export$266a039a005e8314 = (0, $l1VxS.createResource)({
    type: (0, $0f8f8ea7f8143316$export$f658cfd591eb583e),
    getKey: ()=>'state',
    getDataLoader: ()=>(parcelRequire("h4Fqe")),
    maxAge: Number.MAX_VALUE
});

});
const $0f8f8ea7f8143316$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $0f8f8ea7f8143316$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $0f8f8ea7f8143316$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';

parcelRegister("h4Fqe", function(module, exports) {

let $c6e2f0f61ebd78aa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c6e2f0f61ebd78aa$var$load("3nwDR").then(()=>parcelRequire('9RwzH'));

});


parcelRegister("dZRaT", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $4af98aebc4dee24b$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $4af98aebc4dee24b$export$d75816e37af81473);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");


const $4af98aebc4dee24b$var$getDataLoader = ()=>(parcelRequire("drJlZ"));
const $4af98aebc4dee24b$export$27ad0d75c619be68 = (0, $l1VxS.createResource)({
    type: (0, $c8eeacd6960f72dc$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>(0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getDataLoader: $4af98aebc4dee24b$var$getDataLoader,
    maxAge: 1800000
});
const $4af98aebc4dee24b$export$d75816e37af81473 = $4af98aebc4dee24b$export$27ad0d75c619be68;

});
const $c8eeacd6960f72dc$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("drJlZ", function(module, exports) {

let $9ca0fa49670f10a4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ca0fa49670f10a4$var$load("kXuGX").then(()=>parcelRequire('h0bmE'));

});


parcelRegister("2emAF", function(module, exports) {

$parcel$export(module.exports, "fetchSiteTraitsResource", () => $ef9e2dbc0959350e$export$379923e7c903a55d);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

var $lctcw = parcelRequire("lctcw");


const $ef9e2dbc0959350e$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}`;
        const response = false ? (await (0, $jGzN3.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $lctcw.memoizedFetchSitePersonalization)({
            cloudId: cloudId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: (0, $aa00244bb9a84571$export$7f111648ca05f056),
                packageName: (0, $33cafeed9becac72$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $ef9e2dbc0959350e$export$379923e7c903a55d = (0, $l1VxS.createResource)({
    type: (0, $aa00244bb9a84571$export$6f0555de4f60e84e),
    getKey: ()=>(0, $aa00244bb9a84571$export$7e7d7930e22ba39f),
    getData: $ef9e2dbc0959350e$var$getData,
    maxAge: Number.MAX_VALUE
});

});
parcelRegister("lctcw", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSitePersonalization", () => $b8fe630b0608ec20$export$671fb03be30194c3);
$parcel$export(module.exports, "useSitePersonalization", () => $b8fe630b0608ec20$export$58982988039b926f);

var $LFmXM = parcelRequire("LFmXM");

var $hPZg4 = parcelRequire("hPZg4");

var $1Ozm9 = parcelRequire("1Ozm9");
const $b8fe630b0608ec20$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $b8fe630b0608ec20$export$ddf4964d2a406b6a = async ({ cloudId: cloudId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    const { attributes: attributes } = await (0, $1Ozm9.default)($b8fe630b0608ec20$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $b8fe630b0608ec20$export$671fb03be30194c3 = (0, $LFmXM.default)($b8fe630b0608ec20$export$ddf4964d2a406b6a, ([{ cloudId: newCloudId }], [{ cloudId: lastCloudId }])=>newCloudId === lastCloudId);
const $b8fe630b0608ec20$export$58982988039b926f = ()=>(0, $hPZg4.useService)($b8fe630b0608ec20$export$671fb03be30194c3);

});
parcelRegister("hPZg4", function(module, exports) {

$parcel$export(module.exports, "useService", () => $ca6dc04f01b0b806$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $ca6dc04f01b0b806$export$c963713a27525aaf);

var $eJOHy = parcelRequire("eJOHy");
const $ca6dc04f01b0b806$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eJOHy.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eJOHy.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $ca6dc04f01b0b806$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eJOHy.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $ca6dc04f01b0b806$export$6de4685a6c88b4e9(request, initialState);
    (0, $eJOHy.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


const $33cafeed9becac72$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesGrowthRecommendations';

const $aa00244bb9a84571$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_SITE_TRAITS';
const $aa00244bb9a84571$export$7e7d7930e22ba39f = 'recommendations-fetch-site-traits-resource-key';
const $aa00244bb9a84571$export$7f111648ca05f056 = 'useResource.fetchRecommendationsSiteTraits';


parcelRegister("bvwBX", function(module, exports) {

$parcel$export(module.exports, "fetchUserTraitsResource", () => $2d9a8917da259545$export$d5198d02e9089545);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

var $lFovQ = parcelRequire("lFovQ");


const $2d9a8917da259545$var$getData = async (_, { tenantContext: tenantContext })=>{
    try {
        if (tenantContext.isAnonymous) return null;
        const accountId = tenantContext.atlassianAccountId ?? '';
        const cloudId = tenantContext.cloudId;
        const ssrUrl = `/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const response = false ? (await (0, $jGzN3.performGetRequest)(ssrUrl, {
            headers: {
                'x-ssr-service-name': 'tap-delivery'
            }
        }))?.attributes : await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
            cloudId: cloudId,
            userId: accountId
        });
        if (response) return response;
        return null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: (0, $e2e199d119a9299f$export$7f111648ca05f056),
                packageName: (0, $33cafeed9becac72$export$b8b9d90f9e5bd72b)
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};
const $2d9a8917da259545$export$d5198d02e9089545 = (0, $l1VxS.createResource)({
    type: (0, $e2e199d119a9299f$export$6f0555de4f60e84e),
    getKey: ()=>(0, $e2e199d119a9299f$export$7e7d7930e22ba39f),
    getData: $2d9a8917da259545$var$getData,
    maxAge: Number.MAX_VALUE
});

});
parcelRegister("lFovQ", function(module, exports) {

$parcel$export(module.exports, "fetchSiteUserPersonalization", () => $14b13fbf5780b414$export$8f40704723ec6690);
$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $14b13fbf5780b414$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $14b13fbf5780b414$export$8dc79ff315095801);

var $LFmXM = parcelRequire("LFmXM");

var $hPZg4 = parcelRequire("hPZg4");

var $1Ozm9 = parcelRequire("1Ozm9");
const $14b13fbf5780b414$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $14b13fbf5780b414$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $1Ozm9.default)($14b13fbf5780b414$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $14b13fbf5780b414$export$de93ec54b11be450 = (0, $LFmXM.default)($14b13fbf5780b414$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $14b13fbf5780b414$export$8dc79ff315095801 = ()=>(0, $hPZg4.useService)($14b13fbf5780b414$export$de93ec54b11be450);

});

const $e2e199d119a9299f$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_FETCH_USER_TRAITS';
const $e2e199d119a9299f$export$7e7d7930e22ba39f = 'recommendations-fetch-traits-resource-key';
const $e2e199d119a9299f$export$7f111648ca05f056 = 'useResource.fetchRecommendationsUserTraits';


parcelRegister("68g4a", function(module, exports) {

$parcel$export(module.exports, "jpdRecommendationDismissedResource", () => $49b8368db856ef30$export$5db7c4562b672f52);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $6zXPf = parcelRequire("6zXPf");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");


const $49b8368db856ef30$export$5db7c4562b672f52 = (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('blu-3929-sidebar-menu-recommended'), (0, $l1VxS.createResource)({
    type: (0, $2600fd317e4ea417$export$6f0555de4f60e84e),
    getKey: ()=>(0, $2600fd317e4ea417$export$7e7d7930e22ba39f),
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return {
                hasDismissed: true
            };
            const accountId = tenantContext.atlassianAccountId;
            const response = await (0, $jGzN3.performGetRequest)(`/rest/api/latest/user/properties/JpdRecommendationDismissed?accountId=${accountId}`);
            return {
                hasDismissed: response?.value ?? false
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const initialValueNeverSet = error.statusCode === 404;
            if (initialValueNeverSet) /**
					 * If the user has never set the preference, they have never dismissed.
					 */ return {
                hasDismissed: false
            };
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: (0, $2600fd317e4ea417$export$7f111648ca05f056),
                    packageName: (0, $33cafeed9becac72$export$b8b9d90f9e5bd72b)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
        /* on error return true - this ensures we don't show the recommendation if we don't know if they have dismissed */ return {
            hasDismissed: true
        };
    },
    maxAge: Number.MAX_VALUE
}));

});
const $2600fd317e4ea417$export$6f0555de4f60e84e = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
const $2600fd317e4ea417$export$7e7d7930e22ba39f = 'recommendations-dismissed-jpd-resource-key';
const $2600fd317e4ea417$export$7f111648ca05f056 = 'useResource.fetchRecommendationsDismissedJpd';


parcelRegister("lb6FK", function(module, exports) {

$parcel$export(module.exports, "rovoEntitlementResource", () => $010e266d7d00b5af$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $010e266d7d00b5af$export$b9cee3799212b85a);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

const $010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $010e266d7d00b5af$var$getRovoEnabledBasedOnExperiment = ({ isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled })=>{
    // if Rovo is not enabled, we don't need to check the experiment
    if (!isRovoEnabled) return {
        isRovoEnabled: isRovoEnabled,
        isRovoLLMEnabled: isRovoLLMEnabled
    };
    // If a user is in the Control cohort we're overriding the entitlement check with false to NOT serve Rovo experience.
    // Test cohort: users who get the new Rovo experience -> do NOT override the TCS entitlement.
    // Control cohort: users who get the legacy experience (the baseline) -> override the TCS entitlement with false.
    if ((0, $epTsa.expValEquals)('rovo_team25_rollout_performance_exp', 'cohort', 'control', 'test')) return {
        isRovoEnabled: false,
        isRovoLLMEnabled: false
    };
    // A repeat of the above as a second expeirmenet
    // Tenants should only be in one or the other, controlled by the targetting gate
    if ((0, $epTsa.expValEquals)('rovo_team25_rollout_perf_b3a_exp', 'cohort', 'control', 'test')) return {
        isRovoEnabled: false,
        isRovoLLMEnabled: false
    };
    return {
        isRovoEnabled: isRovoEnabled,
        isRovoLLMEnabled: isRovoLLMEnabled
    };
};
const $010e266d7d00b5af$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $a630de669343b4d7$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    shouldShowRovoLLMEnabled: (0, $7jTnu.fg)('rovo_use_rovo_llm_enabled_check')
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $gYnSx.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        const isRovoEnabled = response.data?.jira?.isRovoEnabled ?? null;
        // defaulting to isRovoEnabled if the feature flag is not enabled
        const isRovoLLMEnabled = (0, $7jTnu.fg)('rovo_use_rovo_llm_enabled_check') ? response.data?.jira_isRovoLLMEnabled ?? null : isRovoEnabled;
        return $010e266d7d00b5af$var$getRovoEnabledBasedOnExperiment({
            isRovoEnabled: isRovoEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null,
        isRovoLLMEnabled: undefined
    };
};
const $010e266d7d00b5af$export$a0974cf24d16bc5d = (0, $l1VxS.createResource)({
    type: $010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$010e266d7d00b5af$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity
});
const $010e266d7d00b5af$export$b9cee3799212b85a = ()=>(0, $eJrcF.useResource)($010e266d7d00b5af$export$a0974cf24d16bc5d);

});
const $a630de669343b4d7$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;


parcelRegister("cxQGT", function(module, exports) {

$parcel$export(module.exports, "themePreferenceResource", () => $5f480f6098caae1f$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $5f480f6098caae1f$export$3416635c8aeb5bab);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $fWIQB = parcelRequire("fWIQB");

const $5f480f6098caae1f$var$getDataLoader = ()=>(parcelRequire("jyhEj"));
const $5f480f6098caae1f$export$e5a423d1eb1cf1d0 = (0, $l1VxS.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $5f480f6098caae1f$var$getDataLoader,
    maxAge: 300000
});
const $5f480f6098caae1f$export$3416635c8aeb5bab = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $eJrcF.useResource)($5f480f6098caae1f$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $eJOHy.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $256811ed117b45d8$export$89c5cf64ad15c3ea),
            actionSubject: (0, $256811ed117b45d8$export$9e2cc65718a61846)
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eJOHy.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $fWIQB.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
const $256811ed117b45d8$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $256811ed117b45d8$export$9e2cc65718a61846 = 'themePreference';
const $256811ed117b45d8$export$89c5cf64ad15c3ea = 'changed';

parcelRegister("fWIQB", function(module, exports) {

$parcel$export(module.exports, "setThemePreference", () => $43e3efe56f96aef4$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $43e3efe56f96aef4$export$2f7a12048d96237);

var $hzgTF = parcelRequire("hzgTF");

var $gYnSx = parcelRequire("gYnSx");

var $9DB7T = parcelRequire("9DB7T");

const $43e3efe56f96aef4$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $9DB7T.userPreferenceAPI).set((0, $256811ed117b45d8$export$40bd77e1c9f49c27), theme);
    promise.catch((error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $43e3efe56f96aef4$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $9DB7T.userPreferenceAPI).get((0, $256811ed117b45d8$export$40bd77e1c9f49c27));
    promise.catch((error)=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $hzgTF.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $gYnSx.default)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $hzgTF.ThemeOptions).includes(theme) ? theme : undefined;
};

});
parcelRegister("hzgTF", function(module, exports) {

$parcel$export(module.exports, "ThemeOptions", () => $e6600b9fe64b6e3b$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $e6600b9fe64b6e3b$export$2faeed762aac6741);
// This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $e6600b9fe64b6e3b$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $e6600b9fe64b6e3b$export$2faeed762aac6741 = 'light';

});


parcelRegister("jyhEj", function(module, exports) {

let $e3bee21607c99852$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e3bee21607c99852$var$load("ffQaD"),
    $e3bee21607c99852$var$load("kvRbA"),
    $e3bee21607c99852$var$load("62I9B")
]).then(()=>parcelRequire('fgD68'));

});


parcelRegister("aUy7d", function(module, exports) {

$parcel$export(module.exports, "userHomepageResource", () => $087598b26d31627a$export$16320dd0d1e6c145);

var $jGzN3 = parcelRequire("jGzN3");

var $l1VxS = parcelRequire("l1VxS");

const $087598b26d31627a$export$16320dd0d1e6c145 = (0, $l1VxS.createResource)({
    type: (0, $3eb5263dc85dae9a$export$2026a6db44b15de7),
    getKey: ()=>'state',
    getData: async (_dataContext, _storeContext)=>{
        const { homepagePreference: homepagePreference } = await (0, $jGzN3.performGetRequest)('/rest/internal/3/homepage/');
        return {
            homepagePreference: homepagePreference
        };
    },
    maxAge: Infinity
});

});
const $3eb5263dc85dae9a$export$2026a6db44b15de7 = 'USER_HOMEPAGE';


parcelRegister("5fjzQ", function(module, exports) {

$parcel$export(module.exports, "postOfficeJiraSideNavResource", () => $14f67614a8998d75$export$5fd5ab86e70497f7);
$parcel$export(module.exports, "postOfficeJiraYourWorkResource", () => $14f67614a8998d75$export$5969dfe9b3b29cd3);
$parcel$export(module.exports, "postOfficeJiraTopBannerResource", () => $14f67614a8998d75$export$af242b8c8ffaab42);
$parcel$export(module.exports, "conditionalPostOfficeJiraTopBannerResource", () => $14f67614a8998d75$export$d1df0b3b482d298d);
// eslint-disable-next-line jira/import-whitelist

var $2xVkf = parcelRequire("2xVkf");

var $l1VxS = parcelRequire("l1VxS");

var $5L7qx = parcelRequire("5L7qx");

var $7jTnu = parcelRequire("7jTnu");
const $14f67614a8998d75$export$fd097948b42db8d3 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__SCREEN_SPACE_FLAGS',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('screen-space-flags', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$5fd5ab86e70497f7 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_SIDE_NAV',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-side-nav', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$5969dfe9b3b29cd3 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_YOUR_WORK',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-your-work', tenantContext);
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$af242b8c8ffaab42 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__JIRA_TOP_BANNER',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isSiteAdmin: isSiteAdmin } = tenantContext;
        if (isSiteAdmin) return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('jira-top-banner', tenantContext);
        return null;
    },
    maxAge: Infinity
});
const $14f67614a8998d75$export$d1df0b3b482d298d = (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jira-issue-term-refresh-banner'), $14f67614a8998d75$export$af242b8c8ffaab42);
const $14f67614a8998d75$export$1d4ef0f14729d528 = (0, $l1VxS.createResource)({
    type: 'POST_OFFICE_PLACEMENT__NAV_4_SECTION',
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return null;
        return (0, $2xVkf.preloadPostOfficePlacementWithTenantContext)('nav-4-section', tenantContext);
    },
    maxAge: Infinity
});

});
parcelRegister("2xVkf", function(module, exports) {

$parcel$export(module.exports, "usePlacementSSRFetch", () => $172104d4dfe494d0$export$420f2f91a928b3b6);
$parcel$export(module.exports, "preloadPostOfficePlacementWithTenantContext", () => $172104d4dfe494d0$export$65b5eab182e1ca6f);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $i0k0q = parcelRequire("i0k0q");

var $7Zq2F = parcelRequire("7Zq2F");

var $eJrcF = parcelRequire("eJrcF");

var $dCq6B = parcelRequire("dCq6B");
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $172104d4dfe494d0$var$preloadPostOfficePlacement = async (placementId, contextOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    const jiraFetcherWithS2SHeaders = async (url)=>{
        let hostEnv = 'prod';
        if (environment.currentEnv !== 'production') hostEnv = 'staging';
        const fetchHeaders = {
            'x-ssr-service-name': 'post-office',
            'x-ssr-service-env': hostEnv
        };
        return (0, $jGzN3.performGetRequest)(url.replace('gateway/api/post-office/', ''), {
            headers: fetchHeaders
        });
    };
    return (0, $7Zq2F.requestInitialData)(placementId, postOfficeContext, false ? jiraFetcherWithS2SHeaders : (0, $jGzN3.performGetRequest), (0, $i0k0q.buildBasePath)(environment.currentEnv, environment.envConfigs));
};
const $172104d4dfe494d0$export$420f2f91a928b3b6 = (resource)=>{
    const { data: data } = (0, $eJrcF.useResource)(resource);
    return (0, $eJOHy.useCallback)(()=>{
        if (data) {
            /**
			 * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
			 * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
			 */ const init = {
                status: 200,
                statusText: 'ok!'
            };
            return Promise.resolve(new Response(JSON.stringify(data), init));
        }
    }, [
        data
    ]);
};
const $172104d4dfe494d0$export$17b92961ead3f211 = (resource)=>{
    const { data: data } = (0, $eJrcF.useResource)(resource);
    return data;
};
const $172104d4dfe494d0$export$65b5eab182e1ca6f = async (placementId, preloadedTenantContext)=>{
    return $172104d4dfe494d0$var$preloadPostOfficePlacement(placementId, {
        postOfficeContext: (0, $dCq6B.tenantToPostOfficeContext)(preloadedTenantContext),
        environment: {
            currentEnv: (0, $dCq6B.transformJiraEnvToPostOfficeEnvironment)(preloadedTenantContext.environment)
        }
    });
};

});
parcelRegister("i0k0q", function(module, exports) {

$parcel$export(module.exports, "buildBasePath", () => $7e5543bdcbf94fc0$export$e8b30f9c4a80230f);


var $dWans = parcelRequire("dWans");
const $7e5543bdcbf94fc0$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $dWans.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8);
    return {
        baseUrl: baseUrl,
        path: path
    };
};

});
var $a3af5d93f7abc0d3$exports = {};

$parcel$export($a3af5d93f7abc0d3$exports, "API_ORIGIN_TEST_SERVER", () => $a3af5d93f7abc0d3$export$5ca004be156a127a);
$parcel$export($a3af5d93f7abc0d3$exports, "API_ORIGIN_LOCAL", () => $a3af5d93f7abc0d3$export$1e9fed4c0197724c);
$parcel$export($a3af5d93f7abc0d3$exports, "API_PATHNAME_LOCAL", () => $a3af5d93f7abc0d3$export$919a9569bce66f17);
$parcel$export($a3af5d93f7abc0d3$exports, "API_PATHNAME_STG_PROD", () => $a3af5d93f7abc0d3$export$d4fe3482c88e73a8);
$parcel$export($a3af5d93f7abc0d3$exports, "REMOTE_MODULE_URI_LOCAL", () => $a3af5d93f7abc0d3$export$67be2569ef5d7666);
$parcel$export($a3af5d93f7abc0d3$exports, "REMOTE_MODULE_URI_STG", () => $a3af5d93f7abc0d3$export$b49738b89db261cd);
$parcel$export($a3af5d93f7abc0d3$exports, "REMOTE_MODULE_URI_PROD", () => $a3af5d93f7abc0d3$export$bbd96cd490b0df63);
const $a3af5d93f7abc0d3$export$5ca004be156a127a = 'http://localhost:4224';
const $a3af5d93f7abc0d3$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $a3af5d93f7abc0d3$export$1e9fed4c0197724c = 'http://localhost:8081';
const $a3af5d93f7abc0d3$export$919a9569bce66f17 = '/api/v1/placements/';
const $a3af5d93f7abc0d3$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $a3af5d93f7abc0d3$export$67be2569ef5d7666 = 'http://localhost:9009';
const $a3af5d93f7abc0d3$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $a3af5d93f7abc0d3$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';

parcelRegister("dWans", function(module, exports) {

$parcel$export(module.exports, "defaultEnvironmentValues", () => $656fe8b089a88f92$export$b4ede87479bfcf09);
$parcel$export(module.exports, "PostOfficeEnvironmentProvider", () => $656fe8b089a88f92$export$604607f913ef367c);
$parcel$export(module.exports, "usePostOfficeEnvironment", () => $656fe8b089a88f92$export$877b97169cc75e8b);

var $eJOHy = parcelRequire("eJOHy");

const $656fe8b089a88f92$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        'test-server': {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $a3af5d93f7abc0d3$export$5ca004be156a127a),
                pathname: (0, $a3af5d93f7abc0d3$export$5ca004be156a127a),
                searchParams: undefined
            }
        },
        test: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $a3af5d93f7abc0d3$export$1e9fed4c0197724c),
                pathname: (0, $a3af5d93f7abc0d3$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $a3af5d93f7abc0d3$export$1e9fed4c0197724c),
                pathname: (0, $a3af5d93f7abc0d3$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$67be2569ef5d7666),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $a3af5d93f7abc0d3$export$1e9fed4c0197724c),
                pathname: (0, $a3af5d93f7abc0d3$export$919a9569bce66f17),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$b49738b89db261cd),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $a3af5d93f7abc0d3$export$bbd96cd490b0df63),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $a3af5d93f7abc0d3$export$d4fe3482c88e73a8),
                searchParams: undefined
            }
        }
    }
};
const $656fe8b089a88f92$export$fceca2c399b32565 = (0, $eJOHy.createContext)($656fe8b089a88f92$export$b4ede87479bfcf09);
const $656fe8b089a88f92$export$604607f913ef367c = $656fe8b089a88f92$export$fceca2c399b32565.Provider;
const $656fe8b089a88f92$export$877b97169cc75e8b = ()=>(0, $eJOHy.useContext)($656fe8b089a88f92$export$fceca2c399b32565);

});


parcelRegister("7Zq2F", function(module, exports) {

$parcel$export(module.exports, "requestInitialData", () => $c75006f6f2b46913$export$c4c39037cc4b06ab);
const $c75006f6f2b46913$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $c75006f6f2b46913$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $c75006f6f2b46913$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};

});

parcelRegister("dCq6B", function(module, exports) {

$parcel$export(module.exports, "tenantToPostOfficeContext", () => $509e2223bb06925e$export$d8f2c334a0924146);
$parcel$export(module.exports, "subproductToEdition", () => $509e2223bb06925e$export$2d690d13b91ea44f);
$parcel$export(module.exports, "transformJiraEnvToPostOfficeEnvironment", () => $509e2223bb06925e$export$cfacfecb20987ff1);

var $goBB5 = parcelRequire("goBB5");
const $509e2223bb06925e$var$JIRA_PRODUCT = 'jira';
const $509e2223bb06925e$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $509e2223bb06925e$var$JIRA_PRODUCT,
    locale: 'en'
};
const $509e2223bb06925e$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return (0, $goBB5.JiraWorkspaceAri).create({
        activationId: activationId,
        siteId: cloudId
    }).toString();
};
const $509e2223bb06925e$export$d8f2c334a0924146 = (tenantData)=>{
    const { activationId: activationId, cloudId: cloudId, isSiteAdmin: isSiteAdmin, locale: locale, isAdmin: isAdmin } = tenantData;
    const workspaceAri = $509e2223bb06925e$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$509e2223bb06925e$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        isSiteAdmin: isSiteAdmin,
        tenantId: cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        isAdmin: isAdmin,
        orgId: undefined,
        subproduct: undefined,
        productEdition: undefined
    };
};
const $509e2223bb06925e$export$2d690d13b91ea44f = (subproduct, editions)=>{
    switch(subproduct){
        case 'core':
            return editions.core;
        case 'software':
            return editions.software;
        case 'customerService':
            return editions.customerService;
        case 'serviceDesk':
            return editions.serviceDesk;
        default:
            undefined;
    }
};
const $509e2223bb06925e$export$cfacfecb20987ff1 = (environment)=>{
    switch(environment){
        case 'dev':
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        case 'local':
            return 'local';
        default:
            return 'local';
    }
};

});



parcelRegister("hXbwo", function(module, exports) {

$parcel$export(module.exports, "previewPanelStateResource", () => $9c99d47f78a5b0ec$export$c2ef0c3db4ecdea3);

var $9FYIg = parcelRequire("9FYIg");

var $gOhSQ = parcelRequire("gOhSQ");
const $9c99d47f78a5b0ec$export$c2ef0c3db4ecdea3 = (0, $9FYIg.createRelayResource)({
    type: `${(0, $9FYIg.RELAY_RESOURCE_TYPE)}_PREVIEW_PANEL`,
    getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
            parameters: (0, $gOhSQ.default),
            variables: {
                cloudId: cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
});

});
parcelRegister("gOhSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67849424e576d32a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7608bc86a22fc5b75aa29f223aaf4d1>>
 * @relayHash b395f613968319e8a511c65e3f1ee5fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2
const $67849424e576d32a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "concreteType": "JiraPreviewPanelState",
        "kind": "LinkedField",
        "name": "previewPanel",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraNavigationUIStateUserProperty",
                            "kind": "LinkedField",
                            "name": "navigationUIState",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0bd19038110f3e5bb601e887eb92c999d5f1bd367631b389e79e2bc34a42c0a2",
            "metadata": {},
            "name": "PreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$67849424e576d32a$var$node.hash = "7327e4b44435e860a8ce1fbd4e39a463";
var $67849424e576d32a$export$2e2bcd8739ae039 = $67849424e576d32a$var$node;

});


parcelRegister("lzT4f", function(module, exports) {

$parcel$export(module.exports, "jsmGracePeriodAnnouncementDisplayStateResource", () => $20a65304ac3aab9f$export$9c4218ae35fac02e);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementDisplayStateResource", () => $20a65304ac3aab9f$export$fed541e4e6eb934c);
$parcel$export(module.exports, "jsmGracePeriodAnnouncementGpEndDateResource", () => $20a65304ac3aab9f$export$ee26341514033dab);
$parcel$export(module.exports, "useJsmGracePeriodAnnouncementGpEndDateResource", () => $20a65304ac3aab9f$export$6b1dcceb1bcecc4c);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $gCeeo = parcelRequire("gCeeo");

var $22xih = parcelRequire("22xih");

const $20a65304ac3aab9f$export$9c4218ae35fac02e = (0, $l1VxS.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_DISPLAY_STATE',
    getDataLoader: ()=>(parcelRequire("hJjYL")),
    maxAge: Infinity
});
const $20a65304ac3aab9f$var$getNewAnnouncementDismissState = (bannerType, baseDisplayState, useNewT90State)=>{
    const newT90State = useNewT90State ? 'hideT90BannerNew' : 'hideT90Banner';
    const updatedState = {
        ...baseDisplayState,
        [bannerType === 'T30' ? 'hideT30Banner' : newT90State]: true
    };
    return updatedState;
};
const $20a65304ac3aab9f$export$fed541e4e6eb934c = (accountId)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $eJrcF.useResource)($20a65304ac3aab9f$export$9c4218ae35fac02e);
    const loadingRef = (0, $eJOHy.useRef)(false);
    const errorRef = (0, $eJOHy.useRef)();
    const [userPropertiesError, setUserPropertiesError] = (0, $eJOHy.useState)();
    errorRef.current = userPropertiesError || error;
    const dismissAnnouncement = (0, $eJOHy.useCallback)((baseState, bannerType, analyticsEvent, useNewT90State)=>{
        update(()=>$20a65304ac3aab9f$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State));
        if (accountId) {
            if (loadingRef.current) {
                const err = new Error('User properties is loading');
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Seqouia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setUserPropertiesError(err);
                return Promise.reject(err);
            }
            loadingRef.current = true;
            return (0, $FppkK.setUserProperties)(accountId, (0, $22xih.JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify($20a65304ac3aab9f$var$getNewAnnouncementDismissState(bannerType, baseState, useNewT90State))).catch((err)=>{
                setUserPropertiesError(new Error('Error occured while setting user properties'));
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useJsmGracePeriodAnnouncementResource-update',
                        packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
                        teamName: 'Sequoia'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                // SQA-804: Add more typeOfUserEngagement attributes when we release the banner to low engaged GPC
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'dismissJsmGracePeriodBanner', {
                    source: 'jsmGracePeriodBanner',
                    bannerType: bannerType,
                    typeOfUserEngagement: 'high'
                });
                loadingRef.current = false;
            });
        }
    }, [
        update,
        accountId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (errorRef.current || loading || !data || !accountId) return {
            loading: loading,
            displayState: {
                hideT30Banner: true,
                hideT90Banner: true,
                hideT90BannerNew: true
            },
            dismissAnnouncement: dismissAnnouncement
        };
        return {
            displayState: data,
            loading: loading,
            dismissAnnouncement: dismissAnnouncement
        };
    }, [
        loading,
        data,
        accountId,
        dismissAnnouncement
    ]);
};

const $20a65304ac3aab9f$export$ee26341514033dab = (0, $l1VxS.createResource)({
    type: 'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getKey: ()=>'JSM_GRACE_PERIOD_ANNOUNCEMENT_GP_END_DATE',
    getDataLoader: ()=>(parcelRequire("4DqMx")),
    maxAge: Infinity
});
const $20a65304ac3aab9f$export$6b1dcceb1bcecc4c = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($20a65304ac3aab9f$export$ee26341514033dab);
    const errorRef = (0, $eJOHy.useRef)();
    errorRef.current = error;
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        refresh,
        error
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (errorRef.current || loading) return {
            loading: loading
        };
        return {
            gpEndDateDetails: data?.gpEndDateDetails,
            gpEndDate: data?.gracePeriodEndDate,
            loading: loading
        };
    }, [
        loading,
        data
    ]);
};

});
parcelRegister("22xih", function(module, exports) {

$parcel$export(module.exports, "JSM_GRACE_PERIOD_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", () => $bbc1e6534917c377$export$7d5b09dea0d101b7);
$parcel$export(module.exports, "DEFAULT_ANNOUNCEMENT_BANNER_DISPLAY_STATE", () => $bbc1e6534917c377$export$3751c4ee78cb739a);
$parcel$export(module.exports, "FALLBACK_GP_END_DATE", () => $bbc1e6534917c377$export$a50854eacfeb5c82);
const $bbc1e6534917c377$export$7d5b09dea0d101b7 = 'jsm-grace-period-announcement-dismiss-state';
const $bbc1e6534917c377$export$3751c4ee78cb739a = {};
const $bbc1e6534917c377$export$a50854eacfeb5c82 = new Date('10/16/2025');

});

parcelRegister("hJjYL", function(module, exports) {

let $ce8623126e36e32c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ce8623126e36e32c$var$load("lpb1Z").then(()=>parcelRequire('eUCn3'));

});

parcelRegister("4DqMx", function(module, exports) {

let $35ff94409d20d33c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $35ff94409d20d33c$var$load("iFE2p").then(()=>parcelRequire('3kT7K'));

});



parcelRegister("6tSfI", function(module, exports) {

$parcel$export(module.exports, "LegacyPage", () => $f46c13b0ebf853fa$export$273311ee2c946a58);

var $eJOHy = parcelRequire("eJOHy");

var $1yHZW = parcelRequire("1yHZW");
const $f46c13b0ebf853fa$export$273311ee2c946a58 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1yHZW.SpaStateResetPage), {
        match: props.match,
        action: props.action,
        route: props.route,
        isSpa: false
    }));
var $f46c13b0ebf853fa$export$2e2bcd8739ae039 = $f46c13b0ebf853fa$export$273311ee2c946a58;

});
parcelRegister("1yHZW", function(module, exports) {

$parcel$export(module.exports, "SpaStateResetPage", () => $27bfd1698ff92121$export$560b6ed340766c4b);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $12DRg = parcelRequire("12DRg");

var $ht3nQ = parcelRequire("ht3nQ");

var $bJscI = parcelRequire("bJscI");

var $il8Fk = parcelRequire("il8Fk");

var $6XFSq = parcelRequire("6XFSq");

var $hMEE5 = parcelRequire("hMEE5");

var $13NKu = parcelRequire("13NKu");
const $27bfd1698ff92121$var$SpaStateActionsSubscriber = (0, $ht3nQ.createSubscriber)((0, $6XFSq.default), {
    selector: null
});
const $27bfd1698ff92121$export$faeffe1079a5c864 = (0, $bJscI.componentWithFG)('jfp_magma_migrate_spa_state_controllers_to_hooks', $27bfd1698ff92121$var$SpaStateActionsSubscriber, (0, $il8Fk.SpaStateSubscriber));
class $27bfd1698ff92121$export$560b6ed340766c4b extends (0, $eJOHy.Component) {
    shouldComponentUpdate(nextProps) {
        const cleanMatch = (0, $hMEE5.getApdexMatchObject)(this.props.match, this.props.route);
        const cleanNextMatch = (0, $hMEE5.getApdexMatchObject)(nextProps.match, nextProps.route);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(cleanMatch, cleanNextMatch);
    }
    render() {
        const { action: action, match: match, route: route, isSpa: isSpa } = this.props;
        const shouldNotUpdate = action === 'REPLACE' && (!isSpa || route.name === 'issue-navigator');
        return /* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($27bfd1698ff92121$export$faeffe1079a5c864, null, (_, { resetCurrentPage: resetCurrentPage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $13NKu.default), {
                resetCurrentPage: shouldNotUpdate ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : resetCurrentPage,
                match: (0, $hMEE5.getApdexMatchObject)(match, route),
                route: route
            }));
    }
}

});
parcelRegister("il8Fk", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $a57dbe8751758d47$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "useSpaState", () => $a57dbe8751758d47$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $a57dbe8751758d47$export$b134752525935b78);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $ht3nQ = parcelRequire("ht3nQ");

var $6XFSq = parcelRequire("6XFSq");
const $a57dbe8751758d47$export$fd52daf2a3c1ec68 = (0, $ht3nQ.createSubscriber)((0, $6XFSq.default));
const $a57dbe8751758d47$export$a57865516f6345d1 = (0, $iJq0l.createHook)((0, $6XFSq.default));
const $a57dbe8751758d47$export$b134752525935b78 = (0, $iJq0l.createActionsHook)((0, $6XFSq.default));

});
parcelRegister("6XFSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1df37714d7c7aac6$export$2e2bcd8739ae039);

var $aXKmr = parcelRequire("aXKmr");

var $GtRbT = parcelRequire("GtRbT");

var $km1L2 = parcelRequire("km1L2");
const $1df37714d7c7aac6$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, $aXKmr.v4)(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $1df37714d7c7aac6$var$store = (0, $GtRbT.createStore)({
    name: 'spa-state',
    initialState: $1df37714d7c7aac6$export$d4c72bab9d6cc13a,
    actions: $km1L2
});
var $1df37714d7c7aac6$export$2e2bcd8739ae039 = $1df37714d7c7aac6$var$store;

});
parcelRegister("km1L2", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("VOBaH")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("VOBaH")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("VOBaH")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("VOBaH")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("VOBaH")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("VOBaH")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("VOBaH")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("VOBaH")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("VOBaH")).setResourceMetrics);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $VOBaH = parcelRequire("VOBaH");

});
parcelRegister("VOBaH", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $abd86659006fa64e$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $abd86659006fa64e$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $abd86659006fa64e$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $abd86659006fa64e$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $abd86659006fa64e$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $abd86659006fa64e$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $abd86659006fa64e$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $abd86659006fa64e$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $abd86659006fa64e$export$8ad155d489dcf34d);

var $aXKmr = parcelRequire("aXKmr");

var $ehjs8 = parcelRequire("ehjs8");

var $k04JP = parcelRequire("k04JP");

var $kQnVX = parcelRequire("kQnVX");

var $ioEQd = parcelRequire("ioEQd");
const $abd86659006fa64e$export$7bd623b29ec8e1eb = 10000;
const $abd86659006fa64e$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $k04JP.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $ehjs8.default)(nextRouteUfoName, nextRouteName);
        (0, $ioEQd.GlobalPageLoadExperience).abort({
            force: true
        });
        (0, $ioEQd.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, $aXKmr.v4)(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $abd86659006fa64e$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $abd86659006fa64e$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($abd86659006fa64e$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $abd86659006fa64e$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($abd86659006fa64e$export$8a98548dad2fa97b(appId));
            }, $abd86659006fa64e$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $kQnVX.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $abd86659006fa64e$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($abd86659006fa64e$export$9d528722f2ff2999(appId, startTime));
    };
const $abd86659006fa64e$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $abd86659006fa64e$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($abd86659006fa64e$export$6a25429a42d30f9a(appId, endTime));
    };
const $abd86659006fa64e$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $abd86659006fa64e$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});




parcelRegister("hMEE5", function(module, exports) {

$parcel$export(module.exports, "calcRapidBoardResetState", () => $f519b55c78499965$export$2350ed3ff6c1a082);
$parcel$export(module.exports, "getApdexMatchObject", () => $f519b55c78499965$export$47e434f08768932b);
$parcel$export(module.exports, "calcRapidBoardResetStateV2", () => $f519b55c78499965$export$dbd9185166d0d04c);
$parcel$export(module.exports, "isValidRoute", () => $f519b55c78499965$export$9f3e656a7f6a3adc);
const $f519b55c78499965$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [
                'browse-project-redirect'
            ];
            resetDone = true;
            break;
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-backlog':
        case 'rapidboard-report':
            if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                resetDone = false;
                break;
            }
            if (!useStoredSettings && rapidBoardPaths.indexOf('browse-project-redirect') > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
            rapidBoardPaths = [];
            break;
        default:
            resetDone = false;
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $f519b55c78499965$export$47e434f08768932b = (match, route)=>{
    let cleanMatch = {
        ...match,
        params: {
            ...match.params
        },
        query: {
            ...match.query
        }
    };
    if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
        const { params: params, query: query } = match;
        const paramKeys = params && Object.keys(params);
        const queryKeys = query && Object.keys(query);
        const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
        const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
        if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
        if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
    });
    if (match.query && match.query.view && match.query.view === 'detail') // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
    cleanMatch.query.view = undefined;
    if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
    cleanMatch = {
        ...cleanMatch,
        url: ''
    };
    return cleanMatch;
};
const $f519b55c78499965$export$dbd9185166d0d04c = (boardPaths, routeName, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
useStoredSettings)=>{
    let rapidBoardPaths = [
        ...boardPaths
    ];
    let resetDone = false;
    switch(routeName){
        case 'browse-project-redirect':
            rapidBoardPaths = [];
            resetDone = true;
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-board':
        case 'rapidboard-report':
            // use search to navigate to board
            if (rapidBoardPaths.includes('browse-project-redirect') || rapidBoardPaths.includes('useStoredSettings')) {
                resetDone = true;
                rapidBoardPaths = [];
                break;
            } else if (useStoredSettings) {
                rapidBoardPaths = [
                    ...rapidBoardPaths,
                    'useStoredSettings'
                ];
                break;
            } else {
                rapidBoardPaths = [];
                break;
            }
        default:
            if (rapidBoardPaths.includes('browse-project-redirect')) {
                resetDone = true;
                rapidBoardPaths = [];
            }
    }
    return [
        rapidBoardPaths,
        resetDone
    ];
};
const $f519b55c78499965$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
    if (state) {
        const { currentPage: currentPage, visitedPages: visitedPages } = state;
        const visitedPageLength = visitedPages.length;
        if (currentPage && currentPage.apps[appId]) return true;
        if (visitedPageLength === 0 || searchDepth <= 0) return false;
        for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
            if (visitedPages[visitedPageLength - i].apps[appId]) return true;
        }
    }
    return false;
};
const $f519b55c78499965$export$9f3e656a7f6a3adc = (routeToCheck)=>{
    switch(routeToCheck.name){
        case 'issue':
        case 'issue-embed':
        case 'issue-navigator':
        case 'issue-navigator-classic':
        case 'issue-navigator-core':
        case 'servicedesk-issues':
            return true;
        default:
            return false;
    }
};

});

parcelRegister("13NKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d820c67022ec7286$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $hMEE5 = parcelRequire("hMEE5");
class $d820c67022ec7286$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.resetDone = true, this.rapidBoardPaths = [];
        const [paths] = (0, $hMEE5.calcRapidBoardResetState)(this.rapidBoardPaths, this.props.route.name, !!this.props.match.query.useStoredSettings);
        this.rapidBoardPaths = paths;
    }
    shouldComponentUpdate(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.props.match, nextProps.match)) {
            // RapidboardPaths is being persisted here.
            // resetDone boolean is calculated in the util function.
            const [paths, resetBoolean] = (0, $hMEE5.calcRapidBoardResetState)(this.rapidBoardPaths, nextProps.route.name, !!nextProps.match.query.useStoredSettings);
            this.rapidBoardPaths = paths;
            this.resetDone = resetBoolean;
        }
        return true;
    }
    componentDidUpdate() {
        if (!this.resetDone) {
            if (!__SPA__) {
                this.resetDone = true;
                return;
            }
            this.props.resetCurrentPage();
            this.resetDone = true;
        }
    }
    render() {
        return null;
    }
}

});



parcelRegister("cpLuR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", () => $254ce9d765bbe306$export$5519b86c9ea602e1);

var $kHlOR = parcelRequire("kHlOR");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $jbTNU = parcelRequire("jbTNU");

var $8zfV8 = parcelRequire("8zfV8");
const $254ce9d765bbe306$export$5519b86c9ea602e1 = (0, $6xToB.createEntry)((0, $jbTNU.globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        component: (0, $8zfV8.LazyExplicitFieldsProjectListPage),
        forPaint: [
            (0, $kHlOR.LazyAtlassianNavigation),
            (0, $8zfV8.LazyExplicitFieldsProjectListPromise)
        ]
    }));

});
parcelRegister("kHlOR", function(module, exports) {

$parcel$export(module.exports, "LazyAtlassianNavigation", () => $484a81aa80a53037$export$4caed23aa0274abb);

var $cJAh3 = parcelRequire("cJAh3");

var $dydef = parcelRequire("dydef");

var $bQWwW = parcelRequire("bQWwW");

const $484a81aa80a53037$export$4caed23aa0274abb = (0, $bQWwW.lazyForPaint)(()=>{
    const bundleReady = (parcelRequire("7WeJ3")).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation);
    if (!false) bundleReady.then(()=>{
        (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $cJAh3.JS_EVAL_START))) {
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
            break;
        }
    });
    return bundleReady;
}, {
    moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/ui/index.tsx"
});

});
parcelRegister("dydef", function(module, exports) {

$parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", () => $b504faf7ce6f0cd0$export$15ca6669ae356831);
$parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", () => $b504faf7ce6f0cd0$export$ab75d59423c060f4);
$parcel$export(module.exports, "measureInitialPageLoadTiming", () => $b504faf7ce6f0cd0$export$e18462760bac553c);
$parcel$export(module.exports, "setProductBundleReadyForInitialRender", () => $b504faf7ce6f0cd0$export$de1b4cf109d9ab65);

var $iKhRZ = parcelRequire("iKhRZ");

var $k04JP = parcelRequire("k04JP");
/**
 * `performance.measure` will throw if start/stop aren't set.
 *
 * This call sets a user-timing on the profiler timelines so we can see sections of the load.
 */ const $b504faf7ce6f0cd0$var$safeMeasure = (name, start, stop)=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        performance.measure(name, start, stop);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (_err) {}
};
const $b504faf7ce6f0cd0$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
    if (false) return;
    $b504faf7ce6f0cd0$var$safeMeasure(name, start, stop);
    (0, $k04JP.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
    (0, $iKhRZ.addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
};
const $b504faf7ce6f0cd0$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
    if (false) return;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(stopMark);
    $b504faf7ce6f0cd0$var$safeMeasure(name, start, stopMark);
    (0, $k04JP.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
    (0, $iKhRZ.addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
};
const $b504faf7ce6f0cd0$export$e18462760bac553c = (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = fn();
    performance.mark(stopMark);
    $b504faf7ce6f0cd0$var$safeMeasure(name, startMark, stopMark);
    (0, $k04JP.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $iKhRZ.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b504faf7ce6f0cd0$export$53038a2e9d597818 = async (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = await fn();
    performance.mark(stopMark);
    (0, $k04JP.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $iKhRZ.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $b504faf7ce6f0cd0$export$de1b4cf109d9ab65 = ()=>{
    if (false) return;
    $b504faf7ce6f0cd0$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
};

});

parcelRegister("7WeJ3", function(module, exports) {

let $5c795f6018cd7ee8$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("g81qY"))('edition_awareness_upsell_jira_ab_fg', function() {
        return Promise.all([
            $5c795f6018cd7ee8$var$load("dHAND")
        ]);
    }, function() {
        return Promise.all([
            $5c795f6018cd7ee8$var$load("aQyvI")
        ]);
    }),
    (parcelRequire("g81qY"))('edition_awareness_upsell_jira_ab_fg', function() {
        return Promise.all([
            $5c795f6018cd7ee8$var$load("dHAND")
        ]);
    }, function() {
        return Promise.all([
            $5c795f6018cd7ee8$var$load("aQyvI")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-update-while-rendering', function() {
        return Promise.all([
            $5c795f6018cd7ee8$var$load("cY2SU")
        ]);
    }, function() {
        return Promise.all([
            $5c795f6018cd7ee8$var$load("74PVH")
        ]);
    }),
    $5c795f6018cd7ee8$var$load("kNFvF"),
    $5c795f6018cd7ee8$var$load("ffQaD"),
    $5c795f6018cd7ee8$var$load("kvRbA"),
    $5c795f6018cd7ee8$var$load("kVX56"),
    $5c795f6018cd7ee8$var$load("76n7a"),
    $5c795f6018cd7ee8$var$load("l253H"),
    $5c795f6018cd7ee8$var$load("9kczN")
]).then(()=>parcelRequire('96SSt'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});



parcelRegister("yRJUA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsLayout", () => $150f50faaae72217$export$e6aef6083548e882);

var $7h3uc = parcelRequire("7h3uc");

var $6dwgv = parcelRequire("6dwgv");
const $150f50faaae72217$export$e6aef6083548e882 = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout));

});
parcelRegister("7h3uc", function(module, exports) {

$parcel$export(module.exports, "globalLayout", () => $9f25df309d0ec2b8$export$929cb72e7acb7fd9);

var $6dwgv = parcelRequire("6dwgv");
const $9f25df309d0ec2b8$var$rightSidebars = ()=>[];
const $9f25df309d0ec2b8$export$929cb72e7acb7fd9 = (0, $6dwgv.createLayout)({
    rightSidebars: $9f25df309d0ec2b8$var$rightSidebars()
});

});
parcelRegister("6dwgv", function(module, exports) {

$parcel$export(module.exports, "coalesce", () => $b345ebe3c14918f6$export$6e5538615c060df7);
$parcel$export(module.exports, "renderGlobalComponents", () => $b345ebe3c14918f6$export$fc28c9563350e5b8);
$parcel$export(module.exports, "createLayout", () => $b345ebe3c14918f6$export$3dd437ade36ede40);
$parcel$export(module.exports, "composeLayouts", () => $b345ebe3c14918f6$export$6c041b39c370853f);
$parcel$export(module.exports, "withProjectContext", () => $b345ebe3c14918f6$export$e97a7da67a5b8ce4);

var $eJOHy = parcelRequire("eJOHy");

var $2846K = parcelRequire("2846K");

var $7jTnu = parcelRequire("7jTnu");

var $eWzpp = parcelRequire("eWzpp");

var $ch9En = parcelRequire("ch9En");

const $b345ebe3c14918f6$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
const $b345ebe3c14918f6$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
        const { displayName: displayName, name: name } = Component;
        const placeholderName = $b345ebe3c14918f6$export$6e5538615c060df7(displayName) ?? $b345ebe3c14918f6$export$6e5538615c060df7(name) ?? i;
        const key = (0, $7jTnu.fg)('jfp_magma_shared-component-perf-1') ? (0, $2846K.uid)(Component) : placeholderName;
        return(// TODO Only add suspense if lazy component, otherwise add suspense within component array
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: String(placeholderName),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null)));
    });
const $b345ebe3c14918f6$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
        isChromeless: isChromeless,
        globalComponents: Array.from(new Set(globalComponents)),
        rightSidebars: Array.from(new Set(rightSidebars))
    });
const $b345ebe3c14918f6$export$6c041b39c370853f = (...layouts)=>{
    if (layouts.length === 1) return $b345ebe3c14918f6$export$3dd437ade36ede40(layouts[0]);
    const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
            isChromeless: isChromeless,
            globalComponents: [
                ...l.globalComponents,
                ...globalComponents
            ],
            rightSidebars: [
                ...l.rightSidebars,
                ...rightSidebars
            ]
        }), {
        globalComponents: [],
        rightSidebars: [],
        isChromeless: false
    });
    return $b345ebe3c14918f6$export$3dd437ade36ede40(layout);
};
const $b345ebe3c14918f6$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $b345ebe3c14918f6$var$formatPrefix = (style, type)=>{
    if (!style && !type) return 'Empty';
    if (style === 'any' && type === 'any') return 'Any';
    const formattedStyle = $b345ebe3c14918f6$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
    if (type === 'any') return formattedStyle;
    const formattedType = $b345ebe3c14918f6$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
    if (style === 'any') return formattedType;
    return `${formattedStyle}${formattedType}`;
};
const $b345ebe3c14918f6$export$e97a7da67a5b8ce4 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component, options)=>{
    const { project: expectedProject } = options;
    const ScopedComponent = ()=>{
        const { data: project, loading: loading } = (0, $eWzpp.useProject)();
        if (loading) return null;
        if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null);
    };
    const name = $b345ebe3c14918f6$export$6e5538615c060df7(Component.displayName) ?? $b345ebe3c14918f6$export$6e5538615c060df7(Component.name) ?? 'Component';
    const prefix = $b345ebe3c14918f6$var$formatPrefix(expectedProject?.style, expectedProject?.type);
    ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
    return ScopedComponent;
};

});
parcelRegister("eWzpp", function(module, exports) {

$parcel$export(module.exports, "useProject", () => $b0e367b82a642155$export$51b1383ef8844a7);

var $eJOHy = parcelRequire("eJOHy");

var $imXGf = parcelRequire("imXGf");

var $dSkLG = parcelRequire("dSkLG");
const $b0e367b82a642155$export$51b1383ef8844a7 = (customContext)=>{
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useProjectSidebarNavigation)(customContext);
    const project = (0, $eJOHy.useMemo)(()=>data && (0, $imXGf.extractData)(data), [
        data
    ]);
    return {
        data: project,
        loading: loading,
        error: error
    };
};

});
parcelRegister("imXGf", function(module, exports) {

$parcel$export(module.exports, "getStyle", () => $6f45f52094bb95b1$export$3d2f074408bd1b82);
$parcel$export(module.exports, "extractData", () => $6f45f52094bb95b1$export$9df5fa0a366163d2);

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");
const $6f45f52094bb95b1$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $ln6Iy.ProjectStyle).NEXT_GEN : (0, $ln6Iy.ProjectStyle).CLASSIC;
const $6f45f52094bb95b1$var$getProject = (project)=>({
        avatarUrl: project.avatarUrls['48x48'],
        id: Number(project.id),
        isSimplified: project.simplified,
        key: project.key,
        name: project.name,
        style: $6f45f52094bb95b1$export$3d2f074408bd1b82(project.simplified),
        type: project.projectTypeKey,
        ...typeof project.isLiveTemplate === 'boolean' && (0, $7jTnu.fg)('jira_custom_templates_ux') && {
            isLiveTemplate: project.isLiveTemplate
        }
    });
const $6f45f52094bb95b1$export$9df5fa0a366163d2 = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraWorkManagementNavData.project) : null;
        case 'jira_software':
            return jiraSoftwareNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraSoftwareNavData.project) : null;
        case 'jira_service_management':
        case 'jira_customer_service':
            return jiraServiceManagementNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraServiceManagementNavData.project) : null;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.project ? $6f45f52094bb95b1$var$getProject(jiraProductDiscoveryNavData.project) : null;
        case null:
        default:
            return null;
    }
};

});

parcelRegister("dSkLG", function(module, exports) {

$parcel$export(module.exports, "useProjectSidebarNavigation", () => $305b347fff7113d4$export$5a85006c180fb373);
$parcel$export(module.exports, "useProjectSidebarConnectNavigation", () => $305b347fff7113d4$export$2bed15cd7d167db5);
$parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", () => $305b347fff7113d4$export$a9d05fc2c1d94895);
$parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", () => $305b347fff7113d4$export$d48e3c3556894533);
$parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", () => $305b347fff7113d4$export$24a781cd863077aa);
$parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", () => $305b347fff7113d4$export$e16ecd2512eb0dc7);
$parcel$export(module.exports, "useJiraSoftwareProjectNavigation", () => $305b347fff7113d4$export$68dc0ecbea8211d2);
$parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", () => $305b347fff7113d4$export$5cf90b625d0e1248);
$parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", () => $305b347fff7113d4$export$d63d92edebe543d9);

var $eJOHy = parcelRequire("eJOHy");

var $3qMzf = parcelRequire("3qMzf");

var $6zZVV = parcelRequire("6zZVV");

var $dHUNm = parcelRequire("dHUNm");

var $cY5nO = parcelRequire("cY5nO");

var $9pJMP = parcelRequire("9pJMP");

var $bo7Z6 = parcelRequire("bo7Z6");

var $eJrcF = parcelRequire("eJrcF");

var $9aQsQ = parcelRequire("9aQsQ");
const $305b347fff7113d4$export$5a85006c180fb373 = (customContext)=>{
    const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $9pJMP.staticProjectSidebarNavigationResource), customContext);
    const memoizedResponse = (0, $eJOHy.useMemo)(()=>navResponse, [
        navResponse
    ]);
    (0, $9aQsQ.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
    return {
        data: memoizedResponse,
        loading: memoizedResponse != null ? false : loading,
        refresh: refresh,
        clearAll: clearAll,
        error: error,
        ...rest
    };
};
const $305b347fff7113d4$export$2bed15cd7d167db5 = ()=>(0, $eJrcF.useResource)((0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource));
const $305b347fff7113d4$export$a9d05fc2c1d94895 = ()=>(0, $eJrcF.useResource)((0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource));
const $305b347fff7113d4$export$d48e3c3556894533 = ()=>(0, $eJrcF.useResource)((0, $cY5nO.staticProjectSettingsSidebarConnectAddonsNavigationResource));
const $305b347fff7113d4$export$24a781cd863077aa = ()=>(0, $eJrcF.useResource)((0, $3qMzf.staticJSMProjectConnectAddonsNavigationResource));
const $305b347fff7113d4$export$e16ecd2512eb0dc7 = ()=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373();
    const response = data?.jiraWorkManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $305b347fff7113d4$export$68dc0ecbea8211d2 = ()=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373();
    const response = data?.jiraSoftwareNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $305b347fff7113d4$export$5cf90b625d0e1248 = (customContext)=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373(customContext);
    const response = data?.jiraServiceManagementNavData || null;
    return {
        data: response,
        ...rest
    };
};
const $305b347fff7113d4$export$d63d92edebe543d9 = ()=>{
    const { data: data, ...rest } = $305b347fff7113d4$export$5a85006c180fb373();
    const response = data?.jiraProductDiscoveryNavData || null;
    return {
        data: response,
        ...rest
    };
};

});
parcelRegister("3qMzf", function(module, exports) {

$parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", () => $7b699886fcf4f1e6$export$fab84295e18e9246);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $jfYJb = parcelRequire("jfYJb");
const $7b699886fcf4f1e6$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $7b699886fcf4f1e6$export$fab84295e18e9246 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
    getKey: ({ match: match, query: query })=>$7b699886fcf4f1e6$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $7b699886fcf4f1e6$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("6zZVV", function(module, exports) {

$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", () => $36eb967a9a73fcdf$export$b8c6e2666f12f4bb);
$parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResourceOnNav3Only", () => $36eb967a9a73fcdf$export$a799c58e7bee6de4);

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");

var $bBtQo = parcelRequire("bBtQo");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");

var $jfYJb = parcelRequire("jfYJb");
const $36eb967a9a73fcdf$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $36eb967a9a73fcdf$export$b8c6e2666f12f4bb = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$36eb967a9a73fcdf$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $36eb967a9a73fcdf$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const projectHomeAddonNavInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
        return projectHomeAddonNavInfo;
    },
    maxAge: 300000
});
const $36eb967a9a73fcdf$export$a799c58e7bee6de4 = (0, $5L7qx.resourceWithCondition2)(()=>!((0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('perf-push-big-components-nav-remove-resources')), $36eb967a9a73fcdf$export$b8c6e2666f12f4bb);

});

parcelRegister("dHUNm", function(module, exports) {

$parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", () => $5245c908f3577c91$export$b662f3f877add30d);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $jfYJb = parcelRequire("jfYJb");
const $5245c908f3577c91$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $5245c908f3577c91$export$b662f3f877add30d = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
    getKey: ({ match: match, query: query })=>$5245c908f3577c91$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $5245c908f3577c91$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const navInfo = await (0, $jfYJb.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
        return navInfo;
    },
    maxAge: 300000
});

});

parcelRegister("9pJMP", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", () => $9620e56412c9e007$export$adb27ddab077e944);
$parcel$export(module.exports, "staticProjectSidebarNavigationResource", () => $9620e56412c9e007$export$f2dfc0f7b2d92691);
$parcel$export(module.exports, "useSidebarNavigationResource", () => $9620e56412c9e007$export$b692cfadccf4e047);

var $7jTnu = parcelRequire("7jTnu");

var $jkKE1 = parcelRequire("jkKE1");

var $2at4v = parcelRequire("2at4v");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $1JhVO = parcelRequire("1JhVO");
const $9620e56412c9e007$export$adb27ddab077e944 = (routeName, match, query)=>{
    /**
	 * `boardId` as an identifier should not be returned for JSM boards route,
	 * skip boards on `SERVICEDESK_BOARDS` or `SERVICEDESK_CALENDAR` route.
	 */ if (routeName === 'servicedesk-boards' || routeName === 'servicedesk-calendar' || query['servicedesk.serviceDeskId'] || (routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-custom-calendar' || routeName === 'servicedesk-queues-practice-custom-board' || routeName === 'servicedesk-queues-practice-custom-calendar' || routeName === 'servicedesk-queues-views-config' || routeName === 'servicedesk-practice-views-config') && (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag') || routeName === 'servicedesk-list' && (0, $7jTnu.fg)('jsm_list_view_milestone_1')) {
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        return (0, $jkKE1.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId
        });
    }
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    const boardId = (0, $2at4v.getBoardId)(match, query);
    return (0, $jkKE1.getScopeIdentifier)({
        projectKey: projectKey,
        projectId: projectId,
        boardId: boardId
    });
};
const $9620e56412c9e007$var$getRouterKey = (routeName, match, query)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = $9620e56412c9e007$export$adb27ddab077e944(routeName, match, query);
    // Next-Gen software projects contain only one board. Hence, using the project key itself
    if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
    return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
};
const $9620e56412c9e007$export$f2dfc0f7b2d92691 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    getKey: ({ match: match, query: query, route: { name: name } })=>$9620e56412c9e007$var$getRouterKey(name, match, query),
    /**
	 * is called on resource's init fetch, or .refresh()
	 */ getData: async ({ match: match, query: query, route: { name: name } })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const scopeIdentifier = $9620e56412c9e007$export$adb27ddab077e944(name, match, query);
        if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
        const navInfo = await (0, $1JhVO.fetchProjectSidebarNavInfo)(scopeIdentifier);
        return navInfo;
    },
    maxAge: 300000
});
const $9620e56412c9e007$export$b692cfadccf4e047 = ()=>(0, $eJrcF.useResource)($9620e56412c9e007$export$f2dfc0f7b2d92691);

});
parcelRegister("jkKE1", function(module, exports) {

$parcel$export(module.exports, "getScopeIdentifier", () => $fd68a0d085bd7604$export$68278f7cf66944f9);

const $fd68a0d085bd7604$export$68278f7cf66944f9 = (scope)=>{
    // We check for identifiers in order of specificity first. A board ID is more specific than a project key and so on
    const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
    let identifierType = null;
    if (scope.boardId) identifierType = (0, $4a60e80b3610d78a$export$929d50f83189406c);
    else if (scope.projectKey) identifierType = (0, $4a60e80b3610d78a$export$b5a308a17bc991f3);
    else if (scope.projectId) identifierType = (0, $4a60e80b3610d78a$export$da6f46390e1a426f);
    return {
        identifierValue: identifierValue,
        identifierType: identifierType
    };
};

});
const $4a60e80b3610d78a$export$b5a308a17bc991f3 = 'projectKey';
const $4a60e80b3610d78a$export$929d50f83189406c = 'boardId';
const $4a60e80b3610d78a$export$da6f46390e1a426f = 'projectId';


parcelRegister("1JhVO", function(module, exports) {

$parcel$export(module.exports, "fetchProjectSidebarNavInfo", () => $75af829a86061e6c$export$8a51470472777e11);

var $jGzN3 = parcelRequire("jGzN3");
const $75af829a86061e6c$export$8a51470472777e11 = (scopeIdentifier)=>{
    const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
    if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
    let queryParam = '';
    switch(identifierType){
        case 'boardId':
            queryParam = `boardId=${identifierValue}`;
            break;
        case 'projectKey':
        case 'projectId':
            queryParam = `projectIdOrKey=${identifierValue}`;
            break;
        default:
            break;
    }
    return (0, $jGzN3.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
};

});


parcelRegister("bo7Z6", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $293b1501ed0e6af1$export$61dad767cf446185);

var $eA736 = parcelRequire("eA736");
var $eJrcF = parcelRequire("eJrcF");

var $8IXJk = parcelRequire("8IXJk");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $293b1501ed0e6af1$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
function $293b1501ed0e6af1$export$61dad767cf446185(resource, customRouterContext, options = {}) {
    let resourceOptions;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $293b1501ed0e6af1$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
            routerContext: (0, $eA736.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const { shouldPrefetch: shouldPrefetch } = options;
    const resourceResponse = (0, $eJrcF.useResource)(resource, resourceOptions);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $8IXJk.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
    return resourceResponse;
}

});
parcelRegister("8IXJk", function(module, exports) {

$parcel$export(module.exports, "usePrefetchableResource", () => $f61fc1df4d840af0$export$99f17ace416cfe75);

var $eJOHy = parcelRequire("eJOHy");
function $f61fc1df4d840af0$export$99f17ace416cfe75(resource, shouldPrefetch) {
    (0, $eJOHy.useEffect)(()=>{
        if (!shouldPrefetch) return;
        // "false" is a valid value for data here. We only want to trigger a refresh if data is null or undefined.
        if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("9aQsQ", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", () => $62cf57129499b564$export$780174995da89d60);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $9pJMP = parcelRequire("9pJMP");

var $eA736 = parcelRequire("eA736");
var $kfvK2 = parcelRequire("kfvK2");
var $eJrcF = parcelRequire("eJrcF");
const $62cf57129499b564$export$90dbde7e33e6e21 = ()=>null;
const $62cf57129499b564$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $eA736.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/:projectKey/dummyroute',
        component: $62cf57129499b564$export$90dbde7e33e6e21
    }, {
        params: {
            projectKey: projectKey
        }
    }) : undefined;
const $62cf57129499b564$export$19001bab9e4b7f8f = (projectKey)=>{
    const { data: data, update: update } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource), {
        routerContext: $62cf57129499b564$export$d647718555c2fdd8(projectKey)
    });
    return {
        data: data,
        update: update
    };
};
const $62cf57129499b564$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $eA736.createRouterContext)({
        name: 'software',
        path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
        component: $62cf57129499b564$export$90dbde7e33e6e21
    }, {
        params: {
            boardId: `${boardId}`
        }
    }) : undefined;
const $62cf57129499b564$export$e2bb7877e6cec3eb = (boardId)=>{
    const { data: data, update: update } = (0, $eJrcF.useResource)((0, $9pJMP.staticProjectSidebarNavigationResource), {
        routerContext: $62cf57129499b564$export$23dc6491016cabdc(boardId)
    });
    return {
        data: data,
        update: update
    };
};
const $62cf57129499b564$var$useIsOnBoardBasedRoute = (0, $kfvK2.createRouterSelector)(({ route: route, query: query, match: match })=>(0, $9pJMP.getIdentifier)(route.name, match, query)?.identifierType === 'boardId');
const $62cf57129499b564$export$780174995da89d60 = (latestNavInfo)=>{
    const isOnBoardBasedRoute = $62cf57129499b564$var$useIsOnBoardBasedRoute();
    const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
    const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
    const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
    // explicitly get project data by forcing key to be project
    const { data: projectRouteNavInfo, update: updateProjectRoute } = $62cf57129499b564$export$19001bab9e4b7f8f(pKey);
    // explicitly get board data by forcing key to be board
    const { data: boardRouteNavInfo, update: updateBoardRoute } = $62cf57129499b564$export$e2bb7877e6cec3eb(boardId);
    // if software CMP project or board data is not in sync, then force update
    (0, $eJOHy.useEffect)(()=>{
        if (latestNavInfo != null && isSoftwareCMP) {
            if (isOnBoardBasedRoute && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
        }
    }, [
        isOnBoardBasedRoute,
        latestNavInfo,
        updateProjectRoute,
        updateBoardRoute,
        projectRouteNavInfo,
        boardRouteNavInfo,
        isSoftwareCMP
    ]);
};

});






parcelRegister("5RW99", function(module, exports) {

$parcel$export(module.exports, "ADDON_ID", () => $6707b1635af3be3c$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $6707b1635af3be3c$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $6707b1635af3be3c$export$adf978edbdfaf080);
const $6707b1635af3be3c$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $6707b1635af3be3c$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    COMMUNICATIONS: 'COMMUNICATIONS',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};
const $6707b1635af3be3c$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    CONTENT: 'CONTENT',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS',
    OPERATIONS_GENERAL_CONFIGURATION: 'OPERATIONS_GENERAL_CONFIGURATION'
};

});

parcelRegister("8XpuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f3a4d32478eb00$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $69f3a4d32478eb00$var$LazyGlobalIssuesSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("kCCbB")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
});
const $69f3a4d32478eb00$var$GlobalIssuesSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalIssuesSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69f3a4d32478eb00$var$LazyGlobalIssuesSettingsSidebar, null)));
var $69f3a4d32478eb00$export$2e2bcd8739ae039 = $69f3a4d32478eb00$var$GlobalIssuesSettingsSidebar;

});
parcelRegister("8Dw1w", function(module, exports) {

$parcel$export(module.exports, "SidebarBoundary", () => $b66ffc7f89ff7516$export$1edc778464f08256);

var $eJOHy = parcelRequire("eJOHy");

var $dLR8J = parcelRequire("dLR8J");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $ch9En = parcelRequire("ch9En");

var $16sa1 = parcelRequire("16sa1");

var $7jTnu = parcelRequire("7jTnu");

var $dysGT = parcelRequire("dysGT");

var $8Q9Ns = parcelRequire("8Q9Ns");

var $gpE1B = parcelRequire("gpE1B");
const $b66ffc7f89ff7516$export$1edc778464f08256 = ({ children: children, id: id })=>{
    const onFail = (0, $8Q9Ns.useSidebarFail)();
    const onSuccess = (0, $8Q9Ns.useSidebarSuccess)();
    const onError = (0, $eJOHy.useCallback)((location, error)=>{
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        const { statusCode: statusCode } = error;
        if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
        else onFail(location, error);
    }, [
        onFail,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysGT.SidebarErrorBoundary), {
        id: id,
        packageName: "jiraSpaAppsSidebarCommon",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt
    }), (0, $7jTnu.fg)('jiv-blindspot-fixes-2025-07-01') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "nav-sidebar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "nav-sidebar-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpE1B.Skeleton), {
            isFull: true
        }))
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "nav-sidebar",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpE1B.Skeleton), {
            isFull: true
        })
    }, children));
};

});
parcelRegister("hOBHo", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", () => $f058582c63bdf80a$export$6635720e40ea7a7a);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", () => $f058582c63bdf80a$export$1d3c3cb357af0e86);
$parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", () => $f058582c63bdf80a$export$e7a14fa81b3c6488);
$parcel$export(module.exports, "NAVIGATION_TOP_MARKS", () => $f058582c63bdf80a$export$ad760bb9734bf93f);
$parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", () => $f058582c63bdf80a$export$1d10ee0c85c3cb21);
const $f058582c63bdf80a$export$6635720e40ea7a7a = 'navigation.top';
const $f058582c63bdf80a$export$1d3c3cb357af0e86 = 'navigation.sidebar';
const $f058582c63bdf80a$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
const $f058582c63bdf80a$export$ad760bb9734bf93f = {
    renderStart: 'navigation-top.render.start',
    renderEnd: 'navigation-top.render.end',
    renderSsrStart: 'navigation-top.render.ssr.start',
    renderSsrEnd: 'navigation-top.render.ssr.end',
    bundleLoadStart: 'navigation-top.bundle-load.start'
};
const $f058582c63bdf80a$export$1d10ee0c85c3cb21 = {
    renderAttempt: 'navigation-sidebar.render.attempt',
    renderStart: 'navigation-sidebar.render.start',
    renderEnd: 'navigation-sidebar.render.end',
    renderSsrStart: 'navigation-sidebar.render.ssr.start',
    renderSsrEnd: 'navigation-sidebar.render.ssr.end',
    loadStart: 'navigation-sidebar.load.start',
    loadEnd: 'navigation-sidebar.load.end'
};

});

parcelRegister("03pp6", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", () => $9b842795409a6159$export$8df02628d98cae7e);
$parcel$export(module.exports, "pageSegmentStore", () => $9b842795409a6159$export$26cadbe0bcaabcde);
$parcel$export(module.exports, "useNavPerformanceMetrics", () => $9b842795409a6159$export$906025848d54198d);
$parcel$export(module.exports, "NavTopPerformanceMark", () => $9b842795409a6159$export$b7f4caa65b0906fc);
$parcel$export(module.exports, "NavTopPerformanceReport", () => $9b842795409a6159$export$c64b31449a6177d);
$parcel$export(module.exports, "NavSidebarPerformanceMark", () => $9b842795409a6159$export$35b2aeea5cbc963e);
$parcel$export(module.exports, "NavSidebarPerformanceReport", () => $9b842795409a6159$export$a018e347341b3640);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $hqYEY = parcelRequire("hqYEY");

var $kQnVX = parcelRequire("kQnVX");

var $6dnL8 = parcelRequire("6dnL8");

var $hOBHo = parcelRequire("hOBHo");

const $9b842795409a6159$var$createTopNavPageSegment = ()=>(0, $hqYEY.metrics).pageSegmentLoad({
        key: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME),
        timings: [
            {
                key: 'ttic',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderSsrEnd
            },
            {
                key: 'bundle-load',
                startMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).bundleLoadStart,
                endMark: (0, $hOBHo.NAVIGATION_TOP_MARKS).renderStart
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $9b842795409a6159$export$8df02628d98cae7e = {
    ADDONS: (0, $hqYEY.metrics).interaction({
        key: 'navigation-top.addons-dropdown-opened'
    })
};
const $9b842795409a6159$var$createSidebarPageSegment = ()=>(0, $hqYEY.metrics).pageSegmentLoad({
        key: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME),
        timings: [
            {
                key: 'renderAttempt',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderAttempt
            },
            {
                key: 'ttic',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'tti',
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
            },
            {
                key: 'ttr',
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'ttrc',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
            },
            {
                key: 'load',
                startMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadStart,
                endMark: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadEnd
            }
        ],
        histogram: {
            initial: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '4000_4500_5000_6000_7000_8000_9000'
            },
            transition: {
                fmp: '2500_3000_3500_4000_5000_6000',
                tti: '2500_3000_3500_4000_5000_6000'
            }
        }
    });
const $9b842795409a6159$export$26cadbe0bcaabcde = (()=>{
    const segmentConstructors = {
        [(0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)]: $9b842795409a6159$var$createTopNavPageSegment,
        [(0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $9b842795409a6159$var$createSidebarPageSegment
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const segments = {};
    return {
        getSegment: (key)=>{
            if (!segments[key]) {
                if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                segments[key] = segmentConstructors[key]();
            }
            return segments[key];
        }
    };
})();
const $9b842795409a6159$export$906025848d54198d = (segmentKey = (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME))=>{
    const startedRef = (0, $eJOHy.useRef)(false);
    const segment = (0, $eJOHy.useRef)($9b842795409a6159$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
    if (!false && !startedRef.current) {
        segment && segment.startFromPageLoad();
        startedRef.current = true;
    }
    return (0, $eJOHy.useMemo)(()=>// object assign here to extend origianl segment object and save prototypes
        Object.assign(segment, {
            markSSR: (metricKey)=>{
                const tmpSsrMetricKey = `${(0, $hOBHo.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                if (window.SPA_STATE) {
                    // @ts-expect-error - TS2339 - Property 'startTime' does not exist on type 'unknown'. | TS2339 - Property 'duration' does not exist on type 'unknown'.
                    const { startTime: startTime = 0, duration: duration = 0 } = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))((0, $6dnL8.getRenderTraceFromSSRGlobal)(), [
                        'traces',
                        `render/${tmpSsrMetricKey}`
                    ]) || {};
                    const markTime = startTime + duration;
                    markTime && markTime > 0 && segment.mark(metricKey, markTime);
                }
            }
        }), [
        segment
    ]);
};
const $9b842795409a6159$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
    const navSegment = $9b842795409a6159$export$906025848d54198d(segmentKey);
    (0, $eJOHy.useEffect)(()=>navSegment.mark(metricKey), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return null;
};
const $9b842795409a6159$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
    const navSegment = $9b842795409a6159$export$906025848d54198d(segmentKey);
    (0, $eJOHy.useEffect)(()=>{
        navSegment.stop({
            customData: {
                ...customData,
                userLocation: (0, $kQnVX.getUserLocation)()
            }
        });
        navSegment.clear();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $9b842795409a6159$export$b7f4caa65b0906fc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $9b842795409a6159$export$c64b31449a6177d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_TOP_SEGMENT_NAME)
    });
const $9b842795409a6159$export$35b2aeea5cbc963e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceMark, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });
const $9b842795409a6159$export$a018e347341b3640 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9b842795409a6159$var$NavigationPerformanceReport, {
        ...props,
        segmentKey: (0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME)
    });

});
parcelRegister("6dnL8", function(module, exports) {

$parcel$export(module.exports, "RenderTracerMark", () => $399d856a9213313b$export$54c89059bb435049);
$parcel$export(module.exports, "getRenderTraceFromSSRGlobal", () => $399d856a9213313b$export$345f21b0287f67e5);

var $eJOHy = parcelRequire("eJOHy");

var $Xz6kS = parcelRequire("Xz6kS");

var $9Dhvc = parcelRequire("9Dhvc");

var $QRiTH = parcelRequire("QRiTH");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

const $399d856a9213313b$var$initialState = {
    start: undefined,
    traces: {}
};
let $399d856a9213313b$var$currentTraces = {};
const $399d856a9213313b$export$2365ecd8218e21c7 = ()=>$399d856a9213313b$var$currentTraces;
const $399d856a9213313b$export$5c757eaa1990d0d7 = (key)=>{
    if ($399d856a9213313b$var$currentTraces[key]) return;
    $399d856a9213313b$var$currentTraces[key] = {
        startTime: (0, $QRiTH.performance).now()
    };
};
const $399d856a9213313b$export$16854dc18f8d976 = (key)=>{
    if (!$399d856a9213313b$var$currentTraces[key] || $399d856a9213313b$var$currentTraces[key].duration != null) return;
    $399d856a9213313b$var$currentTraces[key].duration = (0, $QRiTH.performance).now() - $399d856a9213313b$var$currentTraces[key].startTime;
};
const $399d856a9213313b$var$actions = {
    startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            // If <RenderTracerContainer /> has not been setup with a startKey and startTime, return
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            if (traces[key]) return;
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, traces, {
                    [key]: {
                        startTime: time
                    }
                })
            });
        },
    endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
            const { start: start, traces: traces } = getState();
            if (start === undefined) return;
            const key = name === startKey ? name : `${startKey}/${name}`;
            const trace = traces[key] || {
                startTime: 0
            };
            setState({
                traces: (0, (/*@__PURE__*/$parcel$interopDefault($Xz6kS)))({}, traces, {
                    [key]: {
                        ...trace,
                        duration: time - trace.startTime
                    }
                })
            });
            $399d856a9213313b$var$currentTraces = Object.assign($399d856a9213313b$var$currentTraces, getState().traces);
        }
};
const $399d856a9213313b$var$Store = (0, $GtRbT.createStore)({
    name: 'jira-render-tracer',
    initialState: $399d856a9213313b$var$initialState,
    actions: $399d856a9213313b$var$actions
});
const $399d856a9213313b$var$RenderTracerActions = (0, $ht3nQ.createSubscriber)($399d856a9213313b$var$Store, {
    selector: null
});
const $399d856a9213313b$export$719a95758870be58 = (0, $iJq0l.createHook)($399d856a9213313b$var$Store, {
    selector: null
});
const $399d856a9213313b$var$RenderTracerContainerBase = (0, $6E16M.createContainer)($399d856a9213313b$var$Store, {
    onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
            setState({
                start: startTime,
                traces: {
                    [startKey]: {
                        startTime: (0, $QRiTH.performance).now()
                    }
                }
            });
        }
});
const $399d856a9213313b$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($399d856a9213313b$var$RenderTracerContainerBase, {
        startKey: startKey,
        startTime: startTime
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($399d856a9213313b$export$54c89059bb435049, {
        traceKey: startKey,
        type: "end"
    }));
const $399d856a9213313b$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($399d856a9213313b$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
        if (type === 'start') startTrace(traceKey, (0, $QRiTH.performance).now());
        else if (type === 'end') endTrace(traceKey, (0, $QRiTH.performance).now());
        return null;
    });
const $399d856a9213313b$export$cba8addc8743389c = (appName = 'unknown', traces = $399d856a9213313b$var$currentTraces)=>({
        [(0, $6df4e20a5531d5f2$export$3c96fa14fb694e11)]: {
            data: {
                traces: traces,
                routeName: appName
            }
        }
    });
const $399d856a9213313b$export$345f21b0287f67e5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
        (0, $6df4e20a5531d5f2$export$3c96fa14fb694e11),
        'data'
    ], {});

});
parcelRegister("QRiTH", function(module, exports) {

$parcel$export(module.exports, "performance", () => $be16f2b3d59cb675$export$f2d2284f5fec51f8);
const $be16f2b3d59cb675$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
class $be16f2b3d59cb675$export$9a0dbed22cbf63be {
    start() {
        if (false) this.startAt = $be16f2b3d59cb675$var$now();
    }
    now() {
        if (false) return $be16f2b3d59cb675$var$now() - this.startAt;
        return $be16f2b3d59cb675$var$now();
    }
    constructor(){
        this.startAt = $be16f2b3d59cb675$var$now();
    }
}
const $be16f2b3d59cb675$export$f2d2284f5fec51f8 = new $be16f2b3d59cb675$export$9a0dbed22cbf63be();

});

const $6df4e20a5531d5f2$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';



parcelRegister("16sa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d37a74ca9fa1ecb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $7aoMz = parcelRequire("7aoMz");

var $2QO3b = parcelRequire("2QO3b");

var $6FOAB = parcelRequire("6FOAB");

var $lf6Bt = parcelRequire("lf6Bt");

var $7jTnu = parcelRequire("7jTnu");

var $kn2Rh = parcelRequire("kn2Rh");

var $iU66d = parcelRequire("iU66d");
/** A portion of the page we apply measurement to */ function $7d37a74ca9fa1ecb$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $7aoMz.useInteractionContext)();
    const relayProfilerContext = (0, $eJOHy.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eJOHy.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    if ((0, $kn2Rh.getIsConcurrentEnabled)() && (0, $7jTnu.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    this.getInteractionContext().addPreload((0, $2QO3b.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    if ((0, $kn2Rh.getIsConcurrentEnabled)() && (0, $7jTnu.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    if ((0, $kn2Rh.getIsConcurrentEnabled)() && (0, $7jTnu.fg)('ufo-disable-rll-bundle-loads-jira')) return;
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $2QO3b.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $7jTnu.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if ((name === 'nav4-ignore.sidebar' || name === 'nav4-ignore.sidebar.anonymous') && (0, $7jTnu.fg)('afo-3421-remove-sidebar-nav4-suspense')) return;
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j4oe4.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iU66d.default), {
        labelStack: interactionContext.labelStack,
        onRender: (...args)=>interactionContext.onRender(...args)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lf6Bt.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children)));
}
function $7d37a74ca9fa1ecb$export$2e2bcd8739ae039({ name: segmentName, children: children, mode: mode = 'single' }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6FOAB.default), {
        name: segmentName,
        mode: mode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7d37a74ca9fa1ecb$var$JiraUFOSegmentWrapper, null, children));
}

});
parcelRegister("iU66d", function(module, exports) {

$parcel$export(module.exports, "default", () => $577ced15db32032b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $577ced15db32032b$var$SsrRenderProfiler = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
var $577ced15db32032b$export$2e2bcd8739ae039 = $577ced15db32032b$var$SsrRenderProfiler;

});


parcelRegister("dysGT", function(module, exports) {

$parcel$export(module.exports, "SidebarErrorBoundary", () => $c7f6dd1cac39f594$export$62853c5766dad0c4);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $kQnVX = parcelRequire("kQnVX");

var $ea4Iz = parcelRequire("ea4Iz");
const $c7f6dd1cac39f594$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $kQnVX.getUserLocation)();
    const extraEventData = (0, $eJOHy.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ea4Iz.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("ea4Iz", function(module, exports) {

$parcel$export(module.exports, "Fallback", () => $9b4051d45e6e7b1f$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $2HRPu = parcelRequire("2HRPu");

var $lRq8t = parcelRequire("lRq8t");

var $lh7Oqf = parcelRequire("lh7Oqf");

var $6aoQW = parcelRequire("6aoQW");
const $9b4051d45e6e7b1f$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rko9j3y _11c8dcr7 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $9b4051d45e6e7b1f$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lh7Oqf))),
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $6aoQW.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $6aoQW.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("code", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.error
        ])
    }, "ERROR: ", (0, $2HRPu.getErrorHash)(error)));
};

});
parcelRegister("lh7Oqf", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("6aoQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f850c5d954b638cc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f850c5d954b638cc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("8Q9Ns", function(module, exports) {

$parcel$export(module.exports, "SidebarStart", () => $b1d0fa6e8dcb9f72$export$6738d1299dc79710);
$parcel$export(module.exports, "SidebarRenderStart", () => $b1d0fa6e8dcb9f72$export$ba19e3624956e66);
$parcel$export(module.exports, "SidebarReady", () => $b1d0fa6e8dcb9f72$export$a06ecbbe5820282);
$parcel$export(module.exports, "useSidebarFail", () => $b1d0fa6e8dcb9f72$export$661ed14c8f75da9f);
$parcel$export(module.exports, "useSidebarSuccess", () => $b1d0fa6e8dcb9f72$export$ddb17534fdfb7dc6);

var $eJOHy = parcelRequire("eJOHy");

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");

var $aqnJa = parcelRequire("aqnJa");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4ctwv = parcelRequire("4ctwv");

var $XQ5wK = parcelRequire("XQ5wK");

var $hih5V = parcelRequire("hih5V");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $TLYhw = parcelRequire("TLYhw");

var $gCY1z = parcelRequire("gCY1z");

var $eES78 = parcelRequire("eES78");
// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
const { useValue: $b1d0fa6e8dcb9f72$var$useSidebarId } = (0, $XQ5wK.createValueController)('sidebar-id');
const $b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
    experience: (0, $eES78.SIDEBAR_EXPERIENCE),
    attributes: {
        sidebar: 'v3'
    }
};
const $b1d0fa6e8dcb9f72$export$6738d1299dc79710 = ()=>{
    const [{ route: route, match: match }] = (0, $gCY1z.useRouter)();
    const pageId = (0, $TLYhw.usePageId)();
    const startRef = (0, $eJOHy.useRef)(Date.now());
    const onStartExperience = (0, $8Uqf3.useExperienceStart)({
        experienceId: pageId,
        experience: (0, $eES78.SIDEBAR_EXPERIENCE),
        analyticsSource: 'Sidebar'
    });
    (0, $eJOHy.useMemo)(()=>{
        if (route.isRedirect ?? false) return;
        onStartExperience();
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        match
    ]);
    return null;
};
const $b1d0fa6e8dcb9f72$export$ba19e3624956e66 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderStart
    });
const $b1d0fa6e8dcb9f72$export$a06ecbbe5820282 = ({ id: id })=>{
    const [, setSidebarId] = $b1d0fa6e8dcb9f72$var$useSidebarId();
    const route = (0, $hih5V.useCurrentRoute)();
    const routeName = route.name ?? route.group ?? 'UNKNOWN';
    const onSuccess = (0, $4ctwv.useExperienceSuccess)($b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
    (0, $eJOHy.useEffect)(()=>{
        setSidebarId(id);
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        return ()=>setSidebarId();
    }, [
        setSidebarId,
        id
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (route.isRedirect ?? false) return;
        onSuccess();
    }, [
        onSuccess,
        route
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Why are we injecting the route name into the global window state?
        // We currently don't have any way to get the route name when the sidenav is rendered OUTSIDE of the SPA
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__POLLINATOR__ = {
            ...window.__POLLINATOR__,
            routeName: routeName
        };
        const event = createAnalyticsEvent({
            action: 'ready',
            actionSubject: 'sidebar',
            meta: {
                teamName: 'endeavour'
            }
        });
        (0, $gCeeo.fireUIAnalytics)(event, 'Sidebar Ready', {
            route: routeName
        });
    }, [
        createAnalyticsEvent,
        routeName
    ]);
    const customData = (0, $eJOHy.useMemo)(()=>({
            route: routeName,
            sidebarId: id
        }), [
        routeName,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceMark), {
        metricKey: (0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).renderEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $03pp6.NavSidebarPerformanceReport), {
        customData: customData
    }));
};
const $b1d0fa6e8dcb9f72$export$661ed14c8f75da9f = ()=>{
    const onFail = (0, $aqnJa.useExperienceFail)({
        experience: (0, $eES78.SIDEBAR_EXPERIENCE)
    });
    return (0, $eJOHy.useCallback)((location, error)=>{
        onFail(location, error);
    }, [
        onFail
    ]);
};
const $b1d0fa6e8dcb9f72$export$ddb17534fdfb7dc6 = ()=>(0, $4ctwv.useExperienceSuccess)($b1d0fa6e8dcb9f72$var$EXPERIENCE_SUCCESS_ATTRIBUTES);

});
parcelRegister("aqnJa", function(module, exports) {

$parcel$export(module.exports, "useExperienceFail", () => $07b7f78d48d39c0c$export$606da7704d8eaf06);

var $eJOHy = parcelRequire("eJOHy");

var $8KUFq = parcelRequire("8KUFq");

var $7Jk3f = parcelRequire("7Jk3f");

var $hWeHP = parcelRequire("hWeHP");

var $aSmR5 = parcelRequire("aSmR5");
const $07b7f78d48d39c0c$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const self = (0, $eJOHy.useRef)({
        name: experience,
        attributes: attributes,
        experienceTracker: experienceTracker
    });
    self.current.name = experience;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    return (0, $eJOHy.useCallback)((location, error, extraAttributes = {})=>{
        const { current: current } = self;
        // ignore client side errors from impacting experience metrics
        if ((0, $7Jk3f.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $8KUFq.isClientFetchError)(error)) return;
        const shardAndRegionAttributes = {
            shard: (0, $hWeHP.default)('ajs-shard'),
            region: (0, $hWeHP.default)('ajs-region')
        };
        current.experienceTracker.fail({
            name: current.name,
            error: error,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes,
                location: location
            }
        });
    }, [
        self
    ]);
};

});
parcelRegister("aSmR5", function(module, exports) {

$parcel$export(module.exports, "useExperienceContext", () => $9e8c86ec8261bcec$export$be8ec22ac9208049);

var $eJOHy = parcelRequire("eJOHy");

var $40f0Z = parcelRequire("40f0Z");
const $9e8c86ec8261bcec$export$be8ec22ac9208049 = ()=>{
    const context = (0, $eJOHy.useContext)((0, $40f0Z.ExperienceTrackerContext));
    return context;
};

});


parcelRegister("8Uqf3", function(module, exports) {

$parcel$export(module.exports, "useExperienceStart", () => $7363f384519bbd6b$export$675e0d25df38d426);
$parcel$export(module.exports, "ExperienceStart", () => $7363f384519bbd6b$export$f20b867e738a222c);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $aSmR5 = parcelRequire("aSmR5");
const $7363f384519bbd6b$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
    const self = (0, $eJOHy.useRef)({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        experienceTracker: experienceTracker,
        disableSli: disableSli,
        userLocation: userLocation,
        collect: collect
    });
    self.current.experienceId = experienceId;
    self.current.experience = experience;
    self.current.timeout = timeout;
    self.current.analyticsSource = analyticsSource;
    self.current.application = application;
    self.current.edition = edition;
    self.current.experienceTracker = experienceTracker;
    self.current.userLocation = userLocation;
    self.current.collect = collect;
    return (0, $eJOHy.useCallback)(()=>{
        const { current: current } = self;
        current.experienceTracker.start({
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            id: current.experienceId,
            name: current.experience,
            timeout: current.timeout,
            attributes: {
                analyticsSource: current.analyticsSource,
                experience: current.experience,
                experienceId: current.experienceId,
                application: current.application,
                edition: current.edition,
                disableSli: current.disableSli,
                userLocation: current.userLocation
            },
            collect: current.collect,
            onSuccess: ()=>undefined
        });
    }, [
        self
    ]);
};
const $7363f384519bbd6b$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
    const onStart = $7363f384519bbd6b$export$675e0d25df38d426({
        experienceId: experienceId,
        experience: experience,
        timeout: timeout,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        disableSli: disableSli,
        collect: collect
    });
    (0, $eJOHy.useMemo)(()=>{
        onStart();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onStart,
        experienceId,
        experience,
        timeout,
        analyticsSource,
        application,
        edition,
        disableSli,
        collect
    ]);
    return null;
};

});
parcelRegister("hih5V", function(module, exports) {

$parcel$export(module.exports, "useCurrentRoute", () => $0de85b9e16d59246$export$c4b7ea2942f2d0e);
$parcel$export(module.exports, "useRouteByName", () => $0de85b9e16d59246$export$d69a946e2d0a1c12);
$parcel$export(module.exports, "usePreviousRouterState", () => $0de85b9e16d59246$export$1e5fb68306bd0b92);

var $kfvK2 = parcelRequire("kfvK2");
var $gCY1z = parcelRequire("gCY1z");

var $kQnVX = parcelRequire("kQnVX");

const $0de85b9e16d59246$export$c4b7ea2942f2d0e = (0, $kfvK2.createRouterSelector)((state)=>state.route);
const $0de85b9e16d59246$export$d69a946e2d0a1c12 = (0, $kfvK2.createRouterSelector)((state, routeName)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    state.routes.find(({ name: name })=>name === routeName) ?? null);
const $0de85b9e16d59246$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
        name: name,
        path: path,
        query: query,
        exact: exact
    });
const $0de85b9e16d59246$export$1e5fb68306bd0b92 = ()=>{
    // Force updates whenever the current route changes
    (0, $gCY1z.useRouter)();
    return (0, $kQnVX.getPreviousRouterState)();
};

});


parcelRegister("4ctwv", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", () => $b1bfd6142c0877bc$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "ExperienceSuccess", () => $b1bfd6142c0877bc$export$4962f3898bd5c829);

var $eJOHy = parcelRequire("eJOHy");

var $hih5V = parcelRequire("hih5V");

var $hWeHP = parcelRequire("hWeHP");

var $aSmR5 = parcelRequire("aSmR5");
const $b1bfd6142c0877bc$var$STABLE_EMPTY_OBJECT = {};
const $b1bfd6142c0877bc$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $b1bfd6142c0877bc$var$STABLE_EMPTY_OBJECT })=>{
    const experienceTracker = (0, $aSmR5.useExperienceContext)();
    const route = (0, $hih5V.useCurrentRoute)();
    const self = (0, $eJOHy.useRef)({
        experience: experience,
        attributes: attributes,
        experienceTracker: experienceTracker,
        route: route
    });
    self.current.route = route;
    self.current.attributes = attributes;
    self.current.experienceTracker = experienceTracker;
    self.current.experience = experience;
    return (0, $eJOHy.useCallback)((extraAttributes = {})=>{
        const { current: current } = self;
        if (current.route && current.route.isRedirect === true) return;
        const shardAndRegionAttributes = {
            shard: (0, $hWeHP.default)('ajs-shard'),
            region: (0, $hWeHP.default)('ajs-region')
        };
        current.experienceTracker.succeed({
            name: current.experience,
            attributes: {
                ...current.attributes,
                ...extraAttributes,
                ...shardAndRegionAttributes
            }
        });
    }, [
        self
    ]);
};
const $b1bfd6142c0877bc$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $b1bfd6142c0877bc$var$STABLE_EMPTY_OBJECT })=>{
    const onExperienceSuccess = $b1bfd6142c0877bc$export$e94f0da4fc0603c6({
        experience: experience,
        attributes: attributes
    });
    (0, $eJOHy.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        attributes,
        onExperienceSuccess
    ]);
    (0, $eJOHy.useMemo)(()=>{
        if (false) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return null;
};

});

parcelRegister("XQ5wK", function(module, exports) {

$parcel$export(module.exports, "createValueController", () => $a097180df6b282dc$export$ff0ab9dd4ceb4a93);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $a097180df6b282dc$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
    const actions = {
        setValue: (value)=>({ setState: setState })=>setState({
                    value: value
                })
    };
    const initialState = {
        value: defaultValue
    };
    const store = (0, $GtRbT.createStore)({
        name: name,
        initialState: initialState,
        actions: actions
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ValueContainer = (0, $6E16M.createContainer)(store);
    const selector = (state)=>state.value;
    const useValueInternal = (0, $iJq0l.createHook)(store, {
        selector: selector
    });
    const useValue = ()=>{
        const [value, { setValue: setValue }] = useValueInternal();
        return [
            value,
            setValue
        ];
    };
    return {
        ValueContainer: ValueContainer,
        useValue: useValue
    };
};

});

parcelRegister("TLYhw", function(module, exports) {

$parcel$export(module.exports, "usePageId", () => $86c78d8a6af84e38$export$3434ba5eadb360dc);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");

var $6XFSq = parcelRequire("6XFSq");
const $86c78d8a6af84e38$var$useSweetStatePageId = (0, $iJq0l.createHook)((0, $6XFSq.default), {
    selector: (state)=>state.currentPage.uuid
});
const $86c78d8a6af84e38$export$3434ba5eadb360dc = ()=>{
    const [pageId] = $86c78d8a6af84e38$var$useSweetStatePageId();
    return pageId;
};

});

parcelRegister("eES78", function(module, exports) {

$parcel$export(module.exports, "REPO_TYPE", () => $52e041f2c33cd742$export$399c7e6858236b4);
$parcel$export(module.exports, "LINK_TYPE", () => $52e041f2c33cd742$export$58125ce2bb1c3378);
$parcel$export(module.exports, "EMOJI_REGEX", () => $52e041f2c33cd742$export$c79ed2783644934c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", () => $52e041f2c33cd742$export$25ae65041c800c9);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", () => $52e041f2c33cd742$export$e03c9beea817d44b);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", () => $52e041f2c33cd742$export$3d575bdf28c0d17c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", () => $52e041f2c33cd742$export$af84baced6970a17);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", () => $52e041f2c33cd742$export$c767f253046b1ea7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", () => $52e041f2c33cd742$export$265b9384cc2dfbd4);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$2de77b357e71c7a7);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$7de7abb92169d6c);
$parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", () => $52e041f2c33cd742$export$fd7df8bd7600c65c);
$parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", () => $52e041f2c33cd742$export$dde074e512e80dff);
$parcel$export(module.exports, "REPORTS_IDS", () => $52e041f2c33cd742$export$1f70a76cb421b107);
$parcel$export(module.exports, "SIDEBAR_EXPERIENCE", () => $52e041f2c33cd742$export$71aaf2625ee54d10);
$parcel$export(module.exports, "staticLegacyIds", () => $52e041f2c33cd742$export$f57650e6e7be03dc);
const $52e041f2c33cd742$export$399c7e6858236b4 = 'source.code.link';
const $52e041f2c33cd742$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $52e041f2c33cd742$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
const $52e041f2c33cd742$export$25ae65041c800c9 = 'pin-filter-myopenissues';
const $52e041f2c33cd742$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
const $52e041f2c33cd742$export$3d575bdf28c0d17c = 'pin-filter-allissues';
const $52e041f2c33cd742$export$af84baced6970a17 = 'pin-filter-allopenissues';
const $52e041f2c33cd742$export$c767f253046b1ea7 = 'pin-filter-doneissues';
const $52e041f2c33cd742$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
const $52e041f2c33cd742$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
const $52e041f2c33cd742$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
const $52e041f2c33cd742$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
const $52e041f2c33cd742$export$dde074e512e80dff = 'global-create-spotlight';
const $52e041f2c33cd742$export$1f70a76cb421b107 = {
    REPORTS_ADDONS: 'sd-reports-addons'
};
const $52e041f2c33cd742$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
const $52e041f2c33cd742$export$f57650e6e7be03dc = [
    // Global Settings Static Legacy Ids
    'general_configuration',
    'dark_features',
    'troubleshooting_and_support',
    'view_auditing',
    'pluginViewer',
    'pluginViewer',
    'system_info',
    'integrity_checker',
    'logging_profiling',
    'scheduler_details',
    'security_section',
    'project_role_browser',
    'global_permissions',
    'collectors',
    'user_interface',
    'user_defaults',
    'edit_default_dashboard',
    'lookandfeel',
    'com.atlassian.pas:pas-admin-link-jira',
    'import_export_section',
    'vertigo_export',
    'external_import',
    'vertigo_import',
    'vertigo_import_jira_cloud',
    'vertigo_import_jira_server',
    'mail_section',
    'global_mail_settings',
    'outgoing_mail',
    'incoming_mail',
    'send_email',
    'admin-helper-admin-section',
    'permissionhelper-admin-page',
    'notificationhelper-admin-page',
    'shared_section',
    'shared_filters',
    'shared_dashboards',
    'advanced_section',
    'attachments',
    'eventtypes',
    'webhooks-admin',
    'services',
    'manage_dashboards',
    'manage_filters',
    'greenhopper-lexorank-manage',
    // Project Settings Static Legacy Ids
    'jira.webfragments.view.project.operations:edit_project',
    'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
    'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
    'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
    'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
    'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
    'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
    'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
    'com.atlassian.jira.jira-projects-plugin:administer_project_components',
    'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
    'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
    'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
    'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
    'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
    'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation.moderate__cb-automation-project-config',
    'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
    'com.atlassian.jira.jira-projects-plugin:administer_project_code',
    'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
    'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
    'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
    'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
    'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
    'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
    'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
    'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
    'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
    'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
    'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
    'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
    'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
    'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
    'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
    'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
    // Automation connect item
    'com.codebarrel.addons.automation__cb-automation',
    'com.codebarrel.addons.automation.moderate__cb-automation'
];

});


parcelRegister("gpE1B", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $65e95951f2fce7be$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $diNYL = parcelRequire("diNYL");
var $6seod = parcelRequire("6seod");
const $65e95951f2fce7be$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "sidebar-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65e95951f2fce7be$var$BackgroundedWrapper, null, isFull && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($65e95951f2fce7be$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6seod.default), {
        hasIcon: isFull
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $65e95951f2fce7be$var$BackgroundedWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1tem _ca0qidpf _u5f31ejb _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $65e95951f2fce7be$var$HeadingWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt41k9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("diNYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c44efaa9252dc1d8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YEko = parcelRequire("6YEko");

var $2eOKX = parcelRequire("2eOKX");
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c44efaa9252dc1d8$var$Section = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $c44efaa9252dc1d8$export$2e2bcd8739ae039 = $c44efaa9252dc1d8$var$Section;

});

parcelRegister("6seod", function(module, exports) {

$parcel$export(module.exports, "default", () => $982e2949d673f589$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2bMVP = parcelRequire("2bMVP");

var $2eOKX = parcelRequire("2eOKX");
/**
 * __Skeleton item__
 *
 * A skeleton item can be used to reduce the perceived loading time.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#loading)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $982e2949d673f589$var$SkeletonItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bMVP.default), {
        isSideNavSkeleton: true,
        ...props
    });
};
var $982e2949d673f589$export$2e2bcd8739ae039 = $982e2949d673f589$var$SkeletonItem;

});



parcelRegister("7DXwW", function(module, exports) {

$parcel$export(module.exports, "setPerformanceMarkLoadStart", () => $2ebdd972899a51f4$export$4166241bf9111f66);
$parcel$export(module.exports, "setPerformanceMarkLoadEnd", () => $2ebdd972899a51f4$export$edbd543f308bbef5);

var $hOBHo = parcelRequire("hOBHo");

var $03pp6 = parcelRequire("03pp6");
const $2ebdd972899a51f4$export$4166241bf9111f66 = ()=>{
    const sideBarSegment = (0, $03pp6.pageSegmentStore).getSegment((0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadStart);
};
const $2ebdd972899a51f4$export$edbd543f308bbef5 = ()=>{
    const sideBarSegment = (0, $03pp6.pageSegmentStore).getSegment((0, $hOBHo.NAVIGATION_SIDEBAR_SEGMENT_NAME));
    sideBarSegment.mark((0, $hOBHo.NAVIGATION_SIDEBAR_MARKS).loadEnd);
};

});

parcelRegister("kCCbB", function(module, exports) {

let $f034fa3ab0dde7d4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f034fa3ab0dde7d4$var$load("76n7a"),
    $f034fa3ab0dde7d4$var$load("l253H"),
    $f034fa3ab0dde7d4$var$load("ffQaD"),
    $f034fa3ab0dde7d4$var$load("kvRbA"),
    $f034fa3ab0dde7d4$var$load("4r1UM")
]).then(()=>parcelRequire('jlQix'));

});


parcelRegister("6xToB", function(module, exports) {

$parcel$export(module.exports, "createEntry", () => $d82625afc3ab60ed$export$344b9c9ab5e66c9a);

var $cZFiO = parcelRequire("cZFiO");
const $d82625afc3ab60ed$export$344b9c9ab5e66c9a = (0, $cZFiO.createRouteEntry);

});
parcelRegister("cZFiO", function(module, exports) {

$parcel$export(module.exports, "createRouteEntry", () => $afe0694b9341fac8$export$136cc45b1cabb43);
/**
 * Create route entry with entrypoint, resources, etc. override
 *
 * @param baseRoute Base route object that contains matching info
 * @param opts Route definition to fill and override
 */ function $afe0694b9341fac8$export$136cc45b1cabb43(baseRoute, opts) {
    // @ts-expect-error Re-using baseRoute to become the full route Object allows us to optimize
    // route transitions as RRR can directly use the route instead of comparing a separate InvariantRoute
    // against the full route list
    // eslint-disable-next-line no-param-reassign
    baseRoute.lazyOpts = opts;
    // @ts-expect-error TODO
    return baseRoute;
}

});


parcelRegister("jbTNU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", () => $1855163d6f79197b$export$4f2c2d125c2b811a);
const $1855163d6f79197b$export$4f2c2d125c2b811a = {
    name: 'global-settings-issues-explicit-field-association-project-list',
    path: '/jira/settings/issues/explicit-field-association'
};

});

parcelRegister("8zfV8", function(module, exports) {

$parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", () => $fb333efc50c60ea2$export$7b11685155ada84d);
$parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", () => $fb333efc50c60ea2$export$e81c180c4f4833e);

var $eJOHy = parcelRequire("eJOHy");

var $bQWwW = parcelRequire("bQWwW");

var $1F9cm = parcelRequire("1F9cm");

const $fb333efc50c60ea2$export$7b11685155ada84d = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4d81N")), {
    moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
});
const $fb333efc50c60ea2$export$e81c180c4f4833e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1F9cm.LazyPage), {
        Page: $fb333efc50c60ea2$export$7b11685155ada84d,
        pageId: "errors-404",
        shouldShowSpinner: false
    });

});
parcelRegister("1F9cm", function(module, exports) {

$parcel$export(module.exports, "LazyPage", () => $115917303a5a4975$export$a18c9c3dd309b8e6);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $eSnSE = parcelRequire("eSnSE");

var $ch9En = parcelRequire("ch9En");

var $hih5V = parcelRequire("hih5V");

var $56O0g = parcelRequire("56O0g");

var $dTqD3 = parcelRequire("dTqD3");

var $lq8Ki = parcelRequire("lq8Ki");
const $115917303a5a4975$var$LOCATION = 'lazy-page';
const $115917303a5a4975$export$fb85bbdbfb3e6869 = ()=>null;
const $115917303a5a4975$export$a18c9c3dd309b8e6 = ({ pageId: pageId, Page: Page, shouldShowSpinner: shouldShowSpinner = true })=>{
    const route = (0, $hih5V.useCurrentRoute)();
    const Skeleton = route.skeleton || (shouldShowSpinner ? (0, $6OSA0.default) : $115917303a5a4975$export$fb85bbdbfb3e6869);
    (0, $eJOHy.useEffect)(()=>{
        if (route.isRedirect) (0, $eSnSE.default).safeWarnWithoutCustomerData($115917303a5a4975$var$LOCATION, `LazyPage was used inside a redirect component: ${route.name}`);
    }, [
        route.isRedirect,
        route.name
    ]);
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.ReportSSRFailOnUse), {
        pageId: pageId,
        fallbackId: "LazyPage"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null));
    return route.isRedirect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "lazy_page_redirect",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Page, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $56O0g.default), {
        pageId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStateContainer), {
        isGlobal: true,
        appId: pageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStateAppStartWithMatchCheck), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "lazy_page",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lq8Ki.DisableSSRFailDetection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Page, null)))));
};

});
parcelRegister("6OSA0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dece214507286a2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dLR8J = parcelRequire("dLR8J");

var $7ep4S = parcelRequire("7ep4S");
function $9dece214507286a2$export$2e2bcd8739ae039({ testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "legacy-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9dece214507286a2$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9dece214507286a2$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "large",
        testId: testId
    }))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9dece214507286a2$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o _ae4v1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $9dece214507286a2$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("56O0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37d100a906af14f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $662Y6 = parcelRequire("662Y6");

var $6uWhG = parcelRequire("6uWhG");

var $5onjV = parcelRequire("5onjV");

var $2HxHL = parcelRequire("2HxHL");

var $9DwQv = parcelRequire("9DwQv");


var $eeVmH = parcelRequire("eeVmH");

var $dNyX9 = parcelRequire("dNyX9");
class $e37d100a906af14f$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { children: children, pageId: pageId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eeVmH.default).Provider, {
            // @ts-expect-error - TS2322 - Type '{ pageId: string; onReady: (metricKeyForInitialRender: string, metricKeyForTransition: string, extra: { [key: string]: string | number | boolean; } | undefined, metric: BM3Metric) => void; onCustomMark: (markName: string) => void; }' is not assignable to type 'string'.
            value: {
                pageId: pageId,
                onReady: this.onReady,
                onCustomMark: this.onCustomMark
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
            op: this.onStart,
            args: [
                pageId
            ]
        }), children));
    }
    constructor(...args){
        super(...args), this.customMarks = [], this.onStart = ()=>{
            (0, $662Y6.default)((0, $2e47af044bce450a$export$56940a9488e85199));
            (0, $6uWhG.setMark)((0, $2e47af044bce450a$export$45c4b6bf7935c69a));
        }, this.onCustomMark = (markName)=>{
            (0, $6uWhG.setMark)((0, $dNyX9.getPrefixedMarkName)(markName));
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
            this.customMarks.push(markName);
        }, this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
            metric.stop({
                customData: extra
            });
            if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
        };
    }
}

});
parcelRegister("662Y6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8b8f5b498d09c66$export$2e2bcd8739ae039);

var $gPCSe = parcelRequire("gPCSe");
var /*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$a8b8f5b498d09c66$export$2e2bcd8739ae039 = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $gPCSe.default) && (0, $gPCSe.default).getEntries && (0, $gPCSe.default).clearMarks) return (0, $gPCSe.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $gPCSe.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};

});

parcelRegister("5onjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7adc4a77c4e3fb86$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");
// eslint-disable-next-line jira/react/no-class-components
class $7adc4a77c4e3fb86$var$OpTrigger extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $7adc4a77c4e3fb86$export$2e2bcd8739ae039 = $7adc4a77c4e3fb86$var$OpTrigger;

});

parcelRegister("2HxHL", function(module, exports) {

$parcel$export(module.exports, "stopLowPriorityEventDelay", () => $0d6f1ba58ae6ece0$export$a928755af449867);
$parcel$export(module.exports, "startLowPriorityEventDelay", () => $0d6f1ba58ae6ece0$export$8bb8df5a93e9525);
$parcel$export(module.exports, "default", () => $0d6f1ba58ae6ece0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $662Y6 = parcelRequire("662Y6");

var $6uWhG = parcelRequire("6uWhG");

var $8MHJG = parcelRequire("8MHJG");

var $2Mqjh = parcelRequire("2Mqjh");

var $jEvkf = parcelRequire("jEvkf");

var $9DwQv = parcelRequire("9DwQv");

const $0d6f1ba58ae6ece0$var$STOP_DELAY_TIMEOUT = 10000;
let $0d6f1ba58ae6ece0$var$stopDelayTimeout;
let $0d6f1ba58ae6ece0$var$lastDelayActionPromise = (0, $2Mqjh.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
const $0d6f1ba58ae6ece0$export$a928755af449867 = ()=>{
    $0d6f1ba58ae6ece0$var$lastDelayActionPromise = $0d6f1ba58ae6ece0$var$lastDelayActionPromise.then((client)=>{
        if (!(0, $8MHJG.isEventDelayActive)()) return client;
        clearTimeout($0d6f1ba58ae6ece0$var$stopDelayTimeout);
        // stopLowPriorityEventDelay performs a flush of the delayed events,
        // so the delayed period needs to be marked as ended _before_ calling that method.
        (0, $6uWhG.setMark)((0, $f8c82f467f2e47ac$export$2d91d3eed1108e72));
        (0, $8MHJG.setEventDelayActive)(false);
        client.stopLowPriorityEventDelay();
        return client;
    });
};
const $0d6f1ba58ae6ece0$export$8bb8df5a93e9525 = ()=>{
    $0d6f1ba58ae6ece0$var$lastDelayActionPromise = $0d6f1ba58ae6ece0$var$lastDelayActionPromise.then((client)=>{
        // If startLowPriorityEventDelay is called when it's already active, then we are just extending
        // the delay period, so we don't want to reset any metadata we have captured about the original start.
        if (!(0, $8MHJG.isEventDelayActive)()) {
            (0, $662Y6.default)((0, $f8c82f467f2e47ac$export$358721a9d6125914));
            (0, $6uWhG.setMark)((0, $f8c82f467f2e47ac$export$b2122dce85a27912));
        }
        client.startLowPriorityEventDelay();
        (0, $8MHJG.setEventDelayActive)(true);
        clearTimeout($0d6f1ba58ae6ece0$var$stopDelayTimeout);
        $0d6f1ba58ae6ece0$var$stopDelayTimeout = setTimeout($0d6f1ba58ae6ece0$export$a928755af449867, $0d6f1ba58ae6ece0$var$STOP_DELAY_TIMEOUT);
        return client;
    });
};
const $0d6f1ba58ae6ece0$export$778ebe2a4fab1ba7 = ()=>$0d6f1ba58ae6ece0$var$lastDelayActionPromise;
const $0d6f1ba58ae6ece0$var$EventDelayController = ()=>{
    const [loadedState] = (0, $jEvkf.default)();
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * The delay mechanism is currently locked so that only automatic exposure events
		 * can leverage it.
		 * We can remove the performance overhead of starting and stopping critical sections when
		 * these events won't be getting fired.
		 */ if (!loadedState.hasLoaded && (0, $9DwQv.isAutomaticExposureCollectionEnabled)()) $0d6f1ba58ae6ece0$export$8bb8df5a93e9525();
    }, [
        loadedState.hasLoaded
    ]);
    return null;
};
var $0d6f1ba58ae6ece0$export$2e2bcd8739ae039 = $0d6f1ba58ae6ece0$var$EventDelayController;

});
parcelRegister("8MHJG", function(module, exports) {

$parcel$export(module.exports, "setEventDelayActive", () => $477d32fa9a5520a7$export$9a4add6d6ddcc1a);
$parcel$export(module.exports, "isEventDelayActive", () => $477d32fa9a5520a7$export$3536b0184fa98d19);
let $477d32fa9a5520a7$var$eventDelayActive = false;
const $477d32fa9a5520a7$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
    $477d32fa9a5520a7$var$eventDelayActive = isEventDelayActive;
};
const $477d32fa9a5520a7$export$3536b0184fa98d19 = ()=>$477d32fa9a5520a7$var$eventDelayActive;

});

parcelRegister("jEvkf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ceb916e99bf85cf$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");


var $6XFSq = parcelRequire("6XFSq");
const $9ceb916e99bf85cf$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
    const { apps: apps } = currentPage;
    const appIds = Object.keys(apps);
    const determineHasLoaded = ()=>{
        /*
		 * During a transition, the top navigation is the only app loading. Additionally, legacy pages generally
		 * render a LegacyPage component, analytics, or nothing at all.
		 *
		 * This code ensures that the page is considered loaded when the content has finished loading in the
		 * SPA, or when the top navigation has finished loading for legacy pages.
		 *
		 * Ideally the LegacyPage component should include an app for the content, but the usage of route components
		 * in legacy routes is inconsistent and would need thorough testing. This should be good enough for now.
		 */ if (appIds.length === 1 && appIds[0] === (0, $ceaa13d70a0542eb$export$3a54edb6ba4daa82)) return !__SPA__;
        return appIds.length ? appIds.filter((id)=>id !== (0, $ceaa13d70a0542eb$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
    };
    const hasLoaded = determineHasLoaded();
    return {
        hasLoaded: hasLoaded
    };
};
const $9ceb916e99bf85cf$var$usePageLoadedSubscriber = (0, $iJq0l.createHook)((0, $6XFSq.default), {
    selector: $9ceb916e99bf85cf$export$4a361c7505f72f5c
});
var $9ceb916e99bf85cf$export$2e2bcd8739ae039 = $9ceb916e99bf85cf$var$usePageLoadedSubscriber;

});
const $ceaa13d70a0542eb$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $ceaa13d70a0542eb$export$2ee9e5a3556c1e43 = 'SIDEBAR';


const $f8c82f467f2e47ac$export$358721a9d6125914 = 'event-delay-controller.';
const $f8c82f467f2e47ac$export$b2122dce85a27912 = `${$f8c82f467f2e47ac$export$358721a9d6125914}start`;
const $f8c82f467f2e47ac$export$2d91d3eed1108e72 = `${$f8c82f467f2e47ac$export$358721a9d6125914}end`;


const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("eeVmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $03af3bc2e4718069$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $03af3bc2e4718069$var$contextName = 'SpaApdexAnalytics';
var $03af3bc2e4718069$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.createContext)($03af3bc2e4718069$var$contextName);

});

parcelRegister("dNyX9", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $63d33e770a180de1$export$c8f0e9837e7e9425);

const $63d33e770a180de1$export$c8f0e9837e7e9425 = (name)=>`${0, $2e47af044bce450a$export$56940a9488e85199}${name}`;

});


parcelRegister("dTqD3", function(module, exports) {

$parcel$export(module.exports, "SpaStateContainer", () => $79922c5ee50c1ff4$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $79922c5ee50c1ff4$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $79922c5ee50c1ff4$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $79922c5ee50c1ff4$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $79922c5ee50c1ff4$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $79922c5ee50c1ff4$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $79922c5ee50c1ff4$export$6e9ab893e97cccef);

var $eJOHy = parcelRequire("eJOHy");

var $5onjV = parcelRequire("5onjV");

var $kfvK2 = parcelRequire("kfvK2");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $14kUX = parcelRequire("14kUX");

var $bJscI = parcelRequire("bJscI");

var $il8Fk = parcelRequire("il8Fk");

var $6XFSq = parcelRequire("6XFSq");
const $79922c5ee50c1ff4$export$e9a92b877fe80e80 = (0, $6E16M.createContainer)((0, $6XFSq.default));
const $79922c5ee50c1ff4$export$d18dd27183a635c = ()=>{
    const startRef = (0, $eJOHy.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $il8Fk.useSpaState)();
    (0, $eJOHy.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $79922c5ee50c1ff4$var$useRouterMatchSelector = (0, $kfvK2.createRouterSelector)((state)=>state.match);
const $79922c5ee50c1ff4$var$useSpaStatePagesCount = (0, $iJq0l.createHook)((0, $6XFSq.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $79922c5ee50c1ff4$export$95a2912d76fb5433 = ()=>{
    const match = $79922c5ee50c1ff4$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $79922c5ee50c1ff4$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($79922c5ee50c1ff4$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
function $79922c5ee50c1ff4$var$SpaStatePageReadyWithHooks() {
    const { setAppReady: setAppReady } = (0, $il8Fk.useSpaStateActions)();
    (0, $eJOHy.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady
    ]);
    return null;
}
function $79922c5ee50c1ff4$var$SpaStatePageReadyWithSubscriber() {
    /* TODO - this should be using only the actions subscriber not state+actions subscriber */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $il8Fk.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
            op: setAppReady
        }));
}
const $79922c5ee50c1ff4$export$c34439f945fccbdf = (0, $bJscI.componentWithFG)('jfp_magma_migrate_spa_state_controllers_to_hooks', $79922c5ee50c1ff4$var$SpaStatePageReadyWithHooks, $79922c5ee50c1ff4$var$SpaStatePageReadyWithSubscriber);
function $79922c5ee50c1ff4$var$SpaStatePageReadyOnUpdateWithHooks({ updateKey: updateKey }) {
    const { setAppReady: setAppReady } = (0, $il8Fk.useSpaStateActions)();
    (0, $eJOHy.useEffect)(()=>{
        setAppReady();
    }, [
        setAppReady,
        updateKey
    ]);
    return null;
}
function $79922c5ee50c1ff4$var$SpaStatePageReadyOnUpdateWithSubscriber({ comparer: comparer }) {
    /* TODO - this should be using only the actions subscriber not state+actions subscriber */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $il8Fk.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
            op: setAppReady,
            args: comparer
        }));
}
const $79922c5ee50c1ff4$export$41e70078eeddaddc = (0, $bJscI.componentWithFG)('jfp_magma_migrate_spa_state_controllers_to_hooks', $79922c5ee50c1ff4$var$SpaStatePageReadyOnUpdateWithHooks, $79922c5ee50c1ff4$var$SpaStatePageReadyOnUpdateWithSubscriber);
function $79922c5ee50c1ff4$var$SpaStatePageErrorReadyWithHooks() {
    const { setAppErrorReady: setAppErrorReady } = (0, $il8Fk.useSpaStateActions)();
    (0, $eJOHy.useEffect)(()=>{
        setAppErrorReady();
    }, [
        setAppErrorReady
    ]);
    return null;
}
function $79922c5ee50c1ff4$var$SpaStatePageErrorReadyWithSubscriber() {
    return /* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $il8Fk.SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
            op: setAppErrorReady
        }));
}
const $79922c5ee50c1ff4$export$2583aa269898885c = (0, $bJscI.componentWithFG)('jfp_magma_migrate_spa_state_controllers_to_hooks', $79922c5ee50c1ff4$var$SpaStatePageErrorReadyWithHooks, $79922c5ee50c1ff4$var$SpaStatePageErrorReadyWithSubscriber);
class $79922c5ee50c1ff4$export$ada7e0ec445851a2 extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $79922c5ee50c1ff4$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $14kUX.defaultRegistry).getStore((0, $6XFSq.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});

parcelRegister("lq8Ki", function(module, exports) {

$parcel$export(module.exports, "ReportSSRFailOnUse", () => $3331f614e25114ce$export$daa3f09a96683b19);
$parcel$export(module.exports, "DisableSSRFailDetection", () => $3331f614e25114ce$export$420f5a45dbda6a67);

var $eJOHy = parcelRequire("eJOHy");
const $3331f614e25114ce$export$daa3f09a96683b19 = ()=>{
    // this component does nothing. Its .server. version does
    return null;
};
const $3331f614e25114ce$export$420f5a45dbda6a67 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});


parcelRegister("4d81N", function(module, exports) {

let $310e9a7e710271bc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $310e9a7e710271bc$var$load("7mIf9"),
    $310e9a7e710271bc$var$load("jXweD"),
    $310e9a7e710271bc$var$load("ffQaD"),
    $310e9a7e710271bc$var$load("kvRbA"),
    $310e9a7e710271bc$var$load("jbxE1"),
    $310e9a7e710271bc$var$load("7imUH"),
    $310e9a7e710271bc$var$load("76n7a"),
    $310e9a7e710271bc$var$load("l253H"),
    $310e9a7e710271bc$var$load("kNFvF"),
    $310e9a7e710271bc$var$load("kVX56"),
    $310e9a7e710271bc$var$load("7UJZZ")
]).then(()=>parcelRequire('4534k'));

});



parcelRegister("hTn5h", function(module, exports) {

$parcel$export(module.exports, "addonsEmceePublicRouteEntry", () => $0dbb378d6ec66943$export$7922e0b87a833c8e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $hlzJx = parcelRequire("hlzJx");
const $0dbb378d6ec66943$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).ADDONS
});
const $0dbb378d6ec66943$export$7922e0b87a833c8e = (0, $bAJhM.createLegacyEntry)((0, $hlzJx.addonsEmceePublicRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)()
        ],
        entryPoint: ()=>$0dbb378d6ec66943$var$pageEntryPoint
    }));

});
parcelRegister("jPn4m", function(module, exports) {

$parcel$export(module.exports, "legacyPageEntrypoint", () => $40b1df3cac9131ed$export$940b6ffb7ea59cb);
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $3Bzqe = parcelRequire("3Bzqe");

var $hu2rE = parcelRequire("hu2rE");

const $40b1df3cac9131ed$export$940b6ffb7ea59cb = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("3deYd")), {
        moduleId: "f7508cc9",
        priority: "userVisible"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("3deYd", function(module, exports) {

let $256e32ca3279e9c1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $256e32ca3279e9c1$var$load("4y0GY").then(()=>parcelRequire('83vnx'));

});


parcelRegister("g8uYY", function(module, exports) {

$parcel$export(module.exports, "createChromelessEntryPoint", () => $d4128f4ca41a15cd$export$56ea489e9d4bfa04);
$parcel$export(module.exports, "createPageEntryPoint", () => $d4128f4ca41a15cd$export$955a7619d2679b4c);

var $8xgJ5 = parcelRequire("8xgJ5");


var $6zXPf = parcelRequire("6zXPf");
const $d4128f4ca41a15cd$export$56ea489e9d4bfa04 = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $ce4cfb37df77ff19$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    }
                }
            }),
        toString: ()=>'ChromelessEntryPoint'
    });
const $d4128f4ca41a15cd$export$955a7619d2679b4c = (page)=>({
        root: page.main.root,
        getPreloadProps: (entryPointParams)=>({
                entryPoints: {
                    [(0, $ce4cfb37df77ff19$export$900ddb492c628f48)]: {
                        entryPoint: page.main,
                        entryPointParams: entryPointParams
                    },
                    [(0, $ce4cfb37df77ff19$export$bec6dca2e63de4ae)]: {
                        entryPoint: (0, $8xgJ5.topNavigationEntryPoint),
                        entryPointParams: {
                            menuId: page.topNavigationMenuId
                        }
                    },
                    ...page.leftSidebar ? {
                        [(0, $ce4cfb37df77ff19$export$50ea883ba6f28ff5)]: {
                            entryPoint: page.leftSidebar.sidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                entryPoints: {
                                    ...page.leftSidebar.entryPoints ? $d4128f4ca41a15cd$var$injectEntryPointParams(page.leftSidebar.entryPoints, entryPointParams) : undefined
                                },
                                isAppsExpanded: page.leftSidebar.isAppsExpanded ?? false,
                                isFiltersExpanded: page.leftSidebar.isFiltersExpanded ?? false,
                                isPlansExpanded: page.leftSidebar.isPlansExpanded ?? false,
                                isProjectsExpanded: page.leftSidebar.isProjectsExpanded ?? false,
                                isOperationsExpanded: page.leftSidebar.isOperationsExpanded ?? false,
                                isOverviewsExpanded: page.leftSidebar.isOverviewsExpanded ?? false
                            }
                        }
                    } : undefined,
                    ...page.horizontalNavigation && (0, $6zXPf.getWillShowNav4)() ? {
                        [(0, $ce4cfb37df77ff19$export$948d4d345566aed3)]: {
                            entryPoint: page.horizontalNavigation,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.horizontalNavigationFallback
                            }
                        }
                    } : undefined,
                    ...page.rightSidebar ? {
                        [(0, $ce4cfb37df77ff19$export$7bf43119a6b49ddb)]: {
                            entryPoint: page.rightSidebar,
                            entryPointParams: {
                                ...entryPointParams,
                                fallback: page.rightSidebarFallback
                            }
                        }
                    } : undefined
                }
            }),
        toString: ()=>'PageEntryPoint'
    });
function $d4128f4ca41a15cd$var$injectEntryPointParams(obj, entryPointParams) {
    const newParams = {};
    // https://stackoverflow.com/a/16735184
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) newParams[prop] = {
        entryPoint: obj[prop].entryPoint,
        entryPointParams: entryPointParams
    };
    return newParams;
}

});
parcelRegister("8xgJ5", function(module, exports) {

$parcel$export(module.exports, "topNavigationEntryPoint", () => $bd208b44eaab6db9$export$f780be9e138f456f);

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

const $bd208b44eaab6db9$export$f780be9e138f456f = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("7WeJ3")).then(({ AtlassianNavigation: AtlassianNavigation })=>AtlassianNavigation), {
        moduleId: "1f1265b4",
        priority: "userVisible"
    }),
    getPreloadProps: (extraProps)=>({
            extraProps: extraProps
        })
});

});

const $ce4cfb37df77ff19$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $ce4cfb37df77ff19$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $ce4cfb37df77ff19$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $ce4cfb37df77ff19$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $ce4cfb37df77ff19$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';


parcelRegister("gKFn0", function(module, exports) {

$parcel$export(module.exports, "default", () => $09413d0f48517527$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $09413d0f48517527$var$LazyGlobalAppsSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("6l7EE")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
});
const $09413d0f48517527$var$GlobalAppsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalAppsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($09413d0f48517527$var$LazyGlobalAppsSettingsSidebar, null)));
$09413d0f48517527$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
var $09413d0f48517527$export$2e2bcd8739ae039 = $09413d0f48517527$var$GlobalAppsSettingsSidebar;

});
parcelRegister("6l7EE", function(module, exports) {

let $49daa44ff89f9082$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $49daa44ff89f9082$var$load("ffQaD"),
    $49daa44ff89f9082$var$load("kvRbA"),
    $49daa44ff89f9082$var$load("ju8d5")
]).then(()=>parcelRequire('a6XIl'));

});


parcelRegister("bAJhM", function(module, exports) {

$parcel$export(module.exports, "createLegacyEntry", () => $8f24b8cebc35aec9$export$3ee7de8548f88c5f);

var $cZFiO = parcelRequire("cZFiO");
const $8f24b8cebc35aec9$export$3ee7de8548f88c5f = (0, $cZFiO.createRouteEntry);

});

parcelRegister("hlzJx", function(module, exports) {

$parcel$export(module.exports, "addonsEmceePublicRoute", () => $1a0c8156f2c01b4c$export$9f7bcf70c66ebed0);
const $1a0c8156f2c01b4c$export$9f7bcf70c66ebed0 = {
    name: 'addons-emcee-public',
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee/enduser-discover'
};

});


parcelRegister("53afF", function(module, exports) {

$parcel$export(module.exports, "legacyAllReportsRouteEntry", () => $6564a13ec3f12f57$export$b8ab848c3f170ed4);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $4ZfeE = parcelRequire("4ZfeE");

var $g8uYY = parcelRequire("g8uYY");

var $9n5I0 = parcelRequire("9n5I0");

var $jPn4m = parcelRequire("jPn4m");

var $eMJ38 = parcelRequire("eMJ38");
const $6564a13ec3f12f57$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $6564a13ec3f12f57$export$b8ab848c3f170ed4 = (0, $bAJhM.createLegacyEntry)((0, $4ZfeE.legacyAllReportsRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $eMJ38.getReportsCommonResource)()
        ],
        entryPoint: ()=>$6564a13ec3f12f57$var$pageEntryPoint
    }));

});
parcelRegister("ioHIu", function(module, exports) {

$parcel$export(module.exports, "genericProjectLayout", () => $b45ef5b2a7af08eb$export$85dad8e9886563f6);

var $cEBDW = parcelRequire("cEBDW");

var $6dwgv = parcelRequire("6dwgv");

var $aQoXd = parcelRequire("aQoXd");

var $8FCAy = parcelRequire("8FCAy");

var $dkgBy = parcelRequire("dkgBy");
const $b45ef5b2a7af08eb$export$85dad8e9886563f6 = (0, $6dwgv.composeLayouts)((0, $8FCAy.classicSoftwareProjectLayout), (0, $cEBDW.coreProjectLayout), (0, $aQoXd.serviceProjectLayout), (0, $8FCAy.softwareProjectLayout), (0, $dkgBy.userBoardLayout));

});
parcelRegister("cEBDW", function(module, exports) {

$parcel$export(module.exports, "coreProjectLayout", () => $208365a70ac26c02$export$3c06ced9943ca671);

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");
const $208365a70ac26c02$export$3c06ced9943ca671 = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout));

});
parcelRegister("jbfEb", function(module, exports) {

$parcel$export(module.exports, "projectLayout", () => $ca707d874a48fc97$export$204149bac601d20c);

var $h6Od4 = parcelRequire("h6Od4");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");

var $cx2Hn = parcelRequire("cx2Hn");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ca707d874a48fc97$var$withAnyProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: 'any'
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ca707d874a48fc97$var$ProjectTrackers = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("gId6q")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/project-layout/src/ui/trackers/index.tsx"
});
const $ca707d874a48fc97$var$ProjectFavicon = ()=>{
    (0, $cx2Hn.useProjectFavicon)();
    return null;
};
const $ca707d874a48fc97$var$rightSidebars = ()=>[];
const $ca707d874a48fc97$var$globalComponents = [
    $ca707d874a48fc97$var$withAnyProjectContext($ca707d874a48fc97$var$ProjectFavicon),
    $ca707d874a48fc97$var$withAnyProjectContext($ca707d874a48fc97$var$ProjectTrackers),
    $ca707d874a48fc97$var$withAnyProjectContext((0, $h6Od4.ProjectRouteListener))
];
const $ca707d874a48fc97$export$204149bac601d20c = (0, $6dwgv.createLayout)({
    globalComponents: $ca707d874a48fc97$var$globalComponents,
    rightSidebars: $ca707d874a48fc97$var$rightSidebars()
});

});
parcelRegister("h6Od4", function(module, exports) {

$parcel$export(module.exports, "ProjectRouteListener", () => $759f7c84282a636f$export$159f09d701320911);

var $eJOHy = parcelRequire("eJOHy");

var $dZRaT = parcelRequire("dZRaT");

var $gZTP9 = parcelRequire("gZTP9");

var $eJrcF = parcelRequire("eJrcF");

var $7A5g5 = parcelRequire("7A5g5");
const $759f7c84282a636f$export$159f09d701320911 = ()=>{
    const isSiteAdmin = (0, $gZTP9.useIsAdmin)();
    const { data: data, loading: loading } = (0, $eJrcF.useResource)((0, $dZRaT.projectContextResource));
    (0, $eJOHy.useEffect)(()=>{
        if (isSiteAdmin) (0, $7A5g5.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: true
        });
        else if (data != null) (0, $7A5g5.setIsProjectAdmin)({
            loading: false,
            isProjectAdmin: data.isProjectAdmin
        });
        else (0, $7A5g5.setIsProjectAdmin)({
            loading: loading,
            isProjectAdmin: null
        });
    }, [
        data,
        loading,
        isSiteAdmin
    ]);
    // Cleanup when component is unmounted. This means we are no longer in a project route
    (0, $eJOHy.useEffect)(()=>()=>(0, $7A5g5.setIsProjectAdmin)({
                loading: false,
                isProjectAdmin: null
            }), []);
    return null;
};

});
parcelRegister("gZTP9", function(module, exports) {

$parcel$export(module.exports, "useIsAdmin", () => $a1219bbbe722b49f$export$99a5e4bc80d231ca);

var $lvKO5 = parcelRequire("lvKO5");
const $a1219bbbe722b49f$export$99a5e4bc80d231ca = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.isAdmin || false;
};

});


parcelRegister("cx2Hn", function(module, exports) {

$parcel$export(module.exports, "useProjectFavicon", () => $478f39431f2b80dc$export$32abcb1f939de016);

var $eJOHy = parcelRequire("eJOHy");

var $hWeHP = parcelRequire("hWeHP");

var $eWzpp = parcelRequire("eWzpp");

var $7jTnu = parcelRequire("7jTnu");
const $478f39431f2b80dc$export$32abcb1f939de016 = false ? ()=>undefined : ()=>{
    const { data: project } = (0, $eWzpp.useProject)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const iconEle = document.querySelector("link[rel='shortcut icon']");
    // Keep a copy of the default favicon
    const defaultFavicon = (0, $eJOHy.useMemo)(()=>iconEle instanceof HTMLLinkElement ? iconEle.href : '', [
        iconEle
    ]);
    const enabled = (0, $eJOHy.useMemo)(()=>(0, $hWeHP.default)('ajs-favicon-use-projecticon') === 'true', []);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $7jTnu.fg)('blu-7193-new-jira-favicons')) {
            const favicon = project ? project.avatarUrl : defaultFavicon;
            if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = favicon;
            // Switch back to default favicon
            return ()=>{
                if (enabled && iconEle instanceof HTMLLinkElement) iconEle.href = defaultFavicon;
            };
        }
    }, [
        project,
        iconEle,
        defaultFavicon,
        enabled
    ]);
};

});

parcelRegister("gId6q", function(module, exports) {

let $c2aaeb52e55cc5ec$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c2aaeb52e55cc5ec$var$load("gOuNw").then(()=>parcelRequire('lu6uO'));

});



parcelRegister("aQoXd", function(module, exports) {

$parcel$export(module.exports, "serviceProjectLayout", () => $1fa61a55f28068ec$export$e321cb31c875d1ba);
$parcel$export(module.exports, "rightSidebarsLayout", () => $1fa61a55f28068ec$export$820f9bb834280408);

var $ln6Iy = parcelRequire("ln6Iy");

var $7h3uc = parcelRequire("7h3uc");

var $f61QS = parcelRequire("f61QS");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $bwUbt = parcelRequire("bwUbt");

var $bQWwW = parcelRequire("bQWwW");
// TODO Remove this whenever all service project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1fa61a55f28068ec$var$withServiceProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $ln6Iy.SERVICE_DESK_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$ProjectBuilder = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("dTfWL")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/project-builder/ProjectBuilderWithQueryParam.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("dB8Zm")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1fa61a55f28068ec$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("bCSZt")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $1fa61a55f28068ec$export$e321cb31c875d1ba = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout), {
    globalComponents: [
        $1fa61a55f28068ec$var$withServiceProjectContext($1fa61a55f28068ec$var$Onboarding),
        ...(0, $bwUbt.serviceProjectFirstImpressionsLayout).globalComponents.map($1fa61a55f28068ec$var$withServiceProjectContext),
        $1fa61a55f28068ec$var$withServiceProjectContext((0, $f61QS.AsyncJsmCustomDomainChangeBoardingFlag)),
        $1fa61a55f28068ec$var$ProjectBuilder
    ],
    rightSidebars: [
        $1fa61a55f28068ec$var$withServiceProjectContext($1fa61a55f28068ec$var$RightSidebars),
        ...(0, $bwUbt.serviceProjectFirstImpressionsLayout).rightSidebars.map($1fa61a55f28068ec$var$withServiceProjectContext)
    ]
});
const $1fa61a55f28068ec$export$820f9bb834280408 = (0, $6dwgv.composeLayouts)((0, $7h3uc.globalLayout), {
    rightSidebars: [
        $1fa61a55f28068ec$var$RightSidebars
    ]
});

});
parcelRegister("f61QS", function(module, exports) {

$parcel$export(module.exports, "AsyncJsmCustomDomainChangeBoardingFlag", () => $1961db39384c0e0d$export$b1ef5e3da6e1959d);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1961db39384c0e0d$var$LazyJsmCustomDomainChangeBoardingFlag = (0, $bQWwW.lazy)(()=>(parcelRequire("9aYAP")), {
    moduleId: "./src/packages/servicedesk/custom-domain-change-boarding/src/ui/index.tsx"
});
const $1961db39384c0e0d$export$b1ef5e3da6e1959d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async-jsm-custom-domain-change-boarding-flag",
        packageName: "jira-help-center-custom-domain-change-boarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "jsm-custom-domain-change-boarding-flag",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1961db39384c0e0d$var$LazyJsmCustomDomainChangeBoardingFlag, null)));

});
parcelRegister("9aYAP", function(module, exports) {

let $6ae40cb8db62fdb7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ae40cb8db62fdb7$var$load("jRam1").then(()=>parcelRequire('lKRQ7'));

});


parcelRegister("bwUbt", function(module, exports) {

$parcel$export(module.exports, "serviceProjectFirstImpressionsLayout", () => $b899726b5c2e771b$export$2562b2d784eadc10);

var $eJOHy = parcelRequire("eJOHy");

var $jmQek = parcelRequire("jmQek");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");
const $b899726b5c2e771b$var$withServiceProjectAccess = (Component)=>{
    const ScopedComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmQek.default), {
            hasServiceDeskAccess: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null));
    const name = (0, $6dwgv.coalesce)(Component.displayName) ?? (0, $6dwgv.coalesce)(Component.name) ?? 'Component';
    ScopedComponent.displayName = `withServiceProjectAccess(${name})`;
    return ScopedComponent;
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b899726b5c2e771b$var$Onboarding = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("89C1h")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b899726b5c2e771b$var$RightSidebars = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("bVufS")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/service-project-first-impressions-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $b899726b5c2e771b$export$2562b2d784eadc10 = (0, $6dwgv.createLayout)({
    globalComponents: [
        $b899726b5c2e771b$var$withServiceProjectAccess($b899726b5c2e771b$var$Onboarding)
    ],
    rightSidebars: [
        $b899726b5c2e771b$var$withServiceProjectAccess($b899726b5c2e771b$var$RightSidebars)
    ]
});

});
parcelRegister("jmQek", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7838320445e919b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");

var $5aeix = parcelRequire("5aeix");
/**
 * Manages the visibility of child components based on user permissions within a multi-tenant environment.
 * It leverages the application's permission settings to determine access rights, ensuring components are only accessible to users with the appropriate permissions.
 * In development environments, it issues a warning when no access-related properties are provided, aiding in debug and development processes.
 */ const $e7838320445e919b$var$AppPermissionsCheck = (props)=>{
    const { appPermissions: appPermissions } = (0, $lvKO5.useTenantContext)();
    if (props.hasServiceDeskAccess !== undefined && appPermissions.hasServiceDeskAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasCoreAccess !== undefined && appPermissions.hasCoreAccess === props.hasCoreAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasSoftwareAccess !== undefined && appPermissions.hasSoftwareAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    if (props.hasServiceDeskAccess === undefined && props.hasCoreAccess === undefined && props.hasSoftwareAccess === undefined) {
        if ((0, $5aeix.isDevelopmentEnv)()) // eslint-disable-next-line no-console
        console.warn('AppPermissionsCheck should have defined at least one of access prop');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children);
    }
    return null;
};
$e7838320445e919b$var$AppPermissionsCheck.defaultProps = {
    hasCoreAccess: undefined,
    hasSoftwareAccess: undefined,
    hasServiceDeskAccess: undefined
};
var $e7838320445e919b$export$2e2bcd8739ae039 = $e7838320445e919b$var$AppPermissionsCheck;

});
parcelRegister("5aeix", function(module, exports) {

$parcel$export(module.exports, "isDevelopmentEnv", () => $b42edb9e31c9a622$export$48e5fb80244b95c5);
const $b42edb9e31c9a622$export$48e5fb80244b95c5 = ()=>false;

});


parcelRegister("89C1h", function(module, exports) {

let $5efca7eb534e4dd8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5efca7eb534e4dd8$var$load("kVX56"),
    $5efca7eb534e4dd8$var$load("76n7a"),
    $5efca7eb534e4dd8$var$load("l253H"),
    $5efca7eb534e4dd8$var$load("jD0ep")
]).then(()=>parcelRequire('R6Cjs'));

});

parcelRegister("bVufS", function(module, exports) {

let $8aec7c98108c8b58$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8aec7c98108c8b58$var$load("kVX56"),
    $8aec7c98108c8b58$var$load("76n7a"),
    $8aec7c98108c8b58$var$load("l253H"),
    $8aec7c98108c8b58$var$load("7rAm2")
]).then(()=>parcelRequire('dHOBZ'));

});


parcelRegister("dTfWL", function(module, exports) {

let $a1ccc821164debaf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a1ccc821164debaf$var$load("kVX56"),
    $a1ccc821164debaf$var$load("9qY9x")
]).then(()=>parcelRequire('dQKu6'));

});

parcelRegister("dB8Zm", function(module, exports) {

let $9e65b40daaa192f1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9e65b40daaa192f1$var$load("kVX56"),
    $9e65b40daaa192f1$var$load("76n7a"),
    $9e65b40daaa192f1$var$load("l253H"),
    $9e65b40daaa192f1$var$load("ffQaD"),
    $9e65b40daaa192f1$var$load("kvRbA"),
    $9e65b40daaa192f1$var$load("dHHIn")
]).then(()=>parcelRequire('dln7i'));

});

parcelRegister("bCSZt", function(module, exports) {

let $876de64385d2bfc0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $876de64385d2bfc0$var$load("kVX56"),
    $876de64385d2bfc0$var$load("76n7a"),
    $876de64385d2bfc0$var$load("l253H"),
    $876de64385d2bfc0$var$load("ffQaD"),
    $876de64385d2bfc0$var$load("kvRbA"),
    $876de64385d2bfc0$var$load("azviO")
]).then(()=>parcelRequire('byH1L'));

});


parcelRegister("8FCAy", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareProjectLayout", () => $2e2774c38c3e21fa$export$3791efdd32024063);
$parcel$export(module.exports, "softwareProjectLayout", () => $2e2774c38c3e21fa$export$9a918616afa3328c);
$parcel$export(module.exports, "softwareProjectLayoutNoOnboarding", () => $2e2774c38c3e21fa$export$ada52b1309832862);
$parcel$export(module.exports, "classicSoftwareProjectLayoutNoOnboarding", () => $2e2774c38c3e21fa$export$6c1958653c44ba37);
$parcel$export(module.exports, "softwareProjectLayoutCode", () => $2e2774c38c3e21fa$export$ab7e607e8441dc61);

var $ln6Iy = parcelRequire("ln6Iy");

var $jbfEb = parcelRequire("jbfEb");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");

var $bJscI = parcelRequire("bJscI");
// TODO Remove this whenever all software project route paths are no longer ambiguous
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2e2774c38c3e21fa$var$withAnySoftwareProjectContext = (Component)=>(0, $6dwgv.withProjectContext)(Component, {
        project: {
            style: 'any',
            type: (0, $ln6Iy.SOFTWARE_PROJECT)
        }
    });

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$OnboardingOld = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("6Yka0")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$OnboardingNew = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("6Yka0")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding/index.tsx"
});
const $2e2774c38c3e21fa$var$Onboarding = (0, $bJscI.componentWithFG)('onboarding-forpaint-migration-iv-llc', $2e2774c38c3e21fa$var$OnboardingNew, $2e2774c38c3e21fa$var$OnboardingOld);
$2e2774c38c3e21fa$var$Onboarding.displayName = 'Lazy(ui/onboarding/index.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$OnboardingCode = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("hyOEa")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/onboarding-code/OnboardingCode.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebarsOld = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("1zefH")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebarsNew = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("1zefH")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars/RightSidebars.tsx"
});
const $2e2774c38c3e21fa$var$RightSidebars = (0, $bJscI.componentWithFG)('onboarding-forpaint-migration-iv-llc', $2e2774c38c3e21fa$var$RightSidebarsNew, $2e2774c38c3e21fa$var$RightSidebarsOld);
$2e2774c38c3e21fa$var$RightSidebars.displayName = 'Lazy(ui/right-sidebars/RightSidebars.tsx)';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2e2774c38c3e21fa$var$RightSidebarsCode = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("7KD5z")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/software-project-layout/src/ui/right-sidebars-code/RightSidebarsCode.tsx"
});
const $2e2774c38c3e21fa$var$SoftWareOnboarding = $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$Onboarding);
const $2e2774c38c3e21fa$var$SoftWareOnboardingCode = $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$OnboardingCode);
const $2e2774c38c3e21fa$var$nonSettingsRightSidebars = [
    $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$RightSidebars)
];
const $2e2774c38c3e21fa$var$nonSettingsRightSidebarsCode = [
    $2e2774c38c3e21fa$var$withAnySoftwareProjectContext($2e2774c38c3e21fa$var$RightSidebarsCode)
];
const $2e2774c38c3e21fa$var$sharedSoftwareProjectLayout = (0, $6dwgv.composeLayouts)((0, $jbfEb.projectLayout), {});
const $2e2774c38c3e21fa$export$3791efdd32024063 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebars,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboarding
    ]
});
const $2e2774c38c3e21fa$export$9a918616afa3328c = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebars,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboarding
    ]
});
const $2e2774c38c3e21fa$export$ada52b1309832862 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout);
const $2e2774c38c3e21fa$export$6c1958653c44ba37 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout);
const $2e2774c38c3e21fa$export$ab7e607e8441dc61 = (0, $6dwgv.composeLayouts)($2e2774c38c3e21fa$var$sharedSoftwareProjectLayout, {
    rightSidebars: $2e2774c38c3e21fa$var$nonSettingsRightSidebarsCode,
    globalComponents: [
        $2e2774c38c3e21fa$var$SoftWareOnboardingCode
    ]
});

});
parcelRegister("6Yka0", function(module, exports) {

let $5137fc155b79917f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5137fc155b79917f$var$load("kVX56"),
    $5137fc155b79917f$var$load("76n7a"),
    $5137fc155b79917f$var$load("l253H"),
    $5137fc155b79917f$var$load("ffQaD"),
    $5137fc155b79917f$var$load("kvRbA"),
    $5137fc155b79917f$var$load("22QMa")
]).then(()=>parcelRequire('jhc67'));

});

parcelRegister("hyOEa", function(module, exports) {

let $cc8ce6111331dbea$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $cc8ce6111331dbea$var$load("kVX56"),
    $cc8ce6111331dbea$var$load("76n7a"),
    $cc8ce6111331dbea$var$load("l253H"),
    $cc8ce6111331dbea$var$load("ffQaD"),
    $cc8ce6111331dbea$var$load("kvRbA"),
    $cc8ce6111331dbea$var$load("k3KUo")
]).then(()=>parcelRequire('fpUIa'));

});

parcelRegister("1zefH", function(module, exports) {

let $12441d8919e841bf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $12441d8919e841bf$var$load("kVX56"),
    $12441d8919e841bf$var$load("76n7a"),
    $12441d8919e841bf$var$load("l253H"),
    $12441d8919e841bf$var$load("ffQaD"),
    $12441d8919e841bf$var$load("kvRbA"),
    $12441d8919e841bf$var$load("bRZBc")
]).then(()=>parcelRequire('4mkSU'));

});

parcelRegister("7KD5z", function(module, exports) {

let $5a4b267d392ca4b2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5a4b267d392ca4b2$var$load("kVX56"),
    $5a4b267d392ca4b2$var$load("76n7a"),
    $5a4b267d392ca4b2$var$load("l253H"),
    $5a4b267d392ca4b2$var$load("ffQaD"),
    $5a4b267d392ca4b2$var$load("kvRbA"),
    $5a4b267d392ca4b2$var$load("bXt8b")
]).then(()=>parcelRequire('8XVCp'));

});


parcelRegister("dkgBy", function(module, exports) {

$parcel$export(module.exports, "userBoardLayout", () => $cf45c653fc1d9878$export$7092b4ee86ae0b71);

var $6dwgv = parcelRequire("6dwgv");
const $cf45c653fc1d9878$export$7092b4ee86ae0b71 = (0, $6dwgv.createLayout)();

});


/**
 * @deprecated sharing routes between products leads to over-fetching resources. Please define
 * routes per-product and only define the resources + navigation components required for that product instead.
 */ const $aa97a50ba70be130$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $aa97a50ba70be130$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';

parcelRegister("5ddA0", function(module, exports) {

$parcel$export(module.exports, "staticSidebarShortcutsResource", () => $83fdf796383be00f$export$4847c29b4786b3b4);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $24e7X = parcelRequire("24e7X");
const $83fdf796383be00f$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $83fdf796383be00f$export$4847c29b4786b3b4 = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_PROJECT_SHORTCUTS',
    getKey: ({ match: match, query: query })=>$83fdf796383be00f$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $83fdf796383be00f$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        const shortcuts = await (0, $24e7X.fetchShortcuts)(projectKeyOrId);
        return shortcuts;
    },
    maxAge: 300000
});

});
parcelRegister("24e7X", function(module, exports) {

$parcel$export(module.exports, "fetchShortcuts", () => $59a57dc5b45b5a5a$export$49d696bf2525d700);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $59a57dc5b45b5a5a$export$49d696bf2525d700 = (projectKeyOrId)=>{
    try {
        return (0, $1Ozm9.default)(`/rest/projects/1.0/project/${projectKeyOrId}/shortcut`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'fetchProjectShortcuts',
            packageName: 'jiraNavigationAppsResources'
        });
        throw error;
    }
};

});


parcelRegister("aDtWM", function(module, exports) {

$parcel$export(module.exports, "genericProjectSidebars", () => $2441c7e576639e68$export$d88d2d25355bc89a);
$parcel$export(module.exports, "classicBoardSidebars", () => $2441c7e576639e68$export$c04daf123cec1f1e);
$parcel$export(module.exports, "genericConnectSidebars", () => $2441c7e576639e68$export$844d342b575ead35);

var $7zL9d = parcelRequire("7zL9d");

var $hiOwQ = parcelRequire("hiOwQ");

var $gKFn0 = parcelRequire("gKFn0");

var $2nHUF = parcelRequire("2nHUF");

var $gHEJe = parcelRequire("gHEJe");

var $1f2LE = parcelRequire("1f2LE");

var $k6duF = parcelRequire("k6duF");

var $3V6se = parcelRequire("3V6se");
const $2441c7e576639e68$export$d88d2d25355bc89a = [
    // delete when cleaning up getWillShowNav4
    (0, $hiOwQ.default),
    (0, $gHEJe.default),
    (0, $1f2LE.default),
    (0, $k6duF.default),
    (0, $3V6se.default)
];
const $2441c7e576639e68$export$c04daf123cec1f1e = [
    (0, $k6duF.default),
    (0, $3V6se.default)
];
const $2441c7e576639e68$export$844d342b575ead35 = [
    ...$2441c7e576639e68$export$d88d2d25355bc89a,
    (0, $7zL9d.default),
    (0, $gKFn0.default),
    (0, $2nHUF.default)
];

});
parcelRegister("7zL9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5ca43a7cc265a55$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $d5ca43a7cc265a55$var$LazyConnectSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("8rvzL")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
});
const $d5ca43a7cc265a55$var$ConnectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "connect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d5ca43a7cc265a55$var$LazyConnectSidebar, null)));
$d5ca43a7cc265a55$var$ConnectSidebar.displayName = 'ConnectSidebar';
var $d5ca43a7cc265a55$export$2e2bcd8739ae039 = $d5ca43a7cc265a55$var$ConnectSidebar;

});
parcelRegister("8rvzL", function(module, exports) {

let $625956a10a475cb7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $625956a10a475cb7$var$load("ffQaD"),
    $625956a10a475cb7$var$load("kvRbA"),
    $625956a10a475cb7$var$load("dPMOS")
]).then(()=>parcelRequire('9zsf7'));

});


parcelRegister("hiOwQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c48a3c7fb40f9811$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $c48a3c7fb40f9811$var$LazyCoreProjectSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("45mAd")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
});
// delete when cleaning up getWillShowNav4
const $c48a3c7fb40f9811$var$CoreProjectSidebar = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "coreProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c48a3c7fb40f9811$var$LazyCoreProjectSidebar, null));
var $c48a3c7fb40f9811$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($c48a3c7fb40f9811$var$CoreProjectSidebar);

});
parcelRegister("45mAd", function(module, exports) {

let $2f99259d09d4d04e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2f99259d09d4d04e$var$load("ffQaD"),
    $2f99259d09d4d04e$var$load("kvRbA"),
    $2f99259d09d4d04e$var$load("kVX56"),
    $2f99259d09d4d04e$var$load("76n7a"),
    $2f99259d09d4d04e$var$load("l253H"),
    $2f99259d09d4d04e$var$load("knnJv")
]).then(()=>parcelRequire('2ZlQu'));

});


parcelRegister("2nHUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c03066d31b31d1d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $7c03066d31b31d1d$var$LazyGlobalSystemSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("hD6z8")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
});
const $7c03066d31b31d1d$var$GlobalSystemSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalSystemSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c03066d31b31d1d$var$LazyGlobalSystemSettingsSidebar, null)));
$7c03066d31b31d1d$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
var $7c03066d31b31d1d$export$2e2bcd8739ae039 = $7c03066d31b31d1d$var$GlobalSystemSettingsSidebar;

});
parcelRegister("hD6z8", function(module, exports) {

let $cd5b2bfb82eb5b2d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $cd5b2bfb82eb5b2d$var$load("ffQaD"),
    $cd5b2bfb82eb5b2d$var$load("kvRbA"),
    $cd5b2bfb82eb5b2d$var$load("76n7a"),
    $cd5b2bfb82eb5b2d$var$load("l253H"),
    $cd5b2bfb82eb5b2d$var$load("ilGII")
]).then(()=>parcelRequire('cuk8p'));

});


parcelRegister("gHEJe", function(module, exports) {

$parcel$export(module.exports, "ForPaintSoftwareProjectSidebar", () => $7ef94f935654f247$export$16261c6a2217f29d);
$parcel$export(module.exports, "default", () => $7ef94f935654f247$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");

const $7ef94f935654f247$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("9A98O")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});

const $7ef94f935654f247$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("9A98O")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
});
const $7ef94f935654f247$var$AfterPaintSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $7ef94f935654f247$export$16261c6a2217f29d = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "softwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $7ef94f935654f247$var$SoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isIssueRoute = (0, $kfvK2.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$export$16261c6a2217f29d, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7ef94f935654f247$var$AfterPaintSoftwareProjectSidebar, null);
});
$7ef94f935654f247$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
$7ef94f935654f247$export$16261c6a2217f29d.displayName = 'SoftwareProjectSidebar';
var $7ef94f935654f247$export$2e2bcd8739ae039 = $7ef94f935654f247$var$SoftwareProjectSidebar;

});
parcelRegister("9A98O", function(module, exports) {

let $6f9e91178270cb1c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6f9e91178270cb1c$var$load("7mIf9"),
    $6f9e91178270cb1c$var$load("jXweD"),
    $6f9e91178270cb1c$var$load("ffQaD"),
    $6f9e91178270cb1c$var$load("kvRbA"),
    $6f9e91178270cb1c$var$load("kVX56"),
    $6f9e91178270cb1c$var$load("76n7a"),
    $6f9e91178270cb1c$var$load("l253H"),
    $6f9e91178270cb1c$var$load("4yp4h")
]).then(()=>parcelRequire('9WRBf'));

});


parcelRegister("1f2LE", function(module, exports) {

$parcel$export(module.exports, "ForPaintServicedeskSidebar", () => $34d9b7a65dd1d6b8$export$c72ea37d21335def);
$parcel$export(module.exports, "default", () => $34d9b7a65dd1d6b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");

var $7jTnu = parcelRequire("7jTnu");

var $i67QL = parcelRequire("i67QL");
const $34d9b7a65dd1d6b8$var$routesUsingLazyForPaint = new Set([
    'servicedesk-queues-custom-view',
    'servicedesk-practice-custom-view',
    'issue'
]);

const $34d9b7a65dd1d6b8$export$4553575c70a669bf = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("cHDVR")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});
const $34d9b7a65dd1d6b8$var$AfterPaintServicedeskSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$export$4553575c70a669bf, null)));
const $34d9b7a65dd1d6b8$export$c72ea37d21335def = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "servicedeskProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i67QL.LazyForPaintServicedeskSidebar), null)));
const $34d9b7a65dd1d6b8$var$ServicedeskSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isLazyForPaintRoute = (0, $kfvK2.useIsActiveRoute)((0, $7jTnu.fg)('queues_sidebar_lazyafterpaint_to_lazyforpaint') ? $34d9b7a65dd1d6b8$var$routesUsingLazyForPaint : 'issue');
    return isLazyForPaintRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$export$c72ea37d21335def, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34d9b7a65dd1d6b8$var$AfterPaintServicedeskSidebar, null);
});
$34d9b7a65dd1d6b8$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
$34d9b7a65dd1d6b8$export$c72ea37d21335def.displayName = 'ServicedeskSidebar';
var $34d9b7a65dd1d6b8$export$2e2bcd8739ae039 = $34d9b7a65dd1d6b8$var$ServicedeskSidebar;

});
parcelRegister("i67QL", function(module, exports) {

$parcel$export(module.exports, "LazyForPaintServicedeskSidebar", () => $d27c58e19a795fc8$export$15e3805736f2222d);

var $bQWwW = parcelRequire("bQWwW");

var $7DXwW = parcelRequire("7DXwW");

const $d27c58e19a795fc8$export$15e3805736f2222d = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("cHDVR")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
});

});
parcelRegister("cHDVR", function(module, exports) {

let $93f879eb099a5252$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $93f879eb099a5252$var$load("3yAl4"),
    $93f879eb099a5252$var$load("7mIf9"),
    $93f879eb099a5252$var$load("jXweD"),
    $93f879eb099a5252$var$load("kNFvF"),
    $93f879eb099a5252$var$load("ffQaD"),
    $93f879eb099a5252$var$load("kvRbA"),
    $93f879eb099a5252$var$load("kVX56"),
    $93f879eb099a5252$var$load("76n7a"),
    $93f879eb099a5252$var$load("l253H"),
    $93f879eb099a5252$var$load("f861S")
]).then(()=>parcelRequire('eQ0q2'));

});



parcelRegister("k6duF", function(module, exports) {

$parcel$export(module.exports, "ForPaintClassicSoftwareProjectSidebar", () => $919301427081454d$export$a70fda37b3fc5365);
$parcel$export(module.exports, "default", () => $919301427081454d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

var $kfvK2 = parcelRequire("kfvK2");

const $919301427081454d$var$LazyAfterPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("58DDx")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});

const $919301427081454d$var$LazyForPaintClassicSoftwareProjectSidebar = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("58DDx")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
});
const $919301427081454d$var$AfterPaintClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$LazyAfterPaintClassicSoftwareProjectSidebar, null)));
const $919301427081454d$export$a70fda37b3fc5365 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "classicSoftwareProject"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$LazyForPaintClassicSoftwareProjectSidebar, null)));
const $919301427081454d$var$ClassicSoftwareProjectSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const isIssueRoute = (0, $kfvK2.useIsActiveRoute)('issue');
    return isIssueRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$export$a70fda37b3fc5365, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($919301427081454d$var$AfterPaintClassicSoftwareProjectSidebar, null);
});
$919301427081454d$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
$919301427081454d$export$a70fda37b3fc5365.displayName = 'ClassicSoftwareProjectSidebar';
var $919301427081454d$export$2e2bcd8739ae039 = $919301427081454d$var$ClassicSoftwareProjectSidebar;

});
parcelRegister("58DDx", function(module, exports) {

let $3bdc7221ddc09f5e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3bdc7221ddc09f5e$var$load("7mIf9"),
    $3bdc7221ddc09f5e$var$load("jXweD"),
    $3bdc7221ddc09f5e$var$load("kNFvF"),
    $3bdc7221ddc09f5e$var$load("ffQaD"),
    $3bdc7221ddc09f5e$var$load("kvRbA"),
    $3bdc7221ddc09f5e$var$load("kVX56"),
    $3bdc7221ddc09f5e$var$load("76n7a"),
    $3bdc7221ddc09f5e$var$load("l253H"),
    $3bdc7221ddc09f5e$var$load("1WCUI")
]).then(()=>parcelRequire('h8X2Q'));

});


parcelRegister("3V6se", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3a532df6c151ee1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $a3a532df6c151ee1$var$LazyUserSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("59rrd")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
});
const $a3a532df6c151ee1$var$UserSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "user"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3a532df6c151ee1$var$LazyUserSidebar, null)));
$a3a532df6c151ee1$var$UserSidebar.displayName = 'UserSidebar';
var $a3a532df6c151ee1$export$2e2bcd8739ae039 = $a3a532df6c151ee1$var$UserSidebar;

});
parcelRegister("59rrd", function(module, exports) {

let $3c03139a1dda6c2b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3c03139a1dda6c2b$var$load("kNFvF"),
    $3c03139a1dda6c2b$var$load("ffQaD"),
    $3c03139a1dda6c2b$var$load("kvRbA"),
    $3c03139a1dda6c2b$var$load("kVX56"),
    $3c03139a1dda6c2b$var$load("76n7a"),
    $3c03139a1dda6c2b$var$load("l253H"),
    $3c03139a1dda6c2b$var$load("8aAWx")
]).then(()=>parcelRequire('2uIzr'));

});



parcelRegister("kRv8K", function(module, exports) {

$parcel$export(module.exports, "getBusinessProjectResources", () => $624d2da23216c44c$export$20e8c2951e444b08);
$parcel$export(module.exports, "getProjectViewResources", () => $624d2da23216c44c$export$fcbe882e18ee4a35);
$parcel$export(module.exports, "getOverviewViewResources", () => $624d2da23216c44c$export$21c5527b459d56fe);

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $ebWJz = parcelRequire("ebWJz");

var $6zXPf = parcelRequire("6zXPf");

var $bYpK5 = parcelRequire("bYpK5");

var $cV98p = parcelRequire("cV98p");

var $iXIhG = parcelRequire("iXIhG");

var $ebuR2 = parcelRequire("ebuR2");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $8tbnc = parcelRequire("8tbnc");

var $ho9E1 = parcelRequire("ho9E1");

var $1G20J = parcelRequire("1G20J");
const $624d2da23216c44c$export$20e8c2951e444b08 = ()=>(0, $6zXPf.getWillShowNav4)() ? [
        // eslint-disable-next-line camelcase
        (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $1G20J.projectThemeResource)
    ] : [
        (0, $ho9E1.projectCreatePermissionsResource),
        (0, $cV98p.navigationResource),
        // eslint-disable-next-line camelcase
        (0, $ebuR2.DEPRECATED_DO_NOT_USE_projectDetailsResource),
        (0, $bYpK5.businessHorizontalNav3Resource),
        (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $1G20J.projectThemeResource)
    ];
const $624d2da23216c44c$export$fcbe882e18ee4a35 = ()=>[
        ...$624d2da23216c44c$export$20e8c2951e444b08(),
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        (0, $ebWJz.fieldsResource)
    ];
const $624d2da23216c44c$export$46471673e66df5c1 = ()=>[
        (0, $ho9E1.projectCreatePermissionsResource),
        (0, $cV98p.navigationResource),
        (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
        (0, $iXIhG.overviewDetailsResource),
        (0, $1G20J.projectThemeResource)
    ];
const $624d2da23216c44c$export$21c5527b459d56fe = ()=>[
        ...$624d2da23216c44c$export$46471673e66df5c1(),
        ...(0, $9NmsS.getNavigationResources)(),
        (0, $ebWJz.fieldsResource)
    ];

});
parcelRegister("ebWJz", function(module, exports) {

$parcel$export(module.exports, "fieldsResource", () => $f772abfaa17ccd63$export$8bca6c1954ae9308);
$parcel$export(module.exports, "useFieldsResource", () => $f772abfaa17ccd63$export$c0cd85886917fe89);

var $cwZUV = parcelRequire("cwZUV");

var $942wy = parcelRequire("942wy");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $9bD5G = parcelRequire("9bD5G");

var $7cmPk = parcelRequire("7cmPk");
const $f772abfaa17ccd63$var$RESOURCE_TYPE_KEY = 'BUSINESS_FIELDS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f772abfaa17ccd63$var$handleProjectResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jqlBuilder?.fields?.edges == null) throw new (0, $942wy.GraphQLErrors)(response.errors);
    return (0, $7cmPk.transformData)(response.data?.jira?.jqlBuilder?.fields?.edges);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f772abfaa17ccd63$var$handleOverviewResponse = async (promise)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const response = await promise;
    if (response.data?.jira?.jwmOverview?.fields?.edges == null) throw new (0, $942wy.GraphQLErrors)(response.errors);
    return (0, $7cmPk.transformData)(response.data?.jira?.jwmOverview?.fields?.edges);
};
const $f772abfaa17ccd63$export$8bca6c1954ae9308 = (0, $l1VxS.createResource)({
    type: $f772abfaa17ccd63$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        if (matchedRoute.match.params.overviewId) return `${$f772abfaa17ccd63$var$RESOURCE_TYPE_KEY}_overview_${matchedRoute.match.params.overviewId}`;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$f772abfaa17ccd63$var$RESOURCE_TYPE_KEY}_project_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>{
        if (match.params.overviewId) return (0, $9bD5G.fetchFields)((0, $d414d4047a262b56$export$c378ca4a0e2c9fec), $f772abfaa17ccd63$var$handleOverviewResponse, {
            overviewAri: (0, $cwZUV.JiraProjectOverviewAri).create({
                siteId: cloudId,
                activationId: activationId,
                overviewId: match.params.overviewId
            }).toString()
        });
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        return (0, $9bD5G.fetchFields)((0, $d414d4047a262b56$export$4d41378da3f70f0f), $f772abfaa17ccd63$var$handleProjectResponse, {
            cloudId: cloudId,
            jqlContext: `project = '${projectIdOrKey}'`
        });
    },
    maxAge: 3600000
});
const $f772abfaa17ccd63$export$c0cd85886917fe89 = ()=>(0, $eJrcF.useResource)($f772abfaa17ccd63$export$8bca6c1954ae9308);

});
parcelRegister("cwZUV", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAri", () => $91f880a532f2531d$export$714879003922a622);

var $cTkpI = parcelRequire("cTkpI");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/project-overview/manifest.ts
var $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $cTkpI.JiraProjectOverviewAriResourceOwner),
    resourceType: (0, $cTkpI.JiraProjectOverviewAriResourceType),
    resourceIdSlug: "activation/{activationId}/{overviewId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        overviewId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/project-overview/index.ts
var $91f880a532f2531d$export$714879003922a622 = class _JiraProjectOverviewAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._overviewId = opts.resourceIdSegmentValues.overviewId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get overviewId() {
        return this._overviewId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.qualifier,
            platformQualifier: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.resourceOwner,
            resourceType: $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.overviewId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                overviewId: opts.overviewId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $91f880a532f2531d$var$jiraProjectOverviewAriStaticOpts);
        return new _JiraProjectOverviewAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            overviewId: this.overviewId
        };
    }
};

});
parcelRegister("cTkpI", function(module, exports) {

$parcel$export(module.exports, "JiraProjectOverviewAriResourceOwner", () => $962a74da2f17354b$export$d68ef32d028cea3e);
$parcel$export(module.exports, "JiraProjectOverviewAriResourceType", () => $962a74da2f17354b$export$491d1b3b0151dbc4);
// src/jira/project-overview/types.ts
var $962a74da2f17354b$export$d68ef32d028cea3e = "jira", $962a74da2f17354b$export$491d1b3b0151dbc4 = "project-overview";

});


parcelRegister("942wy", function(module, exports) {

$parcel$export(module.exports, "GraphQLErrors", () => $3577b4c37e9af666$export$89c202e66b2de2b6);

var $buoPQ = parcelRequire("buoPQ");

var $4sprp = parcelRequire("4sprp");
// Sets the error message on this error according to the
// the GraphQL errors that are present.
const $3577b4c37e9af666$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4sprp)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `${errorMessage}\n`;
    });
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $3577b4c37e9af666$export$89c202e66b2de2b6 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = graphQLErrors != null ? (0, (/*@__PURE__*/$parcel$interopDefault($buoPQ)))(graphQLErrors) : [];
        this.message = $3577b4c37e9af666$var$generateErrorMessage(this);
        this.cause = this.graphQLErrors?.[0];
        this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
        this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
    }
}

});
parcelRegister("buoPQ", function(module, exports) {

var $4sprp = parcelRequire("4sprp");
/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */ function $85d5c2cbe671e6d1$var$castArray() {
    if (!arguments.length) return [];
    var value = arguments[0];
    return $4sprp(value) ? value : [
        value
    ];
}
module.exports = $85d5c2cbe671e6d1$var$castArray;

});


const $d414d4047a262b56$export$4d41378da3f70f0f = `
query JWMProjectFields($cloudId: ID!, $jqlContext: String!, $first: Int) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
      fields (jqlContext: $jqlContext, forClause: WHERE, viewContext: JWM, first: $first) {
        ... on JiraJqlFieldConnection {
          edges {
            node {
              jqlTerm
              type
              displayName,
            }
          }
        }
      }
    }
  }
}`;
const $d414d4047a262b56$export$c378ca4a0e2c9fec = `
query JWMOverviewFields($overviewAri: ID!, $first: Int) {
  jira {
    jwmOverview(id: $overviewAri) {
      ... on JiraWorkManagementGiraOverview {
        fields (first: $first) {
          ... on JiraJqlFieldConnection {
            edges {
              node {
                jqlTerm
                type
                displayName,
              }
            }
          }
        }
      }
    }
  }
}`;

parcelRegister("9bD5G", function(module, exports) {

$parcel$export(module.exports, "fetchFields", () => $d910ddfedea9b5ee$export$f3ddd735c360919);

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $d910ddfedea9b5ee$var$PAGE_SIZE = 100;
const $d910ddfedea9b5ee$export$f3ddd735c360919 = async (query, handler, params)=>{
    try {
        const promise = (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: $d910ddfedea9b5ee$var$PAGE_SIZE,
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return await handler(promise);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessFields', 'Something went wrong while fetching fields');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $gYnSx.default)({
            meta: {
                id: 'fieldsResource',
                packageName: 'jiraRouterResourcesBusinessFields',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return null;
};

});

parcelRegister("7cmPk", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $532ac776c238882e$export$3ceb62baab058c6b);
const $532ac776c238882e$export$3ceb62baab058c6b = (data)=>data.map((edge)=>edge.node);

});


parcelRegister("bYpK5", function(module, exports) {

$parcel$export(module.exports, "businessHorizontalNav3Resource", () => $de5f5f2174269868$export$b3359003584ee2b0);

var $3osLr = parcelRequire("3osLr");

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $hBje1 = parcelRequire("hBje1");

var $7Bvm5 = parcelRequire("7Bvm5");

var $9FYIg = parcelRequire("9FYIg");

var $l58dJ = parcelRequire("l58dJ");

var $bBtQo = parcelRequire("bBtQo");
const $de5f5f2174269868$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_HORIZONTAL_NAVIGATION';
const $de5f5f2174269868$var$getProjectAri = (projectId, cloudId)=>{
    try {
        return projectId ? (0, $3osLr.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
    } catch (err) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesNavigationItems', 'Failed to get project ari');
        return '';
    }
};
const $de5f5f2174269868$export$b3359003584ee2b0 = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: $de5f5f2174269868$var$RESOURCE_TYPE_KEY,
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        const projectIdOrKey = projectKey || projectId;
        const scopeId = $de5f5f2174269868$var$getProjectAri(projectId, cloudId);
        return {
            parameters: (0, $l58dJ.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey,
                first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE),
                isConsolidatedQuery: false,
                containerNavigationInput: scopeId ? {
                    scopeId: scopeId
                } : {
                    projectKeyQuery: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                },
                useContainerNavigation: false,
                useNewProjectHeader: false,
                projectKey: projectKey,
                projectAri: scopeId,
                useProjectKey: Boolean(projectKey),
                isJiraCustomTemplatesUxEnabled: (0, $7jTnu.fg)('jira_custom_templates_ux')
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        };
    }
}));

});
parcelRegister("3osLr", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAri", () => $2789eceef4467cc4$export$75a0a0a7cb0a58ae);

var $fFcpV = parcelRequire("fFcpV");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/project/manifest.ts
var $2789eceef4467cc4$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fFcpV.JiraProjectAriResourceOwner),
    resourceType: (0, $fFcpV.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $2789eceef4467cc4$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $2789eceef4467cc4$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $2789eceef4467cc4$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $2789eceef4467cc4$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("fFcpV", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $b674512659b7f55c$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $b674512659b7f55c$export$736763838d3aa22e);
// src/jira/project/types.ts
var $b674512659b7f55c$export$99d538a3b04916b1 = "jira", $b674512659b7f55c$export$736763838d3aa22e = "project";

});


parcelRegister("hBje1", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $0507489b8f939505$export$f4b29e78f4c0a526);
const $0507489b8f939505$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});

parcelRegister("7Bvm5", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_ITEMS_PAGE_SIZE", () => $adc6a95ef6681603$export$4653cda61a4943d6);
$parcel$export(module.exports, "TAB_UNDERLINE_HEIGHT", () => $adc6a95ef6681603$export$d1b9ea3245b6a5de);
$parcel$export(module.exports, "TAB_HEIGHT", () => $adc6a95ef6681603$export$d07bba395c9390f1);
$parcel$export(module.exports, "TAB_GAP", () => $adc6a95ef6681603$export$b61e6f89a9db76de);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports


const $adc6a95ef6681603$export$4653cda61a4943d6 = 75;
const $adc6a95ef6681603$export$d1b9ea3245b6a5de = 2;
const $adc6a95ef6681603$export$d07bba395c9390f1 = 36;
const $adc6a95ef6681603$export$29911ec08ab2ca2d = 5;
const $adc6a95ef6681603$export$b61e6f89a9db76de = 12;
const $adc6a95ef6681603$export$7fd2e391116c6ef5 = 9;
const $adc6a95ef6681603$export$e1633e494d305bfb = 'MORE';

});

parcelRegister("l58dJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $94098da9a759e84f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<820042db950ffe26b91d34ffe7050138>>
 * @relayHash bef16a6db03ecc4506e2c317ed3ec3dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5
const $94098da9a759e84f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJiraCustomTemplatesUxEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "useProjectKey"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v9 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "large"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v11 = {
        "alias": "projectKey",
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "alias": "canEditProjectConfig",
        "args": [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ],
        "concreteType": "JiraProjectAction",
        "kind": "LinkedField",
        "name": "action",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ],
        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
    }, v14 = {
        "condition": "isJiraCustomTemplatesUxEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "customTemplateBusinessProjectBanner_businessHorizontalNav"
            }
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectAri"
        }
    ], v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "projectIdOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "condition": "isJiraCustomTemplatesUxEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLiveTemplate"
                }
            ]
        },
        v18 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "tabs_businessHorizontalNav_TabsContent"
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "alias": "projectDataByKey",
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataByKey.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "condition": "useProjectKey",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "alias": "projectDataById",
                                        "args": v15 /*: any*/ ,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProject",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "RequiredField",
                                                "field": v10 /*: any*/ ,
                                                "action": "THROW",
                                                "path": "jira.projectDataById.projectId"
                                            },
                                            v11 /*: any*/ ,
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectNavigation_horizontalNavigationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "concreteType": "JiraNavigationItemConnection",
                            "kind": "LinkedField",
                            "name": "jwmSavedViewsByProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraNavigationItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDefault"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "typeKey"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraNavigationItem"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canRemove"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canSetAsDefault"
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "navigationItems",
                            "args": v16 /*: any*/ ,
                            "filters": [
                                "cloudId",
                                "projectIdOrKey"
                            ],
                            "handle": "connection",
                            "key": "tabs_jiraNavigation__navigationItems",
                            "kind": "LinkedHandle",
                            "name": "jwmSavedViewsByProject"
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "projectDataByKey",
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useProjectKey",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "projectDataById",
                                    "args": v15 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProject",
                                    "plural": false,
                                    "selections": v19 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4c6a8fb0afe8804c6d8b040f3b4ccf6926f7a96b57ad873204c81c3a0ee4ada5",
            "metadata": {},
            "name": "projectNavigation_horizontalNavigationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$94098da9a759e84f$var$node.hash = "73d9509696eb943ac9eaa2deb0444981";
var $94098da9a759e84f$export$2e2bcd8739ae039 = $94098da9a759e84f$var$node;

});


parcelRegister("cV98p", function(module, exports) {

$parcel$export(module.exports, "navigationResource", () => $e93bba7c11632d20$export$62940941ee574cdc);
$parcel$export(module.exports, "useNavigationResource", () => $e93bba7c11632d20$export$c17011c09e042a31);

var $8dH3d = parcelRequire("8dH3d");

var $3osLr = parcelRequire("3osLr");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $exaWd = parcelRequire("exaWd");

const $e93bba7c11632d20$export$62940941ee574cdc = (0, $l1VxS.createResource)({
    type: 'BUSINESS_NAVIGATION',
    getKey: ()=>'BUSINESS_NAVIGATION',
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(projectKey)) return (0, $exaWd.fetchNavigation)((0, $facb8b07dec6e94a$export$a40c5d12b8a53ba2), {
            cloudId: cloudId,
            projectKey: projectKey
        });
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(projectId)) return (0, $exaWd.fetchNavigation)((0, $facb8b07dec6e94a$export$7c9197b656229b53), {
            cloudId: cloudId,
            projectId: (0, $3osLr.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId
            }).toString()
        });
        return (0, $exaWd.fetchNavigation)((0, $facb8b07dec6e94a$export$c378ca4a0e2c9fec), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $e93bba7c11632d20$export$c17011c09e042a31 = ()=>(0, $eJrcF.useResource)($e93bba7c11632d20$export$62940941ee574cdc);

});
const $facb8b07dec6e94a$var$ProjectFragment = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectStyle
  projectType
  isFavourite
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
  defaultView: jwmDefaultSavedView {
    ... on JiraNavigationItem {
      typeKey
    }
  }
}
`;
const $facb8b07dec6e94a$var$ProjectConnectionFragment = `
fragment ProjectConnectionFragment on JiraProjectConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...ProjectFragment
    }
  }
}
`;
const $facb8b07dec6e94a$var$OverviewFragment = `
fragment OverviewFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
}
`;
const $facb8b07dec6e94a$var$OverviewConnectionFragment = `
fragment OverviewConnectionFragment on JiraWorkManagementGiraOverviewConnection {
  pageInfo {
    hasNextPage
  }
  edges {
    node {
      ...OverviewFragment
    }
  }
}
`;
const $facb8b07dec6e94a$var$NavigationDataFragment = `
fragment NavigationFragment on JiraWorkManagementNavigation {
  jwmLicensing {
    currentUserSeatEdition
  }
  recentProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  favoriteProjects(first: $first) {
    ...ProjectConnectionFragment
  }
  overviews: jwmOverviews(cloudId: $cloudId, first: $first) @optIn(to: "JiraWorkManagementGiraOverviews") {
    __typename
    ... on JiraWorkManagementGiraOverviewConnection {
      ...OverviewConnectionFragment
    }
  }
}
`;
const $facb8b07dec6e94a$export$7c9197b656229b53 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectId(projectId: $projectId) {
      ...NavigationFragment
    }
  }
}
${$facb8b07dec6e94a$var$ProjectFragment}
${$facb8b07dec6e94a$var$ProjectConnectionFragment}
${$facb8b07dec6e94a$var$NavigationDataFragment}
${$facb8b07dec6e94a$var$OverviewFragment}
${$facb8b07dec6e94a$var$OverviewConnectionFragment}
`;
const $facb8b07dec6e94a$export$a40c5d12b8a53ba2 = `
query JiraBusinessProjectNavigation($cloudId: ID!, $projectKey: String!, $first: Int!) {
  jira {
    navigation: jwmNavigationByProjectKey(cloudId: $cloudId, projectKey: $projectKey) {
      ...NavigationFragment
    }
  }
}
${$facb8b07dec6e94a$var$ProjectFragment}
${$facb8b07dec6e94a$var$ProjectConnectionFragment}
${$facb8b07dec6e94a$var$NavigationDataFragment}
${$facb8b07dec6e94a$var$OverviewFragment}
${$facb8b07dec6e94a$var$OverviewConnectionFragment}
`;
const $facb8b07dec6e94a$export$c378ca4a0e2c9fec = `
query JiraBusinessOverviewNavigation($cloudId: ID!, $first: Int!) {
  jira {
    navigation: jwmNavigation(cloudId: $cloudId) {
      ...NavigationFragment
    }
  }
}
${$facb8b07dec6e94a$var$ProjectFragment}
${$facb8b07dec6e94a$var$ProjectConnectionFragment}
${$facb8b07dec6e94a$var$NavigationDataFragment}
${$facb8b07dec6e94a$var$OverviewFragment}
${$facb8b07dec6e94a$var$OverviewConnectionFragment}
`;

parcelRegister("exaWd", function(module, exports) {

$parcel$export(module.exports, "fetchNavigation", () => $5a91feaff3ce8435$export$1fc5fff73d9a570c);

var $942wy = parcelRequire("942wy");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");


var $bUjBB = parcelRequire("bUjBB");
const $5a91feaff3ce8435$var$EMPTY_RESPONSE = {
    recents: [],
    favorites: [],
    hasMoreFavorite: false,
    overviews: [],
    overviewsError: null,
    isPremiumUserSeat: false,
    shouldHideOverviews: false
};
const $5a91feaff3ce8435$export$1fc5fff73d9a570c = async (query, params)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    first: (0, $2affa696f349435b$export$3349219a88ac77cd),
                    ...params
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        // checking only for undefined, as null is a valid value (not applicable)
        if (response.data?.jira?.navigation === undefined) throw new (0, $942wy.GraphQLErrors)(response.errors);
        let areOverviewsGone = false;
        if (Array.isArray(response.errors)) // Overviews have been migrated to plans and should no longer be shown to the user
        areOverviewsGone = response.errors.some((error)=>error.extensions?.statusCode === 410);
        return (0, $bUjBB.transformData)(response.data.jira.navigation, areOverviewsGone);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessNavigation', 'Something went wrong while fetching the navigation items');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $gYnSx.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesBusinessNavigation',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $5a91feaff3ce8435$var$EMPTY_RESPONSE;
};

});
const $2affa696f349435b$export$3349219a88ac77cd = 10;
const $2affa696f349435b$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';

parcelRegister("bUjBB", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $af6a29813efa9984$export$3ceb62baab058c6b);

var $1uv7v = parcelRequire("1uv7v");


var $9aOeZ = parcelRequire("9aOeZ");
const $af6a29813efa9984$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
const $af6a29813efa9984$var$PREMIUM = 'PREMIUM';
const $af6a29813efa9984$var$mapProjectNode = (node)=>({
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.projectStyle === $af6a29813efa9984$var$SIMPLIFIED_PROJECT_STYLE,
        isFavorite: node.isFavourite,
        permissions: {
            viewIssues: node.viewIssues.canPerform
        },
        defaultView: node.defaultView?.typeKey?.toLowerCase()
    });
const $af6a29813efa9984$var$mapOverviewNode = (node)=>({
        id: node.id,
        name: node.name,
        theme: node?.theme ?? (0, $1uv7v.DEFAULT_BACKGROUND_CONFIG).name
    });
const $af6a29813efa9984$export$3ceb62baab058c6b = (navigation, areOverviewsGone)=>{
    if (navigation == null) // not a JWM context
    return 0, $2affa696f349435b$export$e8958a6508ec5b71;
    let overviews = [];
    let overviewsError = null;
    const isPremiumUserSeat = navigation.jwmLicensing?.currentUserSeatEdition === $af6a29813efa9984$var$PREMIUM;
    if (isPremiumUserSeat) {
        if (navigation.overviews?.__typename === (0, $9aOeZ.OVERVIEWS_SUCCESS_RESPONSE_TYPE)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        overviews = navigation.overviews.edges.map((edge)=>$af6a29813efa9984$var$mapOverviewNode(edge.node));
        else overviewsError = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        navigation.overviews ?? new Error('Unknown overviews error');
    }
    let recents = navigation.recentProjects?.edges?.map((edge)=>$af6a29813efa9984$var$mapProjectNode(edge.node)) ?? [];
    const favorites = navigation.favoriteProjects?.edges?.map((edge)=>$af6a29813efa9984$var$mapProjectNode(edge.node)) ?? [];
    // Remove favorited projects from the recent projects list
    recents = recents.filter((recentProject)=>!favorites.some((favProject)=>favProject.id === recentProject.id));
    return {
        recents: recents,
        favorites: favorites,
        hasMoreFavorite: navigation.favoriteProjects?.pageInfo?.hasNextPage ?? false,
        overviews: overviews,
        overviewsError: overviewsError,
        isPremiumUserSeat: isPremiumUserSeat,
        shouldHideOverviews: areOverviewsGone
    };
};

});
parcelRegister("1uv7v", function(module, exports) {

$parcel$export(module.exports, "STAR_ICON_COLOR", () => $07a7fda3e3bc1ac3$export$9e0962e0cb41695d);
$parcel$export(module.exports, "Variables", () => $07a7fda3e3bc1ac3$export$8bb9d79ea938efc9);
$parcel$export(module.exports, "Tokens", () => $07a7fda3e3bc1ac3$export$8e1e81ac145e31be);
$parcel$export(module.exports, "BASE_THEME", () => $07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a);
$parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", () => $07a7fda3e3bc1ac3$export$f286efa6bd1e8f9d);
$parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", () => $07a7fda3e3bc1ac3$export$97cb21c6432e07e8);
$parcel$export(module.exports, "GRADIENT_THEME", () => $07a7fda3e3bc1ac3$export$b124f62a6aab972);
$parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$9441e0d8f766c59a);
$parcel$export(module.exports, "NO_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$4c351ec1dc290344);
$parcel$export(module.exports, "ADAPTIVE_IMAGE_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$c8033614bd64480d);
$parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", () => $07a7fda3e3bc1ac3$export$34373eced7ee212e);
$parcel$export(module.exports, "FIXED_COLOR_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$bc16bf654619d060);
$parcel$export(module.exports, "ADAPTIVE_COLOR_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$4b188262dd47f902);
$parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$242b2d2213fedf27);
$parcel$export(module.exports, "ADAPTIVE_GRADIENT_BACKGROUND_CONFIGS", () => $07a7fda3e3bc1ac3$export$8a6c8dd4a86d3f7d);
$parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", () => $07a7fda3e3bc1ac3$export$fe05a238062e2c3d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", () => $07a7fda3e3bc1ac3$export$cab9d853866386f2);
$parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", () => $07a7fda3e3bc1ac3$export$8e357501548afe78);
$parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$baaf8255c30ea280);
$parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$d9035bc768f8226d);
$parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", () => $07a7fda3e3bc1ac3$export$4810531e30462f89);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $07a7fda3e3bc1ac3$export$1c0b806722927549);
$parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$2af5673c2fa63c55);
$parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", () => $07a7fda3e3bc1ac3$export$5771162cdeebfb85);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", () => $07a7fda3e3bc1ac3$export$a1626d6d785092a2);
$parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", () => $07a7fda3e3bc1ac3$export$410e3d6221a052e);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", () => $07a7fda3e3bc1ac3$export$77cdace62a821419);
$parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", () => $07a7fda3e3bc1ac3$export$3efe68325dd9dc02);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout



const $07a7fda3e3bc1ac3$export$9e0962e0cb41695d = '#FFAB00';
const $07a7fda3e3bc1ac3$export$8bb9d79ea938efc9 = {
    BACKDROP_FILTER: '--project-backdrop-filter',
    // Delete when business projects are migrated to the new theming
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: '--project-color-background-neutral-subtle-hovered-contrast',
    COLOR_BACKGROUND_ACCENT_SELECTED: '--project-color-background-accent-selected',
    COLOR_BACKGROUND_BRAND_BOLD: '--project-color-background-brand-bold',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--project-color-background-brand-bold-hovered',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--project-color-background-brand-bold-pressed',
    COLOR_BACKGROUND_DISABLED: '--project-color-background-disabled',
    COLOR_BACKGROUND_INPUT: '--project-background-input',
    COLOR_BACKGROUND_NEUTRAL: '--project-background-neutral',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: '--project-background-neutral-hovered',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: '--project-background-neutral-pressed',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--project-background-neutral-subtle-hovered',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--project-background-neutral-subtle-pressed',
    COLOR_BACKGROUND_SELECTED: '--project-background-selected',
    COLOR_BORDER: '--project-color-border',
    COLOR_BORDER_INPUT: '--project-color-border-input',
    COLOR_BORDER_INVERSE: '--project-color-border-inverse',
    COLOR_BORDER_SELECTED: '--project-color-border-selected',
    COLOR_ELEVATION_SURFACE: '--project-color-elevation-surface',
    COLOR_ELEVATION_SURFACE_SUNKEN: '--project-color-elevation-surface-sunken',
    COLOR_ICON_DANGER: '--project-color-icon-danger',
    COLOR_ICON_INFORMATION: '--project-color-icon-information',
    COLOR_ICON_SUCCESS: '--project-color-icon-success',
    COLOR_ICON_WARNING: '--project-color-icon-warning',
    COLOR_LINK: '--project-color-link',
    COLOR_LINK_PRESSED: '--project-color-link-pressed',
    COLOR_SKELETON: '--project-skeleton',
    COLOR_TEXT: '--project-color-text',
    COLOR_TEXT_ACCENT_SELECTED: '--project-text-accent-selected',
    COLOR_TEXT_DISABLED: '--project-color-text-disabled',
    COLOR_TEXT_INVERSE: '--project-color-text-inverse',
    COLOR_TEXT_SELECTED: '--project-color-text-selected',
    COLOR_TEXT_SUBTLE: '--project-color-text-subtle',
    COLOR_TEXT_SUBTLEST: '--project-color-text-subtlest',
    CONTENT_HEIGHT: '--project-content-height',
    CONTENT_WIDTH: '--project-content-width',
    ELEVATION_SURFACE: '--project-elevation-surface',
    ELEVATION_SURFACE_CONTRAST: '--project-elevation-surface-contrast',
    ELEVATION_SURFACE_CONTRAST_BOLDER: '--project-elevation-surface-contrast-bolder',
    ELEVATION_SURFACE_BLEND_MODE: '--project-elevation-surface-blend-mode',
    WRAPPER_BACKGROUND: '--project-wrapper-background',
    WRAPPER_BORDER_RADIUS: '--project-wrapper-border-radius',
    WRAPPER_HEIGHT: '--project-wrapper-height',
    WRAPPER_PADDING: '--project-wrapper-padding',
    WRAPPER_WIDTH: '--project-wrapper-width'
};
const $07a7fda3e3bc1ac3$export$8e1e81ac145e31be = {
    BACKDROP_FILTER: 'var(--project-backdrop-filter)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST: 'var(--project-color-background-neutral-subtle-hovered-contrast)',
    COLOR_BACKGROUND_ACCENT_SELECTED: 'var(--project-color-background-accent-selected)',
    COLOR_BACKGROUND_BRAND_BOLD: 'var(--project-color-background-brand-bold)',
    COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--project-color-background-brand-bold-hovered)',
    COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--project-color-background-brand-bold-pressed)',
    COLOR_BACKGROUND_DISABLED: 'var(--project-color-background-disabled)',
    COLOR_BACKGROUND_INPUT: 'var(--project-background-input)',
    COLOR_BACKGROUND_NEUTRAL: 'var(--project-background-neutral)',
    COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--project-background-neutral-hovered)',
    COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--project-background-neutral-pressed)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--project-background-neutral-subtle-hovered)',
    COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--project-background-neutral-subtle-pressed)',
    COLOR_BACKGROUND_SELECTED: 'var(--project-background-selected)',
    COLOR_BORDER: 'var(--project-color-border)',
    COLOR_BORDER_INPUT: 'var(--project-color-border-input)',
    COLOR_BORDER_INVERSE: 'var(--project-color-border-inverse)',
    COLOR_BORDER_SELECTED: 'var(--project-color-border-selected)',
    COLOR_ELEVATION_SURFACE: 'var(--project-color-elevation-surface)',
    COLOR_ELEVATION_SURFACE_SUNKEN: 'var(--project-color-elevation-surface-sunken)',
    COLOR_ICON_DANGER: 'var(--project-color-icon-danger)',
    COLOR_ICON_INFORMATION: 'var(--project-color-icon-information)',
    COLOR_ICON_SUCCESS: 'var(--project-color-icon-success)',
    COLOR_ICON_WARNING: 'var(--project-color-icon-warning)',
    COLOR_LINK: 'var(--project-color-link)',
    COLOR_LINK_PRESSED: 'var(--project-color-link-pressed)',
    COLOR_SKELETON: 'var(--project-skeleton)',
    COLOR_TEXT: 'var(--project-color-text)',
    COLOR_TEXT_ACCENT_SELECTED: 'var(--project-text-accent-selected)',
    COLOR_TEXT_DISABLED: 'var(--project-color-text-disabled)',
    COLOR_TEXT_INVERSE: 'var(--project-color-text-inverse)',
    COLOR_TEXT_SELECTED: 'var(--project-color-text-selected)',
    COLOR_TEXT_SUBTLE: 'var(--project-color-text-subtle)',
    COLOR_TEXT_SUBTLEST: 'var(--project-color-text-subtlest)',
    CONTENT_HEIGHT: 'var(--project-content-height)',
    CONTENT_WIDTH: 'var(--project-content-width)',
    ELEVATION_SURFACE: 'var(--project-elevation-surface)',
    ELEVATION_SURFACE_CONTRAST: 'var(--project-elevation-surface-contrast)',
    ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--project-elevation-surface-contrast-bolder)',
    ELEVATION_SURFACE_BLEND_MODE: 'var(--project-elevation-surface-blend-mode)',
    WRAPPER_BACKGROUND: 'var(--project-wrapper-background)',
    WRAPPER_BORDER_RADIUS: 'var(--project-wrapper-border-radius)',
    WRAPPER_HEIGHT: 'var(--project-wrapper-height)',
    WRAPPER_PADDING: 'var(--project-wrapper-padding)',
    WRAPPER_WIDTH: 'var(--project-wrapper-width)'
};
const $07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a = {
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.accent.selected': (0, $7bb4c1736002a04a$exports).B700,
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0C66E4)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0055CC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
    'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.neutral': "var(--ds-background-neutral, #091E420F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #091E424F)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #091E4224)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FF)",
    'color.elevation.surface': "var(--ds-surface, #FFFFFF)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.border': "var(--ds-border, #091E4224)",
    'color.border.input': "var(--ds-border-input, #8590A2)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0C66E4)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.information': "var(--ds-icon-information, #1D7AFC)",
    'color.icon.success': "var(--ds-icon-success, #22A06B)",
    'color.icon.warning': "var(--ds-icon-warning, #E56910)",
    'color.link': "var(--ds-link, #0C66E4)",
    'color.link.pressed': "var(--ds-link-pressed, #0055CC)",
    'color.skeleton': "var(--ds-background-neutral, #091E420F)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.selected': "var(--ds-text, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0C66E4)",
    'color.text.subtle': "var(--ds-text-subtle, #44546F)",
    'color.text.subtlest': "var(--ds-text-subtlest, #626F86)",
    'elevation.surface.contrast': 'transparent',
    'elevation.surface.contrast.bolder': 'transparent',
    'elevation.surface.blend.mode': 'darken'
};
const $07a7fda3e3bc1ac3$export$f286efa6bd1e8f9d = {
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
    'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
    'color.background.input': 'rgba(255, 255, 255, 0.8)',
    'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
    'color.text.selected': "var(--ds-text-inverse, #FFFFFF)"
};
const $07a7fda3e3bc1ac3$export$97cb21c6432e07e8 = {
    'color.background.neutral.subtle.hovered.contrast': 'rgba(255, 255, 255, 0.08)',
    'color.background.accent.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
    'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
    'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
    'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
    'color.background.input': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
    'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
    'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
    'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
    'color.background.selected': 'rgba(255, 255, 255, 0.6)',
    'color.elevation.surface': '#172b4d',
    'color.border': 'rgba(255, 255, 255, 0.14)',
    'color.border.input': 'rgba(255, 255, 255, 0.3)',
    'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
    'color.border.selected': (0, $7bb4c1736002a04a$exports).N0,
    'color.icon.danger': (0, $7bb4c1736002a04a$exports).N0,
    'color.icon.information': (0, $7bb4c1736002a04a$exports).N0,
    'color.icon.success': (0, $7bb4c1736002a04a$exports).N0,
    'color.icon.warning': (0, $7bb4c1736002a04a$exports).N0,
    'color.skeleton': 'rgba(255,255,255,0.08)',
    'color.text': (0, $7bb4c1736002a04a$exports).N0,
    'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
    'color.text.inverse': '#172B4D',
    // Neutral 1000
    'color.text.selected': '#172B4D',
    // Neutral 1000
    'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
    'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
};
const $07a7fda3e3bc1ac3$export$b124f62a6aab972 = {
    'color.link': '#CCE0FF',
    // Blue 200
    'color.link.pressed': '#E9F2FF' // Blue 100
};
const $07a7fda3e3bc1ac3$export$9441e0d8f766c59a = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        },
        dark: {
            'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
            'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
            'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.background.input': 'rgba(34, 39, 43, 0.8)',
            'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
            'color.elevation.surface': '#172b4d',
            'color.border': 'rgba(255, 255, 255, 0.14)',
            'color.border.input': 'rgba(255, 255, 255, 0.3)',
            'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
            'color.icon.danger': (0, $7bb4c1736002a04a$exports).N0,
            'color.icon.information': (0, $7bb4c1736002a04a$exports).N0,
            'color.icon.success': (0, $7bb4c1736002a04a$exports).N0,
            'color.icon.warning': (0, $7bb4c1736002a04a$exports).N0,
            'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
            'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
            'color.skeleton': 'rgba(255,255,255,0.8)',
            'color.text': (0, $7bb4c1736002a04a$exports).N0,
            'color.text.selected': "var(--ds-text-inverse, #FFFFFF)",
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
            'elevation.surface.contrast.bolder': "var(--ds-surface, #FFFFFF)"
        }
    }
};
// Old Colors
const $07a7fda3e3bc1ac3$var$WHITE_BACKGROUND_CONFIG = {
    name: 'white'
};
const $07a7fda3e3bc1ac3$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
    name: 'light-purple'
};
const $07a7fda3e3bc1ac3$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
    name: 'light-blue'
};
const $07a7fda3e3bc1ac3$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
    name: 'light-teal'
};
const $07a7fda3e3bc1ac3$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
    name: 'light-green'
};
const $07a7fda3e3bc1ac3$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
    name: 'light-yellow'
};
const $07a7fda3e3bc1ac3$var$LIGHT_RED_BACKGROUND_CONFIG = {
    name: 'light-red'
};
const $07a7fda3e3bc1ac3$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
    name: 'light-magenta'
};
const $07a7fda3e3bc1ac3$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
    name: 'light-orange'
};
const $07a7fda3e3bc1ac3$var$DARK_BACKGROUND_CONFIG = {
    name: 'dark'
};
const $07a7fda3e3bc1ac3$var$PURPLE_BACKGROUND_CONFIG = {
    name: 'purple'
};
const $07a7fda3e3bc1ac3$var$BLUE_BACKGROUND_CONFIG = {
    name: 'blue'
};
const $07a7fda3e3bc1ac3$var$TEAL_BACKGROUND_CONFIG = {
    name: 'teal'
};
const $07a7fda3e3bc1ac3$var$GREEN_BACKGROUND_CONFIG = {
    name: 'green'
};
const $07a7fda3e3bc1ac3$var$YELLOW_BACKGROUND_CONFIG = {
    name: 'yellow'
};
const $07a7fda3e3bc1ac3$var$RED_BACKGROUND_CONFIG = {
    name: 'red'
};
const $07a7fda3e3bc1ac3$var$MAGENTA_BACKGROUND_CONFIG = {
    name: 'magenta'
};
const $07a7fda3e3bc1ac3$var$ORANGE_BACKGROUND_CONFIG = {
    name: 'orange'
};
// New Colors
const $07a7fda3e3bc1ac3$var$DARKER_GRAY_BACKGROUND_CONFIG = {
    name: 'darker-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
    name: 'darker-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_BLUE_BACKGROUND_CONFIG = {
    name: 'darker-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_TEAL_BACKGROUND_CONFIG = {
    name: 'darker-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_GREEN_BACKGROUND_CONFIG = {
    name: 'darker-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_LIME_BACKGROUND_CONFIG = {
    name: 'darker-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
    name: 'darker-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
    name: 'darker-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_RED_BACKGROUND_CONFIG = {
    name: 'darker-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darker-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
    name: 'darkest-gray',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'darkest-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
    name: 'darkest-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
    name: 'darkest-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
    name: 'darkest-green',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_LIME_BACKGROUND_CONFIG = {
    name: 'darkest-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'darkest-yellow',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'darkest-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_RED_BACKGROUND_CONFIG = {
    name: 'darkest-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'darkest-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
    name: 'lightest-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F1F2F4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
    name: 'lightest-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F3F0FF',
            // Purple 100
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#5E4DB2',
            // Purple 800
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
    name: 'lightest-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E9F2FF',
            // Blue 100
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#0055CC',
            // Blue 800
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
    name: 'lightest-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#E7F9FF',
            // Teal 100
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#206A83',
            // Teal 800
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
    name: 'lightest-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCFFF1',
            // Green 100
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#216E4E',
            // Green 800
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
    name: 'lightest-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#EFFFD6',
            // Lime 100
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#4C6B1F',
            // Lime 800
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
    name: 'lightest-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF7D6',
            // Yellow 100
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#7F5F01',
            // Yellow 800
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
    name: 'lightest-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFF3EB',
            // Orange 100
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#A54800',
            // Orange 800
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
    name: 'lightest-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECEB',
            // Red 100
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#AE2E24',
            // Red 800
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lightest-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFECF8',
            // Magenta 100
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#943D73',
            // Magenta 800
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
    name: 'lighter-gray',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DCDFE4',
            // Neutral 200
            'color.link': '#44546F',
            // Neutral 800
            'color.link.pressed': '#091E42' // Neutral 1100
        },
        dark: {
            'color.elevation.surface': '#172B4D',
            // Neutral 1000
            'color.link': '#F1F2F4',
            // Neutral 200
            'color.link.pressed': '#F7F8F9' // Neutral 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
    name: 'lighter-purple',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#DFD8FD',
            // Purple 200
            'color.link': '#5E4DB2',
            // Purple 800
            'color.link.pressed': '#352C63' // Purple 900
        },
        dark: {
            'color.elevation.surface': '#352C63',
            // Purple 900
            'color.link': '#DFD8FD',
            // Purple 200
            'color.link.pressed': '#F3F0FF' // Purple 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
    name: 'lighter-blue',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#CCE0FF',
            // Blue 200
            'color.link': '#0055CC',
            // Blue 800
            'color.link.pressed': '#09326C' // Blue 900
        },
        dark: {
            'color.elevation.surface': '#09326C',
            // Blue 900
            'color.link': '#CCE0FF',
            // Blue 200
            'color.link.pressed': '#E9F2FF' // Blue 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
    name: 'lighter-teal',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#C6EDFB',
            // Teal 200
            'color.link': '#206A83',
            // Teal 800
            'color.link.pressed': '#164555' // Teal 900
        },
        dark: {
            'color.elevation.surface': '#164555',
            // Teal 900
            'color.link': '#C6EDFB',
            // Teal 200
            'color.link.pressed': '#E7F9FF' // Teal 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
    name: 'lighter-green',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#BAF3DB',
            // Green 200
            'color.link': '#216E4E',
            // Green 800
            'color.link.pressed': '#164B35' // Green 900
        },
        dark: {
            'color.elevation.surface': '#164B35',
            // Green 900
            'color.link': '#BAF3DB',
            // Green 200
            'color.link.pressed': '#DCFFF1' // Green 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
    name: 'lighter-lime',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#D3F1A7',
            // Lime 200
            'color.link': '#4C6B1F',
            // Lime 800
            'color.link.pressed': '#37471F' // Lime 900
        },
        dark: {
            'color.elevation.surface': '#37471F',
            // Lime 900
            'color.link': '#D3F1A7',
            // Lime 200
            'color.link.pressed': '#EFFFD6' // Lime 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
    name: 'lighter-yellow',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#F8E6A0',
            // Yellow 200
            'color.link': '#7F5F01',
            // Yellow 800
            'color.link.pressed': '#533F04' // Yellow 900
        },
        dark: {
            'color.elevation.surface': '#533F04',
            // Yellow 900
            'color.link': '#F8E6A0',
            // Yellow 200
            'color.link.pressed': '#FFF7D6' // Yellow 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
    name: 'lighter-orange',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FEDEC8',
            // Orange 200
            'color.link': '#A54800',
            // Orange 800
            'color.link.pressed': '#702E00' // Orange 900
        },
        dark: {
            'color.elevation.surface': '#702E00',
            // Orange 900
            'color.link': '#FEDEC8',
            // Orange 200
            'color.link.pressed': '#FFF3EB' // Orange 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_RED_BACKGROUND_CONFIG = {
    name: 'lighter-red',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FFD5D2',
            // Red 200
            'color.link': '#AE2E24',
            // Red 800
            'color.link.pressed': '#5D1F1A' // Red 900
        },
        dark: {
            'color.elevation.surface': '#5D1F1A',
            // Red 900
            'color.link': '#FFD5D2',
            // Red 200
            'color.link.pressed': '#FFECEB' // Red 100
        }
    }
};
const $07a7fda3e3bc1ac3$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
    name: 'lighter-magenta',
    brightness: 'high',
    theme: {
        light: {
            'color.elevation.surface': '#FDD0EC',
            // Magenta 200
            'color.link': '#943D73',
            // Magenta 800
            'color.link.pressed': '#50253F' // Magenta 900
        },
        dark: {
            'color.elevation.surface': '#50253F',
            // Magenta 900
            'color.link': '#FDD0EC',
            // Magenta 200
            'color.link.pressed': '#FFECF8' // Magenta 100
        }
    }
};
const $07a7fda3e3bc1ac3$export$4c351ec1dc290344 = {
    name: 'no-background',
    brightness: 'high',
    theme: {
        light: $07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a,
        dark: {
            ...$07a7fda3e3bc1ac3$export$8a6e9b3370a0f87a,
            'color.text.accent.selected': "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE = {
    'color.elevation.surface': "var(--ds-surface-hovered, #F1F2F4)",
    'color.background.input': "var(--ds-background-neutral, #091E420F)",
    'color.link': "var(--ds-text, #172B4D)",
    'color.link.pressed': "var(--ds-text, #172B4D)",
    'color.elevation.surface.sunken': "var(--ds-surface-sunken, #F7F8F9)",
    'color.background.selected': "var(--ds-background-neutral-hovered, #091E4224)",
    'color.background.neutral.subtle.hovered.contrast': "var(--ds-surface-hovered, #F1F2F4)",
    'color.border.selected': "var(--ds-border-bold, #758195)",
    'color.text.selected': "var(--ds-text, #172B4D)",
    'color.text': "var(--ds-text, #172B4D)",
    'color.background.brand.bold': "var(--ds-background-neutral-bold, #44546F)",
    'color.background.brand.bold.hovered': "var(--ds-background-neutral-bold-hovered, #2C3E5D)",
    'color.background.brand.bold.pressed': "var(--ds-background-neutral-bold-pressed, #172B4D)"
};
const $07a7fda3e3bc1ac3$export$2ccb37bafb938d85 = ({ name: name, overrides: overrides })=>{
    const adaptiveColorTheme = {
        ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
        ...overrides
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: adaptiveColorTheme,
            dark: adaptiveColorTheme
        }
    };
};
const $07a7fda3e3bc1ac3$export$18621b73983ebf62 = ({ name: name, overridesAllThemes: overridesAllThemes, overridesLightTheme: overridesLightTheme, overridesDarkTheme: overridesDarkTheme })=>{
    const adaptiveGradientTheme = {
        'elevation.surface': "var(--ds-surface, #FFFFFF)",
        ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
        ...overridesAllThemes
    };
    return {
        name: name,
        brightness: 'high',
        theme: {
            light: {
                ...adaptiveGradientTheme,
                ...overridesLightTheme
            },
            dark: {
                ...adaptiveGradientTheme,
                ...overridesDarkTheme
            }
        }
    };
};
const $07a7fda3e3bc1ac3$export$c8033614bd64480d = {
    name: 'image',
    brightness: 'high',
    theme: {
        light: {
            ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'normal',
            'elevation.surface.contrast': 'rgba(255,255,255,0.82)'
        },
        dark: {
            ...$07a7fda3e3bc1ac3$var$ADAPTIVE_CONFIG_BASE,
            'elevation.surface.blend.mode': 'darken',
            'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)'
        }
    }
};
const $07a7fda3e3bc1ac3$export$dbb791a784a1373b = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-gray',
    overrides: {
        'color.elevation.surface.sunken': "var(--ds-surface-pressed, #DCDFE4)"
    }
});
const $07a7fda3e3bc1ac3$export$e013fca1233b4f7f = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-purple',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        'color.link': "var(--ds-text-accent-purple, #5E4DB2)",
        'color.link.pressed': "var(--ds-text-accent-purple, #5E4DB2)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-purple-subtler, #DFD8FD)"
    }
});
const $07a7fda3e3bc1ac3$export$81ad18a6866e27ad = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-blue',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtler, #CCE0FF)"
    }
});
const $07a7fda3e3bc1ac3$export$e41eaa7177d56baf = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-teal',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    }
});
const $07a7fda3e3bc1ac3$export$31b6c9185eea93be = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-green',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtler, #BAF3DB)"
    }
});
const $07a7fda3e3bc1ac3$export$3214417ed3fa0b58 = $07a7fda3e3bc1ac3$export$2ccb37bafb938d85({
    name: 'adaptive-magenta',
    overrides: {
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    }
});
// Gradients
const $07a7fda3e3bc1ac3$var$GRADIENT_GRAY_TO_BLACK_META = {
    name: 'gradient-gray-to-black',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
    name: 'gradient-dark-to-medium-purple',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
    name: 'gradient-light-to-dark-blue',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_BLUE_TO_TEAL_META = {
    name: 'gradient-blue-to-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
    name: 'gradient-purple-to-magenta',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
    name: 'gradient-magenta-to-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
    name: 'gradient-dark-to-light-red',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
    name: 'gradient-dark-to-light-orange',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        },
        dark: {
            'color.elevation.surface': '#44546F',
            // Neutral 800
            'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
    name: 'gradient-dark-green-to-lime',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        },
        dark: {
            'color.elevation.surface': '#133911',
            'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
    name: 'gradient-dark-to-medium-teal',
    brightness: 'low',
    theme: {
        light: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        },
        dark: {
            'color.elevation.surface': '#01233D',
            'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
        }
    }
};
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GRAY_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-gray',
    overridesAllThemes: {},
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #F8F8F8 0%, #B7B9BE 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #292A2E 0%, #6B6E76 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_PURPLE_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-purple',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #CFE1FD 0%, #EED7FC 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #123263 0%, #48245D 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_BLUE_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-blue',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-blue, #0055CC)",
        'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
        'color.elevation.surface': "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E9F2FE 0%, #669DF1 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C2B42 0%, #1868DB 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_TEAL_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-teal',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-teal, #206A83)",
        'color.link.pressed': "var(--ds-text-accent-teal, #206A83)",
        'color.elevation.surface': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #E7F9FF 0%, #6CC3E0 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1E3137 0%, #227D9B 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GREEN_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-green',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-green, #216E4E)",
        'color.link.pressed': "var(--ds-text-accent-green, #216E4E)",
        'color.elevation.surface': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #DCFFF1 0%, #4BCE97 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #1C3329 0%, #1F845A 100%)'
    }
});
const $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_MAGENTA_META = $07a7fda3e3bc1ac3$export$18621b73983ebf62({
    name: 'adaptive-gradient-magenta',
    overridesAllThemes: {
        'color.link': "var(--ds-text-accent-magenta, #943D73)",
        'color.link.pressed': "var(--ds-text-accent-magenta, #943D73)",
        'color.elevation.surface': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
        'color.elevation.surface.sunken': "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    },
    overridesLightTheme: {
        'elevation.surface': 'linear-gradient(135deg, #FDD0EC 28.5%, #FD9891 100%)'
    },
    overridesDarkTheme: {
        'elevation.surface': 'linear-gradient(135deg, #50253F 28.5%, #AE2E24 100%)'
    }
});
const $07a7fda3e3bc1ac3$export$34373eced7ee212e = [
    $07a7fda3e3bc1ac3$var$WHITE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARK_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$MAGENTA_BACKGROUND_CONFIG
];
const $07a7fda3e3bc1ac3$export$bc16bf654619d060 = [
    $07a7fda3e3bc1ac3$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_BLUE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_TEAL_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_GREEN_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_LIME_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_RED_BACKGROUND_CONFIG,
    $07a7fda3e3bc1ac3$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
];
const $07a7fda3e3bc1ac3$export$4b188262dd47f902 = [
    $07a7fda3e3bc1ac3$export$dbb791a784a1373b,
    $07a7fda3e3bc1ac3$export$e013fca1233b4f7f,
    $07a7fda3e3bc1ac3$export$81ad18a6866e27ad,
    $07a7fda3e3bc1ac3$export$e41eaa7177d56baf,
    $07a7fda3e3bc1ac3$export$31b6c9185eea93be,
    $07a7fda3e3bc1ac3$export$3214417ed3fa0b58
];
const $07a7fda3e3bc1ac3$export$242b2d2213fedf27 = [
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_RED_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_MAGENTA_TO_ORANGE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_GREEN_TO_LIME_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_BLUE_TO_TEAL_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_PURPLE_TO_MAGENTA_META,
    $07a7fda3e3bc1ac3$var$GRADIENT_GRAY_TO_BLACK_META
];
const $07a7fda3e3bc1ac3$export$8a6c8dd4a86d3f7d = [
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GRAY_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_PURPLE_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_BLUE_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_TEAL_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_GREEN_META,
    $07a7fda3e3bc1ac3$var$ADAPTIVE_GRADIENT_MAGENTA_META
];
const $07a7fda3e3bc1ac3$export$fe05a238062e2c3d = {
    white: $07a7fda3e3bc1ac3$export$4c351ec1dc290344,
    'light-purple': $07a7fda3e3bc1ac3$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
    'light-blue': $07a7fda3e3bc1ac3$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
    'light-teal': $07a7fda3e3bc1ac3$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
    'light-green': $07a7fda3e3bc1ac3$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
    'light-yellow': $07a7fda3e3bc1ac3$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
    'light-orange': $07a7fda3e3bc1ac3$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
    'light-red': $07a7fda3e3bc1ac3$var$LIGHTEST_RED_BACKGROUND_CONFIG,
    'light-magenta': $07a7fda3e3bc1ac3$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
    dark: $07a7fda3e3bc1ac3$var$DARKEST_GRAY_BACKGROUND_CONFIG,
    purple: $07a7fda3e3bc1ac3$var$DARKER_PURPLE_BACKGROUND_CONFIG,
    blue: $07a7fda3e3bc1ac3$var$DARKER_BLUE_BACKGROUND_CONFIG,
    teal: $07a7fda3e3bc1ac3$var$DARKER_TEAL_BACKGROUND_CONFIG,
    green: $07a7fda3e3bc1ac3$var$DARKER_GREEN_BACKGROUND_CONFIG,
    yellow: $07a7fda3e3bc1ac3$var$DARKER_YELLOW_BACKGROUND_CONFIG,
    orange: $07a7fda3e3bc1ac3$var$DARKER_ORANGE_BACKGROUND_CONFIG,
    red: $07a7fda3e3bc1ac3$var$DARKER_RED_BACKGROUND_CONFIG,
    magenta: $07a7fda3e3bc1ac3$var$DARKER_MAGENTA_BACKGROUND_CONFIG
};
const $07a7fda3e3bc1ac3$export$cab9d853866386f2 = $07a7fda3e3bc1ac3$export$4c351ec1dc290344;
const $07a7fda3e3bc1ac3$export$8e357501548afe78 = 24;
const $07a7fda3e3bc1ac3$export$baaf8255c30ea280 = 95;
const $07a7fda3e3bc1ac3$export$d9035bc768f8226d = `${$07a7fda3e3bc1ac3$export$baaf8255c30ea280}px`;
const $07a7fda3e3bc1ac3$export$4810531e30462f89 = `calc(100vh - ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$d9035bc768f8226d})`;
const $07a7fda3e3bc1ac3$export$1c0b806722927549 = `calc(100vh - ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$d9035bc768f8226d} - ${$07a7fda3e3bc1ac3$export$8e357501548afe78 * 2}px)`;
const $07a7fda3e3bc1ac3$export$2af5673c2fa63c55 = 104;
const $07a7fda3e3bc1ac3$export$5771162cdeebfb85 = `${$07a7fda3e3bc1ac3$export$2af5673c2fa63c55}px`;
const $07a7fda3e3bc1ac3$export$a1626d6d785092a2 = `calc(100vh - ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$5771162cdeebfb85})`;
const $07a7fda3e3bc1ac3$export$410e3d6221a052e = `calc(100vh - ${(0, $bf1c59a4164b2d18$export$d60454526e2281af)} - ${$07a7fda3e3bc1ac3$export$5771162cdeebfb85} - ${$07a7fda3e3bc1ac3$export$8e357501548afe78 * 2}px)`;
const $07a7fda3e3bc1ac3$export$77cdace62a821419 = `calc(100vw - ${(0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)} - ${(0, $7326b3b2ac0b6dee$export$f897e1ed9f8ed251)} - ${(0, $7326b3b2ac0b6dee$export$750459958906793)} - ${(0, $7326b3b2ac0b6dee$export$b44ab66843c05a69)}) !important`;
const $07a7fda3e3bc1ac3$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $7326b3b2ac0b6dee$export$f963aecf2d4465bd)} - ${(0, $7326b3b2ac0b6dee$export$f897e1ed9f8ed251)} - ${(0, $7326b3b2ac0b6dee$export$750459958906793)} - ${(0, $7326b3b2ac0b6dee$export$b44ab66843c05a69)} - ${$07a7fda3e3bc1ac3$export$8e357501548afe78 * 2}px) !important`;
const $07a7fda3e3bc1ac3$export$689a64196408e5c2 = 82;

});
// dimension vars
const $7326b3b2ac0b6dee$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $7326b3b2ac0b6dee$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $7326b3b2ac0b6dee$export$c103b605cd368aed = 'rightSidebarWidth';
const $7326b3b2ac0b6dee$export$fa34f417972d6341 = 'rightPanelWidth';
const $7326b3b2ac0b6dee$export$3a6a779d9181047c = 'topNavigationHeight';
const $7326b3b2ac0b6dee$export$bcd94a6a792e7f96 = 'bannerHeight';
const $7326b3b2ac0b6dee$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $7326b3b2ac0b6dee$export$344062f7cfc9528e = 'left-panel';
const $7326b3b2ac0b6dee$export$c7139cc2d6110b5f = 'right-panel';
const $7326b3b2ac0b6dee$export$238d30785c4bca84 = 'banner';
const $7326b3b2ac0b6dee$export$bec6dca2e63de4ae = 'top-navigation';
const $7326b3b2ac0b6dee$export$d1213e82613ff4df = 'content';
const $7326b3b2ac0b6dee$export$be83e7118304b28e = 56;
const $7326b3b2ac0b6dee$export$4a98ee0bd1ae362 = 56;
const $7326b3b2ac0b6dee$export$539e68c09584883a = 240;
const $7326b3b2ac0b6dee$export$b92df8810d2fcd01 = 280;
const $7326b3b2ac0b6dee$export$c3e41153b9288bcf = 368;
const $7326b3b2ac0b6dee$export$c4d6152f86ea28f6 = 368;
const $7326b3b2ac0b6dee$export$46acf8758e9e2636 = 20;
const $7326b3b2ac0b6dee$export$70740f5ad8360a78 = 16;
const $7326b3b2ac0b6dee$export$991d5285ad765a3d = 240;
const $7326b3b2ac0b6dee$export$6949d4f32b161684 = 200;
const $7326b3b2ac0b6dee$export$d6e7e8af042815bb = 350;
const $7326b3b2ac0b6dee$export$3749e1104328fde4 = 300;
const $7326b3b2ac0b6dee$export$1074d925b0b82be5 = 200;
const $7326b3b2ac0b6dee$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $7326b3b2ac0b6dee$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $7326b3b2ac0b6dee$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $7326b3b2ac0b6dee$export$70c702a8c5895f03 = 'data-grab-area-line';
const $7326b3b2ac0b6dee$export$48a43f91e4becf4e = 'data-grab-area';
const $7326b3b2ac0b6dee$export$dac2fb31a9f6844d = 'data-resize-button';
const $7326b3b2ac0b6dee$export$9ecd22db14e6c70e = 'data-resize-control';
const $7326b3b2ac0b6dee$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $7326b3b2ac0b6dee$export$206a08f7f8beb554 = 'Skip to:';
const $7326b3b2ac0b6dee$export$659ee746b31b360d = 'data-layout-container';
const $7326b3b2ac0b6dee$export$f963aecf2d4465bd = `var(--${$7326b3b2ac0b6dee$export$cbfb0f5b2869b17b}, 0px)`;
const $7326b3b2ac0b6dee$export$750459958906793 = `var(--${$7326b3b2ac0b6dee$export$fa34f417972d6341}, 0px)`;
const $7326b3b2ac0b6dee$export$f897e1ed9f8ed251 = `var(--${$7326b3b2ac0b6dee$export$a30f2e00489a8957}, 0px)`;
const $7326b3b2ac0b6dee$export$b44ab66843c05a69 = `var(--${$7326b3b2ac0b6dee$export$c103b605cd368aed}, 0px)`;
const $7326b3b2ac0b6dee$export$aeff86a16f13529 = `var(--${$7326b3b2ac0b6dee$export$3a6a779d9181047c}, 0px)`;
const $7326b3b2ac0b6dee$export$ed7cc0d417ee89e = `var(--${$7326b3b2ac0b6dee$export$bcd94a6a792e7f96}, 0px)`;
const $7326b3b2ac0b6dee$export$d2fa14f05b61e66 = `var(--${$7326b3b2ac0b6dee$export$b6744d31294864fd}, ${$7326b3b2ac0b6dee$export$991d5285ad765a3d}px)`;

var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $bf1c59a4164b2d18$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $bf1c59a4164b2d18$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $bf1c59a4164b2d18$export$638757b621fbf475 = `${$bf1c59a4164b2d18$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$bf1c59a4164b2d18$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $bf1c59a4164b2d18$export$d60454526e2281af = `(${$bf1c59a4164b2d18$export$638757b621fbf475})`;


parcelRegister("9aOeZ", function(module, exports) {

$parcel$export(module.exports, "OVERVIEWS_SUCCESS_RESPONSE_TYPE", () => $02fee4f3a61bd031$export$ddf2fc82885279d);
const $02fee4f3a61bd031$export$ddf2fc82885279d = 'JiraWorkManagementGiraOverviewConnection';
const $02fee4f3a61bd031$export$39284f7325536558 = {
    ServiceDesk: 'SERVICE_DESK',
    Business: 'BUSINESS',
    Software: 'SOFTWARE'
};
const $02fee4f3a61bd031$export$1f66f9f05afa05a8 = {
    TeamManagedProject: 'TEAM_MANAGED_PROJECT',
    CompanyManagedProject: 'COMPANY_MANAGED_PROJECT'
};

});




parcelRegister("iXIhG", function(module, exports) {

$parcel$export(module.exports, "overviewDetailsResource", () => $3b47543f677664af$export$cd57aa046b167312);
$parcel$export(module.exports, "useOverview", () => $3b47543f677664af$export$626541a5c6f2cfa1);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $336Fd = parcelRequire("336Fd");
const $3b47543f677664af$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
const $3b47543f677664af$export$cd57aa046b167312 = (0, $l1VxS.createResource)({
    type: $3b47543f677664af$var$RESOURCE_TYPE_KEY,
    getKey: ({ match: match })=>`${$3b47543f677664af$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
    getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $336Fd.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
    maxAge: 3600000
});
const $3b47543f677664af$export$626541a5c6f2cfa1 = ()=>(0, $eJrcF.useResource)($3b47543f677664af$export$cd57aa046b167312);

});
parcelRegister("336Fd", function(module, exports) {

$parcel$export(module.exports, "fetchOverviewDetails", () => $3b2ca6dca30fb5cf$export$f0395142dbdd6c61);

var $cwZUV = parcelRequire("cwZUV");

var $ejRjJ = parcelRequire("ejRjJ");

var $942wy = parcelRequire("942wy");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $29CL1 = parcelRequire("29CL1");

const $3b2ca6dca30fb5cf$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
    if (!overviewId) return null;
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $29CL1.QUERY),
                variables: {
                    id: (0, $cwZUV.JiraProjectOverviewAri).create({
                        siteId: cloudId,
                        activationId: activationId,
                        overviewId: overviewId
                    }).toString()
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'projectStyle'
            }
        });
        if (response?.data?.jira?.overview?.__typename === (0, $5b9dabc66daa95fc$export$62a5da7e3fa5ff88)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $ejRjJ.mapOverviewFragment)(response.data.jira.overview);
        throw new (0, $942wy.GraphQLErrors)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        response?.data?.jira?.overview ?? response.errors);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 410 means that overviews have been migrated to plans and
        // we will show a different message on the not found page.
        if (error?.statusCode === 410) throw error;
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'overviewDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return null;
};

});
parcelRegister("ejRjJ", function(module, exports) {

$parcel$export(module.exports, "mapOverviewFragment", () => $b1720e1416bb124d$export$e79bf238de33eabb);
const $b1720e1416bb124d$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b1720e1416bb124d$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
        const { node: node } = edge || {};
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            isSimplified: node.projectStyle === $b1720e1416bb124d$var$SIMPLIFIED_PROJECT_STYLE,
            isFavorite: node.isFavourite === true,
            permissions: {
                assignIssues: false,
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                // remove optional chaining when jwm-use-updated-graphql-querymutation-for-overview is cleaned up
                transitionIssues: node.transitionIssues?.canPerform === true,
                viewIssues: node.viewIssues.canPerform
            }
        };
    }).filter((project)=>project);
const $b1720e1416bb124d$export$e79bf238de33eabb = (overview)=>{
    const { id: id, name: name, theme: theme, projects: projectsData } = overview;
    const projects = $b1720e1416bb124d$var$mapProjectsNode(projectsData.edges);
    const unreachableProjectsCount = projectsData.edges.length - projects.length;
    return {
        id: id,
        name: name,
        theme: theme,
        projects: projects,
        unreachableProjectsCount: unreachableProjectsCount
    };
};

});

parcelRegister("29CL1", function(module, exports) {

$parcel$export(module.exports, "QUERY", () => $0ae7c7b180165261$export$2b91517d6d5b4365);

const $0ae7c7b180165261$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $bfd590d07d509ee9$export$6f4bda7ea1dcf892)}
`;

});
const $bfd590d07d509ee9$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;


const $5b9dabc66daa95fc$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';



parcelRegister("ebuR2", function(module, exports) {

$parcel$export(module.exports, "DEPRECATED_DO_NOT_USE_projectDetailsResource", () => $a81e3a6968ecf224$export$ced53bf9d9551fef);
$parcel$export(module.exports, "useProject_DEPRECATED_DO_NOT_USE", () => $a81e3a6968ecf224$export$97def3841413167f);
/* eslint-disable camelcase */ 
var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $94I3A = parcelRequire("94I3A");
const $a81e3a6968ecf224$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
const $a81e3a6968ecf224$export$ced53bf9d9551fef = (0, $l1VxS.createResource)({
    type: $a81e3a6968ecf224$var$RESOURCE_TYPE_KEY,
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        const projectIdOrKey = projectKey || projectId;
        return `${$a81e3a6968ecf224$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
    },
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        return (0, $94I3A.fetchProjectDetails)(cloudId, projectKey, projectId);
    },
    maxAge: 3600000
});
const $a81e3a6968ecf224$export$97def3841413167f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($a81e3a6968ecf224$export$ced53bf9d9551fef);
    return {
        data: data?.currentProject ?? null,
        loading: loading,
        error: error
    };
};

});
parcelRegister("94I3A", function(module, exports) {

$parcel$export(module.exports, "fetchProjectDetails", () => $afb0ef71187f4894$export$78aa221476efa1c6);

var $3osLr = parcelRequire("3osLr");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");


var $52UtB = parcelRequire("52UtB");
const $afb0ef71187f4894$var$EMPTY_VALUE = {};
const $afb0ef71187f4894$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
    const projectIdOrKey = projectId || projectKey;
    if (!projectIdOrKey) return null;
    try {
        const response = await (0, $jGzN3.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
            body: JSON.stringify({
                query: (0, $3833a2a8ead613b5$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    projectIdOrKey: projectIdOrKey,
                    usingProjectKey: projectId == null,
                    projectId: projectId != null ? (0, $3osLr.JiraProjectAri).create({
                        siteId: cloudId,
                        projectId: projectId
                    }).toString() : ''
                }
            })
        });
        return (0, $52UtB.transformData)(response.data, projectIdOrKey);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'projectDetailsResource',
                    packageName: 'jiraRouterResourcesBusinessProjectDetails',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return $afb0ef71187f4894$var$EMPTY_VALUE;
};

});
const $3833a2a8ead613b5$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $3833a2a8ead613b5$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
  }
}
${$3833a2a8ead613b5$var$PROJECT_FRAGMENT}
`;

parcelRegister("52UtB", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $e1a6d24fb0f7d7ff$export$3ceb62baab058c6b);
const $e1a6d24fb0f7d7ff$var$mapProjectNode = (node)=>{
    if (node == null) return null;
    return {
        key: node.key,
        id: Number(node.projectId),
        avatarUrl: node.avatar?.large ?? '',
        name: node.name,
        type: node.projectType.toLowerCase(),
        isSimplified: node.simplified,
        isFavorite: node.favorite === true,
        permissions: {
            administerProject: node.administerProject.canPerform,
            createIssues: node.createIssues.canPerform,
            viewIssues: node.viewIssues.canPerform
        }
    };
};
const $e1a6d24fb0f7d7ff$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
        currentProject: $e1a6d24fb0f7d7ff$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $e1a6d24fb0f7d7ff$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
        projectIdOrKey: projectIdOrKey
    });

});



parcelRegister("8tbnc", function(module, exports) {

$parcel$export(module.exports, "licenseDetailsResource_DEPRECATED_DO_NOT_USE", () => $70398e7926820970$export$92c4069b5349d086);
$parcel$export(module.exports, "useIsPremiumUserSeat", () => $70398e7926820970$export$90749419e9042370);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


var $bGJcU = parcelRequire("bGJcU");
const $70398e7926820970$export$92c4069b5349d086 = (0, $l1VxS.createResource)({
    type: 'BUSINESS_LICENSE_DETAILS',
    getKey: ()=>'BUSINESS_LICENSE_DETAILS',
    getData: async (_routerContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
        // do not fetch the resource for anonymous access
        if (isAnonymous) return null;
        return (0, $bGJcU.fetchLicenseDetails)((0, $ba7d1bcdd3e5eca1$export$2b91517d6d5b4365), {
            cloudId: cloudId
        });
    },
    maxAge: Infinity
});
const $70398e7926820970$export$90749419e9042370 = ()=>{
    const { data: data } = (0, $eJrcF.useResource)($70398e7926820970$export$92c4069b5349d086);
    return Boolean(data?.isPremiumUserSeat);
};

});
const $ba7d1bcdd3e5eca1$export$2b91517d6d5b4365 = `
query JiraBusinessLicenseDetails($cloudId:ID!) {
  jira {
    jwmLicensing(cloudId: $cloudId) {
      currentUserSeatEdition
    }
  }
}
`;

parcelRegister("bGJcU", function(module, exports) {

$parcel$export(module.exports, "fetchLicenseDetails", () => $ebc3c21a42e05a54$export$ec058a82eccb31e);

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $ebc3c21a42e05a54$var$EMPTY_RESPONSE = {
    isPremiumUserSeat: false
};
const $ebc3c21a42e05a54$export$ec058a82eccb31e = async (query, { cloudId: cloudId })=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: query,
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        return {
            isPremiumUserSeat: response.data?.jira?.jwmLicensing?.currentUserSeatEdition === 'PREMIUM'
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessLicenseDetails', 'Something went wrong while fetching the license details');
        const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
        if (!isClientError) (0, $gYnSx.default)({
            meta: {
                id: 'licenseDetailsResource',
                packageName: 'jiraRouterResourcesBusinessLicenseDetails',
                teamName: 'wanjel'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return $ebc3c21a42e05a54$var$EMPTY_RESPONSE;
};

});


parcelRegister("ho9E1", function(module, exports) {

$parcel$export(module.exports, "projectCreatePermissionsResource", () => $684d3b239b1e0d5f$export$f6c05eaea53ab4ae);
$parcel$export(module.exports, "useProjectCreatePermissionsResource", () => $684d3b239b1e0d5f$export$2bd0d3b374549a68);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $684d3b239b1e0d5f$var$getDataLoader = ()=>(parcelRequire("40oPd"));
const $684d3b239b1e0d5f$export$f6c05eaea53ab4ae = (0, $l1VxS.createResource)({
    type: (0, $edca60a3af8f4bf8$export$8bc44dee8c6d28f),
    getKey: ()=>'state',
    getDataLoader: $684d3b239b1e0d5f$var$getDataLoader,
    maxAge: Infinity
});
const $684d3b239b1e0d5f$export$2bd0d3b374549a68 = ()=>(0, $eJrcF.useResource)($684d3b239b1e0d5f$export$f6c05eaea53ab4ae);

});
const $edca60a3af8f4bf8$export$8bc44dee8c6d28f = 'RESOURCE_TYPE_PROJECT_PERMISSIONS';

parcelRegister("40oPd", function(module, exports) {

let $2eaa6b4270bfa916$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2eaa6b4270bfa916$var$load("aZk2z").then(()=>parcelRequire('jRDDZ'));

});


parcelRegister("1G20J", function(module, exports) {

$parcel$export(module.exports, "projectThemeResource", () => $08721476ea54ea75$export$84730adce8987203);

var $5V48N = parcelRequire("5V48N");

var $bBtQo = parcelRequire("bBtQo");

var $9FYIg = parcelRequire("9FYIg");

var $8Mxto = parcelRequire("8Mxto");
const $08721476ea54ea75$export$84730adce8987203 = (0, $8Mxto.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'JIRA_PROJECT_THEME',
    getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const { cloudId: cloudId } = tenantContext;
        return {
            parameters: (0, $5V48N.default),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectKey ?? projectId ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}));

});
parcelRegister("5V48N", function(module, exports) {

$parcel$export(module.exports, "default", () => $d340f7d465945734$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a80e3120b80c99e5f371c683e47c1272>>
 * @relayHash 425f234e57bb5ee35d5bff67f4bb926f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 659f6d85a390f6f3ee8492f86debbfeaed75e90b37b222e25a49822daf422a5a

var $37Ewn = parcelRequire("37Ewn");
const $d340f7d465945734$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIdOrKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaClientId"
            },
            {
                "args": v2 /*: any*/ ,
                "kind": "ScalarField",
                "name": "mediaExternalEndpointUrl"
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "idOrKey",
            "variableName": "projectIdOrKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ThemeSetterQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v3 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ThemeSetterBackground"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ThemeSetterQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jira_projectByIdOrKey",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "background",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraActiveBackgroundDetailsResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorValue"
                                        }
                                    ],
                                    "type": "JiraColorBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "gradientValue"
                                        }
                                    ],
                                    "type": "JiraGradientBackground"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "JiraCustomBackground",
                                            "kind": "LinkedField",
                                            "name": "customBackground",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "mediaApiFileId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "durationInSeconds",
                                                            "value": 900
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "mediaReadToken",
                                                    "storageKey": "mediaReadToken(durationInSeconds:900)"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "sourceIdentifier"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "altText"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "dominantColor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "brightness"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraMediaBackground"
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "659f6d85a390f6f3ee8492f86debbfeaed75e90b37b222e25a49822daf422a5a",
            "metadata": {},
            "name": "ThemeSetterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d340f7d465945734$var$node.hash = "9864ab22015f44482ad59ad489f945e0";
(0, $37Ewn.PreloadableQueryRegistry).set($d340f7d465945734$var$node.params.id, $d340f7d465945734$var$node);
var $d340f7d465945734$export$2e2bcd8739ae039 = $d340f7d465945734$var$node;

});

parcelRegister("8Mxto", function(module, exports) {

$parcel$export(module.exports, "withGiraAggAnonSsrFix", () => $0eceed5dfd22dafd$export$f4b29e78f4c0a526);
const $0eceed5dfd22dafd$export$f4b29e78f4c0a526 = (resource)=>{
    if (!resource || !resource.getData) return resource;
    const originalGetData = resource.getData;
    // @ts-expect-error types in the relay resource don't allow null, but the react-resource-router types do
    // eslint-disable-next-line no-param-reassign
    resource.getData = (routerContext, customContext)=>{
        if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
        return originalGetData(routerContext, customContext);
    };
    return resource;
};

});



parcelRegister("bTfc4", function(module, exports) {

$parcel$export(module.exports, "incidentsInitialPageChecksResource", () => $36ca214696dd8d52$export$b2b94ce8ba590cc8);
$parcel$export(module.exports, "incidentsCustomFieldIdResource", () => $36ca214696dd8d52$export$e81d7afef87ae597);
$parcel$export(module.exports, "incidentExperimentTraitResource", () => $36ca214696dd8d52$export$31c6945718067be3);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3Only", () => $36ca214696dd8d52$export$6fc19cf1d90e9453);
$parcel$export(module.exports, "incidentExperimentTraitResourceOnNav3OnlyNonCriticalRoutes", () => $36ca214696dd8d52$export$2e6b9e6402ff1d9b);

var $7jTnu = parcelRequire("7jTnu");

var $6zXPf = parcelRequire("6zXPf");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");


const $36ca214696dd8d52$export$b2b94ce8ba590cc8 = (0, $l1VxS.createResource)({
    type: (0, $225391858474824e$export$9018fdf9116edd9b),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("kp2Yt"))
});

const $36ca214696dd8d52$export$e81d7afef87ae597 = (0, $l1VxS.createResource)({
    type: (0, $225391858474824e$export$508a7d8e5c6b1bf),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("lscoO"))
});

const $36ca214696dd8d52$export$31c6945718067be3 = (0, $l1VxS.createResource)({
    type: (0, $225391858474824e$export$1d954e05e596a51e),
    getKey: ()=>'incident_experiment_traits',
    getDataLoader: ()=>(parcelRequire("M1wlA")),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $36ca214696dd8d52$export$6fc19cf1d90e9453 = (0, $5L7qx.resourceWithCondition2)(()=>!((0, $6zXPf.getWillShowNav4)() && ((0, $7jTnu.fg)('perf-push-big-components-remove-incidents-resource') || (0, $7jTnu.fg)('perf-push-big-components-nav-remove-resources'))), $36ca214696dd8d52$export$31c6945718067be3);
const $36ca214696dd8d52$export$2e6b9e6402ff1d9b = (0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)(), $36ca214696dd8d52$export$31c6945718067be3);

});
const $225391858474824e$export$9018fdf9116edd9b = 'INCIDENTS_PAGE_INITIAL_CHECKS';
const $225391858474824e$export$508a7d8e5c6b1bf = 'INCIDENTS_PAGE_CUSTOM_FIELD_ID';
const $225391858474824e$export$1d954e05e596a51e = 'INCIDENT_EXPERIMENT_TRAITS';

parcelRegister("kp2Yt", function(module, exports) {

let $eda8731dabb473d9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $eda8731dabb473d9$var$load("3awDD").then(()=>parcelRequire('fsQkp'));

});

parcelRegister("lscoO", function(module, exports) {

let $f9e5d4b2b2c4fd29$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f9e5d4b2b2c4fd29$var$load("9jswB").then(()=>parcelRequire('5DyWZ'));

});

parcelRegister("M1wlA", function(module, exports) {

let $0905a9cb5e8fd45f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0905a9cb5e8fd45f$var$load("cBSfN").then(()=>parcelRequire('cbo1b'));

});


parcelRegister("4ZfeE", function(module, exports) {

$parcel$export(module.exports, "legacyAllReportsRoute", () => $b3e8d0f1340dc29e$export$549d32fceee24980);
const $b3e8d0f1340dc29e$export$549d32fceee24980 = {
    name: 'legacy-all-reports',
    path: '/projects/:projectKey',
    query: [
        'selectedItem=(.*report-page.*)'
    ]
};

});

parcelRegister("9n5I0", function(module, exports) {

$parcel$export(module.exports, "jiraHorizontalNavEntrypoint", () => $c3ab5ab6b7a191f3$export$e9ee9fa1097f370e);
/* eslint-disable eslint-comments/no-restricted-disable */ /* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */ 
var $2kG4d = parcelRequire("2kG4d");

var $hu2rE = parcelRequire("hu2rE");

var $3Bzqe = parcelRequire("3Bzqe");

var $3osLr = parcelRequire("3osLr");

var $bBtQo = parcelRequire("bBtQo");

var $7Bvm5 = parcelRequire("7Bvm5");

var $7jTnu = parcelRequire("7jTnu");

const $c3ab5ab6b7a191f3$export$e9ee9fa1097f370e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $hu2rE.JSResourceForUserVisible)(()=>(parcelRequire("gIdMI")), {
        moduleId: "99477251",
        moduleName: "HorizontalNavJiraInner",
        priority: "userVisible",
        entryFsSsrLiftImportToModule: true
    }),
    getPreloadProps: ({ context: { match: match, query: query }, tenantContext: { cloudId: cloudId } })=>{
        let boardId = match.params.boardId;
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectId || projectKey;
        const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
        if (!boardId && (0, $7jTnu.fg)('blu-7733-jracloud-94629-connect-tab')) {
            // If there is no boardId in the URL then we should check to see if it is provided as part of
            // the Connect app rapidView query param. This has been added to address JRACLOUD-94629
            const rapidViewBoard = query.rapidView ? query.rapidView : null;
            boardId = rapidViewBoard || boardId || null;
        }
        const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
        const projectAri = projectId ? (0, $3osLr.JiraProjectAri).create({
            siteId: cloudId,
            projectId: projectId
        }).toString() : '';
        let containerNavigationInput;
        if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
            scopeId: boardAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        else containerNavigationInput = boardAri || projectAri ? {
            scopeId: boardAri || projectAri
        } : {
            projectKeyQuery: {
                cloudId: cloudId,
                projectKey: projectKey
            }
        };
        return {
            queries: {
                horizontalNavQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $2kG4d.default,
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        withProject: Boolean(projectIdOrKey),
                        boardId: boardAri,
                        withBoard: Boolean(boardAri),
                        containerNavigationInput: containerNavigationInput,
                        isTMPBoardRoute: isTMPBoardRoute,
                        first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
                    }
                }
            }
        };
    }
});

});
parcelRegister("2kG4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2342b8045233cc3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ae538bacb39ab4534d4304145457c84e>>
 * @relayHash b0a0aac4362607ae76157f20c62d3339
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d72593b5f67e0089ca9ffc1dfe207010cb82537555975edffe23c4665e01370

var $7KZsS = parcelRequire("7KZsS");

var $5OxM8 = parcelRequire("5OxM8");

var $gpGBt = parcelRequire("gpGBt");

var $811y8 = parcelRequire("811y8");
const $a2342b8045233cc3$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "6d72593b5f67e0089ca9ffc1dfe207010cb82537555975edffe23c4665e01370",
        "metadata": {},
        "name": "HorizontalNavJiraInnerQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $7KZsS.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $811y8.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $gpGBt.default),
            "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider": (0, $5OxM8.default)
        }
    }
};
var $a2342b8045233cc3$export$2e2bcd8739ae039 = $a2342b8045233cc3$var$node;

});
parcelRegister("7KZsS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80c26e7829d9791$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $d80c26e7829d9791$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('jira_custom_templates_ux');
    }
};

});

parcelRegister("5OxM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd552d5fa5c47576$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $dd552d5fa5c47576$var$ShouldFetchAccessLevelRelayProvider = {
    get () {
        return (0, $7jTnu.fg)('jira_fetch_accesslevel_for_nav4_share_button');
    }
};
var $dd552d5fa5c47576$export$2e2bcd8739ae039 = $dd552d5fa5c47576$var$ShouldFetchAccessLevelRelayProvider;

});

parcelRegister("gpGBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $12dde8e7615a22fe$export$2e2bcd8739ae039);

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");
const $12dde8e7615a22fe$var$JiraTeamButtonTeamCountRelayProvider = {
    get () {
        return !(0, $7jTnu.fg)('team-bi-directional-container-connection-gate') || !(0, $epTsa.expVal)('team-bi-directional-container-connection', 'isEnabled', false);
    }
};
var $12dde8e7615a22fe$export$2e2bcd8739ae039 = $12dde8e7615a22fe$var$JiraTeamButtonTeamCountRelayProvider;

});

parcelRegister("811y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da679e99462d392$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
const $4da679e99462d392$var$JiraTeamButtonRelayProvider = {
    get () {
        return(// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $7jTnu.fg)('team-connection-visibility-in-jira'));
    }
};
var $4da679e99462d392$export$2e2bcd8739ae039 = $4da679e99462d392$var$JiraTeamButtonRelayProvider;

});


parcelRegister("gIdMI", function(module, exports) {

let $c2ab72bd17b8e06b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c2ab72bd17b8e06b$var$load("kNFvF"),
    $c2ab72bd17b8e06b$var$load("ffQaD"),
    $c2ab72bd17b8e06b$var$load("kvRbA"),
    $c2ab72bd17b8e06b$var$load("76n7a"),
    $c2ab72bd17b8e06b$var$load("l253H"),
    $c2ab72bd17b8e06b$var$load("kVX56"),
    $c2ab72bd17b8e06b$var$load("2W1LT")
]).then(()=>parcelRequire('5Uorw'));

});


parcelRegister("eMJ38", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $e31af9be758224f0$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $e31af9be758224f0$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $e31af9be758224f0$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});
parcelRegister("ho3Tv", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJSWReportsResource", () => $cc95b3bd57d16e20$export$5910307042ab3f6f);

var $2at4v = parcelRequire("2at4v");

var $l1VxS = parcelRequire("l1VxS");

var $9kIEH = parcelRequire("9kIEH");
const $cc95b3bd57d16e20$export$5910307042ab3f6f = (0, $l1VxS.createResource)({
    type: 'JIRA_SOFTWARE_REPORTS',
    getKey: ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        return boardId ? `board-${boardId}` : 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const boardId = (0, $2at4v.getBoardId)(match, query);
        if (boardId == null) return null;
        const response = await (0, $9kIEH.fetchJSWReports)(boardId);
        return response?.reports;
    },
    maxAge: 300000
});

});
parcelRegister("9kIEH", function(module, exports) {

$parcel$export(module.exports, "fetchJSWReports", () => $0b71b3b31d605b16$export$a93a577d6971da2c);

var $jGzN3 = parcelRequire("jGzN3");
const $0b71b3b31d605b16$export$a93a577d6971da2c = (boardId)=>{
    if (boardId == null) throw new Error('invalid boardId');
    return (0, $jGzN3.performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
};

});


parcelRegister("hlh4g", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $a69e62c33f4a6228$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $a69e62c33f4a6228$export$e9adc6103e9ed514);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $a69e62c33f4a6228$export$96cb0eae1b3413f4 = (0, $l1VxS.createResource)({
    type: (0, $271f8eaa42077abf$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("8mJ0F")),
    maxAge: 60000
});
const $a69e62c33f4a6228$export$e9adc6103e9ed514 = ()=>(0, $eJrcF.useResource)($a69e62c33f4a6228$export$96cb0eae1b3413f4);

});
const $271f8eaa42077abf$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $271f8eaa42077abf$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $271f8eaa42077abf$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("8mJ0F", function(module, exports) {

let $61734acd63506ea4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $61734acd63506ea4$var$load("kaWHz").then(()=>parcelRequire('19vLN'));

});




parcelRegister("bDdfi", function(module, exports) {

$parcel$export(module.exports, "legacyBacklogRouteEntry", () => $fc2b1bedcd302f69$export$e64dbc2432a0bfba);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $6tSfI = parcelRequire("6tSfI");

var $84ki1 = parcelRequire("84ki1");

var $hS1gr = parcelRequire("hS1gr");
const $fc2b1bedcd302f69$export$e64dbc2432a0bfba = (0, $bAJhM.createLegacyEntry)((0, $84ki1.legacyBacklogRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $6tSfI.LegacyPage),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource)
        ]
    }));

});
parcelRegister("b4jBr", function(module, exports) {

$parcel$export(module.exports, "horizontalNavJiraResource", () => $0bd7097ca3e78874$export$faeb8c89315e20da);

var $9FYIg = parcelRequire("9FYIg");

var $byeh6 = parcelRequire("byeh6");

var $3osLr = parcelRequire("3osLr");

var $bBtQo = parcelRequire("bBtQo");

var $6zXPf = parcelRequire("6zXPf");

var $7Bvm5 = parcelRequire("7Bvm5");

var $5L7qx = parcelRequire("5L7qx");

var $hBje1 = parcelRequire("hBje1");
const $0bd7097ca3e78874$export$71eec30d9db46a56 = ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
    const boardId = match.params.boardId;
    let { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    projectKey = projectKey ?? '';
    projectId = projectId ?? '';
    const projectIdOrKey = projectId || projectKey;
    const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;
    const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';
    const projectAri = projectId ? (0, $3osLr.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    }).toString() : '';
    let containerNavigationInput;
    if (isTMPBoardRoute) containerNavigationInput = projectAri ? {
        scopeId: boardAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    else containerNavigationInput = boardAri || projectAri ? {
        scopeId: boardAri || projectAri
    } : {
        projectKeyQuery: {
            cloudId: cloudId,
            projectKey: projectKey
        }
    };
    return {
        options: {
            fetchPolicy: 'store-and-network'
        },
        parameters: (0, $byeh6.default),
        variables: {
            cloudId: cloudId,
            projectIdOrKey: projectIdOrKey,
            withProject: Boolean(projectIdOrKey),
            boardId: boardAri,
            withBoard: Boolean(boardAri),
            containerNavigationInput: containerNavigationInput,
            isTMPBoardRoute: isTMPBoardRoute,
            first: (0, $7Bvm5.NAVIGATION_ITEMS_PAGE_SIZE)
        }
    };
};
const $0bd7097ca3e78874$var$horizontalNavJiraResourceActual = (0, $hBje1.withGiraAggAnonSsrFix)((0, $9FYIg.createRelayResource)({
    type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
    getQuery: $0bd7097ca3e78874$export$71eec30d9db46a56
}));
const $0bd7097ca3e78874$export$faeb8c89315e20da = (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)(), $0bd7097ca3e78874$var$horizontalNavJiraResourceActual);

});
parcelRegister("byeh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $82bde2de23c60ccc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c05bba0c2ef443fbb9ec4977c40f7f4>>
 * @relayHash b0a0aac4362607ae76157f20c62d3339
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d72593b5f67e0089ca9ffc1dfe207010cb82537555975edffe23c4665e01370

var $7KZsS = parcelRequire("7KZsS");

var $5OxM8 = parcelRequire("5OxM8");

var $gpGBt = parcelRequire("gpGBt");

var $811y8 = parcelRequire("811y8");

var $37Ewn = parcelRequire("37Ewn");
const $82bde2de23c60ccc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerNavigationInput"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTMPBoardRoute"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIdOrKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withBoard"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "withProject"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = {
        "kind": "ScalarField",
        "name": "label"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v14 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "message"
        },
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "canEdit"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "boardId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "name"
    }, v21 = {
        "kind": "ScalarField",
        "name": "boardType"
    }, v22 = {
        "concreteType": "JiraFavouriteValue",
        "kind": "LinkedField",
        "name": "favouriteValue",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContent"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "JiraHorizontalNavigationContentOld"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "HorizontalNavJiraInnerQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "input",
                                    "variableName": "containerNavigationInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "containerNavigation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraContainerNavigationResult"
                                },
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeId"
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "first",
                                                    "variableName": "first"
                                                }
                                            ],
                                            "concreteType": "JiraNavigationItemConnection",
                                            "kind": "LinkedField",
                                            "name": "navigationItems",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNavigationItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isDefault"
                                                                },
                                                                v10 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                },
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraNavigationItem"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canRemove"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "canSetAsDefault"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "appId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAppSection",
                                                                            "kind": "LinkedField",
                                                                            "name": "sections",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "links",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v10 /*: any*/ ,
                                                                                        v11 /*: any*/ ,
                                                                                        v12 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "envLabel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ],
                                                                            "type": "JiraNavigationItem",
                                                                            "abstractKey": "__isJiraNavigationItem"
                                                                        }
                                                                    ],
                                                                    "type": "JiraAppNavigationItem"
                                                                },
                                                                v14 /*: any*/ 
                                                            ]
                                                        },
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v15 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopeUrl"
                                        }
                                    ],
                                    "type": "JiraContainerNavigation"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v15 /*: any*/ ,
                                    "type": "QueryError"
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                v18 /*: any*/ 
                            ],
                            "concreteType": "JiraWorkManagementLicensing",
                            "kind": "LinkedField",
                            "name": "jwmLicensing",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "currentUserSeatEdition"
                                }
                            ]
                        },
                        {
                            "condition": "withBoard",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "boardId"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraBoard",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ],
                                            "type": "JiraBoard"
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "withProject",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectIdOrKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "projectType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                },
                                {
                                    "concreteType": "JiraAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "large"
                                        }
                                    ]
                                },
                                {
                                    "alias": "canEditProjectConfig",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "EDIT_PROJECT_CONFIG"
                                        }
                                    ],
                                    "concreteType": "JiraProjectAction",
                                    "kind": "LinkedField",
                                    "name": "action",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canPerform"
                                        }
                                    ],
                                    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                },
                                v20 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "projectStyle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "softwareBoardCount"
                                },
                                v9 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "teamsConnected",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "accessLevel"
                                        }
                                    ]
                                },
                                {
                                    "condition": "isTMPBoardRoute",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "alias": "projectKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "mostRecentlyViewedBoard",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "JiraBoard"
                                                },
                                                v17 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLiveTemplate"
                                        }
                                    ]
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6d72593b5f67e0089ca9ffc1dfe207010cb82537555975edffe23c4665e01370",
            "metadata": {},
            "name": "HorizontalNavJiraInnerQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": (0, $7KZsS.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": (0, $811y8.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": (0, $gpGBt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider": (0, $5OxM8.default)
            }
        }
    };
}();
$82bde2de23c60ccc$var$node.hash = "1202c52be78d2663e71063591f5f6fb5";
(0, $37Ewn.PreloadableQueryRegistry).set($82bde2de23c60ccc$var$node.params.id, $82bde2de23c60ccc$var$node);
var $82bde2de23c60ccc$export$2e2bcd8739ae039 = $82bde2de23c60ccc$var$node;

});


parcelRegister("84ki1", function(module, exports) {

$parcel$export(module.exports, "legacyBacklogRoute", () => $0d386d376d49efa3$export$c51fda014ab27b5d);
const $0d386d376d49efa3$export$c51fda014ab27b5d = {
    name: 'legacy-backlog',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=(.*planning.*)'
    ]
};

});

parcelRegister("hS1gr", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalNavJira", () => $b3848baadec66a18$export$ea83697d960a1a23);

var $eJOHy = parcelRequire("eJOHy");

var $bQWwW = parcelRequire("bQWwW");

var $6zXPf = parcelRequire("6zXPf");

var $f2JN3 = parcelRequire("f2JN3");

var $iX5t3 = parcelRequire("iX5t3");

var $gYW18 = parcelRequire("gYW18");

var $ch9En = parcelRequire("ch9En");

const $b3848baadec66a18$var$LazyHorizontalNavJira = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("lt4sE")).then((HorizontalNavJira)=>HorizontalNavJira), {
    moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jira/src/ui/HorizontalNavJira.tsx"
});
const $b3848baadec66a18$var$AsyncHorizontalNav = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-nav-jira",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iX5t3.HorizontalNavSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b3848baadec66a18$var$LazyHorizontalNavJira, null));
const $b3848baadec66a18$export$ea83697d960a1a23 = (0, $f2JN3.componentWithCondition)(()=>(0, $6zXPf.getWillShowNav4)(), $b3848baadec66a18$var$AsyncHorizontalNav, (0, $gYW18.AsyncHorizontalProjectNav));

});
parcelRegister("iX5t3", function(module, exports) {

$parcel$export(module.exports, "TabsSkeleton", () => $9a24d46adbe633a2$export$807fef2beb9debc2);
$parcel$export(module.exports, "HorizontalNavSkeleton", () => $9a24d46adbe633a2$export$e29d51df5420bf39);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");
const $9a24d46adbe633a2$export$807fef2beb9debc2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            $9a24d46adbe633a2$var$tabsWrapperSkeletonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$tabSkeletonStyles
    }));
const $9a24d46adbe633a2$export$e29d51df5420bf39 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050",
        alignBlock: "end",
        xcss: $9a24d46adbe633a2$var$horizontalNavWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$breadcrumbStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        spread: "space-between",
        xcss: $9a24d46adbe633a2$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $9a24d46adbe633a2$var$primaryContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$projectTitleStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.150",
        xcss: $9a24d46adbe633a2$var$actionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $9a24d46adbe633a2$var$baseSkeletonStyles,
            $9a24d46adbe633a2$var$squareStyles
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a24d46adbe633a2$export$807fef2beb9debc2, null));
const $9a24d46adbe633a2$var$tabsWrapperSkeletonStyles = (0, $1DXK0.xcss)({
    gap: 'space.150',
    height: '32px',
    paddingInlineStart: 'space.300',
    paddingInlineEnd: 'space.300',
    paddingBlockEnd: 'space.150',
    marginBlockStart: 'space.100',
    position: 'relative',
    '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'color.skeleton',
        height: '2px',
        left: '0',
        right: '0'
    }
});
const $9a24d46adbe633a2$var$tabSkeletonStyles = (0, $1DXK0.xcss)({
    minWidth: "var(--ds-space-1000, 80px)",
    backgroundColor: 'color.skeleton',
    borderRadius: "var(--ds-border-radius, 4px)"
});
const $9a24d46adbe633a2$var$horizontalNavWrapperStyles = (0, $1DXK0.xcss)({
    paddingBlockStart: 'space.150',
    blockSize: '104px'
});
const $9a24d46adbe633a2$var$baseSkeletonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius'
});
const $9a24d46adbe633a2$var$breadcrumbStyles = (0, $1DXK0.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '60px',
    marginInlineStart: 'space.300',
    marginBlockEnd: 'space.025'
});
const $9a24d46adbe633a2$var$primaryContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    gap: 'space.100',
    marginInlineStart: 'space.300'
});
const $9a24d46adbe633a2$var$squareStyles = (0, $1DXK0.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: "var(--ds-space-300, 24px)"
});
const $9a24d46adbe633a2$var$headerWrapperStyles = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.050'
});
const $9a24d46adbe633a2$var$projectTitleStyles = (0, $1DXK0.xcss)({
    blockSize: "var(--ds-space-300, 24px)",
    inlineSize: '180px'
});
const $9a24d46adbe633a2$var$actionStyles = (0, $1DXK0.xcss)({
    marginInlineEnd: 'space.300'
});

});

parcelRegister("gYW18", function(module, exports) {

$parcel$export(module.exports, "AsyncHorizontalProjectNav", () => $31220cfbb4b000f2$export$862dd1c0126bb181);
$parcel$export(module.exports, "AsyncHorizontalOverviewNav", () => $31220cfbb4b000f2$export$beabdf5c49f01377);
/* eslint-disable jira/import/webpack-magic-comment-entries */ 
var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

const $31220cfbb4b000f2$var$LazyHorizontalProjectNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("XAdAI")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
});
const $31220cfbb4b000f2$export$862dd1c0126bb181 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-project-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31220cfbb4b000f2$var$LazyHorizontalProjectNav, null));

const $31220cfbb4b000f2$var$LazyHorizontalOverviewNav = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("7tAGN")), {
    moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
});
const $31220cfbb4b000f2$export$beabdf5c49f01377 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "horizontal-overview-nav",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31220cfbb4b000f2$var$LazyHorizontalOverviewNav, null));

});
parcelRegister("XAdAI", function(module, exports) {

let $0b319afc3052ba1f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $0b319afc3052ba1f$var$load("7mIf9"),
    $0b319afc3052ba1f$var$load("jXweD"),
    $0b319afc3052ba1f$var$load("kNFvF"),
    $0b319afc3052ba1f$var$load("ffQaD"),
    $0b319afc3052ba1f$var$load("kvRbA"),
    $0b319afc3052ba1f$var$load("kVX56"),
    $0b319afc3052ba1f$var$load("76n7a"),
    $0b319afc3052ba1f$var$load("l253H"),
    $0b319afc3052ba1f$var$load("4lKdZ")
]).then(()=>parcelRequire('bId22'));

});

parcelRegister("7tAGN", function(module, exports) {

let $5717b38a4bbfac90$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5717b38a4bbfac90$var$load("kNFvF"),
    $5717b38a4bbfac90$var$load("76n7a"),
    $5717b38a4bbfac90$var$load("l253H"),
    $5717b38a4bbfac90$var$load("ffQaD"),
    $5717b38a4bbfac90$var$load("kvRbA"),
    $5717b38a4bbfac90$var$load("kVX56"),
    $5717b38a4bbfac90$var$load("aaqI6")
]).then(()=>parcelRequire('l3jRL'));

});


parcelRegister("lt4sE", function(module, exports) {

let $fa0fc446901f4de9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $fa0fc446901f4de9$var$load("kNFvF"),
    $fa0fc446901f4de9$var$load("ffQaD"),
    $fa0fc446901f4de9$var$load("kvRbA"),
    $fa0fc446901f4de9$var$load("76n7a"),
    $fa0fc446901f4de9$var$load("l253H"),
    $fa0fc446901f4de9$var$load("kVX56"),
    $fa0fc446901f4de9$var$load("iG8Rc")
]).then(()=>parcelRequire('3nLhB'));

});



parcelRegister("3aSjH", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRapidViewRouteEntry", () => $7f4347798dd2ee99$export$36cfd1ed8d73fe4e);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $6tSfI = parcelRequire("6tSfI");

var $hjP2E = parcelRequire("hjP2E");

var $hS1gr = parcelRequire("hS1gr");
const $7f4347798dd2ee99$export$36cfd1ed8d73fe4e = (0, $bAJhM.createLegacyEntry)((0, $hjP2E.legacyBoardRapidViewRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $6tSfI.LegacyPage),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource)
        ]
    }));

});
parcelRegister("hjP2E", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRapidViewRoute", () => $005dd31ac1375ea8$export$4c8472ef2f57845f);
const $005dd31ac1375ea8$export$4c8472ef2f57845f = {
    name: 'legacy-board',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView'
    ]
};

});


parcelRegister("2Sujg", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRouteEntry", () => $dd970decdf4c1c00$export$e3d172b0d9fd0d47);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $6tSfI = parcelRequire("6tSfI");

var $bRZMl = parcelRequire("bRZMl");

var $hS1gr = parcelRequire("hS1gr");
const $dd970decdf4c1c00$export$e3d172b0d9fd0d47 = (0, $bAJhM.createLegacyEntry)((0, $bRZMl.legacyBoardRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars),
            horizontal: (0, $hS1gr.AsyncHorizontalNavJira),
            onlyShowHorizontalOnNav4: true
        },
        component: (0, $6tSfI.LegacyPage),
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource)
        ]
    }));

});
parcelRegister("bRZMl", function(module, exports) {

$parcel$export(module.exports, "legacyBoardRoute", () => $805983e8fd109c7d$export$9259d0f05fc27139);
const $805983e8fd109c7d$export$9259d0f05fc27139 = {
    name: 'legacy-board',
    path: '/secure/RapidBoard.jspa'
};

});


parcelRegister("392g2", function(module, exports) {

$parcel$export(module.exports, "legacyConnectGeneralRouteEntry", () => $353036428ab7e53e$export$5f816cf76ff922b8);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $6dwgv = parcelRequire("6dwgv");

var $7FIkD = parcelRequire("7FIkD");

var $4VIcO = parcelRequire("4VIcO");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $i1Oqz = parcelRequire("i1Oqz");
const $353036428ab7e53e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $353036428ab7e53e$export$5f816cf76ff922b8 = (0, $bAJhM.createLegacyEntry)((0, $i1Oqz.legacyConnectGeneralRoute), ()=>({
        layout: (0, $6dwgv.createLayout)(),
        navigation: {
            sidebar: (0, $aDtWM.genericConnectSidebars)
        },
        resources: [
            (0, $7FIkD.connectGeneralResources),
            (0, $enHI7.navigationSidebarGlobalResource),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$353036428ab7e53e$var$pageEntryPoint
    }));

});
parcelRegister("7FIkD", function(module, exports) {

$parcel$export(module.exports, "connectGeneralResources", () => $ac1e673dd620ded4$export$f34ab0d904621847);
$parcel$export(module.exports, "useConnectGeneralResource", () => $ac1e673dd620ded4$export$53479840ec6d4024);

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $ac1e673dd620ded4$export$f34ab0d904621847 = (0, $l1VxS.createResource)({
    type: (0, $ac8db659dabbf119$export$d5eed449bb62d4c1),
    getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
        // spa-router/src/common/types.js:
        /** TODO we are supporting `undefined` here because we are currently using both
		 * this version of the `Match` type, and react-routers version (which allows for `undefined`)
		 * To fix this we should move `matchPath` to our own util so we can apply our own types, then
		 * decide if we want to support undefined types.
		 */ if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("Jr3Mj"))
});
const $ac1e673dd620ded4$export$53479840ec6d4024 = ()=>(0, $eJrcF.useResource)($ac1e673dd620ded4$export$f34ab0d904621847);

});
const $ac8db659dabbf119$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';

parcelRegister("Jr3Mj", function(module, exports) {

let $0889319fdc0402dd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0889319fdc0402dd$var$load("1qduh").then(()=>parcelRequire('cu1Rj'));

});


parcelRegister("i1Oqz", function(module, exports) {

$parcel$export(module.exports, "legacyConnectGeneralRoute", () => $7169ec62237a14e0$export$837edad42702a8e5);
const $7169ec62237a14e0$export$837edad42702a8e5 = {
    name: 'legacy-connect-general',
    path: '/plugins/servlet/ac/:addonKey/:moduleKey'
};

});


parcelRegister("7j1iv", function(module, exports) {

$parcel$export(module.exports, "legacyConnectProjectRouteEntry", () => $3bd748ee9cae222e$export$c7f411b1904e5c2a);

var $9n5I0 = parcelRequire("9n5I0");

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $b41XS = parcelRequire("b41XS");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $1PvPk = parcelRequire("1PvPk");

var $bTfc4 = parcelRequire("bTfc4");

var $hNA6F = parcelRequire("hNA6F");
const $3bd748ee9cae222e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $3bd748ee9cae222e$export$c7f411b1904e5c2a = (0, $bAJhM.createLegacyEntry)((0, $hNA6F.legacyConnectProjectRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            (0, $b41XS.connectProjectResources),
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1PvPk.getServiceDeskSharedNavigationSingleResources)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$3bd748ee9cae222e$var$pageEntryPoint
    }));

});
parcelRegister("b41XS", function(module, exports) {

$parcel$export(module.exports, "connectProjectResources", () => $bbf230b3d3c324b1$export$7d2d082a4b91a6c7);
// eslint-disable-next-line jira/import-whitelist

var $fnx9L = parcelRequire("fnx9L");

var $9pJMP = parcelRequire("9pJMP");

var $l1VxS = parcelRequire("l1VxS");


const $bbf230b3d3c324b1$export$7d2d082a4b91a6c7 = (0, $l1VxS.createResource)({
    type: (0, $f71270049d49ef4d$export$da32d27651782c3),
    getKey: ({ query: query })=>{
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $fnx9L.transformUrlToAddonAndModuleKeys)(query);
        if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
        return 'state';
    },
    depends: [
        (0, $9pJMP.staticProjectSidebarNavigationResource).type
    ],
    getDataLoader: ()=>(parcelRequire("9qWQ3"))
});

});
parcelRegister("fnx9L", function(module, exports) {

$parcel$export(module.exports, "transformResponse", () => $c9fc058b98a5f055$export$3361e9be8093ddcc);
$parcel$export(module.exports, "extractContext", () => $c9fc058b98a5f055$export$efdbd45f3e77a161);
$parcel$export(module.exports, "transformQueryParams", () => $c9fc058b98a5f055$export$9e3c3f47fc3ab3d0);
$parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", () => $c9fc058b98a5f055$export$752ef5ab3d7ab15f);

var $eSnSE = parcelRequire("eSnSE");

var $aEyM4 = parcelRequire("aEyM4");

var $6zXPf = parcelRequire("6zXPf");

var $imXGf = parcelRequire("imXGf");
const $c9fc058b98a5f055$export$3361e9be8093ddcc = (response)=>{
    try {
        const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
        let structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
        structuredContext = {
            ...structuredContext,
            jira: {
                ...structuredContext.jira,
                horizontalNavigation: (0, $6zXPf.getWillShowNav4)()
            }
        };
        const context = {
            productContext: productContext,
            structuredContext: structuredContext,
            productCtx: productContext
        };
        return {
            ...response,
            ...context,
            isFullPage: response.general === '1',
            user: {
                timeZone: response.timeZone,
                uid: response.uid || undefined,
                ukey: response.ukey || undefined,
                fullName: response.fullName || undefined
            },
            targets: {
                env: {
                    resize: 'both'
                }
            },
            history: {
                state: ''
            },
            autoresize: true,
            ns: response.uniqueKey,
            containerId: `embedded-${response.uniqueKey}`,
            contextPath: response.cp,
            width: response.w || response.width,
            height: response.h || response.height
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const location = 'connect-iframe.transformer';
        (0, $eSnSE.default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
        return {
            autoresize: true,
            productCtx: undefined,
            structuredContext: undefined,
            isFullPage: true,
            history: {
                state: ''
            },
            targets: {
                env: {
                    resize: 'both'
                }
            }
        };
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c9fc058b98a5f055$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
    const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
    return newValue !== null ? {
        [newName]: newValue
    } : null;
};
const $c9fc058b98a5f055$export$1f8eea5a5a32169f = (contextData)=>{
    const scope = contextData && contextData.scope || null;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const project = contextData && contextData.project || null;
    const projectId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $c9fc058b98a5f055$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
    const boardId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $c9fc058b98a5f055$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
    const project = projectSidebarNavInfo && (0, $imXGf.extractData)(projectSidebarNavInfo) || null;
    const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, $aEyM4.extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
    const projectId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'id', 'project.id');
    const projectKey = $c9fc058b98a5f055$var$checkValueAndMapToNewName(project, 'key', 'project.key');
    const boardType = $c9fc058b98a5f055$var$checkValueAndMapToNewName(board, 'type', 'board.type');
    const boardId = $c9fc058b98a5f055$var$checkValueAndMapToNewName(board, 'id', 'board.id');
    return {
        ...projectId,
        ...projectKey,
        ...boardType,
        ...boardId
    };
};
const $c9fc058b98a5f055$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
    const context = $c9fc058b98a5f055$export$1f8eea5a5a32169f(contextData);
    return {
        ...query,
        ...context
    };
};
const $c9fc058b98a5f055$export$752ef5ab3d7ab15f = (query)=>{
    const { selectedItem: selectedItem } = query;
    let addonKey = '';
    let moduleKey = '';
    if (selectedItem) {
        const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
        [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
    }
    return {
        addonKey: addonKey,
        moduleKey: moduleKey
    };
};

});
parcelRegister("aEyM4", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $f0de9883562e19b9$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $f0de9883562e19b9$export$67db9e2d1b6ed865);
const $f0de9883562e19b9$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $f0de9883562e19b9$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


const $f71270049d49ef4d$export$da32d27651782c3 = 'CONNECT_PROJECT';

parcelRegister("9qWQ3", function(module, exports) {

let $6de42ee7a3fe2fd0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6de42ee7a3fe2fd0$var$load("kTkfd").then(()=>parcelRequire('e68Yk'));

});


parcelRegister("1PvPk", function(module, exports) {

$parcel$export(module.exports, "getServiceDeskNavigationResources", () => $bd8fec0596296dc8$export$bc0bd65e6da57c1f);
$parcel$export(module.exports, "getServiceDeskNavigationSingleResources", () => $bd8fec0596296dc8$export$41a9145ddbba28e5);
$parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", () => $bd8fec0596296dc8$export$2c543d6accc1eb9b);
$parcel$export(module.exports, "getServiceDeskSettingsResources", () => $bd8fec0596296dc8$export$7bb3c4a2f6b127fb);
$parcel$export(module.exports, "getServicedeskPageContextResources", () => $bd8fec0596296dc8$export$a8b852f03a310dc0);
$parcel$export(module.exports, "getQueuesResources", () => $bd8fec0596296dc8$export$70b97995f4d5ef9f);
$parcel$export(module.exports, "getIssueListSsrResource", () => $bd8fec0596296dc8$export$e1016cce62543991);
$parcel$export(module.exports, "getKnowledgeBaseResources", () => $bd8fec0596296dc8$export$ed87d3b71544c4ef);
$parcel$export(module.exports, "getInsightResources", () => $bd8fec0596296dc8$export$9e0cf1fab0581096);
$parcel$export(module.exports, "getQueueConfigResource", () => $bd8fec0596296dc8$export$5f7bcaa978a3e51);
$parcel$export(module.exports, "getQueueViewConfigResource", () => $bd8fec0596296dc8$export$54079077c6768752);

var $lopBx = parcelRequire("lopBx");

var $7jTnu = parcelRequire("7jTnu");

var $hHbzj = parcelRequire("hHbzj");

var $3qMzf = parcelRequire("3qMzf");

var $gq8OO = parcelRequire("gq8OO");

var $5FSZM = parcelRequire("5FSZM");

var $6zZVV = parcelRequire("6zZVV");

var $dHUNm = parcelRequire("dHUNm");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $6zXPf = parcelRequire("6zXPf");

var $85Ze9 = parcelRequire("85Ze9");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $cu1g7 = parcelRequire("cu1g7");

var $kgDPH = parcelRequire("kgDPH");

var $iWhpv = parcelRequire("iWhpv");

var $JHxCO = parcelRequire("JHxCO");

var $h60sh = parcelRequire("h60sh");

var $aGQ56 = parcelRequire("aGQ56");

var $aEWXS = parcelRequire("aEWXS");

var $arxGJ = parcelRequire("arxGJ");

var $g9kBK = parcelRequire("g9kBK");

var $bTfc4 = parcelRequire("bTfc4");

var $5L7qx = parcelRequire("5L7qx");

var $ePaI2 = parcelRequire("ePaI2");

var $27Owl = parcelRequire("27Owl");

var $alzbz = parcelRequire("alzbz");

var $c0h8V = parcelRequire("c0h8V");

var $fbgOh = parcelRequire("fbgOh");

var $lzT4f = parcelRequire("lzT4f");
const $bd8fec0596296dc8$var$getQueueSidebarViewAllQueuesResource = ()=>(0, $5L7qx.resourceWithCondition2)(()=>!(0, $6zXPf.getWillShowNav4)() && (0, $7jTnu.fg)('migrate_queue_sidebar_all_queues_expansion_to_be'), (0, $aGQ56.queueSidebarViewAllQueuesResource));
const $bd8fec0596296dc8$export$bc0bd65e6da57c1f = ()=>[
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...$bd8fec0596296dc8$export$41a9145ddbba28e5()
    ];
const $bd8fec0596296dc8$export$41a9145ddbba28e5 = ()=>[
        // projectContextResource is a dependency to the priorityGroupsResource
        (0, $dZRaT.projectContextResource),
        $bd8fec0596296dc8$var$getQueueSidebarViewAllQueuesResource(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)(), (0, $aGQ56.queueNav4SidebarSelectionResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $6zXPf.getWillShowNav4)(), (0, $aGQ56.queueSidebarQueuesCategoryStateResource)),
        ...$bd8fec0596296dc8$export$9c1c5e389bd00e56(),
        ...$bd8fec0596296dc8$export$2c543d6accc1eb9b()
    ];
const $bd8fec0596296dc8$export$9c1c5e389bd00e56 = ()=>[
        (0, $aGQ56.priorityGroupByProjectIdResourceSsr),
        (0, $g9kBK.featuresResource),
        (0, $gq8OO.staticSidebarJsmReportsResource),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $4VIcO.getConsolidationStateResource)()),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $iWhpv.servicedeskIsItsmProjectResource)),
        (0, $aEWXS.nav3QueueGroupsStateResource)
    ];
const $bd8fec0596296dc8$export$2c543d6accc1eb9b = ()=>[
        (0, $aGQ56.queuesNavigationItems),
        (0, $h60sh.requiredProjectProperties),
        (0, $h60sh.requiredFrontendProperties),
        (0, $hHbzj.forgeServiceDeskQueueModuleResource),
        (0, $3qMzf.staticJSMProjectConnectAddonsNavigationResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        // for Getting Started menu item
        // resourceWithCondition2(isNav4ResourcesFixEnabled, requiredFrontendProperties),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $dZRaT.projectContextResourceWithCache)),
        (0, $5L7qx.resourceWithCondition2)((0, $6zXPf.getWillShowNav4), (0, $h60sh.firstProjectResource))
    ];
const $bd8fec0596296dc8$export$7bb3c4a2f6b127fb = ()=>[
        ...(0, $9NmsS.getNavigationResources)(),
        // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
        (0, $bTfc4.incidentExperimentTraitResource),
        (0, $dZRaT.projectContextResource),
        (0, $hHbzj.forgeProjectModuleResource),
        (0, $5ddA0.staticSidebarShortcutsResource),
        (0, $9pJMP.staticProjectSidebarNavigationResource),
        (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
        // end of resources expanded from getNavigationSidebarProjectResource
        ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
        (0, $JHxCO.servicedeskPracticesResource),
        (0, $kgDPH.serviceDeskContextResource),
        (0, $cu1g7.serviceDeskAnalyticsContextResource),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $lopBx.isFedRamp)(), (0, $arxGJ.virtualAgentOnboardingResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('fix_getting_started_panel_in_settings'), (0, $h60sh.firstProjectResource))
    ];
const $bd8fec0596296dc8$export$a8b852f03a310dc0 = ()=>[
        (0, $dZRaT.projectContextResourceWithCache),
        (0, $kgDPH.serviceDeskContextResource),
        (0, $cu1g7.serviceDeskAnalyticsContextResource),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementDisplayStateResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_gp_announcements_banner'), (0, $lzT4f.jsmGracePeriodAnnouncementGpEndDateResource))
    ];
const $bd8fec0596296dc8$export$70b97995f4d5ef9f = ()=>[
        ...$bd8fec0596296dc8$export$a8b852f03a310dc0(),
        ...$bd8fec0596296dc8$export$bc0bd65e6da57c1f(),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('corcap-2944-add-jqlbuilder-to-jsm-queues'), (0, $5FSZM.getCalendarFilterFieldsResource)())
    ];
const $bd8fec0596296dc8$export$e1016cce62543991 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('ssr_view_queues_issuelist'), (0, $aGQ56.issueListSsrResource))
    ];
const $bd8fec0596296dc8$export$ed87d3b71544c4ef = ()=>[
        (0, $85Ze9.kbConfluenceContextResource)
    ];
const $bd8fec0596296dc8$export$9e0cf1fab0581096 = ()=>[
        (0, $ePaI2.workspaceResource)
    ];
const $bd8fec0596296dc8$export$5f7bcaa978a3e51 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('jsm-views-inside-queues-fastfollow') && (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $aGQ56.priorityGroupByProjectIdResourceSsr)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dZRaT.projectContextResource))
    ];
const $bd8fec0596296dc8$export$54079077c6768752 = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('jsm-views-inside-queues-fastfollow') && (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $alzbz.getRapidBoardDataResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $fbgOh.getEditModelResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $27Owl.getBoardDetailsResource)()),
        (0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('jsm-views-inside-queues-fastfollow') && (0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $aGQ56.priorityGroupByProjectIdResourceSsr)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $dZRaT.projectContextResource)),
        (0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), (0, $c0h8V.uifBoardResource)),
        ...(0, $alzbz.getRapidboardResources)().map((resource)=>(0, $5L7qx.resourceWithCondition2)(()=>(0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag'), resource))
    ];

});
parcelRegister("gq8OO", function(module, exports) {

$parcel$export(module.exports, "staticSidebarJsmReportsResource", () => $e907d070057d33a1$export$ec28065a31cce4ce);

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $aGpYW = parcelRequire("aGpYW");
const $e907d070057d33a1$var$getIdentifier = (match, query)=>{
    const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
    return projectKey || projectId;
};
const $e907d070057d33a1$export$ec28065a31cce4ce = (0, $l1VxS.createResource)({
    type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
    getKey: ({ match: match, query: query })=>$e907d070057d33a1$var$getIdentifier(match, query) ?? 'none',
    getData: async ({ match: match, query: query })=>{
        const projectKeyOrId = $e907d070057d33a1$var$getIdentifier(match, query);
        if (projectKeyOrId == null) return null;
        return (0, $aGpYW.fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
    },
    maxAge: 300000
});

});
parcelRegister("aGpYW", function(module, exports) {

$parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", () => $2ca8e623397ccc3d$export$c1dd51127051647d);

var $jGzN3 = parcelRequire("jGzN3");
const $2ca8e623397ccc3d$export$c1dd51127051647d = (projectIdOrKey)=>{
    if (projectIdOrKey == null) throw new Error('invalid project id or key');
    return (0, $jGzN3.performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
};

});


parcelRegister("5FSZM", function(module, exports) {

$parcel$export(module.exports, "getCalendarFilterFieldsResource", () => $613ce22e40063fc2$export$5f02bf5f04197ed7);
$parcel$export(module.exports, "useCalendarFilterResource", () => $613ce22e40063fc2$export$70361b748d216408);

var $eJOHy = parcelRequire("eJOHy");

var $8KUFq = parcelRequire("8KUFq");

var $jGzN3 = parcelRequire("jGzN3");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $7jTnu = parcelRequire("7jTnu");

var $7OmKg = parcelRequire("7OmKg");


var $iPdm8 = parcelRequire("iPdm8");
const $613ce22e40063fc2$var$fetchFilterFieldsOld = async (cloudId, jqlContext)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $4632d48377e7873d$export$546e90157aa718d4),
                variables: {
                    cloudId: cloudId,
                    contextFieldsFilter: (0, $7jTnu.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue') ? {
                        jqlTerms: [
                            (0, $7OmKg.REQUEST_TYPE_FILTER),
                            (0, $7OmKg.SERVICE_DESK_ORIGIN_FILTER),
                            (0, $7OmKg.SERVICE_DESK_ORIGIN_DUPLICATE_FILTER)
                        ]
                    } : {
                        searchString: (0, $7OmKg.REQUEST_TYPE_FILTER)
                    },
                    jqlContext: jqlContext
                }
            }),
            headers: {
                'content-type': 'application/json',
                'X-ExperimentalApi': 'JiraJqlBuilder'
            }
        });
        return (0, $iPdm8.transformAndReport)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $8KUFq.isHttpClientErrorResponse)(error)) (0, $iPdm8.reportError)(error);
        return 0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $613ce22e40063fc2$var$fetchFilterFields = async (cloudId)=>{
    try {
        const requestTypeFieldResponse = await (0, $jGzN3.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $4632d48377e7873d$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        const requestTypeField = requestTypeFieldResponse.data?.jira?.requestTypeField;
        if (!requestTypeField) return 0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS;
        return [
            {
                ...requestTypeField,
                searchTemplate: requestTypeField.searchTemplate.key,
                fieldType: requestTypeField.type
            },
            ...(0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS)
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (!(0, $8KUFq.isHttpClientErrorResponse)(error)) (0, $iPdm8.reportError)(error);
        return 0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS;
    }
};
const $613ce22e40063fc2$var$filterFieldsResource = (0, $l1VxS.createResource)({
    type: (0, $7OmKg.RESOURCE_TYPE_FILTER_FIELD),
    getKey: ({ match: match, query: query })=>{
        if ((0, $7jTnu.fg)('jsm_views_inside_queues_-_main_flag')) {
            const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            return (0, $7OmKg.RESOURCE_TYPE_FILTER_FIELD) + projectIdOrKey;
        }
        return 0, $7OmKg.RESOURCE_TYPE_FILTER_FIELD;
    },
    getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $bBtQo.getProjectKeyId)(match, query);
        const projectIdOrKey = projectKey || projectId;
        const jqlContext = `project = '${projectIdOrKey}'`;
        return (0, $7jTnu.fg)('move_jsm_views_rt_filter_to_new_query') ? $613ce22e40063fc2$var$fetchFilterFields(cloudId) : $613ce22e40063fc2$var$fetchFilterFieldsOld(cloudId, jqlContext);
    },
    maxAge: Infinity
});
const $613ce22e40063fc2$export$5f02bf5f04197ed7 = ()=>$613ce22e40063fc2$var$filterFieldsResource;
const $613ce22e40063fc2$export$70361b748d216408 = ({ isSimplified: isSimplified })=>{
    const resource = (0, $eJrcF.useResource)($613ce22e40063fc2$var$filterFieldsResource);
    (0, $eJOHy.useEffect)(()=>{
        if (((0, $7jTnu.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue') || (0, $7jTnu.fg)('move_jsm_views_rt_filter_to_new_query')) && !isSimplified && !resource.loading && !resource.error && !resource.data?.find((field)=>typeof field === 'object' && Object.values(field).includes((0, $iPdm8.TARGET_FILTER_TYPE)))) (0, $iPdm8.reportError)(new Error('Unable to prefetch request type'));
    }, [
        isSimplified,
        resource.data,
        resource.error,
        resource.loading
    ]);
    return resource;
};

});
parcelRegister("7OmKg", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_NAME", () => $500296557fea2aa7$export$186e93e8ef3f9358);
$parcel$export(module.exports, "PACKAGE_NAME", () => $500296557fea2aa7$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $500296557fea2aa7$export$d57b6b390e78d90f);
$parcel$export(module.exports, "REQUEST_TYPE_FILTER", () => $500296557fea2aa7$export$2c388650eabddf5e);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_FILTER", () => $500296557fea2aa7$export$2fcf90614ee15858);
$parcel$export(module.exports, "SERVICE_DESK_ORIGIN_DUPLICATE_FILTER", () => $500296557fea2aa7$export$43482ff574598f59);
$parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", () => $500296557fea2aa7$export$2019de80301f1da);
$parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", () => $500296557fea2aa7$export$2912f30d4328fc00);
const $500296557fea2aa7$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
const $500296557fea2aa7$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
const $500296557fea2aa7$export$d57b6b390e78d90f = 'jsd-shield';
const $500296557fea2aa7$export$2c388650eabddf5e = 'request type';
const $500296557fea2aa7$export$2fcf90614ee15858 = 'service desk origin';
const $500296557fea2aa7$export$43482ff574598f59 = 'cf[10010]';
const $500296557fea2aa7$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
const $500296557fea2aa7$export$2912f30d4328fc00 = [
    'status',
    'assignee'
];

});

const $4632d48377e7873d$export$546e90157aa718d4 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
const $4632d48377e7873d$export$2b91517d6d5b4365 = `
query requestTypeFieldQuery($cloudId: ID!) {
  jira {
    requestTypeField(cloudId: $cloudId) {
      displayName
      jqlTerm
      operators
      searchTemplate {
        key
      }
      type
    }
  }
}
`;

parcelRegister("iPdm8", function(module, exports) {

$parcel$export(module.exports, "TARGET_FILTER_TYPE", () => $99c8aba5accb3f4b$export$64f54b13b7aea793);
$parcel$export(module.exports, "reportError", () => $99c8aba5accb3f4b$export$b33b857ad1d9900e);
$parcel$export(module.exports, "transformAndReport", () => $99c8aba5accb3f4b$export$af2aa11c88c551af);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $7OmKg = parcelRequire("7OmKg");
const $99c8aba5accb3f4b$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
const $99c8aba5accb3f4b$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
const $99c8aba5accb3f4b$export$b33b857ad1d9900e = (error)=>{
    (0, $gYnSx.default)({
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        meta: {
            id: (0, $7OmKg.RESOURCE_TYPE_NAME),
            packageName: (0, $7OmKg.PACKAGE_NAME),
            teamName: (0, $7OmKg.TEAM_NAME)
        }
    });
};
const $99c8aba5accb3f4b$export$af2aa11c88c551af = (response)=>{
    const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
    // There may be ambigious custom fields with same name, so find the correct one and pass to JQLBuilder
    const requestType = edges?.find((edge)=>edge?.node?.type === $99c8aba5accb3f4b$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $99c8aba5accb3f4b$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
    if (!requestType && !(0, $7jTnu.fg)('corcap-3439-support-sdorigin-jqlbuilder-queue')) $99c8aba5accb3f4b$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
    // if requestType field found, add it to existing default calendar filter fields
    return requestType ? [
        {
            ...requestType,
            searchTemplate: requestType.searchTemplate.key,
            fieldType: requestType.type
        },
        ...(0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS)
    ] : (0, $7OmKg.DEFAULT_CALENDAR_FILTER_FIELDS);
};

});


parcelRegister("85Ze9", function(module, exports) {

$parcel$export(module.exports, "kbConfluenceContextResource", () => $3ddbed7e0cde1711$export$8b58be1423986d17);

var $l1VxS = parcelRequire("l1VxS");


const $3ddbed7e0cde1711$var$getDataLoader = ()=>(parcelRequire("62tV0"));
const $3ddbed7e0cde1711$export$8b58be1423986d17 = (0, $l1VxS.createResource)({
    type: (0, $146576bfaf2f1c5a$export$54b5a0d1e8c78de6),
    getKey: ({ match: match })=>match.params.projectKey || '',
    getDataLoader: $3ddbed7e0cde1711$var$getDataLoader,
    maxAge: Infinity
});

});
const $146576bfaf2f1c5a$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';

parcelRegister("62tV0", function(module, exports) {

let $465a232fb5116658$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $465a232fb5116658$var$load("hj5jD").then(()=>parcelRequire('inoGB'));

});


parcelRegister("cu1g7", function(module, exports) {

$parcel$export(module.exports, "serviceDeskAnalyticsContextResource", () => $ad4e7c5cdb1bb62b$export$d6f4f0483916919f);
$parcel$export(module.exports, "useServiceDeskAnalyticsContext", () => $ad4e7c5cdb1bb62b$export$bc2de1c42df30b10);

var $eJOHy = parcelRequire("eJOHy");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $ad4e7c5cdb1bb62b$var$getDataLoader = ()=>(parcelRequire("bigFu"));
const $ad4e7c5cdb1bb62b$var$ONE_DAY_IN_MILLIS = 86400000;
const $ad4e7c5cdb1bb62b$export$d6f4f0483916919f = (0, $l1VxS.createResource)({
    type: (0, $72fb76455039ad7c$export$285b47583a5bdd0f),
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $ad4e7c5cdb1bb62b$var$getDataLoader,
    maxAge: $ad4e7c5cdb1bb62b$var$ONE_DAY_IN_MILLIS
});
const $ad4e7c5cdb1bb62b$export$bc2de1c42df30b10 = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $eJrcF.useResource)($ad4e7c5cdb1bb62b$export$d6f4f0483916919f);
    (0, $eJOHy.useEffect)(()=>{
        if (!data && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $72fb76455039ad7c$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';

parcelRegister("bigFu", function(module, exports) {

let $838e4e14ef20f0b4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $838e4e14ef20f0b4$var$load("kVX56"),
    $838e4e14ef20f0b4$var$load("d2yCb")
]).then(()=>parcelRequire('icgY0'));

});


parcelRegister("kgDPH", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $5ade9d115ab90445$export$5eaaf465969a9171);

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");


const $5ade9d115ab90445$var$getDataLoader = ()=>(parcelRequire("6GXhG"));
const $5ade9d115ab90445$export$5eaaf465969a9171 = (0, $l1VxS.createResource)({
    type: (0, $ae1f145ea4ba545a$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $fcQiO.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $5ade9d115ab90445$var$getDataLoader,
    maxAge: Infinity
});

});
const $ae1f145ea4ba545a$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("6GXhG", function(module, exports) {

let $4df4a6f153c11136$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4df4a6f153c11136$var$load("9VGhB").then(()=>parcelRequire('c0Tkr'));

});


parcelRegister("iWhpv", function(module, exports) {

$parcel$export(module.exports, "servicedeskIsItsmProjectResource", () => $20362448f0bcac55$export$920308cef4e291b1);
$parcel$export(module.exports, "useIsItsmTemplateProject", () => $20362448f0bcac55$export$7bb46948fb84f164);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");


const $20362448f0bcac55$var$getDataLoader = ()=>(parcelRequire("2SPmJ"));
const $20362448f0bcac55$var$ONE_DAY_IN_MILLIS = 86400000;
const $20362448f0bcac55$export$920308cef4e291b1 = (0, $l1VxS.createResource)({
    type: (0, $d87510ea5f50e0bd$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $20362448f0bcac55$var$getDataLoader,
    maxAge: $20362448f0bcac55$var$ONE_DAY_IN_MILLIS
});
const $20362448f0bcac55$export$7bb46948fb84f164 = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $bo7Z6.useResourceWithCustomRouterContext)($20362448f0bcac55$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined, {
        shouldPrefetch: true
    });
    return (0, $eJOHy.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});
const $d87510ea5f50e0bd$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("2SPmJ", function(module, exports) {

let $2198780bb1165e1c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2198780bb1165e1c$var$load("kVX56"),
    $2198780bb1165e1c$var$load("cEpbi")
]).then(()=>parcelRequire('bJETC'));

});


parcelRegister("JHxCO", function(module, exports) {

$parcel$export(module.exports, "servicedeskPracticesResource", () => $446148a1d016b5d1$export$2ae319305481e7de);
$parcel$export(module.exports, "useWorkCategoriesQueueSupported", () => $446148a1d016b5d1$export$a86ac771006f14b3);
$parcel$export(module.exports, "useWorkCategoriesAllSupported", () => $446148a1d016b5d1$export$fe081b1a59d3c818);
$parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", () => $446148a1d016b5d1$export$4d46346ef0bdc6b9);

var $eJOHy = parcelRequire("eJOHy");

var $fcQiO = parcelRequire("fcQiO");

var $jlJsl = parcelRequire("jlJsl");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");


const $446148a1d016b5d1$var$getDataLoader = ()=>(parcelRequire("4Yy10"));
const $446148a1d016b5d1$var$ONE_DAY_IN_MILLIS = 86400000;
const $446148a1d016b5d1$export$2ae319305481e7de = (0, $l1VxS.createResource)({
    type: (0, $6d5c2d68fdd6fc0f$export$45919c8f50bb1db5),
    getKey: ({ match: match })=>(0, $fcQiO.getProjectKeyOrId)(match),
    getDataLoader: $446148a1d016b5d1$var$getDataLoader,
    maxAge: $446148a1d016b5d1$var$ONE_DAY_IN_MILLIS
});
const $446148a1d016b5d1$var$queuesOrder = [
    ...(0, $jlJsl.WORK_CATEGORIES_QUEUE_SUPPORTED)
];
const $446148a1d016b5d1$var$workCategoryOrder = [
    ...$446148a1d016b5d1$var$queuesOrder,
    (0, $jlJsl.DEVELOPER_ESCALATION)
];
const $446148a1d016b5d1$var$transformItsmPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $446148a1d016b5d1$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $446148a1d016b5d1$var$transformServiceDeskPracticesList = (data)=>{
    if (!data?.practices) return null;
    return $446148a1d016b5d1$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
};
const $446148a1d016b5d1$export$a86ac771006f14b3 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $eJrcF.useResource)($446148a1d016b5d1$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eJOHy.useMemo)(()=>({
            data: $446148a1d016b5d1$var$transformItsmPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $446148a1d016b5d1$export$fe081b1a59d3c818 = ()=>{
    const { data: data, loading: loading, ...resource } = (0, $eJrcF.useResource)($446148a1d016b5d1$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    return (0, $eJOHy.useMemo)(()=>({
            data: $446148a1d016b5d1$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};
const $446148a1d016b5d1$export$4d46346ef0bdc6b9 = ()=>{
    const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $eJrcF.useResource)($446148a1d016b5d1$export$2ae319305481e7de);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = resource.error;
    (0, $eJOHy.useEffect)(()=>{
        if (!loading && !data && !error) refreshPractices();
    }, [
        data,
        error,
        loading,
        refreshPractices
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: $446148a1d016b5d1$var$transformServiceDeskPracticesList(data),
            loading: loading,
            error: error
        }), [
        data,
        error,
        loading
    ]);
};

});
parcelRegister("jlJsl", function(module, exports) {

$parcel$export(module.exports, "CHANGES", () => $4f1e5109a7f57422$export$8598196f74460271);
$parcel$export(module.exports, "INCIDENTS", () => $4f1e5109a7f57422$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "PROBLEMS", () => $4f1e5109a7f57422$export$ceba70db1edb1def);
$parcel$export(module.exports, "SERVICE_REQUEST", () => $4f1e5109a7f57422$export$3d1cda9bd50505e8);
$parcel$export(module.exports, "POST_INCIDENT_REVIEWS", () => $4f1e5109a7f57422$export$6ebf7b6bf1c580f);
$parcel$export(module.exports, "DEVELOPER_ESCALATION", () => $4f1e5109a7f57422$export$81e62964cc725098);
$parcel$export(module.exports, "NO_CATEGORY", () => $4f1e5109a7f57422$export$485b1216c42d8d4);
$parcel$export(module.exports, "NO_PRACTICE", () => $4f1e5109a7f57422$export$52bf3f16b7812704);
$parcel$export(module.exports, "SHORT_FORM_CHANGES", () => $4f1e5109a7f57422$export$a50185c8e9fb007e);
$parcel$export(module.exports, "SHORT_FORM_INCIDENTS", () => $4f1e5109a7f57422$export$a54a30a3c3cce634);
$parcel$export(module.exports, "SHORT_FORM_PROBLEMS", () => $4f1e5109a7f57422$export$354f3a4c6ac0c903);
$parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", () => $4f1e5109a7f57422$export$335d3ac0c367f03f);
$parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", () => $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f);
$parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", () => $4f1e5109a7f57422$export$cb41b99ca54e6bd);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", () => $4f1e5109a7f57422$export$a2b1f8f055150f02);
$parcel$export(module.exports, "ItsmPracticeToShortForm", () => $4f1e5109a7f57422$export$56c57f7ad650c45c);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP", () => $4f1e5109a7f57422$export$fbf0dfd01228e38d);
$parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", () => $4f1e5109a7f57422$export$45ba5f49e9509c4d);
$parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", () => $4f1e5109a7f57422$export$45952424a7f29b99);
$parcel$export(module.exports, "CHANGES_JQL_NAME", () => $4f1e5109a7f57422$export$6c24c440228eac9c);
$parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", () => $4f1e5109a7f57422$export$3f757c5e00588ffd);
$parcel$export(module.exports, "practiceKeyJqlNameMapping", () => $4f1e5109a7f57422$export$b78213db77524b5b);

var $kF1zg = parcelRequire("kF1zg");

var $ZfaX7 = parcelRequire("ZfaX7");
const $4f1e5109a7f57422$export$8598196f74460271 = 'change-management';
const $4f1e5109a7f57422$export$a50b49a533b5f7bc = 'incident-management';
const $4f1e5109a7f57422$export$ceba70db1edb1def = 'problem-management';
const $4f1e5109a7f57422$export$3d1cda9bd50505e8 = 'service-request';
const $4f1e5109a7f57422$export$6ebf7b6bf1c580f = 'post-incident-review';
const $4f1e5109a7f57422$export$81e62964cc725098 = 'developer-escalation';
const $4f1e5109a7f57422$export$485b1216c42d8d4 = 'no-category';
const $4f1e5109a7f57422$var$NO_CATEGORY_NEW = 'no-category-new';
const $4f1e5109a7f57422$export$52bf3f16b7812704 = 'no-practice'; // BERRY-1358 should consolidate into NO_CATEGORY
const $4f1e5109a7f57422$export$a50185c8e9fb007e = 'changes';
const $4f1e5109a7f57422$export$a54a30a3c3cce634 = 'incidents';
const $4f1e5109a7f57422$export$354f3a4c6ac0c903 = 'problems';
const $4f1e5109a7f57422$export$335d3ac0c367f03f = 'service-requests';
const $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
const $4f1e5109a7f57422$export$cb41b99ca54e6bd = 'developer-escalations';
const $4f1e5109a7f57422$export$a613d808168c7b25 = [
    $4f1e5109a7f57422$export$8598196f74460271,
    $4f1e5109a7f57422$export$a50b49a533b5f7bc,
    $4f1e5109a7f57422$export$ceba70db1edb1def,
    $4f1e5109a7f57422$export$3d1cda9bd50505e8,
    $4f1e5109a7f57422$export$6ebf7b6bf1c580f,
    $4f1e5109a7f57422$export$81e62964cc725098
]; // /!\ defines WorkCategoryApiResource type
const $4f1e5109a7f57422$export$a2b1f8f055150f02 = [
    $4f1e5109a7f57422$export$3d1cda9bd50505e8,
    $4f1e5109a7f57422$export$a50b49a533b5f7bc,
    $4f1e5109a7f57422$export$ceba70db1edb1def,
    $4f1e5109a7f57422$export$8598196f74460271,
    $4f1e5109a7f57422$export$6ebf7b6bf1c580f
]; // /!\ defines WorkCategoryQueueSupported type
const $4f1e5109a7f57422$export$5a9122a4028fb8ef = [
    ...$4f1e5109a7f57422$export$a2b1f8f055150f02,
    $4f1e5109a7f57422$export$485b1216c42d8d4
];
const $4f1e5109a7f57422$export$f1b813cd23817ade = [
    $4f1e5109a7f57422$export$a50185c8e9fb007e,
    $4f1e5109a7f57422$export$a54a30a3c3cce634,
    $4f1e5109a7f57422$export$354f3a4c6ac0c903,
    $4f1e5109a7f57422$export$335d3ac0c367f03f,
    $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f,
    $4f1e5109a7f57422$export$cb41b99ca54e6bd
]; // /!\ defines WorkCategoryShortForm type
const $4f1e5109a7f57422$export$56c57f7ad650c45c = {
    [$4f1e5109a7f57422$export$8598196f74460271]: $4f1e5109a7f57422$export$a50185c8e9fb007e,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: $4f1e5109a7f57422$export$a54a30a3c3cce634,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: $4f1e5109a7f57422$export$354f3a4c6ac0c903,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: $4f1e5109a7f57422$export$335d3ac0c367f03f,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: $4f1e5109a7f57422$export$7ffd7f2c2ae96b6f,
    [$4f1e5109a7f57422$export$485b1216c42d8d4]: $4f1e5109a7f57422$var$NO_CATEGORY_NEW
};
const $4f1e5109a7f57422$export$fbf0dfd01228e38d = {
    [$4f1e5109a7f57422$export$8598196f74460271]: (0, $ZfaX7.default).changes,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: (0, $ZfaX7.default).serviceRequests,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: (0, $ZfaX7.default).problems,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: (0, $ZfaX7.default).incidents,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: (0, $ZfaX7.default).postIncidentReviews,
    [$4f1e5109a7f57422$export$485b1216c42d8d4]: (0, $ZfaX7.default).queues,
    [$4f1e5109a7f57422$export$81e62964cc725098]: (0, $ZfaX7.default).developerEscalation,
    [$4f1e5109a7f57422$export$52bf3f16b7812704]: (0, $ZfaX7.default).noCategory
};
const $4f1e5109a7f57422$export$45ba5f49e9509c4d = {
    [$4f1e5109a7f57422$export$8598196f74460271]: (0, $ZfaX7.default).changesLower,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: (0, $ZfaX7.default).serviceRequestsLower,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: (0, $ZfaX7.default).problemsLower,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: (0, $ZfaX7.default).incidentsLower,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: (0, $ZfaX7.default).postIncidentReviewsLower,
    [$4f1e5109a7f57422$export$485b1216c42d8d4]: (0, $ZfaX7.default).queuesLower,
    [$4f1e5109a7f57422$export$81e62964cc725098]: (0, $ZfaX7.default).developerEscalationLower,
    [$4f1e5109a7f57422$export$52bf3f16b7812704]: (0, $ZfaX7.default).noCategoryLower
};
const $4f1e5109a7f57422$export$45952424a7f29b99 = (0, $kF1zg.getTypedKeys)($4f1e5109a7f57422$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
    // cannot type .indexOf() as not-string in Ts, therefore need to use .find(). And shows error if `key` in acc[key] being of wider type than the result (than ItsmPracticeCategory), therefore, need to use different keys in the `acc[queueKey] =` line
    const queueKey = $4f1e5109a7f57422$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
    if (queueKey) acc[queueKey] = $4f1e5109a7f57422$export$fbf0dfd01228e38d[labelMapKey];
    return acc;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
}, {});
const $4f1e5109a7f57422$export$6c24c440228eac9c = 'Changes';
const $4f1e5109a7f57422$export$5b65d27ec2d28d18 = 'Incidents';
const $4f1e5109a7f57422$var$PROBLEMS_JQL_NAME = 'Problems';
const $4f1e5109a7f57422$var$SERVICE_REQUEST_JQL_NAME = 'Service requests';
const $4f1e5109a7f57422$var$POST_INCIDENT_REVIEWS_JQL_NAME = 'Post-incident reviews';
const $4f1e5109a7f57422$export$3f757c5e00588ffd = 'Developer escalation';
const $4f1e5109a7f57422$export$b78213db77524b5b = {
    [$4f1e5109a7f57422$export$8598196f74460271]: $4f1e5109a7f57422$export$6c24c440228eac9c,
    [$4f1e5109a7f57422$export$a50b49a533b5f7bc]: $4f1e5109a7f57422$export$5b65d27ec2d28d18,
    [$4f1e5109a7f57422$export$ceba70db1edb1def]: $4f1e5109a7f57422$var$PROBLEMS_JQL_NAME,
    [$4f1e5109a7f57422$export$3d1cda9bd50505e8]: $4f1e5109a7f57422$var$SERVICE_REQUEST_JQL_NAME,
    [$4f1e5109a7f57422$export$6ebf7b6bf1c580f]: $4f1e5109a7f57422$var$POST_INCIDENT_REVIEWS_JQL_NAME,
    [$4f1e5109a7f57422$export$81e62964cc725098]: $4f1e5109a7f57422$export$3f757c5e00588ffd
};

});
parcelRegister("kF1zg", function(module, exports) {

$parcel$export(module.exports, "hasProp", () => $0d70700b8179d491$export$dd642ef726dcde21);
$parcel$export(module.exports, "getTypedKeys", () => $0d70700b8179d491$export$5206d47972fefe20);
/**
 * Use to remove `TS2339: Property 'id' does not exist on type 'object'` errors, e.g. when checking/refining variable of `unknown' type
 */ const $0d70700b8179d491$export$dd642ef726dcde21 = (data, prop)=>prop in data;
const $0d70700b8179d491$export$5206d47972fefe20 = (obj)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(obj);
};

});

parcelRegister("ZfaX7", function(module, exports) {

$parcel$export(module.exports, "default", () => $255bf593eeb7a55c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $255bf593eeb7a55c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    queues: {
        "id": "work-category.common.queues",
        "defaultMessage": "Queues"
    },
    serviceRequests: {
        "id": "work-category.common.service-requests",
        "defaultMessage": "Service requests"
    },
    incidents: {
        "id": "work-category.common.incidents",
        "defaultMessage": "Incidents"
    },
    changes: {
        "id": "work-category.common.changes",
        "defaultMessage": "Changes"
    },
    problems: {
        "id": "work-category.common.problems",
        "defaultMessage": "Problems"
    },
    postIncidentReviews: {
        "id": "work-category.common.post-incident-reviews",
        "defaultMessage": "Post-incident reviews"
    },
    noCategory: {
        "id": "work-category.common.no-category",
        "defaultMessage": "General"
    },
    queuesLower: {
        "id": "work-category.common.queues-lower",
        "defaultMessage": "queues"
    },
    serviceRequestsLower: {
        "id": "work-category.common.service-requests-lower",
        "defaultMessage": "service requests"
    },
    incidentsLower: {
        "id": "work-category.common.incidents-lower",
        "defaultMessage": "incidents"
    },
    changesLower: {
        "id": "work-category.common.changes-lower",
        "defaultMessage": "changes"
    },
    problemsLower: {
        "id": "work-category.common.problems-lower",
        "defaultMessage": "problems"
    },
    postIncidentReviewsLower: {
        "id": "work-category.common.post-incident-reviews-lower",
        "defaultMessage": "post-incident reviews"
    },
    noCategoryLower: {
        "id": "work-category.common.no-category-lower",
        "defaultMessage": "general"
    },
    developerEscalation: {
        "id": "work-category.common.developer-escalation",
        "defaultMessage": "Developer escalations"
    },
    developerEscalationLower: {
        "id": "work-category.common.developer-escalation-lower",
        "defaultMessage": "developer escalations"
    }
});

});


const $6d5c2d68fdd6fc0f$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';

parcelRegister("4Yy10", function(module, exports) {

let $39f726bc5f1d5df5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $39f726bc5f1d5df5$var$load("acuke").then(()=>parcelRequire('4E57L'));

});


parcelRegister("h60sh", function(module, exports) {

$parcel$export(module.exports, "requiredProjectProperties", () => $2793aada3a9f7a33$export$fbeae45a65f4a5a6);
$parcel$export(module.exports, "requiredFrontendProperties", () => $2793aada3a9f7a33$export$47241956725e3029);
$parcel$export(module.exports, "firstProjectResource", () => $2793aada3a9f7a33$export$f620cebb7e8eeeae);

var $9Dhvc = parcelRequire("9Dhvc");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");
const $2793aada3a9f7a33$var$getKey = ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
    (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0];

const $2793aada3a9f7a33$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("lkb9E"));
const $2793aada3a9f7a33$export$fbeae45a65f4a5a6 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES',
    getKey: $2793aada3a9f7a33$var$getKey,
    getDataLoader: $2793aada3a9f7a33$var$getRequiredProjectPropertiesDataLoader,
    maxAge: 300000
});

const $2793aada3a9f7a33$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("jVCPc"));
const $2793aada3a9f7a33$var$ONE_DAY_IN_MILLIS = 86400000;
const $2793aada3a9f7a33$export$47241956725e3029 = (0, $l1VxS.createResource)({
    type: 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES',
    getKey: $2793aada3a9f7a33$var$getKey,
    getDataLoader: $2793aada3a9f7a33$var$getRequiredFrontendPropertiesDataLoader,
    maxAge: $2793aada3a9f7a33$var$ONE_DAY_IN_MILLIS
});

const $2793aada3a9f7a33$var$getFirstProjectDataLoader = ()=>(parcelRequire("86DGm"));
const $2793aada3a9f7a33$var$TWELVE_HOURS_IN_MILLIS = 43200000;
const $2793aada3a9f7a33$export$f620cebb7e8eeeae = (0, $l1VxS.createResource)({
    type: 'JSM_FIRST_PROJECT_RESOURCE',
    // first project is the same for the tenantId (there is also no per-project arg in request url). Therefore, only 1 key value is used.
    getKey: ()=>'none',
    getDataLoader: $2793aada3a9f7a33$var$getFirstProjectDataLoader,
    maxAge: $2793aada3a9f7a33$var$TWELVE_HOURS_IN_MILLIS
});

});
parcelRegister("lkb9E", function(module, exports) {

let $f8641e4e777b76bd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f8641e4e777b76bd$var$load("jCLhY").then(()=>parcelRequire('aiZVu'));

});

parcelRegister("jVCPc", function(module, exports) {

let $e82174fd0f74c742$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e82174fd0f74c742$var$load("fJQbu").then(()=>parcelRequire('dcEuZ'));

});

parcelRegister("86DGm", function(module, exports) {

let $5e6daa578874a1ce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5e6daa578874a1ce$var$load("a905R").then(()=>parcelRequire('91ovr'));

});


parcelRegister("aGQ56", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $afd2eec712bd1e40$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $afd2eec712bd1e40$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResourceSsr", () => $afd2eec712bd1e40$export$b55fde45b61f13f4);
$parcel$export(module.exports, "priorityGroupCrossProjectResource", () => $afd2eec712bd1e40$export$ce17a222de842d7c);
$parcel$export(module.exports, "issueListSsrResource", () => $afd2eec712bd1e40$export$3d03cbaac8581e65);
$parcel$export(module.exports, "queueSidebarViewAllQueuesResource", () => $afd2eec712bd1e40$export$5b6f88b653545aa1);
$parcel$export(module.exports, "queueNav4SidebarSelectionResource", () => $afd2eec712bd1e40$export$dead630ba04fdfe4);
$parcel$export(module.exports, "queueSidebarQueuesCategoryStateResource", () => $afd2eec712bd1e40$export$9e9033d678058efa);

var $9Dhvc = parcelRequire("9Dhvc");

var $gYnSx = parcelRequire("gYnSx");


var $5j85B = parcelRequire("5j85B");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");

var $FppkK = parcelRequire("FppkK");

var $l9f4K = parcelRequire("l9f4K");

var $dhGgY = parcelRequire("dhGgY");

const $afd2eec712bd1e40$var$getDataLoader = ()=>(parcelRequire("2b4E9"));

const $afd2eec712bd1e40$var$getPriorityGroupDataLoader = ()=>(parcelRequire("b8Xr6"));

const $afd2eec712bd1e40$var$fetchIssueListDataLoader = ()=>(parcelRequire("exc9M"));
const $afd2eec712bd1e40$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.queueId', '')}`;
const $afd2eec712bd1e40$var$getResourceKeyFromProjectKey = ({ match: match, query: query })=>`${(0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0]}`;
const $afd2eec712bd1e40$export$4fed8be571897bef = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getDataLoader: $afd2eec712bd1e40$var$getDataLoader,
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$1f9ab301771fe42e = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getDataLoader: $afd2eec712bd1e40$var$getPriorityGroupDataLoader,
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $afd2eec712bd1e40$var$priorityGroupCrossProjectResourcePayload = {
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
        const projectKey = (0, $bBtQo.getProjectKeyId)(match, query).projectKey;
        try {
            const projectId = match.params.projectId ? +match.params.projectId : undefined;
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'priorityGroupCrossProjectNoProjectId',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    depends: []
};
const $afd2eec712bd1e40$var$priorityGroupByProjectIdResourcePayload = {
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdStart',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const { projectKey: projectKey } = (0, $bBtQo.getProjectKeyId)(match, query);
        if (!projectKey) (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectKey',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        if (!cloudId) (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdNoCloudId',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        let data;
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            data = await (0, $5j85B.consumeDependency)(dependencies, (0, $c8eeacd6960f72dc$export$80a60a092d9ab81));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'priorityGroupByProjectIdProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (!data) (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectContextData',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const projectId = data?.projectId;
        if (!projectId) (0, $gYnSx.default)({
            meta: {
                id: 'priorityGroupByProjectIdNoProjectContextProjectId',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        try {
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'priorityGroupByProjectIdGettingPriorityGroupsDataError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $dhGgY.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS),
    depends: [
        (0, $c8eeacd6960f72dc$export$80a60a092d9ab81)
    ]
};
const $afd2eec712bd1e40$export$b55fde45b61f13f4 = (0, $l1VxS.createResource)($afd2eec712bd1e40$var$priorityGroupByProjectIdResourcePayload);
const $afd2eec712bd1e40$export$ce17a222de842d7c = (0, $l1VxS.createResource)({
    ...$afd2eec712bd1e40$var$priorityGroupCrossProjectResourcePayload,
    isBrowserOnly: true
});
const $afd2eec712bd1e40$export$3d03cbaac8581e65 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $afd2eec712bd1e40$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $afd2eec712bd1e40$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});
const $afd2eec712bd1e40$export$5b6f88b653545aa1 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        const projectKey = $afd2eec712bd1e40$var$getResourceKeyFromProjectKey({
            match: match,
            query: query
        });
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, `jsm-all-queues-state_is-open-${projectKey}`);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'fetchJsmQueueSidebarViewAllQueuesResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$dead630ba04fdfe4 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, (0, $l9f4K.LOCAL_STORAGE_KEY_NAV_LOCATION));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'fetchQueueNav4SidebarSelectionResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});
const $afd2eec712bd1e40$export$9e9033d678058efa = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY),
    getKey: $afd2eec712bd1e40$var$getResourceKeyFromProjectKey,
    getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        try {
            if (!atlassianAccountId) throw new Error('accountId is missing.');
            const response = await (0, $FppkK.getUserProperty)(atlassianAccountId, (0, $l9f4K.LOCAL_STORAGE_KEY_CATEGORY));
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'fetchJsmQueueSidebarQueuesCategoryStateResourceError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("5j85B", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $9d19e695d8895e78$export$a973ef9e17a326f);
async function $9d19e695d8895e78$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("l9f4K", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $3365e8184adaa319$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $3365e8184adaa319$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $3365e8184adaa319$export$2733615da5b906f0);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE", () => $3365e8184adaa319$export$f510a6e9fec0630a);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES", () => $3365e8184adaa319$export$94bda82b7db2173c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION", () => $3365e8184adaa319$export$7e07da72de89b61c);
$parcel$export(module.exports, "SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY", () => $3365e8184adaa319$export$5b3a0c7c3b3456f);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_NAV_LOCATION", () => $3365e8184adaa319$export$3c59a089fdd2614a);
$parcel$export(module.exports, "LOCAL_STORAGE_KEY_CATEGORY", () => $3365e8184adaa319$export$9b99689db482a6bb);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $3365e8184adaa319$export$5a00268156ea5027);
const $3365e8184adaa319$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $3365e8184adaa319$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $3365e8184adaa319$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $3365e8184adaa319$export$f510a6e9fec0630a = 'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE';
const $3365e8184adaa319$export$94bda82b7db2173c = 'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';
const $3365e8184adaa319$export$7e07da72de89b61c = 'SERVICEDESK_QUEUES_NAV_4_SIDEBAR_SELECTION';
const $3365e8184adaa319$export$5b3a0c7c3b3456f = 'SERVICEDESK_QUEUES_SIDEBAR_QUEUES_CATEGORY';
const $3365e8184adaa319$export$3c59a089fdd2614a = 'queue-groups-nav-state';
const $3365e8184adaa319$export$9b99689db482a6bb = 'queues-category-state';
const $3365e8184adaa319$export$5a00268156ea5027 = 86400000;

});

parcelRegister("dhGgY", function(module, exports) {

$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $3c68df8ab7c5fa41$export$cf2bd2ec601ed920);

var $llUmI = parcelRequire("llUmI");

var $6Abnv = parcelRequire("6Abnv");

var $j4oe4 = parcelRequire("j4oe4");

var $7zZ4w = parcelRequire("7zZ4w");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $3c68df8ab7c5fa41$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $1Ozm9.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}&operation=fetchPriorityGroups`);
};
const $3c68df8ab7c5fa41$var$fetchGroupsByIdGraphql = async (projectId, cloudId)=>{
    const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
    const result = await (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), (0, $llUmI.default), {
        projectAri: projectAri
    }).toPromise();
    if (!result?.queuesprioritygroups_priorityGroups?.results) (0, $gYnSx.default)({
        meta: {
            id: 'priorityGroupByProjectIdNoPriorityGroupsGraphql',
            packageName: 'jiraRouterResourcesServiceDeskQueues',
            teamName: 'jsm-flash'
        },
        sendToPrivacyUnsafeSplunk: true
    });
    return {
        results: result?.queuesprioritygroups_priorityGroups?.results?.reduce((priorityGroups, priorityGroup)=>{
            // this mapping function is to make types happy
            if (priorityGroup && priorityGroup.id && priorityGroup.name && priorityGroup.category && priorityGroup.queueIds) priorityGroups.push({
                id: priorityGroup.id,
                name: priorityGroup.name,
                category: priorityGroup.category,
                queueIds: priorityGroup.queueIds.reduce((queueIds, queueId)=>{
                    if (queueId !== null && queueId !== undefined) queueIds.push(queueId);
                    return queueIds;
                // we need the below, otherwise reduce things the type is never[]
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                }, []),
                ...priorityGroup.version ? {
                    version: priorityGroup.version
                } : {},
                ...priorityGroup.creationMethod ? {
                    creationMethod: priorityGroup.creationMethod
                } : {}
            });
            return priorityGroups;
        }, // we need the below, otherwise reduce things the type is never[]
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        []) ?? []
    };
};
const $3c68df8ab7c5fa41$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    let data;
    if (projectId) data = await $3c68df8ab7c5fa41$var$fetchGroupsByIdGraphql(projectId, cloudId);
    else {
        (0, $gYnSx.default)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $3c68df8ab7c5fa41$var$fetchGroupsByKey(projectKey, cloudId);
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});
parcelRegister("llUmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $49a175edfdfe7540$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<509a54dc797b22dc5439dcc947ec5646>>
 * @relayHash aa856b961b835b1f9323042c281fa03b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530
const $49a175edfdfe7540$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectId",
                    "variableName": "projectAri"
                }
            ],
            "concreteType": "QueuesPriorityGroupsResults",
            "kind": "LinkedField",
            "name": "queuesprioritygroups_priorityGroups",
            "plural": false,
            "selections": [
                {
                    "concreteType": "QueuesPriorityGroupsResultsGroup",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "queueIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "version"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationMethod"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getPriorityGroupDataByProjectIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a06f924d3b993614f20cc99cb824d0a15370bb2745568a6f165c081ee7493530",
            "metadata": {},
            "name": "getPriorityGroupDataByProjectIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$49a175edfdfe7540$var$node.hash = "e99dcef5a507344c549819dcfbf09d31";
var $49a175edfdfe7540$export$2e2bcd8739ae039 = $49a175edfdfe7540$var$node;

});

parcelRegister("6Abnv", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/** Used for built-in method references. */ var $4caeee4f6c048b0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caeee4f6c048b0e$var$hasOwnProperty = $4caeee4f6c048b0e$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $4caeee4f6c048b0e$var$groupBy = $a9KaZ(function(result, value, key) {
    if ($4caeee4f6c048b0e$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $iBJlb(result, key, [
        value
    ]);
});
module.exports = $4caeee4f6c048b0e$var$groupBy;

});


parcelRegister("2b4E9", function(module, exports) {

let $1960368d242c3e0b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1960368d242c3e0b$var$load("kVX56"),
    $1960368d242c3e0b$var$load("gGEaT")
]).then(()=>parcelRequire('fIAjW'));

});

parcelRegister("b8Xr6", function(module, exports) {

let $81ce8bd5e87db6fd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $81ce8bd5e87db6fd$var$load("aQC4s").then(()=>parcelRequire('9Uve2'));

});

parcelRegister("exc9M", function(module, exports) {

let $a94d93d98fa8d9e8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a94d93d98fa8d9e8$var$load("dgQcw").then(()=>parcelRequire('22Hs1'));

});


parcelRegister("aEWXS", function(module, exports) {

$parcel$export(module.exports, "nav3QueueGroupsStateResource", () => $474104609766e589$export$53d0e5294221581);

var $9Dhvc = parcelRequire("9Dhvc");

var $l1VxS = parcelRequire("l1VxS");

var $gYnSx = parcelRequire("gYnSx");

var $bBtQo = parcelRequire("bBtQo");

var $l9f4K = parcelRequire("l9f4K");

var $7KiwK = parcelRequire("7KiwK");
const $474104609766e589$var$getProjectKey = ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
    (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0];
const $474104609766e589$export$53d0e5294221581 = (0, $l1VxS.createResource)({
    type: (0, $l9f4K.RESOURCE_TYPE_SERVICEDESK_NAV3_QUEUE_GROUPS_STATE),
    getKey: $474104609766e589$var$getProjectKey,
    getData: async ({ match: match, query: query }, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>{
        if (!atlassianAccountId) return undefined;
        const projectKey = $474104609766e589$var$getProjectKey({
            match: match,
            query: query
        });
        try {
            return await (0, $7KiwK.getQueueGroupsStateFromUserProperty)(projectKey, atlassianAccountId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                error: error,
                meta: {
                    id: 'getQueueGroupsStateInUserPropertyResourceError'
                }
            });
            return undefined;
        }
    },
    maxAge: (0, $l9f4K.ONE_DAY_IN_MILLIS)
});

});
parcelRegister("7KiwK", function(module, exports) {

$parcel$export(module.exports, "setQueueGroupsStateInUserProperty", () => $7032001ee4a89aff$export$e316bbc9b5e5100d);
$parcel$export(module.exports, "getQueueGroupsStateFromUserProperty", () => $7032001ee4a89aff$export$87bc602eb5671315);

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");
const $7032001ee4a89aff$export$bb10a02fc2feb574 = 'jsm-queue-groups-state-selected-group-id';
const $7032001ee4a89aff$export$e316bbc9b5e5100d = async (projectKey, value, accountId)=>{
    try {
        (0, $FppkK.setUserProperties)(accountId, `${$7032001ee4a89aff$export$bb10a02fc2feb574}_${projectKey}`, JSON.stringify(value));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'setQueueGroupsStateInUserPropertyError'
            }
        });
        throw error;
    }
};
const $7032001ee4a89aff$export$87bc602eb5671315 = async (projectKey, accountId)=>{
    try {
        return await (0, $FppkK.getUserProperty)(accountId, `${$7032001ee4a89aff$export$bb10a02fc2feb574}_${projectKey}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getQueueGroupsStateFromUserPropertyError'
            }
        });
        throw error;
    }
};

});


parcelRegister("arxGJ", function(module, exports) {

$parcel$export(module.exports, "virtualAgentOnboardingResource", () => $43d426eb1ac4453c$export$d39827c053fda3aa);

var $7jTnu = parcelRequire("7jTnu");

var $9FYIg = parcelRequire("9FYIg");

var $kYSzP = parcelRequire("kYSzP");
const $43d426eb1ac4453c$export$d39827c053fda3aa = (0, $9FYIg.createRelayResource)({
    type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
    isBrowserOnly: true,
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $kYSzP.default),
            variables: {
                cloudId: tenantContext.cloudId,
                key: match.params.projectKey || '',
                checkForAiEnabledFF: (0, $7jTnu.fg)('require_ai_enabled_for_jsm_virtual_agent')
            }
        })
});

});
parcelRegister("kYSzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f69717998c70f94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8391836c727c96074b367b5cee339a0d>>
 * @relayHash a752dde009c93b4975b47e740db8b1bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf

var $bXR9c = parcelRequire("bXR9c");
const $4f69717998c70f94$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "43c453bca1e65ebbd87f7974bea4d6b5c78178b9b9507ff8b40972a4e4fe9ecf",
        "metadata": {},
        "name": "mainVirtualAgentSidebarQuery",
        "operationKind": "query",
        "text": null,
        "providedVariables": {
            "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, $bXR9c.default)
        }
    }
};
var $4f69717998c70f94$export$2e2bcd8739ae039 = $4f69717998c70f94$var$node;

});
parcelRegister("bXR9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b15431a198dc56$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");
var $34b15431a198dc56$export$2e2bcd8739ae039 = {
    get () {
        return (0, $7jTnu.fg)('require_ai_enabled_for_jsm_virtual_agent');
    }
};

});



parcelRegister("g9kBK", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $64d699e1b049a1a4$export$16f81cc9da2c6c47);

var $9Dhvc = parcelRequire("9Dhvc");

var $bBtQo = parcelRequire("bBtQo");

var $l1VxS = parcelRequire("l1VxS");


const $64d699e1b049a1a4$var$getDataLoader = ()=>(parcelRequire("4pa6c"));
const $64d699e1b049a1a4$var$ONE_DAY_IN_MILLIS = 86400000;
const $64d699e1b049a1a4$export$16f81cc9da2c6c47 = (0, $l1VxS.createResource)({
    type: (0, $48cfe47ee1d47a2f$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $bBtQo.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $64d699e1b049a1a4$var$getDataLoader,
    maxAge: $64d699e1b049a1a4$var$ONE_DAY_IN_MILLIS
});

});
const $48cfe47ee1d47a2f$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';

parcelRegister("4pa6c", function(module, exports) {

let $335154aaa54cbadb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $335154aaa54cbadb$var$load("kVX56"),
    $335154aaa54cbadb$var$load("fSodV")
]).then(()=>parcelRequire('dYpVn'));

});


parcelRegister("ePaI2", function(module, exports) {

$parcel$export(module.exports, "workspaceResource", () => $e09848882139baa5$export$2f02c3f971168d17);

var $l1VxS = parcelRequire("l1VxS");

var $jopyG = parcelRequire("jopyG");
const $e09848882139baa5$export$9b3a4d71d46e5ee7 = 'JSM_INSIGHT_WORKSPACE_CONTEXT';
const $e09848882139baa5$export$2f02c3f971168d17 = (0, $l1VxS.createResource)({
    type: $e09848882139baa5$export$9b3a4d71d46e5ee7,
    getKey: ()=>'state',
    getData: async (_, routerContext)=>{
        const workspaceId = await (0, $jopyG.default)(_, routerContext);
        return workspaceId;
    },
    maxAge: Infinity
});

});
parcelRegister("jopyG", function(module, exports) {

$parcel$export(module.exports, "getUserJsmLicenceState", () => $f9ae8515d7b2e372$export$65bf73aad2afa39);
$parcel$export(module.exports, "isPremiumInstance", () => $f9ae8515d7b2e372$export$abb609d3bcbb74f6);
$parcel$export(module.exports, "isLicensedPremiumUser", () => $f9ae8515d7b2e372$export$d7b4c32773b1c643);
$parcel$export(module.exports, "default", () => $f9ae8515d7b2e372$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $u4YbY = parcelRequire("u4YbY");

var $7cSYk = parcelRequire("7cSYk");

var $4ZeQj = parcelRequire("4ZeQj");

var $a9ldn = parcelRequire("a9ldn");

const $f9ae8515d7b2e372$export$530f260cc76f04ff = ()=>'/rest/servicedesk/cmdb/latest/workspace';
const $f9ae8515d7b2e372$export$65bf73aad2afa39 = (tenantContext)=>{
    const { licensedProducts: licensedProducts, appPermissions: appPermissions } = tenantContext;
    const hasJsmLicence = licensedProducts && licensedProducts[0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61];
    const isJsmLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    if (!hasJsmLicence) return {
        siteHasJsmInstalled: false
    };
    return {
        siteHasJsmInstalled: true,
        siteIsPremium: $f9ae8515d7b2e372$export$abb609d3bcbb74f6(tenantContext),
        userLicensed: isJsmLicensedUser
    };
};
const $f9ae8515d7b2e372$export$abb609d3bcbb74f6 = (tenantContext)=>{
    const { appEditions: { serviceDesk: serviceDeskAppEdition } } = tenantContext;
    const isPremium = serviceDeskAppEdition === (0, $a9ldn.PREMIUM_EDITION);
    return isPremium;
};
const $f9ae8515d7b2e372$export$d7b4c32773b1c643 = (tenantContext)=>{
    const { appPermissions: appPermissions } = tenantContext;
    const isPremium = $f9ae8515d7b2e372$export$abb609d3bcbb74f6(tenantContext);
    const isLicensedUser = appPermissions && appPermissions.hasServiceDeskAccess;
    return isPremium && isLicensedUser;
};
const $f9ae8515d7b2e372$var$transformResponse = (response)=>{
    const ids = response.results ?? [];
    return ids.length ? (0, $4ZeQj.toWorkspaceId)(ids[0].id) : null;
};
const $f9ae8515d7b2e372$export$e1d718dfe6dad973 = (routerContext, { tenantContext: tenantContext })=>{
    if ($f9ae8515d7b2e372$export$d7b4c32773b1c643(tenantContext) === false || !(0, $7cSYk.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP)) return null;
    return (0, $u4YbY.performCmdbGetRequest)($f9ae8515d7b2e372$export$530f260cc76f04ff()).then($f9ae8515d7b2e372$var$transformResponse).catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('spa.view.routes.servicedesk.workspace-id', 'Error while fetching servicedesk Insight workspace id', error);
        return null;
    });
};
var $f9ae8515d7b2e372$export$2e2bcd8739ae039 = $f9ae8515d7b2e372$export$e1d718dfe6dad973;

});
parcelRegister("u4YbY", function(module, exports) {

$parcel$export(module.exports, "performCmdbGetRequest", () => $97885f5e767a49bb$export$a252413f43ec7247);
$parcel$export(module.exports, "performCmdbPostRequest", () => $97885f5e767a49bb$export$d68a9f67166d25a2);
$parcel$export(module.exports, "performCmdbPutRequest", () => $97885f5e767a49bb$export$326b7407f501f98b);
$parcel$export(module.exports, "performCmdbDeleteRequest", () => $97885f5e767a49bb$export$b198eb14f22c12e6);

var $7jTnu = parcelRequire("7jTnu");

var $1oMOM = parcelRequire("1oMOM");

var $jGzN3 = parcelRequire("jGzN3");
const $97885f5e767a49bb$export$d5e211a0106aa636 = {
    'X-Request-Source': 'cmdb-frontend'
};
const $97885f5e767a49bb$export$a252413f43ec7247 = (url, options)=>(0, $jGzN3.performGetRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$d68a9f67166d25a2 = (url, options)=>(0, $jGzN3.performPostRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$326b7407f501f98b = (url, options)=>(0, $jGzN3.performPutRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$b198eb14f22c12e6 = (url, options)=>(0, $jGzN3.performDeleteRequest)(url, $97885f5e767a49bb$export$235b7fc70b9fc359(url, options));
const $97885f5e767a49bb$export$235b7fc70b9fc359 = (url, options)=>{
    const defaultOptions = (0, $1oMOM.getDefaultOptions)(url);
    return (0, $7jTnu.fg)('fly-2529-cmdb-client-send-request-source-header') ? {
        ...defaultOptions,
        ...options,
        headers: {
            ...defaultOptions.headers,
            ...options?.headers,
            ...$97885f5e767a49bb$export$d5e211a0106aa636
        }
    } : options;
};

});

parcelRegister("7cSYk", function(module, exports) {

$parcel$export(module.exports, "isCMDBEnabledInEnvironment", () => $d8faa2e2692e1ff5$export$6dbfb62369f79a64);

var $lopBx = parcelRequire("lopBx");

var $7jTnu = parcelRequire("7jTnu");
const $d8faa2e2692e1ff5$export$6dbfb62369f79a64 = (cmdbDisabledInFedRAMPForTenant)=>!(0, $lopBx.isFedRamp)() || (0, $lopBx.isFedRamp)() && ((0, $7jTnu.fg)('use_cmdb_scr12_enabled') ? cmdbDisabledInFedRAMPForTenant != null && !cmdbDisabledInFedRAMPForTenant : (0, $7jTnu.fg)('jsm-assets-fedramp-ui'));

});

parcelRegister("4ZeQj", function(module, exports) {

$parcel$export(module.exports, "toSchemaId", () => $a31a1cf0aae81680$export$d577b7f3b832f656);
$parcel$export(module.exports, "toCmdbObjectId", () => $a31a1cf0aae81680$export$1ba342595bc7be13);
$parcel$export(module.exports, "toCmdbObjectTypeId", () => $a31a1cf0aae81680$export$b46e25afa2bab6a);
$parcel$export(module.exports, "toObjectCommentId", () => $a31a1cf0aae81680$export$ece2917434bb0a8c);
$parcel$export(module.exports, "toWorkspaceId", () => $a31a1cf0aae81680$export$d002b8d7821b6b59);
$parcel$export(module.exports, "toObjectTypeAttributeId", () => $a31a1cf0aae81680$export$cfd92c18cee8add7);
const $a31a1cf0aae81680$export$d577b7f3b832f656 = (id)=>id;
const $a31a1cf0aae81680$export$1ba342595bc7be13 = (id)=>id;
const $a31a1cf0aae81680$export$b46e25afa2bab6a = (id)=>id;
const $a31a1cf0aae81680$export$ece2917434bb0a8c = (id)=>id;
const $a31a1cf0aae81680$export$d002b8d7821b6b59 = (id)=>id;
const $a31a1cf0aae81680$export$cfd92c18cee8add7 = (id)=>id;

});

const $e08dff4ae358d899$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $e08dff4ae358d899$export$e9c56aa3b027d98f = 'jira-customer-service';
const $e08dff4ae358d899$export$1346c9aa3cbb477d = 'jira-software';
const $e08dff4ae358d899$export$202f50ee62667e32 = 'jira-product-discovery';
const $e08dff4ae358d899$export$db515c8cec1e6f79 = 'jira-core';
const $e08dff4ae358d899$export$c811f21c9ad05dc2 = 'confluence';
const $e08dff4ae358d899$export$961148c98d198270 = 'opsgenie';



parcelRegister("27Owl", function(module, exports) {

$parcel$export(module.exports, "boardDetailsResource", () => $649dd820db29afaa$export$6c6984c55b171c5d);
$parcel$export(module.exports, "getBoardDetailsResource", () => $649dd820db29afaa$export$b67eabcfc08e7c62);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $l1VxS = parcelRequire("l1VxS");

var $blWcH = parcelRequire("blWcH");
const $649dd820db29afaa$export$90ce361a5838e31e = async (boardId)=>{
    try {
        return await (0, $1Ozm9.default)(`/rest/agile/1.0/board/${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getBoardDetailsRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $649dd820db29afaa$export$6c6984c55b171c5d = (0, $l1VxS.createResource)({
    type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
    getKey: (routerContext)=>(0, $blWcH.getConfigFromRouterContext)(routerContext) ? 'cmp-board-settings' : 'not-cmp-board-setting',
    getData: async (routerContext)=>{
        const boardId = routerContext.match.params?.boardId ?? '';
        if ((0, $blWcH.getConfigFromRouterContext)(routerContext)) return $649dd820db29afaa$export$90ce361a5838e31e(boardId);
        return null;
    }
});
const $649dd820db29afaa$export$b67eabcfc08e7c62 = ()=>$649dd820db29afaa$export$6c6984c55b171c5d;

});
parcelRegister("blWcH", function(module, exports) {

$parcel$export(module.exports, "buildAllDataQueryParams", () => $6a4cf61bbd4e46b4$export$487708debaea6de3);
$parcel$export(module.exports, "getInlineScriptData", () => $6a4cf61bbd4e46b4$export$7bd4b867b9305f97);
$parcel$export(module.exports, "getRapidViewConfigFromRouteName", () => $6a4cf61bbd4e46b4$export$62c86c4062215346);
$parcel$export(module.exports, "getRequiredResourceList", () => $6a4cf61bbd4e46b4$export$7bff98a3d459b1b8);
$parcel$export(module.exports, "getConfigFromRouterContext", () => $6a4cf61bbd4e46b4$export$1705c550e5b835bf);

var $7jTnu = parcelRequire("7jTnu");

var $6XhAO = parcelRequire("6XhAO");

var $q8NP8 = parcelRequire("q8NP8");
const $6a4cf61bbd4e46b4$export$487708debaea6de3 = (query, match)=>{
    const { rapidView: rapidView, quickFilter: quickFilter, projectKey: queryProjectKey, etag: etag } = query;
    const boardId = match.params.boardId || rapidView;
    const projectKey = match.params.projectKey || queryProjectKey;
    let activeQuickFilters = '';
    if (quickFilter) activeQuickFilters = Array.isArray(quickFilter) ? quickFilter.reduce((prevFilter, nextFilter)=>`${prevFilter}&activeQuickFilters=${nextFilter}`, activeQuickFilters) : `&activeQuickFilters=${quickFilter}`;
    const etagParam = etag ? `&etag=${etag}` : '';
    const projectKeyParam = projectKey ? `&selectedProjectKey=${projectKey}` : '';
    const { GH: GH } = window;
    const forceConsistency = '&forceConsistency=true';
    GH?.RapidBoard?.State?.setRapidViewIdForEventuallyConsistentBoard(undefined);
    return `rapidViewId=${boardId}${projectKeyParam}${activeQuickFilters}${etagParam}${forceConsistency}`;
};
const $6a4cf61bbd4e46b4$var$cleanUpInlineScript = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    delete window[dataName];
};
const $6a4cf61bbd4e46b4$export$7bd4b867b9305f97 = (dataName)=>{
    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const req = window[dataName];
    if (!req) return null;
    if (req.readyState === req.DONE && req.status !== 200) {
        $6a4cf61bbd4e46b4$var$cleanUpInlineScript(dataName);
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((r)=>{
        if (req.readyState === req.DONE && req.status === 200) {
            $6a4cf61bbd4e46b4$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        } else req.addEventListener('load', ()=>{
            $6a4cf61bbd4e46b4$var$cleanUpInlineScript(dataName);
            r(JSON.parse(req.response));
        });
    });
};
const $6a4cf61bbd4e46b4$export$62c86c4062215346 = (routeName)=>{
    for (const routeConfig of Object.values((0, $q8NP8.RAPID_VIEW_ROUTE_CONFIG))){
        if (routeConfig.routes?.includes(routeName)) return routeConfig;
    }
    return (0, $q8NP8.RAPID_VIEW_ROUTE_CONFIG).DEFAULT;
};
const $6a4cf61bbd4e46b4$export$7bff98a3d459b1b8 = (view)=>{
    let rapidboardResources = (0, $6XhAO.WRM_RESOURCES_ARRAY);
    if ((0, $7jTnu.fg)('reports-overview-page-migration')) {
        if (view) {
            const routeConfig = $6a4cf61bbd4e46b4$export$62c86c4062215346(view);
            return [
                ...(0, $6XhAO.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
                ...routeConfig.resources
            ];
        }
        return [
            ...(0, $6XhAO.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
            ...(0, $q8NP8.RAPID_VIEW_ROUTE_CONFIG).DEFAULT.resources
        ];
    }
    // eslint-disable-next-line default-case
    switch(view){
        case 'rapidboard-board':
        case 'rapidboard-board-embed':
        case 'rapidboard-user-board':
        case 'servicedesk-boards':
        case 'servicedesk-queues-custom-board':
        case 'servicedesk-queues-practice-custom-board':
            rapidboardResources = (0, $6XhAO.WRM_BOARD_RESOURCES_FHD_ARRAY);
            break;
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
        case 'rapidboard-backlog-embed':
            rapidboardResources = (0, $6XhAO.WRM_BACKLOG_RESOURCES_FHD_ARRAY);
            break;
    }
    return [
        ...(0, $6XhAO.WRM_HERITAGE_RESOURCES_FHD_ARRAY),
        ...rapidboardResources
    ];
};
function $6a4cf61bbd4e46b4$export$1705c550e5b835bf(routerContext) {
    return routerContext.match?.params.config || routerContext.query?.config || '';
}

});
parcelRegister("6XhAO", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", () => $a8c4ab1630e67bda$export$88e2a0b89be042c1);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", () => $a8c4ab1630e67bda$export$ba075d0985968d1c);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", () => $a8c4ab1630e67bda$export$395f77888d07f2e0);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", () => $a8c4ab1630e67bda$export$4f7c4e3508fd2a07);
$parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", () => $a8c4ab1630e67bda$export$3328c8e71fda97bb);
$parcel$export(module.exports, "WRM_RESOURCES_ARRAY", () => $a8c4ab1630e67bda$export$ef21257df3d71188);
$parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", () => $a8c4ab1630e67bda$export$ccd0929652c235de);
$parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", () => $a8c4ab1630e67bda$export$1d16bdcc94a40107);
$parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", () => $a8c4ab1630e67bda$export$1f599d2eef0a7281);
const $a8c4ab1630e67bda$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
const $a8c4ab1630e67bda$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
const $a8c4ab1630e67bda$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
const $a8c4ab1630e67bda$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
const $a8c4ab1630e67bda$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
const $a8c4ab1630e67bda$export$ef21257df3d71188 = [
    '_super',
    'wrc!greenhopper-rapid-non-gadget',
    'wrc!gh-rapid',
    'wrc!jira.global',
    'wrc!jira.general',
    'wrc!atl.global',
    // Required to prevent an error on initial loading of reports
    'wrc!jira.webresources:header',
    // Required for Control Chart report page
    'wrc!jira.webresources:calendar',
    'wrc!jira.webresources:calendar-en',
    'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
    // Required for explicit usage of jQuery
    'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
    // Required for the styles of the toggle button when transitioning from reports to board settings
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
    // Required for the profile card in board settings, that doesn't really render because it has wrong
    // parameters and it has been broken for ages, but at least prevents noisy errors
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!gh-rapid-config',
    'wrc!gh-rapid-analytics',
    'wrc!gh-rapid-charts',
    'wrc!jira.webresources:mentions-feature',
    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
];
const $a8c4ab1630e67bda$export$ccd0929652c235de = [];
const $a8c4ab1630e67bda$export$1d16bdcc94a40107 = [
    'wrc!gh-rapid-lwf-board-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];
const $a8c4ab1630e67bda$export$1f599d2eef0a7281 = [
    'wrc!gh-rapid-backlog-fhd',
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:header',
    'wrc!jira.webresources:feature-flags',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("q8NP8", function(module, exports) {

$parcel$export(module.exports, "RAPID_VIEW_ROUTE_CONFIG", () => $388fe636b9cb51cc$export$99d0df2f58f37dfe);

var $6XhAO = parcelRequire("6XhAO");
const $388fe636b9cb51cc$export$99d0df2f58f37dfe = {
    BOARD: {
        routes: [
            'rapidboard-board',
            'rapidboard-board-embed',
            'rapidboard-user-board',
            'servicedesk-boards',
            'servicedesk-queues-custom-board',
            'servicedesk-queues-practice-custom-board'
        ],
        resources: (0, $6XhAO.WRM_BOARD_RESOURCES_FHD_ARRAY),
        stateKey: 'board-state'
    },
    BACKLOG: {
        routes: [
            'rapidboard-backlog',
            'rapidboard-user-backlog',
            'rapidboard-backlog-embed'
        ],
        resources: (0, $6XhAO.WRM_BACKLOG_RESOURCES_FHD_ARRAY),
        stateKey: 'backlog-state'
    },
    DEFAULT: {
        resources: (0, $6XhAO.WRM_RESOURCES_ARRAY),
        stateKey: 'report-state'
    }
};

});



parcelRegister("alzbz", function(module, exports) {

$parcel$export(module.exports, "shouldLoadUIFBoardResources", () => $d3a00a694785eff5$export$d8d4641986a9ac7f);
$parcel$export(module.exports, "getRapidboardResources", () => $d3a00a694785eff5$export$3a5e56bd5231a56b);
$parcel$export(module.exports, "getRapidBoardDataResource", () => $d3a00a694785eff5$export$1c63de7f548f965f);
$parcel$export(module.exports, "getUIFBacklogDataResource", () => $d3a00a694785eff5$export$ee826506b3baa13a);

var $7jTnu = parcelRequire("7jTnu");

var $4kRUy = parcelRequire("4kRUy");

var $5L7qx = parcelRequire("5L7qx");

var $kmK2e = parcelRequire("kmK2e");

var $451Ow = parcelRequire("451Ow");

var $4pqJW = parcelRequire("4pqJW");
const $d3a00a694785eff5$export$d8d4641986a9ac7f = ()=>!false || (0, $7jTnu.fg)('enable_ssr_for_cmp_backlog');
const $d3a00a694785eff5$export$462ca08d6ce67848 = ()=>!$d3a00a694785eff5$export$d8d4641986a9ac7f();
const $d3a00a694785eff5$export$3a5e56bd5231a56b = ()=>[
        (0, $4pqJW.wrmBundleResource),
        (0, $5L7qx.resourceWithCondition2)($d3a00a694785eff5$export$462ca08d6ce67848, (0, $451Ow.rapidboardResource))
    ];
const $d3a00a694785eff5$export$1c63de7f548f965f = ()=>(0, $kmK2e.boardDataResource);
const $d3a00a694785eff5$export$ee826506b3baa13a = ()=>[
        (0, $5L7qx.resourceWithCondition2)(()=>$d3a00a694785eff5$export$d8d4641986a9ac7f() && !(0, $7jTnu.fg)('indexeddb_cache_for_backlog'), (0, $4kRUy.uifBacklogResourceOld)),
        (0, $5L7qx.resourceWithCondition2)(()=>$d3a00a694785eff5$export$d8d4641986a9ac7f() && (0, $7jTnu.fg)('indexeddb_cache_for_backlog'), (0, $4kRUy.uifBacklogResource))
    ];

});
parcelRegister("4kRUy", function(module, exports) {

$parcel$export(module.exports, "uifBacklogResourceOld", () => $c3662b34dad9676c$export$db83ef0443397b85);
$parcel$export(module.exports, "uifBacklogResource", () => $c3662b34dad9676c$export$c182dffb98985208);

var $l1VxS = parcelRequire("l1VxS");


const $c3662b34dad9676c$export$db83ef0443397b85 = (0, $l1VxS.createResource)({
    type: (0, $63ba8ce42e431ec8$export$8f9824ba4409b537),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("90SJc")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

const $c3662b34dad9676c$export$c182dffb98985208 = (0, $l1VxS.createResource)({
    type: (0, $63ba8ce42e431ec8$export$d15ce4feabd76ea),
    getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>/*
            When navigating to and from the board settings page we need
            the data to get reloaded. So we are updating the key to force a refresh
        */ [
            'uif-backlog-data'
        ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
    getDataLoader: ()=>(parcelRequire("izEnc")),
    // Setting mexAge to 0 so it will get the data again after coming back from a config page
    maxAge: 0
});

});
const $63ba8ce42e431ec8$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $63ba8ce42e431ec8$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';

parcelRegister("90SJc", function(module, exports) {

let $68fe90fb3338afd1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $68fe90fb3338afd1$var$load("bHIV9").then(()=>parcelRequire('1WnIl'));

});

parcelRegister("izEnc", function(module, exports) {

let $d85ad02723047344$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d85ad02723047344$var$load("5ff9A").then(()=>parcelRequire('cvbpu'));

});


parcelRegister("kmK2e", function(module, exports) {

$parcel$export(module.exports, "boardDataResource", () => $7ee5fa79b31b97ea$export$138fa635416978f7);

var $l1VxS = parcelRequire("l1VxS");

var $6XhAO = parcelRequire("6XhAO");

var $8QGVd = parcelRequire("8QGVd");

const $7ee5fa79b31b97ea$export$138fa635416978f7 = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
    getKey: ({ match: match, query: query, route: route })=>{
        const { name: name = '' } = route || {};
        const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
        const { config: config } = query;
        const hasConfig = Boolean(config);
        let key = 'rapidBoardData';
        if ((0, $8QGVd.isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
        else if ((0, $8QGVd.isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
        return key;
    },
    getDataLoader: ()=>(parcelRequire("k8HTE")),
    maxAge: 0,
    isBrowserOnly: true
});

});
parcelRegister("8QGVd", function(module, exports) {

$parcel$export(module.exports, "isBoardRoute", () => $94656fa01dfef750$export$437d4d6e25681588);
$parcel$export(module.exports, "isBacklogRoute", () => $94656fa01dfef750$export$bcb853db5e3e8054);
const $94656fa01dfef750$export$437d4d6e25681588 = (routeName)=>routeName === 'rapidboard-board' || routeName === 'rapidboard-board-embed' || routeName === 'rapidboard-board-settings' || routeName === 'rapidboard-user-board' || routeName === 'rapidboard-user-board-settings' || routeName === 'servicedesk-boards' || routeName === 'servicedesk-queues-custom-board' || routeName === 'servicedesk-queues-practice-custom-board';
const $94656fa01dfef750$export$bcb853db5e3e8054 = (routeName)=>routeName === 'rapidboard-backlog' || routeName === 'rapidboard-user-backlog' || routeName === 'rapidboard-backlog-embed';

});

parcelRegister("k8HTE", function(module, exports) {

let $ea969af116191082$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ea969af116191082$var$load("dbBUH").then(()=>parcelRequire('btTZq'));

});


parcelRegister("451Ow", function(module, exports) {

$parcel$export(module.exports, "rapidboardResource", () => $22f6993f0f896f9c$export$d0f42a55e7c5752c);

var $l1VxS = parcelRequire("l1VxS");

var $6XhAO = parcelRequire("6XhAO");

const $22f6993f0f896f9c$export$d0f42a55e7c5752c = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
    getKey: ({ match: match })=>match.query.rapidView || '',
    getDataLoader: ()=>(parcelRequire("dfCmh")),
    maxAge: Number.MAX_VALUE,
    isBrowserOnly: true
});

});
parcelRegister("dfCmh", function(module, exports) {

let $9a5a6e3b08dcd406$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9a5a6e3b08dcd406$var$load("4S1dY").then(()=>parcelRequire('a7NHJ'));

});


parcelRegister("4pqJW", function(module, exports) {

$parcel$export(module.exports, "wrmBundleResource", () => $af9fd9dae3624e0c$export$f199d15b7cd18df1);

var $l1VxS = parcelRequire("l1VxS");

var $7jTnu = parcelRequire("7jTnu");

var $6XhAO = parcelRequire("6XhAO");

var $blWcH = parcelRequire("blWcH");

const $af9fd9dae3624e0c$export$f199d15b7cd18df1 = (0, $l1VxS.createResource)({
    type: (0, $6XhAO.RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
    getKey: ({ route: route })=>{
        if ((0, $7jTnu.fg)('reports-overview-page-migration')) return (0, $blWcH.getRapidViewConfigFromRouteName)(route.name).stateKey;
        return 'state';
    },
    getDataLoader: ()=>(parcelRequire("dIiVx")),
    maxAge: Number.MAX_SAFE_INTEGER,
    isBrowserOnly: true
});

});
parcelRegister("dIiVx", function(module, exports) {

let $9fbe10f140dcf886$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9fbe10f140dcf886$var$load("dSNZF").then(()=>parcelRequire('6Y0wG'));

});



parcelRegister("c0h8V", function(module, exports) {

$parcel$export(module.exports, "uifBoardResource", () => $e44f77f60fe564e6$export$b65bcbbccad354ac);

var $l1VxS = parcelRequire("l1VxS");


const $e44f77f60fe564e6$export$b65bcbbccad354ac = (0, $l1VxS.createResource)({
    type: (0, $deaac3eb1a0f3204$export$cfae566ecf2855f8),
    getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
        if (config) return `uif-board::${routeName}::config`;
        if (boardId == null) return `uif-board::${routeName}::not-found`;
        return `uif-board::${routeName}::${boardId}`;
    },
    getDataLoader: ()=>(parcelRequire("dTP9K")),
    maxAge: 0
});

});
const $deaac3eb1a0f3204$export$cfae566ecf2855f8 = 'UIF_BOARD';

parcelRegister("dTP9K", function(module, exports) {

let $a1e817fe8e66b5ed$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a1e817fe8e66b5ed$var$load("cPGW6").then(()=>parcelRequire('5Uxlx'));

});


parcelRegister("fbgOh", function(module, exports) {

$parcel$export(module.exports, "editModelResource", () => $eeba0f4399f27fcb$export$ab9a4786826fd2d);
$parcel$export(module.exports, "getEditModelResource", () => $eeba0f4399f27fcb$export$5b9bac2cc4bf4511);

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $1Ozm9 = parcelRequire("1Ozm9");

var $5L7qx = parcelRequire("5L7qx");

var $l1VxS = parcelRequire("l1VxS");

var $blWcH = parcelRequire("blWcH");
const $eeba0f4399f27fcb$export$ddbb511f9111736a = async (boardId)=>{
    try {
        return await (0, $1Ozm9.default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'getEditModelRequest',
                packageName: 'jiraRouterResourcesClassicProjects',
                teamName: 'a4t-pandora'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $eeba0f4399f27fcb$export$ab9a4786826fd2d = (0, $l1VxS.createResource)({
    type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
    getKey: (routerContext)=>(0, $blWcH.getConfigFromRouterContext)(routerContext) ? 'edit-model' : 'not-edit-model',
    getData: async (routerContext)=>{
        if ((0, $blWcH.getConfigFromRouterContext)(routerContext)) {
            const boardId = routerContext.match.params?.boardId ?? '';
            return $eeba0f4399f27fcb$export$ddbb511f9111736a(boardId);
        }
        return null;
    }
});
const $eeba0f4399f27fcb$export$5b9bac2cc4bf4511 = ()=>(0, $5L7qx.resourceWithCondition2)(()=>!(0, $7jTnu.fg)('board-settings-graphql-refactor_cyvz9'), $eeba0f4399f27fcb$export$ab9a4786826fd2d);

});


parcelRegister("hNA6F", function(module, exports) {

$parcel$export(module.exports, "legacyConnectProjectRoute", () => $ec84df8ada88bb1f$export$dfdf98c5b58cfa04);
const $ec84df8ada88bb1f$export$dfdf98c5b58cfa04 = {
    name: 'legacy-connect-project',
    path: '/projects/:projectKey',
    query: [
        'selectedItem'
    ]
};

});


parcelRegister("6U4RT", function(module, exports) {

$parcel$export(module.exports, "legacyCustomReportRouteEntry", () => $11e4cd0c8f72dc6f$export$12938ba85bf5fe54);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $2Fii1 = parcelRequire("2Fii1");

var $aT1SD = parcelRequire("aT1SD");
const $11e4cd0c8f72dc6f$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $11e4cd0c8f72dc6f$export$12938ba85bf5fe54 = (0, $bAJhM.createLegacyEntry)((0, $2Fii1.legacyCustomReportRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.classicBoardSidebars)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $aT1SD.getReportsCommonResource)()
        ],
        entryPoint: ()=>$11e4cd0c8f72dc6f$var$pageEntryPoint
    }));

});
parcelRegister("2Fii1", function(module, exports) {

$parcel$export(module.exports, "legacyCustomReportRoute", () => $78eaa1e62ea0b9b3$export$6f4b8901e7772b05);
const $78eaa1e62ea0b9b3$export$6f4b8901e7772b05 = {
    name: 'legacy-custom-report',
    path: '/secure/RapidBoard.jspa',
    query: [
        'rapidView',
        'view=reporting',
        'chart'
    ]
};

});

parcelRegister("aT1SD", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $333606027719b6cb$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $333606027719b6cb$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $333606027719b6cb$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("5h6kW", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsAddRouteEntry", () => $d2af934486f75c5a$export$6cc9527a3f96c0a5);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $efuX1 = parcelRequire("efuX1");
const $d2af934486f75c5a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS
});
const $d2af934486f75c5a$export$6cc9527a3f96c0a5 = (0, $bAJhM.createLegacyEntry)((0, $efuX1.legacyDashboardsAddRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$d2af934486f75c5a$var$pageEntryPoint
    }));

});
parcelRegister("efuX1", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsAddRoute", () => $9769d156e18814ef$export$1e88394d2d12a4bc);
const $9769d156e18814ef$export$1e88394d2d12a4bc = {
    name: 'legacy-dashboards-add',
    path: '(/secure/|/)AddPortalPage([!%]?[\\w]*).jspa'
};

});


parcelRegister("hhFBc", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsConfigureRouteEntry", () => $66ab70f5758387dc$export$18ff609f147595cc);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $7dSVK = parcelRequire("7dSVK");
const $66ab70f5758387dc$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS
});
const $66ab70f5758387dc$export$18ff609f147595cc = (0, $bAJhM.createLegacyEntry)((0, $7dSVK.legacyDashboardsConfigureRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$66ab70f5758387dc$var$pageEntryPoint
    }));

});
parcelRegister("7dSVK", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsConfigureRoute", () => $5ba92d8bcd549c97$export$549a0bcc3a0017a7);
const $5ba92d8bcd549c97$export$549a0bcc3a0017a7 = {
    name: 'legacy-dashboards-configure',
    path: '(/secure/|/)ConfigurePortalPages([!%]?[\\w]*).jspa'
};

});


parcelRegister("krVQS", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsDeleteRouteEntry", () => $42ace51f9ce2a45a$export$4f59d0a9276c0c9b);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $dS3HB = parcelRequire("dS3HB");
const $42ace51f9ce2a45a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS
});
const $42ace51f9ce2a45a$export$4f59d0a9276c0c9b = (0, $bAJhM.createLegacyEntry)((0, $dS3HB.legacyDashboardsDeleteRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$42ace51f9ce2a45a$var$pageEntryPoint
    }));

});
parcelRegister("dS3HB", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsDeleteRoute", () => $8c22bef9862fd49b$export$dfa5dcc35e497330);
const $8c22bef9862fd49b$export$dfa5dcc35e497330 = {
    name: 'legacy-dashboards-delete',
    path: '(/secure/|/)DeletePortalPage([!%]?[\\w]*).jspa'
};

});


parcelRegister("7WXQd", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRouteEntry", () => $2d21e13f222140f9$export$748e329bd0c282a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $5j3iP = parcelRequire("5j3iP");
const $2d21e13f222140f9$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS
});
const $2d21e13f222140f9$export$748e329bd0c282a = (0, $bAJhM.createLegacyEntry)((0, $5j3iP.dashboardsDirectoryRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$2d21e13f222140f9$var$pageEntryPoint
    }));

});
parcelRegister("5j3iP", function(module, exports) {

$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $6563e9d5b525062d$export$41bba408475cab16);
const $6563e9d5b525062d$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});


parcelRegister("7JPxp", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsEditRouteEntry", () => $b5caec956435296f$export$60414c63c9cd3646);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $bZ87V = parcelRequire("bZ87V");
const $b5caec956435296f$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS
});
const $b5caec956435296f$export$60414c63c9cd3646 = (0, $bAJhM.createLegacyEntry)((0, $bZ87V.legacyDashboardsEditRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$b5caec956435296f$var$pageEntryPoint
    }));

});
parcelRegister("bZ87V", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsEditRoute", () => $7db117af5fa9bb4b$export$4f028eb17334a195);
const $7db117af5fa9bb4b$export$4f028eb17334a195 = {
    name: 'legacy-dashboards-edit',
    path: '(/secure/|/)EditPortalPage([!%]?[\\w]*).jspa'
};

});


parcelRegister("k34zk", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsRestoreRouteEntry", () => $6a40f7879854fc74$export$4bf748e39cc28644);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $3h8iY = parcelRequire("3h8iY");
const $6a40f7879854fc74$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).DASHBOARDS
});
const $6a40f7879854fc74$export$4bf748e39cc28644 = (0, $bAJhM.createLegacyEntry)((0, $3h8iY.legacyDashboardsRestoreRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).DASHBOARDS
        },
        entryPoint: ()=>$6a40f7879854fc74$var$pageEntryPoint
    }));

});
parcelRegister("3h8iY", function(module, exports) {

$parcel$export(module.exports, "legacyDashboardsRestoreRoute", () => $372672ccecac9a3f$export$110af57b4332630d);
const $372672ccecac9a3f$export$110af57b4332630d = {
    name: 'legacy-dashboards-restore',
    path: '/secure/RestoreDefaultDashboard([!%]?[\\w]*).jspa'
};

});


parcelRegister("jcL7x", function(module, exports) {

$parcel$export(module.exports, "legacyFallbackRouteEntry", () => $cced893ab7632f87$export$1af0a6dff57e40e7);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $lKA8j = parcelRequire("lKA8j");
const $cced893ab7632f87$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $cced893ab7632f87$export$1af0a6dff57e40e7 = (0, $bAJhM.createLegacyEntry)((0, $lKA8j.legacyFallbackRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$cced893ab7632f87$var$pageEntryPoint
    }));

});
parcelRegister("lKA8j", function(module, exports) {

$parcel$export(module.exports, "legacyFallbackRoute", () => $f6ec399647b3649a$export$27cd5ba2ad569682);
const $f6ec399647b3649a$export$27cd5ba2ad569682 = {
    name: 'legacy-fallback',
    path: '/:any'
};

});


parcelRegister("h2n1r", function(module, exports) {

$parcel$export(module.exports, "legacyGinActionRouteEntry", () => $10f6beaa7a5f1a5a$export$8d542f975e38405d);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $ftFEp = parcelRequire("ftFEp");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $eQtOf = parcelRequire("eQtOf");
const $10f6beaa7a5f1a5a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).FILTERS
});
const $10f6beaa7a5f1a5a$export$8d542f975e38405d = (0, $bAJhM.createLegacyEntry)((0, $eQtOf.legacyGinActionRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS,
            sidebar: (0, $ftFEp.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$10f6beaa7a5f1a5a$var$pageEntryPoint
    }));

});
parcelRegister("ftFEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $159719ac782bc91d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncForPaintSidebarFiltersGlobal", () => $159719ac782bc91d$export$7655c90db6341aa6);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

// Legacy GIN Sidebar
const $159719ac782bc91d$var$LazySidebarFiltersLegacy = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("dY0ZW")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
});
const $159719ac782bc91d$var$AsyncSidebarFiltersLegacy = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "filters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($159719ac782bc91d$var$LazySidebarFiltersLegacy, null)));
var $159719ac782bc91d$export$2e2bcd8739ae039 = $159719ac782bc91d$var$AsyncSidebarFiltersLegacy;

// Global-scope NIN sidebar
const $159719ac782bc91d$var$LazyAfterPaintSidebarFiltersGlobal = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    return (parcelRequire("bfvno")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});

const $159719ac782bc91d$var$LazyForPaintSidebarFiltersGlobal = (0, $bQWwW.lazyForPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    // using direct path instead of `index` because webpack will combine multiple chunks from same file
    // eslint-disable-next-line jira/import/webpack-magic-comment-entries
    return (parcelRequire("bfvno")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle.SidebarFiltersGlobal;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
});
const $159719ac782bc91d$export$1af88ebe65f50e73 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($159719ac782bc91d$var$LazyAfterPaintSidebarFiltersGlobal, null)));
const $159719ac782bc91d$export$7655c90db6341aa6 = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "filters-global"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($159719ac782bc91d$var$LazyForPaintSidebarFiltersGlobal, null)));

});
parcelRegister("dY0ZW", function(module, exports) {

let $a2b1a726194f99cc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $a2b1a726194f99cc$var$load("ffQaD"),
    $a2b1a726194f99cc$var$load("kvRbA"),
    $a2b1a726194f99cc$var$load("lfhFX")
]).then(()=>parcelRequire('6C8aj'));

});

parcelRegister("bfvno", function(module, exports) {

let $83096f1f7fa8aa39$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $83096f1f7fa8aa39$var$load("ffQaD"),
    $83096f1f7fa8aa39$var$load("kvRbA"),
    $83096f1f7fa8aa39$var$load("dn0w6")
]).then(()=>parcelRequire('6ItgB'));

});


parcelRegister("eQtOf", function(module, exports) {

$parcel$export(module.exports, "legacyGinActionRoute", () => $2224005331cc0d83$export$796a8e79b017f80d);
const $2224005331cc0d83$export$796a8e79b017f80d = {
    name: 'legacy-gin-action',
    path: '/secure/IssueNavAction!default.jspa',
    query: [
        'filter|jql|issueKey'
    ]
};

});


parcelRegister("gtzhv", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkRouteEntry", () => $afe1107a0fea55fd$export$fa36e59125fc7266);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $1dIfn = parcelRequire("1dIfn");
const $afe1107a0fea55fd$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $afe1107a0fea55fd$export$fa36e59125fc7266 = (0, $bAJhM.createLegacyEntry)((0, $1dIfn.legacyGinBulkRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$afe1107a0fea55fd$var$pageEntryPoint
    }));

});
parcelRegister("1dIfn", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkRoute", () => $9bd27c6aa70e22c7$export$73e4833202a78627);
const $9bd27c6aa70e22c7$export$73e4833202a78627 = {
    name: 'legacy-gin-bulk',
    path: '/secure/Bulk(\\w+)([!%]?[\\w]*).jspa'
};

});


parcelRegister("aLMek", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkeditRouteEntry", () => $f9514ccc3e07c4ae$export$f591688aa6cd2d3);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $94ZkQ = parcelRequire("94ZkQ");
const $f9514ccc3e07c4ae$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $f9514ccc3e07c4ae$export$f591688aa6cd2d3 = (0, $bAJhM.createLegacyEntry)((0, $94ZkQ.legacyGinBulkeditRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$f9514ccc3e07c4ae$var$pageEntryPoint
    }));

});
parcelRegister("94ZkQ", function(module, exports) {

$parcel$export(module.exports, "legacyGinBulkeditRoute", () => $224c4db9fe3d6b57$export$7c8f48fad7f31e42);
const $224c4db9fe3d6b57$export$7c8f48fad7f31e42 = {
    name: 'legacy-gin-bulkedit',
    path: '/(secure/views|issue)/bulkedit/Bulk(\\w+)([!%]?[\\w]*).jspa'
};

});


parcelRegister("91XPM", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueAssignRouteEntry", () => $047d88b4edc2a673$export$b7bc71c8e27d96);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $63nbU = parcelRequire("63nbU");
const $047d88b4edc2a673$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $047d88b4edc2a673$export$b7bc71c8e27d96 = (0, $bAJhM.createLegacyEntry)((0, $63nbU.legacyGinIssueAssignRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$047d88b4edc2a673$var$pageEntryPoint
    }));

});
parcelRegister("63nbU", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueAssignRoute", () => $6d89f19ebeff2cdc$export$6cc1fcd71b2e06ad);
const $6d89f19ebeff2cdc$export$6cc1fcd71b2e06ad = {
    name: 'legacy-gin-issue-assign',
    path: '/secure/(\\w*)AssignIssue([!%]?[\\w]*).jspa'
};

});


parcelRegister("3Mqis", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCloneRouteEntry", () => $c94227045a4daba8$export$b54f23b666808992);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $2Ccgh = parcelRequire("2Ccgh");
const $c94227045a4daba8$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $c94227045a4daba8$export$b54f23b666808992 = (0, $bAJhM.createLegacyEntry)((0, $2Ccgh.legacyGinIssueCloneRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$c94227045a4daba8$var$pageEntryPoint
    }));

});
parcelRegister("2Ccgh", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCloneRoute", () => $05ba1272e3bdd4ab$export$55ba9c8834c09ade);
const $05ba1272e3bdd4ab$export$55ba9c8834c09ade = {
    name: 'legacy-gin-issue-clone',
    path: '/(secure|issue)/CloneIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("62ivL", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueConvertRouteEntry", () => $3ee461f25fb50c9d$export$45f0108fe367a800);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $3qJP0 = parcelRequire("3qJP0");
const $3ee461f25fb50c9d$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $3ee461f25fb50c9d$export$45f0108fe367a800 = (0, $bAJhM.createLegacyEntry)((0, $3qJP0.legacyGinIssueConvertRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$3ee461f25fb50c9d$var$pageEntryPoint
    }));

});
parcelRegister("3qJP0", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueConvertRoute", () => $505c4ea732b4ca67$export$338f229cb5c21a79);
const $505c4ea732b4ca67$export$338f229cb5c21a79 = {
    name: 'legacy-gin-issue-convert',
    path: '/secure/ConvertIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("fufI0", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCreateRouteEntry", () => $90250b1eede01e8a$export$86ab2339e662875a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $fjsSz = parcelRequire("fjsSz");
const $90250b1eede01e8a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $90250b1eede01e8a$export$86ab2339e662875a = (0, $bAJhM.createLegacyEntry)((0, $fjsSz.legacyGinIssueCreateRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$90250b1eede01e8a$var$pageEntryPoint
    }));

});
parcelRegister("fjsSz", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueCreateRoute", () => $933e3cdc368843b7$export$f27db894d3724085);
const $933e3cdc368843b7$export$f27db894d3724085 = {
    name: 'legacy-gin-issue-create',
    path: '(/secure/|/)CreateIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("hH0zn", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueEditRouteEntry", () => $67248e3b81bc5b1e$export$944b36cf4b5cef62);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $8nQ2K = parcelRequire("8nQ2K");
const $67248e3b81bc5b1e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $67248e3b81bc5b1e$export$944b36cf4b5cef62 = (0, $bAJhM.createLegacyEntry)((0, $8nQ2K.legacyGinIssueEditRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$67248e3b81bc5b1e$var$pageEntryPoint
    }));

});
parcelRegister("8nQ2K", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueEditRoute", () => $60a0a1d4c0e7cc91$export$5286735392e527fb);
const $60a0a1d4c0e7cc91$export$5286735392e527fb = {
    name: 'legacy-gin-issue-edit',
    path: '/secure/EditIssue([!%]?[\\w]*).jspaa'
};

});


parcelRegister("5lZQR", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueMoveRouteEntry", () => $6e528896df9f7e72$export$9c2ab973bb46413b);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $dutp3 = parcelRequire("dutp3");
const $6e528896df9f7e72$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $6e528896df9f7e72$export$9c2ab973bb46413b = (0, $bAJhM.createLegacyEntry)((0, $dutp3.legacyGinIssueMoveRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$6e528896df9f7e72$var$pageEntryPoint
    }));

});
parcelRegister("dutp3", function(module, exports) {

$parcel$export(module.exports, "legacyGinIssueMoveRoute", () => $cf494313c0038302$export$338e257c93d678f9);
const $cf494313c0038302$export$338e257c93d678f9 = {
    name: 'legacy-gin-issue-move',
    path: '/secure/MoveIssue(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("83qWW", function(module, exports) {

$parcel$export(module.exports, "legacyGinManageRouteEntry", () => $d01000e0dfd2ff20$export$2b56a5623615dd47);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $ftFEp = parcelRequire("ftFEp");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $cYTI6 = parcelRequire("cYTI6");
const $d01000e0dfd2ff20$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).FILTERS
});
const $d01000e0dfd2ff20$export$2b56a5623615dd47 = (0, $bAJhM.createLegacyEntry)((0, $cYTI6.legacyGinManageRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS,
            sidebar: (0, $ftFEp.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$d01000e0dfd2ff20$var$pageEntryPoint
    }));

});
parcelRegister("cYTI6", function(module, exports) {

$parcel$export(module.exports, "legacyGinManageRoute", () => $f4bb8e65351cafec$export$e6c509778313a0c1);
const $f4bb8e65351cafec$export$e6c509778313a0c1 = {
    name: 'legacy-gin-manage',
    path: '(/secure/|/)ManageFilters.jspa'
};

});


parcelRegister("T1dvB", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionEditRouteEntry", () => $3d9dde665d3d9c93$export$5255243cc56f26c3);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $ftFEp = parcelRequire("ftFEp");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $ktQkD = parcelRequire("ktQkD");
const $3d9dde665d3d9c93$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).FILTERS
});
const $3d9dde665d3d9c93$export$5255243cc56f26c3 = (0, $bAJhM.createLegacyEntry)((0, $ktQkD.legacyGinSubscriptionEditRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS,
            sidebar: (0, $ftFEp.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$3d9dde665d3d9c93$var$pageEntryPoint
    }));

});
parcelRegister("ktQkD", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionEditRoute", () => $6ef7f228c14a70a1$export$20e6c550a55cf8f4);
const $6ef7f228c14a70a1$export$20e6c550a55cf8f4 = {
    name: 'legacy-gin-subscription-edit',
    path: '(/secure/|/)EditSubscription([!%]?[\\w]*).jspa'
};

});


parcelRegister("gYqAI", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionsRouteEntry", () => $c1df2132b89ac6d2$export$e739dd8af3aee54a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $ftFEp = parcelRequire("ftFEp");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $7A66G = parcelRequire("7A66G");
const $c1df2132b89ac6d2$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).FILTERS
});
const $c1df2132b89ac6d2$export$e739dd8af3aee54a = (0, $bAJhM.createLegacyEntry)((0, $7A66G.legacyGinSubscriptionsRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS,
            sidebar: (0, $ftFEp.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c1df2132b89ac6d2$var$pageEntryPoint
    }));

});
parcelRegister("7A66G", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubscriptionsRoute", () => $7394f9b85734bd6d$export$cbcaf00bd4f92b0);
const $7394f9b85734bd6d$export$cbcaf00bd4f92b0 = {
    name: 'legacy-gin-subscriptions',
    path: '(/secure/|/)ViewSubscriptions([!%]?[\\w]*).jspa'
};

});


parcelRegister("1rErS", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubtaskActionRouteEntry", () => $fb0ff745f2f37b8e$export$31f29cb95c5903fc);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $demUW = parcelRequire("demUW");
const $fb0ff745f2f37b8e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $fb0ff745f2f37b8e$export$31f29cb95c5903fc = (0, $bAJhM.createLegacyEntry)((0, $demUW.legacyGinSubtaskActionRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$fb0ff745f2f37b8e$var$pageEntryPoint
    }));

});
parcelRegister("demUW", function(module, exports) {

$parcel$export(module.exports, "legacyGinSubtaskActionRoute", () => $3ce82ce54e0eccaf$export$d9c87b9b27d73f7c);
const $3ce82ce54e0eccaf$export$d9c87b9b27d73f7c = {
    name: 'legacy-gin-subtask-action',
    path: '/secure/(Move|Convert)SubTask(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("9NDvE", function(module, exports) {

$parcel$export(module.exports, "legacyGinWatchersIssueRouteEntry", () => $e76d720fcfbfda54$export$97a124d7b834ca82);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $i3bH4 = parcelRequire("i3bH4");
const $e76d720fcfbfda54$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $e76d720fcfbfda54$export$97a124d7b834ca82 = (0, $bAJhM.createLegacyEntry)((0, $i3bH4.legacyGinWatchersIssueRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$e76d720fcfbfda54$var$pageEntryPoint
    }));

});
parcelRegister("i3bH4", function(module, exports) {

$parcel$export(module.exports, "legacyGinWatchersIssueRoute", () => $38ca20516bd36cc7$export$b3198e66bf5d49ae);
const $38ca20516bd36cc7$export$b3198e66bf5d49ae = {
    name: 'legacy-gin-watchers-issue',
    path: '/secure/ManageWatchers!default.jspa'
};

});


parcelRegister("effUy", function(module, exports) {

$parcel$export(module.exports, "globalAutomationRouteEntry", () => $b9f8c212e76dc7b1$export$652cb0c5f80823c0);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $bQ0O9 = parcelRequire("bQ0O9");
const $b9f8c212e76dc7b1$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b9f8c212e76dc7b1$export$652cb0c5f80823c0 = (0, $bAJhM.createLegacyEntry)((0, $bQ0O9.globalAutomationRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b9f8c212e76dc7b1$var$pageEntryPoint
    }));

});
parcelRegister("bQ0O9", function(module, exports) {

$parcel$export(module.exports, "globalAutomationRoute", () => $b38de55a81a6c3e7$export$5276d514cac1db59);
const $b38de55a81a6c3e7$export$5276d514cac1db59 = {
    name: 'global-automation',
    path: '/secure/Automation([!%]?[\\w]*).jspa'
};

});


parcelRegister("69omQ", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseRouteEntry", () => $4b80d614a7e8e7f1$export$b1b791616cdb9491);

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $ftFEp = parcelRequire("ftFEp");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $6tSfI = parcelRequire("6tSfI");

var $k3hRi = parcelRequire("k3hRi");
const $4b80d614a7e8e7f1$export$b1b791616cdb9491 = (0, $bAJhM.createLegacyEntry)((0, $k3hRi.globalIssueNavigatorBrowseRoute), ()=>({
        canTransitionIn: ()=>false,
        component: (0, $6tSfI.LegacyPage),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS,
            sidebar: (0, $ftFEp.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("k3hRi", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorBrowseRoute", () => $10ad0dc6dbd44e91$export$c1b37e392499fccf);
const $10ad0dc6dbd44e91$export$c1b37e392499fccf = {
    name: 'legacy-gin-issue',
    path: '/browse/:issueKey?',
    query: [
        'jql|filter'
    ]
};

});


parcelRegister("l7ZAX", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRedirectRouteEntry", () => $8368e0fafe146f8b$export$8cbe781346b8b4a2);

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $ftFEp = parcelRequire("ftFEp");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $6tSfI = parcelRequire("6tSfI");

var $fE5nW = parcelRequire("fE5nW");
const $8368e0fafe146f8b$export$8cbe781346b8b4a2 = (0, $bAJhM.createLegacyEntry)((0, $fE5nW.globalIssueNavigatorRedirectRoute), ()=>({
        canTransitionIn: ()=>false,
        component: (0, $6tSfI.LegacyPage),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS,
            sidebar: (0, $ftFEp.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("fE5nW", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRedirectRoute", () => $ea5f65e8d939ca6a$export$b2cd2888fd62d62e);
const $ea5f65e8d939ca6a$export$b2cd2888fd62d62e = {
    name: 'legacy-gin-quicksearch',
    path: '/secure/QuickSearch.jspa',
    query: [
        'searchString'
    ]
};

});


parcelRegister("fH85f", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRouteEntry", () => $ccc300af2594e7e7$export$690b5fd7062ce607);

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $ftFEp = parcelRequire("ftFEp");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $5Wtrd = parcelRequire("5Wtrd");

var $7V1Zt = parcelRequire("7V1Zt");
const $ccc300af2594e7e7$export$690b5fd7062ce607 = (0, $bAJhM.createLegacyEntry)((0, $5Wtrd.globalIssueNavigatorRoute), ()=>({
        apdexIgnoreParams: [
            'issueKey'
        ],
        canTransitionIn: ()=>false,
        component: (0, $7V1Zt.LegacyPageWithTeamProfileCardView),
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).FILTERS,
            sidebar: (0, $ftFEp.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("5Wtrd", function(module, exports) {

$parcel$export(module.exports, "globalIssueNavigatorRoute", () => $9bf9b37176e0373e$export$f4c8e8bc55cd2008);
const $9bf9b37176e0373e$export$f4c8e8bc55cd2008 = {
    name: 'legacy-gin',
    path: '/issues/:issueKey(.*)?'
};

});

parcelRegister("7V1Zt", function(module, exports) {

$parcel$export(module.exports, "LegacyPageWithTeamProfileCardView", () => $66c7c4a73318f51c$export$bc3f01ea4ac19d59);

var $eJOHy = parcelRequire("eJOHy");

var $hpLhu = parcelRequire("hpLhu");

var $3Ei7t = parcelRequire("3Ei7t");

var $6tSfI = parcelRequire("6tSfI");
const $66c7c4a73318f51c$export$bc3f01ea4ac19d59 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tSfI.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hpLhu.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Ei7t.default), null));

});
parcelRegister("hpLhu", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc9951a55c561de9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dc9951a55c561de9$var$OpenHelpPanelLinkThroughEventListener = (0, $bQWwW.lazy)(()=>(parcelRequire("lXDEi")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/help-panel-button/src/services/open-help-panel-link-through-event-listener/index.tsx"
});
const $dc9951a55c561de9$export$9b28d5c0f56030a7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "open-help-panel-link-through-event-listener",
        packageName: "jira-help-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-open-help-panel-link-through-event-listener",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($dc9951a55c561de9$var$OpenHelpPanelLinkThroughEventListener, null)));
var $dc9951a55c561de9$export$2e2bcd8739ae039 = $dc9951a55c561de9$export$9b28d5c0f56030a7;

});
parcelRegister("lXDEi", function(module, exports) {

let $ffcddd1f17b70ca9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ffcddd1f17b70ca9$var$load("2yd6V").then(()=>parcelRequire('jXFJi'));

});


parcelRegister("3Ei7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b00ff8b766311813$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b00ff8b766311813$var$LegacyTeamProfileCard = (0, $bQWwW.lazy)(()=>(parcelRequire("82RZY")), {
    moduleId: "./src/packages/profilecard-next/src/ui/team-profilecard-legacy/index.tsx"
});
const $b00ff8b766311813$export$c8a3662e461b7707 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "legacy-team-profile-card",
        packageName: "profilecard-next"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-legacy-team-profile-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b00ff8b766311813$var$LegacyTeamProfileCard, props)));
var $b00ff8b766311813$export$2e2bcd8739ae039 = $b00ff8b766311813$export$c8a3662e461b7707;

});
parcelRegister("82RZY", function(module, exports) {

let $5db8659eab78f8e3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5db8659eab78f8e3$var$load("ffQaD"),
    $5db8659eab78f8e3$var$load("kvRbA"),
    $5db8659eab78f8e3$var$load("kVX56"),
    $5db8659eab78f8e3$var$load("a48bl")
]).then(()=>parcelRequire('dzW1r'));

});




parcelRegister("3McBT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsAddonsOauthRouteEntry", () => $b5467fc34f61f7bb$export$b674e2feb3ded4d1);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $iDY55 = parcelRequire("iDY55");
const $b5467fc34f61f7bb$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b5467fc34f61f7bb$export$b674e2feb3ded4d1 = (0, $bAJhM.createLegacyEntry)((0, $iDY55.globalSettingsAddonsOauthRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)()
        ],
        entryPoint: ()=>$b5467fc34f61f7bb$var$pageEntryPoint
    }));

});
parcelRegister("iDY55", function(module, exports) {

$parcel$export(module.exports, "globalSettingsAddonsOauthRoute", () => $906b89570b898302$export$13884c00b567e541);
const $906b89570b898302$export$13884c00b567e541 = {
    name: 'global-settings-addons-oauth',
    path: '/secure/oauth-credentials'
};

});


parcelRegister("cOPPu", function(module, exports) {

$parcel$export(module.exports, "emceeAppRouteEntry", () => $7557f33eeab5c538$export$881c7d683ab02802);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $6tSfI = parcelRequire("6tSfI");

var $dAdwz = parcelRequire("dAdwz");
const $7557f33eeab5c538$export$881c7d683ab02802 = (0, $bAJhM.createLegacyEntry)((0, $dAdwz.emceeAppRoute), ()=>({
        canTransitionIn: ()=>false,
        component: (0, $6tSfI.LegacyPage),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)()
        ]
    }));

});
parcelRegister("dAdwz", function(module, exports) {

$parcel$export(module.exports, "emceeAppRoute", () => $d8b2a6fd32f86d54$export$5149e7851c6c4f53);
const $d8b2a6fd32f86d54$export$5149e7851c6c4f53 = {
    name: 'global-settings-addons-emcee',
    path: '/plugins/servlet/ac/com.atlassian.jira.emcee:environment(.?[\\w.]*)?/:page'
};

});


parcelRegister("9px2T", function(module, exports) {

$parcel$export(module.exports, "manageAppsRouteEntry", () => $34e2fb42a0fca5f6$export$4ce557e11b5e9d68);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $gKFn0 = parcelRequire("gKFn0");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $6tSfI = parcelRequire("6tSfI");

var $5YSBe = parcelRequire("5YSBe");
const $34e2fb42a0fca5f6$export$4ce557e11b5e9d68 = (0, $bAJhM.createLegacyEntry)((0, $5YSBe.manageAppsRoute), ()=>({
        canTransitionIn: ()=>false,
        component: (0, $6tSfI.LegacyPage),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
            menuId: (0, $5RW99.MENU_ID).ADDONS,
            sidebar: (0, $gKFn0.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)()
        ]
    }));

});
parcelRegister("5YSBe", function(module, exports) {

$parcel$export(module.exports, "manageAppsRoute", () => $53c4d48f73619d4d$export$d5409be3b4016aab);
const $53c4d48f73619d4d$export$d5409be3b4016aab = {
    name: 'global-settings-addons-upm',
    path: '/plugins/servlet/upm'
};

});


parcelRegister("j5kwX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", () => $331258353b4aaec9$export$d83c2e469d070766);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $3Tj9W = parcelRequire("3Tj9W");

var $5fjzQ = parcelRequire("5fjzQ");
const $331258353b4aaec9$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $331258353b4aaec9$export$d83c2e469d070766 = (0, $bAJhM.createLegacyEntry)((0, $3Tj9W.globalSettingsCustomFieldsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$331258353b4aaec9$var$pageEntryPoint
    }));

});
parcelRegister("3Tj9W", function(module, exports) {

$parcel$export(module.exports, "globalSettingsCustomFieldsRoute", () => $ecd84c670bc8cdd2$export$45e7d93edcc9507f);
const $ecd84c670bc8cdd2$export$45e7d93edcc9507f = {
    name: 'global-settings-issues-custom-fields-view',
    path: '/secure/admin/ViewCustomFields.jspa'
};

});


parcelRegister("8PgUz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRouteEntry", () => $0fda3903efd2bcd2$export$c493b601f2512cdb);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $bjxTM = parcelRequire("bjxTM");

var $5fjzQ = parcelRequire("5fjzQ");
const $0fda3903efd2bcd2$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $0fda3903efd2bcd2$export$c493b601f2512cdb = (0, $bAJhM.createLegacyEntry)((0, $bjxTM.globalSettingsFieldLayoutSchemesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$0fda3903efd2bcd2$var$pageEntryPoint
    }));

});
parcelRegister("bjxTM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutSchemesRoute", () => $1e7b1171305f2f78$export$6e04f01d8f54ad08);
const $1e7b1171305f2f78$export$6e04f01d8f54ad08 = {
    name: 'global-settings-issues-fieldlayouts-schemes-view',
    path: '/secure/admin/ViewFieldLayoutSchemes.jspa'
};

});


parcelRegister("dn8g8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutsRouteEntry", () => $bc3eaffba048be6b$export$9988358457e7d230);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $eH7B2 = parcelRequire("eH7B2");

var $5fjzQ = parcelRequire("5fjzQ");
const $bc3eaffba048be6b$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $bc3eaffba048be6b$export$9988358457e7d230 = (0, $bAJhM.createLegacyEntry)((0, $eH7B2.globalSettingsFieldLayoutsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$bc3eaffba048be6b$var$pageEntryPoint
    }));

});
parcelRegister("eH7B2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsFieldLayoutsRoute", () => $c0e90c886fac453b$export$ead41dd3ea1da5b3);
const $c0e90c886fac453b$export$ead41dd3ea1da5b3 = {
    name: 'global-settings-issues-fieldlayouts-view',
    path: '/secure/admin/ViewFieldLayouts.jspa'
};

});


parcelRegister("bidOp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueSubtasksRouteEntry", () => $1d8ba0e5a100bf10$export$625e23490e28fdb5);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $5i3Re = parcelRequire("5i3Re");

var $5fjzQ = parcelRequire("5fjzQ");
const $1d8ba0e5a100bf10$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $1d8ba0e5a100bf10$export$625e23490e28fdb5 = (0, $bAJhM.createLegacyEntry)((0, $5i3Re.globalSettingsIssueSubtasksRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$1d8ba0e5a100bf10$var$pageEntryPoint
    }));

});
parcelRegister("5i3Re", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueSubtasksRoute", () => $0dcc259a57efb2f7$export$1327adfb7eea6607);
const $0dcc259a57efb2f7$export$1327adfb7eea6607 = {
    name: 'global-settings-issues-subtasks-manage',
    path: '/secure/admin/subtasks/ManageSubTasks.jspa'
};

});


parcelRegister("5bHK3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTimeTrackingRouteEntry", () => $0a32490a228fb039$export$ad6c1602c9fe5020);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $bS2VX = parcelRequire("bS2VX");

var $5fjzQ = parcelRequire("5fjzQ");
const $0a32490a228fb039$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $0a32490a228fb039$export$ad6c1602c9fe5020 = (0, $bAJhM.createLegacyEntry)((0, $bS2VX.globalSettingsIssueTimeTrackingRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$0a32490a228fb039$var$pageEntryPoint
    }));

});
parcelRegister("bS2VX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueTimeTrackingRoute", () => $06a4a9eb0e47d2d8$export$8596beec8543d958);
// like !default / !edit / %21viewLogs
const $06a4a9eb0e47d2d8$export$8596beec8543d958 = {
    name: 'global-settings-issues-time-tracking',
    path: '/secure/admin/TimeTrackingAdmin([!%]?[\\w]*).jspa'
};

});


parcelRegister("ktEsE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowRouteEntry", () => $532e85036ae8a483$export$460b4d1709d73a2e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $b7cWf = parcelRequire("b7cWf");

var $5fjzQ = parcelRequire("5fjzQ");
const $532e85036ae8a483$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $532e85036ae8a483$export$460b4d1709d73a2e = (0, $bAJhM.createLegacyEntry)((0, $b7cWf.globalSettingsIssueWorkflowRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$532e85036ae8a483$var$pageEntryPoint
    }));

});
parcelRegister("b7cWf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowRoute", () => $a5d3b7de0cfeab20$export$83c76a9f38e044d2);
const $a5d3b7de0cfeab20$export$83c76a9f38e044d2 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/secure/admin/workflows/:page'
};

});


parcelRegister("22SFa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRouteEntry", () => $df4d3e15e1d220f8$export$cfc4572fe7838d46);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $eruko = parcelRequire("eruko");

var $5fjzQ = parcelRequire("5fjzQ");
const $df4d3e15e1d220f8$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $df4d3e15e1d220f8$export$cfc4572fe7838d46 = (0, $bAJhM.createLegacyEntry)((0, $eruko.globalSettingsIssueWorkflowSchemesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$df4d3e15e1d220f8$var$pageEntryPoint
    }));

});
parcelRegister("eruko", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssueWorkflowSchemesRoute", () => $5195cfb1a744dd5f$export$fabaf6e717c3f1b6);
const $5195cfb1a744dd5f$export$fabaf6e717c3f1b6 = {
    name: 'global-settings-issues-workflows-schemes-view',
    path: '/secure/admin/ViewWorkflowSchemes.jspa'
};

});


parcelRegister("7j07r", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRouteEntry", () => $731df63598d9a474$export$580990afd7fb8505);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $8z3m3 = parcelRequire("8z3m3");
const $731df63598d9a474$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $731df63598d9a474$export$580990afd7fb8505 = (0, $bAJhM.createLegacyEntry)((0, $8z3m3.globalSettingsIssuesCustomFieldsAssociateRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$731df63598d9a474$var$pageEntryPoint
    }));

});
parcelRegister("8z3m3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsAssociateRoute", () => $c43f307413ed1353$export$4e17e29838928fe7);
const $c43f307413ed1353$export$4e17e29838928fe7 = {
    name: 'global-settings-issues-custom-fields-associate',
    path: '/secure/admin/AssociateFieldToScreens!default.jspa'
};

});


parcelRegister("hZhdy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRouteEntry", () => $72bc68d6c33fa1fb$export$f2078b26bfdef553);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $2OfK9 = parcelRequire("2OfK9");
const $72bc68d6c33fa1fb$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $72bc68d6c33fa1fb$export$f2078b26bfdef553 = (0, $bAJhM.createLegacyEntry)((0, $2OfK9.globalSettingsIssuesCustomFieldsConfigRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$72bc68d6c33fa1fb$var$pageEntryPoint
    }));

});
parcelRegister("2OfK9", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsConfigRoute", () => $5de291a05527e4a1$export$db330236178a2eb2);
const $5de291a05527e4a1$export$db330236178a2eb2 = {
    name: 'global-settings-issues-custom-fields-config',
    path: '/secure/admin/ConfigureCustomField!default.jspa'
};

});


parcelRegister("kIGfb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRouteEntry", () => $bdd541354280342c$export$504c6fb2862492a1);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $9ZUFb = parcelRequire("9ZUFb");
const $bdd541354280342c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $bdd541354280342c$export$504c6fb2862492a1 = (0, $bAJhM.createLegacyEntry)((0, $9ZUFb.globalSettingsIssuesCustomFieldsDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$bdd541354280342c$var$pageEntryPoint
    }));

});
parcelRegister("9ZUFb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsDeleteRoute", () => $8fc0bb601e8857c8$export$36f7f639e35c6980);
const $8fc0bb601e8857c8$export$36f7f639e35c6980 = {
    name: 'global-settings-issues-custom-fields-delete',
    path: '/secure/admin/DeleteCustomField!default.jspa'
};

});


parcelRegister("99HLd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRouteEntry", () => $3962b18bf7037f19$export$68ff9a44323b27ca);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $cQpwp = parcelRequire("cQpwp");
const $3962b18bf7037f19$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $3962b18bf7037f19$export$68ff9a44323b27ca = (0, $bAJhM.createLegacyEntry)((0, $cQpwp.globalSettingsIssuesCustomFieldsEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$3962b18bf7037f19$var$pageEntryPoint
    }));

});
parcelRegister("cQpwp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsEditRoute", () => $c441eb2e38333482$export$ca7a3fa1760c59bf);
const $c441eb2e38333482$export$ca7a3fa1760c59bf = {
    name: 'global-settings-issues-custom-fields-edit',
    path: '/secure/admin/EditCustomField(\\w*)!default.jspa'
};

});


parcelRegister("eDlwW", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRouteEntry", () => $3adfbb4760920d3b$export$12970e70b4c77f98);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $2OGvZ = parcelRequire("2OGvZ");
const $3adfbb4760920d3b$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $3adfbb4760920d3b$export$12970e70b4c77f98 = (0, $bAJhM.createLegacyEntry)((0, $2OGvZ.globalSettingsIssuesCustomFieldsManageRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$3adfbb4760920d3b$var$pageEntryPoint
    }));

});
parcelRegister("2OGvZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsManageRoute", () => $43b755a264102cb5$export$441ab7e26eb9710);
const $43b755a264102cb5$export$441ab7e26eb9710 = {
    name: 'global-settings-issues-custom-fields-manage',
    path: '/secure/admin/ManageConfigurationScheme!default.jspa'
};

});


parcelRegister("i2l2X", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRouteEntry", () => $c1a11cf97ca44284$export$df186d4a4dcc70d6);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $kQTdR = parcelRequire("kQTdR");
const $c1a11cf97ca44284$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $c1a11cf97ca44284$export$df186d4a4dcc70d6 = (0, $bAJhM.createLegacyEntry)((0, $kQTdR.globalSettingsIssuesCustomFieldsTranslateRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c1a11cf97ca44284$var$pageEntryPoint
    }));

});
parcelRegister("kQTdR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesCustomFieldsTranslateRoute", () => $09ba2d5b7140cb53$export$13f985d12cff8c13);
const $09ba2d5b7140cb53$export$13f985d12cff8c13 = {
    name: 'global-settings-issues-custom-fields-translate',
    path: '/secure/admin/TranslateCustomField!default.jspa'
};

});


parcelRegister("fivSn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldAddRouteEntry", () => $205d1bcbecaa802c$export$a0f9d2aa72494978);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $eIcaV = parcelRequire("eIcaV");
const $205d1bcbecaa802c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $205d1bcbecaa802c$export$a0f9d2aa72494978 = (0, $bAJhM.createLegacyEntry)((0, $eIcaV.globalSettingsIssuesFieldAddRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$205d1bcbecaa802c$var$pageEntryPoint
    }));

});
parcelRegister("eIcaV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldAddRoute", () => $534f9289640b77fb$export$7bb3a869061a8016);
const $534f9289640b77fb$export$7bb3a869061a8016 = {
    name: 'global-settings-issues-field-add',
    path: '/secure/admin/AddNewFieldScreen.jspa'
};

});


parcelRegister("3wKhX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRouteEntry", () => $1b3022a1f2759198$export$26b162cdb704f0a0);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $kFnv2 = parcelRequire("kFnv2");
const $1b3022a1f2759198$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $1b3022a1f2759198$export$26b162cdb704f0a0 = (0, $bAJhM.createLegacyEntry)((0, $kFnv2.globalSettingsIssuesFieldConfigureEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$1b3022a1f2759198$var$pageEntryPoint
    }));

});
parcelRegister("kFnv2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureEditRoute", () => $31a67eca3a5842bf$export$37908ebd0fc6f94c);
const $31a67eca3a5842bf$export$37908ebd0fc6f94c = {
    name: 'global-settings-issues-field-configure-edit',
    path: '/secure/admin/EditDefaultFieldLayoutItem!default.jspa'
};

});


parcelRegister("cmefl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRouteEntry", () => $eb9f06b17433082f$export$ce20a01bf6cc22e8);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $82cFi = parcelRequire("82cFi");
const $eb9f06b17433082f$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $eb9f06b17433082f$export$ce20a01bf6cc22e8 = (0, $bAJhM.createLegacyEntry)((0, $82cFi.globalSettingsIssuesFieldConfigureRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$eb9f06b17433082f$var$pageEntryPoint
    }));

});
parcelRegister("82cFi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldConfigureRoute", () => $b9bd752746240853$export$47585e3c198123be);
const $b9bd752746240853$export$47585e3c198123be = {
    name: 'global-settings-issues-field-configure',
    path: '/secure/admin/ConfigureFieldScreen.jspa'
};

});


parcelRegister("ihtJL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldCopyRouteEntry", () => $81adb75b6e0e2e99$export$4d899a20474ade0);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $lWIfp = parcelRequire("lWIfp");
const $81adb75b6e0e2e99$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $81adb75b6e0e2e99$export$4d899a20474ade0 = (0, $bAJhM.createLegacyEntry)((0, $lWIfp.globalSettingsIssuesFieldCopyRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$81adb75b6e0e2e99$var$pageEntryPoint
    }));

});
parcelRegister("lWIfp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldCopyRoute", () => $03b90531dfa9be7a$export$ec5bbfc3593b01b7);
const $03b90531dfa9be7a$export$ec5bbfc3593b01b7 = {
    name: 'global-settings-issues-field-copy',
    path: '/secure/admin/ViewCopyFieldScreen.jspa'
};

});


parcelRegister("lu5oo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRouteEntry", () => $8b576d03b0448b63$export$9170e2ce6999793e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $bh85L = parcelRequire("bh85L");
const $8b576d03b0448b63$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $8b576d03b0448b63$export$9170e2ce6999793e = (0, $bAJhM.createLegacyEntry)((0, $bh85L.globalSettingsIssuesFieldDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8b576d03b0448b63$var$pageEntryPoint
    }));

});
parcelRegister("bh85L", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldDeleteRoute", () => $825f8dd4770bd08d$export$9a0bc2a1c24ad312);
const $825f8dd4770bd08d$export$9a0bc2a1c24ad312 = {
    name: 'global-settings-issues-field-delete',
    path: '/secure/admin/ViewDeleteFieldScreen.jspa'
};

});


parcelRegister("7zpYc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldEditRouteEntry", () => $71d81eea42de33bb$export$4f6f7197ee5fbd88);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $9FPg5 = parcelRequire("9FPg5");
const $71d81eea42de33bb$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $71d81eea42de33bb$export$4f6f7197ee5fbd88 = (0, $bAJhM.createLegacyEntry)((0, $9FPg5.globalSettingsIssuesFieldEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$71d81eea42de33bb$var$pageEntryPoint
    }));

});
parcelRegister("9FPg5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldEditRoute", () => $9c10d8926a272821$export$e41329d1f04b5b51);
const $9c10d8926a272821$export$e41329d1f04b5b51 = {
    name: 'global-settings-issues-field-edit',
    path: '/secure/admin/EditFieldScreen!default.jspa'
};

});


parcelRegister("8Mzfn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRouteEntry", () => $6fcab28fc595588c$export$3a842eb59e795637);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $2deOV = parcelRequire("2deOV");
const $6fcab28fc595588c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $6fcab28fc595588c$export$3a842eb59e795637 = (0, $bAJhM.createLegacyEntry)((0, $2deOV.globalSettingsIssuesFieldSchemesAddRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$6fcab28fc595588c$var$pageEntryPoint
    }));

});
parcelRegister("2deOV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesAddRoute", () => $bef88b7756319a6e$export$8b20e975ade5b676);
const $bef88b7756319a6e$export$8b20e975ade5b676 = {
    name: 'global-settings-issues-field-schemes-add',
    path: '/secure/admin/AddFieldConfigurationScheme!default.jspa'
};

});


parcelRegister("huZ9p", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRouteEntry", () => $a100288492c8f811$export$5f5a8b65a56acfea);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $ghiKG = parcelRequire("ghiKG");
const $a100288492c8f811$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $a100288492c8f811$export$5f5a8b65a56acfea = (0, $bAJhM.createLegacyEntry)((0, $ghiKG.globalSettingsIssuesFieldSchemesConfigureRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a100288492c8f811$var$pageEntryPoint
    }));

});
parcelRegister("ghiKG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesConfigureRoute", () => $ec98166024dac06a$export$6401bf37dfa17226);
const $ec98166024dac06a$export$6401bf37dfa17226 = {
    name: 'global-settings-issues-field-schemes-configure',
    path: '/secure/admin/ConfigureFieldScreenScheme.jspa'
};

});


parcelRegister("iorJC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRouteEntry", () => $99d3cd0d3dcfc215$export$4c126f203951bdce);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $cvk1S = parcelRequire("cvk1S");
const $99d3cd0d3dcfc215$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $99d3cd0d3dcfc215$export$4c126f203951bdce = (0, $bAJhM.createLegacyEntry)((0, $cvk1S.globalSettingsIssuesFieldSchemesCopyRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$99d3cd0d3dcfc215$var$pageEntryPoint
    }));

});
parcelRegister("cvk1S", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesCopyRoute", () => $cb33e60311492f80$export$195423dd1ef4cf0a);
const $cb33e60311492f80$export$195423dd1ef4cf0a = {
    name: 'global-settings-issues-field-schemes-copy',
    path: '/secure/admin/ViewCopyFieldScreenScheme.jspa'
};

});


parcelRegister("i0Hvl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRouteEntry", () => $7cf23b2768a7e040$export$a4609f789aeed81f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $cNCfQ = parcelRequire("cNCfQ");
const $7cf23b2768a7e040$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $7cf23b2768a7e040$export$a4609f789aeed81f = (0, $bAJhM.createLegacyEntry)((0, $cNCfQ.globalSettingsIssuesFieldSchemesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$7cf23b2768a7e040$var$pageEntryPoint
    }));

});
parcelRegister("cNCfQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesDeleteRoute", () => $b72a41105dd6133d$export$998546ee0d8d0995);
const $b72a41105dd6133d$export$998546ee0d8d0995 = {
    name: 'global-settings-issues-field-schemes-delete',
    path: '/secure/admin/ViewDeleteFieldScreenScheme.jspa'
};

});


parcelRegister("dMa7J", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRouteEntry", () => $7890524410f12a8e$export$aabed4f53fb4f921);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $d0NFi = parcelRequire("d0NFi");
const $7890524410f12a8e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $7890524410f12a8e$export$aabed4f53fb4f921 = (0, $bAJhM.createLegacyEntry)((0, $d0NFi.globalSettingsIssuesFieldSchemesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$7890524410f12a8e$var$pageEntryPoint
    }));

});
parcelRegister("d0NFi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditRoute", () => $5f0187929e7c3aa9$export$c7b713e1fe2e026f);
const $5f0187929e7c3aa9$export$c7b713e1fe2e026f = {
    name: 'global-settings-issues-field-schemes-edit',
    path: '/secure/admin/EditFieldScreenScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("1mEkb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRouteEntry", () => $efe9513ee78fb927$export$e38b78ff4a960db6);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $g3DT5 = parcelRequire("g3DT5");
const $efe9513ee78fb927$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $efe9513ee78fb927$export$e38b78ff4a960db6 = (0, $bAJhM.createLegacyEntry)((0, $g3DT5.globalSettingsIssuesFieldSchemesEditItemRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$efe9513ee78fb927$var$pageEntryPoint
    }));

});
parcelRegister("g3DT5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldSchemesEditItemRoute", () => $692a2360b7724f43$export$4606c3f78e4ec3db);
const $692a2360b7724f43$export$4606c3f78e4ec3db = {
    name: 'global-settings-issues-field-schemes-edit-item',
    path: '/secure/admin/EditFieldScreenSchemeItem([!%]?[\\w]*).jspa'
};

});


parcelRegister("6lhom", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldViewRouteEntry", () => $ac143b2ff05fb032$export$25331ec7b1b8ebfb);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $8PUJi = parcelRequire("8PUJi");
const $ac143b2ff05fb032$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $ac143b2ff05fb032$export$25331ec7b1b8ebfb = (0, $bAJhM.createLegacyEntry)((0, $8PUJi.globalSettingsIssuesFieldViewRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ac143b2ff05fb032$var$pageEntryPoint
    }));

});
parcelRegister("8PUJi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldViewRoute", () => $093ba25b784b8470$export$1a32944e52a128e5);
const $093ba25b784b8470$export$1a32944e52a128e5 = {
    name: 'global-settings-issues-field-view',
    path: '/secure/admin/ViewFieldsScreen.jspa'
};

});


parcelRegister("aTQG3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRouteEntry", () => $b4ce124a9f13565e$export$8946e190202a15c7);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $f6vHv = parcelRequire("f6vHv");
const $b4ce124a9f13565e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b4ce124a9f13565e$export$8946e190202a15c7 = (0, $bAJhM.createLegacyEntry)((0, $f6vHv.globalSettingsIssuesFieldlayoutsConfigRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b4ce124a9f13565e$var$pageEntryPoint
    }));

});
parcelRegister("f6vHv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsConfigRoute", () => $351e9de02d720cc9$export$b469488e0c133a32);
const $351e9de02d720cc9$export$b469488e0c133a32 = {
    name: 'global-settings-issues-fieldlayouts-config',
    path: '/secure/admin/ConfigureFieldLayout([!%]?[\\w]*).jspa'
};

});


parcelRegister("cYYHw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRouteEntry", () => $bb1307dadd4cb63c$export$c4d25de70db36bde);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $hZ4j4 = parcelRequire("hZ4j4");
const $bb1307dadd4cb63c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $bb1307dadd4cb63c$export$c4d25de70db36bde = (0, $bAJhM.createLegacyEntry)((0, $hZ4j4.globalSettingsIssuesFieldlayoutsCopyRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$bb1307dadd4cb63c$var$pageEntryPoint
    }));

});
parcelRegister("hZ4j4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsCopyRoute", () => $ec274834a6f0fd56$export$3a9552d4b0f71408);
const $ec274834a6f0fd56$export$3a9552d4b0f71408 = {
    name: 'global-settings-issues-fieldlayouts-copy',
    path: '/secure/admin/CopyFieldLayout!default.jspa'
};

});


parcelRegister("kF7Lh", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRouteEntry", () => $9c8befaacc4984d3$export$f2dfb8808ab4e2f2);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $i6bA2 = parcelRequire("i6bA2");
const $9c8befaacc4984d3$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $9c8befaacc4984d3$export$f2dfb8808ab4e2f2 = (0, $bAJhM.createLegacyEntry)((0, $i6bA2.globalSettingsIssuesFieldlayoutsDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$9c8befaacc4984d3$var$pageEntryPoint
    }));

});
parcelRegister("i6bA2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsDeleteRoute", () => $9eafb5fa588df35f$export$3ef4c145c5aa96b6);
const $9eafb5fa588df35f$export$3ef4c145c5aa96b6 = {
    name: 'global-settings-issues-fieldlayouts-delete',
    path: '/secure/admin/DeleteFieldLayout!default.jspa'
};

});


parcelRegister("eeg6o", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRouteEntry", () => $8d18a5d93686a13d$export$10710e2f7971e271);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $ixa0A = parcelRequire("ixa0A");
const $8d18a5d93686a13d$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $8d18a5d93686a13d$export$10710e2f7971e271 = (0, $bAJhM.createLegacyEntry)((0, $ixa0A.globalSettingsIssuesFieldlayoutsEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8d18a5d93686a13d$var$pageEntryPoint
    }));

});
parcelRegister("ixa0A", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsEditRoute", () => $165f16fdbe95346e$export$3a0534b35ee08e33);
const $165f16fdbe95346e$export$3a0534b35ee08e33 = {
    name: 'global-settings-issues-fieldlayouts-edit',
    path: '/secure/admin/EditFieldLayout!default.jspa'
};

});


parcelRegister("e1IYH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRouteEntry", () => $da77235c761d2752$export$5b791b0a90dab069);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $80LNG = parcelRequire("80LNG");
const $da77235c761d2752$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $da77235c761d2752$export$5b791b0a90dab069 = (0, $bAJhM.createLegacyEntry)((0, $80LNG.globalSettingsIssuesFieldlayoutsSchemesConfigRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$da77235c761d2752$var$pageEntryPoint
    }));

});
parcelRegister("80LNG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesConfigRoute", () => $d813fcb04813fa87$export$97921be5feed3adf);
const $d813fcb04813fa87$export$97921be5feed3adf = {
    name: 'global-settings-issues-fieldlayouts-schemes-config',
    path: '/secure/admin/ConfigureFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("4mwkU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRouteEntry", () => $a30e5b06c1d63e13$export$e5d2e7b8b7eb3bf5);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $gA0SU = parcelRequire("gA0SU");
const $a30e5b06c1d63e13$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $a30e5b06c1d63e13$export$e5d2e7b8b7eb3bf5 = (0, $bAJhM.createLegacyEntry)((0, $gA0SU.globalSettingsIssuesFieldlayoutsSchemesCopyRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a30e5b06c1d63e13$var$pageEntryPoint
    }));

});
parcelRegister("gA0SU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesCopyRoute", () => $4eab7690f116d596$export$71563f57601b0e2);
const $4eab7690f116d596$export$71563f57601b0e2 = {
    name: 'global-settings-issues-fieldlayouts-schemes-copy',
    path: '/secure/admin/CopyFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("kE2d6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRouteEntry", () => $20bae9b895d04356$export$c1e57f90dca7eb4c);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $3QGge = parcelRequire("3QGge");
const $20bae9b895d04356$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $20bae9b895d04356$export$c1e57f90dca7eb4c = (0, $bAJhM.createLegacyEntry)((0, $3QGge.globalSettingsIssuesFieldlayoutsSchemesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$20bae9b895d04356$var$pageEntryPoint
    }));

});
parcelRegister("3QGge", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesDeleteRoute", () => $26665dd1e6c579c4$export$e1a49cd1071690c4);
const $26665dd1e6c579c4$export$e1a49cd1071690c4 = {
    name: 'global-settings-issues-fieldlayouts-schemes-delete',
    path: '/secure/admin/DeleteFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("ad39g", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRouteEntry", () => $1edd6bd7a3a255ff$export$99138c4ced2f05f7);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $craRn = parcelRequire("craRn");
const $1edd6bd7a3a255ff$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $1edd6bd7a3a255ff$export$99138c4ced2f05f7 = (0, $bAJhM.createLegacyEntry)((0, $craRn.globalSettingsIssuesFieldlayoutsSchemesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$1edd6bd7a3a255ff$var$pageEntryPoint
    }));

});
parcelRegister("craRn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEditRoute", () => $6e01f4b8395e90ae$export$a14fc516b4846e63);
const $6e01f4b8395e90ae$export$a14fc516b4846e63 = {
    name: 'global-settings-issues-fieldlayouts-schemes-edit',
    path: '/secure/admin/EditFieldLayoutScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("7mhuF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRouteEntry", () => $877c6cbd81bef39e$export$a860d5fef4b2c724);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $ktcEg = parcelRequire("ktcEg");
const $877c6cbd81bef39e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $877c6cbd81bef39e$export$a860d5fef4b2c724 = (0, $bAJhM.createLegacyEntry)((0, $ktcEg.globalSettingsIssuesFieldlayoutsSchemesEntityRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$877c6cbd81bef39e$var$pageEntryPoint
    }));

});
parcelRegister("ktcEg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldlayoutsSchemesEntityRoute", () => $4e87f35474751cce$export$54dfcbcea4cc773c);
const $4e87f35474751cce$export$54dfcbcea4cc773c = {
    name: 'global-settings-issues-fieldlayouts-schemes-entity',
    path: '/secure/admin/ViewEditFieldLayoutSchemeEntity([!%]?[\\w]*).jspa'
};

});


parcelRegister("h5nWA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldviewRouteEntry", () => $15213257b2a6c6dd$export$1258f6b3b3168b6a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $699Dr = parcelRequire("699Dr");
const $15213257b2a6c6dd$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $15213257b2a6c6dd$export$1258f6b3b3168b6a = (0, $bAJhM.createLegacyEntry)((0, $699Dr.globalSettingsIssuesFieldviewRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$15213257b2a6c6dd$var$pageEntryPoint
    }));

});
parcelRegister("699Dr", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesFieldviewRoute", () => $8189c789c2a64b4f$export$4e15d6f42067a40d);
const $8189c789c2a64b4f$export$4e15d6f42067a40d = {
    name: 'global-settings-issues-fieldview',
    path: '/secure/admin/ViewIssueFields.jspa'
};

});


parcelRegister("6a3fB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRouteEntry", () => $bd67e020a2c302ab$export$611de8afc4baaba5);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $abudc = parcelRequire("abudc");
const $bd67e020a2c302ab$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $bd67e020a2c302ab$export$611de8afc4baaba5 = (0, $bAJhM.createLegacyEntry)((0, $abudc.globalSettingsIssuesGeneralTranslationsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$bd67e020a2c302ab$var$pageEntryPoint
    }));

});
parcelRegister("abudc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesGeneralTranslationsRoute", () => $d17a08a4ac7bfac4$export$82d4e60692b6b82);
const $d17a08a4ac7bfac4$export$82d4e60692b6b82 = {
    name: 'global-settings-issues-general-translations',
    path: '/secure/admin/ViewTranslations!default.jspa'
};

});


parcelRegister("6882f", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRouteEntry", () => $95f4f0dc937136e1$export$a7de28edcb387644);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $1x4kf = parcelRequire("1x4kf");
const $95f4f0dc937136e1$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $95f4f0dc937136e1$export$a7de28edcb387644 = (0, $bAJhM.createLegacyEntry)((0, $1x4kf.globalSettingsIssuesLinkTypesActivateRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$95f4f0dc937136e1$var$pageEntryPoint
    }));

});
parcelRegister("1x4kf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesActivateRoute", () => $b21282c6cff793a4$export$3669b743a852443d);
const $b21282c6cff793a4$export$3669b743a852443d = {
    name: 'global-settings-issues-linktypes-activate',
    path: '/secure/admin/IssueLinkingActivate.jspa'
};

});


parcelRegister("26rp0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRouteEntry", () => $bb753b8f37a50d00$export$bcae6091ca248a97);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $7UQYV = parcelRequire("7UQYV");
const $bb753b8f37a50d00$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $bb753b8f37a50d00$export$bcae6091ca248a97 = (0, $bAJhM.createLegacyEntry)((0, $7UQYV.globalSettingsIssuesLinkTypesDeactivateRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$bb753b8f37a50d00$var$pageEntryPoint
    }));

});
parcelRegister("7UQYV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesDeactivateRoute", () => $5c2d1f76d0934d2b$export$3b168b9635205cc2);
const $5c2d1f76d0934d2b$export$3b168b9635205cc2 = {
    name: 'global-settings-issues-linktypes-deactivate',
    path: '/secure/admin/IssueLinkingDeActivate.jspa'
};

});


parcelRegister("57B98", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesRouteEntry", () => $5c06f061b8e63c84$export$a96d582e6ce3db7f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $6mFag = parcelRequire("6mFag");

var $5fjzQ = parcelRequire("5fjzQ");
const $5c06f061b8e63c84$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $5c06f061b8e63c84$export$a96d582e6ce3db7f = (0, $bAJhM.createLegacyEntry)((0, $6mFag.globalSettingsIssuesLinkTypesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$5c06f061b8e63c84$var$pageEntryPoint
    }));

});
parcelRegister("6mFag", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinkTypesRoute", () => $82e7e8837e0837b9$export$ee4b5d966d77c912);
const $82e7e8837e0837b9$export$ee4b5d966d77c912 = {
    name: 'global-settings-issues-linktypes-view',
    path: '/secure/admin/ViewLinkTypes!default.jspa'
};

});


parcelRegister("up4vn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRouteEntry", () => $a80cb5789e4be309$export$5fed41168399db0a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $ehPPH = parcelRequire("ehPPH");
const $a80cb5789e4be309$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $a80cb5789e4be309$export$5fed41168399db0a = (0, $bAJhM.createLegacyEntry)((0, $ehPPH.globalSettingsIssuesLinktypesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a80cb5789e4be309$var$pageEntryPoint
    }));

});
parcelRegister("ehPPH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesDeleteRoute", () => $68cdb35b042662f5$export$da95e063618de37b);
const $68cdb35b042662f5$export$da95e063618de37b = {
    name: 'global-settings-issues-linktypes-delete',
    path: '/secure/admin/DeleteLinkType!default.jspa'
};

});


parcelRegister("8BXQZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRouteEntry", () => $03596088ec6c1ab7$export$58d36c7fbe66c9af);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $qQxYV = parcelRequire("qQxYV");
const $03596088ec6c1ab7$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $03596088ec6c1ab7$export$58d36c7fbe66c9af = (0, $bAJhM.createLegacyEntry)((0, $qQxYV.globalSettingsIssuesLinktypesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$03596088ec6c1ab7$var$pageEntryPoint
    }));

});
parcelRegister("qQxYV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesLinktypesEditRoute", () => $4807f5093889c673$export$670f7372491286fd);
const $4807f5093889c673$export$670f7372491286fd = {
    name: 'global-settings-issues-linktypes-edit',
    path: '/secure/admin/EditLinkType!default.jspa'
};

});


parcelRegister("2BIMj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationAddRouteEntry", () => $acca8a86ae0779e8$export$d52d95e2669ccb14);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $7a8zg = parcelRequire("7a8zg");
const $acca8a86ae0779e8$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $acca8a86ae0779e8$export$d52d95e2669ccb14 = (0, $bAJhM.createLegacyEntry)((0, $7a8zg.globalSettingsIssuesNotificationAddRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$acca8a86ae0779e8$var$pageEntryPoint
    }));

});
parcelRegister("7a8zg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationAddRoute", () => $cb8e43c572f5a188$export$493378d37b4f830);
const $cb8e43c572f5a188$export$493378d37b4f830 = {
    name: 'global-settings-issues-notification-add',
    path: '/secure/admin/AddNotification([!%]?[\\w]*).jspa'
};

});


parcelRegister("4CJ3w", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRouteEntry", () => $a937dca4416ff6e5$export$e3ff68e9ac0a92e2);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $aNqYg = parcelRequire("aNqYg");
const $a937dca4416ff6e5$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $a937dca4416ff6e5$export$e3ff68e9ac0a92e2 = (0, $bAJhM.createLegacyEntry)((0, $aNqYg.globalSettingsIssuesNotificationDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a937dca4416ff6e5$var$pageEntryPoint
    }));

});
parcelRegister("aNqYg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationDeleteRoute", () => $fa3637fa981b4a9b$export$7497920ead69d08f);
const $fa3637fa981b4a9b$export$7497920ead69d08f = {
    name: 'global-settings-issues-notification-delete',
    path: '/secure/admin/DeleteNotification([!%]?[\\w]*).jspa'
};

});


parcelRegister("eIvZR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationEditRouteEntry", () => $0056c98a94b1040b$export$256c34b63a2221ee);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $dHA6q = parcelRequire("dHA6q");
const $0056c98a94b1040b$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $0056c98a94b1040b$export$256c34b63a2221ee = (0, $bAJhM.createLegacyEntry)((0, $dHA6q.globalSettingsIssuesNotificationEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$0056c98a94b1040b$var$pageEntryPoint
    }));

});
parcelRegister("dHA6q", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationEditRoute", () => $6c1f77023b5f44ee$export$715522cf2d547eaf);
const $6c1f77023b5f44ee$export$715522cf2d547eaf = {
    name: 'global-settings-issues-notification-edit',
    path: '/secure/admin/EditNotifications([!%]?[\\w]*).jspa'
};

});


parcelRegister("8a334", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRouteEntry", () => $26522c840490b2ef$export$f1f02571fc623886);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $lD4jN = parcelRequire("lD4jN");
const $26522c840490b2ef$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $26522c840490b2ef$export$f1f02571fc623886 = (0, $bAJhM.createLegacyEntry)((0, $lD4jN.globalSettingsIssuesNotificationSchemeAddRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$26522c840490b2ef$var$pageEntryPoint
    }));

});
parcelRegister("lD4jN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeAddRoute", () => $542d02e100855c17$export$629ba048f31d2c0f);
const $542d02e100855c17$export$629ba048f31d2c0f = {
    name: 'global-settings-issues-notification-scheme-add',
    path: '/secure/admin/AddNotificationScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("5w3KH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRouteEntry", () => $0192bf70420594a6$export$40145c5de888865f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $hAggm = parcelRequire("hAggm");
const $0192bf70420594a6$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $0192bf70420594a6$export$40145c5de888865f = (0, $bAJhM.createLegacyEntry)((0, $hAggm.globalSettingsIssuesNotificationSchemeDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$0192bf70420594a6$var$pageEntryPoint
    }));

});
parcelRegister("hAggm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeDeleteRoute", () => $5ee9c1c4a10f4333$export$64a190266a30ffd6);
const $5ee9c1c4a10f4333$export$64a190266a30ffd6 = {
    name: 'global-settings-issues-notification-scheme-delete',
    path: '/secure/admin/DeleteNotificationScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("bYTPy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRouteEntry", () => $14b28c209217d6fd$export$856d15be55b1a791);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $23MCH = parcelRequire("23MCH");
const $14b28c209217d6fd$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $14b28c209217d6fd$export$856d15be55b1a791 = (0, $bAJhM.createLegacyEntry)((0, $23MCH.globalSettingsIssuesNotificationSchemeEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$14b28c209217d6fd$var$pageEntryPoint
    }));

});
parcelRegister("23MCH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationSchemeEditRoute", () => $217c71323af8b9f8$export$a7f8c6170a6db933);
const $217c71323af8b9f8$export$a7f8c6170a6db933 = {
    name: 'global-settings-issues-notification-scheme-edit',
    path: '/secure/admin/EditNotificationScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("45dSt", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationViewRouteEntry", () => $3a59ea1a9473c3c7$export$45dd8c9548b0054e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $inJOp = parcelRequire("inJOp");

var $5fjzQ = parcelRequire("5fjzQ");
const $3a59ea1a9473c3c7$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $3a59ea1a9473c3c7$export$45dd8c9548b0054e = (0, $bAJhM.createLegacyEntry)((0, $inJOp.globalSettingsIssuesNotificationViewRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$3a59ea1a9473c3c7$var$pageEntryPoint
    }));

});
parcelRegister("inJOp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesNotificationViewRoute", () => $dc74216996c7f937$export$bc2109e7325d1a16);
// like !default / !edit / %21viewLogs
const $dc74216996c7f937$export$bc2109e7325d1a16 = {
    name: 'global-settings-issues-notification-view',
    path: '/secure/admin/ViewNotificationSchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("h7nx5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRouteEntry", () => $b003487c0a7fc6bd$export$f49580b73c3ba83);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $eS5nk = parcelRequire("eS5nk");

var $13JxZ = parcelRequire("13JxZ");
const $b003487c0a7fc6bd$export$f49580b73c3ba83 = (0, $bAJhM.createLegacyEntry)((0, $eS5nk.globalSettingsIssuesPermissionsEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        component: (0, $13JxZ.LegacyEditPermissionsPage),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ]
    }));

});
parcelRegister("eS5nk", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsEditRoute", () => $76c8e8f9c7c53719$export$c7d87b3baf9e9a67);
const $76c8e8f9c7c53719$export$c7d87b3baf9e9a67 = {
    name: 'global-settings-issues-permissions-edit',
    path: '/secure/admin/EditPermissions([!%]?[\\w]*).jspa'
};

});

parcelRegister("13JxZ", function(module, exports) {

$parcel$export(module.exports, "LegacyEditPermissionsPage", () => $068f02016b2a1966$export$fb0bf0e5f8e439b9);

var $eJOHy = parcelRequire("eJOHy");

var $6tSfI = parcelRequire("6tSfI");
const $068f02016b2a1966$export$fb0bf0e5f8e439b9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tSfI.LegacyPage), props));
var $068f02016b2a1966$export$2e2bcd8739ae039 = $068f02016b2a1966$export$fb0bf0e5f8e439b9;

});


parcelRegister("VU3Sv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRouteEntry", () => $143e1ba622625485$export$d475751e96368b33);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $5GJxQ = parcelRequire("5GJxQ");
const $143e1ba622625485$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $143e1ba622625485$export$d475751e96368b33 = (0, $bAJhM.createLegacyEntry)((0, $5GJxQ.globalSettingsIssuesPermissionsSchemesAddRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$143e1ba622625485$var$pageEntryPoint
    }));

});
parcelRegister("5GJxQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesAddRoute", () => $5fd113b79f522601$export$f9c900df1268958);
const $5fd113b79f522601$export$f9c900df1268958 = {
    name: 'global-settings-issues-permissions-schemes-add',
    path: '/secure/admin/AddPermissionScheme!default.jspa'
};

});


parcelRegister("16s17", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRouteEntry", () => $6a80a6d93c9492f7$export$af3ca420f50b74f8);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $ieyfp = parcelRequire("ieyfp");
const $6a80a6d93c9492f7$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $6a80a6d93c9492f7$export$af3ca420f50b74f8 = (0, $bAJhM.createLegacyEntry)((0, $ieyfp.globalSettingsIssuesPermissionsSchemesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$6a80a6d93c9492f7$var$pageEntryPoint
    }));

});
parcelRegister("ieyfp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesDeleteRoute", () => $fed42a948e7f9e85$export$9cbf97d551da6de6);
const $fed42a948e7f9e85$export$9cbf97d551da6de6 = {
    name: 'global-settings-issues-permissions-schemes-delete',
    path: '/secure/admin/DeletePermissionScheme!default.jspa'
};

});


parcelRegister("5rBfu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRouteEntry", () => $67aadf6183dbba09$export$a1aace45fc58c0c0);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $8tjBE = parcelRequire("8tjBE");
const $67aadf6183dbba09$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $67aadf6183dbba09$export$a1aace45fc58c0c0 = (0, $bAJhM.createLegacyEntry)((0, $8tjBE.globalSettingsIssuesPermissionsSchemesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$67aadf6183dbba09$var$pageEntryPoint
    }));

});
parcelRegister("8tjBE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesEditRoute", () => $29491ba6d14a46f3$export$baed669ce740350d);
const $29491ba6d14a46f3$export$baed669ce740350d = {
    name: 'global-settings-issues-permissions-schemes-edit',
    path: '/secure/admin/EditPermissionScheme!default.jspa'
};

});


parcelRegister("2vFcC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRouteEntry", () => $b9dfb12ed7c44e53$export$92306855354418dd);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $eWqwZ = parcelRequire("eWqwZ");

var $5fjzQ = parcelRequire("5fjzQ");
const $b9dfb12ed7c44e53$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b9dfb12ed7c44e53$export$92306855354418dd = (0, $bAJhM.createLegacyEntry)((0, $eWqwZ.globalSettingsIssuesPermissionsSchemesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$b9dfb12ed7c44e53$var$pageEntryPoint
    }));

});
parcelRegister("eWqwZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesRoute", () => $74790b245f10db43$export$152abbb6f806c87);
// like !default / !edit / %21viewLogs
const $74790b245f10db43$export$152abbb6f806c87 = {
    name: 'global-settings-issues-permissions-schemes-view',
    path: '/secure/admin/ViewPermissionSchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("iw65Q", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRouteEntry", () => $20dfbc45d52fd7f9$export$79f7bd4999f40475);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $3igLV = parcelRequire("3igLV");
const $20dfbc45d52fd7f9$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $20dfbc45d52fd7f9$export$79f7bd4999f40475 = (0, $bAJhM.createLegacyEntry)((0, $3igLV.globalSettingsIssuesPermissionsSchemesProjectRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$20dfbc45d52fd7f9$var$pageEntryPoint
    }));

});
parcelRegister("3igLV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPermissionsSchemesProjectRoute", () => $a21a7754698f0a7e$export$c29ffdea8ba3226d);
const $a21a7754698f0a7e$export$c29ffdea8ba3226d = {
    name: 'legacy-project-settings-permissions-associate',
    path: '/secure/project/SelectProjectPermissionScheme!default.jspa'
};

});


parcelRegister("82jfc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRouteEntry", () => $256cb832ba6adb16$export$88a39202914c5905);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $fI6KB = parcelRequire("fI6KB");
const $256cb832ba6adb16$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $256cb832ba6adb16$export$88a39202914c5905 = (0, $bAJhM.createLegacyEntry)((0, $fI6KB.globalSettingsIssuesPrioritiesDefaultRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$256cb832ba6adb16$var$pageEntryPoint
    }));

});
parcelRegister("fI6KB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDefaultRoute", () => $779a592436a565a4$export$83a29d1cc0270f5a);
const $779a592436a565a4$export$83a29d1cc0270f5a = {
    name: 'global-settings-issues-priorities-default',
    path: '/secure/admin/MakeDefaultPriority([!%]?[\\w]*).jspa'
};

});


parcelRegister("fsAzL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRouteEntry", () => $cff2911fa377c011$export$e13fff0f49e2648b);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $kdM2P = parcelRequire("kdM2P");
const $cff2911fa377c011$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $cff2911fa377c011$export$e13fff0f49e2648b = (0, $bAJhM.createLegacyEntry)((0, $kdM2P.globalSettingsIssuesPrioritiesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$cff2911fa377c011$var$pageEntryPoint
    }));

});
parcelRegister("kdM2P", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesDeleteRoute", () => $9c8ce7b2f892f318$export$1092268c69e42aa4);
const $9c8ce7b2f892f318$export$1092268c69e42aa4 = {
    name: 'global-settings-issues-priorities-delete',
    path: '/secure/admin/DeletePriority!default.jspa'
};

});


parcelRegister("dw3Lv", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRouteEntry", () => $8efc52933cbece7a$export$cd447ff81bd82138);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $nU2f4 = parcelRequire("nU2f4");
const $8efc52933cbece7a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $8efc52933cbece7a$export$cd447ff81bd82138 = (0, $bAJhM.createLegacyEntry)((0, $nU2f4.globalSettingsIssuesPrioritiesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8efc52933cbece7a$var$pageEntryPoint
    }));

});
parcelRegister("nU2f4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesEditRoute", () => $424933cdf61f4dfd$export$c0f633caf37ba40d);
const $424933cdf61f4dfd$export$c0f633caf37ba40d = {
    name: 'global-settings-issues-priorities-edit',
    path: '/secure/admin/EditPriority!default.jspa'
};

});


parcelRegister("gX9nI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRouteEntry", () => $07e0f8cadf6d754f$export$63a56a096ab0d260);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bkITc = parcelRequire("bkITc");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $245yZ = parcelRequire("245yZ");
const $07e0f8cadf6d754f$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $07e0f8cadf6d754f$export$63a56a096ab0d260 = (0, $bAJhM.createLegacyEntry)((0, $245yZ.globalSettingsIssuesPrioritiesRoute), ()=>({
        layout: (0, $bkITc.priorityMappingGlobalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$07e0f8cadf6d754f$var$pageEntryPoint
    }));

});
parcelRegister("bkITc", function(module, exports) {

$parcel$export(module.exports, "priorityMappingGlobalSettingsLayout", () => $506e7e8230c06519$export$233c4c28b2b79294);

var $yRJUA = parcelRequire("yRJUA");

var $6dwgv = parcelRequire("6dwgv");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $506e7e8230c06519$var$LegacyAsyncModals = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("1sPgE")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/layouts/jira-priorities-mapping-global-settings-layout/src/ui/legacy-async-modals/index.tsx"
});
const $506e7e8230c06519$export$4219cc7dcaa1716c = [
    $506e7e8230c06519$var$LegacyAsyncModals
];
const $506e7e8230c06519$export$233c4c28b2b79294 = (0, $6dwgv.composeLayouts)((0, $yRJUA.globalSettingsLayout), {
    globalComponents: $506e7e8230c06519$export$4219cc7dcaa1716c
});

});
parcelRegister("1sPgE", function(module, exports) {

let $11102ca37c57c0af$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $11102ca37c57c0af$var$load("kVX56"),
    $11102ca37c57c0af$var$load("3p02a")
]).then(()=>parcelRequire('lEH8S'));

});


parcelRegister("245yZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", () => $9b3519ad46821246$export$518516cdf6b7cd83);
const $9b3519ad46821246$export$518516cdf6b7cd83 = {
    name: 'global-settings-issues-priorities',
    path: '/secure/admin/ViewPriorities.jspa'
};

});


parcelRegister("26CXx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRouteEntry", () => $a8bb6471b94156c9$export$3dd9e223f9189ad8);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $2Fq7q = parcelRequire("2Fq7q");
const $a8bb6471b94156c9$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $a8bb6471b94156c9$export$3dd9e223f9189ad8 = (0, $bAJhM.createLegacyEntry)((0, $2Fq7q.globalSettingsIssuesPrioritiesTranslationsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$a8bb6471b94156c9$var$pageEntryPoint
    }));

});
parcelRegister("2Fq7q", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesPrioritiesTranslationsRoute", () => $a0837fdd322b1771$export$ac50c32d38c2abe0);
const $a0837fdd322b1771$export$ac50c32d38c2abe0 = {
    name: 'global-settings-issues-priorities-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=priority'
    ]
};

});


parcelRegister("a0Vt3", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRouteEntry", () => $87b914e5cfce7b42$export$48a6536027e4aff8);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $kM9Sl = parcelRequire("kM9Sl");
const $87b914e5cfce7b42$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $87b914e5cfce7b42$export$48a6536027e4aff8 = (0, $bAJhM.createLegacyEntry)((0, $kM9Sl.globalSettingsIssuesResolutionsDefaultRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$87b914e5cfce7b42$var$pageEntryPoint
    }));

});
parcelRegister("kM9Sl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDefaultRoute", () => $af4f175e0377805c$export$3069447d64064849);
const $af4f175e0377805c$export$3069447d64064849 = {
    name: 'global-settings-issues-resolutions-default',
    path: '/secure/admin/MakeDefaultResolution([!%]?[\\w]*).jspa'
};

});


parcelRegister("asVNC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRouteEntry", () => $561b01d225e3676f$export$e4f8ecf8d9862ad4);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $egJ45 = parcelRequire("egJ45");
const $561b01d225e3676f$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $561b01d225e3676f$export$e4f8ecf8d9862ad4 = (0, $bAJhM.createLegacyEntry)((0, $egJ45.globalSettingsIssuesResolutionsDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$561b01d225e3676f$var$pageEntryPoint
    }));

});
parcelRegister("egJ45", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsDeleteRoute", () => $7a4006ef9742c100$export$cef4d5289f287690);
const $7a4006ef9742c100$export$cef4d5289f287690 = {
    name: 'global-settings-issues-resolutions-delete',
    path: '/secure/admin/DeleteResolution!default.jspa'
};

});


parcelRegister("7olX6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRouteEntry", () => $8eb96000c88ffbd8$export$abc7d0979f67b53f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $eGmlX = parcelRequire("eGmlX");
const $8eb96000c88ffbd8$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $8eb96000c88ffbd8$export$abc7d0979f67b53f = (0, $bAJhM.createLegacyEntry)((0, $eGmlX.globalSettingsIssuesResolutionsEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8eb96000c88ffbd8$var$pageEntryPoint
    }));

});
parcelRegister("eGmlX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsEditRoute", () => $573e2ca18a5d9ce4$export$92b7f2cef28676);
const $573e2ca18a5d9ce4$export$92b7f2cef28676 = {
    name: 'global-settings-issues-resolutions-edit',
    path: '/secure/admin/EditResolution!default.jspa'
};

});


parcelRegister("gTfP2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsRouteEntry", () => $b348b279e75f199d$export$2fc29b05ae7ea40);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $8b2Mi = parcelRequire("8b2Mi");

var $5fjzQ = parcelRequire("5fjzQ");
const $b348b279e75f199d$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b348b279e75f199d$export$2fc29b05ae7ea40 = (0, $bAJhM.createLegacyEntry)((0, $8b2Mi.globalSettingsIssuesResolutionsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$b348b279e75f199d$var$pageEntryPoint
    }));

});
parcelRegister("8b2Mi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsRoute", () => $be52a07a467a1bae$export$7ad0e4697ed2a3ec);
const $be52a07a467a1bae$export$7ad0e4697ed2a3ec = {
    name: 'global-settings-issues-resolutions',
    path: '/secure/admin/ViewResolutions.jspa'
};

});


parcelRegister("lnUYw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRouteEntry", () => $c6ac0b2440e0a315$export$93bb5b2fc4a9a739);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $6LHc1 = parcelRequire("6LHc1");
const $c6ac0b2440e0a315$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $c6ac0b2440e0a315$export$93bb5b2fc4a9a739 = (0, $bAJhM.createLegacyEntry)((0, $6LHc1.globalSettingsIssuesResolutionsTranslationsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c6ac0b2440e0a315$var$pageEntryPoint
    }));

});
parcelRegister("6LHc1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesResolutionsTranslationsRoute", () => $fedfebba30d6eb49$export$c84118fcbe41734c);
const $fedfebba30d6eb49$export$c84118fcbe41734c = {
    name: 'global-settings-issues-resolutions-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=resolution'
    ]
};

});


parcelRegister("4qhMs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityEditRouteEntry", () => $c84f4f162caeaae9$export$fe5197eff63a479c);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $25UXZ = parcelRequire("25UXZ");
const $c84f4f162caeaae9$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $c84f4f162caeaae9$export$fe5197eff63a479c = (0, $bAJhM.createLegacyEntry)((0, $25UXZ.globalSettingsIssuesSecurityEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c84f4f162caeaae9$var$pageEntryPoint
    }));

});
parcelRegister("25UXZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityEditRoute", () => $e55bae810c13af5f$export$5f1d8fd298c25945);
const $e55bae810c13af5f$export$5f1d8fd298c25945 = {
    name: 'global-settings-issues-security-edit',
    path: '/secure/admin/EditIssueSecurities([!%]?[\\w]*).jspa'
};

});


parcelRegister("98bLG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRouteEntry", () => $bc7fdc028c9e5285$export$32a0f47c80094c8a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $jHKpl = parcelRequire("jHKpl");
const $bc7fdc028c9e5285$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $bc7fdc028c9e5285$export$32a0f47c80094c8a = (0, $bAJhM.createLegacyEntry)((0, $jHKpl.globalSettingsIssuesSecurityLevelAddRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$bc7fdc028c9e5285$var$pageEntryPoint
    }));

});
parcelRegister("jHKpl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelAddRoute", () => $6e8a07a9959dd31e$export$27fd05d5eac2b88);
const $6e8a07a9959dd31e$export$27fd05d5eac2b88 = {
    name: 'global-settings-issues-security-level-add',
    path: '/secure/admin/AddIssueSecurity!default.jspa'
};

});


parcelRegister("9yLXc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRouteEntry", () => $9b20d33dcf8007c3$export$566f3107971a2203);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $gb7OM = parcelRequire("gb7OM");
const $9b20d33dcf8007c3$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $9b20d33dcf8007c3$export$566f3107971a2203 = (0, $bAJhM.createLegacyEntry)((0, $gb7OM.globalSettingsIssuesSecurityLevelDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$9b20d33dcf8007c3$var$pageEntryPoint
    }));

});
parcelRegister("gb7OM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelDeleteRoute", () => $5f38ab9d7f365bcd$export$9d60d6418ce002aa);
const $5f38ab9d7f365bcd$export$9d60d6418ce002aa = {
    name: 'global-settings-issues-security-level-delete',
    path: '/secure/admin/DeleteIssueSecurityLevel!default.jspa'
};

});


parcelRegister("fK8Na", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRouteEntry", () => $4454afb4d3c87280$export$d5da255e04fa662f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $1OcRL = parcelRequire("1OcRL");
const $4454afb4d3c87280$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $4454afb4d3c87280$export$d5da255e04fa662f = (0, $bAJhM.createLegacyEntry)((0, $1OcRL.globalSettingsIssuesSecurityLevelEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$4454afb4d3c87280$var$pageEntryPoint
    }));

});
parcelRegister("1OcRL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecurityLevelEditRoute", () => $c5280c578a0787c7$export$882588e58b7b7aa4);
const $c5280c578a0787c7$export$882588e58b7b7aa4 = {
    name: 'global-settings-issues-security-level-edit',
    path: '/secure/admin/EditSecurityLevel!default.jspa'
};

});


parcelRegister("bPQBZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRouteEntry", () => $cf3682664d24898b$export$a0157f60ff5930b1);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $7Ikzl = parcelRequire("7Ikzl");
const $cf3682664d24898b$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $cf3682664d24898b$export$a0157f60ff5930b1 = (0, $bAJhM.createLegacyEntry)((0, $7Ikzl.globalSettingsIssuesSecuritySchemesAddRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$cf3682664d24898b$var$pageEntryPoint
    }));

});
parcelRegister("7Ikzl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesAddRoute", () => $500cee8eae50462d$export$1f38848b5541a84a);
const $500cee8eae50462d$export$1f38848b5541a84a = {
    name: 'global-settings-issues-security-schemes-add',
    path: '/secure/admin/AddIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("quVRm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRouteEntry", () => $b38575a78c616def$export$9a262260e12c79c8);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $jBggV = parcelRequire("jBggV");
const $b38575a78c616def$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b38575a78c616def$export$9a262260e12c79c8 = (0, $bAJhM.createLegacyEntry)((0, $jBggV.globalSettingsIssuesSecuritySchemesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b38575a78c616def$var$pageEntryPoint
    }));

});
parcelRegister("jBggV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesDeleteRoute", () => $f5bae6b911cae621$export$c653091a64df0f25);
const $f5bae6b911cae621$export$c653091a64df0f25 = {
    name: 'global-settings-issues-security-schemes-delete',
    path: '/secure/admin/DeleteIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("lus0a", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRouteEntry", () => $7e5c7d7f5fc32a6e$export$fd9e3acdd660a584);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $gJi32 = parcelRequire("gJi32");
const $7e5c7d7f5fc32a6e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $7e5c7d7f5fc32a6e$export$fd9e3acdd660a584 = (0, $bAJhM.createLegacyEntry)((0, $gJi32.globalSettingsIssuesSecuritySchemesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$7e5c7d7f5fc32a6e$var$pageEntryPoint
    }));

});
parcelRegister("gJi32", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesEditRoute", () => $7e377a3724916a20$export$bea68ab25bef976c);
const $7e377a3724916a20$export$bea68ab25bef976c = {
    name: 'global-settings-issues-security-schemes-edit',
    path: '/secure/admin/EditIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("9Hzvs", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRouteEntry", () => $34a191adc08cc400$export$97cc0de5c7b8411a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $7lkTR = parcelRequire("7lkTR");

var $5fjzQ = parcelRequire("5fjzQ");
const $34a191adc08cc400$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $34a191adc08cc400$export$97cc0de5c7b8411a = (0, $bAJhM.createLegacyEntry)((0, $7lkTR.globalSettingsIssuesSecuritySchemesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$34a191adc08cc400$var$pageEntryPoint
    }));

});
parcelRegister("7lkTR", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSecuritySchemesRoute", () => $22eed4e3adb47593$export$35f866ec59eb6111);
// like !default / !edit / %21viewLogs
const $22eed4e3adb47593$export$35f866ec59eb6111 = {
    name: 'global-settings-issues-security-schemes',
    path: '/secure/admin/ViewIssueSecuritySchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("jjhsN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesRouteEntry", () => $d5ec649d2c03c65d$export$f736a667e7868236);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $27pTy = parcelRequire("27pTy");

var $5fjzQ = parcelRequire("5fjzQ");
const $d5ec649d2c03c65d$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $d5ec649d2c03c65d$export$f736a667e7868236 = (0, $bAJhM.createLegacyEntry)((0, $27pTy.globalSettingsIssuesStatusesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$d5ec649d2c03c65d$var$pageEntryPoint
    }));

});
parcelRegister("27pTy", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesRoute", () => $adf0ba8c6e31a7a3$export$4f249f1de6014aa8);
const $adf0ba8c6e31a7a3$export$4f249f1de6014aa8 = {
    name: 'global-settings-issues-statuses',
    path: '/secure/admin/ViewStatuses.jspa'
};

});


parcelRegister("3Ce1y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRouteEntry", () => $8eba19cf1f6449be$export$6ae705ef4b0a0174);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $kuVB9 = parcelRequire("kuVB9");
const $8eba19cf1f6449be$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $8eba19cf1f6449be$export$6ae705ef4b0a0174 = (0, $bAJhM.createLegacyEntry)((0, $kuVB9.globalSettingsIssuesStatusesTranslationsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8eba19cf1f6449be$var$pageEntryPoint
    }));

});
parcelRegister("kuVB9", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesStatusesTranslationsRoute", () => $dc506daa0a462f00$export$1766642f43dd1413);
const $dc506daa0a462f00$export$1766642f43dd1413 = {
    name: 'global-settings-issues-statuses-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=status'
    ]
};

});


parcelRegister("hahBd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRouteEntry", () => $5dca3f4c76145a5a$export$62334310a9f11802);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $adi6L = parcelRequire("adi6L");
const $5dca3f4c76145a5a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $5dca3f4c76145a5a$export$62334310a9f11802 = (0, $bAJhM.createLegacyEntry)((0, $adi6L.globalSettingsIssuesSubtasksDisableRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$5dca3f4c76145a5a$var$pageEntryPoint
    }));

});
parcelRegister("adi6L", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksDisableRoute", () => $0aee9bb8b1df7c9c$export$d2a6ab37bbab7a2d);
const $0aee9bb8b1df7c9c$export$d2a6ab37bbab7a2d = {
    name: 'global-settings-issues-subtasks-disable',
    path: '/secure/admin/subtasks/DisableSubTasks!default.jspa'
};

});


parcelRegister("1fhQ0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRouteEntry", () => $829a070fe61a7049$export$ffc845bbb3fd5a36);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $gMbJw = parcelRequire("gMbJw");
const $829a070fe61a7049$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $829a070fe61a7049$export$ffc845bbb3fd5a36 = (0, $bAJhM.createLegacyEntry)((0, $gMbJw.globalSettingsIssuesSubtasksEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$829a070fe61a7049$var$pageEntryPoint
    }));

});
parcelRegister("gMbJw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksEditRoute", () => $860e550fd9fbcb46$export$6ab3581cc7d5f524);
const $860e550fd9fbcb46$export$6ab3581cc7d5f524 = {
    name: 'global-settings-issues-subtasks-edit',
    path: '/secure/admin/subtasks/EditSubTaskIssueTypes!default.jspa'
};

});


parcelRegister("6Hth2", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRouteEntry", () => $e1de09e626e9d64d$export$e03cf52d50503939);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $68Vpn = parcelRequire("68Vpn");
const $e1de09e626e9d64d$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $e1de09e626e9d64d$export$e03cf52d50503939 = (0, $bAJhM.createLegacyEntry)((0, $68Vpn.globalSettingsIssuesSubtasksTranlationsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$e1de09e626e9d64d$var$pageEntryPoint
    }));

});
parcelRegister("68Vpn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesSubtasksTranlationsRoute", () => $3c93652f15670df4$export$5ebaadfa47e727e6);
const $3c93652f15670df4$export$5ebaadfa47e727e6 = {
    name: 'global-settings-issues-subtasks-tranlations',
    path: '/secure/admin/subtasks/ViewTranslations!default.jspa'
};

});


parcelRegister("7QZSt", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRouteEntry", () => $2545f3149903ac25$export$5d0300325c3e456c);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $3L44i = parcelRequire("3L44i");
const $2545f3149903ac25$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $2545f3149903ac25$export$5d0300325c3e456c = (0, $bAJhM.createLegacyEntry)((0, $3L44i.globalSettingsIssuesTypesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2545f3149903ac25$var$pageEntryPoint
    }));

});
parcelRegister("3L44i", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesDeleteRoute", () => $a122bf2e16347576$export$53c2f4353355a41b);
const $a122bf2e16347576$export$53c2f4353355a41b = {
    name: 'global-settings-issues-types-delete',
    path: '/secure/admin/DeleteIssueType!default.jspa'
};

});


parcelRegister("sRxbJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesEditRouteEntry", () => $b22284ff2a78f4cd$export$7e3e6487b18f13dd);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $iixq6 = parcelRequire("iixq6");
const $b22284ff2a78f4cd$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b22284ff2a78f4cd$export$7e3e6487b18f13dd = (0, $bAJhM.createLegacyEntry)((0, $iixq6.globalSettingsIssuesTypesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b22284ff2a78f4cd$var$pageEntryPoint
    }));

});
parcelRegister("iixq6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesEditRoute", () => $770e50507e0de085$export$26b7c50d91022a7);
const $770e50507e0de085$export$26b7c50d91022a7 = {
    name: 'global-settings-issues-types-edit',
    path: '/secure/admin/EditIssueType!default.jspa'
};

});


parcelRegister("fpvqi", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRouteEntry", () => $f6f6b4eb56116cd3$export$5d1defdba7aabb03);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $b4DG0 = parcelRequire("b4DG0");
const $f6f6b4eb56116cd3$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $f6f6b4eb56116cd3$export$5d1defdba7aabb03 = (0, $bAJhM.createLegacyEntry)((0, $b4DG0.globalSettingsIssuesTypesMigrateRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$f6f6b4eb56116cd3$var$pageEntryPoint
    }));

});
parcelRegister("b4DG0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesMigrateRoute", () => $9f842ef5bdb6f099$export$6f6923c45a7c3d7d);
const $9f842ef5bdb6f099$export$6f6923c45a7c3d7d = {
    name: 'global-settings-issues-types-migrate',
    path: '/secure/admin/MigrateIssueTypes([!%]?[\\w]*).jspa'
};

});


parcelRegister("lk87Q", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRouteEntry", () => $cc0ed3f95bdf371f$export$7c04fddca02bf5e5);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $pP21Y = parcelRequire("pP21Y");
const $cc0ed3f95bdf371f$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $cc0ed3f95bdf371f$export$7c04fddca02bf5e5 = (0, $bAJhM.createLegacyEntry)((0, $pP21Y.globalSettingsIssuesTypesSchemesAssociateDefaultRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$cc0ed3f95bdf371f$var$pageEntryPoint
    }));

});
parcelRegister("pP21Y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateDefaultRoute", () => $3c38f7194b4bf131$export$ce555a4492eeb41);
const $3c38f7194b4bf131$export$ce555a4492eeb41 = {
    name: 'global-settings-issues-types-schemes-associate-default',
    path: '/secure/admin/AssociateIssueTypeSchemesWithDefault!default.jspa'
};

});


parcelRegister("ddTL8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRouteEntry", () => $d1e2d66762f17742$export$a4322d0977a716ec);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $7cd7Y = parcelRequire("7cd7Y");
const $d1e2d66762f17742$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $d1e2d66762f17742$export$a4322d0977a716ec = (0, $bAJhM.createLegacyEntry)((0, $7cd7Y.globalSettingsIssuesTypesSchemesAssociateRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$d1e2d66762f17742$var$pageEntryPoint
    }));

});
parcelRegister("7cd7Y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesAssociateRoute", () => $a2a22d4105710bfe$export$695947f4bf787b08);
const $a2a22d4105710bfe$export$695947f4bf787b08 = {
    name: 'global-settings-issues-types-schemes-associate',
    path: '/secure/admin/AssociateIssueTypeSchemes!default.jspa'
};

});


parcelRegister("1mGBY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRouteEntry", () => $31fafd258114fc51$export$2486d5cbf90be36f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $309bT = parcelRequire("309bT");
const $31fafd258114fc51$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $31fafd258114fc51$export$2486d5cbf90be36f = (0, $bAJhM.createLegacyEntry)((0, $309bT.globalSettingsIssuesTypesSchemesOptionDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$31fafd258114fc51$var$pageEntryPoint
    }));

});
parcelRegister("309bT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionDeleteRoute", () => $fcab59f9790600c2$export$c6dca032125109f7);
const $fcab59f9790600c2$export$c6dca032125109f7 = {
    name: 'global-settings-issues-types-schemes-option-delete',
    path: '/secure/admin/DeleteOptionScheme!default.jspa'
};

});


parcelRegister("cbLe1", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRouteEntry", () => $284181edffc10521$export$c604bf31fc1ec79f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $2eBxm = parcelRequire("2eBxm");
const $284181edffc10521$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $284181edffc10521$export$c604bf31fc1ec79f = (0, $bAJhM.createLegacyEntry)((0, $2eBxm.globalSettingsIssuesTypesSchemesOptionRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$284181edffc10521$var$pageEntryPoint
    }));

});
parcelRegister("2eBxm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesSchemesOptionRoute", () => $df0569e36d79fadd$export$e77dd31f52063355);
const $df0569e36d79fadd$export$e77dd31f52063355 = {
    name: 'global-settings-issues-types-schemes-option',
    path: '/secure/admin/ConfigureOptionSchemes([!%]?[\\w]*).jspa'
};

});


parcelRegister("gGGZ4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRouteEntry", () => $8728b7207483cda6$export$953b618d4334efe8);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $fXTmf = parcelRequire("fXTmf");
const $8728b7207483cda6$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $8728b7207483cda6$export$953b618d4334efe8 = (0, $bAJhM.createLegacyEntry)((0, $fXTmf.globalSettingsIssuesTypesScreenSchemesConfigureRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8728b7207483cda6$var$pageEntryPoint
    }));

});
parcelRegister("fXTmf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesConfigureRoute", () => $681057a168618a67$export$35a08f15e9b959ee);
const $681057a168618a67$export$35a08f15e9b959ee = {
    name: 'global-settings-issues-types-screen-schemes-configure',
    path: '/secure/admin/ConfigureIssueTypeScreenScheme.jspa'
};

});


parcelRegister("bCuzN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRouteEntry", () => $3f1b3f26dfdfbae2$export$7f2d678246700c2);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $6VZy5 = parcelRequire("6VZy5");
const $3f1b3f26dfdfbae2$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $3f1b3f26dfdfbae2$export$7f2d678246700c2 = (0, $bAJhM.createLegacyEntry)((0, $6VZy5.globalSettingsIssuesTypesScreenSchemesCopyRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$3f1b3f26dfdfbae2$var$pageEntryPoint
    }));

});
parcelRegister("6VZy5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesCopyRoute", () => $c2f0ef349f5a98d5$export$56cacc1b264d8eec);
const $c2f0ef349f5a98d5$export$56cacc1b264d8eec = {
    name: 'global-settings-issues-types-screen-schemes-copy',
    path: '/secure/admin/ViewCopyIssueTypeScreenScheme.jspa'
};

});


parcelRegister("nYwoX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRouteEntry", () => $fa85e4b5c973d024$export$5776296a4d01ebfc);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $iPlAA = parcelRequire("iPlAA");
const $fa85e4b5c973d024$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $fa85e4b5c973d024$export$5776296a4d01ebfc = (0, $bAJhM.createLegacyEntry)((0, $iPlAA.globalSettingsIssuesTypesScreenSchemesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$fa85e4b5c973d024$var$pageEntryPoint
    }));

});
parcelRegister("iPlAA", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesDeleteRoute", () => $4bb0a6989c3cce6d$export$3e0cfa858e2af787);
const $4bb0a6989c3cce6d$export$3e0cfa858e2af787 = {
    name: 'global-settings-issues-types-screen-schemes-delete',
    path: '/secure/admin/ViewDeleteIssueTypeScreenScheme.jspa'
};

});


parcelRegister("6vj5T", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRouteEntry", () => $249d8527e519a1ca$export$c4d5ef3d480983a7);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $8B8ql = parcelRequire("8B8ql");
const $249d8527e519a1ca$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $249d8527e519a1ca$export$c4d5ef3d480983a7 = (0, $bAJhM.createLegacyEntry)((0, $8B8ql.globalSettingsIssuesTypesScreenSchemesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$249d8527e519a1ca$var$pageEntryPoint
    }));

});
parcelRegister("8B8ql", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEditRoute", () => $2608bba47c94ae27$export$1ddbfff8d0b6f652);
const $2608bba47c94ae27$export$1ddbfff8d0b6f652 = {
    name: 'global-settings-issues-types-screen-schemes-edit',
    path: '/secure/admin/EditIssueTypeScreenScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("kSikr", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRouteEntry", () => $887440badb277e5b$export$13bfbf88a9e3596d);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $fZHug = parcelRequire("fZHug");
const $887440badb277e5b$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $887440badb277e5b$export$13bfbf88a9e3596d = (0, $bAJhM.createLegacyEntry)((0, $fZHug.globalSettingsIssuesTypesScreenSchemesEntityRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$887440badb277e5b$var$pageEntryPoint
    }));

});
parcelRegister("fZHug", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesScreenSchemesEntityRoute", () => $76638b5367920d1f$export$dbd4ba90dd0ca938);
const $76638b5367920d1f$export$dbd4ba90dd0ca938 = {
    name: 'global-settings-issues-types-screen-schemes-entity',
    path: '/secure/admin/ViewEditIssueTypeScreenSchemeEntity.jspa'
};

});


parcelRegister("hXqaO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRouteEntry", () => $ce2ca3f5a45a7c66$export$4f9686f0681ca4ae);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $aZHOJ = parcelRequire("aZHOJ");
const $ce2ca3f5a45a7c66$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $ce2ca3f5a45a7c66$export$4f9686f0681ca4ae = (0, $bAJhM.createLegacyEntry)((0, $aZHOJ.globalSettingsIssuesTypesTranslationsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ce2ca3f5a45a7c66$var$pageEntryPoint
    }));

});
parcelRegister("aZHOJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesTypesTranslationsRoute", () => $0a8983e1ca664493$export$58b39a591d56ebd2);
const $0a8983e1ca664493$export$58b39a591d56ebd2 = {
    name: 'global-settings-issues-types-translations',
    path: '/secure/admin/ViewTranslations!default.jspa',
    query: [
        'issueConstantType=issuetype'
    ]
};

});


parcelRegister("gRK6u", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRouteEntry", () => $373bd8182b7a4207$export$bf03c0c6f11d43ea);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $5i1F4 = parcelRequire("5i1F4");
const $373bd8182b7a4207$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $373bd8182b7a4207$export$bf03c0c6f11d43ea = (0, $bAJhM.createLegacyEntry)((0, $5i1F4.globalSettingsIssuesWorkflowTransitionMetaAttributesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$373bd8182b7a4207$var$pageEntryPoint
    }));

});
parcelRegister("5i1F4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionMetaAttributesRoute", () => $1944d20e6ea66cda$export$bc1d4dae621df0c5);
const $1944d20e6ea66cda$export$bc1d4dae621df0c5 = {
    name: 'global-settings-issues-workflow-transition-meta-attributes',
    path: '/secure/admin/ViewWorkflowTransitionMetaAttributes.jspa'
};

});


parcelRegister("9JZc6", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRouteEntry", () => $fa3cb35516dea08b$export$fc7a930108b9d172);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $8VIhb = parcelRequire("8VIhb");
const $fa3cb35516dea08b$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $fa3cb35516dea08b$export$fc7a930108b9d172 = (0, $bAJhM.createLegacyEntry)((0, $8VIhb.globalSettingsIssuesWorkflowTransitionRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS
        },
        entryPoint: ()=>$fa3cb35516dea08b$var$pageEntryPoint
    }));

});
parcelRegister("8VIhb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowTransitionRoute", () => $1071839c2725bb45$export$1579038a55dade21);
const $1071839c2725bb45$export$1579038a55dade21 = {
    name: 'global-settings-issues-workflow-transition',
    path: '/secure/admin/ViewWorkflowTransition.jspa'
};

});


parcelRegister("ivQwe", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRouteEntry", () => $59fd7fed488cb1ba$export$3c5fdd60ca22958d);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $6RcDM = parcelRequire("6RcDM");
const $59fd7fed488cb1ba$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $59fd7fed488cb1ba$export$3c5fdd60ca22958d = (0, $bAJhM.createLegacyEntry)((0, $6RcDM.globalSettingsIssuesWorkflowsImportRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$59fd7fed488cb1ba$var$pageEntryPoint
    }));

});
parcelRegister("6RcDM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsImportRoute", () => $15e4476665802ecc$export$81f075f719f41037);
const $15e4476665802ecc$export$81f075f719f41037 = {
    name: 'global-settings-issues-workflows-import',
    path: '/plugins/servlet/wfshare-(import|export)'
};

});


parcelRegister("5Ivpf", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRouteEntry", () => $fe52383588a0e14f$export$22172eb9e4a9e4ae);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $8XpuN = parcelRequire("8XpuN");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $4c2QP = parcelRequire("4c2QP");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $lUdXr = parcelRequire("lUdXr");
const $fe52383588a0e14f$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $fe52383588a0e14f$export$22172eb9e4a9e4ae = (0, $bAJhM.createLegacyEntry)((0, $4c2QP.globalSettingsIssuesWorkflowsSchemesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>!(0, $7jTnu.fg)('hix-7083-modern-read-only-workflow-diagram') ? $fe52383588a0e14f$var$pageEntryPoint : undefined,
        component: (0, $bJscI.componentWithFG)('hix-7083-modern-read-only-workflow-diagram', (0, $lUdXr.ProjectSettingsWorkflowsSchemesEdit), ()=>null)
    }));

});
parcelRegister("4c2QP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsIssuesWorkflowsSchemesEditRoute", () => $030ef97209e98791$export$51a0d34ef3d00da8);
const $030ef97209e98791$export$51a0d34ef3d00da8 = {
    name: 'global-settings-issues-workflows-schemes-edit',
    path: '/secure/admin/EditWorkflowScheme.jspa'
};

});

parcelRegister("lUdXr", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsWorkflowsSchemesEdit", () => $0208d7f2f2e54efe$export$46534748d4965ee9);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $1KdDN = parcelRequire("1KdDN");

var $6tSfI = parcelRequire("6tSfI");

var $2CJyb = parcelRequire("2CJyb");
const $0208d7f2f2e54efe$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS = 'workflow-diagram-view';
// This id is the main entry point for the project settings workflows schemes page that can be found in:
// `jira-domains/infrastructure/webapp/jira-webapp-resources/src/main/webapp/secure/admin/views/workflow/editworkflowscheme.jsp#lines-16`
const $0208d7f2f2e54efe$var$LEGACY_WORKFLOW_SCHEMES_EDITOR_ID = 'workflowscheme-editor';
const $0208d7f2f2e54efe$var$getLegacyWorkflowDiagramLinks = ()=>{
    const workflowDiagramLinksElem = globalThis.document?.getElementsByClassName($0208d7f2f2e54efe$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS);
    return [
        ...workflowDiagramLinksElem ?? []
    ];
};
const $0208d7f2f2e54efe$var$getLegacyWorkflowsSchemeEditorElement = ()=>{
    return globalThis.document?.getElementById($0208d7f2f2e54efe$var$LEGACY_WORKFLOW_SCHEMES_EDITOR_ID);
};
const $0208d7f2f2e54efe$var$getLegacyWorkflowsPanelBody = ()=>{
    const workflowsPanel = globalThis.document?.getElementsByClassName('workflows-list');
    const workflowsPanelArray = [
        ...workflowsPanel ?? []
    ];
    return workflowsPanelArray.length > 0 ? workflowsPanelArray[0] : undefined;
};
const $0208d7f2f2e54efe$export$46534748d4965ee9 = (props)=>{
    const [selectedWorkflow, setSelectedWorkflow] = (0, $eJOHy.useState)(undefined);
    const handleOnClose = (0, $eJOHy.useCallback)(()=>{
        setSelectedWorkflow(undefined);
    }, [
        setSelectedWorkflow
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let observer = null;
        const handleClicksOnWorkflowDiagramLinks = ()=>{
            const workflowsTable = $0208d7f2f2e54efe$var$getLegacyWorkflowsPanelBody();
            if (!workflowsTable) return;
            // Register click handlers to all legacy workflow diagram links
            workflowsTable.addEventListener('click', (event)=>{
                // We only want to handle clicks on the legacy workflow diagram links.
                // by checking the closest ancestor element with the class 'project-config-workflow-designer-link'
                // since the `event.target`can be any element inside the link (span for example)
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const diagramLinkElement = event.target.closest(`.${$0208d7f2f2e54efe$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS}`);
                if (diagramLinkElement) {
                    event.preventDefault();
                    // We are missing the data attribute with the workflow name in the link element,
                    // so we need to find the closest ancestor row and get the workflow name from there
                    const workflowName = diagramLinkElement.closest('tr')?.getAttribute('data-workflow-name');
                    if (workflowName) setSelectedWorkflow(workflowName);
                }
            });
        };
        // If there are already legacy workflow diagram links, we register the click handler immediately.
        if ($0208d7f2f2e54efe$var$getLegacyWorkflowDiagramLinks().length > 0) handleClicksOnWorkflowDiagramLinks();
        else {
            // We only execute this once, when the `#workflowscheme-editor` is populated
            // This is because the workflows schemes page is rendered server-side and the links are
            // dynamically added to the DOM after the initial render.
            observer = new MutationObserver(()=>{
                handleClicksOnWorkflowDiagramLinks();
                observer && observer.disconnect();
            });
            const workflowsSchemeEditorElement = $0208d7f2f2e54efe$var$getLegacyWorkflowsSchemeEditorElement();
            if (workflowsSchemeEditorElement) observer.observe(workflowsSchemeEditorElement, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            $0208d7f2f2e54efe$var$getLegacyWorkflowsPanelBody()?.removeEventListener('click', handleClicksOnWorkflowDiagramLinks);
            observer && observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "read-only-workflow-schemes-diagram-error-boundary",
        packageName: "jiraRouterRoutesLegacyGlobalSettingsWorkflowsSchemesEditRouteEntries",
        teamName: "helix",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tSfI.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, selectedWorkflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2CJyb.default), {
        workflowIdentifier: {
            workflowName: selectedWorkflow
        },
        onClose: handleOnClose
    })));
};

});
parcelRegister("2CJyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $663c0d02e62a9fd4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4xbv3 = parcelRequire("4xbv3");

var $7iHUq = parcelRequire("7iHUq");

var $19MvJ = parcelRequire("19MvJ");
const $663c0d02e62a9fd4$export$5b6c28c7dca07ad7 = 'jiraWorkflowViewDiagramModal';
const $663c0d02e62a9fd4$export$fe8be8543ba8f3f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
        id: $663c0d02e62a9fd4$export$5b6c28c7dca07ad7,
        hasErrorBoundary: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "workflow-view-diagram-modal",
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $19MvJ.WorkflowDiagramViewModal), props)));
};
var $663c0d02e62a9fd4$export$2e2bcd8739ae039 = $663c0d02e62a9fd4$export$fe8be8543ba8f3f;

});
parcelRegister("19MvJ", function(module, exports) {

$parcel$export(module.exports, "WorkflowDiagramViewModal", () => $03edee16b0c38027$export$37e6d9b300263ca2);

var $eJOHy = parcelRequire("eJOHy");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7ep4S = parcelRequire("7ep4S");

var $6MnLl = parcelRequire("6MnLl");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $aC4Bh = parcelRequire("aC4Bh");

var $5MJX0 = parcelRequire("5MJX0");

var $kEUB1 = parcelRequire("kEUB1");


var $dPMMf = parcelRequire("dPMMf");

var $aNRVY = parcelRequire("aNRVY");

var $dymbf = parcelRequire("dymbf");

var $aTJmy = parcelRequire("aTJmy");

var $iqtgH = parcelRequire("iqtgH");

var $gYnSx = parcelRequire("gYnSx");

var $eSnSE = parcelRequire("eSnSE");

var $1uIew = parcelRequire("1uIew");

var $eFrz1 = parcelRequire("eFrz1");

var $zBqnt = parcelRequire("zBqnt");
const $03edee16b0c38027$var$closeButton = (0, $7qGN1.defineMessage)({
    id: 'workflow-view-diagram-modal.close-button',
    defaultMessage: 'Close',
    description: 'Label for the button to close the workflow view diagram modal'
});
const $03edee16b0c38027$var$errorMessage = (0, $7qGN1.defineMessage)({
    defaultMessage: "We couldn\u2019t load the workflow.",
    id: 'workflow-view-diagram-modal.error-message',
    description: 'Error message for when the modal fails to load its content'
});
const $03edee16b0c38027$var$INITIAL_ZOOM = 1;
const $03edee16b0c38027$var$ERROR_IMAGE_MAX_HEIGHT = 212;
const $03edee16b0c38027$var$ERROR_LOGGER_PATTERN = '#workflow-view-diagram-modal#';
// Custom hook for workflow data management
const $03edee16b0c38027$var$useWorkflowData = (cloudId, workflowIdentifier)=>{
    const [state, setState] = (0, $eJOHy.useState)({
        data: undefined,
        isLoading: true,
        hasError: false
    });
    (0, $eFrz1.useEffectWithoutConcurrency)(()=>{
        const fetchWorkflow = async ()=>{
            setState((prev)=>({
                    ...prev,
                    isLoading: true,
                    hasError: false
                }));
            try {
                const workflowResponse = await (0, $5MJX0.default)(cloudId, workflowIdentifier);
                setState({
                    data: workflowResponse,
                    isLoading: false,
                    hasError: false
                });
            } catch (error) {
                if (error instanceof (0, $1uIew.default) && error.statusCode) (0, $eSnSE.default).safeErrorWithoutCustomerData(`${$03edee16b0c38027$var$ERROR_LOGGER_PATTERN}.fetch.failure.${error.statusCode}`, error.message || 'Fetch failure with empty error message', error);
                else if (error instanceof TypeError) (0, $eSnSE.default).safeErrorWithoutCustomerData(`${$03edee16b0c38027$var$ERROR_LOGGER_PATTERN}.fetch.failure`, error.message, error);
                (0, $gYnSx.default)({
                    meta: {
                        id: `${$03edee16b0c38027$var$ERROR_LOGGER_PATTERN}.fetch.error`,
                        packageName: 'jiraWorkflowViewDiagramModal',
                        teamName: 'helix'
                    },
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    error: error
                });
                setState((prev)=>({
                        ...prev,
                        hasError: true,
                        isLoading: false
                    }));
            }
        };
        fetchWorkflow();
    }, [
        cloudId,
        workflowIdentifier
    ]);
    return state;
};
// Workflow Diagram Content Component
const $03edee16b0c38027$var$WorkflowDiagramContent = ({ workflow: workflow, zoom: zoom, onZoomChange: onZoomChange, onZoomUpdate: onZoomUpdate })=>{
    const statuses = workflow.visibleStatuses.map(({ ref: statusId })=>workflow.allStatuses[statusId]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $03edee16b0c38027$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $03edee16b0c38027$var$diagramContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNRVY.default), {
        startNodeLayout: workflow.startNodeLayout,
        statuses: statuses,
        transitions: Object.values(workflow.transitions),
        zoom: zoom,
        isImmutable: true,
        onZoomUpdate: onZoomUpdate,
        collapseTransitionLabels: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $zBqnt.ZoomControls), {
        zoom: zoom,
        onZoomChange: onZoomChange
    }));
};
const $03edee16b0c38027$export$37e6d9b300263ca2 = ({ workflowIdentifier: workflowIdentifier, onClose: onClose })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [zoom, setZoom] = (0, $eJOHy.useState)($03edee16b0c38027$var$INITIAL_ZOOM);
    const { data: workflow, isLoading: isLoading, hasError: hasError } = $03edee16b0c38027$var$useWorkflowData(cloudId, workflowIdentifier);
    const onZoomChange = (0, $eJOHy.useCallback)((newZoomValue)=>{
        setZoom(newZoomValue);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "workflow-view-diagram-modal.ui.modal-dialog",
        messageType: "transactional",
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true,
        onClose: onClose,
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $03edee16b0c38027$var$modalContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, workflow && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        testId: "workflow-view-diagram-modal.ui.modal-title"
    }, workflow.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $03edee16b0c38027$var$contentStyles
    }, (()=>{
        if (!hasError && isLoading && !workflow) return(// Loading state
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $03edee16b0c38027$var$centerWrapperStyles,
            testId: "workflow-view-diagram-modal.ui.loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "large"
        })));
        if (hasError && !isLoading || !workflow) return(// Error state
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
            header: "",
            maxImageHeight: $03edee16b0c38027$var$ERROR_IMAGE_MAX_HEIGHT,
            renderImage: (0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $dymbf.default)),
            description: formatMessage($03edee16b0c38027$var$errorMessage)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($03edee16b0c38027$var$WorkflowDiagramContent, {
            workflow: workflow,
            zoom: zoom,
            onZoomChange: onZoomChange,
            onZoomUpdate: setZoom
        });
    })())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClose,
        appearance: "subtle"
    }, formatMessage($03edee16b0c38027$var$closeButton))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null));
};
const $03edee16b0c38027$var$centerWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    height: '100%'
});
const $03edee16b0c38027$var$wrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexGrow: '1',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $dPMMf.gridSize) * 44}px`,
    boxShadow: 'elevation.shadow.raised'
});
const $03edee16b0c38027$var$diagramContentWrapperStyles = (0, $1DXK0.xcss)({
    width: '100%',
    height: 'auto'
});
const $03edee16b0c38027$var$contentStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    height: '100%'
});
const $03edee16b0c38027$var$getmodalcontentwrapperheight = ()=>`calc(100vh - ${0, $bf1c59a4164b2d18$export$d60454526e2281af} - ${0, $bf1c59a4164b2d18$export$d60454526e2281af})`;
const $03edee16b0c38027$var$modalContentWrapperStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    height: $03edee16b0c38027$var$getmodalcontentwrapperheight(),
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: 'border.radius.100'
});

});
parcelRegister("aC4Bh", function(module, exports) {

$parcel$export(module.exports, "JiraModal", () => $1ed06102d0e4c7bf$export$3782fcca1f68992e);

var $eJOHy = parcelRequire("eJOHy");

var $gHHv2 = parcelRequire("gHHv2");

var $SyPNn = parcelRequire("SyPNn");

var $fYeTG = parcelRequire("fYeTG");

var $3tIRK = parcelRequire("3tIRK");
const $1ed06102d0e4c7bf$export$3782fcca1f68992e = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3tIRK.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHHv2.default), rest);
};
$1ed06102d0e4c7bf$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("SyPNn", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $136bce68f4b94682$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "environmentToEnvType", () => $136bce68f4b94682$export$e2cf19200849be9e);

var $78ewy = parcelRequire("78ewy");

var $gL5G0 = parcelRequire("gL5G0");
function $136bce68f4b94682$export$a8ba9111c7eec9ac(props) {
    return (0, $gL5G0.shouldBeChoreographed)(props);
}
function $136bce68f4b94682$export$e2cf19200849be9e(environment) {
    switch(environment){
        case 'dev':
            return (0, $78ewy.envType).DEV;
        case 'staging':
            return (0, $78ewy.envType).STAGING;
        case 'prod':
            return (0, $78ewy.envType).PROD;
        default:
            return (0, $78ewy.envType).LOCAL;
    }
}

});
parcelRegister("gL5G0", function(module, exports) {

$parcel$export(module.exports, "getPendoPlugin", () => $038980df3dc27b63$export$3d3a86b2d636214b);
$parcel$export(module.exports, "shouldBeChoreographed", () => $038980df3dc27b63$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "withChoreographedToggle", () => $038980df3dc27b63$export$a646002207b915ac);
$parcel$export(module.exports, "useChoreographedRender", () => $038980df3dc27b63$export$2cfd68294be82811);
$parcel$export(module.exports, "useDisableInAppMessagesForIframe", () => $038980df3dc27b63$export$a60a99a250d6a89c);

var $eJOHy = parcelRequire("eJOHy");

var $bdILV = parcelRequire("bdILV");
var $bgcdo = parcelRequire("bgcdo");
var $7Q9YQ = parcelRequire("7Q9YQ");
var $aeXRO = parcelRequire("aeXRO");

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $c9z5K = parcelRequire("c9z5K");

var $3CprG = parcelRequire("3CprG");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $038980df3dc27b63$var$environment = (0, $c9z5K.toEnvironment)((0, $hWeHP.default)('ajs-environment')) ?? 'prod';
const $038980df3dc27b63$var$createChoreographerFactory = ()=>{
    if (false) return {
        useChoreographer: (..._)=>({
                startMessage: ()=>Promise.resolve((0, $7Q9YQ.MessageDeliveryStatus).STARTED),
                stopMessage: ()=>Promise.resolve((0, $7Q9YQ.MessageDeliveryStatus).STOPPED),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                toggleMessage: ()=>Promise.resolve('')
            }),
        withChoreographedToggle: (Component)=>Component,
        shouldBeChoreographed: (props)=>false
    };
    return (0, $bgcdo.choreographerFactory)((0, $7Q9YQ.ProductIds).JIRA, $038980df3dc27b63$var$environment);
};
let $038980df3dc27b63$var$pendoPlugin;
function $038980df3dc27b63$export$3d3a86b2d636214b(env) {
    if (!$038980df3dc27b63$var$pendoPlugin) $038980df3dc27b63$var$pendoPlugin = new (0, $aeXRO.PendoChoreographerPlugin)(env, {
        sourceProductId: (0, $7Q9YQ.ProductIds).JIRA
    });
    return $038980df3dc27b63$var$pendoPlugin;
}
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ const { useChoreographer: $038980df3dc27b63$export$9f0e2488ffd90f11, withChoreographedToggle: $038980df3dc27b63$var$withChoreographedToggleFromFactory, shouldBeChoreographed: $038980df3dc27b63$export$a8ba9111c7eec9ac } = $038980df3dc27b63$var$createChoreographerFactory();
const $038980df3dc27b63$export$a646002207b915ac = (Component, toggleableProp, toggleableContentProp)=>{
    const WithChoreographedToggleComponent = (props)=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $3CprG.useChoreographedStatusContext)();
        const ChoreographedComponent = (0, $eJOHy.useMemo)(()=>$038980df3dc27b63$var$withChoreographedToggleFromFactory(Component, toggleableProp), []);
        if (isAlreadyChoreographedAtAncestor || !(0, $7jTnu.fg)('jira_with_choreographed_toggle_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props);
        const propsWithContextProviderWrapper = {
            ...props
        };
        if (toggleableContentProp) {
            const { [toggleableContentProp]: toggleableContentPropValue } = propsWithContextProviderWrapper;
            if (typeof toggleableContentPropValue === 'function') // @ts-expect-error TS doesn't know this is a callback with variable params that returns ReactNode, but we do
            propsWithContextProviderWrapper[toggleableContentProp] = (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
                    isChoreographed: true
                }, toggleableContentPropValue(...args));
            else {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const content = toggleableContentPropValue;
                // @ts-expect-error TS doesn't know this is a ReactNode, but we do
                propsWithContextProviderWrapper[toggleableContentProp] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
                    isChoreographed: true
                }, content);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ChoreographedComponent, propsWithContextProviderWrapper);
    };
    WithChoreographedToggleComponent.displayName = `WithChoreographedToggle(${Component.displayName ?? Component.name ?? 'Component'})`;
    return WithChoreographedToggleComponent;
};
const $038980df3dc27b63$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $3CprG.useChoreographedStatusContext)();
    const [shouldRender, setShouldRender] = (0, $eJOHy.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $038980df3dc27b63$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!isAlreadyChoreographedAtAncestor) {
            const startMessageAsync = async ()=>{
                const disposition = await startMessage();
                onMessageDisposition?.(disposition);
            };
            startMessageAsync();
            return ()=>{
                stopMessage();
            };
        }
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage,
        isAlreadyChoreographedAtAncestor
    ]);
    return shouldRender || isAlreadyChoreographedAtAncestor;
};
const $038980df3dc27b63$export$a60a99a250d6a89c = ()=>{
    const cleanup = (0, $eJOHy.useRef)();
    const disabled = (0, $eJOHy.useRef)(false);
    if (!disabled.current) {
        cleanup.current = (0, $bdILV.Choreographer).getInstance().disableChoreographerForIframe();
        disabled.current = true;
    }
    (0, $eJOHy.useEffect)(()=>()=>cleanup.current?.(), []);
};

});
parcelRegister("3CprG", function(module, exports) {

$parcel$export(module.exports, "ChoreographerContextProvider", () => $bf177571df54bc6f$export$c3226151caaf2fbf);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $bf177571df54bc6f$export$2eb1efa814fe4a);

var $eJOHy = parcelRequire("eJOHy");
const $bf177571df54bc6f$var$choreographedStatusContextValue = {
    isAlreadyChoreographedAtAncestor: true
};
const $bf177571df54bc6f$export$c3226151caaf2fbf = ({ isChoreographed: isChoreographed, children: children })=>{
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $bf177571df54bc6f$export$2eb1efa814fe4a();
    const shouldUseChoreographerContextProvider = !isAlreadyChoreographedAtAncestor && isChoreographed;
    return shouldUseChoreographerContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bf177571df54bc6f$export$3ff96dbefca6b00d.Provider, {
        value: $bf177571df54bc6f$var$choreographedStatusContextValue
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $bf177571df54bc6f$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $bf177571df54bc6f$export$2eb1efa814fe4a = ()=>(0, $eJOHy.useContext)($bf177571df54bc6f$export$3ff96dbefca6b00d);

});



parcelRegister("3tIRK", function(module, exports) {

$parcel$export(module.exports, "ChoreographerModal", () => $448662a8fa007f74$export$3f5d627caa6fc630);
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $gHHv2 = parcelRequire("gHHv2");

var $1pkzT = parcelRequire("1pkzT");
const $448662a8fa007f74$export$3f5d627caa6fc630 = (0, $1pkzT.withChoreographedRender)((0, $gHHv2.default));

});
parcelRegister("1pkzT", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $8aa717e7fe718299$export$c1160fdac17030e);

var $eJOHy = parcelRequire("eJOHy");

var $3CprG = parcelRequire("3CprG");

var $gL5G0 = parcelRequire("gL5G0");
function $8aa717e7fe718299$export$c1160fdac17030e(Component) {
    function ChoreographedComponent(props) {
        const { messageId: messageId, onMessageDisposition: onMessageDisposition } = props;
        const shouldRender = (0, $gL5G0.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3CprG.ChoreographerContextProvider), {
            isChoreographed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props));
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    function WithChoreographedRenderComponent(props) {
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $3CprG.useChoreographedStatusContext)();
        if (isAlreadyChoreographedAtAncestor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ChoreographedComponent, props);
    }
    WithChoreographedRenderComponent.displayName = `WithChoreographedRender${Component.displayName ?? 'Component'}`;
    return WithChoreographedRenderComponent;
}

});



parcelRegister("5MJX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a3391ab490e79b$export$2e2bcd8739ae039);

var $jPROM = parcelRequire("jPROM");

var $eSnSE = parcelRequire("eSnSE");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");

var $hbF3h = parcelRequire("hbF3h");

var $1gXqv = parcelRequire("1gXqv");

var $aiUkq = parcelRequire("aiUkq");

var $52Wvm = parcelRequire("52Wvm");

var $h7f7W = parcelRequire("h7f7W");

var $lHDWF = parcelRequire("lHDWF");
const $20a3391ab490e79b$export$a5b7a8c3b1c6e775 = (cloudId)=>{
    return `/${(0, $aiUkq.getApiPrefix)()}/query/${cloudId}/3/workflow`;
};
// can be removed with clean up of 'hix-6586_support_wfe_no_nav_or_sidebar_route' as has moved to a shared package
const $20a3391ab490e79b$var$getWorkflowOld = (cloudId, workflowIdentifier, config)=>{
    const url = $20a3391ab490e79b$export$a5b7a8c3b1c6e775(cloudId);
    const { workflowId: workflowId, workflowName: workflowName, projectAndIssueType: projectAndIssueType } = workflowIdentifier;
    const payload = {
        skipUsageLookup: false
    };
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(workflowId)) payload.workflowIds = [
        workflowId
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(workflowName)) payload.workflowNames = [
        workflowName
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(projectAndIssueType)) payload.projectAndIssueTypes = [
        projectAndIssueType
    ];
    if (config?.checkForDrafts && (0, $7jTnu.fg)('hix-6846-discard-wfl-drafts-on-update')) payload.checkForDrafts = true;
    return (0, $jGzN3.performPostRequest)(url, {
        body: JSON.stringify(payload)
    }).then((result)=>{
        try {
            (0, $lHDWF.validateLogicalDocumentIntegrity)(result);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            // an error here will not block the user experience, but it triggers
            // a priority alarm for us to investigate and understand the occurrence.
            (0, $eSnSE.default).safeErrorWithoutCustomerData('workflow.render.integrity.checker', e.message);
        }
        return (0, $7jTnu.fg)('restore-from-workflow-history-versions-hix-4042') ? (0, $52Wvm.transformWithUsages)(result) : (0, $h7f7W.transform)(result);
    });
};
const $20a3391ab490e79b$var$getWorkflowNew = async (cloudId, workflowIdentifier, config)=>{
    const result = await (0, $1gXqv.getWorkflow)(cloudId, workflowIdentifier, config);
    return (0, $h7f7W.transformAPIToMetaDocument)(result);
};
var $20a3391ab490e79b$export$2e2bcd8739ae039 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('hix-6586_support_wfe_no_nav_or_sidebar_route'), $20a3391ab490e79b$var$getWorkflowNew, $20a3391ab490e79b$var$getWorkflowOld);

});
parcelRegister("1gXqv", function(module, exports) {

$parcel$export(module.exports, "getWorkflow", () => $93785a613cfcfac0$export$f927248b35ee72a7);

var $jPROM = parcelRequire("jPROM");

var $jGzN3 = parcelRequire("jGzN3");

var $7jTnu = parcelRequire("7jTnu");
const $93785a613cfcfac0$export$c1b7f62a96ae605b = ()=>'gateway/api/jira/project-configuration';
const $93785a613cfcfac0$export$a5b7a8c3b1c6e775 = (cloudId)=>`/${$93785a613cfcfac0$export$c1b7f62a96ae605b()}/query/${cloudId}/3/workflow`;
const $93785a613cfcfac0$export$f927248b35ee72a7 = (cloudId, workflowIdentifier, config)=>{
    const url = $93785a613cfcfac0$export$a5b7a8c3b1c6e775(cloudId);
    const { workflowId: workflowId, workflowName: workflowName, projectAndIssueType: projectAndIssueType } = workflowIdentifier;
    const payload = {
        skipUsageLookup: false
    };
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(workflowId)) payload.workflowIds = [
        workflowId
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(workflowName)) payload.workflowNames = [
        workflowName
    ];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(projectAndIssueType)) payload.projectAndIssueTypes = [
        projectAndIssueType
    ];
    if (config?.checkForDrafts && (0, $7jTnu.fg)('hix-6846-discard-wfl-drafts-on-update')) payload.checkForDrafts = true;
    return (0, $jGzN3.performPostRequest)(url, {
        body: JSON.stringify(payload)
    });
};

});

parcelRegister("aiUkq", function(module, exports) {

$parcel$export(module.exports, "getApiPrefix", () => $9ddaa120e00cb569$export$c1b7f62a96ae605b);
const $9ddaa120e00cb569$export$c1b7f62a96ae605b = ()=>'gateway/api/jira/project-configuration';

});

parcelRegister("52Wvm", function(module, exports) {

$parcel$export(module.exports, "transform", () => $3b874162164fdf4b$export$51186ad6e864892a);
$parcel$export(module.exports, "transformWithUsages", () => $3b874162164fdf4b$export$2fa43feeb8801e0b);

var $aXKmr = parcelRequire("aXKmr");

var $ljej9 = parcelRequire("ljej9");

var $7jTnu = parcelRequire("7jTnu");

var $200fA = parcelRequire("200fA");

var $5OPbX = parcelRequire("5OPbX");
// TODO - remove transform function from src/packages/project-configuration-commons/src/services/get-workflow/transformer.tsx on restore-from-workflow-history-versions-hix-4042 cleanup
const $3b874162164fdf4b$var$flattenConditionsRecursively = (conditionGroup)=>{
    if (!conditionGroup) return [];
    return conditionGroup.conditions.concat(conditionGroup.conditionGroups.flatMap($3b874162164fdf4b$var$flattenConditionsRecursively));
};
const $3b874162164fdf4b$var$transformConditionGroupRecursively = (conditionGroup)=>({
        id: (0, $aXKmr.v4)(),
        operation: conditionGroup.operation,
        conditionGroups: conditionGroup.conditionGroups.map($3b874162164fdf4b$var$transformConditionGroupRecursively),
        conditionIds: conditionGroup.conditions.map(({ id: id })=>(0, $5OPbX.toRuleId)(id))
    });
const $3b874162164fdf4b$var$transformRule = (rule)=>({
        id: rule.id,
        displayText: '',
        ruleKey: rule.ruleKey,
        config: rule.parameters,
        ...rule.type ? {
            type: rule.type
        } : {}
    });
const $3b874162164fdf4b$var$transformRules = (transition)=>{
    const actions = (transition.actions || []).map((action)=>({
            ...action,
            type: (0, $5OPbX.ACTION_RULE_TYPE)
        }));
    const conditions = $3b874162164fdf4b$var$flattenConditionsRecursively(transition.conditions).map((condition)=>({
            ...condition,
            type: (0, $5OPbX.CONDITION_RULE_TYPE)
        }));
    const validators = (transition.validators || []).map((validator)=>({
            ...validator,
            type: (0, $5OPbX.VALIDATOR_RULE_TYPE)
        }));
    const triggers = (transition.triggers || []).map((trigger)=>({
            ...trigger,
            type: (0, $5OPbX.TRIGGER_RULE_TYPE)
        }));
    const screens = transition.transitionScreen ? [
        {
            ...transition.transitionScreen,
            type: (0, $5OPbX.SCREEN_RULE_TYPE)
        }
    ] : [];
    const rules = [
        ...actions,
        ...conditions,
        ...validators,
        ...triggers,
        ...screens
    ];
    let conditionTree;
    if (transition.conditions) conditionTree = $3b874162164fdf4b$var$transformConditionGroupRecursively(transition.conditions);
    return {
        rules: rules.map($3b874162164fdf4b$var$transformRule),
        conditionTree: conditionTree
    };
};
const $3b874162164fdf4b$var$getTransitionLinks = (transition)=>{
    const { links: links } = transition;
    if (transition.type === (0, $200fA.transitionType).INITIAL) return [
        {
            fromRef: (0, $5OPbX.toStatusId)((0, $200fA.START_NODE_ID)),
            fromPort: 0,
            toPort: links[0]?.toPort || 0
        }
    ];
    if (transition.type === (0, $200fA.transitionType).GLOBAL) return [];
    return links.reduce((acc, link)=>{
        if (link.fromStatusReference !== undefined) acc.push({
            fromRef: link.fromStatusReference,
            fromPort: link.fromPort,
            toPort: link.toPort
        });
        return acc;
    }, []);
};
const $3b874162164fdf4b$var$transformTransitions = (transitions)=>{
    const transformed = {};
    transitions.forEach((transition)=>{
        transformed[transition.id] = {
            id: transition.id,
            type: (0, $200fA.transitionType)[transition.type],
            name: transition.name,
            description: transition.description || '',
            toRef: transition.toStatusReference,
            links: $3b874162164fdf4b$var$getTransitionLinks(transition),
            properties: transition.properties ?? {},
            ...$3b874162164fdf4b$var$transformRules(transition),
            ...transition.customIssueEventId ? {
                customIssueEventId: transition.customIssueEventId
            } : {}
        };
    });
    return transformed;
};
const $3b874162164fdf4b$export$51186ad6e864892a = (response)=>{
    const [workflow] = response.workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allStatuses = {};
    const visibleStatuses = [];
    response.statuses.forEach((status)=>{
        const workflowStatus = workflow.statuses.find((candidate)=>candidate.statusReference === status.id);
        allStatuses[status.statusReference] = {
            id: status.id,
            name: status.name,
            description: status.description,
            isNew: false,
            statusCategory: status.statusCategory,
            layout: workflowStatus?.layout && workflowStatus.layout.x && workflowStatus.layout.y ? workflowStatus.layout : undefined,
            properties: workflowStatus?.properties ?? {},
            ...workflowStatus?.approvalConfiguration && {
                approvalConfiguration: workflowStatus.approvalConfiguration
            }
        };
        if (workflowStatus) visibleStatuses.push({
            ref: (0, $5OPbX.toStatusId)(workflowStatus.statusReference)
        });
    });
    return {
        id: workflow.id,
        name: workflow.name,
        description: workflow.description,
        versionNumber: workflow.version.versionNumber,
        versionId: workflow.version.id,
        scope: workflow.scope,
        allStatuses: allStatuses,
        visibleStatuses: visibleStatuses,
        transitions: $3b874162164fdf4b$var$transformTransitions(workflow.transitions),
        startNodeLayout: workflow.startPointLayout || {},
        loopedTransitionContainerLayout: workflow.loopedTransitionContainerLayout || {},
        migrationId: workflow.migrationId,
        isEditable: workflow.isEditable,
        hasDraft: (0, $7jTnu.fg)('hix-6846-discard-wfl-drafts-on-update') ? workflow.hasDraft : undefined
    };
};
const $3b874162164fdf4b$export$2fa43feeb8801e0b = (response)=>{
    const [workflow] = response.workflows;
    const transformedWorkflow = $3b874162164fdf4b$export$51186ad6e864892a(response);
    const getAssociatedIssueTypes = (associations)=>associations?.length ? associations[0].issueTypes.map((0, $ljej9.toIssueTypeId)) : [];
    return {
        ...transformedWorkflow,
        associatedIssueTypeIds: getAssociatedIssueTypes(workflow.associatedWith),
        associatedEntityIds: workflow.associatedWith.map(({ project: project, issueTypes: issueTypes })=>({
                project: {
                    id: (0, $ljej9.toProjectId)(project.id)
                },
                issueTypes: issueTypes.map((0, $ljej9.toIssueTypeId))
            }))
    };
};

});
parcelRegister("200fA", function(module, exports) {

$parcel$export(module.exports, "START_NODE_ID", () => $06774dfad150bafe$export$e117396b0784c7cc);
$parcel$export(module.exports, "transitionType", () => $06774dfad150bafe$export$331d6399b2e33350);
$parcel$export(module.exports, "SCOPE_GLOBAL", () => $06774dfad150bafe$export$9bb188cec3fcc43d);
$parcel$export(module.exports, "SCOPE_PROJECT", () => $06774dfad150bafe$export$54c3a1cc8eb1bc43);
$parcel$export(module.exports, "ALL_OPERATION", () => $06774dfad150bafe$export$d3dc8e33b7258fc5);
$parcel$export(module.exports, "STATUS_CATEGORY_WEIGHTS", () => $06774dfad150bafe$export$8fc40e3c53b7f30e);
$parcel$export(module.exports, "ANY_OPERATION", () => $06774dfad150bafe$export$804f62993e553350);
$parcel$export(module.exports, "errorSeverity", () => $06774dfad150bafe$export$927c560a42a52ce0);

var $7keuM = parcelRequire("7keuM");
const $06774dfad150bafe$export$e117396b0784c7cc = 'START';
const $06774dfad150bafe$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $06774dfad150bafe$export$9bb188cec3fcc43d = 'GLOBAL';
const $06774dfad150bafe$export$54c3a1cc8eb1bc43 = 'PROJECT';
const $06774dfad150bafe$export$d3dc8e33b7258fc5 = 'ALL';
const $06774dfad150bafe$export$8fc40e3c53b7f30e = {
    [(0, $7keuM.TODO)]: 1,
    [(0, $7keuM.IN_PROGRESS)]: 2,
    [(0, $7keuM.DONE)]: 3,
    [(0, $7keuM.UNDEFINED)]: 4
};
const $06774dfad150bafe$export$804f62993e553350 = 'ANY';
const $06774dfad150bafe$export$927c560a42a52ce0 = {
    WARNING: 'WARNING',
    ERROR: 'ERROR'
};

});
parcelRegister("7keuM", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e9fafd5bde6d9f47$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e9fafd5bde6d9f47$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e9fafd5bde6d9f47$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e9fafd5bde6d9f47$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e9fafd5bde6d9f47$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e9fafd5bde6d9f47$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e9fafd5bde6d9f47$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e9fafd5bde6d9f47$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e9fafd5bde6d9f47$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e9fafd5bde6d9f47$export$d928f247c903643a);
const $e9fafd5bde6d9f47$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e9fafd5bde6d9f47$export$aa456a5030160740 = 'TODO';
const $e9fafd5bde6d9f47$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e9fafd5bde6d9f47$export$71efb3495f6084f2 = 'DONE';
const $e9fafd5bde6d9f47$export$d9119300f9d9a815 = [
    $e9fafd5bde6d9f47$export$6db089fe7b26f5b6,
    $e9fafd5bde6d9f47$export$aa456a5030160740,
    $e9fafd5bde6d9f47$export$5a9ac66c2785cc13,
    $e9fafd5bde6d9f47$export$71efb3495f6084f2
];
const $e9fafd5bde6d9f47$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e9fafd5bde6d9f47$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e9fafd5bde6d9f47$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e9fafd5bde6d9f47$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e9fafd5bde6d9f47$export$71efb3495f6084f2
    }
];
const $e9fafd5bde6d9f47$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e9fafd5bde6d9f47$export$3f42f49c284d5b58 = Object.freeze({
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.NEW]: 2,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.DONE]: 3,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb = Object.values($e9fafd5bde6d9f47$export$5d42a08d46cffe7);
const $e9fafd5bde6d9f47$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e9fafd5bde6d9f47$export$6db089fe7b26f5b6;
};
const $e9fafd5bde6d9f47$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e9fafd5bde6d9f47$export$d928f247c903643a = (key)=>$e9fafd5bde6d9f47$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("5OPbX", function(module, exports) {

$parcel$export(module.exports, "toStatusId", () => $f0475b44e23747e3$export$1699a296491b2858);
$parcel$export(module.exports, "toTransitionId", () => $f0475b44e23747e3$export$516884c22d7e44a0);
$parcel$export(module.exports, "toRuleId", () => $f0475b44e23747e3$export$a18d02a6aa57ae7f);
$parcel$export(module.exports, "toRuleKey", () => $f0475b44e23747e3$export$8869faa66afddcee);
$parcel$export(module.exports, "ACTION_RULE_TYPE", () => $f0475b44e23747e3$export$3502294f79d19760);
$parcel$export(module.exports, "VALIDATOR_RULE_TYPE", () => $f0475b44e23747e3$export$693dd3cc66111a25);
$parcel$export(module.exports, "TRIGGER_RULE_TYPE", () => $f0475b44e23747e3$export$3ba72f070d7e1f8);
$parcel$export(module.exports, "CONDITION_RULE_TYPE", () => $f0475b44e23747e3$export$80aa97bba188b58d);
$parcel$export(module.exports, "SCREEN_RULE_TYPE", () => $f0475b44e23747e3$export$f2806a4bb8fad62e);
$parcel$export(module.exports, "toMigrationId", () => $f0475b44e23747e3$export$2e3b8adb0f6f0e73);
$parcel$export(module.exports, "RULEDESCRIPTORTYPE_VALIDATOR", () => $f0475b44e23747e3$export$2de5623c1b523a0e);
$parcel$export(module.exports, "RULEDESCRIPTORTYPE_FUNCTION", () => $f0475b44e23747e3$export$409e451098fe718a);
$parcel$export(module.exports, "RULEDESCRIPTORTYPE_SCREEN", () => $f0475b44e23747e3$export$fb9c85bcc2b7f87f);
$parcel$export(module.exports, "INITIAL", () => $f0475b44e23747e3$export$17227441e89ee693);
$parcel$export(module.exports, "GLOBAL", () => $f0475b44e23747e3$export$17ff3f7e02c6ac22);
$parcel$export(module.exports, "DIRECTED", () => $f0475b44e23747e3$export$ecdc381371b8557);
const $f0475b44e23747e3$export$1699a296491b2858 = (value)=>value;
const $f0475b44e23747e3$export$516884c22d7e44a0 = (value)=>value;
const $f0475b44e23747e3$export$a18d02a6aa57ae7f = (value)=>value;
const $f0475b44e23747e3$export$8869faa66afddcee = (value)=>value;
const $f0475b44e23747e3$export$e712733e83adfe5f = 'all';
const $f0475b44e23747e3$export$3502294f79d19760 = 'action';
const $f0475b44e23747e3$export$693dd3cc66111a25 = 'validator';
const $f0475b44e23747e3$export$3ba72f070d7e1f8 = 'trigger';
const $f0475b44e23747e3$export$80aa97bba188b58d = 'condition';
const $f0475b44e23747e3$export$f2806a4bb8fad62e = 'screen';
const $f0475b44e23747e3$export$2e3b8adb0f6f0e73 = (value)=>value;
const $f0475b44e23747e3$export$3376a0f7af04519d = 'Condition';
const $f0475b44e23747e3$export$2de5623c1b523a0e = 'Validator';
const $f0475b44e23747e3$export$409e451098fe718a = 'Function';
const $f0475b44e23747e3$export$fb9c85bcc2b7f87f = 'Screen';
const $f0475b44e23747e3$export$17227441e89ee693 = 'INITIAL';
const $f0475b44e23747e3$export$17ff3f7e02c6ac22 = 'GLOBAL';
const $f0475b44e23747e3$export$ecdc381371b8557 = 'DIRECTED';

});


parcelRegister("h7f7W", function(module, exports) {

$parcel$export(module.exports, "transform", () => $22f3055ae1fe6def$export$51186ad6e864892a);
$parcel$export(module.exports, "transformAPIToMetaDocument", () => $22f3055ae1fe6def$export$d8b89067fc7ab9b2);

var $aXKmr = parcelRequire("aXKmr");

var $ljej9 = parcelRequire("ljej9");

var $7jTnu = parcelRequire("7jTnu");

var $eSnSE = parcelRequire("eSnSE");

var $200fA = parcelRequire("200fA");

var $5OPbX = parcelRequire("5OPbX");

var $52Wvm = parcelRequire("52Wvm");

var $lHDWF = parcelRequire("lHDWF");
const $22f3055ae1fe6def$var$flattenConditionsRecursively = (conditionGroup)=>{
    if (!conditionGroup) return [];
    return conditionGroup.conditions.concat(conditionGroup.conditionGroups.flatMap($22f3055ae1fe6def$var$flattenConditionsRecursively));
};
const $22f3055ae1fe6def$var$transformConditionGroupRecursively = (conditionGroup)=>({
        id: (0, $aXKmr.v4)(),
        operation: conditionGroup.operation,
        conditionGroups: conditionGroup.conditionGroups.map($22f3055ae1fe6def$var$transformConditionGroupRecursively),
        conditionIds: conditionGroup.conditions.map(({ id: id })=>(0, $5OPbX.toRuleId)(id))
    });
const $22f3055ae1fe6def$var$transformRule = (rule)=>({
        id: rule.id,
        displayText: '',
        ruleKey: rule.ruleKey,
        config: rule.parameters,
        ...rule.type ? {
            type: rule.type
        } : {}
    });
const $22f3055ae1fe6def$var$transformRules = (transition)=>{
    const actions = (transition.actions || []).map((action)=>({
            ...action,
            type: (0, $5OPbX.ACTION_RULE_TYPE)
        }));
    const conditions = $22f3055ae1fe6def$var$flattenConditionsRecursively(transition.conditions).map((condition)=>({
            ...condition,
            type: (0, $5OPbX.CONDITION_RULE_TYPE)
        }));
    const validators = (transition.validators || []).map((validator)=>({
            ...validator,
            type: (0, $5OPbX.VALIDATOR_RULE_TYPE)
        }));
    const triggers = (transition.triggers || []).map((trigger)=>({
            ...trigger,
            type: (0, $5OPbX.TRIGGER_RULE_TYPE)
        }));
    const screens = transition.transitionScreen ? [
        {
            ...transition.transitionScreen,
            type: (0, $5OPbX.SCREEN_RULE_TYPE)
        }
    ] : [];
    const rules = [
        ...actions,
        ...conditions,
        ...validators,
        ...triggers,
        ...screens
    ];
    let conditionTree;
    if (transition.conditions) conditionTree = $22f3055ae1fe6def$var$transformConditionGroupRecursively(transition.conditions);
    return {
        rules: rules.map($22f3055ae1fe6def$var$transformRule),
        conditionTree: conditionTree
    };
};
const $22f3055ae1fe6def$var$getTransitionLinks = (transition)=>{
    const { links: links } = transition;
    if (transition.type === (0, $200fA.transitionType).INITIAL) return [
        {
            fromRef: (0, $5OPbX.toStatusId)((0, $200fA.START_NODE_ID)),
            fromPort: 0,
            toPort: links[0]?.toPort || 0
        }
    ];
    if (transition.type === (0, $200fA.transitionType).GLOBAL) return [];
    return links.reduce((acc, link)=>{
        if (link.fromStatusReference !== undefined) acc.push({
            fromRef: link.fromStatusReference,
            fromPort: link.fromPort,
            toPort: link.toPort
        });
        return acc;
    }, []);
};
const $22f3055ae1fe6def$var$transformTransitions = (transitions)=>{
    const transformed = {};
    transitions.forEach((transition)=>{
        transformed[transition.id] = {
            id: transition.id,
            type: (0, $200fA.transitionType)[transition.type],
            name: transition.name,
            description: transition.description || '',
            toRef: transition.toStatusReference,
            links: $22f3055ae1fe6def$var$getTransitionLinks(transition),
            properties: transition.properties ?? {},
            ...$22f3055ae1fe6def$var$transformRules(transition),
            ...transition.customIssueEventId ? {
                customIssueEventId: transition.customIssueEventId
            } : {}
        };
    });
    return transformed;
};
const $22f3055ae1fe6def$export$51186ad6e864892a = (response)=>{
    const [workflow] = response.workflows;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allStatuses = {};
    const visibleStatuses = [];
    const getAssociatedIssueTypes = (associations)=>associations?.length ? associations[0].issueTypes.map((0, $ljej9.toIssueTypeId)) : [];
    response.statuses.forEach((status)=>{
        const workflowStatus = workflow.statuses.find((candidate)=>candidate.statusReference === status.id);
        allStatuses[status.statusReference] = {
            id: status.id,
            name: status.name,
            description: status.description,
            isNew: false,
            statusCategory: status.statusCategory,
            layout: workflowStatus?.layout && workflowStatus.layout.x && workflowStatus.layout.y ? workflowStatus.layout : undefined,
            properties: workflowStatus?.properties ?? {},
            ...workflowStatus?.approvalConfiguration && {
                approvalConfiguration: workflowStatus.approvalConfiguration
            }
        };
        if (workflowStatus) visibleStatuses.push({
            ref: (0, $5OPbX.toStatusId)(workflowStatus.statusReference)
        });
    });
    return {
        id: workflow.id,
        name: workflow.name,
        description: workflow.description,
        versionNumber: workflow.version.versionNumber,
        versionId: workflow.version.id,
        scope: workflow.scope,
        allStatuses: allStatuses,
        visibleStatuses: visibleStatuses,
        transitions: $22f3055ae1fe6def$var$transformTransitions(workflow.transitions),
        startNodeLayout: workflow.startPointLayout || {},
        loopedTransitionContainerLayout: workflow.loopedTransitionContainerLayout || {},
        associatedIssueTypeIds: getAssociatedIssueTypes(workflow.associatedWith),
        associatedEntityIds: workflow.associatedWith.map(({ project: project, issueTypes: issueTypes })=>({
                project: {
                    id: (0, $ljej9.toProjectId)(project.id)
                },
                issueTypes: issueTypes.map((0, $ljej9.toIssueTypeId))
            })),
        migrationId: workflow.migrationId,
        isEditable: workflow.isEditable,
        hasDraft: (0, $7jTnu.fg)('hix-6846-discard-wfl-drafts-on-update') ? workflow.hasDraft : undefined
    };
};
function $22f3055ae1fe6def$export$d8b89067fc7ab9b2(apiResponse) {
    try {
        (0, $lHDWF.validateLogicalDocumentIntegrity)(apiResponse);
    } catch (err) {
        // an error here will not block the user experience, but it triggers
        // a priority alarm for us to investigate and understand the occurrence.
        (0, $eSnSE.default).safeErrorWithoutCustomerData('workflow.render.integrity.checker', err instanceof Error ? err.message : String(err));
    }
    return (0, $7jTnu.fg)('restore-from-workflow-history-versions-hix-4042') ? (0, $52Wvm.transformWithUsages)(apiResponse) : $22f3055ae1fe6def$export$51186ad6e864892a(apiResponse);
}

});
parcelRegister("lHDWF", function(module, exports) {

$parcel$export(module.exports, "validateLogicalDocumentIntegrity", () => $bd2fab33bc131d55$export$f2d04b42cf39668b);

var $7keuM = parcelRequire("7keuM");

var $5OPbX = parcelRequire("5OPbX");
class $bd2fab33bc131d55$export$627388fd8033c742 extends Error {
}
const $bd2fab33bc131d55$var$assertStatusesHaveValidNames = (statuses)=>{
    statuses.forEach((status)=>{
        if (status.name.length === 0) throw new $bd2fab33bc131d55$export$627388fd8033c742('Detected invalid empty status name.');
    });
};
const $bd2fab33bc131d55$var$assertStatusesHaveValidCategories = (statuses)=>{
    statuses.forEach((status)=>{
        if (!(0, $7keuM.STATUS_CATEGORIES).includes(status.statusCategory)) throw new $bd2fab33bc131d55$export$627388fd8033c742(`Detected unexpected status category: ${status.statusCategory}.`);
    });
};
const $bd2fab33bc131d55$var$assertTransitionsHaveValidNames = (transitions)=>{
    transitions.forEach((transition)=>{
        if (transition.name.length === 0) throw new $bd2fab33bc131d55$export$627388fd8033c742('Detected invalid empty transition name.');
    });
};
const $bd2fab33bc131d55$var$assertInitialTransitionExists = (transitions)=>{
    const countInitialTransitions = transitions.filter((t)=>t.type === (0, $5OPbX.INITIAL)).length;
    if (countInitialTransitions !== 1) throw new $bd2fab33bc131d55$export$627388fd8033c742(`Detected workflow with ${countInitialTransitions} INITIAL transitions. Expected a single one.`);
};
const $bd2fab33bc131d55$var$assertTransitionsAreCorrectlyConnected = (transitions, statuses)=>{
    const validStatusReferences = statuses.map((status)=>status.statusReference);
    transitions.filter((t)=>t.type === (0, $5OPbX.DIRECTED)).forEach((transition)=>{
        const { toStatusReference: toStatusReference, links: [{ fromStatusReference: fromStatusReference }] } = transition;
        // DIRECTED transitions have to have valid `from` and `to` references
        if (!fromStatusReference || !validStatusReferences.includes(fromStatusReference) || !toStatusReference || !validStatusReferences.includes(toStatusReference)) throw new $bd2fab33bc131d55$export$627388fd8033c742('Detected DIRECTED transition with invalid from and to references (either or both).');
    });
    transitions.filter((t)=>t.type === (0, $5OPbX.INITIAL)).forEach((transition)=>{
        const { toStatusReference: toStatusReference, links: links } = transition;
        const fromRefs = links.map((link)=>link.fromStatusReference).filter((ref)=>ref !== undefined);
        // INITIAL transitions only need to have a valid `to` reference
        if (!toStatusReference || !validStatusReferences.includes(toStatusReference) || fromRefs.length) throw new $bd2fab33bc131d55$export$627388fd8033c742(`Detected ${transition.type} transition without a valid destination or with a defined "from".`);
    });
    const unknownType = transitions.find((t)=>t.type !== (0, $5OPbX.DIRECTED) && t.type !== (0, $5OPbX.GLOBAL) && t.type !== (0, $5OPbX.INITIAL));
    if (unknownType) throw new $bd2fab33bc131d55$export$627388fd8033c742(`Detected unexpected transition type: ${unknownType.type}.`);
};
const $bd2fab33bc131d55$export$f2d04b42cf39668b = (result)=>{
    const { statuses: statuses } = result;
    const [workflow] = result.workflows;
    const { transitions: transitions } = workflow;
    $bd2fab33bc131d55$var$assertStatusesHaveValidNames(statuses);
    $bd2fab33bc131d55$var$assertStatusesHaveValidCategories(statuses);
    $bd2fab33bc131d55$var$assertTransitionsHaveValidNames(transitions);
    $bd2fab33bc131d55$var$assertTransitionsAreCorrectlyConnected(transitions, statuses);
    $bd2fab33bc131d55$var$assertInitialTransitionExists(transitions);
    return result;
};

});



parcelRegister("kEUB1", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $5217c4f42a781287$export$9da0f7c65f28ed16);

var $lvKO5 = parcelRequire("lvKO5");
const $5217c4f42a781287$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("dPMMf", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $5368467aa3534c05$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $5368467aa3534c05$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $5368467aa3534c05$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $5368467aa3534c05$export$7be255094ccdc533);

var $IW7jS = parcelRequire("IW7jS");
const $5368467aa3534c05$export$6d8204c2cb2e06b8 = 8;
const $5368467aa3534c05$export$7a57f79000377ca2 = (0, $IW7jS.borderRadius)();
const $5368467aa3534c05$export$22dec01f2c854397 = 40;
const $5368467aa3534c05$export$dab5ea164c6f81a = 100;
const $5368467aa3534c05$export$7be255094ccdc533 = {
    banner: (0, $IW7jS.layers).navigation(),
    card: (0, $IW7jS.layers).card(),
    dialog: (0, $IW7jS.layers).dialog(),
    navigation: (0, $IW7jS.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $IW7jS.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $IW7jS.layers).navigation() - 1,
    layer: (0, $IW7jS.layers).layer(),
    blanket: (0, $IW7jS.layers).blanket(),
    modal: (0, $IW7jS.layers).modal(),
    flag: (0, $IW7jS.layers).flag(),
    spotlight: (0, $IW7jS.layers).spotlight(),
    tooltip: (0, $IW7jS.layers).tooltip(),
    mobileBanner: $5368467aa3534c05$export$dab5ea164c6f81a
};
const $5368467aa3534c05$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});

parcelRegister("aNRVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c2d600cb4e68291$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5kYyR = parcelRequire("5kYyR");

var $6dmHl = parcelRequire("6dmHl");
const $4c2d600cb4e68291$var$WrappedDiagram = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: "unhandled",
        packageName: "jiraAccessibleWorkflowDiagram",
        teamName: "helix",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6dmHl.default), props));
var $4c2d600cb4e68291$export$2e2bcd8739ae039 = $4c2d600cb4e68291$var$WrappedDiagram;

});
parcelRegister("6dmHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4460c1c4dc7c33d6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $200fA = parcelRequire("200fA");

var $h2zA1 = parcelRequire("h2zA1");

var $v1MZY = parcelRequire("v1MZY");

var $6ERGt = parcelRequire("6ERGt");

var $gn7EO = parcelRequire("gn7EO");

var $4yAsG = parcelRequire("4yAsG");

var $dIUfl = parcelRequire("dIUfl");

var $3rQlT = parcelRequire("3rQlT");
const $4460c1c4dc7c33d6$var$AccessibleDiagram = ({ statuses: statuses, transitions: transitions, errors: errors, startNodeLayout: startNodeLayout, globalLoopsContainerLayout: globalLoopsContainerLayout, zoom: zoom, panOffset: panOffset, isImmutable: isImmutable = false, selectedItem: selectedItem, onSelect: onSelect, onDrawCompleted: onDrawCompleted, onNodeUpdate: onNodeUpdate, onViewBoxChanged: onViewBoxChanged, onZoomUpdate: onZoomUpdate, onTransitionUpdate: onTransitionUpdate, onTransitionCreate: onTransitionCreate, onPanUpdate: onPanUpdate, onGlobalLoopsContainerMove: onGlobalLoopsContainerMove, onTargetChange: onTargetChange, collapseTransitionLabels: collapseTransitionLabels = false, shouldShowGlobalLoops: shouldShowGlobalLoops = false })=>{
    const [targetedItem, setTargetedItem] = (0, $eJOHy.useState)();
    const [movingItem, setMovingItem] = (0, $eJOHy.useState)(undefined);
    const latestOnSelect = (0, $h2zA1.useLatest)(onSelect);
    const latestOnDrawCompleted = (0, $h2zA1.useLatest)(onDrawCompleted);
    const latestOnNodeUpdate = (0, $h2zA1.useLatest)(onNodeUpdate);
    const latestOnViewBoxChanged = (0, $h2zA1.useLatest)(onViewBoxChanged);
    const latestOnTransitionUpdate = (0, $h2zA1.useLatest)(onTransitionUpdate);
    const latestOnTransitionCreate = (0, $h2zA1.useLatest)(onTransitionCreate);
    const latestOnGlobalLoopsContainerMove = (0, $h2zA1.useLatest)(onGlobalLoopsContainerMove);
    const latestOnTargetChange = (0, $h2zA1.useLatest)(onTargetChange);
    const handleTargetChange = (0, $eJOHy.useCallback)((target)=>{
        setTargetedItem(target);
        latestOnTargetChange.current?.(target);
    }, [
        latestOnTargetChange
    ]);
    const diagramTransitions = (0, $eJOHy.useMemo)(()=>(0, $3rQlT.toDiagramTransitions)(transitions, errors, statuses), [
        errors,
        statuses,
        transitions
    ]);
    const initialStatusId = diagramTransitions.find((transition)=>transition.type === 'direct' && transition.source === (0, $200fA.START_NODE_ID))?.target;
    const diagramStatuses = (0, $eJOHy.useMemo)(()=>(0, $3rQlT.toDiagramStatuses)(statuses, initialStatusId, errors), [
        errors,
        initialStatusId,
        statuses
    ]);
    const startNodePosition = (0, $eJOHy.useMemo)(()=>(0, $3rQlT.toDiagramStartNodePosition)(startNodeLayout), [
        startNodeLayout
    ]);
    const globalLoopsContainerPosition = (0, $eJOHy.useMemo)(()=>{
        return (0, $3rQlT.toDiagramGlobalLoopsContainerPosition)(globalLoopsContainerLayout);
    }, [
        globalLoopsContainerLayout
    ]);
    const onRenderComplete = (0, $eJOHy.useCallback)(()=>{
        latestOnDrawCompleted.current?.('INITIAL');
    }, [
        latestOnDrawCompleted
    ]);
    const onSelectItem = (0, $eJOHy.useCallback)((item)=>{
        if (!item) {
            latestOnSelect.current?.(undefined);
            return;
        }
        latestOnSelect.current?.({
            id: item.id,
            type: item.type
        });
    }, [
        latestOnSelect
    ]);
    const onItemMove = (0, $eJOHy.useCallback)((payload)=>{
        if (payload.type === (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE)) latestOnGlobalLoopsContainerMove.current?.(payload.position);
        else latestOnNodeUpdate.current?.({
            id: payload.id,
            layout: payload.position
        });
    }, [
        latestOnGlobalLoopsContainerMove,
        latestOnNodeUpdate
    ]);
    const clearGlobalLoopsContainerPosition = (0, $eJOHy.useCallback)(()=>{
        latestOnGlobalLoopsContainerMove.current?.({});
    }, [
        latestOnGlobalLoopsContainerMove
    ]);
    const handleTransitionCreateNew = (0, $eJOHy.useCallback)((transition)=>{
        latestOnTransitionCreate.current?.((0, $3rQlT.getTransitionConnectionInfo)(transition));
    }, [
        latestOnTransitionCreate
    ]);
    const handleTransitionPortChangeNew = (0, $eJOHy.useCallback)((transition)=>{
        latestOnTransitionUpdate.current?.({
            id: transition.id,
            ...(0, $3rQlT.getTransitionConnectionInfo)(transition)
        });
    }, [
        latestOnTransitionUpdate
    ]);
    const [currentPan, updatePan] = (0, $6ERGt.useControllable)(panOffset, onPanUpdate, (0, $gn7EO.DEFAULT_PAN));
    const [currentZoom, updateZoom] = (0, $6ERGt.useControllable)(zoom, onZoomUpdate, (0, $gn7EO.DEFAULT_ZOOM_LEVEL));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dIUfl.default), {
        startNodePosition: startNodePosition,
        globalLoopsContainerPosition: globalLoopsContainerPosition,
        statuses: statuses,
        transitions: transitions,
        errors: errors,
        isImmutable: isImmutable,
        movingItem: movingItem,
        selectedItem: selectedItem,
        zoom: currentZoom,
        pan: currentPan,
        onSelect: latestOnSelect.current,
        onTargetChange: handleTargetChange,
        setMovingItem: setMovingItem,
        onItemMove: onItemMove,
        onZoomChange: updateZoom,
        onPanChange: updatePan
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4yAsG.default), {
        isImmutable: isImmutable,
        transitions: diagramTransitions,
        startNodePosition: startNodePosition,
        globalLoopsContainerPosition: globalLoopsContainerPosition,
        onClearGlobalLoopsContainerPosition: clearGlobalLoopsContainerPosition,
        statuses: diagramStatuses,
        selectedItem: selectedItem ?? undefined,
        targetedItem: targetedItem,
        movingItem: movingItem,
        zoom: currentZoom,
        pan: currentPan,
        onViewBoxChange: latestOnViewBoxChanged.current,
        onZoomChange: updateZoom,
        onPanChange: updatePan,
        onRenderComplete: onRenderComplete,
        onItemMove: onItemMove,
        onTransitionCreate: handleTransitionCreateNew,
        onTransitionPortChange: handleTransitionPortChangeNew,
        onSelect: onSelectItem,
        collapseTransitionLabels: collapseTransitionLabels,
        shouldShowGlobalLoops: shouldShowGlobalLoops
    }));
};
var $4460c1c4dc7c33d6$export$2e2bcd8739ae039 = $4460c1c4dc7c33d6$var$AccessibleDiagram;

});
parcelRegister("h2zA1", function(module, exports) {

$parcel$export(module.exports, "useLatest", () => $8a4c5145d991e99d$export$d4b699e2c1148419);

var $eJOHy = parcelRequire("eJOHy");
const $8a4c5145d991e99d$export$d4b699e2c1148419 = (value)=>{
    const latestValueRef = (0, $eJOHy.useRef)(value);
    latestValueRef.current = value;
    return latestValueRef;
};

});

parcelRegister("v1MZY", function(module, exports) {

$parcel$export(module.exports, "NODE_TYPE", () => $0886c21f03063533$export$accaa52ddae3fe58);
$parcel$export(module.exports, "EDGE_TYPE", () => $0886c21f03063533$export$97a9b8cddf240cf5);
$parcel$export(module.exports, "GLOBAL_LOOPS_CONTAINER_TYPE", () => $0886c21f03063533$export$7d4b2f678780aa0e);
$parcel$export(module.exports, "DIAGRAM_CONTAINER_TYPE", () => $0886c21f03063533$export$7404c17aa85d8d13);
$parcel$export(module.exports, "DIRECTION_KEYS", () => $0886c21f03063533$export$7a24a077d7a1fcef);
$parcel$export(module.exports, "ZOOM_KEYS", () => $0886c21f03063533$export$f9f0f7b18f298734);
const $0886c21f03063533$export$accaa52ddae3fe58 = 'node';
const $0886c21f03063533$export$97a9b8cddf240cf5 = 'edge';
const $0886c21f03063533$export$7d4b2f678780aa0e = 'global-loops-container';
const $0886c21f03063533$export$7404c17aa85d8d13 = 'diagram-container';
const $0886c21f03063533$export$7a24a077d7a1fcef = {
    ArrowUp: 'up',
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right'
};
const $0886c21f03063533$export$f9f0f7b18f298734 = {
    '+': 'IN',
    '=': 'IN',
    '-': 'OUT',
    _: 'OUT'
};

});

parcelRegister("6ERGt", function(module, exports) {

$parcel$export(module.exports, "useControllable", () => $2edc79d04600f319$export$454217e89aea72b);
/**
 * Use in scenarios where you want an optionally controlled prop.
 * If the prop is defined its value will be used otherwise local state will be used.
 * Using the provided update function ensures that the state is updated and change callback function is called (if given).
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $h2zA1 = parcelRequire("h2zA1");
function $2edc79d04600f319$export$454217e89aea72b(propValue, changeCallback, defaultValue) {
    const [stateValue, setStateValue] = (0, $eJOHy.useState)(defaultValue);
    const latestChangeCallback = (0, $h2zA1.useLatest)(changeCallback);
    const value = propValue === undefined ? stateValue : propValue;
    const updateValue = (0, $eJOHy.useCallback)((newValue)=>{
        setStateValue(newValue);
        latestChangeCallback.current?.(newValue);
    }, [
        latestChangeCallback
    ]);
    return [
        value,
        updateValue
    ];
}

});

parcelRegister("gn7EO", function(module, exports) {

$parcel$export(module.exports, "MINIMUM_ZOOM_LEVEL", () => $f940d9ba3f88f31d$export$eadcd7bcf388da50);
$parcel$export(module.exports, "MAXIMUM_ZOOM_LEVEL", () => $f940d9ba3f88f31d$export$212e080fc48fe6c9);
$parcel$export(module.exports, "DEFAULT_ZOOM_LEVEL", () => $f940d9ba3f88f31d$export$314df2ab1d1b768f);
$parcel$export(module.exports, "LINEAR_ZOOM_STEP", () => $f940d9ba3f88f31d$export$242961008b66e9eb);
$parcel$export(module.exports, "DEFAULT_PAN", () => $f940d9ba3f88f31d$export$bce6d504eee086c2);
$parcel$export(module.exports, "STATUS_HEIGHT", () => $f940d9ba3f88f31d$export$2dcb44527ea5ccd4);
$parcel$export(module.exports, "TRANSITION_STROKE_WIDTH", () => $f940d9ba3f88f31d$export$2a3643000478f19c);
$parcel$export(module.exports, "START_NODE_RADIUS", () => $f940d9ba3f88f31d$export$bc1449a84350d176);
$parcel$export(module.exports, "PORT_RADIUS", () => $f940d9ba3f88f31d$export$7a3df93415c22959);
$parcel$export(module.exports, "GLOBAL_TRANSITION_PORT_OFFSET", () => $f940d9ba3f88f31d$export$3b4ba534bacfcbd1);
$parcel$export(module.exports, "ARROW_PORT_OFFSET", () => $f940d9ba3f88f31d$export$87d6ef7590617cc6);
$parcel$export(module.exports, "ARROW_WING_LENGTH", () => $f940d9ba3f88f31d$export$694048c54f729ecb);
$parcel$export(module.exports, "GLOBAL_TRANSITION_PORT", () => $f940d9ba3f88f31d$export$da538e9c3b4bc32f);
$parcel$export(module.exports, "STATE_COLOURS", () => $f940d9ba3f88f31d$export$add05b3c7c2c5f8f);
$parcel$export(module.exports, "MAX_LABEL_LENGTH", () => $f940d9ba3f88f31d$export$8bedd3d485c3d02f);
$parcel$export(module.exports, "ELLIPSIS", () => $f940d9ba3f88f31d$export$dc26c440c68f2c2a);

var $jCNJE = parcelRequire("jCNJE");
const $f940d9ba3f88f31d$export$eadcd7bcf388da50 = 0.5;
const $f940d9ba3f88f31d$export$212e080fc48fe6c9 = 2;
const $f940d9ba3f88f31d$export$314df2ab1d1b768f = 1;
const $f940d9ba3f88f31d$export$242961008b66e9eb = 0.1;
const $f940d9ba3f88f31d$export$bce6d504eee086c2 = (0, $jCNJE.toPoint)(600, 80);
const $f940d9ba3f88f31d$export$2dcb44527ea5ccd4 = 32;
const $f940d9ba3f88f31d$export$fd690d8ea6636270 = 120;
const $f940d9ba3f88f31d$export$2a3643000478f19c = 2;
const $f940d9ba3f88f31d$export$bc1449a84350d176 = 20;
const $f940d9ba3f88f31d$export$7a3df93415c22959 = 5;
const $f940d9ba3f88f31d$export$3b4ba534bacfcbd1 = 2;
const $f940d9ba3f88f31d$export$87d6ef7590617cc6 = $f940d9ba3f88f31d$export$7a3df93415c22959 / 2;
const $f940d9ba3f88f31d$export$694048c54f729ecb = 5;
const $f940d9ba3f88f31d$export$da538e9c3b4bc32f = 3;
const $f940d9ba3f88f31d$export$add05b3c7c2c5f8f = {
    focused: "var(--ds-border-focused, #388BFF)",
    selected: "var(--ds-border-selected, #0C66E4)",
    warning: "var(--ds-border-warning, #E56910)",
    error: "var(--ds-border-danger, #E2483D)"
};
const $f940d9ba3f88f31d$export$8bedd3d485c3d02f = 40;
const $f940d9ba3f88f31d$export$dc26c440c68f2c2a = '\u2026';

});
parcelRegister("jCNJE", function(module, exports) {

$parcel$export(module.exports, "TransitionIcons", () => $abf6827d3b424f9a$export$ce448d88de6ac43e);
$parcel$export(module.exports, "PortIndex", () => $abf6827d3b424f9a$export$4549e552522d6540);
$parcel$export(module.exports, "allStatusPorts", () => $abf6827d3b424f9a$export$c39dd9d2b04f8803);
$parcel$export(module.exports, "ValidationFlag", () => $abf6827d3b424f9a$export$4edd599884789108);
$parcel$export(module.exports, "toPortInfo", () => $abf6827d3b424f9a$export$b0c629e479719649);
$parcel$export(module.exports, "toPortKey", () => $abf6827d3b424f9a$export$e86e2262732e6179);
$parcel$export(module.exports, "toPoint", () => $abf6827d3b424f9a$export$b63cca88ddc558a9);
$parcel$export(module.exports, "LayerIndex", () => $abf6827d3b424f9a$export$e44e4947d8392b61);

var $200fA = parcelRequire("200fA");
var $abf6827d3b424f9a$export$ce448d88de6ac43e = /*#__PURE__*/ function(TransitionIcons) {
    TransitionIcons["Bolt"] = "bolt";
    TransitionIcons["Error"] = "error";
    TransitionIcons["Check"] = "check";
    TransitionIcons["CheckInactive"] = "check_inactive";
    TransitionIcons["Cross"] = "cross";
    TransitionIcons["CrossInactive"] = "cross_inactive";
    TransitionIcons["SharedTransition"] = "shared_transition";
    return TransitionIcons;
}({});
var $abf6827d3b424f9a$export$4549e552522d6540 = /*#__PURE__*/ function(PortIndex) {
    /**
	 * ```txt
	 *  ╭-⭐️-----------╮
	 *  |    Status    |
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["TopLeft"] = 0] = "TopLeft";
    /**
	 * ```txt
	 *  ╭------⭐️------╮
	 *  |    Status    |
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["Top"] = 1] = "Top";
    /**
	 * ```txt
	 *  ╭-----------⭐️-╮
	 *  |    Status    |
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["TopRight"] = 2] = "TopRight";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  |    Status    ⭐️
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["Right"] = 3] = "Right";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  |    Status    |
	 *  ╰-----------⭐️-╯
	 * ``` */ PortIndex[PortIndex["BottomRight"] = 4] = "BottomRight";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  |    Status    |
	 *  ╰------⭐️------╯
	 * ``` */ PortIndex[PortIndex["Bottom"] = 5] = "Bottom";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  |    Status    |
	 *  ╰--⭐️----------╯
	 * ``` */ PortIndex[PortIndex["BottomLeft"] = 6] = "BottomLeft";
    /**
	 * ```txt
	 *  ╭--------------╮
	 *  ⭐️   Status    |
	 *  ╰--------------╯
	 * ``` */ PortIndex[PortIndex["Left"] = 7] = "Left";
    return PortIndex;
}({});
const $abf6827d3b424f9a$export$c39dd9d2b04f8803 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7
];
var $abf6827d3b424f9a$export$4edd599884789108 = /*#__PURE__*/ function(ValidationFlag) {
    ValidationFlag["Warn"] = "warn";
    ValidationFlag["Error"] = "error";
    return ValidationFlag;
}({});
const $abf6827d3b424f9a$export$b0c629e479719649 = (statusId, portIndex, position, isVisible, isGlowing)=>{
    const key = statusId === (0, $200fA.START_NODE_ID) ? (0, $200fA.START_NODE_ID) : `${statusId}:${portIndex}`;
    return {
        key: key,
        position: position,
        statusId: statusId,
        portIndex: portIndex,
        isVisible: isVisible,
        isGlowing: isGlowing
    };
};
function $abf6827d3b424f9a$export$e86e2262732e6179(statusId, portIndex) {
    return `${statusId}:${portIndex}`;
}
const $abf6827d3b424f9a$export$b63cca88ddc558a9 = (x, y)=>({
        x: x,
        y: y
    });
var $abf6827d3b424f9a$export$e44e4947d8392b61 = /*#__PURE__*/ function(LayerIndex) {
    /** Layer for most elements in default state */ LayerIndex[LayerIndex["Default"] = 0] = "Default";
    /** Layer for labels when in default state */ LayerIndex[LayerIndex["TransitionsDefault"] = 1] = "TransitionsDefault";
    /** Layer for statuses that are selected, targeted etc */ LayerIndex[LayerIndex["PrioritisedStatuses"] = 2] = "PrioritisedStatuses";
    /** Layer for transitions that are selected, rerouting, highlighted etc */ LayerIndex[LayerIndex["PrioritisedTransitions"] = 3] = "PrioritisedTransitions";
    /** Layer for overlay */ LayerIndex[LayerIndex["Overlay"] = 4] = "Overlay";
    /** Layer for all hovered elements */ LayerIndex[LayerIndex["Hover"] = 5] = "Hover";
    /** Layer for elements that exist during the editing process */ LayerIndex[LayerIndex["Proposals"] = 6] = "Proposals";
    /** Layer for all Ports */ LayerIndex[LayerIndex["Ports"] = 7] = "Ports";
    /** Layer for Global Loops container that sits above all other elements */ LayerIndex[LayerIndex["GlobalLoopsContainer"] = 8] = "GlobalLoopsContainer";
    return LayerIndex;
}({});

});


parcelRegister("4yAsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b64fad48f430317$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2f1HK = parcelRequire("2f1HK");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dPMMf = parcelRequire("dPMMf");

var $7jTnu = parcelRequire("7jTnu");

var $200fA = parcelRequire("200fA");

var $gn7EO = parcelRequire("gn7EO");

var $jCNJE = parcelRequire("jCNJE");

var $dq7yG = parcelRequire("dq7yG");

var $7nmny = parcelRequire("7nmny");

var $7tPN1 = parcelRequire("7tPN1");

var $hwBSd = parcelRequire("hwBSd");

var $6ERGt = parcelRequire("6ERGt");

var $6yjnN = parcelRequire("6yjnN");

var $h2zA1 = parcelRequire("h2zA1");

var $bp6kW = parcelRequire("bp6kW");

var $hcMjR = parcelRequire("hcMjR");

var $fiArL = parcelRequire("fiArL");

var $iYsbF = parcelRequire("iYsbF");

var $gXlg7 = parcelRequire("gXlg7");

var $3lHO8 = parcelRequire("3lHO8");

var $crnvo = parcelRequire("crnvo");

var $3KLH9 = parcelRequire("3KLH9");

var $4Yp5F = parcelRequire("4Yp5F");

var $whaAa = parcelRequire("whaAa");

var $hiXsx = parcelRequire("hiXsx");

var $cm7e7 = parcelRequire("cm7e7");

var $v1MZY = parcelRequire("v1MZY");

var $4bXD4 = parcelRequire("4bXD4");

var $b6DVy = parcelRequire("b6DVy");

var $lRP7n = parcelRequire("lRP7n");

var $aoNyD = parcelRequire("aoNyD");

var $lbFMB = parcelRequire("lbFMB");

var $eIlh0 = parcelRequire("eIlh0");

var $2j7sg = parcelRequire("2j7sg");

var $4xWre = parcelRequire("4xWre");

var $6eint = parcelRequire("6eint");

var $aJBX7 = parcelRequire("aJBX7");

var $4ojSV = parcelRequire("4ojSV");

var $4cZ7b = parcelRequire("4cZ7b");

var $dB7Fq = parcelRequire("dB7Fq");
const $5b64fad48f430317$var$useStatusWidthsWithReadinessCheck = (statuses)=>{
    const [statusWidths, setStatusWidths, setStatusWidthEntry] = (0, $iYsbF.useRecordState)();
    return (0, $eJOHy.useMemo)(()=>{
        const isReady = statuses.length === Object.keys(statusWidths).length;
        return [
            statusWidths,
            setStatusWidths,
            setStatusWidthEntry,
            isReady
        ];
    }, [
        setStatusWidthEntry,
        setStatusWidths,
        statusWidths,
        statuses.length
    ]);
};
const $5b64fad48f430317$var$WorkflowDiagram = ({ isImmutable: isImmutable = false, pan: controlledPan, zoom: controlledZoom, startNodePosition: startNodePosition, globalLoopsContainerPosition: providedGlobalLoopsContainerPosition, onClearGlobalLoopsContainerPosition: onClearGlobalLoopsContainerPosition, transitions: transitions, statuses: statuses, selectedItem: selectedItem, targetedItem: targetedItem, movingItem: movingItem, onSelect: onSelect, onItemMove: onItemMove, onTransitionCreate: onTransitionCreate, onTransitionPortChange: onTransitionPortChange, onZoomChange: onZoomChange, onPanChange: onPanChange, onViewBoxChange: onViewBoxChange, onRenderComplete: onRenderComplete, collapseTransitionLabels: collapseTransitionLabels = false, shouldShowGlobalLoops: shouldShowGlobalLoops = false })=>{
    const rootSvgRef = (0, $eJOHy.useRef)(null);
    const [hoveredItem, setHoveredItem] = (0, $eJOHy.useState)();
    const [statusWidthsOld, , setStatusWidthEntryOld] = (0, $iYsbF.useRecordState)();
    const [statusWidthsNew, , setStatusWidthEntryNew, isStatusWidthsReady] = $5b64fad48f430317$var$useStatusWidthsWithReadinessCheck(statuses);
    const statusWidths = (0, $7jTnu.fg)('concurrent-rendering-workflows-replace-settimeout') ? statusWidthsNew : statusWidthsOld;
    const setStatusWidthEntry = (0, $7jTnu.fg)('concurrent-rendering-workflows-replace-settimeout') ? setStatusWidthEntryNew : setStatusWidthEntryOld;
    const [pan, updatePan] = (0, $6ERGt.useControllable)(controlledPan, onPanChange, (0, $gn7EO.DEFAULT_PAN));
    const [zoom, updateZoom] = (0, $6ERGt.useControllable)(controlledZoom ? (0, (/*@__PURE__*/$parcel$interopDefault($2f1HK)))(controlledZoom, (0, $gn7EO.MINIMUM_ZOOM_LEVEL), (0, $gn7EO.MAXIMUM_ZOOM_LEVEL)) : undefined, onZoomChange, (0, $gn7EO.DEFAULT_ZOOM_LEVEL));
    const { canvasContainerRef: canvasContainerRef, diagramSize: diagramSize, viewBox: viewBox } = (0, $hwBSd.useCanvasView)(zoom, pan, onViewBoxChange);
    const { dragDropState: dragDropState, temporaryPan: temporaryPan } = (0, $7tPN1.useCanvasDragDropEvents)({
        rootSvgRef: rootSvgRef,
        zoom: zoom,
        pan: pan,
        viewBox: viewBox,
        isImmutable: isImmutable,
        updatePan: updatePan,
        onSelect: onSelect
    });
    const [reroutingTransition, { onTransitionReroutingCancel: onTransitionReroutingCancel, onTransitionReroutingClose: onTransitionReroutingClose, onTransitionReroutingMove: onTransitionReroutingMove }] = (0, $hiXsx.useTransitionRerouting)();
    const [proposedTransition, { onTransitionProposalCancel: onTransitionProposalCancel, onTransitionProposalMove: onTransitionProposalMove, onTransitionProposalClose: onTransitionProposalClose }] = (0, $whaAa.useTransitionProposals)();
    const { isLayoutStable: isLayoutStable, defaultPositions: defaultPositions, defaultGlobalLoopsContainerPosition: defaultGlobalLoopsContainerPosition, transitionsWithDefaultPorts: transitionsWithDefaultPorts } = (0, $7nmny.useAutoLayout)({
        rootSvgRef: rootSvgRef,
        canvasContainerRef: canvasContainerRef,
        startNodePosition: startNodePosition,
        transitions: transitions,
        statuses: statuses,
        statusWidths: statusWidths,
        isStatusWidthsReady: isStatusWidthsReady,
        providedGlobalLoopsContainerPosition: providedGlobalLoopsContainerPosition,
        onClearGlobalLoopsContainerPosition: onClearGlobalLoopsContainerPosition,
        onItemMove: onItemMove,
        onTransitionPortChange: onTransitionPortChange,
        onPan: updatePan,
        onZoom: updateZoom
    });
    const latestOnRenderComplete = (0, $h2zA1.useLatest)(onRenderComplete);
    (0, $eJOHy.useEffect)(()=>{
        if (isLayoutStable) latestOnRenderComplete.current?.();
    }, [
        isLayoutStable,
        latestOnRenderComplete
    ]);
    const { snapLines: snapLines, snappedSubjectPosition: snappedSubjectPosition } = (0, $gXlg7.useSnapLines)({
        isImmutable: isImmutable,
        startNodePosition: startNodePosition,
        globalLoopsContainerPosition: providedGlobalLoopsContainerPosition,
        statuses: statuses,
        transitions: transitions,
        statusWidths: statusWidths,
        movingItem: movingItem,
        dragDropState: dragDropState
    });
    const { draggingItem: draggingItem } = (0, $6yjnN.useItemDragDrop)({
        isImmutable: isImmutable,
        dragDropState: dragDropState,
        snappedSubjectPosition: snappedSubjectPosition,
        onItemMove: onItemMove
    });
    const globalLoopsContainer = (0, $cm7e7.useGlobalLoopsContainer)({
        providedGlobalLoopsContainerPosition: providedGlobalLoopsContainerPosition,
        defaultGlobalLoopsContainerPosition: defaultGlobalLoopsContainerPosition,
        targetedItem: targetedItem,
        draggingItem: draggingItem,
        movingItem: movingItem
    });
    const startNode = (0, $3lHO8.useStartNode)({
        startNodePosition: startNodePosition,
        targetedItem: targetedItem,
        hoveredItem: hoveredItem,
        movingItem: movingItem,
        draggingItem: draggingItem,
        defaultPositions: defaultPositions
    });
    const statefulStatuses = (0, $crnvo.useStatefulStatuses)({
        statuses: statuses,
        selectedItem: selectedItem,
        targetedItem: targetedItem,
        hoveredItem: hoveredItem,
        draggingItem: draggingItem,
        movingItem: movingItem,
        defaultPositions: defaultPositions
    });
    const { ports: ports, visiblePorts: visiblePorts } = (0, $fiArL.usePorts)({
        hoveredItem: hoveredItem,
        selectedItem: selectedItem,
        startNodePosition: startNode.position,
        transitions: transitions,
        statuses: statefulStatuses,
        statusWidths: statusWidths,
        defaultPositions: defaultPositions,
        dragDropState: dragDropState,
        reroutingTransition: reroutingTransition,
        proposedTransition: proposedTransition,
        isImmutable: isImmutable
    });
    const statefulTransitions = (0, $3KLH9.useStatefulTransitions)({
        transitions: transitions,
        selectedItem: selectedItem,
        targetedItem: targetedItem,
        hoveredItem: hoveredItem,
        ports: ports,
        reroutingTransition: reroutingTransition,
        transitionsWithDefaultPorts: transitionsWithDefaultPorts
    });
    const onWheel = (0, $bp6kW.useOnWheel)({
        pan: pan,
        zoom: zoom,
        updateZoom: updateZoom,
        updatePan: updatePan
    });
    (0, $hcMjR.usePortDragAndDrop)({
        ports: ports,
        isImmutable: isImmutable,
        selectedItem: selectedItem,
        transitions: transitions,
        dragDropState: dragDropState,
        onTransitionReroutingMove: onTransitionReroutingMove,
        onTransitionProposalMove: onTransitionProposalMove
    });
    (0, $4Yp5F.useTransitionDragDrop)({
        ports: ports,
        dragDropState: dragDropState,
        proposedTransition: proposedTransition,
        reroutingTransition: reroutingTransition,
        transitions: transitions,
        onTransitionProposalCancel: onTransitionProposalCancel,
        onTransitionReroutingCancel: onTransitionReroutingCancel,
        onTransitionCreate: onTransitionCreate,
        onTransitionPortChange: onTransitionPortChange
    });
    (0, $eJOHy.useEffect)(()=>{
        const containerRef = canvasContainerRef?.current;
        if (containerRef) // @ts-expect-error - WheelEvent is the correct value
        containerRef.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>{
            if (containerRef) // @ts-expect-error - WheelEvent is the correct value
            containerRef.removeEventListener('wheel', onWheel);
        };
    }, [
        canvasContainerRef,
        onWheel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b64fad48f430317$var$DiagramContainer, {
        ref: canvasContainerRef,
        isContentHidden: !isLayoutStable,
        isTargeted: targetedItem?.type === (0, $v1MZY.DIAGRAM_CONTAINER_TYPE)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4bXD4.CanvasSvg), {
        rootSvgRef: rootSvgRef,
        pan: temporaryPan || pan,
        zoom: zoom,
        diagramSize: diagramSize
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerGroup), null, shouldShowGlobalLoops && globalLoopsContainer.position && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerItem), {
        layer: (0, $jCNJE.LayerIndex).GlobalLoopsContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lRP7n.default), {
        isImmutable: isImmutable,
        position: globalLoopsContainer.position,
        transitions: statefulTransitions.filter((x)=>x.type === 'global-looped'),
        onSelect: onSelect,
        onHover: setHoveredItem,
        isMoving: globalLoopsContainer.isMoving,
        isTargeted: globalLoopsContainer.isTargeted
    })), statefulTransitions.map((transition)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerItem), {
            key: `transitionPath_${transition.id}`,
            layer: (0, $4cZ7b.getTransitionLayer)(transition)
        }, transition.type === 'global' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aoNyD.default), {
            id: transition.id,
            flag: transition.flag,
            isHovered: transition.isHovered,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            portPosition: transition.targetPort?.position,
            onSelect: onSelect,
            onHover: setHoveredItem,
            icons: (0, $4cZ7b.applyTransitionIconConditions)(transition.icons, undefined)
        }), transition.type === 'direct' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b6DVy.default), {
            id: transition.id,
            path: transition.path,
            flag: transition.flag,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            isHovered: transition.isHovered,
            start: transition.sourcePort,
            end: transition.targetPort,
            onSelect: onSelect,
            onHover: setHoveredItem
        }), transition.type === 'shared' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xWre.default), {
            id: transition.id,
            flag: transition.flag,
            isHovered: transition.isHovered,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            connections: transition.connections,
            onSelect: onSelect,
            onHover: setHoveredItem
        }))), statefulTransitions.filter((transition)=>{
        if (transition.type === 'global') return false;
        if (transition.type === 'global-looped') return false;
        return true;
    }).map((transition)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerItem), {
            key: `transitionLabel_${transition.id}`,
            layer: (0, $4cZ7b.getTransitionLayer)(transition)
        }, transition.type === 'shared' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, transition.connections?.map((connection, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dq7yG.default), {
                id: transition.id,
                key: i,
                label: transition.label,
                icons: (0, $4cZ7b.applyTransitionIconConditions)(transition.icons, connection.sourcePort.statusId).concat((0, $jCNJE.TransitionIcons).SharedTransition),
                flag: transition.flag,
                position: connection.labelPosition,
                isImmutable: isImmutable,
                isHovered: transition.isHovered,
                isSelected: transition.isSelected,
                isTargeted: transition.isTargeted,
                isHighlighted: transition.isHighlighted,
                isOverlapping: transition.isOverlapping,
                isOverlapHovered: transition.isOverlapHovered,
                onSelect: onSelect,
                onHover: setHoveredItem,
                collapseTransitionLabels: collapseTransitionLabels,
                connection: (0, $7jTnu.fg)('hix-7062_shared_transition_show_label_highlighted') ? connection : undefined,
                hoveredItem: (0, $7jTnu.fg)('hix-7062_shared_transition_show_label_highlighted') ? hoveredItem : undefined
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dq7yG.default), {
            id: transition.id,
            label: transition.label,
            icons: (0, $4cZ7b.applyTransitionIconConditions)(transition.icons, (0, $4cZ7b.getTransitionSource)(transition)),
            flag: transition.flag,
            position: transition.labelPosition,
            isImmutable: isImmutable,
            isHovered: transition.isHovered,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            isHighlighted: transition.isHighlighted,
            isOverlapping: transition.isOverlapping,
            isOverlapHovered: transition.isOverlapHovered,
            onSelect: onSelect,
            onHover: setHoveredItem,
            collapseTransitionLabels: collapseTransitionLabels,
            connection: (0, $7jTnu.fg)('hix-7062_shared_transition_show_label_highlighted') ? {
                sourcePort: transition.sourcePort,
                targetPort: transition.targetPort
            } : undefined,
            hoveredItem: (0, $7jTnu.fg)('hix-7062_shared_transition_show_label_highlighted') ? hoveredItem : undefined
        }))), statefulStatuses.map((status)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerItem), {
            key: `status_${status.id}`,
            layer: (0, $4cZ7b.getStatusLayer)(status)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ojSV.default), {
            id: status.id,
            label: status.label,
            position: status.position,
            category: status.category,
            flag: status.flag,
            isImmutable: isImmutable,
            isSelected: status.isSelected,
            isTargeted: status.isTargeted,
            isMoving: status.isMoving,
            onHover: setHoveredItem,
            onStatusResize: setStatusWidthEntry,
            onSelect: onSelect
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerItem), {
        key: (0, $200fA.START_NODE_ID),
        layer: (0, $4cZ7b.getStartNodeLayer)(startNode)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aJBX7.default), {
        id: (0, $200fA.START_NODE_ID),
        position: startNode.position,
        isImmutable: isImmutable,
        isTargeted: startNode.isTargeted,
        isMoving: startNode.isMoving,
        onHover: setHoveredItem
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerItem), {
        layer: (0, $jCNJE.LayerIndex).Proposals
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6eint.default), {
        lines: snapLines
    })), visiblePorts.map((port)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerItem), {
            key: `port_${port.key}`,
            layer: (0, $jCNJE.LayerIndex).Ports
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eIlh0.default), {
            portKey: port.key,
            isImmutable: isImmutable,
            position: port.position,
            isGlowing: port.isGlowing,
            parentStatusId: port.statusId,
            portIndex: port.portIndex,
            onHover: setHoveredItem,
            isProposingTransition: proposedTransition.stage !== 'none',
            isRerouting: reroutingTransition.stage !== 'none',
            onTransitionReroutingClose: onTransitionReroutingClose,
            onTransitionProposalClose: onTransitionProposalClose
        }))), proposedTransition.stage !== 'none' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerItem), {
        layer: (0, $jCNJE.LayerIndex).Proposals
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2j7sg.default), {
        start: proposedTransition.line.start,
        end: proposedTransition.line.end
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eIlh0.default), {
        isImmutable: true,
        position: proposedTransition.line.end
    })), (movingItem || draggingItem) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbFMB.LayerItem), {
        layer: (0, $jCNJE.LayerIndex).PrioritisedTransitions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dB7Fq.default), {
        viewBox: viewBox
    })))));
};
var $5b64fad48f430317$export$2e2bcd8739ae039 = $5b64fad48f430317$var$WorkflowDiagram;
const $5b64fad48f430317$var$DiagramContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isContentHidden: isContentHidden, isTargeted: isTargeted, children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: ref,
        xcss: [
            $5b64fad48f430317$var$containerBaseStyles,
            isContentHidden && $5b64fad48f430317$var$containerHiddenStyles,
            isTargeted && $5b64fad48f430317$var$containerTargetedStyles
        ]
    }, children));
const $5b64fad48f430317$var$containerBaseStyles = (0, $1DXK0.xcss)({
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    minHeight: `${42 * (0, $dPMMf.gridSize)}px`,
    width: '100%',
    // disables browser handling of all touch events, giving us full control
    touchAction: 'none'
});
const $5b64fad48f430317$var$containerHiddenStyles = (0, $1DXK0.xcss)({
    opacity: '0'
});
const $5b64fad48f430317$var$containerTargetedStyles = (0, $1DXK0.xcss)({
    outline: '2px solid',
    outlineColor: 'color.border.focused'
});

});
parcelRegister("2f1HK", function(module, exports) {

var $hyPlD = parcelRequire("hyPlD");

var $fQnJZ = parcelRequire("fQnJZ");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $1a1e4df8c91caf77$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $fQnJZ(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $fQnJZ(lower);
        lower = lower === lower ? lower : 0;
    }
    return $hyPlD($fQnJZ(number), lower, upper);
}
module.exports = $1a1e4df8c91caf77$var$clamp;

});
parcelRegister("hyPlD", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $cc8d7144fabccd11$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $cc8d7144fabccd11$var$baseClamp;

});


parcelRegister("dq7yG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d343789ec4496f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $gn7EO = parcelRequire("gn7EO");

var $v1MZY = parcelRequire("v1MZY");

var $jCNJE = parcelRequire("jCNJE");

var $5Y3a5 = parcelRequire("5Y3a5");

var $4sIW7 = parcelRequire("4sIW7");

var $5ahMX = parcelRequire("5ahMX");

var $cbefB = parcelRequire("cbefB");

var $dcsRA = parcelRequire("dcsRA");
const $d4d343789ec4496f$var$TEXT_Y_OFFSET = 16;
const $d4d343789ec4496f$var$ICON_LABEL_GAP = 2;
const $d4d343789ec4496f$var$ICON_PADDING = 2;
const $d4d343789ec4496f$var$ICON_ONLY_LABEL_PADDING = 16;
const $d4d343789ec4496f$var$LABEL_PADDING = 20;
const $d4d343789ec4496f$var$TEXT_X_IF_NO_ICONS = 20;
const $d4d343789ec4496f$var$LABEL_HEIGHT = 24;
const $d4d343789ec4496f$var$TEXT_OFFSET = 6;
const $d4d343789ec4496f$var$ERROR_RING_DASH_ARRAY = '3,2';
const $d4d343789ec4496f$var$FOCUS_RING_WIDTH = 4;
const $d4d343789ec4496f$var$SVG_VISIBLE = {};
const $d4d343789ec4496f$var$SVG_HIDDEN_AND_HOVERABLE = {
    opacity: 0
};
const $d4d343789ec4496f$var$SVG_HIDDEN_NOT_HOVERABLE = {
    visibility: 'hidden'
};
const $d4d343789ec4496f$var$SVG_HIDDEN = {
    opacity: 0
};
const $d4d343789ec4496f$var$TransitionLabel = ({ id: id, label: label = '', flag: flag, icons: icons = [], isHovered: isHovered = false, isHighlighted: isHighlighted = false, isImmutable: isImmutable = false, isSelected: isSelected = false, isTargeted: isTargeted = false, position: position, isOverlapping: isOverlapping = false, isOverlapHovered: isOverlapHovered = false, maxLabelLength: maxLabelLength = (0, $gn7EO.MAX_LABEL_LENGTH), onSelect: onSelect, onHover: onHover, collapseTransitionLabels: collapseTransitionLabels = false, connection: connection, hoveredItem: hoveredItem })=>{
    const textRef = (0, $eJOHy.useRef)(null);
    const iconGroupRef = (0, $eJOHy.useRef)(null);
    const textWidth = (0, $5ahMX.useLayoutWidth)(textRef, [
        label,
        icons,
        position
    ]);
    const iconsWidth = (0, $5ahMX.useLayoutWidth)(iconGroupRef, [
        label,
        icons,
        position
    ]);
    const labelWidth = label === '' ? textWidth + iconsWidth + $d4d343789ec4496f$var$ICON_ONLY_LABEL_PADDING : textWidth + iconsWidth + $d4d343789ec4496f$var$LABEL_PADDING;
    const textTransformX = iconsWidth ? $d4d343789ec4496f$var$TEXT_X_IF_NO_ICONS : (labelWidth - textWidth) / 2;
    const textX = iconsWidth && iconsWidth - $d4d343789ec4496f$var$TEXT_OFFSET;
    const stroke = (0, $cbefB.useStrokeColor)({
        flag: flag,
        isHighlighted: isHighlighted,
        isHovered: isHovered,
        isSelected: isSelected
    });
    const onGroupClick = (0, $eJOHy.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $v1MZY.EDGE_TYPE),
            id: id
        });
    }, [
        isImmutable,
        onSelect,
        id
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('hix-7062_shared_transition_show_label_highlighted')) onHover?.({
            id: id,
            type: (0, $v1MZY.EDGE_TYPE),
            connection: connection
        });
        else onHover?.({
            id: id,
            type: (0, $v1MZY.EDGE_TYPE)
        });
    }, [
        id,
        onHover,
        connection
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    const visibilityProps = (0, $eJOHy.useMemo)(()=>{
        if ((0, $7jTnu.fg)('hix-7062_shared_transition_show_label_highlighted')) {
            if (!collapseTransitionLabels || isSelected || isTargeted) return $d4d343789ec4496f$var$SVG_VISIBLE;
            const isConnectionHovered = hoveredItem?.type === (0, $v1MZY.EDGE_TYPE) && (0, $5Y3a5.areConnectionsEqual)(connection, hoveredItem?.connection);
            return isConnectionHovered ? $d4d343789ec4496f$var$SVG_VISIBLE : $d4d343789ec4496f$var$SVG_HIDDEN;
        }
        const canCollapseLabel = collapseTransitionLabels && !isHovered && !isSelected && !isTargeted;
        if (!canCollapseLabel || isOverlapHovered) return $d4d343789ec4496f$var$SVG_VISIBLE;
        return isOverlapping ? $d4d343789ec4496f$var$SVG_HIDDEN_AND_HOVERABLE : $d4d343789ec4496f$var$SVG_HIDDEN_NOT_HOVERABLE;
    }, [
        isOverlapping,
        collapseTransitionLabels,
        isOverlapHovered,
        isHovered,
        isSelected,
        isTargeted,
        hoveredItem,
        connection
    ]);
    if (icons.length === 0 && label === '') return null;
    const truncatedLabel = (0, $5Y3a5.truncateLabel)(label, maxLabelLength);
    if (!position) return null;
    const labelX = position.x - labelWidth / 2;
    const labelY = position.y - $d4d343789ec4496f$var$LABEL_HEIGHT / 2;
    const hasLabelText = label !== '';
    const hasError = flag === (0, $jCNJE.ValidationFlag).Error;
    const hasWarning = flag === (0, $jCNJE.ValidationFlag).Warn;
    const hasValidationFlag = hasError || hasWarning;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        "data-testid": "accessible-workflow-diagram.common.ui.diagram-transition-label.transition-label",
        ...visibilityProps,
        onClick: onGroupClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ...!label && (0, $4sIW7.DATA_ATTRIBUTE_IGNORE_AUTOFIT)
    }, hasLabelText && isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: labelX,
        y: labelY,
        width: labelWidth,
        height: $d4d343789ec4496f$var$LABEL_HEIGHT,
        rx: $d4d343789ec4496f$var$LABEL_HEIGHT / 2,
        ry: $d4d343789ec4496f$var$LABEL_HEIGHT / 2,
        stroke: (0, $gn7EO.STATE_COLOURS).focused,
        strokeWidth: $d4d343789ec4496f$var$FOCUS_RING_WIDTH * 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: labelX,
        y: labelY,
        width: labelWidth,
        height: $d4d343789ec4496f$var$LABEL_HEIGHT,
        rx: $d4d343789ec4496f$var$LABEL_HEIGHT / 2,
        ry: $d4d343789ec4496f$var$LABEL_HEIGHT / 2,
        fill: "var(--ds-background-input, #FFFFFF)",
        stroke: stroke,
        strokeWidth: (0, $gn7EO.TRANSITION_STROKE_WIDTH),
        strokeDasharray: !isSelected && hasValidationFlag ? $d4d343789ec4496f$var$ERROR_RING_DASH_ARRAY : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        ref: iconGroupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dcsRA.IconSet), {
        icons: icons,
        anchor: (0, $jCNJE.toPoint)(labelX + $d4d343789ec4496f$var$ICON_LABEL_GAP + $d4d343789ec4496f$var$ICON_PADDING, labelY + $d4d343789ec4496f$var$ICON_PADDING)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("text", {
        ref: textRef,
        x: textX + labelX + textTransformX,
        y: labelY + $d4d343789ec4496f$var$TEXT_Y_OFFSET,
        textAnchor: "start",
        fontSize: "12px",
        fill: "var(--ds-text, #172B4D)"
    }, truncatedLabel));
};
var $d4d343789ec4496f$export$2e2bcd8739ae039 = $d4d343789ec4496f$var$TransitionLabel;

});
parcelRegister("5Y3a5", function(module, exports) {

$parcel$export(module.exports, "isStartNodeReference", () => $5f169d15fcfa7be6$export$1eb9ae9959295d59);
$parcel$export(module.exports, "statusMatchesReference", () => $5f169d15fcfa7be6$export$967ac6fef7f5c262);
$parcel$export(module.exports, "transitionMatchesReference", () => $5f169d15fcfa7be6$export$c064b7cf73e916fe);
$parcel$export(module.exports, "isHighlightedTransition", () => $5f169d15fcfa7be6$export$c3b1e67c2831ddf8);
$parcel$export(module.exports, "findPort", () => $5f169d15fcfa7be6$export$93f100df314912d6);
$parcel$export(module.exports, "isEveryPropertyDefined", () => $5f169d15fcfa7be6$export$1943a591a215fa66);
$parcel$export(module.exports, "isTransitionRerouting", () => $5f169d15fcfa7be6$export$ecbe6c678814dd28);
$parcel$export(module.exports, "isPortMovingForReroutingTransition", () => $5f169d15fcfa7be6$export$e14dc45af0365967);
$parcel$export(module.exports, "updateTransitionPortIfRerouting", () => $5f169d15fcfa7be6$export$c64f7962d1fe4f1e);
$parcel$export(module.exports, "calculateViewBox", () => $5f169d15fcfa7be6$export$7e29f973febe72ad);
$parcel$export(module.exports, "truncateLabel", () => $5f169d15fcfa7be6$export$e70af1df4a68fcd7);
$parcel$export(module.exports, "getBBox", () => $5f169d15fcfa7be6$export$9cafdf24ffa90680);
$parcel$export(module.exports, "getBoundingClientRect", () => $5f169d15fcfa7be6$export$84fe60b31769e95f);
$parcel$export(module.exports, "isDirectOrSharedTransitionWithDefinedPorts", () => $5f169d15fcfa7be6$export$287d3c398c47405c);
$parcel$export(module.exports, "isTransitionOverlapping", () => $5f169d15fcfa7be6$export$725a66fefe9cab0f);
$parcel$export(module.exports, "isAnyOverlappingTransitionHovered", () => $5f169d15fcfa7be6$export$5ece72e373d74d4e);
$parcel$export(module.exports, "isNilOrEmpty", () => $5f169d15fcfa7be6$export$5e81610d3310ece7);
$parcel$export(module.exports, "areConnectionsEqual", () => $5f169d15fcfa7be6$export$8cf33fc5c91c388b);

var $crnx3 = parcelRequire("crnx3");

var $8dH3d = parcelRequire("8dH3d");

var $jPROM = parcelRequire("jPROM");

var $200fA = parcelRequire("200fA");

var $gn7EO = parcelRequire("gn7EO");

var $v1MZY = parcelRequire("v1MZY");

var $jCNJE = parcelRequire("jCNJE");
const $5f169d15fcfa7be6$export$1eb9ae9959295d59 = (reference)=>{
    if (!reference || reference.type !== (0, $v1MZY.NODE_TYPE)) return false;
    return (0, $200fA.START_NODE_ID) === reference.id;
};
const $5f169d15fcfa7be6$export$967ac6fef7f5c262 = (status, reference)=>{
    if (!reference || reference.type !== (0, $v1MZY.NODE_TYPE)) return false;
    return status.id === reference.id;
};
const $5f169d15fcfa7be6$export$c064b7cf73e916fe = (transition, reference)=>{
    if (!reference || reference.type !== (0, $v1MZY.EDGE_TYPE)) return false;
    return transition.id === reference.id;
};
const $5f169d15fcfa7be6$var$isTransitionConnectedToStatus = (transition, statusId)=>{
    if (transition.type === 'global-looped') return false;
    if (transition.target === statusId) return true;
    if (transition.type === 'direct' && transition.source === statusId) return true;
    if (transition.type === 'shared' && transition.links.some((link)=>link.source === statusId)) return true;
    return false;
};
const $5f169d15fcfa7be6$export$c3b1e67c2831ddf8 = (transition, selectedItem, hoveredItem)=>{
    if (hoveredItem && hoveredItem.type === (0, $v1MZY.NODE_TYPE)) return $5f169d15fcfa7be6$var$isTransitionConnectedToStatus(transition, hoveredItem.id);
    if (selectedItem && selectedItem.type === (0, $v1MZY.NODE_TYPE)) return $5f169d15fcfa7be6$var$isTransitionConnectedToStatus(transition, selectedItem.id);
    return false;
};
const $5f169d15fcfa7be6$export$93f100df314912d6 = (ports, source, sourceIndex)=>{
    if (sourceIndex === undefined) return undefined;
    if (source === (0, $200fA.START_NODE_ID)) return ports[0, $200fA.START_NODE_ID];
    return ports[(0, $jCNJE.toPortKey)(source, sourceIndex)];
};
const $5f169d15fcfa7be6$export$62fd8532fd9c9b36 = (ports, statusPortPairs)=>{
    if (!$5f169d15fcfa7be6$export$1943a591a215fa66(statusPortPairs, 'portIndex')) return undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($crnx3)))(statusPortPairs.map(({ statusId: statusId, portIndex: portIndex })=>ports[(0, $jCNJE.toPortKey)(statusId, portIndex)]));
};
const $5f169d15fcfa7be6$export$ecbe6c678814dd28 = (transition, reroutingTransition)=>reroutingTransition.stage !== 'none' && reroutingTransition?.transition.id === transition.id;
const $5f169d15fcfa7be6$export$e14dc45af0365967 = (port, side, transitionId, reroutingTransition)=>port !== undefined && reroutingTransition.stage !== 'none' && reroutingTransition?.transition.id === transitionId && reroutingTransition.side === side && port.key === reroutingTransition.originalPortKey;
const $5f169d15fcfa7be6$export$c64f7962d1fe4f1e = (port, side, transition, reroutingTransition)=>{
    if (!port || reroutingTransition.stage === 'none' || reroutingTransition?.transition.id !== transition.id || reroutingTransition.side !== side || port.key !== reroutingTransition.originalPortKey) return port;
    return {
        ...port,
        position: reroutingTransition.currentPosition
    };
};
const $5f169d15fcfa7be6$export$7e29f973febe72ad = (diagramSize, pan, zoom)=>{
    const viewBoxWidth = diagramSize.width / zoom;
    const viewBoxHeight = diagramSize.height / zoom;
    return {
        width: viewBoxWidth,
        height: viewBoxHeight,
        top: pan.y - viewBoxHeight / 2,
        left: pan.x - viewBoxWidth / 2
    };
};
const $5f169d15fcfa7be6$export$e70af1df4a68fcd7 = (text, maxLength = (0, $gn7EO.MAX_LABEL_LENGTH))=>text.length <= maxLength ? text : text.substring(0, maxLength - (0, $gn7EO.ELLIPSIS).length) + (0, $gn7EO.ELLIPSIS);
function $5f169d15fcfa7be6$export$9cafdf24ffa90680(element) {
    return 'getBBox' in element && typeof element.getBBox === 'function' && element.getBBox();
}
function $5f169d15fcfa7be6$export$84fe60b31769e95f(element) {
    return element.getBoundingClientRect();
}
function $5f169d15fcfa7be6$export$287d3c398c47405c(transition) {
    if (transition.type === 'global') return false;
    if (transition.type === 'global-looped') return false;
    if (transition.type === 'direct') return transition.sourceIndex !== undefined && transition.targetIndex !== undefined;
    // else shared
    return transition.links.every((link)=>link.sourceIndex !== undefined && link.targetIndex !== undefined);
}
function $5f169d15fcfa7be6$export$1943a591a215fa66(collection, ...properties) {
    return collection.every((item)=>properties.every((property)=>item[property] !== undefined));
}
const $5f169d15fcfa7be6$export$725a66fefe9cab0f = (transitionId, transitionLabelPlacements)=>transitionLabelPlacements.some((x)=>x.transitionId === transitionId);
const $5f169d15fcfa7be6$export$5ece72e373d74d4e = (transitionId, hoveredTransitionId, transitionLabelPlacements)=>{
    if (!hoveredTransitionId) return false;
    // find overlap info if transition overlaps another
    const overlapInfo = transitionLabelPlacements.find((x)=>x.transitionId === transitionId);
    if (!overlapInfo) return false;
    // check if hovered item overlaps given transition
    return transitionLabelPlacements.some((x)=>x.transitionId === hoveredTransitionId && x.overlapKey === overlapInfo.overlapKey);
};
const $5f169d15fcfa7be6$export$5e81610d3310ece7 = (value)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) || (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(value);
};
const $5f169d15fcfa7be6$export$8cf33fc5c91c388b = (conn1, conn2)=>{
    if (!conn1 || !conn2) return false;
    // Check if connections match in either direction (A→B or B→A)
    const forwardMatch = conn1.sourcePort?.portIndex === conn2.sourcePort?.portIndex && conn1.sourcePort?.statusId === conn2.sourcePort?.statusId && conn1.targetPort?.portIndex === conn2.targetPort?.portIndex && conn1.targetPort?.statusId === conn2.targetPort?.statusId;
    const reverseMatch = conn1.sourcePort?.portIndex === conn2.targetPort?.portIndex && conn1.sourcePort?.statusId === conn2.targetPort?.statusId && conn1.targetPort?.portIndex === conn2.sourcePort?.portIndex && conn1.targetPort?.statusId === conn2.sourcePort?.statusId;
    return forwardMatch || reverseMatch;
};

});
parcelRegister("crnx3", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $90ea429f86967b42$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $90ea429f86967b42$var$compact;

});


parcelRegister("4sIW7", function(module, exports) {

$parcel$export(module.exports, "findDefaultPositions", () => $0d31f74ed24851d2$export$b9760a6c42a85e06);
$parcel$export(module.exports, "autoFitCanvas", () => $0d31f74ed24851d2$export$38064ff1e4b4c0dd);
$parcel$export(module.exports, "DATA_ATTRIBUTE_IGNORE_AUTOFIT", () => $0d31f74ed24851d2$export$25a8ca882c171176);
$parcel$export(module.exports, "deferredExecute", () => $0d31f74ed24851d2$export$4c1e07610eea88e9);
$parcel$export(module.exports, "definePortsOnSharedTransition", () => $0d31f74ed24851d2$export$b4e613cf530b1d0);
$parcel$export(module.exports, "definePortsOnDirectTransition", () => $0d31f74ed24851d2$export$783b19e064f6f596);

var $2f1HK = parcelRequire("2f1HK");

var $crnx3 = parcelRequire("crnx3");

var $200fA = parcelRequire("200fA");

var $gn7EO = parcelRequire("gn7EO");

var $jCNJE = parcelRequire("jCNJE");

var $lJ60K = parcelRequire("lJ60K");

var $5Y3a5 = parcelRequire("5Y3a5");

var $aHcca = parcelRequire("aHcca");
const $0d31f74ed24851d2$export$91ff915000ab24ac = 60;
const $0d31f74ed24851d2$export$d5f8d30d5f0f009a = 50;
const $0d31f74ed24851d2$export$eb14e0fdcc559489 = 80;
const $0d31f74ed24851d2$var$DEFAULT_LOOP_SOURCE_INDEX = (0, $jCNJE.PortIndex).Bottom;
const $0d31f74ed24851d2$var$DEFAULT_LOOP_TARGET_INDEX = (0, $jCNJE.PortIndex).Left;
const $0d31f74ed24851d2$export$9b6499ea936d492a = (statuses, sourceStatusId, targetStatusId, sourceOrTarget)=>{
    const sourceStatus = statuses.find(({ id: id })=>id === sourceStatusId);
    const targetStatus = statuses.find(({ id: id })=>id === targetStatusId);
    if (sourceStatus?.position === undefined || targetStatus?.position === undefined) return 0;
    const angle = sourceOrTarget === 'source' ? (0, $lJ60K.angleBetween)(sourceStatus.position, targetStatus.position) : (0, $lJ60K.angleBetween)(targetStatus.position, sourceStatus.position);
    if (angle >= 22.5 && angle < 67.5) return (0, $jCNJE.PortIndex).BottomRight;
    if (angle >= 67.5 && angle < 112.5) return (0, $jCNJE.PortIndex).Bottom;
    if (angle >= 112.5 && angle < 157.5) return (0, $jCNJE.PortIndex).BottomLeft;
    if (angle >= 157.5 && angle < 202.5) return (0, $jCNJE.PortIndex).Left;
    if (angle >= 202.5 && angle < 247.5) return (0, $jCNJE.PortIndex).TopLeft;
    if (angle >= 247.5 && angle < 292.5) return (0, $jCNJE.PortIndex).Top;
    if (angle >= 292.5 && angle < 337.5) return (0, $jCNJE.PortIndex).TopRight;
    // between 337.5º to 22.5º
    return (0, $jCNJE.PortIndex).Right;
};
const $0d31f74ed24851d2$export$666bbaa8fbaa0b18 = (positionable, statusWidths)=>positionable.type === 'start-node' ? (0, $gn7EO.START_NODE_RADIUS) * 2 : statusWidths[positionable.id] || 0;
const $0d31f74ed24851d2$export$b9760a6c42a85e06 = (statusWidths, startNodePosition, statuses, defaultPositions)=>{
    const positioned = [];
    if (!Object.keys(statusWidths).length) return positioned;
    const positionables = [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            type: 'start-node',
            id: (0, $200fA.START_NODE_ID),
            position: startNodePosition || defaultPositions[0, $200fA.START_NODE_ID]
        },
        ...statuses.sort((statusA, statusB)=>1 - Number(statusA.isInitial) - (1 - Number(statusB.isInitial))).map(({ id: id, position: position })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ({
                type: 'status',
                id: id,
                position: position || defaultPositions[id]
            }))
    ];
    const positionablesWithUndefinedPositions = positionables.filter(({ position: position })=>position === undefined);
    if (positionablesWithUndefinedPositions.length > 0) {
        let maxY;
        let minY;
        let maxX;
        positionables.forEach((positionable)=>{
            if (!positionable.position) return;
            const statusWidth = $0d31f74ed24851d2$export$666bbaa8fbaa0b18(positionable, statusWidths);
            if (maxX === undefined || positionable.position.x + statusWidth > maxX) maxX = positionable.position.x + statusWidth;
            if (maxY === undefined || positionable.position.y + (0, $gn7EO.STATUS_HEIGHT) > maxY) maxY = positionable.position.y + (0, $gn7EO.STATUS_HEIGHT);
            if (minY === undefined || positionable.position.y < minY) minY = positionable.position.y;
        });
        let x = (maxX || 0) + $0d31f74ed24851d2$export$91ff915000ab24ac;
        const centerY = ((maxY || 0) + (minY || 0)) / 2;
        positionablesWithUndefinedPositions.forEach((positionable)=>{
            const y = centerY - $0d31f74ed24851d2$export$c7ca8986ba140884(positionable);
            positioned.push({
                ...positionable,
                position: {
                    x: x,
                    y: y
                }
            });
            x = x + $0d31f74ed24851d2$export$666bbaa8fbaa0b18(positionable, statusWidths) + $0d31f74ed24851d2$export$e1f70992c451c246(positionable);
        });
    }
    return positioned;
};
const $0d31f74ed24851d2$export$e1f70992c451c246 = (positionable)=>positionable.type === 'start-node' ? $0d31f74ed24851d2$export$eb14e0fdcc559489 : $0d31f74ed24851d2$export$91ff915000ab24ac;
const $0d31f74ed24851d2$export$c7ca8986ba140884 = (positionable)=>positionable.type === 'start-node' ? $0d31f74ed24851d2$export$d5f8d30d5f0f009a + (0, $gn7EO.START_NODE_RADIUS) : (0, $gn7EO.STATUS_HEIGHT) / 2;
const $0d31f74ed24851d2$export$38064ff1e4b4c0dd = (rootSvgRef, canvasContainerRef, onPan, onZoom)=>{
    if (!rootSvgRef.current || !canvasContainerRef.current) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const children = Array.from(rootSvgRef.current.children);
    const childBounds = (0, (/*@__PURE__*/$parcel$interopDefault($crnx3)))(children.filter((child)=>// Filter out elements with ignore auto fit boolean attribute
        // Note that this checks existence of attribute not value as
        // per definition of boolean attributes https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes#boolean_attributes
        !child.hasAttribute($0d31f74ed24851d2$export$a2a7c5ecd86d2098)).map((0, $5Y3a5.getBBox)));
    const boundingBox = (0, $aHcca.getCanvasBoundingBox)(childBounds);
    if (!boundingBox) return;
    const boundingBoxCenter = (0, $aHcca.getBBoxCenter)(boundingBox);
    onPan((0, $jCNJE.toPoint)(boundingBoxCenter.x, boundingBoxCenter.y));
    const paddedBoundingBox = (0, $aHcca.expandBoundingBox)(boundingBox, 20);
    const canvasBoundingBox = canvasContainerRef.current.getBoundingClientRect();
    const zoomLevel = Math.min(canvasBoundingBox.height / paddedBoundingBox.height, canvasBoundingBox.width / paddedBoundingBox.width);
    onZoom((0, (/*@__PURE__*/$parcel$interopDefault($2f1HK)))(zoomLevel, (0, $gn7EO.MINIMUM_ZOOM_LEVEL), (0, $gn7EO.DEFAULT_ZOOM_LEVEL)));
};
const $0d31f74ed24851d2$export$a2a7c5ecd86d2098 = 'data-ignore-autofit';
const $0d31f74ed24851d2$export$25a8ca882c171176 = {
    [$0d31f74ed24851d2$export$a2a7c5ecd86d2098]: true
};
const $0d31f74ed24851d2$export$4c1e07610eea88e9 = (callback)=>setTimeout(callback, 0);
const $0d31f74ed24851d2$export$b4e613cf530b1d0 = (transition, statuses)=>({
        ...transition,
        links: transition.links.map((link)=>{
            if (link.source === transition.target) return {
                ...link,
                sourceIndex: $0d31f74ed24851d2$var$DEFAULT_LOOP_SOURCE_INDEX,
                targetIndex: $0d31f74ed24851d2$var$DEFAULT_LOOP_TARGET_INDEX
            };
            return {
                ...link,
                sourceIndex: link.sourceIndex ?? $0d31f74ed24851d2$export$9b6499ea936d492a(statuses, link.source, transition.target, 'source'),
                targetIndex: link.targetIndex ?? $0d31f74ed24851d2$export$9b6499ea936d492a(statuses, link.source, transition.target, 'target')
            };
        })
    });
const $0d31f74ed24851d2$export$783b19e064f6f596 = (transition, statuses)=>{
    if (transition.source === transition.target) return {
        ...transition,
        sourceIndex: $0d31f74ed24851d2$var$DEFAULT_LOOP_SOURCE_INDEX,
        targetIndex: $0d31f74ed24851d2$var$DEFAULT_LOOP_TARGET_INDEX
    };
    return {
        ...transition,
        sourceIndex: transition.sourceIndex ?? $0d31f74ed24851d2$export$9b6499ea936d492a(statuses, transition.source, transition.target, 'source'),
        targetIndex: transition.targetIndex ?? $0d31f74ed24851d2$export$9b6499ea936d492a(statuses, transition.source, transition.target, 'target')
    };
};

});
parcelRegister("lJ60K", function(module, exports) {

$parcel$export(module.exports, "add", () => $0071c433a71a40c4$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $0071c433a71a40c4$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $0071c433a71a40c4$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $0071c433a71a40c4$export$cd007d971a5a2143);
$parcel$export(module.exports, "midpoint", () => $0071c433a71a40c4$export$f2e8a19be46147af);
$parcel$export(module.exports, "invert", () => $0071c433a71a40c4$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "distance", () => $0071c433a71a40c4$export$9f17032d917177de);
$parcel$export(module.exports, "angleBetween", () => $0071c433a71a40c4$export$47cb7eb79666608a);
$parcel$export(module.exports, "unitDirectionAngle", () => $0071c433a71a40c4$export$e8d8309fbd338973);

var $jCNJE = parcelRequire("jCNJE");
const $0071c433a71a40c4$export$e16d8520af44a096 = (point, other)=>(0, $jCNJE.toPoint)(point.x + other.x, point.y + other.y);
const $0071c433a71a40c4$export$4e2d2ead65e5f7e3 = (point, other)=>(0, $jCNJE.toPoint)(point.x - other.x, point.y - other.y);
const $0071c433a71a40c4$export$2060d2db72cce88f = (point, scalar)=>(0, $jCNJE.toPoint)(point.x * scalar, point.y * scalar);
const $0071c433a71a40c4$export$cd007d971a5a2143 = (point, scalar)=>(0, $jCNJE.toPoint)(point.x / scalar, point.y / scalar);
const $0071c433a71a40c4$export$7319af7d4cf5a6ca = (start, end, percent)=>(0, $jCNJE.toPoint)((start.x + end.x) * percent, (start.y + end.y) * percent);
const $0071c433a71a40c4$export$f2e8a19be46147af = (start, end)=>$0071c433a71a40c4$export$7319af7d4cf5a6ca(start, end, 0.5);
const $0071c433a71a40c4$export$6897c284b6f9f4dc = (point)=>$0071c433a71a40c4$export$2060d2db72cce88f(point, -1);
const $0071c433a71a40c4$export$9f17032d917177de = (p, q)=>{
    const a = q.x - p.x;
    const b = q.y - p.y;
    return Math.sqrt(a * a + b * b);
};
const $0071c433a71a40c4$export$47cb7eb79666608a = (p, q)=>{
    const degrees = Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI;
    const angleClampedBetween0And360 = (degrees + 360) % 360;
    return angleClampedBetween0And360;
};
const $0071c433a71a40c4$export$e8d8309fbd338973 = (unitDirection)=>Math.atan2(unitDirection.x, unitDirection.y) * 180 / Math.PI;

});

parcelRegister("aHcca", function(module, exports) {

$parcel$export(module.exports, "getBBoxCenter", () => $de8898313583a2c6$export$eccd94b26d0a3f4e);
$parcel$export(module.exports, "getCanvasBoundingBox", () => $de8898313583a2c6$export$550eedf6c679837d);
$parcel$export(module.exports, "expandBoundingBox", () => $de8898313583a2c6$export$2db36c07d90aafd0);
$parcel$export(module.exports, "getInitialSize", () => $de8898313583a2c6$export$70d7abb12b759ef9);
const $de8898313583a2c6$export$eccd94b26d0a3f4e = (bBox)=>{
    const { x: x, y: y, width: width, height: height } = bBox;
    return {
        x: x + width / 2,
        y: y + height / 2
    };
};
const $de8898313583a2c6$export$f3eab0b38a6a1a03 = (canvasBoundingBox, bBox)=>{
    if (!canvasBoundingBox) return {
        x: bBox.x,
        y: bBox.y,
        width: bBox.width,
        height: bBox.height
    };
    const bottomRight = {
        x: Math.max(bBox.x + bBox.width, canvasBoundingBox.x + canvasBoundingBox.width),
        y: Math.max(bBox.y + bBox.height, canvasBoundingBox.y + canvasBoundingBox.height)
    };
    const topLeft = {
        x: Math.min(bBox.x, canvasBoundingBox.x),
        y: Math.min(bBox.y, canvasBoundingBox.y)
    };
    return {
        x: topLeft.x,
        y: topLeft.y,
        width: bottomRight.x - topLeft.x,
        height: bottomRight.y - topLeft.y
    };
};
const $de8898313583a2c6$export$550eedf6c679837d = (bBoxes)=>{
    if (bBoxes.length < 1) return undefined;
    return bBoxes.reduce((acc, item)=>$de8898313583a2c6$export$f3eab0b38a6a1a03(acc, item), undefined);
};
const $de8898313583a2c6$export$2db36c07d90aafd0 = ({ x: x, y: y, width: width, height: height }, padding)=>({
        x: x - padding,
        y: y - padding,
        width: width + 2 * padding,
        height: height + 2 * padding
    });
const $de8898313583a2c6$export$70d7abb12b759ef9 = ()=>({
        width: 0,
        height: 0
    });

});


parcelRegister("5ahMX", function(module, exports) {

$parcel$export(module.exports, "useLayoutWidth", () => $e834675b188d2c32$export$5e90136528d56d69);
$parcel$export(module.exports, "default", () => $e834675b188d2c32$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $5Y3a5 = parcelRequire("5Y3a5");
const $e834675b188d2c32$export$5e90136528d56d69 = (ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dependancies = [])=>{
    const [width, setWidth] = (0, $eJOHy.useState)(0);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!ref.current) {
            if ((0, $7jTnu.fg)('hix-7004_workflow_editor_naming_global_transitions')) setWidth(0);
            return;
        }
        const bBox = (0, $5Y3a5.getBBox)(ref.current);
        if (!bBox) {
            if ((0, $7jTnu.fg)('hix-7004_workflow_editor_naming_global_transitions')) setWidth(0);
            return;
        }
        setWidth(Math.max(0, bBox.width));
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref,
        ...dependancies
    ]);
    return width;
};
var $e834675b188d2c32$export$2e2bcd8739ae039 = $e834675b188d2c32$export$5e90136528d56d69;

});

parcelRegister("cbefB", function(module, exports) {

$parcel$export(module.exports, "useStrokeColor", () => $a951ccc5a6c3b1dc$export$d361b13df0887ca8);

var $eJOHy = parcelRequire("eJOHy");

var $gn7EO = parcelRequire("gn7EO");

var $jCNJE = parcelRequire("jCNJE");
const $a951ccc5a6c3b1dc$export$d361b13df0887ca8 = ({ flag: flag, isSelected: isSelected, isHighlighted: isHighlighted, isHovered: isHovered })=>{
    const stroke = (0, $eJOHy.useMemo)(()=>{
        if (flag === (0, $jCNJE.ValidationFlag).Error) return (0, $gn7EO.STATE_COLOURS).error;
        if (flag === (0, $jCNJE.ValidationFlag).Warn) return (0, $gn7EO.STATE_COLOURS).warning;
        if (isSelected) return (0, $gn7EO.STATE_COLOURS).selected;
        if (isHighlighted || isHovered) return "var(--ds-chart-gray-boldest-hovered, #2C3E5D)";
        return "var(--ds-chart-gray-bold, #8590A2)";
    }, [
        flag,
        isHighlighted,
        isHovered,
        isSelected
    ]);
    return stroke;
};

});

parcelRegister("dcsRA", function(module, exports) {

$parcel$export(module.exports, "IconSet", () => $31bac001ccbccb32$export$c0faf18b76ac5204);

var $eJOHy = parcelRequire("eJOHy");

var $jCNJE = parcelRequire("jCNJE");

var $lJ60K = parcelRequire("lJ60K");
const $31bac001ccbccb32$var$ICON_PADDING = 18;
const $31bac001ccbccb32$var$BoltIcon = ({ anchor: anchor, inverse: inverse = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.common.ui.diagram-transition-label.icon-set.bolt-icon",
        fill: inverse ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #44546F)",
        stroke: "none",
        d: "M10.339854,4L15.1874898,4C15.4636322,4,15.6874898,4.22385763,15.6874898,4.5C15.6874898,4.57818367,15.6691551,4.65527785,15.6339583,4.72509094L13.5848909,8.78942131C13.4605766,9.03599902,13.5596907,9.3366664,13.8062684,9.46098069C13.8760815,9.49617756,13.9531756,9.51451225,14.0313593,9.51451225L17.65813,9.51451225C17.9342724,9.51451225,18.15813,9.73836987,18.15813,10.0145122C18.15813,10.1589731,18.0956491,10.2963739,17.9867788,10.3913278L7.71485013,19.3502415C7.50674068,19.5317492,7.19089352,19.5101843,7.00938577,19.3020748C6.88345852,19.1576918,6.85110443,18.9540478,6.92608257,18.7777457L8.97708607,13.9550573C9.08515731,13.7009408,8.9667642,13.4073296,8.71264766,13.2992583C8.65076634,13.2729413,8.58421231,13.259377,8.51696736,13.259377L6.12950524,13.259377C5.85336286,13.259377,5.62950524,13.0355194,5.62950524,12.759377C5.62950524,12.6804396,5.64819503,12.6026237,5.68404531,12.5322967L9.8943941,4.27291972C9.97976952,4.10544006,10.1518689,4,10.339854,4Z",
        transform: `matrix(0.7982,0,0,0.8617,${anchor.x},${anchor.y})`
    });
const $31bac001ccbccb32$var$CheckIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.common.ui.diagram-transition-label.icon-set.check-icon",
        fill: "var(--ds-icon-success, #22A06B)",
        stroke: "none",
        d: "M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M22.5857864,12.5857864 L16,19.1715729 L13.4142136,16.5857864 C12.633165,15.8047379 11.366835,15.8047379 10.5857864,16.5857864 C9.8047379,17.366835 9.8047379,18.633165 10.5857864,19.4142136 L14.5857864,23.4142136 C15.366835,24.1952621 16.633165,24.1952621 17.4142136,23.4142136 L25.4142136,15.4142136 C26.1952621,14.633165 26.1952621,13.366835 25.4142136,12.5857864 C24.633165,11.8047379 23.366835,11.8047379 22.5857864,12.5857864 Z",
        transform: `matrix(0.4,0,0,0.4,${anchor.x + 1.5},${anchor.y + 3})`
    });
const $31bac001ccbccb32$var$CheckInactiveIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.common.ui.diagram-transition-label.icon-set.check-inactive-icon",
        fill: "var(--ds-text-subtlest, #626F86)",
        stroke: "none",
        d: "M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M22.5857864,12.5857864 L16,19.1715729 L13.4142136,16.5857864 C12.633165,15.8047379 11.366835,15.8047379 10.5857864,16.5857864 C9.8047379,17.366835 9.8047379,18.633165 10.5857864,19.4142136 L14.5857864,23.4142136 C15.366835,24.1952621 16.633165,24.1952621 17.4142136,23.4142136 L25.4142136,15.4142136 C26.1952621,14.633165 26.1952621,13.366835 25.4142136,12.5857864 C24.633165,11.8047379 23.366835,11.8047379 22.5857864,12.5857864 Z",
        transform: `matrix(0.4,0,0,0.4,${anchor.x + 1.5},${anchor.y + 3})`
    });
const $31bac001ccbccb32$var$CrossIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.common.ui.diagram-transition-label.icon-set.cross-icon",
        fill: "var(--ds-icon-danger, #C9372C)",
        stroke: "none",
        d: "M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M12.1745714,12.1742923 C11.3918678,12.9536824 11.3891818,14.2200095 12.1685719,15.0027131 L15.183,18.03 L12.2338602,20.9972333 C11.4551613,21.7806245 11.458965,23.0469487 12.2423561,23.8256477 C13.0257473,24.6043467 14.2920715,24.6005429 15.0707705,23.8171518 L18.005,20.864 L20.8848942,23.7560915 C21.6642843,24.538795 22.9306114,24.5414811 23.7133149,23.762091 C24.4960185,22.9827009 24.4987046,21.7163738 23.7193145,20.9336703 L20.825,18.027 L23.7899828,15.0454007 C24.5686818,14.2620096 24.564878,12.9956853 23.7814869,12.2169863 C22.9980957,11.4382874 21.7317715,11.4420911 20.9530725,12.2254822 L18.003,15.193 L15.0029922,12.1802919 C14.2236021,11.3975883 12.957275,11.3949022 12.1745714,12.1742923 Z",
        transform: `matrix(0.4,0,0,0.4,${anchor.x + 1.5},${anchor.y + 3})`
    });
const $31bac001ccbccb32$var$CrossInactiveIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.common.ui.diagram-transition-label.icon-set.cross-inactive-icon",
        fill: "var(--ds-text-subtlest, #626F86)",
        stroke: "none",
        d: "M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M12.1745714,12.1742923 C11.3918678,12.9536824 11.3891818,14.2200095 12.1685719,15.0027131 L15.183,18.03 L12.2338602,20.9972333 C11.4551613,21.7806245 11.458965,23.0469487 12.2423561,23.8256477 C13.0257473,24.6043467 14.2920715,24.6005429 15.0707705,23.8171518 L18.005,20.864 L20.8848942,23.7560915 C21.6642843,24.538795 22.9306114,24.5414811 23.7133149,23.762091 C24.4960185,22.9827009 24.4987046,21.7163738 23.7193145,20.9336703 L20.825,18.027 L23.7899828,15.0454007 C24.5686818,14.2620096 24.564878,12.9956853 23.7814869,12.2169863 C22.9980957,11.4382874 21.7317715,11.4420911 20.9530725,12.2254822 L18.003,15.193 L15.0029922,12.1802919 C14.2236021,11.3975883 12.957275,11.3949022 12.1745714,12.1742923 Z",
        transform: `matrix(0.4,0,0,0.4,${anchor.x + 1.5},${anchor.y + 3})`
    });
const $31bac001ccbccb32$var$ErrorIcon = ({ anchor: anchor, inverse: inverse = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.common.ui.diagram-transition-label.icon-set.error-icon",
        fill: inverse ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #44546F)",
        stroke: "none",
        d: "M7.28711356,1.29771564 L7.4143185,1.41458101 L10.5856815,4.58607097 C11.3279955,5.32841471 11.3648683,6.50189375 10.7025422,7.28746336 L10.5856815,7.41465944 L7.4143185,10.5857867 C6.67200448,11.3280455 5.49850741,11.3649156 4.71288644,10.7026387 L4.5856815,10.5857867 L1.4143185,7.41465944 C0.67200448,6.67240061 0.63513165,5.49892578 1.29745781,4.71328041 L1.4143185,4.58607097 L4.5856815,1.41458101 C5.32799552,0.67223727 6.50149259,0.63536297 7.28711356,1.29771564 Z M6,8 L5.90152767,8.0072327 C5.58016529,8.054876 5.33333333,8.3321212 5.33333333,8.6666667 L5.33333333,8.6666667 L5.34056599,8.765139 C5.38820937,9.0865014 5.66545455,9.3333333 6,9.3333333 L6,9.3333333 L6.09847233,9.3261007 C6.41983471,9.2784573 6.66666667,9.0012121 6.66666667,8.6666667 L6.66666667,8.6666667 L6.65943401,8.5681943 C6.61179063,8.246832 6.33454545,8 6,8 L6,8 Z M6,2.66666667 L5.90152767,2.67389932 C5.61230153,2.71677836 5.38344503,2.94563486 5.34056599,3.23486101 L5.33333333,3.33333333 L5.33333333,6.66666667 C5.33333333,7.00121212 5.58016529,7.2784573 5.90152767,7.32610068 L6,7.33333333 L6.09847233,7.32610068 C6.38769847,7.28322164 6.61655497,7.05436514 6.65943401,6.76513899 L6.66666667,6.66666667 L6.66666667,3.33333333 C6.66666667,2.96533333 6.368,2.66666667 6,2.66666667 Z",
        transform: `matrix(1.3,0,0,1.3,${anchor.x + 1.5},${anchor.y + 2})`
    });
const $31bac001ccbccb32$var$SharedTransitionIcon = ({ anchor: anchor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.common.ui.diagram-transition-label.icon-set.shared-transition-icon",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.48039 0.214666L3.52772 2.18467C3.40318 2.3106 3.33333 2.48056 3.33333 2.65767C3.33333 2.83478 3.40318 3.00474 3.52772 3.13067C3.58888 3.19277 3.66179 3.24209 3.74219 3.27575C3.82259 3.30941 3.90889 3.32675 3.99605 3.32675C4.08322 3.32675 4.16951 3.30941 4.24992 3.27575C4.33032 3.24209 4.40322 3.19277 4.46439 3.13067L5.33333 2.25454V4.66667H2C1.63181 4.66667 1.33333 4.96514 1.33333 5.33333V8.1138C0.556539 8.38836 0 9.12919 0 10C0 11.1046 0.895431 12 2 12C3.10457 12 4 11.1046 4 10C4 9.12919 3.44346 8.38836 2.66667 8.1138V6H5.33333L6 6L6.66667 6L9.33333 6V8.1138C8.55654 8.38836 8 9.12919 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 9.12919 11.4435 8.38836 10.6667 8.1138V5.33333C10.6667 4.96514 10.3682 4.66667 10 4.66667H6.66667V2.26209L7.53439 3.13733C7.59571 3.1994 7.66874 3.24867 7.74925 3.2823C7.82976 3.31593 7.91614 3.33325 8.00339 3.33325C8.09064 3.33325 8.17702 3.31593 8.25752 3.2823C8.33803 3.24867 8.41106 3.1994 8.47239 3.13733C8.59676 3.01132 8.6665 2.84139 8.6665 2.66433C8.6665 2.48728 8.59676 2.31735 8.47239 2.19133L6.51239 0.214666C6.37456 0.077525 6.18815 0.000372232 5.99372 0C5.80772 0 5.62239 0.071333 5.48039 0.214666ZM1.33333 10C1.33333 9.63181 1.63181 9.33333 2 9.33333C2.36819 9.33333 2.66667 9.63181 2.66667 10C2.66667 10.3682 2.36819 10.6667 2 10.6667C1.63181 10.6667 1.33333 10.3682 1.33333 10ZM9.33333 10C9.33333 9.63181 9.63181 9.33333 10 9.33333C10.3682 9.33333 10.6667 9.63181 10.6667 10C10.6667 10.3682 10.3682 10.6667 10 10.6667C9.63181 10.6667 9.33333 10.3682 9.33333 10Z",
        fill: "var(--ds-icon, #44546F)",
        transform: `matrix(1.1,0,0,1.1,${anchor.x + 1.2},${anchor.y + 3})`
    });
const $31bac001ccbccb32$export$c0faf18b76ac5204 = ({ setRef: setRef, anchor: anchor, icons: icons, inverse: inverse = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        ref: setRef
    }, icons.map((iconType, index)=>{
        switch(iconType){
            case (0, $jCNJE.TransitionIcons).Bolt:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31bac001ccbccb32$var$BoltIcon, {
                    key: "bolt",
                    inverse: inverse,
                    anchor: (0, $lJ60K.add)(anchor, (0, $jCNJE.toPoint)(index * $31bac001ccbccb32$var$ICON_PADDING, 0))
                });
            case (0, $jCNJE.TransitionIcons).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31bac001ccbccb32$var$ErrorIcon, {
                    key: "error",
                    inverse: inverse,
                    anchor: (0, $lJ60K.add)(anchor, (0, $jCNJE.toPoint)(index * $31bac001ccbccb32$var$ICON_PADDING, 0))
                });
            case (0, $jCNJE.TransitionIcons).Check:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31bac001ccbccb32$var$CheckIcon, {
                    key: "check",
                    anchor: (0, $lJ60K.add)(anchor, (0, $jCNJE.toPoint)(index * $31bac001ccbccb32$var$ICON_PADDING, 0))
                });
            case (0, $jCNJE.TransitionIcons).CheckInactive:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31bac001ccbccb32$var$CheckInactiveIcon, {
                    key: "check-inactive",
                    anchor: (0, $lJ60K.add)(anchor, (0, $jCNJE.toPoint)(index * $31bac001ccbccb32$var$ICON_PADDING, 0))
                });
            case (0, $jCNJE.TransitionIcons).Cross:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31bac001ccbccb32$var$CrossIcon, {
                    key: "cross",
                    anchor: (0, $lJ60K.add)(anchor, (0, $jCNJE.toPoint)(index * $31bac001ccbccb32$var$ICON_PADDING, 0))
                });
            case (0, $jCNJE.TransitionIcons).CrossInactive:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31bac001ccbccb32$var$CrossInactiveIcon, {
                    key: "cross-inactive",
                    anchor: (0, $lJ60K.add)(anchor, (0, $jCNJE.toPoint)(index * $31bac001ccbccb32$var$ICON_PADDING, 0))
                });
            case (0, $jCNJE.TransitionIcons).SharedTransition:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($31bac001ccbccb32$var$SharedTransitionIcon, {
                    key: iconType,
                    anchor: (0, $lJ60K.add)(anchor, (0, $jCNJE.toPoint)(index * $31bac001ccbccb32$var$ICON_PADDING, 0))
                });
            default:
                return null;
        }
    }));

});


parcelRegister("7nmny", function(module, exports) {

$parcel$export(module.exports, "useAutoLayout", () => $94905b5dfbeb57ff$export$1f798865516ae65f);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $6d9QY = parcelRequire("6d9QY");

var $5Y3a5 = parcelRequire("5Y3a5");

var $h2zA1 = parcelRequire("h2zA1");

var $4cZ7b = parcelRequire("4cZ7b");

var $v1MZY = parcelRequire("v1MZY");

var $4sIW7 = parcelRequire("4sIW7");
const $94905b5dfbeb57ff$export$1f798865516ae65f = ({ transitions: transitions, startNodePosition: startNodePosition, statuses: statuses, statusWidths: statusWidths, isStatusWidthsReady: isStatusWidthsReady, rootSvgRef: rootSvgRef, canvasContainerRef: canvasContainerRef, providedGlobalLoopsContainerPosition: providedGlobalLoopsContainerPosition, onClearGlobalLoopsContainerPosition: onClearGlobalLoopsContainerPosition, onTransitionPortChange: onTransitionPortChange, onItemMove: onItemMove, onPan: onPan, onZoom: onZoom })=>{
    const latestStatuses = (0, $h2zA1.useLatest)(statuses);
    const latestStatusWidths = (0, $h2zA1.useLatest)(statusWidths);
    const hasInitialised = (0, $eJOHy.useRef)('pending');
    const [isLayoutStable, setIsLayoutStable] = (0, $eJOHy.useState)(false);
    const doesDiagramContainGlobalLoops = transitions.some((x)=>x.type === 'global-looped');
    const previousDoesDiagramContainGlobalLoops = (0, $6d9QY.usePrevious)(doesDiagramContainGlobalLoops);
    const [defaultPositions, setDefaultPositions] = (0, $eJOHy.useState)({});
    const [defaultGlobalLoopsContainerPosition, setDefaultGlobalLoopsContainerPosition] = (0, $eJOHy.useState)();
    const [shouldAutoFit, setShouldAutoFit] = (0, $eJOHy.useState)(false);
    const [transitionsWithDefaultPorts, setTransitionsWithDefaultPorts] = (0, $eJOHy.useState)({});
    const latestDefaultPositions = (0, $h2zA1.useLatest)(defaultPositions);
    const latestDefaultGlobalLoopsContainerPosition = (0, $h2zA1.useLatest)(defaultGlobalLoopsContainerPosition);
    const latestStartNodePosition = (0, $h2zA1.useLatest)(startNodePosition);
    const latestOnItemMove = (0, $h2zA1.useLatest)(onItemMove);
    const autoFit = (0, $eJOHy.useCallback)(()=>{
        (0, $4sIW7.autoFitCanvas)(rootSvgRef, canvasContainerRef, onPan, onZoom);
        (0, $4sIW7.deferredExecute)(()=>{
            setIsLayoutStable(true);
        });
    }, [
        canvasContainerRef,
        onPan,
        onZoom,
        rootSvgRef
    ]);
    const autoPositionStatuses = (0, $eJOHy.useCallback)(()=>{
        const positioned = (0, $4sIW7.findDefaultPositions)(latestStatusWidths.current, latestStartNodePosition.current, statuses, latestDefaultPositions.current);
        if (positioned.length) {
            const newPositions = positioned.reduce((acc, positionable)=>{
                acc[positionable.id] = positionable.position;
                return acc;
            }, {});
            setDefaultPositions((prev)=>({
                    ...prev,
                    ...newPositions
                }));
            positioned.forEach((positionable)=>{
                latestOnItemMove.current?.(positionable);
            });
        }
        return positioned;
    }, [
        latestDefaultPositions,
        latestOnItemMove,
        latestStatusWidths,
        latestStartNodePosition,
        statuses
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Effect to handle auto positioning of global loops container when global loop container is added or removed from diagram
        if (doesDiagramContainGlobalLoops) {
            if (!(0, $5Y3a5.isNilOrEmpty)(latestDefaultGlobalLoopsContainerPosition.current)) // Exit early if global loops container already has a default position set
            return;
            const defaultPosition = !(0, $5Y3a5.isNilOrEmpty)(providedGlobalLoopsContainerPosition) ? providedGlobalLoopsContainerPosition : (0, $4cZ7b.calculateDefaultGlobalLoopsContainerPosition)(startNodePosition, statuses, defaultPositions);
            setDefaultGlobalLoopsContainerPosition(defaultPosition);
            // Call container move callback to save the calculated default back to the component that mounts the accessible diagram
            defaultPosition && latestOnItemMove.current?.({
                id: (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE),
                type: (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE),
                position: defaultPosition
            });
        } else if (previousDoesDiagramContainGlobalLoops) {
            // When global loops are removed from the diagram, clear out the global loops position so a new auto position can be calculated when it is added back
            setDefaultGlobalLoopsContainerPosition(undefined);
            onClearGlobalLoopsContainerPosition();
        }
    }, [
        doesDiagramContainGlobalLoops,
        previousDoesDiagramContainGlobalLoops,
        latestDefaultGlobalLoopsContainerPosition,
        providedGlobalLoopsContainerPosition,
        startNodePosition,
        statuses,
        defaultPositions,
        latestOnItemMove,
        onClearGlobalLoopsContainerPosition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // On initialisation - auto position statuses after timeout so that status widths are available and always autofit
        if (hasInitialised.current === 'pending') {
            hasInitialised.current = 'started';
            if (!(0, $7jTnu.fg)('concurrent-rendering-workflows-replace-settimeout')) (0, $4sIW7.deferredExecute)(()=>{
                autoPositionStatuses();
                setShouldAutoFit(true);
                hasInitialised.current = 'finished';
            });
        }
        if (hasInitialised.current === 'started' && isStatusWidthsReady && (0, $7jTnu.fg)('concurrent-rendering-workflows-replace-settimeout')) {
            autoPositionStatuses();
            setShouldAutoFit(true);
            hasInitialised.current = 'finished';
        }
        // Subsequent additional statuses - auto position statuses and auto fit if status has been positioned
        if (hasInitialised.current === 'finished') {
            const positioned = autoPositionStatuses();
            if (positioned.length) setShouldAutoFit(true);
        }
    }, [
        autoPositionStatuses,
        latestDefaultPositions,
        latestOnItemMove,
        latestStatusWidths,
        startNodePosition,
        statuses,
        isStatusWidthsReady
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // autofit after next render so that auto positioned statuses are in place
        if (shouldAutoFit) {
            autoFit();
            setShouldAutoFit(false);
        }
    }, [
        autoFit,
        shouldAutoFit
    ]);
    /** Update transitions with undefined ports */ (0, $eJOHy.useEffect)(()=>{
        const updatedTransitions = {};
        const updateTransition = (transition)=>{
            updatedTransitions[transition.id] = transition;
            onTransitionPortChange?.(transition);
        };
        transitions.forEach((transition)=>{
            if (transition.type === 'global-looped' || transition.type === 'global' || (0, $5Y3a5.isDirectOrSharedTransitionWithDefinedPorts)(transition)) return;
            if (transition.type === 'shared') {
                const positioned = (0, $4sIW7.definePortsOnSharedTransition)(transition, latestStatuses.current);
                updateTransition(positioned);
                return;
            }
            const positioned = (0, $4sIW7.definePortsOnDirectTransition)(transition, latestStatuses.current);
            updateTransition(positioned);
        });
        setTransitionsWithDefaultPorts(updatedTransitions);
    }, [
        transitions,
        latestStatuses,
        onTransitionPortChange
    ]);
    return {
        isLayoutStable: isLayoutStable,
        defaultPositions: defaultPositions,
        defaultGlobalLoopsContainerPosition: defaultGlobalLoopsContainerPosition,
        transitionsWithDefaultPorts: transitionsWithDefaultPorts
    };
};

});
parcelRegister("6d9QY", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $6561b991da312eac$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousPersistent", () => $6561b991da312eac$export$9c42f2690cfe6963);
$parcel$export(module.exports, "usePreviousWithInitial", () => $6561b991da312eac$export$23fbbb2e62c4a911);

var $eJOHy = parcelRequire("eJOHy");
const $6561b991da312eac$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $6561b991da312eac$export$9c42f2690cfe6963 = (value)=>{
    // initialise the ref with previous and current values
    const ref = (0, $eJOHy.useRef)({
        value: value,
        prev: undefined
    });
    const current = ref.current.value;
    // if the value passed into hook doesn't match what we store as "current"
    // move the "current" to the "previous"
    // and store the passed value as "current"
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    // return the previous value only
    return ref.current.prev;
};
const $6561b991da312eac$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $eJOHy.useRef)(value);
    (0, $eJOHy.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("4cZ7b", function(module, exports) {

$parcel$export(module.exports, "getTransitionLayer", () => $c538a59997e63faa$export$933f49990d445c70);
$parcel$export(module.exports, "getStatusLayer", () => $c538a59997e63faa$export$4bd193df4d34f0d7);
$parcel$export(module.exports, "getStartNodeLayer", () => $c538a59997e63faa$export$ee6042e13e13003b);
$parcel$export(module.exports, "applyTransitionIconConditions", () => $c538a59997e63faa$export$18f06647e1a06eb1);
$parcel$export(module.exports, "getTransitionSource", () => $c538a59997e63faa$export$7e1664cbb47ef0e1);
$parcel$export(module.exports, "calculateDefaultGlobalLoopsContainerPosition", () => $c538a59997e63faa$export$b8436f1af7483e1c);

var $200fA = parcelRequire("200fA");

var $gn7EO = parcelRequire("gn7EO");

var $jCNJE = parcelRequire("jCNJE");
function $c538a59997e63faa$export$933f49990d445c70(transition) {
    if (transition.isHovered) return (0, $jCNJE.LayerIndex).Hover;
    if (transition.isRerouting) return (0, $jCNJE.LayerIndex).Proposals;
    if (transition.isSelected || transition.isTargeted || transition.isHighlighted) return (0, $jCNJE.LayerIndex).PrioritisedTransitions;
    return (0, $jCNJE.LayerIndex).TransitionsDefault;
}
function $c538a59997e63faa$export$4bd193df4d34f0d7(status) {
    if (status.isHovered) return (0, $jCNJE.LayerIndex).Hover;
    if (status.isDragging || status.isMoving) return (0, $jCNJE.LayerIndex).Proposals;
    if (status.isSelected || status.isTargeted) return (0, $jCNJE.LayerIndex).PrioritisedStatuses;
    return (0, $jCNJE.LayerIndex).Default;
}
function $c538a59997e63faa$export$ee6042e13e13003b(startNode) {
    if (startNode.isHovered) return (0, $jCNJE.LayerIndex).Hover;
    if (startNode.isDragging || startNode.isMoving) return (0, $jCNJE.LayerIndex).Proposals;
    if (startNode.isTargeted) return (0, $jCNJE.LayerIndex).PrioritisedStatuses;
    return (0, $jCNJE.LayerIndex).Default;
}
const $c538a59997e63faa$export$18f06647e1a06eb1 = (icons, from)=>{
    switch(true){
        case typeof from === 'string':
            return icons.filter(({ fromStatuses: fromStatuses })=>!Array.isArray(fromStatuses) || fromStatuses.includes(from)).map(({ type: type })=>type);
        case Array.isArray(from):
            return icons.filter(({ fromStatuses: fromStatuses })=>!Array.isArray(fromStatuses) || fromStatuses.some((id)=>from.includes(id))).map(({ type: type })=>type);
        default:
            return icons.filter(({ fromStatuses: fromStatuses })=>!Array.isArray(fromStatuses)).map(({ type: type })=>type);
    }
};
const $c538a59997e63faa$export$7e1664cbb47ef0e1 = (transition)=>{
    if (transition.type === 'global-looped') return undefined;
    if (transition.type === 'global') return undefined;
    if (transition.type === 'shared') return transition.links.map((link)=>link.source);
    return transition.source;
};
const $c538a59997e63faa$var$GLOBAL_LOOPS_CONTAINER_OFFSET_X = -250;
const $c538a59997e63faa$var$GLOBAL_LOOPS_CONTAINER_OFFSET_Y = -50;
const $c538a59997e63faa$export$b8436f1af7483e1c = (startNodePosition, statuses, defaultPositions)=>{
    const positionables = [
        startNodePosition || defaultPositions[0, $200fA.START_NODE_ID],
        ...statuses.map(({ id: id, position: position })=>position || defaultPositions[id])
    ];
    const areAllPositionablesStable = !positionables.some((position)=>!position);
    if (!areAllPositionablesStable) return undefined;
    let minY;
    let maxY;
    let minX;
    positionables.forEach((position)=>{
        if (!position) return;
        if (maxY === undefined || position.y + (0, $gn7EO.STATUS_HEIGHT) > maxY) maxY = position.y + (0, $gn7EO.STATUS_HEIGHT);
        if (minY === undefined || position.y < minY) minY = position.y;
        if (minX === undefined || position.x < minX) minX = position.x;
    });
    const x = (minX || 0) + $c538a59997e63faa$var$GLOBAL_LOOPS_CONTAINER_OFFSET_X;
    const centerY = ((maxY || 0) + (minY || 0)) / 2 + $c538a59997e63faa$var$GLOBAL_LOOPS_CONTAINER_OFFSET_Y;
    return {
        x: x,
        y: centerY
    };
};

});


parcelRegister("7tPN1", function(module, exports) {

$parcel$export(module.exports, "useCanvasDragDropEvents", () => $378c4d17a5a2d1f1$export$a53c45ebda9df7e2);
$parcel$export(module.exports, "useDraggableDataAttributes", () => $378c4d17a5a2d1f1$export$5d8cee90f1863f3a);

var $eJOHy = parcelRequire("eJOHy");

var $jCNJE = parcelRequire("jCNJE");

var $lJ60K = parcelRequire("lJ60K");

var $5Y3a5 = parcelRequire("5Y3a5");

var $h2zA1 = parcelRequire("h2zA1");


var $5BB2b = parcelRequire("5BB2b");
const $378c4d17a5a2d1f1$export$a53c45ebda9df7e2 = ({ rootSvgRef: rootSvgRef, zoom: zoom, viewBox: viewBox, pan: pan, updatePan: updatePan, onSelect: onSelect, isImmutable: isImmutable })=>{
    const [dragSubject, setDragSubject] = (0, $eJOHy.useState)(undefined);
    const [dragDropState, setDragDropState] = (0, $eJOHy.useState)({
        isDragging: false
    });
    const [dragStartPosition, setDragStartPosition] = (0, $eJOHy.useState)();
    const [temporaryPan, setTemporaryPan] = (0, $eJOHy.useState)();
    const latestPan = (0, $h2zA1.useLatest)(pan);
    const latestZoom = (0, $h2zA1.useLatest)(zoom);
    const latestDragSubject = (0, $h2zA1.useLatest)(dragSubject);
    const latestDragDropState = (0, $h2zA1.useLatest)(dragDropState);
    const latestViewBox = (0, $h2zA1.useLatest)(viewBox);
    const latestDragStartPosition = (0, $h2zA1.useLatest)(dragStartPosition);
    const latestTemporaryPan = (0, $h2zA1.useLatest)(temporaryPan);
    (0, $eJOHy.useEffect)(()=>{
        const handlePointerDown = (e)=>{
            const ancestor = (0, $5BB2b.findClosestDraggableAncestor)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            e.target, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            rootSvgRef.current);
            if (!ancestor) return;
            const dragType = ancestor.getAttribute((0, $d0c3395bc5a417bb$export$83f968f8e731fa74));
            const dragTargetId = ancestor.getAttribute((0, $d0c3395bc5a417bb$export$eb0a5100f29d97bb)) || undefined;
            if (dragType) {
                (0, $5BB2b.releasePointerCaptureIfHeld)(e);
                const ancestorBounds = (0, $5Y3a5.getBoundingClientRect)(ancestor);
                setDragSubject({
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                    type: dragType,
                    id: dragTargetId,
                    offset: (0, $lJ60K.divide)((0, $jCNJE.toPoint)(e.clientX - ancestorBounds.left, e.clientY - ancestorBounds.top), latestZoom.current)
                });
                setDragStartPosition((0, $jCNJE.toPoint)(e.clientX, e.clientY));
            }
        };
        const handlePointerMove = (e)=>{
            if (!latestDragSubject.current || !latestDragStartPosition.current) return;
            // Check if a drag has been started or it is a standard click
            const hasDragged = latestDragDropState.current.isDragging || e.clientX !== latestDragStartPosition.current.x || e.clientY !== latestDragStartPosition.current.y;
            if (!hasDragged) return;
            setDragDropState({
                isDragging: true,
                dragSubject: latestDragSubject.current,
                currentPosition: (0, $5BB2b.toDiagramPosition)(e.clientX, e.clientY, rootSvgRef.current, latestZoom.current, latestViewBox.current)
            });
            if (latestDragSubject.current.type === 'pan' && latestDragStartPosition.current) {
                const movement = (0, $jCNJE.toPoint)(e.clientX - latestDragStartPosition.current.x, e.clientY - latestDragStartPosition.current.y);
                const zoomedMovement = (0, $lJ60K.divide)(movement, latestZoom.current);
                const newPan = (0, $lJ60K.subtract)(latestPan.current, zoomedMovement);
                setTemporaryPan(newPan);
            }
        };
        const handlePointerUp = (e)=>{
            // unselect current selected item if canvas background is clicked
            if (e.target === rootSvgRef.current && !isImmutable && !latestDragDropState.current.isDragging) onSelect?.(undefined);
            if (latestDragSubject.current) {
                if (latestTemporaryPan.current) {
                    updatePan(latestTemporaryPan.current);
                    setTemporaryPan(undefined);
                }
                setDragSubject(undefined);
                setDragDropState({
                    isDragging: false
                });
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('pointerdown', handlePointerDown);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('pointermove', handlePointerMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('pointerup', handlePointerUp);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('pointerdown', handlePointerDown);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('pointermove', handlePointerMove);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('pointerup', handlePointerUp);
        };
    }, [
        isImmutable,
        latestDragSubject,
        latestViewBox,
        latestZoom,
        onSelect,
        rootSvgRef,
        latestDragDropState,
        latestPan,
        updatePan,
        latestDragStartPosition,
        latestTemporaryPan
    ]);
    return {
        dragDropState: dragDropState,
        temporaryPan: temporaryPan
    };
};
const $378c4d17a5a2d1f1$export$5d8cee90f1863f3a = (type, id)=>(0, $eJOHy.useMemo)(()=>({
            [(0, $d0c3395bc5a417bb$export$83f968f8e731fa74)]: type,
            [(0, $d0c3395bc5a417bb$export$eb0a5100f29d97bb)]: id
        }), [
        id,
        type
    ]);

});
/** Data attribute key for which the value is DragSubject's type */ const $d0c3395bc5a417bb$export$83f968f8e731fa74 = 'data-drag-type';
const $d0c3395bc5a417bb$export$eb0a5100f29d97bb = 'data-drag-id';

parcelRegister("5BB2b", function(module, exports) {

$parcel$export(module.exports, "toDiagramPosition", () => $48b6752f9e6e7c9e$export$d9473476f2fff27f);
$parcel$export(module.exports, "findClosestDraggableAncestor", () => $48b6752f9e6e7c9e$export$784ae781ab5d3c6);
$parcel$export(module.exports, "releasePointerCaptureIfHeld", () => $48b6752f9e6e7c9e$export$3072b9c3ca4d3798);

var $jCNJE = parcelRequire("jCNJE");

const $48b6752f9e6e7c9e$export$d9473476f2fff27f = (x, y, svgElement, zoom, viewBox)=>{
    const bound = svgElement?.getBoundingClientRect();
    const boundLeft = bound?.left || 0;
    const boundTop = bound?.top || 0;
    return (0, $jCNJE.toPoint)((x - boundLeft) / zoom + viewBox.left, (y - boundTop) / zoom + viewBox.top);
};
const $48b6752f9e6e7c9e$export$784ae781ab5d3c6 = (target, stopAtAncestor)=>{
    let current = target;
    if (!stopAtAncestor.contains(target)) return null;
    while(current){
        if (current == null || current === stopAtAncestor) return stopAtAncestor;
        if (current.getAttribute((0, $d0c3395bc5a417bb$export$83f968f8e731fa74))) return current;
        current = current.parentElement;
    }
    return stopAtAncestor;
};
function $48b6752f9e6e7c9e$export$3072b9c3ca4d3798(e) {
    if (e.target && e.target instanceof Element && e.target.hasPointerCapture(e.pointerId)) e.target.releasePointerCapture(e.pointerId);
}

});


parcelRegister("hwBSd", function(module, exports) {

$parcel$export(module.exports, "useCanvasView", () => $b25d0aeeeb2f5037$export$da041b3c789750d);

var $eJOHy = parcelRequire("eJOHy");

var $5Y3a5 = parcelRequire("5Y3a5");

var $h2zA1 = parcelRequire("h2zA1");

var $8pSNm = parcelRequire("8pSNm");

var $aHcca = parcelRequire("aHcca");
const $b25d0aeeeb2f5037$export$da041b3c789750d = (zoom, pan, onViewBoxChange)=>{
    const canvasContainerRef = (0, $eJOHy.useRef)(null);
    const [diagramSize, setDiagramSize] = (0, $eJOHy.useState)((0, $aHcca.getInitialSize)());
    const [viewBox, setViewBox] = (0, $eJOHy.useState)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const onViewBoxChangeLatest = (0, $h2zA1.useLatest)(onViewBoxChange);
    const updateViewBox = (0, $eJOHy.useCallback)((box)=>{
        setViewBox(box);
        onViewBoxChangeLatest.current?.(box);
    }, [
        onViewBoxChangeLatest
    ]);
    const observerCanvasSize = (0, $eJOHy.useCallback)((entry)=>{
        const { contentRect: { width: width, height: height } } = entry;
        setDiagramSize({
            width: width,
            height: height
        });
        updateViewBox((0, $5Y3a5.calculateViewBox)({
            width: width,
            height: height
        }, pan, zoom));
    }, [
        pan,
        updateViewBox,
        zoom
    ]);
    const { setRef: setCanvasContainerRef } = (0, $8pSNm.default)(observerCanvasSize);
    (0, $eJOHy.useEffect)(()=>{
        setCanvasContainerRef(canvasContainerRef.current);
    }, [
        setCanvasContainerRef
    ]);
    return {
        canvasContainerRef: canvasContainerRef,
        diagramSize: diagramSize,
        viewBox: viewBox
    };
};

});
parcelRegister("8pSNm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4119682ea9e81042$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $4119682ea9e81042$var$useResizeObserver = (cb)=>{
    const [ref, setRef] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!ref || !window.ResizeObserver) return undefined;
        const observer = new ResizeObserver((entries)=>{
            cb(entries[0]);
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        cb
    ]);
    return {
        setRef: setRef
    };
};
var $4119682ea9e81042$export$2e2bcd8739ae039 = $4119682ea9e81042$var$useResizeObserver;

});


parcelRegister("6yjnN", function(module, exports) {

$parcel$export(module.exports, "useItemDragDrop", () => $95996ac166fd5db1$export$4fd28756cf7c7448);

var $eJOHy = parcelRequire("eJOHy");

var $kEtMU = parcelRequire("kEtMU");
const $95996ac166fd5db1$export$4fd28756cf7c7448 = ({ isImmutable: isImmutable, dragDropState: dragDropState, snappedSubjectPosition: snappedSubjectPosition, onItemMove: onItemMove })=>{
    const previousDraggingItem = (0, $eJOHy.useRef)(undefined);
    const draggingItem = isImmutable ? undefined : (0, $kEtMU.getDraggingItem)(dragDropState, snappedSubjectPosition);
    (0, $eJOHy.useEffect)(()=>{
        if (!draggingItem && previousDraggingItem.current) // item has been dropped
        onItemMove?.(previousDraggingItem.current);
        previousDraggingItem.current = draggingItem;
    }, [
        draggingItem,
        onItemMove
    ]);
    return {
        draggingItem: draggingItem
    };
};

});
parcelRegister("kEtMU", function(module, exports) {

$parcel$export(module.exports, "getDraggingItem", () => $3ae953d5a016ae82$export$a5e4fe6aa18c1281);

var $lJ60K = parcelRequire("lJ60K");
const $3ae953d5a016ae82$export$a5e4fe6aa18c1281 = (dragDropState, positionOverride)=>{
    if (!dragDropState || !dragDropState.isDragging || dragDropState.dragSubject.type !== 'status' && dragDropState.dragSubject.type !== 'start-node' && dragDropState.dragSubject.type !== 'global-loops-container') return;
    return {
        type: dragDropState.dragSubject.type,
        id: dragDropState.dragSubject.id,
        position: positionOverride || (0, $lJ60K.subtract)(dragDropState.currentPosition, dragDropState.dragSubject.offset)
    };
};

});


parcelRegister("bp6kW", function(module, exports) {

$parcel$export(module.exports, "useOnWheel", () => $3224bc2028b599fc$export$b6b63f7ee81c9f36);

var $eJOHy = parcelRequire("eJOHy");

var $jCNJE = parcelRequire("jCNJE");

var $lJ60K = parcelRequire("lJ60K");

var $h2zA1 = parcelRequire("h2zA1");

var $e9zpI = parcelRequire("e9zpI");
const $3224bc2028b599fc$export$b6b63f7ee81c9f36 = ({ pan: pan, zoom: zoom, updateZoom: updateZoom, updatePan: updatePan })=>{
    const latestPan = (0, $h2zA1.useLatest)(pan);
    return (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        // Mac style zoom, two finger = pan, pinch to zoom
        const shouldZoom = e.ctrlKey;
        const shouldPan = !shouldZoom;
        if (shouldZoom) updateZoom((0, $e9zpI.getZoomFromDeltaY)(e.deltaY, zoom));
        else if (shouldPan) {
            if (!e.target) return;
            updatePan((0, $lJ60K.add)(latestPan.current, (0, $jCNJE.toPoint)(e.deltaX, e.deltaY)));
        }
    }, [
        latestPan,
        updatePan,
        updateZoom,
        zoom
    ]);
};
var $3224bc2028b599fc$export$2e2bcd8739ae039 = $3224bc2028b599fc$export$b6b63f7ee81c9f36;

});
parcelRegister("e9zpI", function(module, exports) {

$parcel$export(module.exports, "getZoomFromDeltaY", () => $48334bf5dfcf5009$export$b802864ad072f2fa);

var $2f1HK = parcelRequire("2f1HK");
const $48334bf5dfcf5009$var$EXPONENTIAL_ZOOM_BASE = 2;
const $48334bf5dfcf5009$var$LOGRAITHMIC_ZOOM_BASE = Math.log(2);
/* Convert exponential diagram zoom to a linear ak-range accessible value */ const $48334bf5dfcf5009$var$getLinearZoom = (exponentialZoom)=>Math.log(exponentialZoom) / $48334bf5dfcf5009$var$LOGRAITHMIC_ZOOM_BASE;
/** Convert linear ak-range value to exponential diagram zoom value */ const $48334bf5dfcf5009$var$getExponentialZoom = (linearZoom)=>$48334bf5dfcf5009$var$EXPONENTIAL_ZOOM_BASE ** linearZoom;
const $48334bf5dfcf5009$export$b802864ad072f2fa = (deltaY, currentZoom)=>{
    const delta = (0, (/*@__PURE__*/$parcel$interopDefault($2f1HK)))(deltaY, -0.1, 0.1);
    const newLinearZoom = (0, (/*@__PURE__*/$parcel$interopDefault($2f1HK)))($48334bf5dfcf5009$var$getLinearZoom(currentZoom) - delta, -1, 1);
    return $48334bf5dfcf5009$var$getExponentialZoom(newLinearZoom);
};

});


parcelRegister("hcMjR", function(module, exports) {

$parcel$export(module.exports, "usePortDragAndDrop", () => $58141be79d6c7d9b$export$49de3ac734cf9d9a);

var $eJOHy = parcelRequire("eJOHy");

var $h2zA1 = parcelRequire("h2zA1");

var $aHK8w = parcelRequire("aHK8w");
const $58141be79d6c7d9b$export$49de3ac734cf9d9a = ({ ports: ports, isImmutable: isImmutable, selectedItem: selectedItem, transitions: transitions, dragDropState: dragDropState, onTransitionReroutingMove: onTransitionReroutingMove, onTransitionProposalMove: onTransitionProposalMove })=>{
    const latestPortByStatusAndIndex = (0, $h2zA1.useLatest)(ports);
    const selectedTransitionInfo = (0, $aHK8w.useSelectedTransitionInfo)({
        transitions: transitions,
        selectedItem: selectedItem
    });
    const latestSelectedTransitionInfo = (0, $h2zA1.useLatest)(selectedTransitionInfo);
    (0, $eJOHy.useEffect)(()=>{
        if (isImmutable || !dragDropState.isDragging || dragDropState.dragSubject.type !== 'port') // no port being dragged, nothing to do
        return;
        const portBeingDragged = latestPortByStatusAndIndex.current[dragDropState.dragSubject.id];
        const latestSelectedTransition = latestSelectedTransitionInfo.current;
        const isSourcePortMoving = latestSelectedTransition?.sourcePortIndexKeys.some((portKey)=>portKey === portBeingDragged.key);
        const isTargetPortMoving = latestSelectedTransition?.targetPortIndexKeys.some((portKey)=>portKey === portBeingDragged.key);
        if (latestSelectedTransition && latestSelectedTransition.transition.type !== 'global' && !(latestSelectedTransition.transition.type === 'global-looped') && (isSourcePortMoving || isTargetPortMoving)) onTransitionReroutingMove({
            transition: latestSelectedTransition.transition,
            side: isSourcePortMoving ? 'source' : 'target',
            originalStatusId: portBeingDragged.statusId,
            originalPortKey: portBeingDragged.key,
            originalPortIndex: portBeingDragged.portIndex,
            currentPosition: dragDropState.currentPosition
        });
        else onTransitionProposalMove(dragDropState.dragSubject.id, {
            start: portBeingDragged.position,
            end: dragDropState.currentPosition
        });
    }, [
        dragDropState,
        isImmutable,
        latestPortByStatusAndIndex,
        latestSelectedTransitionInfo,
        onTransitionProposalMove,
        onTransitionReroutingMove
    ]);
};

});
parcelRegister("aHK8w", function(module, exports) {

$parcel$export(module.exports, "useSelectedTransitionInfo", () => $39179a10039c6c92$export$311b92958e309675);

var $eJOHy = parcelRequire("eJOHy");

var $crnx3 = parcelRequire("crnx3");

var $v1MZY = parcelRequire("v1MZY");

var $jCNJE = parcelRequire("jCNJE");

var $5Y3a5 = parcelRequire("5Y3a5");
const $39179a10039c6c92$export$311b92958e309675 = ({ transitions: transitions, selectedItem: selectedItem })=>{
    const selectedTransitionInfo = (0, $eJOHy.useMemo)(()=>{
        if (!selectedItem || selectedItem.type !== (0, $v1MZY.EDGE_TYPE)) return undefined;
        const selectedTransition = transitions.find((x)=>x.id === selectedItem.id);
        if (!selectedTransition) return undefined;
        let sourcePortIndexKeys = [];
        if ((0, $5Y3a5.isDirectOrSharedTransitionWithDefinedPorts)(selectedTransition)) {
            if (selectedTransition.type === 'direct') sourcePortIndexKeys = (0, (/*@__PURE__*/$parcel$interopDefault($crnx3)))([
                (0, $jCNJE.toPortKey)(selectedTransition.source, selectedTransition.sourceIndex)
            ]);
            else if (selectedTransition.type === 'shared') sourcePortIndexKeys = (0, (/*@__PURE__*/$parcel$interopDefault($crnx3)))(selectedTransition.links.map(({ source: source, sourceIndex: sourceIndex })=>(0, $jCNJE.toPortKey)(source, sourceIndex)));
        }
        let targetPortIndexKeys = [];
        if ((0, $5Y3a5.isDirectOrSharedTransitionWithDefinedPorts)(selectedTransition)) {
            if (selectedTransition.type === 'direct') targetPortIndexKeys = [
                (0, $jCNJE.toPortKey)(selectedTransition.target, selectedTransition.targetIndex)
            ];
            else if (selectedTransition.type === 'shared') targetPortIndexKeys = selectedTransition.links.map((x)=>(0, $jCNJE.toPortKey)(selectedTransition.target, x.targetIndex));
        }
        return {
            transition: selectedTransition,
            sourcePortIndexKeys: sourcePortIndexKeys,
            targetPortIndexKeys: targetPortIndexKeys
        };
    }, [
        selectedItem,
        transitions
    ]);
    return selectedTransitionInfo;
};
var $39179a10039c6c92$export$2e2bcd8739ae039 = $39179a10039c6c92$export$311b92958e309675;

});


parcelRegister("fiArL", function(module, exports) {

$parcel$export(module.exports, "usePorts", () => $50d723b9d2524ede$export$655248e226a08400);
$parcel$export(module.exports, "toSquareUnitDirection", () => $50d723b9d2524ede$export$b25e3332b7e56531);

var $eJOHy = parcelRequire("eJOHy");

var $crnx3 = parcelRequire("crnx3");

var $75SEb = parcelRequire("75SEb");

var $8dH3d = parcelRequire("8dH3d");

var $200fA = parcelRequire("200fA");

var $gn7EO = parcelRequire("gn7EO");

var $jCNJE = parcelRequire("jCNJE");

var $gJeI4 = parcelRequire("gJeI4");

var $h2zA1 = parcelRequire("h2zA1");

var $aHK8w = parcelRequire("aHK8w");

var $7OVM6 = parcelRequire("7OVM6");
/** Distance between Status boundary and Port's center */ const $50d723b9d2524ede$var$PORT_STATUS_OFFSET = 3;
/** Fraction of a Status' width where PortIndeces `Top` and `Bottom` appear */ const $50d723b9d2524ede$var$PORT_TOP_OR_BOTTOM_X_FRACTION = 0.5;
/** Fraction of a Status' width where PortIndeces `TopLeft` and `BottomLeft` appear */ const $50d723b9d2524ede$var$PORT_TOPLEFT_OR_BOTTOMLEFT_X_FRACTION = 1 / 4.5;
/** Fraction of a Status' width where PortIndeces `TopRight` and `BottomRight` appear */ const $50d723b9d2524ede$var$PORT_TOPRIGHT_OR_BOTTOMRIGHT_X_FRACTION = 1 / 1.28;
function $50d723b9d2524ede$export$f006e34fa35e5c56(portIndex, statusPosition, statusWidth) {
    switch(portIndex){
        case (0, $jCNJE.PortIndex).Left:
            return (0, $jCNJE.toPoint)(statusPosition.x - $50d723b9d2524ede$var$PORT_STATUS_OFFSET, statusPosition.y + (0, $gn7EO.STATUS_HEIGHT) / 2);
        case (0, $jCNJE.PortIndex).TopLeft:
            return (0, $jCNJE.toPoint)(statusPosition.x + statusWidth * $50d723b9d2524ede$var$PORT_TOPLEFT_OR_BOTTOMLEFT_X_FRACTION, statusPosition.y - $50d723b9d2524ede$var$PORT_STATUS_OFFSET);
        case (0, $jCNJE.PortIndex).Top:
            return (0, $jCNJE.toPoint)(statusPosition.x + statusWidth * $50d723b9d2524ede$var$PORT_TOP_OR_BOTTOM_X_FRACTION, statusPosition.y - $50d723b9d2524ede$var$PORT_STATUS_OFFSET);
        case (0, $jCNJE.PortIndex).TopRight:
            return (0, $jCNJE.toPoint)(statusPosition.x + statusWidth * $50d723b9d2524ede$var$PORT_TOPRIGHT_OR_BOTTOMRIGHT_X_FRACTION, statusPosition.y - $50d723b9d2524ede$var$PORT_STATUS_OFFSET);
        case (0, $jCNJE.PortIndex).Right:
            return (0, $jCNJE.toPoint)(statusPosition.x + statusWidth + $50d723b9d2524ede$var$PORT_STATUS_OFFSET, statusPosition.y + (0, $gn7EO.STATUS_HEIGHT) * $50d723b9d2524ede$var$PORT_TOP_OR_BOTTOM_X_FRACTION);
        case (0, $jCNJE.PortIndex).BottomRight:
            return (0, $jCNJE.toPoint)(statusPosition.x + statusWidth * $50d723b9d2524ede$var$PORT_TOPRIGHT_OR_BOTTOMRIGHT_X_FRACTION, statusPosition.y + (0, $gn7EO.STATUS_HEIGHT) + $50d723b9d2524ede$var$PORT_STATUS_OFFSET);
        case (0, $jCNJE.PortIndex).Bottom:
            return (0, $jCNJE.toPoint)(statusPosition.x + statusWidth * $50d723b9d2524ede$var$PORT_TOP_OR_BOTTOM_X_FRACTION, statusPosition.y + (0, $gn7EO.STATUS_HEIGHT) + $50d723b9d2524ede$var$PORT_STATUS_OFFSET);
        case (0, $jCNJE.PortIndex).BottomLeft:
            return (0, $jCNJE.toPoint)(statusPosition.x + statusWidth * $50d723b9d2524ede$var$PORT_TOPLEFT_OR_BOTTOMLEFT_X_FRACTION, statusPosition.y + (0, $gn7EO.STATUS_HEIGHT) + $50d723b9d2524ede$var$PORT_STATUS_OFFSET);
        default:
            (0, $gJeI4.fireError)('PortIndex given does not match any known PortIndexes.', 'use-ports.utils.get-port-position', {
                portIndex: portIndex
            });
            return (0, $jCNJE.toPoint)(0, 0);
    }
}
const $50d723b9d2524ede$export$e3dd17f2878a4154 = ({ selectedItem: selectedItem, transitions: transitions })=>{
    const selectedTransitionInfo = (0, $aHK8w.useSelectedTransitionInfo)({
        selectedItem: selectedItem,
        transitions: transitions
    });
    const focusedPortKeys = (0, $eJOHy.useMemo)(()=>{
        if (!selectedTransitionInfo) return [];
        return (0, (/*@__PURE__*/$parcel$interopDefault($crnx3)))([
            ...selectedTransitionInfo.sourcePortIndexKeys,
            ...selectedTransitionInfo.targetPortIndexKeys
        ]);
    }, [
        selectedTransitionInfo
    ]);
    return focusedPortKeys;
};
const $50d723b9d2524ede$export$655248e226a08400 = ({ hoveredItem: hoveredItem, selectedItem: selectedItem, transitions: transitions, statusWidths: statusWidths, startNodePosition: startNodePosition, statuses: statuses, defaultPositions: defaultPositions, dragDropState: dragDropState, proposedTransition: proposedTransition, reroutingTransition: reroutingTransition, isImmutable: isImmutable })=>{
    const isProposingTransition = proposedTransition.stage !== 'none';
    let glowingPortKey;
    if (proposedTransition.stage === 'valid') glowingPortKey = proposedTransition.endPortKey;
    else if (reroutingTransition.stage === 'valid') glowingPortKey = reroutingTransition.proposedPortKey;
    const proposedTransitionStartPort = proposedTransition.stage === 'none' ? undefined : proposedTransition.startPortKey;
    const statusesThatShouldShowPorts = (0, $7OVM6.useStatusesThatShouldShowPorts)({
        hoveredItem: hoveredItem,
        statuses: statuses,
        dragDropState: dragDropState,
        isProposingTransition: isProposingTransition,
        reroutingTransition: reroutingTransition
    });
    const portsConnectedToSelectedTransition = $50d723b9d2524ede$export$e3dd17f2878a4154({
        selectedItem: selectedItem,
        transitions: transitions
    });
    const latestStatuses = (0, $h2zA1.useLatest)(statuses);
    const portsByPortKey = (0, $eJOHy.useMemo)(()=>{
        const ports = {};
        if (latestStatuses.current.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(statusWidths)) return ports;
        const startNodePositionOrDefault = startNodePosition || defaultPositions[0, $200fA.START_NODE_ID];
        if (startNodePositionOrDefault) ports[0, $200fA.START_NODE_ID] = (0, $jCNJE.toPortInfo)((0, $200fA.START_NODE_ID), (0, $jCNJE.PortIndex).Bottom, {
            x: startNodePositionOrDefault.x + (0, $gn7EO.START_NODE_RADIUS),
            y: startNodePositionOrDefault.y + (0, $gn7EO.START_NODE_RADIUS) * 2 - (0, $gn7EO.PORT_RADIUS)
        }, false, false);
        return latestStatuses.current.reduce((acc, status)=>{
            const statusPosition = status.position || defaultPositions[status.id];
            if (statusPosition === undefined) return acc;
            const isVisibleForStatus = statusesThatShouldShowPorts.includes(status.id);
            (0, $jCNJE.allStatusPorts).forEach((portIndex)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const portKey = (0, $jCNJE.toPortKey)(status.id, portIndex);
                acc[portKey] = {
                    key: portKey,
                    isVisible: (isVisibleForStatus || portsConnectedToSelectedTransition.includes(portKey)) && proposedTransitionStartPort !== portKey,
                    statusId: status.id,
                    portIndex: portIndex,
                    position: $50d723b9d2524ede$export$f006e34fa35e5c56(portIndex, statusPosition, statusWidths[status.id]),
                    isGlowing: glowingPortKey === portKey
                };
            });
            return acc;
        }, ports);
    }, [
        latestStatuses,
        statusWidths,
        startNodePosition,
        defaultPositions,
        statusesThatShouldShowPorts,
        portsConnectedToSelectedTransition,
        proposedTransitionStartPort,
        glowingPortKey
    ]);
    const visiblePorts = (0, $eJOHy.useMemo)(()=>{
        if (isImmutable) return [];
        return (0, (/*@__PURE__*/$parcel$interopDefault($75SEb)))(portsByPortKey, (x)=>x.isVisible);
    }, [
        isImmutable,
        portsByPortKey
    ]);
    return {
        ports: portsByPortKey,
        visiblePorts: visiblePorts
    };
};
function $50d723b9d2524ede$export$b25e3332b7e56531(portIndex) {
    switch(portIndex){
        case (0, $jCNJE.PortIndex).Top:
        case (0, $jCNJE.PortIndex).TopRight:
        case (0, $jCNJE.PortIndex).TopLeft:
            return (0, $jCNJE.toPoint)(0, 1);
        case (0, $jCNJE.PortIndex).Bottom:
        case (0, $jCNJE.PortIndex).BottomRight:
        case (0, $jCNJE.PortIndex).BottomLeft:
            return (0, $jCNJE.toPoint)(0, -1);
        case (0, $jCNJE.PortIndex).Right:
            return (0, $jCNJE.toPoint)(-1, 0);
        case (0, $jCNJE.PortIndex).Left:
            return (0, $jCNJE.toPoint)(1, 0);
        default:
            return (0, $jCNJE.toPoint)(0, 0);
    }
}

});
parcelRegister("75SEb", function(module, exports) {

var $821Ou = parcelRequire("821Ou");

var $3PLp8 = parcelRequire("3PLp8");

var $1lM9j = parcelRequire("1lM9j");

var $4sprp = parcelRequire("4sprp");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $52a363cc76e51f60$var$filter(collection, predicate) {
    var func = $4sprp(collection) ? $821Ou : $3PLp8;
    return func(collection, $1lM9j(predicate, 3));
}
module.exports = $52a363cc76e51f60$var$filter;

});
parcelRegister("3PLp8", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $2caae80f7af1e608$var$baseFilter(collection, predicate) {
    var result = [];
    $c3u3c(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $2caae80f7af1e608$var$baseFilter;

});


parcelRegister("gJeI4", function(module, exports) {

$parcel$export(module.exports, "fireError", () => $5c36b461bc2e9d19$export$ee6e888f68fd8ba1);

var $gYnSx = parcelRequire("gYnSx");
const $5c36b461bc2e9d19$export$ee6e888f68fd8ba1 = (messageOrError, location, attributes)=>{
    const errorObject = messageOrError instanceof Error ? messageOrError : new Error(messageOrError);
    (0, $gYnSx.default)({
        error: errorObject,
        meta: {
            id: location,
            packageName: 'jiraAccessibleWorkflowDiagram',
            teamName: 'helix'
        },
        skipSentry: false,
        attributes: attributes
    });
};

});

parcelRegister("7OVM6", function(module, exports) {

$parcel$export(module.exports, "useStatusesThatShouldShowPorts", () => $9474ce49aadfe1eb$export$6a8b70aa5f9821f);

var $eJOHy = parcelRequire("eJOHy");

var $5Y3a5 = parcelRequire("5Y3a5");
const $9474ce49aadfe1eb$export$6a8b70aa5f9821f = ({ hoveredItem: hoveredItem, statuses: statuses, dragDropState: dragDropState, isProposingTransition: isProposingTransition, reroutingTransition: reroutingTransition })=>{
    const statusesThatShouldShowPorts = (0, $eJOHy.useMemo)(()=>{
        if (dragDropState.isDragging && dragDropState.dragSubject.type === 'status') return [];
        const isReroutingDirectTransition = reroutingTransition.stage !== 'none' && reroutingTransition.transition.type === 'direct';
        if (isProposingTransition || isReroutingDirectTransition) return statuses.map(({ id: id })=>id);
        if (reroutingTransition.stage !== 'none') {
            if (reroutingTransition.side === 'target') return statuses.map(({ id: id })=>id);
            // ignore ports from statuses that are already in the source list from showing,
            // except the one we're moving from already
            const reroutingSharedTransition = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            reroutingTransition.transition;
            const otherSourceStatusIds = reroutingSharedTransition.links.filter((link)=>link.source !== reroutingTransition.originalStatusId).map(({ source: source })=>source);
            return statuses.filter(({ id: id })=>!otherSourceStatusIds.includes(id)).map(({ id: id })=>id);
        }
        return statuses.filter((n)=>(0, $5Y3a5.statusMatchesReference)(n, hoveredItem)).map(({ id: id })=>id);
    }, [
        dragDropState,
        reroutingTransition,
        isProposingTransition,
        statuses,
        hoveredItem
    ]);
    return statusesThatShouldShowPorts;
};
var $9474ce49aadfe1eb$export$2e2bcd8739ae039 = $9474ce49aadfe1eb$export$6a8b70aa5f9821f;

});


parcelRegister("iYsbF", function(module, exports) {

$parcel$export(module.exports, "useRecordState", () => $ab73f1ddfb197bfd$export$8d6124146484a634);

var $eJOHy = parcelRequire("eJOHy");
const $ab73f1ddfb197bfd$export$8d6124146484a634 = (// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
initialValue = {})=>{
    const [state, setState] = (0, $eJOHy.useState)(initialValue);
    const setItem = (0, $eJOHy.useCallback)((key, value)=>{
        setState((prev)=>({
                ...prev,
                [key]: value
            }));
    }, []);
    return [
        state,
        setState,
        setItem
    ];
};

});

parcelRegister("gXlg7", function(module, exports) {

$parcel$export(module.exports, "useSnapLines", () => $5e842b6e52effcff$export$b69c21835c582cef);

var $gn7EO = parcelRequire("gn7EO");

var $kEtMU = parcelRequire("kEtMU");

var $gzNJ4 = parcelRequire("gzNJ4");
const $5e842b6e52effcff$export$b69c21835c582cef = ({ isImmutable: isImmutable, statuses: statuses, transitions: transitions, statusWidths: statusWidths, startNodePosition: startNodePosition, globalLoopsContainerPosition: globalLoopsContainerPosition, movingItem: movingItem, dragDropState: dragDropState })=>{
    const subject = movingItem || (0, $kEtMU.getDraggingItem)(dragDropState);
    const globalLoopedTransitions = transitions.filter((transition)=>transition.type === 'global-looped');
    if (isImmutable || !subject) return {
        snapLines: []
    };
    const subjectBounds = (0, $gzNJ4.getSubjectBounds)(subject, statusWidths, globalLoopedTransitions.length);
    const othersOld = statuses.filter((status)=>status.id !== subject.id && status.position)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((status)=>(0, $gzNJ4.getBounds)(status.position, statusWidths[status.id], (0, $gn7EO.STATUS_HEIGHT)));
    if (subject.type !== 'start-node' && startNodePosition) othersOld.push((0, $gzNJ4.getBounds)(startNodePosition, (0, $gn7EO.START_NODE_RADIUS) * 2, (0, $gn7EO.START_NODE_RADIUS) * 2));
    const otherBounds = (0, $gzNJ4.getOtherBounds)(statuses, statusWidths, subject, startNodePosition, globalLoopsContainerPosition, globalLoopedTransitions.length);
    const snappables = (0, $gzNJ4.findAllSnappableLines)(subjectBounds, otherBounds);
    const snapLines = (0, $gzNJ4.aggregateSnapLines)(subjectBounds, snappables);
    const snappedSubjectPosition = (0, $gzNJ4.snapSubject)(subjectBounds, snapLines);
    return {
        snapLines: (0, $gzNJ4.toLines)(snapLines),
        snappedSubjectPosition: snappedSubjectPosition
    };
};

});
parcelRegister("gzNJ4", function(module, exports) {

$parcel$export(module.exports, "findAllSnappableLines", () => $7789ad282f330f05$export$7fb4059c463d0a63);
$parcel$export(module.exports, "aggregateSnapLines", () => $7789ad282f330f05$export$bf23497f1a2c32a9);
$parcel$export(module.exports, "snapSubject", () => $7789ad282f330f05$export$ea2163b0ecb21cd2);
$parcel$export(module.exports, "toLines", () => $7789ad282f330f05$export$d614ee83a8a0f115);
$parcel$export(module.exports, "getOtherBounds", () => $7789ad282f330f05$export$d8ab6d98959ac338);
$parcel$export(module.exports, "getBounds", () => $7789ad282f330f05$export$becd1e645219fa23);
$parcel$export(module.exports, "getSubjectBounds", () => $7789ad282f330f05$export$ed0676213054c996);

var $40zJW = parcelRequire("40zJW");

var $jCNJE = parcelRequire("jCNJE");

var $hyRwo = parcelRequire("hyRwo");

var $gn7EO = parcelRequire("gn7EO");

var $4LjO0 = parcelRequire("4LjO0");
const $7789ad282f330f05$var$SNAP_THRESHOLD = 3;
/** Returns true if two values are within the {@link SNAP_THRESHOLD} */ function $7789ad282f330f05$var$isInSnapDistance(a, b) {
    return Math.abs(a - b) < $7789ad282f330f05$var$SNAP_THRESHOLD;
}
const $7789ad282f330f05$export$c396406f3a71033d = (snappable)=>`${snappable.alignment}:${snappable.type === 'horizontal' ? snappable.x : snappable.y} `;
const $7789ad282f330f05$var$horizontalAlignmentCombinations = [
    [
        (0, $4LjO0.HorizontalAlignment).left,
        (0, $4LjO0.HorizontalAlignment).left
    ],
    [
        (0, $4LjO0.HorizontalAlignment).left,
        (0, $4LjO0.HorizontalAlignment).right
    ],
    [
        (0, $4LjO0.HorizontalAlignment).left,
        (0, $4LjO0.HorizontalAlignment).middle
    ],
    [
        (0, $4LjO0.HorizontalAlignment).middle,
        (0, $4LjO0.HorizontalAlignment).left
    ],
    [
        (0, $4LjO0.HorizontalAlignment).middle,
        (0, $4LjO0.HorizontalAlignment).right
    ],
    [
        (0, $4LjO0.HorizontalAlignment).middle,
        (0, $4LjO0.HorizontalAlignment).middle
    ],
    [
        (0, $4LjO0.HorizontalAlignment).right,
        (0, $4LjO0.HorizontalAlignment).left
    ],
    [
        (0, $4LjO0.HorizontalAlignment).right,
        (0, $4LjO0.HorizontalAlignment).right
    ],
    [
        (0, $4LjO0.HorizontalAlignment).right,
        (0, $4LjO0.HorizontalAlignment).middle
    ]
];
const $7789ad282f330f05$var$verticalAlignmentCombinations = [
    [
        (0, $4LjO0.VerticalAlignment).top,
        (0, $4LjO0.VerticalAlignment).top
    ],
    [
        (0, $4LjO0.VerticalAlignment).top,
        (0, $4LjO0.VerticalAlignment).bottom
    ],
    [
        (0, $4LjO0.VerticalAlignment).bottom,
        (0, $4LjO0.VerticalAlignment).top
    ],
    [
        (0, $4LjO0.VerticalAlignment).bottom,
        (0, $4LjO0.VerticalAlignment).bottom
    ]
];
const $7789ad282f330f05$export$7fb4059c463d0a63 = (subject, others)=>{
    if (others.length === 0) return [];
    // find closest horizontal rays of same x value
    let closestDistanceX = Number.POSITIVE_INFINITY;
    let horizontalSnappables = [];
    $7789ad282f330f05$var$horizontalAlignmentCombinations.forEach(([subjectAlignment, otherAlignment])=>{
        others.forEach((other)=>{
            if ($7789ad282f330f05$var$isInSnapDistance(subject[subjectAlignment], other[otherAlignment])) {
                const distance = Math.abs(subject[subjectAlignment] - other[otherAlignment]);
                if (distance < closestDistanceX) {
                    // closer snappable exists on this axis, clear list
                    closestDistanceX = distance;
                    horizontalSnappables = [];
                }
                horizontalSnappables.push({
                    type: 'horizontal',
                    x: other[otherAlignment],
                    alignment: subjectAlignment,
                    top: other.top,
                    bottom: other.bottom
                });
            }
        });
    });
    // find closest verticals rays of same y value
    let closestDistanceY = Number.POSITIVE_INFINITY;
    let verticalSnappables = [];
    $7789ad282f330f05$var$verticalAlignmentCombinations.forEach(([subjectAlignment, otherAlignment])=>{
        others.forEach((other)=>{
            if ($7789ad282f330f05$var$isInSnapDistance(subject[subjectAlignment], other[otherAlignment])) {
                const distance = Math.abs(subject[subjectAlignment] - other[otherAlignment]);
                if (distance < closestDistanceY) {
                    // closer snappable exists on this axis, clear list
                    closestDistanceY = distance;
                    verticalSnappables = [];
                }
                verticalSnappables.push({
                    type: 'vertical',
                    y: other[otherAlignment],
                    alignment: subjectAlignment,
                    left: other.left,
                    right: other.right
                });
            }
        });
    });
    return [
        ...horizontalSnappables,
        ...verticalSnappables
    ];
};
const $7789ad282f330f05$export$bf23497f1a2c32a9 = (subject, snappables)=>{
    if (snappables.length === 0) return [];
    const mapped = snappables.reduce((acc, snappable)=>{
        if (snappable.type === 'horizontal') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const existingSnapLine = acc[$7789ad282f330f05$export$c396406f3a71033d(snappable)];
            if (existingSnapLine) {
                // if exists, just update the top-most/bottom-most values
                existingSnapLine.top = Math.min(existingSnapLine.top, snappable.top, subject.top);
                existingSnapLine.bottom = Math.max(existingSnapLine.bottom, snappable.bottom, subject.bottom);
            } else {
                const newSnapLine = {
                    type: 'horizontal',
                    x: snappable.x,
                    alignment: snappable.alignment,
                    top: Math.min(snappable.top, subject.top),
                    bottom: Math.max(snappable.bottom, subject.bottom)
                };
                acc[$7789ad282f330f05$export$c396406f3a71033d(snappable)] = newSnapLine;
            }
        } else if (snappable.type === 'vertical') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const existingSnapLine = acc[$7789ad282f330f05$export$c396406f3a71033d(snappable)];
            if (existingSnapLine) {
                // if exists, just update the left-most/right-most values
                existingSnapLine.left = Math.min(existingSnapLine.left, snappable.left, subject.left);
                existingSnapLine.right = Math.max(existingSnapLine.right, snappable.right, subject.right);
            } else {
                const newSnapLine = {
                    type: 'vertical',
                    y: snappable.y,
                    alignment: snappable.alignment,
                    left: Math.min(snappable.left, subject.left),
                    right: Math.max(snappable.right, subject.right)
                };
                acc[$7789ad282f330f05$export$c396406f3a71033d(snappable)] = newSnapLine;
            }
        }
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($40zJW)))(mapped);
};
const $7789ad282f330f05$export$ea2163b0ecb21cd2 = (subject, snapLines)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const firstHorizontal = snapLines.find((snapLine)=>snapLine.type === 'horizontal');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const firstVertical = snapLines.find((snapLine)=>snapLine.type === 'vertical');
    let x = subject.left;
    let y = subject.top;
    const subjectWidth = subject.right - subject.left;
    if (firstHorizontal?.alignment === 'left') x = firstHorizontal.x;
    else if (firstHorizontal?.alignment === 'middle') x = firstHorizontal.x - subjectWidth / 2;
    else if (firstHorizontal?.alignment === 'right') x = firstHorizontal.x - subjectWidth;
    const subjectHeight = subject.bottom - subject.top;
    if (firstVertical?.alignment === 'top') y = firstVertical.y;
    else if (firstVertical?.alignment === 'bottom') y = firstVertical.y - subjectHeight;
    return (0, $jCNJE.toPoint)(x, y);
};
const $7789ad282f330f05$export$d614ee83a8a0f115 = (snapLines)=>snapLines.map((snapLine)=>{
        if (snapLine.type === 'horizontal') return {
            start: (0, $jCNJE.toPoint)(snapLine.x, snapLine.top),
            end: (0, $jCNJE.toPoint)(snapLine.x, snapLine.bottom)
        };
        return {
            start: (0, $jCNJE.toPoint)(snapLine.left, snapLine.y),
            end: (0, $jCNJE.toPoint)(snapLine.right, snapLine.y)
        };
    });
const $7789ad282f330f05$export$d8ab6d98959ac338 = (statuses, statusWidths, subject, startNodePosition, globalLoopsContainerPosition, globalLoopedTransitionsCount)=>{
    // Status bounds that exclude the currently moving status (if any)
    const statusBounds = statuses.filter((status)=>status.id !== subject.id && status.position)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((status)=>$7789ad282f330f05$export$becd1e645219fa23(status.position, statusWidths[status.id], (0, $gn7EO.STATUS_HEIGHT)));
    const containerHeight = (0, $hyRwo.getContainerHeight)(globalLoopedTransitionsCount);
    if (subject.type === 'status') {
        startNodePosition && statusBounds.push($7789ad282f330f05$export$becd1e645219fa23(startNodePosition, (0, $gn7EO.START_NODE_RADIUS) * 2, (0, $gn7EO.START_NODE_RADIUS) * 2));
        globalLoopsContainerPosition && statusBounds.push($7789ad282f330f05$export$becd1e645219fa23(globalLoopsContainerPosition, (0, $hyRwo.CONTAINER_WIDTH), containerHeight));
    } else if (subject.type === 'start-node') globalLoopsContainerPosition && statusBounds.push($7789ad282f330f05$export$becd1e645219fa23(globalLoopsContainerPosition, (0, $hyRwo.CONTAINER_WIDTH), containerHeight));
    else if (subject.type === 'global-loops-container') startNodePosition && statusBounds.push($7789ad282f330f05$export$becd1e645219fa23(startNodePosition, (0, $gn7EO.START_NODE_RADIUS) * 2, (0, $gn7EO.START_NODE_RADIUS) * 2));
    return statusBounds;
};
const $7789ad282f330f05$export$ed0676213054c996 = (subject, statusWidths, globalLoopedTransitionsCount)=>{
    if (subject.type === 'status') return $7789ad282f330f05$export$becd1e645219fa23(subject.position, statusWidths[subject.id], (0, $gn7EO.STATUS_HEIGHT));
    if (subject.type === 'global-loops-container') {
        const containerHeight = (0, $hyRwo.getContainerHeight)(globalLoopedTransitionsCount);
        return $7789ad282f330f05$export$becd1e645219fa23(subject.position, (0, $hyRwo.CONTAINER_WIDTH), containerHeight);
    }
    return $7789ad282f330f05$export$becd1e645219fa23(subject.position, (0, $gn7EO.START_NODE_RADIUS) * 2, (0, $gn7EO.START_NODE_RADIUS) * 2);
};
const $7789ad282f330f05$export$becd1e645219fa23 = (position, width, height)=>({
        left: position.x,
        middle: position.x + width / 2,
        right: position.x + width,
        top: position.y,
        bottom: position.y + height
    });

});
parcelRegister("hyRwo", function(module, exports) {

$parcel$export(module.exports, "CONTAINER_WIDTH", () => $eee6ba59b02596ec$export$51aec347ac39078);
$parcel$export(module.exports, "LOZENGE_HEIGHT", () => $eee6ba59b02596ec$export$ec1acf08b99151bb);
$parcel$export(module.exports, "LOZENGE_BORDER_RADIUS", () => $eee6ba59b02596ec$export$7aa25920b550c80e);
$parcel$export(module.exports, "getGlobalLoopTransitionPosition", () => $eee6ba59b02596ec$export$cc25202f879fd2c5);
$parcel$export(module.exports, "getContainerHeight", () => $eee6ba59b02596ec$export$cf6292b4985d86a5);
$parcel$export(module.exports, "getLozengePosition", () => $eee6ba59b02596ec$export$36425df40d6710c4);
$parcel$export(module.exports, "getLozengeTextPosition", () => $eee6ba59b02596ec$export$7854da71fb30db7);
$parcel$export(module.exports, "globalLoopedTransitionRoute", () => $eee6ba59b02596ec$export$18cc9cc7ce4c58b9);
$parcel$export(module.exports, "getLozengeWidth", () => $eee6ba59b02596ec$export$985458f07240fb0b);
$parcel$export(module.exports, "getLabelPosition", () => $eee6ba59b02596ec$export$bd7634e2250a2a2c);
$parcel$export(module.exports, "getArrowPosition", () => $eee6ba59b02596ec$export$54d73b6175e7c49d);

var $gn7EO = parcelRequire("gn7EO");

var $jCNJE = parcelRequire("jCNJE");

var $lJ60K = parcelRequire("lJ60K");

var $9VjvI = parcelRequire("9VjvI");
const $eee6ba59b02596ec$var$CONTENT_PADDING_LEFT = 12;
const $eee6ba59b02596ec$var$CONTENT_PADDING = 12;
const $eee6ba59b02596ec$export$9c6ac22bdb6c9001 = 90;
const $eee6ba59b02596ec$export$71d1fa29bd83ad5d = 50;
const $eee6ba59b02596ec$export$38741e59cd4e433d = 30;
const $eee6ba59b02596ec$export$51aec347ac39078 = 160;
const $eee6ba59b02596ec$export$f49fe38c1d28c9ce = 40;
const $eee6ba59b02596ec$export$ec1acf08b99151bb = 24;
const $eee6ba59b02596ec$export$7aa25920b550c80e = $eee6ba59b02596ec$export$ec1acf08b99151bb / 2;
const $eee6ba59b02596ec$export$98927b09f44af95e = 10; // total padding around left and right of lozenge, L + R value
const $eee6ba59b02596ec$export$507b37241cc637ae = 24;
const $eee6ba59b02596ec$export$cc25202f879fd2c5 = (position, index)=>(0, $lJ60K.add)(position, (0, $jCNJE.toPoint)($eee6ba59b02596ec$var$CONTENT_PADDING_LEFT, $eee6ba59b02596ec$var$CONTENT_PADDING + index * ($eee6ba59b02596ec$export$71d1fa29bd83ad5d + $eee6ba59b02596ec$export$38741e59cd4e433d)));
const $eee6ba59b02596ec$export$cf6292b4985d86a5 = (transitionsCount)=>$eee6ba59b02596ec$var$CONTENT_PADDING * 2 + transitionsCount * ($eee6ba59b02596ec$export$71d1fa29bd83ad5d + $eee6ba59b02596ec$export$38741e59cd4e433d);
const $eee6ba59b02596ec$export$36425df40d6710c4 = (position)=>({
        x: position.x,
        y: position.y + $eee6ba59b02596ec$export$71d1fa29bd83ad5d
    });
const $eee6ba59b02596ec$export$7854da71fb30db7 = (lozengePosition, lozengeWidth)=>(0, $lJ60K.add)(lozengePosition, (0, $jCNJE.toPoint)(lozengeWidth / 2, $eee6ba59b02596ec$export$ec1acf08b99151bb / 2 + 4));
const $eee6ba59b02596ec$export$18cc9cc7ce4c58b9 = (lozengePosition, lozengeWidth)=>{
    const lozengeMiddleRight = (0, $lJ60K.add)(lozengePosition, (0, $jCNJE.toPoint)(lozengeWidth, $eee6ba59b02596ec$export$ec1acf08b99151bb / 2));
    return (0, $9VjvI.combinePath)((0, $9VjvI.move)(lozengeMiddleRight), (0, $9VjvI.lineRight)($eee6ba59b02596ec$export$9c6ac22bdb6c9001 - lozengeWidth / 2), (0, $9VjvI.lineUp)($eee6ba59b02596ec$export$71d1fa29bd83ad5d), (0, $9VjvI.lineLeft)($eee6ba59b02596ec$export$9c6ac22bdb6c9001), (0, $9VjvI.lineDown)($eee6ba59b02596ec$export$71d1fa29bd83ad5d - $eee6ba59b02596ec$export$ec1acf08b99151bb / 2 - (0, $gn7EO.PORT_RADIUS)));
};
const $eee6ba59b02596ec$export$985458f07240fb0b = (textWidth)=>Math.max($eee6ba59b02596ec$export$f49fe38c1d28c9ce, textWidth + $eee6ba59b02596ec$export$98927b09f44af95e);
const $eee6ba59b02596ec$export$bd7634e2250a2a2c = (position)=>(0, $lJ60K.add)(position, (0, $jCNJE.toPoint)($eee6ba59b02596ec$export$9c6ac22bdb6c9001 - 5, $eee6ba59b02596ec$export$507b37241cc637ae / 2));
const $eee6ba59b02596ec$export$54d73b6175e7c49d = (lozengePosition, lozengeWidth)=>(0, $lJ60K.add)(lozengePosition, (0, $jCNJE.toPoint)(lozengeWidth / 2, 0));

});
parcelRegister("9VjvI", function(module, exports) {

$parcel$export(module.exports, "move", () => $ae7c32d032acf682$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "line", () => $ae7c32d032acf682$export$53f1d5ea8de3d7c);
$parcel$export(module.exports, "lineUp", () => $ae7c32d032acf682$export$9df76f8840ecca30);
$parcel$export(module.exports, "lineDown", () => $ae7c32d032acf682$export$dd6c925082c620b);
$parcel$export(module.exports, "lineLeft", () => $ae7c32d032acf682$export$b285e852656515c);
$parcel$export(module.exports, "lineRight", () => $ae7c32d032acf682$export$f6a982dcdc83dc);
$parcel$export(module.exports, "combinePath", () => $ae7c32d032acf682$export$fba1874d3b3435ea);
const $ae7c32d032acf682$export$d947e5f4f4c48d48 = ({ x: x, y: y })=>`M${x},${y}`;
const $ae7c32d032acf682$export$53f1d5ea8de3d7c = ({ x: x, y: y })=>`L${x},${y}`;
const $ae7c32d032acf682$export$9df76f8840ecca30 = (amount)=>`l0,${-amount}`;
const $ae7c32d032acf682$export$dd6c925082c620b = (amount)=>`l0,${amount}`;
const $ae7c32d032acf682$export$b285e852656515c = (amount)=>`l${-amount},0`;
const $ae7c32d032acf682$export$f6a982dcdc83dc = (amount)=>`l${amount},0`;
const $ae7c32d032acf682$export$fba1874d3b3435ea = (...components)=>components.join('');

});


parcelRegister("4LjO0", function(module, exports) {

$parcel$export(module.exports, "HorizontalAlignment", () => $5543f7ca23b29bf7$export$d94dcb5bec64086e);
$parcel$export(module.exports, "VerticalAlignment", () => $5543f7ca23b29bf7$export$c12e835f91722ef8);
/**
 * Alignable parts of a status across both horizontal and vertical axes
 *
 * ```
 * ┄┄╭――――――――――――――――╮┄┄┄┄┄ top
 *   |                |
 * ┄┄╰――――――――――――――――╯┄┄┄┄┄ bottom
 *
 * left   middle   right
 * ┆        ┆        ┆
 * ╭――――――――┆――――――――╮
 * |        ┆        |
 * ╰――――――――┆――――――――╯
 * ┆        ┆        ┆
 * ```
 */ var $5543f7ca23b29bf7$export$d94dcb5bec64086e = /*#__PURE__*/ function(HorizontalAlignment) {
    HorizontalAlignment["left"] = "left";
    HorizontalAlignment["middle"] = "middle";
    HorizontalAlignment["right"] = "right";
    return HorizontalAlignment;
}({});
var $5543f7ca23b29bf7$export$c12e835f91722ef8 = /*#__PURE__*/ function(VerticalAlignment) {
    VerticalAlignment["top"] = "top";
    VerticalAlignment["bottom"] = "bottom";
    return VerticalAlignment;
}({});

});



parcelRegister("3lHO8", function(module, exports) {

$parcel$export(module.exports, "useStartNode", () => $3add40a305b9db61$export$b67102238a108f96);

var $200fA = parcelRequire("200fA");

var $5Y3a5 = parcelRequire("5Y3a5");
const $3add40a305b9db61$export$b67102238a108f96 = ({ startNodePosition: startNodePosition, targetedItem: targetedItem, hoveredItem: hoveredItem, draggingItem: draggingItem, movingItem: movingItem, defaultPositions: defaultPositions })=>{
    let position = startNodePosition || defaultPositions[0, $200fA.START_NODE_ID];
    const isDragging = draggingItem?.type === 'start-node';
    const isMoving = movingItem?.type === 'start-node';
    if (isDragging) position = draggingItem.position;
    if (isMoving) position = movingItem.position;
    return {
        id: (0, $200fA.START_NODE_ID),
        position: position,
        isTargeted: (0, $5Y3a5.isStartNodeReference)(targetedItem),
        isHovered: (0, $5Y3a5.isStartNodeReference)(hoveredItem),
        isDragging: isDragging,
        isMoving: isMoving
    };
};

});

parcelRegister("crnvo", function(module, exports) {

$parcel$export(module.exports, "useStatefulStatuses", () => $1c255b5943e22510$export$ab9803bd767942da);

var $5Y3a5 = parcelRequire("5Y3a5");
const $1c255b5943e22510$export$ab9803bd767942da = ({ statuses: statuses, selectedItem: selectedItem, targetedItem: targetedItem, hoveredItem: hoveredItem, draggingItem: draggingItem, movingItem: movingItem, defaultPositions: defaultPositions })=>statuses.map((status)=>{
        let position = status.position || defaultPositions[status.id];
        const isDragging = draggingItem?.type === 'status' && draggingItem?.id === status.id;
        const isMoving = movingItem?.type === 'status' && movingItem?.id === status.id;
        if (isDragging) position = draggingItem.position;
        if (isMoving) position = movingItem.position;
        return {
            ...status,
            position: position,
            isSelected: (0, $5Y3a5.statusMatchesReference)(status, selectedItem),
            isTargeted: (0, $5Y3a5.statusMatchesReference)(status, targetedItem),
            isHovered: (0, $5Y3a5.statusMatchesReference)(status, hoveredItem),
            isDragging: isDragging,
            isMoving: isMoving
        };
    });

});

parcelRegister("3KLH9", function(module, exports) {

$parcel$export(module.exports, "useStatefulTransitions", () => $e32bb05ec7654a29$export$8659463c3cf31448);

var $eJOHy = parcelRequire("eJOHy");

var $gn7EO = parcelRequire("gn7EO");

var $jCNJE = parcelRequire("jCNJE");

var $5Y3a5 = parcelRequire("5Y3a5");

var $4zxGr = parcelRequire("4zxGr");

var $S2Jmq = parcelRequire("S2Jmq");

var $5VqRQ = parcelRequire("5VqRQ");

var $3O7Ee = parcelRequire("3O7Ee");
const $e32bb05ec7654a29$export$6054b5d3597b4f98 = 35;
const $e32bb05ec7654a29$export$8659463c3cf31448 = ({ transitions: transitions, selectedItem: selectedItem, targetedItem: targetedItem, hoveredItem: hoveredItem, ports: ports, reroutingTransition: reroutingTransition, transitionsWithDefaultPorts: transitionsWithDefaultPorts })=>{
    const transitionLabelPlacementsNew = (0, $eJOHy.useMemo)(()=>(0, $S2Jmq.calculateOverlappingLabelPlacement)(transitions), [
        transitions
    ]);
    const statefulTransitions = transitions.map((baseTransition)=>{
        let isOverlapping = false;
        let isOverlapHovered = false;
        // use default transition data if it exists and the base transition is missing ports
        const transition = (baseTransition.type === 'shared' || baseTransition.type === 'direct') && !(0, $5Y3a5.isDirectOrSharedTransitionWithDefinedPorts)(baseTransition) && transitionsWithDefaultPorts[baseTransition.id] ? transitionsWithDefaultPorts[baseTransition.id] : baseTransition;
        isOverlapping = (0, $5Y3a5.isTransitionOverlapping)(transition.id, transitionLabelPlacementsNew);
        isOverlapHovered = (0, $5Y3a5.isAnyOverlappingTransitionHovered)(transition.id, hoveredItem?.id, transitionLabelPlacementsNew);
        const transitionFlags = {
            isSelected: (0, $5Y3a5.transitionMatchesReference)(transition, selectedItem),
            isTargeted: (0, $5Y3a5.transitionMatchesReference)(transition, targetedItem),
            isHovered: (0, $5Y3a5.transitionMatchesReference)(transition, hoveredItem),
            isHighlighted: (0, $5Y3a5.isHighlightedTransition)(transition, selectedItem, hoveredItem),
            isRerouting: (0, $5Y3a5.isTransitionRerouting)(transition, reroutingTransition),
            isOverlapping: isOverlapping,
            isOverlapHovered: isOverlapHovered
        };
        if (transition.type === 'global-looped') {
            // TODO HIX-5551 implement label positions
            let labelPosition;
            return {
                ...transition,
                ...transitionFlags,
                labelPosition: labelPosition
            };
        }
        if (transition.type === 'global') {
            const targetPort = ports[(0, $jCNJE.toPortKey)(transition.target, (0, $gn7EO.GLOBAL_TRANSITION_PORT))];
            let labelPosition;
            if (targetPort?.position) labelPosition = (0, $jCNJE.toPoint)(targetPort.position.x, targetPort.position.y + $e32bb05ec7654a29$export$6054b5d3597b4f98);
            return {
                ...transition,
                ...transitionFlags,
                labelPosition: labelPosition,
                targetPort: targetPort
            };
        }
        if (transition.type === 'shared') return {
            ...transition,
            ...transitionFlags,
            ...(0, $3O7Ee.getSharedTransitionLayout)(transition, ports, transitionLabelPlacementsNew, reroutingTransition)
        };
        // direct transition
        let sourcePort = (0, $5Y3a5.findPort)(ports, transition.source, transition.sourceIndex);
        sourcePort = (0, $5Y3a5.updateTransitionPortIfRerouting)(sourcePort, 'source', transition, reroutingTransition);
        let targetPort = (0, $5Y3a5.findPort)(ports, transition.target, transition.targetIndex);
        targetPort = (0, $5Y3a5.updateTransitionPortIfRerouting)(targetPort, 'target', transition, reroutingTransition);
        const labelPlacement = (0, $5VqRQ.getLabelPlacement)(transition.id, transitionLabelPlacementsNew);
        if (sourcePort && targetPort) {
            const { path: path, labelPosition: labelPosition } = (0, $4zxGr.manhattanPathAndLabelPosition)(sourcePort, targetPort, {
                fractionOfPath: labelPlacement,
                endsPadding: 0.25
            });
            return {
                ...transition,
                ...transitionFlags,
                sourcePort: sourcePort,
                targetPort: targetPort,
                path: path,
                labelPosition: labelPosition
            };
        }
        return {
            ...transition,
            ...transitionFlags,
            sourcePort: sourcePort,
            targetPort: targetPort,
            path: undefined,
            labelPosition: undefined
        };
    });
    return statefulTransitions;
};

});
parcelRegister("4zxGr", function(module, exports) {

$parcel$export(module.exports, "manhattanPathAndLabelPosition", () => $53df24428791c4a0$export$ae89ccf025923e8);
/* eslint-disable no-param-reassign */ 
var $2f1HK = parcelRequire("2f1HK");

var $gn7EO = parcelRequire("gn7EO");

var $9VjvI = parcelRequire("9VjvI");

var $hRzTq = parcelRequire("hRzTq");

var $ieuUA = parcelRequire("ieuUA");
/**
 * To prevent routing getting stuck in an infinite loop for whatever reason, we only perform this many iterations of each step.
 */ const $53df24428791c4a0$var$MAX_ITERATIONS = 4;
const $53df24428791c4a0$var$analyzeVectors = (subject, other)=>{
    const doesSubjectFaceOther = (0, $ieuUA.inFrontOf)(subject, other);
    const doesOtherFaceSubject = (0, $ieuUA.inFrontOf)(other, subject);
    const subjectAxis = (0, $hRzTq.axisOf)(subject);
    const otherAxis = (0, $hRzTq.axisOf)(other);
    const distanceBetween = (0, $ieuUA.distanceAll)((0, $hRzTq.extractPoint)(subject), (0, $hRzTq.extractPoint)(other));
    const isFacingEachOtherOnSameLine = doesSubjectFaceOther && doesOtherFaceSubject && (0, $ieuUA.hasSharedAxis)(subject, other);
    const isFacingEachOtherInParallel = doesSubjectFaceOther && doesOtherFaceSubject && subjectAxis === otherAxis;
    return {
        doesSubjectFaceOther: doesSubjectFaceOther,
        doesOtherFaceSubject: doesOtherFaceSubject,
        distanceBetween: distanceBetween,
        subjectAxis: subjectAxis,
        otherAxis: otherAxis,
        isFacingEachOtherOnSameLine: isFacingEachOtherOnSameLine,
        isFacingEachOtherInParallel: isFacingEachOtherInParallel
    };
};
/**
 * Performs a step in the manhattan routing given a 'subject' vector and 'other' vector to go towards.
 *
 * Logic is as follows
 * 1. if both facing each 'other' on same line, they can meet
 * 2. otherwise if both facing each 'other' but in parallel, they walk half way on that axis
 * 3. otherwise if subject faces 'other', move subject closest to 'other' in one axis
 * 4. otherwise subject has to turn towards 'other'
 *
 * See the [visualization of the steps](https://hello.atlassian.net/wiki/spaces/HELIX/pages/2821877619/Manhattan+Algorithm+-+React+Workflow+Diagram) for more info
 * @param subject the current 'subject' vector being considered
 * @param other the other vector (i.e. not the 'subject')
 * @returns
 */ function $53df24428791c4a0$var$mutativelyPlotTo(subject, other) {
    const { doesSubjectFaceOther: doesSubjectFaceOther, doesOtherFaceSubject: doesOtherFaceSubject, subjectAxis: subjectAxis, otherAxis: otherAxis, isFacingEachOtherOnSameLine: isFacingEachOtherOnSameLine, isFacingEachOtherInParallel: isFacingEachOtherInParallel } = $53df24428791c4a0$var$analyzeVectors(subject, other);
    // subject →      ← other
    if (isFacingEachOtherOnSameLine) {
        subject[otherAxis] = other[otherAxis];
        return (0, $hRzTq.extractPoint)(subject);
    }
    // subject →
    //            ← other
    if (isFacingEachOtherInParallel) {
        const middle = (other[otherAxis] - subject[subjectAxis]) / 2;
        const updatedSubject = (0, $ieuUA.displace)(subject, middle);
        subject.x = updatedSubject.x;
        subject.y = updatedSubject.y;
        const updatedOther = (0, $ieuUA.displace)(other, middle);
        other.x = updatedOther.x;
        other.y = updatedOther.y;
        return undefined;
    }
    // subject →
    //             •
    //           other
    if (doesSubjectFaceOther) {
        // subject →
        //           other
        //             ↓
        if (!doesOtherFaceSubject) return undefined;
        // subject →
        //             ↑
        //           other
        subject[subjectAxis] = other[subjectAxis];
        return (0, $hRzTq.extractPoint)(subject);
    }
    // ← subject
    //             •
    //           other
    const direction = (0, $ieuUA.turnDirection)(subject, other);
    if (!direction) return undefined;
    subject.direction = direction;
    return (0, $hRzTq.extractPoint)(subject);
}
function $53df24428791c4a0$export$17b864d0fee42306(start, end) {
    const alice = start;
    const fiona = end;
    // points starting at `start` and continuing to middle
    const leadingPoints = [
        (0, $hRzTq.extractPoint)(alice)
    ];
    // points starting at middle and ending at `end`
    const trailingPoints = [
        (0, $hRzTq.extractPoint)(fiona)
    ];
    // keep moving until both meet, but break after MAX_ITERATIONS
    // times to avoid infinite loop
    for(let i = 0; i < $53df24428791c4a0$var$MAX_ITERATIONS; i += 1){
        if ((0, $ieuUA.coincides)(alice, fiona)) break;
        const leadingPoint = $53df24428791c4a0$var$mutativelyPlotTo(alice, fiona);
        if (leadingPoint) leadingPoints.push(leadingPoint);
        const trailingPoint = $53df24428791c4a0$var$mutativelyPlotTo(fiona, alice);
        if (trailingPoint) trailingPoints.unshift(trailingPoint);
    }
    return [
        ...leadingPoints,
        ...trailingPoints
    ];
}
const $53df24428791c4a0$var$interpolate = (min, max, ratio)=>min + ratio * (max - min);
const $53df24428791c4a0$export$d14d80f7b2661b77 = (start, end)=>{
    const { isFacingEachOtherInParallel: isFacingEachOtherInParallel, distanceBetween: distanceBetween } = $53df24428791c4a0$var$analyzeVectors(start, end);
    // Move away from ports
    const a = (0, $ieuUA.displace)(start, (0, $gn7EO.ARROW_PORT_OFFSET));
    const f = (0, $ieuUA.displace)(end, (0, $gn7EO.ARROW_PORT_OFFSET));
    // Move a further 'padding' distance away depending on distance between points
    let padding = (0, $ieuUA.CONNECTION_ENDS_PADDING);
    if (isFacingEachOtherInParallel) {
        const ratio = (0, (/*@__PURE__*/$parcel$interopDefault($2f1HK)))(distanceBetween, 0, 100) / 100;
        padding = $53df24428791c4a0$var$interpolate(0, (0, $ieuUA.CONNECTION_ENDS_PADDING), ratio);
    }
    const b = (0, $ieuUA.displace)(a, padding);
    const e = (0, $ieuUA.displace)(f, padding);
    return [
        a,
        ...$53df24428791c4a0$export$17b864d0fee42306(b, e),
        f
    ];
};
const $53df24428791c4a0$export$4b8d4fb9b6922cc = (path, fractionOfPath = 0.5, padding = 0.2)=>{
    const totalDistance = (0, $ieuUA.distanceAll)(...path);
    const normalisedLabelPositionBias = fractionOfPath * (1 - padding * 2) + padding;
    return (0, $ieuUA.pointOnPathByDistance)(path, totalDistance * normalisedLabelPositionBias);
};
const $53df24428791c4a0$export$ae89ccf025923e8 = (startPort, endPort, labelPositionOptions = {
    fractionOfPath: 0.5,
    endsPadding: 0.2
})=>{
    const start = (0, $ieuUA.portIndexToVector)(startPort);
    const end = (0, $ieuUA.portIndexToVector)(endPort);
    const points = $53df24428791c4a0$export$d14d80f7b2661b77(start, end);
    let labelPosition = (0, $hRzTq.extractPoint)(start);
    if (!('skipLabelPosition' in labelPositionOptions)) labelPosition = $53df24428791c4a0$export$4b8d4fb9b6922cc(points, labelPositionOptions.fractionOfPath, labelPositionOptions.endsPadding);
    const [firstPoint, ...restOfPoints] = points;
    const path = (0, $9VjvI.combinePath)((0, $9VjvI.move)(firstPoint), ...restOfPoints.map((point)=>(0, $9VjvI.line)(point)));
    return {
        path: /**
		 * SVG path data of the final route
		 */ path,
        labelPosition: /**
		 * Point on the route that would be a transition label's center given `labelPositionOptions`. If none provided, returns the midpoint.
		 */ labelPosition
    };
};

});
parcelRegister("hRzTq", function(module, exports) {

$parcel$export(module.exports, "Axis", () => $da1aaafe1b5989f6$export$d06866a9fb0606da);
$parcel$export(module.exports, "Direction", () => $da1aaafe1b5989f6$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "extractPoint", () => $da1aaafe1b5989f6$export$4717e065ef5ccb62);
$parcel$export(module.exports, "axisOf", () => $da1aaafe1b5989f6$export$1e719f8c82cad46f);
var $da1aaafe1b5989f6$export$d06866a9fb0606da = /*#__PURE__*/ function(Axis) {
    /** Horizontal axis spanning left and right */ Axis["x"] = "x";
    /** Vertical axis spanning top and bottom */ Axis["y"] = "y";
    return Axis;
}({});
var $da1aaafe1b5989f6$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    /** Points ↑ indicating negative Y value */ Direction["up"] = "up";
    /** Points ↓ indicating positive Y value */ Direction["down"] = "down";
    /** Points ← indicating negative X value */ Direction["left"] = "left";
    /** Points → indicating positive X value */ Direction["right"] = "right";
    return Direction;
}({});
const $da1aaafe1b5989f6$export$4717e065ef5ccb62 = ({ x: x, y: y })=>({
        x: x,
        y: y
    });
const $da1aaafe1b5989f6$export$1e719f8c82cad46f = (vector)=>{
    switch(vector.direction){
        case "up":
            return "y";
        case "down":
            return "y";
        case "left":
            return "x";
        default:
            return "x";
    }
};

});

parcelRegister("ieuUA", function(module, exports) {

$parcel$export(module.exports, "CONNECTION_ENDS_PADDING", () => $ad7a06036779054c$export$6ace81a7dc830449);
$parcel$export(module.exports, "coincides", () => $ad7a06036779054c$export$e4f16d0d9cf560c0);
$parcel$export(module.exports, "displace", () => $ad7a06036779054c$export$cc68d5a7d2892656);
$parcel$export(module.exports, "portIndexToVector", () => $ad7a06036779054c$export$195ba35ec30e4539);
$parcel$export(module.exports, "inFrontOf", () => $ad7a06036779054c$export$5bd4d41460c34242);
$parcel$export(module.exports, "turnDirection", () => $ad7a06036779054c$export$f58f386b5545b3f5);
$parcel$export(module.exports, "hasSharedAxis", () => $ad7a06036779054c$export$c20988d716f90868);
$parcel$export(module.exports, "distanceAll", () => $ad7a06036779054c$export$c380aff58b95f144);
$parcel$export(module.exports, "pointOnPathByDistance", () => $ad7a06036779054c$export$58edb8b4e32a1277);

var $jCNJE = parcelRequire("jCNJE");

var $lJ60K = parcelRequire("lJ60K");

var $gJeI4 = parcelRequire("gJeI4");

var $hRzTq = parcelRequire("hRzTq");
const $ad7a06036779054c$export$6ace81a7dc830449 = 20;
const $ad7a06036779054c$export$bc86dfbf7795668c = (a, b)=>{
    if ($ad7a06036779054c$export$e4f16d0d9cf560c0(a, b)) return (0, $hRzTq.extractPoint)(a);
    if (a.direction === (0, $hRzTq.Direction).up || a.direction === (0, $hRzTq.Direction).down) return (0, $jCNJE.toPoint)(a.x, b.y);
    if (b.direction === (0, $hRzTq.Direction).up || b.direction === (0, $hRzTq.Direction).down) return (0, $jCNJE.toPoint)(b.x, a.y);
    return undefined;
};
const $ad7a06036779054c$export$cc68d5a7d2892656 = (vector, amount)=>{
    switch(vector.direction){
        case (0, $hRzTq.Direction).up:
            return {
                ...vector,
                y: vector.y - amount
            };
        case (0, $hRzTq.Direction).down:
            return {
                ...vector,
                y: vector.y + amount
            };
        case (0, $hRzTq.Direction).left:
            return {
                ...vector,
                x: vector.x - amount
            };
        case (0, $hRzTq.Direction).right:
            return {
                ...vector,
                x: vector.x + amount
            };
        default:
            return vector;
    }
};
const $ad7a06036779054c$export$57e795267c26e600 = (original, { direction: direction, x: x, y: y })=>{
    // eslint-disable-next-line no-param-reassign
    original.direction = direction;
    // eslint-disable-next-line no-param-reassign
    original.x = x;
    // eslint-disable-next-line no-param-reassign
    original.y = y;
};
const $ad7a06036779054c$export$798c8192f05c1676 = (vector, other)=>{
    const vectorAxis = (0, $hRzTq.axisOf)(vector);
    const otherAxis = (0, $hRzTq.axisOf)(other);
    if (vectorAxis === (0, $hRzTq.Axis).y && otherAxis === (0, $hRzTq.Axis).y) return (0, $hRzTq.Axis).y;
    if (vectorAxis === (0, $hRzTq.Axis).x && otherAxis === (0, $hRzTq.Axis).x) return (0, $hRzTq.Axis).x;
    // perpendicular
    return undefined;
};
const $ad7a06036779054c$export$195ba35ec30e4539 = ({ portIndex: portIndex, position: { x: x, y: y } })=>{
    switch(portIndex){
        case (0, $jCNJE.PortIndex).TopLeft:
        case (0, $jCNJE.PortIndex).Top:
        case (0, $jCNJE.PortIndex).TopRight:
            return {
                x: x,
                y: y,
                direction: (0, $hRzTq.Direction).up
            };
        case (0, $jCNJE.PortIndex).BottomLeft:
        case (0, $jCNJE.PortIndex).Bottom:
        case (0, $jCNJE.PortIndex).BottomRight:
            return {
                x: x,
                y: y,
                direction: (0, $hRzTq.Direction).down
            };
        case (0, $jCNJE.PortIndex).Right:
            return {
                x: x,
                y: y,
                direction: (0, $hRzTq.Direction).right
            };
        default:
            return {
                x: x,
                y: y,
                direction: (0, $hRzTq.Direction).left
            };
    }
};
const $ad7a06036779054c$export$5bd4d41460c34242 = (vector, other)=>{
    switch(vector.direction){
        case (0, $hRzTq.Direction).up:
            return other.y < vector.y;
        case (0, $hRzTq.Direction).down:
            return other.y > vector.y;
        case (0, $hRzTq.Direction).left:
            return other.x < vector.x;
        case (0, $hRzTq.Direction).right:
            return other.x > vector.x;
        default:
            return false;
    }
};
const $ad7a06036779054c$export$e4f16d0d9cf560c0 = (point, other)=>point.x === other.x && point.y === other.y;
const $ad7a06036779054c$export$f58f386b5545b3f5 = (vector, point)=>{
    const dx = point.x - vector.x;
    const dy = point.y - vector.y;
    if (dx === 0 && dy === 0) return undefined;
    if ((0, $hRzTq.axisOf)(vector) === (0, $hRzTq.Axis).y) {
        if (dx < 0) return (0, $hRzTq.Direction).left;
        if (dx > 0) return (0, $hRzTq.Direction).right;
        if (dy > 0) return (0, $hRzTq.Direction).down;
        if (dy < 0) return (0, $hRzTq.Direction).up;
        // must be in front, don't turn
        return vector.direction;
    }
    if ((0, $hRzTq.axisOf)(vector) === (0, $hRzTq.Axis).x) {
        if (dy < 0) return (0, $hRzTq.Direction).up;
        if (dy > 0) return (0, $hRzTq.Direction).down;
        if (dx > 0) return (0, $hRzTq.Direction).right;
        if (dx < 0) return (0, $hRzTq.Direction).left;
        // must be in front, don't turn
        return vector.direction;
    }
    return undefined;
};
const $ad7a06036779054c$export$c20988d716f90868 = (subject, other)=>subject.x === other.x || subject.y === other.y;
const $ad7a06036779054c$export$c380aff58b95f144 = (...points)=>{
    const [firstPoint, ...remainingPoints] = points;
    let total = 0;
    remainingPoints.reduce((prev, curr)=>{
        total += (0, $lJ60K.distance)(prev, curr);
        return curr;
    }, firstPoint);
    return total;
};
const $ad7a06036779054c$export$58edb8b4e32a1277 = (points, stopAtDistance)=>{
    if (points.length === 0) {
        (0, $gJeI4.fireError)('Unexepcted empty points array. Cannot determine point on path.', 'manhattan-routing.point-on-path-by-distance');
        return (0, $jCNJE.toPoint)(0, 0);
    }
    let distanceTravelled = 0;
    for(let i = 1; i < points.length; i += 1){
        const prev = points[i - 1];
        const curr = points[i];
        const segmentLength = (0, $lJ60K.distance)(prev, curr);
        distanceTravelled += segmentLength;
        if (distanceTravelled >= stopAtDistance) {
            const perc = (distanceTravelled - stopAtDistance) / segmentLength;
            return (0, $lJ60K.add)(curr, (0, $lJ60K.multiply)((0, $lJ60K.subtract)(prev, curr), perc));
        }
    }
    const endPoint = points[points.length - 1];
    return endPoint;
};

});


parcelRegister("S2Jmq", function(module, exports) {

$parcel$export(module.exports, "calculateOverlappingLabelPlacement", () => $909f6f35d394009b$export$97ec3454f8ebbeff);

var $jFHCE = parcelRequire("jFHCE");

var $jCNJE = parcelRequire("jCNJE");

var $5Y3a5 = parcelRequire("5Y3a5");

var $5VqRQ = parcelRequire("5VqRQ");
const $909f6f35d394009b$export$97ec3454f8ebbeff = (transitions)=>{
    const groupedByOverlapKey = new Map();
    // group transitions by 'overlap key' which is a string comparable represenation of overlap criteria
    transitions.forEach((transition)=>{
        if (!(0, $5Y3a5.isDirectOrSharedTransitionWithDefinedPorts)(transition)) return;
        const isSharedTransition = transition.type === 'shared';
        if (isSharedTransition) transition.links.forEach((link, linkIndex)=>{
            const startPortKey = (0, $jCNJE.toPortKey)(link.source, link.sourceIndex);
            const endPortKey = (0, $jCNJE.toPortKey)(transition.target, link.targetIndex);
            const { overlapKey: overlapKey, isReversed: isReversed } = (0, $5VqRQ.overlapKeyByPorts)(startPortKey, endPortKey);
            (0, $5VqRQ.addToOverlapsGroup)(groupedByOverlapKey, overlapKey, {
                type: 'shared-transition',
                transitionId: transition.id,
                linkIndex: linkIndex,
                isReversed: isReversed
            });
        });
        else if (transition.type === 'direct') {
            const startPortKey = (0, $jCNJE.toPortKey)(transition.source, transition.sourceIndex);
            const endPortKey = (0, $jCNJE.toPortKey)(transition.target, transition.targetIndex);
            const { overlapKey: overlapKey, isReversed: isReversed } = (0, $5VqRQ.overlapKeyByPorts)(startPortKey, endPortKey);
            (0, $5VqRQ.addToOverlapsGroup)(groupedByOverlapKey, overlapKey, {
                type: 'direct-transition',
                transitionId: transition.id,
                isReversed: isReversed
            });
        }
    // }
    }, {});
    const result = [];
    // calculate placements for each transition in a group while considering if reversed
    groupedByOverlapKey.forEach((overlaps, overlapKey)=>{
        overlaps.forEach((overlap, position)=>{
            // by definition a single item in a group has no overlaps, hence '- 1'
            // we only care about overlaps so we ignore all non-overlapping transitions
            const totalOverlapping = overlaps.length - 1;
            if (totalOverlapping === 0) return;
            let placement = position / totalOverlapping;
            if ('isReversed' in overlap && overlap.isReversed) // place transition label in the opposite direction
            placement = 1 - placement;
            result.push({
                ...(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(overlap, 'isReversed'),
                placement: placement,
                overlapKey: overlapKey
            });
        });
    });
    return result;
};

});
parcelRegister("5VqRQ", function(module, exports) {

$parcel$export(module.exports, "addToOverlapsGroup", () => $df95562842abdf69$export$b4b1c9fe32f0e076);
$parcel$export(module.exports, "overlapKeyByPorts", () => $df95562842abdf69$export$dad46676c954236b);
$parcel$export(module.exports, "getLabelPlacement", () => $df95562842abdf69$export$330bb965f61fa4fe);
/** A string key used to group transitions by a overlap criteria depending on the type of transition */ const $df95562842abdf69$export$87f647dcd0870d73 = 0.5;
function $df95562842abdf69$export$b4b1c9fe32f0e076(overlaps, overlapKey, overlapItem) {
    const previousValue = overlaps.get(overlapKey) ?? [];
    if ('isReversed' in overlapItem && overlapItem.isReversed) overlaps.set(overlapKey, [
        overlapItem,
        ...previousValue
    ]);
    else overlaps.set(overlapKey, [
        ...previousValue,
        overlapItem
    ]);
}
function $df95562842abdf69$export$dad46676c954236b(startPortKey, endPortKey) {
    // start and end port key order is ignored to determine if route between two ports is overlapping
    // however we need to if its reversed or not, to do a cheap order-insensitive check for overlaps
    // we can simply use a string alphabetic comparison
    const isReversed = startPortKey > endPortKey;
    return {
        overlapKey: isReversed ? $df95562842abdf69$export$9776532a71c8b981('by-ports', endPortKey, startPortKey) : $df95562842abdf69$export$9776532a71c8b981('by-ports', startPortKey, endPortKey),
        isReversed: isReversed
    };
}
function $df95562842abdf69$export$9776532a71c8b981(...strings) {
    return `overlap[${strings.join(';')}]`;
}
function $df95562842abdf69$export$330bb965f61fa4fe(transitionId, transitionLabelPlacements, /** Additionally filter on linkIndex for shared transitions */ linkIndex) {
    const match = transitionLabelPlacements.find((x)=>{
        if (x.transitionId !== transitionId) return false;
        if ('linkIndex' in x && x.linkIndex !== linkIndex) return false;
        return true;
    });
    return match?.placement ?? $df95562842abdf69$export$87f647dcd0870d73;
}

});


parcelRegister("3O7Ee", function(module, exports) {

$parcel$export(module.exports, "getSharedTransitionLayout", () => $d0a327913bcb5815$export$a13185bc8db9ec97);

var $jCNJE = parcelRequire("jCNJE");

var $5Y3a5 = parcelRequire("5Y3a5");

var $4zxGr = parcelRequire("4zxGr");

var $5VqRQ = parcelRequire("5VqRQ");
const $d0a327913bcb5815$export$4194cab44e4dd0f2 = 0.6;
const $d0a327913bcb5815$export$d1d8ca5010332ec1 = 80;
const $d0a327913bcb5815$export$dd2963ab5ca60569 = (port)=>{
    const newPosition = {
        ...port.position
    };
    switch(port.portIndex){
        case (0, $jCNJE.PortIndex).TopLeft:
        case (0, $jCNJE.PortIndex).Top:
        case (0, $jCNJE.PortIndex).TopRight:
            newPosition.y = port.position.y - $d0a327913bcb5815$export$d1d8ca5010332ec1;
            break;
        case (0, $jCNJE.PortIndex).Right:
            newPosition.x = port.position.x + $d0a327913bcb5815$export$d1d8ca5010332ec1;
            break;
        case (0, $jCNJE.PortIndex).BottomRight:
        case (0, $jCNJE.PortIndex).Bottom:
        case (0, $jCNJE.PortIndex).BottomLeft:
            newPosition.y = port.position.y + $d0a327913bcb5815$export$d1d8ca5010332ec1;
            break;
        // case PortIndex.Left
        default:
            newPosition.x = port.position.x - $d0a327913bcb5815$export$d1d8ca5010332ec1;
            break;
    }
    return {
        position: newPosition,
        portIndex: port.portIndex
    };
};
const $d0a327913bcb5815$export$a13185bc8db9ec97 = (transition, ports, transitionLabelPlacements, reroutingTransition)=>{
    const emptyLayout = {
        connections: undefined
    };
    if (transition.links.length === 0 || !(0, $5Y3a5.isEveryPropertyDefined)(transition.links, 'sourceIndex', 'targetIndex')) return emptyLayout;
    const connections = [];
    let didAlreadyMoveTargetPort = false;
    let linkIndex = 0;
    for (const link of transition.links){
        const source = link.source;
        const sourceIndex = link.sourceIndex;
        const targetIndex = link.targetIndex;
        let sourcePort = (0, $5Y3a5.findPort)(ports, source, sourceIndex);
        const isSourcePortMoving = (0, $5Y3a5.isPortMovingForReroutingTransition)(sourcePort, 'source', transition.id, reroutingTransition);
        if (!sourcePort) return emptyLayout;
        if (isSourcePortMoving) sourcePort = {
            ...sourcePort,
            position: reroutingTransition.currentPosition
        };
        let targetPort = (0, $5Y3a5.findPort)(ports, transition.target, targetIndex);
        if (!targetPort) return emptyLayout;
        const isTargetPortMoving = (0, $5Y3a5.isPortMovingForReroutingTransition)(targetPort, 'target', transition.id, reroutingTransition);
        // if there are multiple links touching the same port, we only move the first one
        if (isTargetPortMoving && !didAlreadyMoveTargetPort) {
            targetPort = {
                ...targetPort,
                position: reroutingTransition.currentPosition
            };
            didAlreadyMoveTargetPort = true;
        }
        // Paths and labels between each source and target
        const { path: path, labelPosition: labelPosition } = (0, $4zxGr.manhattanPathAndLabelPosition)(sourcePort, targetPort, {
            fractionOfPath: (0, $5VqRQ.getLabelPlacement)(transition.id, transitionLabelPlacements, linkIndex),
            endsPadding: 0.25
        });
        connections.push({
            path: path,
            sourcePort: sourcePort,
            targetPort: targetPort,
            labelPosition: labelPosition
        });
        ++linkIndex;
    }
    return {
        connections: connections
    };
};

});


parcelRegister("4Yp5F", function(module, exports) {

$parcel$export(module.exports, "useTransitionDragDrop", () => $0a648638da2f7fed$export$1acd582b1912a987);

var $eJOHy = parcelRequire("eJOHy");

var $h2zA1 = parcelRequire("h2zA1");

var $6dzi5 = parcelRequire("6dzi5");
const $0a648638da2f7fed$export$1acd582b1912a987 = ({ ports: ports, transitions: transitions, dragDropState: dragDropState, reroutingTransition: reroutingTransition, proposedTransition: proposedTransition, onTransitionCreate: onTransitionCreate, onTransitionPortChange: onTransitionPortChange, onTransitionReroutingCancel: onTransitionReroutingCancel, onTransitionProposalCancel: onTransitionProposalCancel })=>{
    const latestPorts = (0, $h2zA1.useLatest)(ports);
    const latestTransitions = (0, $h2zA1.useLatest)(transitions);
    const latestReroutingTransition = (0, $h2zA1.useLatest)(reroutingTransition);
    const latestProposedTransition = (0, $h2zA1.useLatest)(proposedTransition);
    (0, $eJOHy.useEffect)(()=>{
        if (dragDropState.isDragging) return;
        if (latestProposedTransition.current.stage === 'started') {
            // dragging ended without finishing creation of new transition
            onTransitionProposalCancel();
            return;
        }
        if (latestProposedTransition.current.stage === 'valid') {
            // dragging ended while finishing creation of new transition
            const transition = (0, $6dzi5.createTransitionFromProposed)(latestProposedTransition.current, latestPorts.current);
            onTransitionCreate?.(transition);
            onTransitionProposalCancel();
            return;
        }
        if (latestReroutingTransition.current.stage === 'started') {
            // dragging ended without finishing change of ports of existing transition
            onTransitionReroutingCancel();
            return;
        }
        if (latestReroutingTransition.current.stage === 'valid') {
            // dragging ended while finishing change of ports of existing transition
            const updatedTransition = (0, $6dzi5.updateTransitionAfterReroute)(latestReroutingTransition.current, latestPorts.current);
            onTransitionPortChange?.(updatedTransition);
            onTransitionReroutingCancel();
        }
    }, [
        onTransitionProposalCancel,
        dragDropState,
        proposedTransition,
        latestReroutingTransition,
        latestTransitions,
        onTransitionCreate,
        onTransitionPortChange,
        latestProposedTransition,
        onTransitionReroutingCancel,
        latestPorts
    ]);
};

});
parcelRegister("6dzi5", function(module, exports) {

$parcel$export(module.exports, "createTransitionFromProposed", () => $75a24d70eea8c3bb$export$175a587f328a01d2);
$parcel$export(module.exports, "updateTransitionAfterReroute", () => $75a24d70eea8c3bb$export$ea55afc0963f677b);

var $aXKmr = parcelRequire("aXKmr");
function $75a24d70eea8c3bb$export$175a587f328a01d2(validProposedTransition, ports) {
    const { startPortKey: startPortKey, endPortKey: endPortKey } = validProposedTransition;
    const startPort = ports[startPortKey];
    const endPort = ports[endPortKey];
    return {
        id: (0, $aXKmr.v4)(),
        type: 'direct',
        icons: [],
        label: '',
        source: startPort.statusId,
        sourceIndex: startPort.portIndex,
        target: endPort.statusId,
        targetIndex: endPort.portIndex
    };
}
function $75a24d70eea8c3bb$export$ea55afc0963f677b(reroutingTransition, ports) {
    const { transition: transition, side: side, originalPortKey: originalPortKey, proposedPortKey: proposedPortKey } = reroutingTransition;
    const proposedPort = ports[proposedPortKey];
    if (transition.type === 'direct') return {
        ...transition,
        [side]: proposedPort.statusId,
        [`${side}Index`]: proposedPort.portIndex
    };
    // transition.type === 'shared'
    if (side === 'source') {
        const originalPort = ports[originalPortKey];
        const updatedLinks = transition.links.map((link)=>link.source === originalPort.statusId && link.sourceIndex === originalPort.portIndex ? {
                ...link,
                source: proposedPort.statusId,
                sourceIndex: proposedPort.portIndex
            } : link);
        return {
            ...transition,
            links: updatedLinks
        };
    }
    // side === 'target'
    const originalPort = ports[originalPortKey];
    let didRerouteTarget = false;
    const updatedLinks = transition.links.map((link)=>{
        if (proposedPort.statusId !== originalPort.statusId) {
            if (link.targetIndex === originalPort.portIndex) return {
                ...link,
                targetIndex: proposedPort.portIndex
            };
            // trigger best guess
            return {
                ...link,
                targetIndex: undefined
            };
        }
        if (link.targetIndex === originalPort.portIndex && !didRerouteTarget) {
            // reroute only the first matching link
            didRerouteTarget = true;
            return {
                ...link,
                targetIndex: proposedPort.portIndex
            };
        }
        return link;
    });
    return {
        ...transition,
        target: proposedPort.statusId,
        links: updatedLinks
    };
}

});


parcelRegister("whaAa", function(module, exports) {

$parcel$export(module.exports, "useTransitionProposals", () => $3d40e99c65ba144f$export$ad7bb463e2681cc1);

var $eJOHy = parcelRequire("eJOHy");
const $3d40e99c65ba144f$export$ad7bb463e2681cc1 = ()=>{
    const [transitionProposal, setTransitionProposal] = (0, $eJOHy.useState)({
        stage: 'none'
    });
    const onTransitionProposalCancel = (0, $eJOHy.useCallback)(()=>{
        setTransitionProposal({
            stage: 'none'
        });
    }, []);
    const onTransitionProposalMove = (0, $eJOHy.useCallback)((startPortKey, line)=>{
        setTransitionProposal((prev)=>{
            if (prev.stage === 'none') return {
                ...prev,
                stage: 'started',
                startPortKey: startPortKey,
                line: line
            };
            return {
                ...prev,
                startPortKey: startPortKey,
                line: line
            };
        });
    }, []);
    const onTransitionProposalClose = (0, $eJOHy.useCallback)((endPortKey)=>{
        setTransitionProposal((prev)=>{
            if (prev.stage === 'none') return prev;
            if (endPortKey === undefined) return {
                stage: 'started',
                line: prev.line,
                startPortKey: prev.startPortKey
            };
            return {
                ...prev,
                stage: 'valid',
                endPortKey: endPortKey
            };
        });
    }, []);
    return [
        transitionProposal,
        {
            onTransitionProposalCancel: onTransitionProposalCancel,
            onTransitionProposalClose: onTransitionProposalClose,
            onTransitionProposalMove: onTransitionProposalMove
        }
    ];
};

});

parcelRegister("hiXsx", function(module, exports) {

$parcel$export(module.exports, "useTransitionRerouting", () => $7bd0b288f2451768$export$6bb143efd1a1161b);

var $eJOHy = parcelRequire("eJOHy");

var $jCNJE = parcelRequire("jCNJE");

var $5Y3a5 = parcelRequire("5Y3a5");
const $7bd0b288f2451768$var$initialState = {
    stage: 'none'
};
const $7bd0b288f2451768$export$66f9ac6aeebf5298 = ({ transition: transition, proposedPortKey: proposedPortKey, originalStatusId: originalStatusId, proposedStatusId: proposedStatusId, side: side })=>{
    if (side === 'source' && (0, $5Y3a5.isDirectOrSharedTransitionWithDefinedPorts)(transition)) {
        if (transition.type === 'shared') return transition.links.some((links)=>links.source !== originalStatusId && links.source === proposedStatusId) || proposedPortKey === (0, $jCNJE.toPortKey)(transition.target, transition.links[0].targetIndex) // TODO HIX-4369 Handle multiple targetIndices
        ;
        return proposedPortKey === (0, $jCNJE.toPortKey)(transition.target, transition.targetIndex);
    }
    if (side === 'target' && (0, $5Y3a5.isDirectOrSharedTransitionWithDefinedPorts)(transition)) {
        if (transition.type === 'shared') {
            const portKeys = transition.links.map((link)=>(0, $jCNJE.toPortKey)(link.source, link.sourceIndex));
            return portKeys.includes(proposedPortKey);
        }
        return proposedPortKey === (0, $jCNJE.toPortKey)(transition.source, transition.sourceIndex);
    }
    return false;
};
const $7bd0b288f2451768$export$6bb143efd1a1161b = ()=>{
    const [reroutingTransition, setReroutingTransition] = (0, $eJOHy.useState)($7bd0b288f2451768$var$initialState);
    const onTransitionReroutingCancel = (0, $eJOHy.useCallback)(()=>{
        setReroutingTransition({
            stage: 'none'
        });
    }, []);
    const onTransitionReroutingMove = (0, $eJOHy.useCallback)((value)=>{
        setReroutingTransition((prev)=>{
            if (prev.stage === 'none') {
                const startingState = {
                    stage: 'started',
                    ...value
                };
                return startingState;
            }
            const movingState = {
                ...prev,
                ...value
            };
            return movingState;
        });
    }, []);
    const onTransitionReroutingClose = (0, $eJOHy.useCallback)(({ proposedPortKey: proposedPortKey, proposedStatusId: proposedStatusId })=>{
        setReroutingTransition((prev)=>{
            if (prev.stage === 'none') return prev;
            if (proposedPortKey === undefined || $7bd0b288f2451768$export$66f9ac6aeebf5298({
                transition: prev.transition,
                proposedPortKey: proposedPortKey,
                proposedStatusId: proposedStatusId,
                originalStatusId: prev.originalStatusId,
                side: prev.side
            })) {
                const startingState = {
                    stage: 'started',
                    transition: prev.transition,
                    side: prev.side,
                    currentPosition: prev.currentPosition,
                    originalStatusId: prev.originalStatusId,
                    originalPortIndex: prev.originalPortIndex,
                    originalPortKey: prev.originalPortKey
                };
                return startingState;
            }
            const completedState = {
                stage: 'valid',
                transition: prev.transition,
                side: prev.side,
                currentPosition: prev.currentPosition,
                originalStatusId: prev.originalStatusId,
                originalPortIndex: prev.originalPortIndex,
                originalPortKey: prev.originalPortKey,
                proposedPortKey: proposedPortKey
            };
            return completedState;
        });
    }, []);
    return [
        reroutingTransition,
        {
            onTransitionReroutingMove: onTransitionReroutingMove,
            onTransitionReroutingClose: onTransitionReroutingClose,
            onTransitionReroutingCancel: onTransitionReroutingCancel
        }
    ];
};

});

parcelRegister("cm7e7", function(module, exports) {

$parcel$export(module.exports, "useGlobalLoopsContainer", () => $3d8a8b1fdb67c4bc$export$4c621f3f7c99f1c6);

var $v1MZY = parcelRequire("v1MZY");
const $3d8a8b1fdb67c4bc$export$4c621f3f7c99f1c6 = ({ providedGlobalLoopsContainerPosition: providedGlobalLoopsContainerPosition, defaultGlobalLoopsContainerPosition: defaultGlobalLoopsContainerPosition, targetedItem: targetedItem, draggingItem: draggingItem, movingItem: movingItem })=>{
    let position = providedGlobalLoopsContainerPosition || defaultGlobalLoopsContainerPosition;
    const isDragging = draggingItem?.type === (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE);
    const isMoving = movingItem?.type === (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE);
    const isTargeted = targetedItem?.type === (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE);
    if (isDragging) position = draggingItem.position;
    if (isMoving) position = movingItem.position;
    return {
        position: position,
        isTargeted: isTargeted,
        isDragging: isDragging,
        isMoving: isMoving
    };
};

});

parcelRegister("4bXD4", function(module, exports) {

$parcel$export(module.exports, "CanvasSvg", () => $1d8a168b555a5282$export$6801d6d4bd9b9cd4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5Y3a5 = parcelRequire("5Y3a5");

var $7tPN1 = parcelRequire("7tPN1");
const $1d8a168b555a5282$export$6801d6d4bd9b9cd4 = ({ rootSvgRef: rootSvgRef, children: children, diagramSize: diagramSize, pan: pan, zoom: zoom })=>{
    const dataAttributes = (0, $7tPN1.useDraggableDataAttributes)('pan');
    const viewBox = (0, $5Y3a5.calculateViewBox)(diagramSize, pan, zoom);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d8a168b555a5282$var$StyledSvg, {
        ref: rootSvgRef,
        ...dataAttributes,
        width: diagramSize.width,
        height: diagramSize.height,
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: `${viewBox.left} ${viewBox.top} ${viewBox.width} ${viewBox.height}`,
        preserveAspectRatio: "xMinYMin",
        "data-testid": "accessible-workflow-diagram.ui.diagram.canvas.svg-root"
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d8a168b555a5282$var$StyledSvg = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _s7n4nkob _bfhkvuon _uiztglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b6DVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d1a8c4c36faced3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $gn7EO = parcelRequire("gn7EO");

var $v1MZY = parcelRequire("v1MZY");

var $6WkqH = parcelRequire("6WkqH");

var $cbefB = parcelRequire("cbefB");
const $4d1a8c4c36faced3$var$DirectTransition = ({ id: id, flag: flag, isHighlighted: isHighlighted = false, isHovered: isHovered = false, isImmutable: isImmutable = false, isSelected: isSelected = false, end: end, start: start, path: path, onSelect: onSelect, onHover: onHover })=>{
    const stroke = (0, $cbefB.useStrokeColor)({
        flag: flag,
        isHighlighted: isHighlighted,
        isHovered: isHovered,
        isSelected: isSelected
    });
    const onGroupClick = (0, $eJOHy.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $v1MZY.EDGE_TYPE),
            id: id
        });
    }, [
        isImmutable,
        onSelect,
        id
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('hix-7062_shared_transition_show_label_highlighted')) onHover?.({
            id: id,
            type: (0, $v1MZY.EDGE_TYPE),
            connection: {
                sourcePort: start,
                targetPort: end
            }
        });
        else onHover?.({
            id: id,
            type: (0, $v1MZY.EDGE_TYPE)
        });
    }, [
        end,
        id,
        onHover,
        start
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    if (!start || !end) return null;
    if (start.portIndex === undefined || end.portIndex === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        onClick: onGroupClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "none",
        stroke: "transparent",
        d: path,
        strokeLinejoin: "round",
        strokeWidth: "15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "none",
        stroke: stroke,
        d: path,
        strokeLinejoin: "round",
        strokeWidth: (0, $gn7EO.TRANSITION_STROKE_WIDTH)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6WkqH.Arrow), {
        portIndex: end.portIndex,
        portPosition: end.position,
        stroke: stroke
    }));
};
var $4d1a8c4c36faced3$export$2e2bcd8739ae039 = $4d1a8c4c36faced3$var$DirectTransition;

});
parcelRegister("6WkqH", function(module, exports) {

$parcel$export(module.exports, "Arrow", () => $fac0787afbc902a0$export$21b07c8f274aebd5);

var $eJOHy = parcelRequire("eJOHy");

var $gn7EO = parcelRequire("gn7EO");

var $jCNJE = parcelRequire("jCNJE");

var $lJ60K = parcelRequire("lJ60K");

var $9VjvI = parcelRequire("9VjvI");

var $fiArL = parcelRequire("fiArL");
const $fac0787afbc902a0$export$21b07c8f274aebd5 = ({ stroke: stroke, portPosition: portPosition, portIndex: portIndex, portOffset: portOffset })=>{
    const unitDirection = (0, $lJ60K.invert)((0, $fiArL.toSquareUnitDirection)(portIndex));
    const tip = (0, $lJ60K.add)(portPosition, (0, $lJ60K.multiply)(unitDirection, portOffset ?? (0, $gn7EO.ARROW_PORT_OFFSET)));
    const rotation = (0, $lJ60K.unitDirectionAngle)(unitDirection);
    const leftWing = (0, $lJ60K.add)(tip, (0, $jCNJE.toPoint)(-(0, $gn7EO.ARROW_WING_LENGTH), +(0, $gn7EO.ARROW_WING_LENGTH)));
    const rightWing = (0, $lJ60K.add)(tip, (0, $jCNJE.toPoint)((0, $gn7EO.ARROW_WING_LENGTH), (0, $gn7EO.ARROW_WING_LENGTH)));
    const arrowPath = (0, $9VjvI.combinePath)((0, $9VjvI.move)(leftWing), (0, $9VjvI.line)(tip), (0, $9VjvI.line)(rightWing));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "none",
        stroke: stroke,
        d: arrowPath,
        strokeWidth: "2",
        transform: `rotate(${-rotation} ${tip.x} ${tip.y})`
    });
};

});


parcelRegister("lRP7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7dd933fd06cb75$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bnAAH = parcelRequire("bnAAH");

var $4cZ7b = parcelRequire("4cZ7b");

var $7tPN1 = parcelRequire("7tPN1");

var $4fWCz = parcelRequire("4fWCz");

var $gn7EO = parcelRequire("gn7EO");

var $hyRwo = parcelRequire("hyRwo");
const $da7dd933fd06cb75$var$OUTLINE_PADDING = 3;
const $da7dd933fd06cb75$var$FOCUS_RING_WIDTH = 4;
const $da7dd933fd06cb75$var$ARROW_PADDING = $da7dd933fd06cb75$var$OUTLINE_PADDING + $da7dd933fd06cb75$var$FOCUS_RING_WIDTH + (0, $4fWCz.ARROW_RADIUS);
const $da7dd933fd06cb75$export$108a2aec753e2c50 = ({ position: position, isMoving: isMoving, isTargeted: isTargeted, transitions: transitions, isImmutable: isImmutable, onSelect: onSelect, onHover: onHover })=>{
    const dataAttributes = (0, $7tPN1.useDraggableDataAttributes)('global-loops-container', 'global-loops-container');
    const containerHeight = (0, $hyRwo.getContainerHeight)(transitions.length);
    if (transitions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        "data-testid": "accessible-workflow-diagram.ui.diagram.global-loops-container",
        ...dataAttributes
    }, isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: position.x - $da7dd933fd06cb75$var$OUTLINE_PADDING - $da7dd933fd06cb75$var$FOCUS_RING_WIDTH / 4,
        y: position.y - $da7dd933fd06cb75$var$OUTLINE_PADDING - $da7dd933fd06cb75$var$FOCUS_RING_WIDTH / 4,
        width: (0, $hyRwo.CONTAINER_WIDTH) + $da7dd933fd06cb75$var$OUTLINE_PADDING * 2 + $da7dd933fd06cb75$var$FOCUS_RING_WIDTH / 2,
        height: containerHeight + $da7dd933fd06cb75$var$OUTLINE_PADDING * 2 + $da7dd933fd06cb75$var$FOCUS_RING_WIDTH / 2,
        rx: "3.5",
        ry: "3.5",
        stroke: (0, $gn7EO.STATE_COLOURS).focused,
        fillOpacity: "0",
        strokeWidth: $da7dd933fd06cb75$var$FOCUS_RING_WIDTH
    }), isMoving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: position.x + (0, $hyRwo.CONTAINER_WIDTH) / 2,
        y: position.y - $da7dd933fd06cb75$var$ARROW_PADDING,
        direction: "up"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: position.x + (0, $hyRwo.CONTAINER_WIDTH) / 2,
        y: position.y + containerHeight + $da7dd933fd06cb75$var$ARROW_PADDING,
        direction: "down"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: position.x - $da7dd933fd06cb75$var$ARROW_PADDING,
        y: position.y + containerHeight / 2,
        direction: "left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: position.x + (0, $hyRwo.CONTAINER_WIDTH) + $da7dd933fd06cb75$var$ARROW_PADDING,
        y: position.y + containerHeight / 2,
        direction: "right"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: position.x,
        y: position.y,
        width: (0, $hyRwo.CONTAINER_WIDTH),
        height: containerHeight,
        rx: "3.5",
        fill: "var(--ds-surface, #FFFFFF)",
        fillOpacity: "0.8",
        stroke: "var(--ds-border, #091E4224)",
        cursor: isImmutable ? undefined : 'move'
    }), transitions.map((transition, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bnAAH.GlobalLoopedTransition), {
            id: transition.id,
            key: transition.id,
            position: (0, $hyRwo.getGlobalLoopTransitionPosition)(position, index),
            label: transition.label,
            flag: transition.flag,
            isHovered: transition.isHovered,
            isImmutable: isImmutable,
            isSelected: transition.isSelected,
            isTargeted: transition.isTargeted,
            onSelect: onSelect,
            onHover: onHover,
            icons: (0, $4cZ7b.applyTransitionIconConditions)(transition.icons, undefined)
        })));
};
var $da7dd933fd06cb75$export$2e2bcd8739ae039 = $da7dd933fd06cb75$export$108a2aec753e2c50;

});
parcelRegister("bnAAH", function(module, exports) {

$parcel$export(module.exports, "GlobalLoopedTransition", () => $ff47e8769661b801$export$b5d79cea29b5d080);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $gn7EO = parcelRequire("gn7EO");

var $v1MZY = parcelRequire("v1MZY");

var $jCNJE = parcelRequire("jCNJE");

var $6WkqH = parcelRequire("6WkqH");

var $dq7yG = parcelRequire("dq7yG");

var $5Y3a5 = parcelRequire("5Y3a5");

var $cbefB = parcelRequire("cbefB");

var $hyRwo = parcelRequire("hyRwo");

var $dGyc2 = parcelRequire("dGyc2");
const $ff47e8769661b801$export$74f370493ac84dd3 = 13; // as per Workflow Designer
const $ff47e8769661b801$export$b5d79cea29b5d080 = ({ id: id, flag: flag, isHovered: isHovered = false, isImmutable: isImmutable, position: containerPosition, isSelected: isSelected = false, isTargeted: isTargeted = false, label: label, onSelect: onSelect, onHover: onHover, icons: icons = [] })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const stroke = (0, $cbefB.useStrokeColor)({
        flag: flag,
        isHighlighted: false,
        isSelected: isSelected,
        isHovered: isHovered
    });
    const [textRef, setTextRef] = (0, $eJOHy.useState)(null);
    const lozengeText = (0, $5Y3a5.truncateLabel)(formatMessage((0, $dGyc2.default).anyLozengeTextNonFinal));
    const textWidth = textRef?.getBBox?.().width || 0;
    const lozengeWidth = (0, $hyRwo.getLozengeWidth)(textWidth);
    const onGroupClick = (0, $eJOHy.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $v1MZY.EDGE_TYPE),
            id: id
        });
    }, [
        id,
        isImmutable,
        onSelect
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        onHover?.({
            id: id,
            type: (0, $v1MZY.EDGE_TYPE)
        });
    }, [
        id,
        onHover
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    const onTextRef = (0, $eJOHy.useCallback)((ref)=>{
        if (ref) setTextRef(ref);
    }, []);
    if (!containerPosition) return null;
    const lozengePosition = (0, $hyRwo.getLozengePosition)(containerPosition);
    const lozengeTextPosition = (0, $hyRwo.getLozengeTextPosition)(lozengePosition, lozengeWidth);
    const path = (0, $hyRwo.globalLoopedTransitionRoute)(lozengePosition, lozengeWidth);
    const arrowPosition = (0, $hyRwo.getArrowPosition)(lozengePosition, lozengeWidth);
    const labelPosition = (0, $hyRwo.getLabelPosition)(containerPosition);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        onClick: onGroupClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.ui.diagram.global-looped-transition.interactable-path",
        fill: "none",
        stroke: "transparent",
        d: path,
        strokeWidth: "15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "data-testid": "accessible-workflow-diagram.ui.diagram.global-looped-transition.visible-path",
        fill: "none",
        stroke: stroke,
        strokeLinejoin: "round",
        d: path,
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6WkqH.Arrow), {
        portPosition: arrowPosition,
        stroke: stroke,
        portIndex: (0, $jCNJE.PortIndex).Top,
        portOffset: (0, $gn7EO.PORT_RADIUS)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        ...lozengePosition,
        width: lozengeWidth,
        height: (0, $hyRwo.LOZENGE_HEIGHT),
        rx: (0, $hyRwo.LOZENGE_BORDER_RADIUS),
        ry: (0, $hyRwo.LOZENGE_BORDER_RADIUS),
        fill: "var(--ds-background-neutral-bold, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("text", {
        ...lozengeTextPosition,
        ref: onTextRef,
        textAnchor: "middle",
        fontSize: "11px",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tspan", null, lozengeText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dq7yG.default), {
        id: id,
        position: labelPosition,
        label: label,
        flag: flag,
        icons: icons,
        isTargeted: isTargeted,
        isSelected: isSelected,
        isHovered: isHovered,
        isImmutable: isImmutable,
        maxLabelLength: $ff47e8769661b801$export$74f370493ac84dd3,
        onSelect: onSelect
    }));
};

});
parcelRegister("dGyc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b75f19fc150eceb4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b75f19fc150eceb4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    anyLozengeTextNonFinal: {
        "id": "accessible-workflow-diagram.diagram.global-loop-transition.any-lozenge-text-non-final",
        "defaultMessage": "Any"
    }
});

});


parcelRegister("4fWCz", function(module, exports) {

$parcel$export(module.exports, "ARROW_RADIUS", () => $16dc3005c1175509$export$fa53c1d9d4c86cc2);
$parcel$export(module.exports, "default", () => $16dc3005c1175509$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $16dc3005c1175509$var$ROTATIONS = {
    up: 0,
    right: 90,
    down: 180,
    left: 270
};
const $16dc3005c1175509$export$fa53c1d9d4c86cc2 = 8;
const $16dc3005c1175509$var$MoveArrow = ({ x: x, y: y, direction: direction })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        x: x - $16dc3005c1175509$export$fa53c1d9d4c86cc2,
        y: y - $16dc3005c1175509$export$fa53c1d9d4c86cc2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: $16dc3005c1175509$export$fa53c1d9d4c86cc2,
        cy: $16dc3005c1175509$export$fa53c1d9d4c86cc2,
        r: $16dc3005c1175509$export$fa53c1d9d4c86cc2,
        fill: "var(--ds-surface, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.61317 8.79009C5.22098 9.09525 4.65374 9.06771 4.29313 8.70735C3.90248 8.31696 3.90226 7.68379 4.29265 7.29313L7.29061 4.29313L7.38478 4.20991C7.40593 4.19346 7.42759 4.17797 7.45041 4.16443C7.45646 4.16044 7.46257 4.15651 7.46788 4.15179C7.49043 4.13766 7.51343 4.12453 7.5368 4.11352C7.54775 4.10778 7.55883 4.10224 7.57017 4.09582C7.59257 4.08522 7.61528 4.0755 7.6381 4.06749C7.65076 4.06258 7.66354 4.05791 7.67639 4.05288C7.69947 4.04506 7.72278 4.03811 7.74628 4.03247C7.76084 4.02866 7.77552 4.02518 7.7901 4.02172C7.81167 4.01716 7.83337 4.01331 7.85506 4.01043C7.87192 4.00798 7.8889 4.00595 7.90635 4.00418C7.93138 4.00189 7.95648 4.00054 7.98082 4.00018L8 4C8.05202 4 8.10311 4.00397 8.15227 4.01191C8.16598 4.01404 8.17966 4.01645 8.19387 4.01878C8.2213 4.02417 8.24832 4.03068 8.27458 4.03883C8.2833 4.04133 8.29199 4.04395 8.30085 4.04605C8.3292 4.05498 8.35701 4.06514 8.38384 4.07717C8.39319 4.08108 8.4025 4.08513 8.41222 4.08865C8.5338 4.14373 8.64241 4.22242 8.73218 4.31888L11.7069 7.29265L11.7901 7.38683C12.0952 7.77902 12.0677 8.34626 11.7073 8.70687L11.6132 8.79009C11.221 9.09525 10.6537 9.06771 10.2931 8.70735L9 7.415L9 12C9 12.5523 8.55228 13 8 13C7.48716 13 7.06449 12.614 7.00673 12.1166L7 12L7 7.413L5.70735 8.70687L5.61317 8.79009Z",
        fill: "var(--ds-text-accent-gray-bolder, #091E42)",
        transform: `rotate(${$16dc3005c1175509$var$ROTATIONS[direction]}, ${$16dc3005c1175509$export$fa53c1d9d4c86cc2}, ${$16dc3005c1175509$export$fa53c1d9d4c86cc2})`
    }));
var $16dc3005c1175509$export$2e2bcd8739ae039 = $16dc3005c1175509$var$MoveArrow;

});


parcelRegister("aoNyD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf14501dcea134d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $gn7EO = parcelRequire("gn7EO");

var $v1MZY = parcelRequire("v1MZY");

var $jCNJE = parcelRequire("jCNJE");

var $6WkqH = parcelRequire("6WkqH");

var $dcsRA = parcelRequire("dcsRA");

var $5Y3a5 = parcelRequire("5Y3a5");

var $7L2Jz = parcelRequire("7L2Jz");

var $cbefB = parcelRequire("cbefB");

var $5ahMX = parcelRequire("5ahMX");

var $lmtF7 = parcelRequire("lmtF7");
const $9cf14501dcea134d$var$MIN_LOZENGE_WIDTH = 40;
const $9cf14501dcea134d$var$LOZENGE_HEIGHT = 24;
const $9cf14501dcea134d$var$LOZENGE_BORDER_RADIUS = $9cf14501dcea134d$var$LOZENGE_HEIGHT / 2;
const $9cf14501dcea134d$var$ERROR_RING_DASH_ARRAY = '3,2';
const $9cf14501dcea134d$var$FOCUS_RING_WIDTH = 4;
const $9cf14501dcea134d$var$TEXT_ICON_BUFFER = 8;
const $9cf14501dcea134d$var$LOZENGE_PADDING = 10; // total padding around left and right of lozenge, L + R value
const $9cf14501dcea134d$var$GlobalTransition = ({ id: id, flag: flag, isHovered: isHovered = false, isImmutable: isImmutable, isHighlighted: isHighlighted, portPosition: portPosition, isSelected: isSelected = false, isTargeted: isTargeted = false, onSelect: onSelect, onHover: onHover, icons: icons = [] })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const stroke = (0, $cbefB.useStrokeColor)({
        flag: flag,
        isHighlighted: isHighlighted,
        isSelected: isSelected,
        isHovered: isHovered
    });
    const textRef = (0, $eJOHy.useRef)(null);
    const iconsRef = (0, $eJOHy.useRef)(null);
    const lozengeText = (0, $5Y3a5.truncateLabel)(formatMessage((0, $lmtF7.default).anyTransitionLabel));
    const textWidth = (0, $5ahMX.default)(textRef, [
        icons
    ]);
    const iconsWidth = (0, $5ahMX.default)(iconsRef, [
        icons
    ]);
    const lozengeWidth = Math.max($9cf14501dcea134d$var$MIN_LOZENGE_WIDTH + iconsWidth, textWidth + iconsWidth + (iconsWidth > 0 ? $9cf14501dcea134d$var$TEXT_ICON_BUFFER : 0) + $9cf14501dcea134d$var$LOZENGE_PADDING);
    const routeWidth = lozengeWidth / 2;
    const onGroupClick = (0, $eJOHy.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $v1MZY.EDGE_TYPE),
            id: id
        });
    }, [
        id,
        isImmutable,
        onSelect
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        onHover?.({
            id: id,
            type: (0, $v1MZY.EDGE_TYPE)
        });
    }, [
        id,
        onHover
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    if (!portPosition) return null;
    const path = (0, $7L2Jz.globalTransitionRoute)(portPosition, (0, $7jTnu.fg)('hix-7234_global_transition_arrow_isnt_lining_up') ? (0, $gn7EO.GLOBAL_TRANSITION_PORT_OFFSET) : (0, $gn7EO.PORT_RADIUS), lozengeWidth / 2);
    const textX = iconsWidth > 0 ? portPosition.x + iconsWidth + $9cf14501dcea134d$var$TEXT_ICON_BUFFER + $9cf14501dcea134d$var$LOZENGE_PADDING / 2 : portPosition.x + (lozengeWidth - textWidth) / 2;
    const textY = portPosition.y - (0, $7L2Jz.GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE) - 8;
    const lozengeX = portPosition.x + routeWidth - lozengeWidth / 2;
    const lozengeY = portPosition.y - (0, $7L2Jz.GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE) - $9cf14501dcea134d$var$LOZENGE_HEIGHT;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        onClick: onGroupClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "none",
        stroke: "transparent",
        d: path,
        strokeWidth: "15"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fill: "none",
        stroke: stroke,
        strokeLinejoin: "round",
        d: path,
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6WkqH.Arrow), {
        stroke: stroke,
        portIndex: (0, $gn7EO.GLOBAL_TRANSITION_PORT),
        portPosition: portPosition,
        portOffset: (0, $7jTnu.fg)('hix-7234_global_transition_arrow_isnt_lining_up') ? (0, $gn7EO.GLOBAL_TRANSITION_PORT_OFFSET) : (0, $gn7EO.PORT_RADIUS)
    }), isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: lozengeX,
        y: lozengeY,
        width: lozengeWidth,
        height: $9cf14501dcea134d$var$LOZENGE_HEIGHT,
        rx: $9cf14501dcea134d$var$LOZENGE_BORDER_RADIUS,
        ry: $9cf14501dcea134d$var$LOZENGE_BORDER_RADIUS,
        stroke: (0, $gn7EO.STATE_COLOURS).focused,
        strokeWidth: $9cf14501dcea134d$var$FOCUS_RING_WIDTH * 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: lozengeX,
        y: lozengeY,
        width: lozengeWidth,
        height: $9cf14501dcea134d$var$LOZENGE_HEIGHT,
        rx: $9cf14501dcea134d$var$LOZENGE_BORDER_RADIUS,
        ry: $9cf14501dcea134d$var$LOZENGE_BORDER_RADIUS,
        fill: "var(--ds-background-neutral-bold, #44546F)",
        strokeWidth: (0, $gn7EO.TRANSITION_STROKE_WIDTH),
        stroke: isSelected || flag ? stroke : undefined,
        strokeDasharray: flag && !isSelected ? $9cf14501dcea134d$var$ERROR_RING_DASH_ARRAY : undefined
    }), icons.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dcsRA.IconSet), {
        setRef: (ref)=>{
            iconsRef.current = ref;
        },
        icons: icons,
        inverse: true,
        anchor: (0, $jCNJE.toPoint)(portPosition.x + $9cf14501dcea134d$var$LOZENGE_PADDING / 2, textY - $9cf14501dcea134d$var$LOZENGE_HEIGHT / 2 - 2)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("text", {
        ref: textRef,
        textAnchor: "left",
        fontSize: "11px",
        fill: "var(--ds-text-inverse, #FFFFFF)",
        x: textX,
        y: textY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tspan", null, lozengeText)));
};
var $9cf14501dcea134d$export$2e2bcd8739ae039 = $9cf14501dcea134d$var$GlobalTransition;

});
parcelRegister("7L2Jz", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_TRANSITION_ROUTE_HEIGHT_DISTANCE", () => $f19c7046d1cf2af9$export$749823dbfef429ad);
$parcel$export(module.exports, "globalTransitionRoute", () => $f19c7046d1cf2af9$export$63f557e78cc90426);

var $lJ60K = parcelRequire("lJ60K");

var $9VjvI = parcelRequire("9VjvI");
const $f19c7046d1cf2af9$export$d7ea5b7fe202bfa1 = (start, end)=>({
        path: (0, $9VjvI.move)(start.position) + (0, $9VjvI.line)(end.position),
        midpoint: (0, $lJ60K.midpoint)(start.position, end.position)
    });
const $f19c7046d1cf2af9$export$749823dbfef429ad = 10;
const $f19c7046d1cf2af9$export$63f557e78cc90426 = (portPosition, portOffset, width)=>`M${portPosition.x + portOffset},${portPosition.y}L${portPosition.x + width},${portPosition.y}L${portPosition.x + width},${portPosition.y - $f19c7046d1cf2af9$export$749823dbfef429ad}`;

});

parcelRegister("lmtF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2b9a7fc954063b6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a2b9a7fc954063b6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    anyTransitionLabel: {
        "id": "accessible-workflow-diagram.diagram.global-transition.any-transition-label",
        "defaultMessage": "Any"
    }
});

});


parcelRegister("lbFMB", function(module, exports) {

$parcel$export(module.exports, "LayerGroup", () => $a19325f6d1148152$export$829212b9319961ea);
$parcel$export(module.exports, "LayerItem", () => $a19325f6d1148152$export$a8b53972628ea76c);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $80xRm = parcelRequire("80xRm");

var $jCNJE = parcelRequire("jCNJE");
const $a19325f6d1148152$export$829212b9319961ea = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(children.flatMap((child)=>Array.isArray(child) ? child : [
            child
        ]), (child)=>Number((0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(child, 'props.layer', (0, $jCNJE.LayerIndex).Default))));
const $a19325f6d1148152$export$a8b53972628ea76c = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);

});
parcelRegister("80xRm", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $4ppQ2 = parcelRequire("4ppQ2");

var $l76qh = parcelRequire("l76qh");

var $eA1it = parcelRequire("eA1it");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $5d48969fb93c8520$var$sortBy = $l76qh(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $eA1it(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $eA1it(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $4ppQ2(collection, $72Qfa(iteratees, 1), []);
});
module.exports = $5d48969fb93c8520$var$sortBy;

});
parcelRegister("4ppQ2", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $5BbSa = parcelRequire("5BbSa");

var $1lM9j = parcelRequire("1lM9j");

var $k0Eii = parcelRequire("k0Eii");

var $1QISL = parcelRequire("1QISL");

var $cUaWv = parcelRequire("cUaWv");

var $6c1m2 = parcelRequire("6c1m2");

var $d7YnM = parcelRequire("d7YnM");

var $4sprp = parcelRequire("4sprp");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $335d8a321b94e157$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $lylkU(iteratees, function(iteratee) {
        if ($4sprp(iteratee)) return function(value) {
            return $5BbSa(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $d7YnM
    ];
    var index = -1;
    iteratees = $lylkU(iteratees, $cUaWv($1lM9j));
    var result = $k0Eii(collection, function(value, key, collection) {
        var criteria = $lylkU(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $1QISL(result, function(object, other) {
        return $6c1m2(object, other, orders);
    });
}
module.exports = $335d8a321b94e157$var$baseOrderBy;

});
parcelRegister("k0Eii", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");

var $7H30b = parcelRequire("7H30b");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e9131047aaeaff47$var$baseMap(collection, iteratee) {
    var index = -1, result = $7H30b(collection) ? Array(collection.length) : [];
    $c3u3c(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e9131047aaeaff47$var$baseMap;

});

parcelRegister("1QISL", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $158d7678f0c45464$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $158d7678f0c45464$var$baseSortBy;

});

parcelRegister("6c1m2", function(module, exports) {

var $boN2o = parcelRequire("boN2o");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $4824ea093db12906$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $boN2o(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $4824ea093db12906$var$compareMultiple;

});
parcelRegister("boN2o", function(module, exports) {

var $9D78T = parcelRequire("9D78T");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $84c7f970dc532949$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9D78T(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9D78T(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $84c7f970dc532949$var$compareAscending;

});





parcelRegister("eIlh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d9ec0ccacfced54$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gn7EO = parcelRequire("gn7EO");

var $v1MZY = parcelRequire("v1MZY");

var $jCNJE = parcelRequire("jCNJE");

var $7tPN1 = parcelRequire("7tPN1");
const $7d9ec0ccacfced54$var$CORONA_GLOW_OPACITY = 0.45;
const $7d9ec0ccacfced54$var$Port = ({ position: position, portKey: portKey, isImmutable: isImmutable, isGlowing: isGlowing = false, parentStatusId: parentStatusId, portIndex: portIndex, isRerouting: isRerouting = false, isProposingTransition: isProposingTransition = false, onHover: onHover, onTransitionProposalClose: onTransitionProposalClose, onTransitionReroutingClose: onTransitionReroutingClose })=>{
    const dataAttributes = (0, $7tPN1.useDraggableDataAttributes)('port', portKey);
    const onHoverChange = (isHovered)=>{
        if (isProposingTransition && parentStatusId && portIndex !== undefined) {
            onTransitionProposalClose?.(isHovered ? (0, $jCNJE.toPortKey)(parentStatusId, portIndex) : undefined);
            return;
        }
        if (isRerouting && parentStatusId && portIndex !== undefined) {
            onTransitionReroutingClose?.({
                proposedStatusId: parentStatusId,
                proposedPortKey: isHovered ? (0, $jCNJE.toPortKey)(parentStatusId, portIndex) : undefined
            });
            return;
        }
        if (isHovered && parentStatusId) {
            onHover?.({
                id: parentStatusId,
                type: (0, $v1MZY.NODE_TYPE)
            });
            return;
        }
        onHover?.(undefined);
    };
    const onPointerEnter = ()=>{
        onHoverChange(true);
    };
    const onPointerLeave = ()=>onHoverChange(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        pointerEvents: isImmutable ? 'none' : undefined,
        cursor: isImmutable ? undefined : 'crosshair',
        "data-testid": "accessible-workflow-diagram.ui.diagram.port",
        ...dataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ellipse", {
        cx: position.x,
        cy: position.y,
        rx: "10",
        ry: "10",
        fill: (0, $gn7EO.STATE_COLOURS).focused,
        fillOpacity: isGlowing ? $7d9ec0ccacfced54$var$CORONA_GLOW_OPACITY : 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ellipse", {
        x: position.x,
        y: position.y,
        cx: position.x,
        cy: position.y,
        rx: "4",
        ry: "4",
        fill: "var(--ds-background-input, #FFFFFF)",
        stroke: (0, $gn7EO.STATE_COLOURS).focused,
        strokeWidth: "2"
    }));
};
var $7d9ec0ccacfced54$export$2e2bcd8739ae039 = $7d9ec0ccacfced54$var$Port;

});

parcelRegister("2j7sg", function(module, exports) {

$parcel$export(module.exports, "default", () => $26a17756d22e10e5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $26a17756d22e10e5$var$ProposedTransition = ({ start: start, end: end })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("line", {
        x1: start.x,
        y1: start.y,
        x2: end.x,
        y2: end.y,
        strokeDasharray: "4",
        stroke: "var(--ds-border-accent-blue, #1D7AFC)",
        pointerEvents: "none"
    });
var $26a17756d22e10e5$export$2e2bcd8739ae039 = $26a17756d22e10e5$var$ProposedTransition;

});

parcelRegister("4xWre", function(module, exports) {

$parcel$export(module.exports, "default", () => $579ac8cb7f0aa8c7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $gn7EO = parcelRequire("gn7EO");

var $v1MZY = parcelRequire("v1MZY");

var $6WkqH = parcelRequire("6WkqH");

var $cbefB = parcelRequire("cbefB");
const $579ac8cb7f0aa8c7$var$SharedTransition = ({ id: id, flag: flag, isHovered: isHovered = false, isHighlighted: isHighlighted = false, isImmutable: isImmutable = false, isSelected: isSelected = false, connections: connections, onSelect: onSelect, onHover: onHover })=>{
    const stroke = (0, $cbefB.useStrokeColor)({
        flag: flag,
        isHighlighted: isHighlighted,
        isHovered: isHovered,
        isSelected: isSelected
    });
    const onGroupClick = (0, $eJOHy.useCallback)(()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $v1MZY.EDGE_TYPE),
            id: id
        });
    }, [
        isImmutable,
        onSelect,
        id
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)((connection)=>()=>{
            if ((0, $7jTnu.fg)('hix-7062_shared_transition_show_label_highlighted')) onHover?.({
                id: id,
                type: (0, $v1MZY.EDGE_TYPE),
                connection: connection
            });
            else onHover?.({
                id: id,
                type: (0, $v1MZY.EDGE_TYPE)
            });
        }, [
        id,
        onHover
    ]);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        onHover?.(undefined);
    }, [
        onHover
    ]);
    if (!connections) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, connections.map(({ path: path, targetPort: targetPort }, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
            onClick: onGroupClick,
            onMouseEnter: onMouseEnter(connections[i]),
            onMouseLeave: onMouseLeave,
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
            fill: "none",
            stroke: "transparent",
            d: path,
            strokeLinejoin: "round",
            strokeWidth: "15"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
            fill: "none",
            stroke: stroke,
            d: path,
            strokeLinejoin: "round",
            strokeWidth: (0, $gn7EO.TRANSITION_STROKE_WIDTH)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6WkqH.Arrow), {
            portIndex: targetPort.portIndex,
            portPosition: targetPort.position,
            stroke: stroke
        }))));
};
var $579ac8cb7f0aa8c7$export$2e2bcd8739ae039 = $579ac8cb7f0aa8c7$var$SharedTransition;

});

parcelRegister("6eint", function(module, exports) {

$parcel$export(module.exports, "default", () => $7204a30e00cbabdb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9VjvI = parcelRequire("9VjvI");
/**
 * Alignment lines that appear when dragging a status and allow aligning with other statuses
 */ const $7204a30e00cbabdb$var$SnapLines = ({ lines: lines })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, lines.map(({ start: start, end: end }, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
            key: i,
            fill: "none",
            stroke: "var(--ds-border-accent-orange, #E56910)",
            d: (0, $9VjvI.move)(start) + (0, $9VjvI.line)(end)
        })));
var $7204a30e00cbabdb$export$2e2bcd8739ae039 = $7204a30e00cbabdb$var$SnapLines;

});

parcelRegister("aJBX7", function(module, exports) {

$parcel$export(module.exports, "default", () => $678615901ee4fc97$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $gn7EO = parcelRequire("gn7EO");

var $v1MZY = parcelRequire("v1MZY");

var $4fWCz = parcelRequire("4fWCz");

var $7tPN1 = parcelRequire("7tPN1");

var $dTAwl = parcelRequire("dTAwl");
const $678615901ee4fc97$var$TEXT_LINE_HEIGHT_OFFSET = 2.75;
const $678615901ee4fc97$var$FOCUS_RING_WIDTH = 4;
const $678615901ee4fc97$var$ARROW_PADDING = $678615901ee4fc97$var$FOCUS_RING_WIDTH + (0, $4fWCz.ARROW_RADIUS);
const $678615901ee4fc97$var$StartNode = ({ position: position = {
    x: 0,
    y: 0
}, id: id, isImmutable: isImmutable, isTargeted: isTargeted, isMoving: isMoving, onHover: onHover })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const dataAttributes = (0, $7tPN1.useDraggableDataAttributes)('start-node', id);
    const onMouseEnter = ()=>{
        onHover({
            id: id,
            type: (0, $v1MZY.NODE_TYPE)
        });
    };
    const onMouseLeave = ()=>{
        onHover(undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ellipse", {
        cx: position.x + (0, $gn7EO.START_NODE_RADIUS),
        cy: position.y + (0, $gn7EO.START_NODE_RADIUS),
        rx: (0, $gn7EO.START_NODE_RADIUS) + $678615901ee4fc97$var$FOCUS_RING_WIDTH / 2,
        ry: (0, $gn7EO.START_NODE_RADIUS) + $678615901ee4fc97$var$FOCUS_RING_WIDTH / 2,
        stroke: (0, $gn7EO.STATE_COLOURS).focused,
        fillOpacity: "0",
        strokeWidth: $678615901ee4fc97$var$FOCUS_RING_WIDTH
    }), isMoving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: position.x + (0, $gn7EO.START_NODE_RADIUS),
        y: position.y - $678615901ee4fc97$var$ARROW_PADDING,
        direction: "up"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: position.x + (0, $gn7EO.START_NODE_RADIUS),
        y: position.y + (0, $gn7EO.START_NODE_RADIUS) * 2 + $678615901ee4fc97$var$ARROW_PADDING,
        direction: "down"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: position.x - $678615901ee4fc97$var$ARROW_PADDING,
        y: position.y + (0, $gn7EO.START_NODE_RADIUS),
        direction: "left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: position.x + (0, $gn7EO.START_NODE_RADIUS) * 2 + $678615901ee4fc97$var$ARROW_PADDING,
        y: position.y + (0, $gn7EO.START_NODE_RADIUS),
        direction: "right"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        cursor: isImmutable ? undefined : 'move',
        ...dataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ellipse", {
        cx: position.x + (0, $gn7EO.START_NODE_RADIUS),
        cy: (0, $7jTnu.fg)('jif_jam_wfe_ui_fixes') ? position.y + (0, $gn7EO.START_NODE_RADIUS) - (0, $gn7EO.TRANSITION_STROKE_WIDTH) : position.y + (0, $gn7EO.START_NODE_RADIUS),
        rx: (0, $gn7EO.START_NODE_RADIUS),
        ry: (0, $gn7EO.START_NODE_RADIUS),
        fill: "var(--ds-background-neutral-bold, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("text", {
        x: position.x + (0, $gn7EO.START_NODE_RADIUS),
        y: (0, $7jTnu.fg)('jif_jam_wfe_ui_fixes') ? position.y + (0, $gn7EO.START_NODE_RADIUS) - (0, $gn7EO.TRANSITION_STROKE_WIDTH) : position.y + (0, $gn7EO.START_NODE_RADIUS),
        textAnchor: "middle",
        fontSize: "8px",
        fill: "var(--ds-text-inverse, #FFFFFF)",
        fontWeight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tspan", {
        dy: $678615901ee4fc97$var$TEXT_LINE_HEIGHT_OFFSET
    }, formatMessage((0, $dTAwl.default).startNodeLabel)))));
};
var $678615901ee4fc97$export$2e2bcd8739ae039 = $678615901ee4fc97$var$StartNode;

});
parcelRegister("dTAwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49617cb0be21cc3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c49617cb0be21cc3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    startNodeLabel: {
        "id": "accessible-workflow-diagram.diagram.start-node.start-node-label",
        "defaultMessage": "START"
    }
});

});


parcelRegister("4ojSV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c57fc87b1adbcb3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $gn7EO = parcelRequire("gn7EO");

var $v1MZY = parcelRequire("v1MZY");

var $jCNJE = parcelRequire("jCNJE");

var $4fWCz = parcelRequire("4fWCz");

var $5Y3a5 = parcelRequire("5Y3a5");

var $7tPN1 = parcelRequire("7tPN1");

var $5ahMX = parcelRequire("5ahMX");
const $2c57fc87b1adbcb3$var$STATUS_TEXT_OFFSET_Y = 3.25;
const $2c57fc87b1adbcb3$var$STATUS_TEXT_HORIZONTAL_PADDING = 50;
const $2c57fc87b1adbcb3$var$OUTLINE_PADDING = 3;
const $2c57fc87b1adbcb3$var$DEFAULT_BORDER_WIDTH = 2;
const $2c57fc87b1adbcb3$var$FOCUS_RING_WIDTH = 4;
const $2c57fc87b1adbcb3$var$SELECTION_RING_RADIUS = 6;
const $2c57fc87b1adbcb3$var$BORDER_RADIUS = 4;
const $2c57fc87b1adbcb3$var$ERROR_RING_DASH_ARRAY = '6,3';
const $2c57fc87b1adbcb3$var$ARROW_PADDING = $2c57fc87b1adbcb3$var$OUTLINE_PADDING + $2c57fc87b1adbcb3$var$FOCUS_RING_WIDTH + (0, $4fWCz.ARROW_RADIUS);
const $2c57fc87b1adbcb3$var$statusCategoryThemes = {
    UNDEFINED: {
        border: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        background: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        text: "var(--ds-text-accent-gray-bolder, #091E42)"
    },
    TODO: {
        border: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        background: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        text: "var(--ds-text-accent-gray-bolder, #091E42)"
    },
    IN_PROGRESS: {
        border: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        background: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        text: "var(--ds-text-accent-blue-bolder, #09326C)"
    },
    DONE: {
        border: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        background: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        text: "var(--ds-text-accent-green-bolder, #164B35)"
    }
};
const $2c57fc87b1adbcb3$var$Status = ({ id: id, position: position = {
    x: 0,
    y: 0
}, label: label, category: category = 'UNDEFINED', flag: flag, isImmutable: isImmutable, isSelected: isSelected = false, isTargeted: isTargeted = false, isMoving: isMoving = false, onStatusResize: onStatusResize, onHover: onHover, onSelect: onSelect })=>{
    const textRef = (0, $eJOHy.useRef)(null);
    const labelWidth = (0, $5ahMX.useLayoutWidth)(textRef, [
        label
    ]);
    const width = labelWidth + $2c57fc87b1adbcb3$var$STATUS_TEXT_HORIZONTAL_PADDING;
    (0, $eJOHy.useEffect)(()=>{
        if (width > $2c57fc87b1adbcb3$var$STATUS_TEXT_HORIZONTAL_PADDING || !(0, $7jTnu.fg)('concurrent-rendering-workflows-replace-settimeout')) onStatusResize?.(id, width);
    }, [
        id,
        label,
        onStatusResize,
        width
    ]);
    const dataAttributes = (0, $7tPN1.useDraggableDataAttributes)('status', id);
    const onPointerEnter = ()=>onHover?.({
            id: id,
            type: (0, $v1MZY.NODE_TYPE)
        });
    const onPointerLeave = ()=>onHover?.(undefined);
    const onGroupClick = ()=>{
        if (!isImmutable) onSelect?.({
            type: (0, $v1MZY.NODE_TYPE),
            id: id
        });
    };
    const truncatedLabel = (0, $5Y3a5.truncateLabel)(label);
    const hasError = flag === (0, $jCNJE.ValidationFlag).Error;
    const hasWarning = flag === (0, $jCNJE.ValidationFlag).Warn;
    const hasValidationFlag = hasError || hasWarning;
    const theme = $2c57fc87b1adbcb3$var$statusCategoryThemes[category];
    const statusLeft = position.x;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", null, isTargeted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: statusLeft - $2c57fc87b1adbcb3$var$OUTLINE_PADDING - $2c57fc87b1adbcb3$var$FOCUS_RING_WIDTH / 4,
        y: position.y - $2c57fc87b1adbcb3$var$OUTLINE_PADDING - $2c57fc87b1adbcb3$var$FOCUS_RING_WIDTH / 4,
        width: width + $2c57fc87b1adbcb3$var$OUTLINE_PADDING * 2 + $2c57fc87b1adbcb3$var$FOCUS_RING_WIDTH / 2,
        height: (0, $gn7EO.STATUS_HEIGHT) + $2c57fc87b1adbcb3$var$OUTLINE_PADDING * 2 + $2c57fc87b1adbcb3$var$FOCUS_RING_WIDTH / 2,
        rx: $2c57fc87b1adbcb3$var$SELECTION_RING_RADIUS,
        ry: $2c57fc87b1adbcb3$var$SELECTION_RING_RADIUS,
        stroke: (0, $gn7EO.STATE_COLOURS).focused,
        fillOpacity: "0",
        strokeWidth: $2c57fc87b1adbcb3$var$FOCUS_RING_WIDTH
    }), isMoving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: statusLeft + width / 2,
        y: position.y - $2c57fc87b1adbcb3$var$ARROW_PADDING,
        direction: "up"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: statusLeft + width / 2,
        y: position.y + (0, $gn7EO.STATUS_HEIGHT) + $2c57fc87b1adbcb3$var$ARROW_PADDING,
        direction: "down"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: statusLeft - $2c57fc87b1adbcb3$var$ARROW_PADDING,
        y: position.y + (0, $gn7EO.STATUS_HEIGHT) / 2,
        direction: "left"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4fWCz.default), {
        x: statusLeft + width + $2c57fc87b1adbcb3$var$ARROW_PADDING,
        y: position.y + (0, $gn7EO.STATUS_HEIGHT) / 2,
        direction: "right"
    })), hasValidationFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: statusLeft - $2c57fc87b1adbcb3$var$OUTLINE_PADDING,
        y: position.y - $2c57fc87b1adbcb3$var$OUTLINE_PADDING,
        width: width + $2c57fc87b1adbcb3$var$OUTLINE_PADDING * 2,
        height: (0, $gn7EO.STATUS_HEIGHT) + $2c57fc87b1adbcb3$var$OUTLINE_PADDING * 2,
        rx: $2c57fc87b1adbcb3$var$SELECTION_RING_RADIUS,
        ry: $2c57fc87b1adbcb3$var$SELECTION_RING_RADIUS,
        stroke: hasError ? (0, $gn7EO.STATE_COLOURS).error : (0, $gn7EO.STATE_COLOURS).warning,
        fillOpacity: "0",
        strokeDasharray: !isSelected ? $2c57fc87b1adbcb3$var$ERROR_RING_DASH_ARRAY : undefined,
        strokeWidth: $2c57fc87b1adbcb3$var$DEFAULT_BORDER_WIDTH
    }), isSelected && !hasValidationFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: statusLeft - $2c57fc87b1adbcb3$var$OUTLINE_PADDING,
        y: position.y - $2c57fc87b1adbcb3$var$OUTLINE_PADDING,
        width: width + $2c57fc87b1adbcb3$var$OUTLINE_PADDING * 2,
        height: (0, $gn7EO.STATUS_HEIGHT) + $2c57fc87b1adbcb3$var$OUTLINE_PADDING * 2,
        rx: $2c57fc87b1adbcb3$var$SELECTION_RING_RADIUS,
        ry: $2c57fc87b1adbcb3$var$SELECTION_RING_RADIUS,
        stroke: (0, $gn7EO.STATE_COLOURS).selected,
        fillOpacity: "0",
        strokeWidth: $2c57fc87b1adbcb3$var$DEFAULT_BORDER_WIDTH
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        ...dataAttributes,
        cursor: !isImmutable ? 'move' : undefined,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onClick: onGroupClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        x: statusLeft,
        y: position.y,
        width: width,
        height: (0, $gn7EO.STATUS_HEIGHT),
        rx: $2c57fc87b1adbcb3$var$BORDER_RADIUS,
        ry: $2c57fc87b1adbcb3$var$BORDER_RADIUS,
        fill: theme.background,
        stroke: theme.border,
        strokeWidth: $2c57fc87b1adbcb3$var$DEFAULT_BORDER_WIDTH
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("text", {
        x: statusLeft + width / 2,
        y: position.y + (0, $gn7EO.STATUS_HEIGHT) / 2 + $2c57fc87b1adbcb3$var$STATUS_TEXT_OFFSET_Y,
        fontSize: "11px",
        stroke: "none",
        fill: theme.text,
        textAnchor: "middle",
        fontWeight: "bold",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tspan", {
        ref: textRef
    }, truncatedLabel.toLocaleUpperCase())))));
};
var $2c57fc87b1adbcb3$export$2e2bcd8739ae039 = $2c57fc87b1adbcb3$var$Status;

});

parcelRegister("dB7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa5a78fc5abf7212$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4sIW7 = parcelRequire("4sIW7");
const $aa5a78fc5abf7212$var$ViewOverlay = ({ viewBox: viewBox })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        ...(0, $4sIW7.DATA_ATTRIBUTE_IGNORE_AUTOFIT),
        x: viewBox.left,
        y: viewBox.top,
        width: viewBox.width,
        height: viewBox.height,
        fill: "var(--ds-surface, #FFFFFF)",
        fillOpacity: "0.5"
    });
var $aa5a78fc5abf7212$export$2e2bcd8739ae039 = $aa5a78fc5abf7212$var$ViewOverlay;

});


parcelRegister("dIUfl", function(module, exports) {

$parcel$export(module.exports, "default", () => $73e3a1a372cbfb29$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $lRq8t = parcelRequire("lRq8t");

var $v1MZY = parcelRequire("v1MZY");

var $gn7EO = parcelRequire("gn7EO");

var $kP1XV = parcelRequire("kP1XV");

var $3HNB5 = parcelRequire("3HNB5");

var $jkFGk = parcelRequire("jkFGk");

var $9ci9g = parcelRequire("9ci9g");

var $2iWdc = parcelRequire("2iWdc");

var $j23Cu = parcelRequire("j23Cu");
const $73e3a1a372cbfb29$export$b816ea2e633ab9e1 = 'accessible-workflow-list.edit-help';
const $73e3a1a372cbfb29$export$13e6b85d8ac872ed = 'accessible-workflow-list.move-help';
const $73e3a1a372cbfb29$export$ca19fc40c2d5aff5 = 'accessible-workflow-list.delete-help';
const $73e3a1a372cbfb29$export$39d7113f2dbf2b71 = 10;
const $73e3a1a372cbfb29$export$90d9ca2a443f323d = 20;
const $73e3a1a372cbfb29$export$3be9fb6f5ac33422 = 5;
const $73e3a1a372cbfb29$var$ListNavigation = ({ globalLoopsContainerPosition: globalLoopsContainerPosition, startNodePosition: startNodePosition, statuses: statuses, transitions: transitions, isImmutable: isImmutable = false, movingItem: movingItem, errors: errors, selectedItem: selectedItem, pan: pan = (0, $gn7EO.DEFAULT_PAN), zoom: zoom = (0, $gn7EO.DEFAULT_ZOOM_LEVEL), onSelect: onSelect, onTargetChange: onTargetChange, setMovingItem: setMovingItem, onItemMove: onItemMove, onZoomChange: onZoomChange, onPanChange: onPanChange })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const listRef = (0, $eJOHy.useRef)(null);
    const [moveAnnouncement, setMoveAnnouncement] = (0, $eJOHy.useState)('');
    const { nodes: nodes, globalLoops: globalLoops } = (0, $j23Cu.getFlattenedStructure)(statuses, transitions, startNodePosition, errors, movingItem);
    const handleBlur = (event)=>{
        if (!listRef || !listRef.current) return; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (!event.relatedTarget || !listRef.current.contains(event.relatedTarget)) {
            // focus moving outside of diagram
            onTargetChange?.(undefined);
            handleMoveCancel();
        }
    };
    const handleFocus = (event)=>{
        if (!listRef || !listRef.current) return;
        if (event.target === listRef.current) // list itself is targeted
        onTargetChange?.({
            type: (0, $v1MZY.DIAGRAM_CONTAINER_TYPE),
            id: (0, $v1MZY.DIAGRAM_CONTAINER_TYPE)
        });
    };
    const handleNodeFocus = (id)=>{
        onTargetChange?.({
            type: (0, $v1MZY.NODE_TYPE),
            id: id
        });
    };
    const handleEdgeFocus = (id)=>{
        onTargetChange?.({
            type: (0, $v1MZY.EDGE_TYPE),
            id: id
        });
        handleMoveCancel();
    };
    const handleContainerFocus = ()=>{
        onTargetChange?.({
            type: (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE),
            id: (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE)
        });
    };
    const handleMoveStart = (updatedMoveState)=>{
        if (updatedMoveState.type === 'start-node') updateMoveAnnouncement(formatMessage((0, $2iWdc.default).startNodeMoveStartAnnouncement, {
            ...updatedMoveState.position
        }));
        else if (updatedMoveState.type === (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE)) updateMoveAnnouncement(formatMessage((0, $2iWdc.default).globalLoopsContainerMoveStartAnnouncement, {
            ...updatedMoveState.position
        }));
        else {
            const movingStatus = statuses.find((status)=>status.id === updatedMoveState.id);
            if (movingStatus) updateMoveAnnouncement(formatMessage((0, $2iWdc.default).statusMoveStartAnnouncement, {
                statusName: movingStatus.name,
                ...updatedMoveState.position
            }));
        }
        setMovingItem?.(updatedMoveState);
    };
    const handleMoveUpdate = (updatedMoveState)=>{
        updateMoveAnnouncement(formatMessage((0, $2iWdc.default).moveUpdateAnnouncement, {
            ...updatedMoveState.position
        }));
        setMovingItem?.(updatedMoveState);
    };
    const handleMoveComplete = ()=>{
        if (movingItem) {
            updateMoveAnnouncement(formatMessage((0, $2iWdc.default).moveCompleteAnnouncement, {
                ...movingItem.position
            }));
            onItemMove?.(movingItem);
            setMovingItem?.(undefined);
        }
    };
    const handleMoveCancel = ()=>{
        if (movingItem) {
            updateMoveAnnouncement(formatMessage((0, $2iWdc.default).moveCancelAnnouncement));
            setMovingItem?.(undefined);
        }
    };
    const handleKeyDown = (e)=>{
        const panDirection = (0, $v1MZY.DIRECTION_KEYS)[e.key];
        const zoomDirection = (0, $v1MZY.ZOOM_KEYS)[e.key];
        if (panDirection && !movingItem && pan) {
            let moveDistance = $73e3a1a372cbfb29$export$39d7113f2dbf2b71;
            if (e.shiftKey) moveDistance = $73e3a1a372cbfb29$export$90d9ca2a443f323d;
            else if (e.altKey) moveDistance = $73e3a1a372cbfb29$export$3be9fb6f5ac33422;
            const updatedPan = (0, $j23Cu.getMovedPoint)(pan, panDirection, moveDistance);
            onPanChange?.(updatedPan);
        }
        if (zoomDirection) {
            const nextZoom = (0, $kP1XV.getNextZoomStep)(zoom, zoomDirection);
            onZoomChange?.(nextZoom);
        }
    };
    const updateMoveAnnouncement = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((message)=>setMoveAnnouncement(message), 500), []); // Cancel debounced function when component unmounts
    (0, $eJOHy.useEffect)(()=>()=>{
            updateMoveAnnouncement.cancel();
        }, [
        updateMoveAnnouncement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73e3a1a372cbfb29$var$HiddenWrapper, null, !isImmutable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        id: $73e3a1a372cbfb29$export$b816ea2e633ab9e1
    }, formatMessage((0, $2iWdc.default).editHelpText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        id: $73e3a1a372cbfb29$export$13e6b85d8ac872ed
    }, formatMessage((0, $2iWdc.default).moveHelpText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        id: $73e3a1a372cbfb29$export$ca19fc40c2d5aff5
    }, formatMessage((0, $2iWdc.default).deleteHelpText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "aria-live": "assertive",
        "data-testid": "accessible-workflow-diagram.ui.list-navigation-with-move.move-announcement"
    }, moveAnnouncement), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73e3a1a372cbfb29$var$List, {
        ref: listRef,
        onBlur: handleBlur,
        onFocus: handleFocus,
        "aria-label": formatMessage((0, $2iWdc.default).navigationListLabel),
        "aria-description": formatMessage((0, $2iWdc.default).navigationListDescription),
        onKeyDown: handleKeyDown,
        tabIndex: 0
    }, nodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: node.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jkFGk.default), {
            node: node,
            isImmutable: isImmutable,
            selectedItem: selectedItem,
            describedBy: $73e3a1a372cbfb29$var$getNodeDescribedBy(isImmutable, node),
            onSelect: onSelect,
            onFocus: handleNodeFocus,
            onMoveStart: handleMoveStart,
            onMoveUpdate: handleMoveUpdate,
            onMoveComplete: handleMoveComplete,
            onMoveCancel: handleMoveCancel
        }), node.children && node.children.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73e3a1a372cbfb29$var$List, {
            "aria-label": node.status ? formatMessage((0, $2iWdc.default).statusTransitionsListLabel, {
                statusName: node.status.name
            }) : formatMessage((0, $2iWdc.default).initialTransitionListLabel)
        }, node.children.map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
                key: edge.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HNB5.default), {
                edge: edge,
                statuses: statuses,
                isImmutable: isImmutable,
                selectedItem: selectedItem,
                describedBy: $73e3a1a372cbfb29$var$getTransitionDescribedBy(isImmutable, edge),
                onSelect: onSelect,
                onFocus: handleEdgeFocus
            })))))), globalLoops && globalLoops.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73e3a1a372cbfb29$var$List, {
        "aria-label": formatMessage((0, $2iWdc.default).globalLoopedTransitionsList)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
        key: "global-loops-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9ci9g.default), {
        position: movingItem?.type === 'global-loops-container' ? movingItem.position : globalLoopsContainerPosition,
        isImmutable: isImmutable,
        isMoving: movingItem?.type === (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE),
        onFocus: handleContainerFocus,
        onMoveStart: handleMoveStart,
        onMoveUpdate: handleMoveUpdate,
        onMoveComplete: handleMoveComplete,
        onMoveCancel: handleMoveCancel
    })), globalLoops.map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: edge.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HNB5.default), {
            edge: edge,
            statuses: statuses,
            isImmutable: isImmutable,
            selectedItem: selectedItem,
            onSelect: onSelect,
            onFocus: handleEdgeFocus
        })))))));
};
const $73e3a1a372cbfb29$var$getNodeDescribedBy = (isImmutable, node)=>{
    if (isImmutable) return undefined;
    if (node.isInitial) return $73e3a1a372cbfb29$export$13e6b85d8ac872ed;
    if (node.canDelete) return `${$73e3a1a372cbfb29$export$b816ea2e633ab9e1} ${$73e3a1a372cbfb29$export$13e6b85d8ac872ed} ${$73e3a1a372cbfb29$export$ca19fc40c2d5aff5}`;
    return `${$73e3a1a372cbfb29$export$b816ea2e633ab9e1} ${$73e3a1a372cbfb29$export$13e6b85d8ac872ed}`;
};
const $73e3a1a372cbfb29$var$getTransitionDescribedBy = (isImmutable, edge)=>{
    if (isImmutable) return undefined;
    if (edge.canDelete) return `${$73e3a1a372cbfb29$export$b816ea2e633ab9e1} ${$73e3a1a372cbfb29$export$ca19fc40c2d5aff5}`;
    return $73e3a1a372cbfb29$export$b816ea2e633ab9e1;
};
var $73e3a1a372cbfb29$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $73e3a1a372cbfb29$var$ListNavigation;
const $73e3a1a372cbfb29$var$List = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_qtt8glyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73e3a1a372cbfb29$var$HiddenWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kP1XV", function(module, exports) {

$parcel$export(module.exports, "getNextZoomStep", () => $f12c1ff07e3bb696$export$6217ce1eaa5c65a);

var $2f1HK = parcelRequire("2f1HK");

var $gn7EO = parcelRequire("gn7EO");
const $f12c1ff07e3bb696$var$EXPONENTIAL_ZOOM_BASE = 2;
const $f12c1ff07e3bb696$var$LOGRAITHMIC_ZOOM_BASE = Math.log(2);
const $f12c1ff07e3bb696$export$92ad4ab75b1348d7 = (exponentialZoom)=>Math.log(exponentialZoom) / $f12c1ff07e3bb696$var$LOGRAITHMIC_ZOOM_BASE;
const $f12c1ff07e3bb696$export$1c090fe1906100fd = (linearZoom)=>$f12c1ff07e3bb696$var$EXPONENTIAL_ZOOM_BASE ** linearZoom;
const $f12c1ff07e3bb696$export$6217ce1eaa5c65a = (zoom, direction)=>{
    const step = direction === 'IN' ? (0, $gn7EO.LINEAR_ZOOM_STEP) : -(0, $gn7EO.LINEAR_ZOOM_STEP);
    const nextLinearZoom = $f12c1ff07e3bb696$export$92ad4ab75b1348d7(zoom) + step;
    const nextZoom = $f12c1ff07e3bb696$export$1c090fe1906100fd(nextLinearZoom);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2f1HK)))(nextZoom, (0, $gn7EO.MINIMUM_ZOOM_LEVEL), (0, $gn7EO.MAXIMUM_ZOOM_LEVEL));
};

});

parcelRegister("3HNB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b19841b1927d167$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $v1MZY = parcelRequire("v1MZY");

var $9tdox = parcelRequire("9tdox");

var $fS5jn = parcelRequire("fS5jn");

var $fu1BF = parcelRequire("fu1BF");
const $8b19841b1927d167$var$ListEdge = ({ edge: edge, statuses: statuses, isImmutable: isImmutable = false, describedBy: describedBy, selectedItem: selectedItem, onSelect: onSelect, onFocus: onFocus })=>{
    const isSelected = !!selectedItem && selectedItem.type === (0, $v1MZY.EDGE_TYPE) && selectedItem.id === edge.id;
    const handleClick = ()=>{
        onSelect?.({
            type: 'edge',
            id: edge.id
        });
    };
    const handleFocus = ()=>{
        onFocus?.(edge.id);
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8b19841b1927d167$var$EdgeLabel, {
        edge: edge,
        statuses: statuses
    }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9tdox.default), {
        rulesCount: edge.rulesCount
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fS5jn.default), {
        validationFlag: edge.validationFlag
    }));
    if (isImmutable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "aria-current": isSelected
    }, content);
    return(// We are using a primitive here to support accessible navigation of complex diagram,
    // this will never be visible to the user
    // eslint-disable-next-line @atlaskit/design-system/no-html-button
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
        type: "button",
        "aria-current": isSelected,
        onClick: handleClick,
        onFocus: handleFocus,
        "aria-describedby": describedBy
    }, content));
};
const $8b19841b1927d167$var$EdgeLabel = ({ edge: { type: type, transition: transition, parentId: parentId }, statuses: statuses })=>{
    const { formatMessage: formatMessage, formatList: formatList } = (0, $lRq8t.default)();
    const parentStatus = statuses.find((status)=>status.id === parentId);
    if (type === 'GLOBAL_LOOPED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $fu1BF.default).globalLoopedTransitionLabelIssueTermRefresh : (0, $fu1BF.default).globalLoopedTransitionLabel, {
        transitionName: transition.name
    }));
    if (type === 'GLOBAL') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $fu1BF.default).globalTransitionLabel, {
        parentName: parentStatus?.name
    }));
    if (type === 'LOOPED') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $fu1BF.default).loopedTransitionLabelIssueTermRefresh : (0, $fu1BF.default).loopedTransitionLabel, {
        transitionName: transition.name,
        parentName: parentStatus?.name
    }));
    const target = statuses.find((status)=>status.id === transition.toRef);
    if (type === 'INITIAL') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $fu1BF.default).initialTransitionLabelIssueTermRefresh : (0, $fu1BF.default).initialTransitionLabel, {
        transitionName: transition.name,
        targetName: target?.name
    }));
    const sourceIds = transition.links.map((source)=>source.fromRef);
    const otherSourcesNames = statuses.filter((status)=>status.id !== parentId && sourceIds.includes(status.id)).map((status)=>status.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $fu1BF.default).directedTransitionLabelIssueTermRefresh : (0, $fu1BF.default).directedTransitionLabel, {
        transitionName: transition.name,
        sourceNames: formatList([
            parentStatus?.name,
            ...otherSourcesNames
        ]),
        targetName: target?.name
    }));
};
var $8b19841b1927d167$export$2e2bcd8739ae039 = $8b19841b1927d167$var$ListEdge;

});
parcelRegister("9tdox", function(module, exports) {

$parcel$export(module.exports, "default", () => $88c9b555cb564823$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");
const $88c9b555cb564823$var$hasRulesIndicator = (0, $7qGN1.defineMessage)({
    id: 'accessible-workflow-diagram.common.rules-indicator.has-rules-indicator',
    defaultMessage: 'Has {rulesCount, plural, one {# rule} other {# rules}}.',
    description: 'Indicates that a transition has rules'
});
const $88c9b555cb564823$var$RulesIndicator = ({ rulesCount: rulesCount })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (rulesCount <= 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage($88c9b555cb564823$var$hasRulesIndicator, {
        rulesCount: rulesCount
    }));
};
var $88c9b555cb564823$export$2e2bcd8739ae039 = $88c9b555cb564823$var$RulesIndicator;

});

parcelRegister("fS5jn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5aa2d4dad618b6a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");
const $e5aa2d4dad618b6a$var$hasErrorIndicator = (0, $7qGN1.defineMessage)({
    id: 'accessible-workflow-diagram.common.validation-indicator.has-error-indicator',
    defaultMessage: 'Has error.',
    description: 'Indicates that a status or transition has an error'
});
const $e5aa2d4dad618b6a$var$hasWarningIndicator = (0, $7qGN1.defineMessage)({
    id: 'accessible-workflow-diagram.common.validation-indicator.has-warning-indicator',
    defaultMessage: 'Has warning.',
    description: 'Indicates that a status or transition has a warning'
});
const $e5aa2d4dad618b6a$var$ValidationIndicator = ({ validationFlag: validationFlag })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!validationFlag) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage(validationFlag === 'error' ? $e5aa2d4dad618b6a$var$hasErrorIndicator : $e5aa2d4dad618b6a$var$hasWarningIndicator));
};
var $e5aa2d4dad618b6a$export$2e2bcd8739ae039 = $e5aa2d4dad618b6a$var$ValidationIndicator;

});

parcelRegister("fu1BF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8034445a396a7a1d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8034445a396a7a1d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    globalTransitionLabel: {
        "id": "accessible-workflow-diagram.list-navigation.list-edge.global-transition-label",
        "defaultMessage": "Transition from any status to {parentName}."
    },
    loopedTransitionLabel: {
        "id": "accessible-workflow-diagram.list-navigation.list-edge.looped-transition-label",
        "defaultMessage": "{transitionName} transition - move issue from {parentName} back to itself."
    },
    globalLoopedTransitionLabel: {
        "id": "accessible-workflow-diagram.list-navigation-list-edge.global-looped-transition-label",
        "defaultMessage": "{transitionName} transition - move issue from any status back to itself."
    },
    initialTransitionLabel: {
        "id": "accessible-workflow-diagram.list-navigation.list-edge.initial-transition-label",
        "defaultMessage": "{transitionName} transition - move issue to {targetName}."
    },
    directedTransitionLabel: {
        "id": "accessible-workflow-diagram.list-navigation.list-edge.directed-transition-label",
        "defaultMessage": "{transitionName} transition - move issue from {sourceNames} to {targetName}."
    },
    loopedTransitionLabelIssueTermRefresh: {
        "id": "accessible-workflow-diagram.list-navigation.list-edge.looped-transition-label-issue-term-refresh",
        "defaultMessage": "{transitionName} transition - move work item from {parentName} back to itself."
    },
    globalLoopedTransitionLabelIssueTermRefresh: {
        "id": "accessible-workflow-diagram.list-navigation-list-edge.global-looped-transition-label-issue-term-refresh",
        "defaultMessage": "{transitionName} transition - move work item from any status back to itself."
    },
    initialTransitionLabelIssueTermRefresh: {
        "id": "accessible-workflow-diagram.list-navigation.list-edge.initial-transition-label-issue-term-refresh",
        "defaultMessage": "{transitionName} transition - move work item to {targetName}."
    },
    directedTransitionLabelIssueTermRefresh: {
        "id": "accessible-workflow-diagram.list-navigation.list-edge.directed-transition-label-issue-term-refresh",
        "defaultMessage": "{transitionName} transition - move work item from {sourceNames} to {targetName}."
    }
});

});


parcelRegister("jkFGk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f788aef708b84f00$export$2e2bcd8739ae039);
// primitive buttons are used here for native level screen reader support
/* eslint-disable @atlaskit/design-system/no-html-button */ 
var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $v1MZY = parcelRequire("v1MZY");

var $fS5jn = parcelRequire("fS5jn");

var $gzGnz = parcelRequire("gzGnz");
const $f788aef708b84f00$export$c0ac0a5c7f93677c = 5;
const $f788aef708b84f00$export$367adc66518209f7 = 10;
const $f788aef708b84f00$export$8586a781d0daf2c1 = 1;
const $f788aef708b84f00$var$NodeLabel = ({ node: node })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (node.status) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $gzGnz.default).statusNodeLabel, {
        statusName: node.status.name
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $gzGnz.default).startNodeLabelIssueTermRefresh : (0, $gzGnz.default).startNodeLabel));
};
const $f788aef708b84f00$var$ListNode = ({ node: node, selectedItem: selectedItem, isImmutable: isImmutable = false, describedBy: describedBy, onSelect: onSelect, onFocus: onFocus, onMoveStart: onMoveStart, onMoveUpdate: onMoveUpdate, onMoveComplete: onMoveComplete, onMoveCancel: onMoveCancel })=>{
    const isSelected = !!selectedItem && selectedItem.type === (0, $v1MZY.NODE_TYPE) && selectedItem.id === node.id;
    const handleClick = ()=>{
        if (!node.isMoving && !node.isInitial) onSelect?.({
            type: 'node',
            id: node.id
        });
    };
    const handleFocus = ()=>{
        onFocus?.(node.id);
    };
    const handleKeyDown = (e)=>{
        const direction = (0, $v1MZY.DIRECTION_KEYS)[e.key];
        if (node.isMoving && direction && node.position) {
            const updatedPosition = {
                ...node.position
            };
            let moveDistance = $f788aef708b84f00$export$c0ac0a5c7f93677c;
            if (e.shiftKey) moveDistance = $f788aef708b84f00$export$367adc66518209f7;
            else if (e.altKey) moveDistance = $f788aef708b84f00$export$8586a781d0daf2c1;
            if (direction === 'up') updatedPosition.y -= moveDistance;
            if (direction === 'down') updatedPosition.y += moveDistance;
            if (direction === 'left') updatedPosition.x -= moveDistance;
            if (direction === 'right') updatedPosition.x += moveDistance;
            onMoveUpdate?.({
                id: node.id,
                type: node.isInitial ? 'start-node' : 'status',
                position: updatedPosition
            });
        }
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'm' && !node.isMoving && node.position) onMoveStart?.({
            id: node.id,
            type: node.isInitial ? 'start-node' : 'status',
            position: node.position
        });
        if ((e.key === 'Enter' || e.key === ' ') && node.isMoving) onMoveComplete?.();
        if (e.key === 'Escape' && node.isMoving) onMoveCancel?.();
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f788aef708b84f00$var$NodeLabel, {
        node: node
    }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fS5jn.default), {
        validationFlag: node.validationFlag
    }));
    if (isImmutable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "aria-current": isSelected
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
        type: "button",
        "aria-current": isSelected,
        onClick: handleClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        "aria-describedby": describedBy
    }, content);
};
var $f788aef708b84f00$export$2e2bcd8739ae039 = $f788aef708b84f00$var$ListNode;

});
parcelRegister("gzGnz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfac2920faa2cc64$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cfac2920faa2cc64$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    startNodeLabel: {
        "id": "accessible-workflow-diagram.list-navigation.list-node.start-node-label",
        "defaultMessage": "Start - issues transition from here when they're created."
    },
    statusNodeLabel: {
        "id": "accessible-workflow-diagram.list-navigation.list-node.status-node-label",
        "defaultMessage": "{statusName} status."
    },
    startNodeLabelIssueTermRefresh: {
        "id": "accessible-workflow-diagram.list-navigation.list-node.start-node-label-issue-term-refresh",
        "defaultMessage": "Start - transition from here once created."
    }
});

});


parcelRegister("9ci9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $90d46b75afc03c92$export$2e2bcd8739ae039);
// primitive buttons are used here for native level screen reader support
/* eslint-disable @atlaskit/design-system/no-html-button */ 
var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $v1MZY = parcelRequire("v1MZY");

var $2iWdc = parcelRequire("2iWdc");
const $90d46b75afc03c92$export$c0ac0a5c7f93677c = 5;
const $90d46b75afc03c92$export$367adc66518209f7 = 10;
const $90d46b75afc03c92$export$8586a781d0daf2c1 = 1;
const $90d46b75afc03c92$var$ListContainer = ({ position: position, isImmutable: isImmutable = false, describedBy: describedBy, isMoving: isMoving, onFocus: onFocus, onMoveStart: onMoveStart, onMoveUpdate: onMoveUpdate, onMoveComplete: onMoveComplete, onMoveCancel: onMoveCancel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleKeyDown = (e)=>{
        const direction = (0, $v1MZY.DIRECTION_KEYS)[e.key];
        if (isMoving && direction && position) {
            const updatedPosition = {
                ...position
            };
            let moveDistance = $90d46b75afc03c92$export$c0ac0a5c7f93677c;
            if (e.shiftKey) moveDistance = $90d46b75afc03c92$export$367adc66518209f7;
            else if (e.altKey) moveDistance = $90d46b75afc03c92$export$8586a781d0daf2c1;
            if (direction === 'up') updatedPosition.y -= moveDistance;
            if (direction === 'down') updatedPosition.y += moveDistance;
            if (direction === 'left') updatedPosition.x -= moveDistance;
            if (direction === 'right') updatedPosition.x += moveDistance;
            onMoveUpdate({
                id: (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE),
                type: (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE),
                position: updatedPosition
            });
        }
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'm' && !isMoving && position) onMoveStart({
            id: (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE),
            type: (0, $v1MZY.GLOBAL_LOOPS_CONTAINER_TYPE),
            position: position
        });
        if ((e.key === 'Enter' || e.key === ' ') && isMoving) onMoveComplete();
        if (e.key === 'Escape' && isMoving) onMoveCancel();
    };
    if (isImmutable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $2iWdc.default).containerLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("button", {
        type: "button",
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        "aria-describedby": describedBy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), null, formatMessage((0, $2iWdc.default).containerLabel)));
};
var $90d46b75afc03c92$export$2e2bcd8739ae039 = $90d46b75afc03c92$var$ListContainer;

});
parcelRegister("2iWdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9047164c75ebcab$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b9047164c75ebcab$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    navigationListLabel: {
        "id": "accessible-workflow-diagram.list-navigation.navigation-list-label",
        "defaultMessage": "Navigate statuses and transitions in the workflow."
    },
    navigationListDescription: {
        "id": "accessible-workflow-diagram.list-navigation.navigation-list-description",
        "defaultMessage": "Use direction keys to pan diagram. Use plus and minus keys to zoom the diagram."
    },
    initialTransitionListLabel: {
        "id": "accessible-workflow-diagram.list-navigation.initial-transition-list-label",
        "defaultMessage": "First transition."
    },
    statusTransitionsListLabel: {
        "id": "accessible-workflow-diagram.list-navigation.status-transitions-list-label",
        "defaultMessage": "Transitions for {statusName}."
    },
    startNodeMoveStartAnnouncement: {
        "id": "accessible-workflow-diagram.list-navigation.start-node-move-start-announcement",
        "defaultMessage": "Moving start node. Current position x: {x} y: {y}. Change position with arrow keys. Hold \u201Cshift\u201C to make greater movements or \u201Calt\u201C to make finer movements. Confirm with \u201Center\u201C or cancel with \u201Cescape\u201C."
    },
    statusMoveStartAnnouncement: {
        "id": "accessible-workflow-diagram.list-navigation.status-move-start-announcement",
        "defaultMessage": "Moving {statusName} status. Current position x: {x} y: {y}. Change position with arrow keys. Hold \u201Cshift\u201C to make greater movements or \u201Calt\u201C to make finer movements. Confirm with \u201Center\u201C or cancel with \u201Cescape\u201C."
    },
    globalLoopsContainerMoveStartAnnouncement: {
        "id": "accessible-workflow-diagram.list-navigation.global-looped-transitions-container-move-start-announcement",
        "defaultMessage": "Moving global looped transitions container. Current position x: {x} y: {y}. Change position with arrow keys. Hold \u201Cshift\u201C to make greater movements or \u201Calt\u201C to make finer movements. Confirm with \u201Center\u201C or cancel with \u201Cescape\u201C."
    },
    moveUpdateAnnouncement: {
        "id": "accessible-workflow-diagram.list-navigation.move-update-announcement",
        "defaultMessage": "x: {x}, y: {y}"
    },
    moveCompleteAnnouncement: {
        "id": "accessible-workflow-diagram.list-navigation.move-complete-announcement",
        "defaultMessage": "Move completed. New position x: {x} y: {y}"
    },
    moveCancelAnnouncement: {
        "id": "accessible-workflow-diagram.list-navigation.move-cancel-announcement",
        "defaultMessage": "Move canceled."
    },
    editHelpText: {
        "id": "accessible-workflow-diagram.list-navigation.edit-help-text",
        "defaultMessage": "Select to edit details."
    },
    moveHelpText: {
        "id": "accessible-workflow-diagram.list-navigation.move-help-text",
        "defaultMessage": "Press \u201Cm\u201D to enter move mode."
    },
    deleteHelpText: {
        "id": "accessible-workflow-diagram.list-navigation.delete-help-text",
        "defaultMessage": "Select and press \u201Cdelete\u201D to delete."
    },
    globalLoopedTransitionsList: {
        "id": "accessible-workflow-diagram.list-navigation.global-looped-transitions-list",
        "defaultMessage": "Global looped transitions"
    },
    containerLabel: {
        "id": "accessible-workflow-diagram.list-navigation.list-container.container-label",
        "defaultMessage": "Global looped transition container"
    }
});

});


parcelRegister("j23Cu", function(module, exports) {

$parcel$export(module.exports, "getFlattenedStructure", () => $086d54f964c86541$export$320bc7471675c215);
$parcel$export(module.exports, "getMovedPoint", () => $086d54f964c86541$export$68d7f09cf1f03476);

var $jPROM = parcelRequire("jPROM");

var $200fA = parcelRequire("200fA");

var $jCNJE = parcelRequire("jCNJE");
const $086d54f964c86541$var$orderStatuses = (statuses)=>[
        ...statuses
    ].sort((a, b)=>{
        if (a.layout === undefined || b.layout === undefined) return 0;
        if (a.layout.x !== b.layout.x) return a.layout.x - b.layout.x;
        return a.layout.y - b.layout.y;
    });
const $086d54f964c86541$var$getEdge = (transition, type, parentId, errors)=>{
    let validationFlag;
    const allErrors = (errors[transition.id] ?? []).concat(...transition.rules.filter((rule)=>!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(errors[rule.id])).map((rule)=>errors[rule.id]));
    if (allErrors.length) validationFlag = allErrors.some((error)=>error.severity === (0, $200fA.errorSeverity).ERROR) ? (0, $jCNJE.ValidationFlag).Error : (0, $jCNJE.ValidationFlag).Warn;
    return {
        id: transition.id,
        transition: transition,
        type: type,
        parentId: parentId,
        rulesCount: transition.rules.length,
        ...validationFlag ? {
            validationFlag: validationFlag
        } : {},
        canDelete: type !== 'INITIAL'
    };
};
const $086d54f964c86541$var$getNestedEdges = (parentId, transitions, errors)=>{
    const directedTransitions = transitions.filter((transition)=>transition.toRef !== parentId && transition.links && transition.links.some((target)=>target.fromRef === parentId)).map((transition)=>$086d54f964c86541$var$getEdge(transition, transition.type === 'INITIAL' ? 'INITIAL' : 'DIRECTED', parentId, errors));
    const loopedTransitions = transitions.filter((transition)=>transition.toRef === parentId && transition.links && transition.links.some((target)=>target.fromRef === parentId)).map((transition)=>$086d54f964c86541$var$getEdge(transition, 'LOOPED', parentId, errors));
    const globalTransitions = transitions.filter((transition)=>!transition.links.length && transition.toRef === parentId).map((transition)=>$086d54f964c86541$var$getEdge(transition, 'GLOBAL', parentId, errors));
    return [
        ...directedTransitions,
        ...loopedTransitions,
        ...globalTransitions
    ];
};
const $086d54f964c86541$var$getGlobalLoops = (transitions, errors)=>transitions.filter((transition)=>!transition.links.length && transition.toRef === undefined).map((transition)=>$086d54f964c86541$var$getEdge(transition, 'GLOBAL_LOOPED', undefined, errors));
const $086d54f964c86541$export$320bc7471675c215 = (statuses, transitions, startNodePosition, errors = {}, movingItem)=>{
    const initialTransition = transitions.find((transition)=>transition.type === 'INITIAL');
    const initialTransitionTarget = initialTransition?.toRef;
    const startItem = {
        id: (0, $200fA.START_NODE_ID),
        isInitial: true,
        children: $086d54f964c86541$var$getNestedEdges((0, $200fA.START_NODE_ID), transitions, errors),
        isMoving: movingItem?.id === (0, $200fA.START_NODE_ID),
        position: movingItem?.id === (0, $200fA.START_NODE_ID) ? movingItem.position : startNodePosition,
        canDelete: false
    };
    const statusItems = $086d54f964c86541$var$orderStatuses(statuses).map((status)=>{
        const statusErrors = errors?.[status.id] || [];
        const isMoving = movingItem?.id === status.id;
        const canDelete = status.id !== initialTransitionTarget;
        return {
            id: status.id,
            status: status,
            children: $086d54f964c86541$var$getNestedEdges(status.id, transitions, errors),
            ...statusErrors.length ? {
                validationFlag: (0, $jCNJE.ValidationFlag).Error
            } : {},
            isMoving: isMoving,
            position: isMoving ? movingItem.position : status.layout,
            canDelete: canDelete
        };
    });
    const globalLoops = $086d54f964c86541$var$getGlobalLoops(transitions, errors);
    return {
        nodes: [
            startItem,
            ...statusItems
        ],
        globalLoops: globalLoops
    };
};
const $086d54f964c86541$export$68d7f09cf1f03476 = (point, direction, distance)=>{
    const updated = {
        ...point
    };
    if (direction === 'up') updated.y -= distance;
    if (direction === 'down') updated.y += distance;
    if (direction === 'left') updated.x -= distance;
    if (direction === 'right') updated.x += distance;
    return updated;
};

});


parcelRegister("3rQlT", function(module, exports) {

$parcel$export(module.exports, "toDiagramStartNodePosition", () => $df5e23a779805e27$export$dda2237b70238711);
$parcel$export(module.exports, "toDiagramGlobalLoopsContainerPosition", () => $df5e23a779805e27$export$38d5df80e5fbbe05);
$parcel$export(module.exports, "toDiagramStatuses", () => $df5e23a779805e27$export$a68083484778dd7f);
$parcel$export(module.exports, "toDiagramTransitions", () => $df5e23a779805e27$export$5c6df39babffa5d6);
$parcel$export(module.exports, "getTransitionConnectionInfo", () => $df5e23a779805e27$export$49150f61646e15b7);

var $jPROM = parcelRequire("jPROM");

var $iNghu = parcelRequire("iNghu");

var $200fA = parcelRequire("200fA");

var $7jTnu = parcelRequire("7jTnu");

var $jCNJE = parcelRequire("jCNJE");
const $df5e23a779805e27$var$CMP_APPROVAL_RULE_KEY = 'system:block-in-progress-approval';
const $df5e23a779805e27$var$TMP_APPROVAL_APPROVE_RULE_KEY = 'system:jsd-approvals-block-until-approved';
const $df5e23a779805e27$var$TMP_APPROVAL_DECLINE_RULE_KEY = 'system:jsd-approvals-block-until-rejected';
// Helper functions
// ------------------------------------------------------------------------------------------------
const $df5e23a779805e27$var$CMP_ICON_CONFIG = [
    [
        (0, $jCNJE.TransitionIcons).Check,
        (t)=>({ approvalConfiguration: approvalConfiguration })=>!!approvalConfiguration && approvalConfiguration.active === 'true' && approvalConfiguration.transitionApproved === t.id
    ],
    [
        (0, $jCNJE.TransitionIcons).Cross,
        (t)=>({ approvalConfiguration: approvalConfiguration })=>!!approvalConfiguration && approvalConfiguration.active === 'true' && approvalConfiguration.transitionRejected === t.id
    ],
    [
        (0, $jCNJE.TransitionIcons).CheckInactive,
        (t)=>({ approvalConfiguration: approvalConfiguration })=>!!approvalConfiguration && !(approvalConfiguration.active === 'true') && approvalConfiguration.transitionApproved === t.id
    ],
    [
        (0, $jCNJE.TransitionIcons).CrossInactive,
        (t)=>({ approvalConfiguration: approvalConfiguration })=>!!approvalConfiguration && !(approvalConfiguration.active === 'true') && approvalConfiguration.transitionRejected === t.id
    ]
];
const $df5e23a779805e27$var$TMP_ICON_CONFIG = [
    [
        (0, $jCNJE.TransitionIcons).Check,
        ({ config: config, ruleKey: ruleKey })=>ruleKey === $df5e23a779805e27$var$TMP_APPROVAL_APPROVE_RULE_KEY && !!config?.approvalConfigurationJson && typeof config.approvalConfigurationJson === 'string' && JSON.parse(config.approvalConfigurationJson).active
    ],
    [
        (0, $jCNJE.TransitionIcons).Cross,
        ({ config: config, ruleKey: ruleKey })=>ruleKey === $df5e23a779805e27$var$TMP_APPROVAL_DECLINE_RULE_KEY && !!config?.approvalConfigurationJson && typeof config.approvalConfigurationJson === 'string' && JSON.parse(config.approvalConfigurationJson).active
    ],
    [
        (0, $jCNJE.TransitionIcons).CheckInactive,
        ({ config: config, ruleKey: ruleKey })=>ruleKey === $df5e23a779805e27$var$TMP_APPROVAL_APPROVE_RULE_KEY && !!config?.approvalConfigurationJson && typeof config.approvalConfigurationJson === 'string' && !JSON.parse(config.approvalConfigurationJson).active
    ],
    [
        (0, $jCNJE.TransitionIcons).CrossInactive,
        ({ config: config, ruleKey: ruleKey })=>ruleKey === $df5e23a779805e27$var$TMP_APPROVAL_DECLINE_RULE_KEY && !!config?.approvalConfigurationJson && typeof config.approvalConfigurationJson === 'string' && !JSON.parse(config.approvalConfigurationJson).active
    ]
];
const $df5e23a779805e27$var$getCMPApprovalIcons = (statuses, transition)=>$df5e23a779805e27$var$CMP_ICON_CONFIG.map(([type, statusFilter])=>({
            type: type,
            fromStatuses: statuses.filter(statusFilter(transition)).map(({ id: id })=>id)
        })).filter(({ fromStatuses: fromStatuses })=>(fromStatuses ?? []).length > 0);
const $df5e23a779805e27$var$getTMPApprovalIcons = (statuses, { links: links }, rule)=>$df5e23a779805e27$var$TMP_ICON_CONFIG.map(([type, ruleFilter])=>({
            type: type,
            fromStatuses: ruleFilter(rule) ? (links ?? []).map(({ fromRef: fromRef })=>fromRef) : []
        })).filter(({ fromStatuses: fromStatuses })=>(fromStatuses ?? []).length > 0);
const $df5e23a779805e27$var$getApprovalIcons = (statuses, transition)=>(rule)=>{
        switch(rule.ruleKey){
            case $df5e23a779805e27$var$CMP_APPROVAL_RULE_KEY:
                return $df5e23a779805e27$var$getCMPApprovalIcons(statuses, transition, rule);
            case $df5e23a779805e27$var$TMP_APPROVAL_APPROVE_RULE_KEY:
            case $df5e23a779805e27$var$TMP_APPROVAL_DECLINE_RULE_KEY:
                return $df5e23a779805e27$var$getTMPApprovalIcons(statuses, transition, rule);
            default:
                return [];
        }
    };
const $df5e23a779805e27$var$isAnApprovalRule = ({ ruleKey: ruleKey })=>{
    const approvalRuleKeys = [
        $df5e23a779805e27$var$CMP_APPROVAL_RULE_KEY,
        $df5e23a779805e27$var$TMP_APPROVAL_APPROVE_RULE_KEY,
        $df5e23a779805e27$var$TMP_APPROVAL_DECLINE_RULE_KEY
    ];
    return approvalRuleKeys.some((approvalKey)=>ruleKey === approvalKey);
};
/**
 * Merge icons.
 *
 * @param unmerged A list of conditional transition icons that may contain duplicate icons.
 * @returns A merged list of icons with only one entry per icon type.
 */ const $df5e23a779805e27$var$mergeIcons = (unmerged)=>{
    // Take each icon and use its key as an index to a Map. Add each of its fromStatuses entries
    // to a Set to remove duplicates.
    const mergedMap = unmerged.reduce((iconMap, { type: type, fromStatuses: fromStatuses })=>{
        // If this icon key isn't in the Map yet, add it along with an empty set as the value.
        if (!iconMap.has(type)) iconMap.set(type, new Set());
        // Add each of the fromStatuses entries to the set.
        fromStatuses?.forEach((statusId)=>iconMap.get(type)?.add(statusId));
        // Return the Map we just updated.
        return iconMap;
    }, new Map());
    // Convert the map back to an array of ConditionalTransitionIcon objects.
    return [
        ...mergedMap.entries()
    ].map(([type, fromStatuses])=>({
            type: type,
            ...fromStatuses.size > 0 ? {
                fromStatuses: [
                    ...fromStatuses.values()
                ]
            } : {}
        }));
};
const $df5e23a779805e27$export$dda2237b70238711 = (startNodeLayout)=>!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(startNodeLayout.x) && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(startNodeLayout.y) ? {
        x: startNodeLayout.x,
        y: startNodeLayout.y
    } : undefined;
const $df5e23a779805e27$export$38d5df80e5fbbe05 = (globalLoopsContainerLayout)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(globalLoopsContainerLayout)) return undefined;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(globalLoopsContainerLayout.x) || (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(globalLoopsContainerLayout.y)) return undefined;
    return (0, $jCNJE.toPoint)(globalLoopsContainerLayout.x, globalLoopsContainerLayout.y);
};
const $df5e23a779805e27$export$a68083484778dd7f = (statuses, initialStatusId, errors)=>statuses.map((status)=>{
        const statusErrors = (0, $7jTnu.fg)('hix-7004_workflow_editor_naming_global_transitions') ? errors?.[status.id]?.filter((e)=>e.node === 'STATUS') || [] : errors?.[status.id] || [];
        const diagramStatus = {
            id: status.id,
            label: status.name,
            flag: statusErrors.length ? (0, $jCNJE.ValidationFlag).Error : undefined,
            position: status.layout,
            category: status.statusCategory,
            isInitial: status.id === initialStatusId
        };
        return diagramStatus;
    });
const $df5e23a779805e27$var$getTransitionValidationFlag = (transition, errors = {})=>{
    const allErrors = (errors[transition.id] ?? []).concat(...transition.rules.filter((rule)=>!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(errors[rule.id])).map((rule)=>errors[rule.id]));
    if (allErrors.length) return allErrors.some((error)=>error.severity === (0, $200fA.errorSeverity).ERROR) ? (0, $jCNJE.ValidationFlag).Error : (0, $jCNJE.ValidationFlag).Warn;
};
/**
 * To Diagram Transition Icons.
 *
 * Determine what icons should display on the transition label. Transition icons display under the
 * following conditions:
 *
 * | Icon                           | Reason                                |
 * | -------------------------------|---------------------------------------|
 * | **Error**                      | if there is an error or warning flag. |
 * | **Tick/Cross**                 | for an active approval                |
 * | **TickInactive/CrossInactive** | for an inactive approval              |
 * | **Bolt**                       | for any other transition rules        |
 * @param transition The transition.
 * @param availableRules A list of known rules that we consider valid.
 * @param flag Are there any warnings or errors on this transition?
 * @param statuses A list of statuses used in the Workflow (needed to look up approval
 *                 configuration)
 * @returns A list of icons to display on this transition label.
 */ const $df5e23a779805e27$var$toDiagramTransitionIcons = (transition, flag, statuses)=>{
    const errorIcons = flag ? [
        {
            type: (0, $jCNJE.TransitionIcons).Error
        }
    ] : [];
    const approvalIcons = transition.rules.filter($df5e23a779805e27$var$isAnApprovalRule).flatMap($df5e23a779805e27$var$getApprovalIcons(statuses, transition));
    const otherIcons = transition.rules.some((0, (/*@__PURE__*/$parcel$interopDefault($iNghu)))($df5e23a779805e27$var$isAnApprovalRule)) ? [
        {
            type: (0, $jCNJE.TransitionIcons).Bolt
        }
    ] : [];
    return $df5e23a779805e27$var$mergeIcons([
        ...errorIcons,
        ...otherIcons,
        ...approvalIcons
    ]);
};
const $df5e23a779805e27$export$5c6df39babffa5d6 = (transitions, errors = {}, statuses = [])=>transitions.filter((transition)=>{
        return transition.type !== (0, $200fA.transitionType).DIRECTED || transition.links.length > 0;
    }).map((transition)=>{
        const { id: id, type: type, links: links, name: name, toRef: toRef } = transition;
        const flag = $df5e23a779805e27$var$getTransitionValidationFlag(transition, errors);
        const icons = $df5e23a779805e27$var$toDiagramTransitionIcons(transition, flag, statuses);
        if (toRef == null) {
            const globalLoopedTransition = {
                id: id,
                type: 'global-looped',
                flag: flag,
                icons: icons,
                label: name
            };
            return globalLoopedTransition;
        }
        if (type === (0, $200fA.transitionType).GLOBAL) {
            const globalTransition = {
                id: id,
                type: 'global',
                flag: flag,
                icons: icons,
                target: toRef
            };
            return globalTransition;
        }
        if (links.length > 1) {
            const sharedTransition = {
                id: id,
                type: 'shared',
                label: name,
                flag: flag,
                icons: icons,
                target: toRef,
                links: links.map((link)=>({
                        source: link.fromRef,
                        sourceIndex: link.fromPort,
                        targetIndex: link.toPort
                    }))
            };
            return sharedTransition;
        }
        const directTransition = {
            id: id,
            type: 'direct',
            label: name,
            flag: flag,
            icons: icons,
            target: toRef,
            targetIndex: links[0].toPort,
            source: links[0].fromRef,
            sourceIndex: links[0].fromPort
        };
        return directTransition;
    });
const $df5e23a779805e27$export$49150f61646e15b7 = (transition)=>{
    if (transition.type === 'shared') return {
        toRef: transition.target,
        links: transition.links.map((link)=>({
                fromRef: link.source,
                fromPort: link.sourceIndex,
                toPort: link.targetIndex
            }))
    };
    if (transition.type === 'direct') return {
        toRef: transition.target,
        links: [
            {
                fromRef: transition.source,
                fromPort: transition.sourceIndex,
                toPort: transition.targetIndex
            }
        ]
    };
    if (transition.type === 'global-looped') return {
        links: []
    };
    return {
        toRef: transition.target,
        links: []
    };
};

});



parcelRegister("dymbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $42825a5af59db372$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $42825a5af59db372$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6FdCu")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6GQY3")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $c4huj = parcelRequire("c4huj");

var $6GQY3 = parcelRequire("6GQY3");

var $6FdCu = parcelRequire("6FdCu");
const $42825a5af59db372$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6FdCu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6GQY3))
});
var $42825a5af59db372$export$2e2bcd8739ae039 = $42825a5af59db372$var$Illustration;
// for advanced use only
const $42825a5af59db372$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("c4huj", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $23ef7a56b51bae71$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $23ef7a56b51bae71$export$4d00e7be716a0093);

var $eJOHy = parcelRequire("eJOHy");

var $7Tdyj = parcelRequire("7Tdyj");
function $23ef7a56b51bae71$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Tdyj.AsImg), props);
}
function $23ef7a56b51bae71$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23ef7a56b51bae71$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("7Tdyj", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $0b0259f6264d72ea$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58yRG = parcelRequire("58yRG");
// Moved to src/packages/illustrations/illustration/src/ui/types.tsx to avoid circular dependency
// export interface AsImgProps extends IllustrationProps, ImgHTMLAttributes<HTMLImageElement>
// suggested defaults, the consumer is free to override
const $0b0259f6264d72ea$var$defaultStyles = null;
const $0b0259f6264d72ea$var$fillStyles = null;
const $0b0259f6264d72ea$var$autoDarkModeStyles = null;
function $0b0259f6264d72ea$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $58yRG.default)();
    return /*#__PURE__*/ $eJOHy.createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $hcewu.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("6GQY3", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("6FdCu", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("aTJmy", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $484fdcae7d1a2fee$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3xT3U = parcelRequire("3xT3U");
function $484fdcae7d1a2fee$export$ebf64b9217c1b2a3(JiraIllustration = (0, $3xT3U.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $awdRS.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $awdRS.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $hcewu.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("3xT3U", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1b1236d04dc76a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e8HDz")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aiB9q")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $c4huj = parcelRequire("c4huj");

var $aiB9q = parcelRequire("aiB9q");

var $e8HDz = parcelRequire("e8HDz");
const $3b1b1236d04dc76a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e8HDz)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aiB9q))
});
var $3b1b1236d04dc76a$export$2e2bcd8739ae039 = $3b1b1236d04dc76a$var$Illustration;
// for advanced use only
const $3b1b1236d04dc76a$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("aiB9q", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("e8HDz", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("iqtgH", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $57f94b33c65bff71$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $57f94b33c65bff71$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $57f94b33c65bff71$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $57f94b33c65bff71$export$2ccf161b817b43b);

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");


var $gCeeo = parcelRequire("gCeeo");
// eslint-disable-next-line jira/react/no-class-components
class $57f94b33c65bff71$var$FireComponent extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $gCeeo.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $57f94b33c65bff71$export$64eb47d7b94ba089 = (0, $4J0ad.default)()($57f94b33c65bff71$var$FireComponent);
const $57f94b33c65bff71$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57f94b33c65bff71$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $466f60259c330878$export$a1562d08625f5d7e)
    });
const $57f94b33c65bff71$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57f94b33c65bff71$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $466f60259c330878$export$947dac6c72b26f81)
    });
const $57f94b33c65bff71$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57f94b33c65bff71$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $466f60259c330878$export$12346a674644c156)
    });
const $57f94b33c65bff71$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($57f94b33c65bff71$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $466f60259c330878$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});

parcelRegister("eFrz1", function(module, exports) {

$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $a5e28192b76c8457$export$e44126cd87ea434);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $8GOss = parcelRequire("8GOss");
function $a5e28192b76c8457$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $eJOHy.useRef)(false);
    const depsRef = (0, $eJOHy.useRef)(dependencies);
    (0, $eJOHy.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $8GOss.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});

parcelRegister("zBqnt", function(module, exports) {

$parcel$export(module.exports, "ZoomControls", () => $edb9a11c70627a6f$export$782627f418f61db3);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $goZPP = parcelRequire("goZPP");

var $i8jzO = parcelRequire("i8jzO");

var $a8ipI = parcelRequire("a8ipI");

var $MevUn = parcelRequire("MevUn");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $dPMMf = parcelRequire("dPMMf");

var $gCeeo = parcelRequire("gCeeo");

var $lUDpv = parcelRequire("lUDpv");
const $edb9a11c70627a6f$var$zoomIn = (0, $7qGN1.defineMessage)({
    id: 'workflow-view-diagram-modal.zoom-controls.zoom-in',
    defaultMessage: 'Zoom in',
    description: 'Label for workflow editor zoom in button'
});
const $edb9a11c70627a6f$var$zoomOut = (0, $7qGN1.defineMessage)({
    id: 'workflow-view-diagram-modal.zoom-controls.zoom-out',
    defaultMessage: 'Zoom out',
    description: 'Label for workflow editor zoom out button'
});
const $edb9a11c70627a6f$var$zoomSlider = (0, $7qGN1.defineMessage)({
    id: 'workflow-view-diagram-modal.zoom-controls.zoom-slider',
    defaultMessage: 'Zoom level',
    description: 'Label for workflow editor zoom range slider'
});
const $edb9a11c70627a6f$export$782627f418f61db3 = ({ onZoomChange: onZoomChange, zoom: zoom })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const changeZoom = (0, $eJOHy.useCallback)((linearZoom)=>{
        const exponentialZoom = (0, $lUDpv.getExponentialZoom)(linearZoom);
        onZoomChange(exponentialZoom);
    }, [
        onZoomChange
    ]);
    const onZoomIn = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        const linearZoom = (0, $lUDpv.getLinearZoom)(zoom) + (0, $lUDpv.LINEAR_ZOOM_STEP);
        changeZoom(linearZoom);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'zoomIn');
    }, [
        changeZoom,
        zoom
    ]);
    const onZoomOut = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        const linearZoom = (0, $lUDpv.getLinearZoom)(zoom) - (0, $lUDpv.LINEAR_ZOOM_STEP);
        changeZoom(linearZoom);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'zoomOut');
    }, [
        changeZoom,
        zoom
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $edb9a11c70627a6f$var$zoomControlContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $edb9a11c70627a6f$var$zoomControlsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        isDisabled: (0, $lUDpv.isMinimumZoom)((0, $lUDpv.getLinearZoom)(zoom)),
        testId: "workflow-view-diagram-modal.ui.zoom-controls.zoom-out-button",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a8ipI))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)",
            label: ""
        }),
        onClick: onZoomOut,
        "aria-label": formatMessage($edb9a11c70627a6f$var$zoomOut),
        interactionName: "auto-generated.workflow-readonly-modal.ui.diagram.zoom-out-button.button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $MevUn.default), {
        min: (0, $lUDpv.MINIMUM_LINEAR_ZOOM),
        max: (0, $lUDpv.MAXIMUM_LINEAR_ZOOM),
        step: (0, $lUDpv.LINEAR_ZOOM_STEP),
        value: (0, $lUDpv.getLinearZoom)(zoom),
        onChange: changeZoom,
        "aria-label": formatMessage($edb9a11c70627a6f$var$zoomSlider)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "workflow-view-diagram-modal.ui.zoom-controls.zoom-in-button",
        isDisabled: (0, $lUDpv.isMaximumZoom)((0, $lUDpv.getLinearZoom)(zoom)),
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i8jzO))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)",
            label: ""
        }),
        onClick: onZoomIn,
        "aria-label": formatMessage($edb9a11c70627a6f$var$zoomIn),
        interactionName: "auto-generated.workflow-readonly-modal.ui.diagram.zoom-in-button.button1"
    })));
};
const $edb9a11c70627a6f$var$zoomControlContainerStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $edb9a11c70627a6f$var$zoomControlsStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    bottom: 'space.100',
    right: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    width: `${(0, $dPMMf.gridSize) * 25}px`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'color.background.neutral',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    height: `${(0, $dPMMf.gridSize) * 5}px`,
    justifyContent: 'space-evenly',
    paddingTop: 'space.0',
    paddingRight: 'space.050',
    paddingBottom: 'space.0',
    paddingLeft: 'space.050'
});

});
parcelRegister("i8jzO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a77c7787f980fdb0a9bf8aad01cf287>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d33828d98c1b2123$var$_react = $d33828d98c1b2123$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d33828d98c1b2123$var$_zoomIn = $d33828d98c1b2123$var$_interopRequireDefault((parcelRequire("8a7MV")));

var $d33828d98c1b2123$var$_zoomIn2 = $d33828d98c1b2123$var$_interopRequireDefault((parcelRequire("funwk")));
function $d33828d98c1b2123$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ZoomInIcon.
 * This component is ZoomInIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesZoomInIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d33828d98c1b2123$var$ZoomInIcon = (props)=>/*#__PURE__*/ $d33828d98c1b2123$var$_react.default.createElement($d33828d98c1b2123$var$_zoomIn.default, Object.assign({
        LEGACY_fallbackIcon: $d33828d98c1b2123$var$_zoomIn2.default
    }, props));
$d33828d98c1b2123$var$ZoomInIcon.Name = 'ZoomInIconMigration';
var $d33828d98c1b2123$var$_default = module.exports.default = $d33828d98c1b2123$var$ZoomInIcon;

});
parcelRegister("8a7MV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4e3e14173b47c6de5fe1fa37ade34ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f154c6f3bb0e5dd$var$_react = $5f154c6f3bb0e5dd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5f154c6f3bb0e5dd$var$_baseNew = $5f154c6f3bb0e5dd$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5f154c6f3bb0e5dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ZoomIn".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming in of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f154c6f3bb0e5dd$var$ZoomInIcon = (props)=>/*#__PURE__*/ $5f154c6f3bb0e5dd$var$_react.default.createElement($5f154c6f3bb0e5dd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7m5.25.75V10h1.5V7.75H10v-1.5H7.75V4h-1.5v2.25H4v1.5z" clip-rule="evenodd"/>`
    }, props));
$5f154c6f3bb0e5dd$var$ZoomInIcon.displayName = 'ZoomInIcon';
var $5f154c6f3bb0e5dd$var$_default = module.exports.default = $5f154c6f3bb0e5dd$var$ZoomInIcon;

});

parcelRegister("funwk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b46be705f6b42691$var$_react = $b46be705f6b42691$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $b46be705f6b42691$var$_zoomIn = $b46be705f6b42691$var$_interopRequireDefault((parcelRequire("8a7MV")));
function $b46be705f6b42691$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b46be705f6b42691$var$MediaServicesZoomInIcon = (props)=>/*#__PURE__*/ $b46be705f6b42691$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5a1 1 0 0 0 0-2h-2v-2a1 1 0 0 0-2 0v2h-2a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2z"/></svg>`
    }, props, {
        newIcon: $b46be705f6b42691$var$_zoomIn.default
    }));
$b46be705f6b42691$var$MediaServicesZoomInIcon.displayName = 'MediaServicesZoomInIcon';
var $b46be705f6b42691$var$_default = module.exports.default = $b46be705f6b42691$var$MediaServicesZoomInIcon;

});


parcelRegister("a8ipI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30577ec4e1eb084dbdbe0787dd497bd1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7608ef4f8b7c1e88$var$_react = $7608ef4f8b7c1e88$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7608ef4f8b7c1e88$var$_zoomOut = $7608ef4f8b7c1e88$var$_interopRequireDefault((parcelRequire("4ABXT")));

var $7608ef4f8b7c1e88$var$_zoomOut2 = $7608ef4f8b7c1e88$var$_interopRequireDefault((parcelRequire("djL4Z")));
function $7608ef4f8b7c1e88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ZoomOutIcon.
 * This component is ZoomOutIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesZoomOutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming out of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7608ef4f8b7c1e88$var$ZoomOutIcon = (props)=>/*#__PURE__*/ $7608ef4f8b7c1e88$var$_react.default.createElement($7608ef4f8b7c1e88$var$_zoomOut.default, Object.assign({
        LEGACY_fallbackIcon: $7608ef4f8b7c1e88$var$_zoomOut2.default
    }, props));
$7608ef4f8b7c1e88$var$ZoomOutIcon.Name = 'ZoomOutIconMigration';
var $7608ef4f8b7c1e88$var$_default = module.exports.default = $7608ef4f8b7c1e88$var$ZoomOutIcon;

});
parcelRegister("4ABXT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37fb24f79715a5e8762f768d1ae974b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3577f94bcca5bdcf$var$_react = $3577f94bcca5bdcf$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3577f94bcca5bdcf$var$_baseNew = $3577f94bcca5bdcf$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3577f94bcca5bdcf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ZoomOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for zooming out of an object or view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3577f94bcca5bdcf$var$ZoomOutIcon = (props)=>/*#__PURE__*/ $3577f94bcca5bdcf$var$_react.default.createElement($3577f94bcca5bdcf$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7m9 .75H4v-1.5h6z" clip-rule="evenodd"/>`
    }, props));
$3577f94bcca5bdcf$var$ZoomOutIcon.displayName = 'ZoomOutIcon';
var $3577f94bcca5bdcf$var$_default = module.exports.default = $3577f94bcca5bdcf$var$ZoomOutIcon;

});

parcelRegister("djL4Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b2191b2796f101f$var$_react = $9b2191b2796f101f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $9b2191b2796f101f$var$_zoomOut = $9b2191b2796f101f$var$_interopRequireDefault((parcelRequire("4ABXT")));
function $9b2191b2796f101f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b2191b2796f101f$var$MediaServicesZoomOutIcon = (props)=>/*#__PURE__*/ $9b2191b2796f101f$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M13.5 11.5h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2"/></svg>`
    }, props, {
        newIcon: $9b2191b2796f101f$var$_zoomOut.default
    }));
$9b2191b2796f101f$var$MediaServicesZoomOutIcon.displayName = 'MediaServicesZoomOutIcon';
var $9b2191b2796f101f$var$_default = module.exports.default = $9b2191b2796f101f$var$MediaServicesZoomOutIcon;

});


parcelRegister("MevUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c0f57dfc7b1472c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $dbgh6 = parcelRequire("dbgh6");
const $9c0f57dfc7b1472c$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $9c0f57dfc7b1472c$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $9c0f57dfc7b1472c$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $9c0f57dfc7b1472c$var$noop = (0, $3Vuhz.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $9c0f57dfc7b1472c$var$Range = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $9c0f57dfc7b1472c$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $eJOHy.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $eJOHy.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $9c0f57dfc7b1472c$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dbgh6.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $9c0f57dfc7b1472c$export$2e2bcd8739ae039 = $9c0f57dfc7b1472c$var$Range;

});
parcelRegister("dbgh6", function(module, exports) {

$parcel$export(module.exports, "Input", () => $b65ac72e66820907$export$f5b8910cec6cf069);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b65ac72e66820907$var$rangeHeight = 40; // Height of the range input, used for the track and thumb
const $b65ac72e66820907$var$trackHeight = 6; // Height of the track, used for the track and thumb
const $b65ac72e66820907$var$thumbSize = "var(--ds-space-200, 16px)"; // Size of the thumb, used for the thumb styles
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $b65ac72e66820907$var$webkitStyles = null;
const $b65ac72e66820907$var$firefoxStyles = null;
const $b65ac72e66820907$var$baseStyles = null;
const $b65ac72e66820907$var$themeStyles = null;
const $b65ac72e66820907$var$trackStyles = {
    root: "_1bsb1osq _4t3i1ylp _kqswh2mm _14mj1q5u _1ywu1ule _z0ai1y44 _1qdg1y44 _18postnw _1hfk1b6k _aetrb3bt _19nq1ssb _g0nfo1yi",
    disabled: "_1peq2wxo"
};
const $b65ac72e66820907$var$rangeA11yStyles = null;
const $b65ac72e66820907$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    const input = /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $hcewu.default)([
            "_1bsb1osq _4t3i1ylp _bfhk18uv _j5dh13gf _1j552wxo _nt751r31 _49pcglyw _1hvw1o36",
            "_wstuglyw _h2ksglyw _1kdl1q5u _m8f8g56u _1yz62hjt _1bdkusvi _u98zpxbi _1j70pxbi _1esf5udg _4w431ik2 _yfyntlke _1sdc196n _18k7v77o _1cdcglyw _10lridpf _g6tdyh40 _vi4t2hjt _1g2h1osq _168l1y44 _9u3f2hce _1g741hsc _1d8tmgnk _np53xlkz _18tdtlke _1p201osq _1yte13gf _5i7a13gf",
            "_1yq0glyw _108m1q5u _1rf3g56u _1yeu2hjt _g4ppusvi _r763pxbi _1mn5pxbi _12el5udg _1oqe1ik2 _10o7tlke _1kzev77o _15raidpf _e8hnidpf _37ywyh40 _1tcb2hjt _aoww1osq _1kd2i2wt _vt2s1w6o _1ssqtlke _ru37idpf _1gvoyh40 _1nx42hjt _1f5t1osq _142y1y44 _d7w62hce _b3fmtlke _1vq313gf _1fov13gf _34m613gf",
            "_14h11kge _15dp1yrq _18lxyvsn _jxar1eo5 _ydqghkel _1jhc1eo5 _1ruc16ss _164c194a",
            "_1drq1b6k _15dp1vck _18lx1b6k _g6td1l7b _168li2wt _37yw1l7b _1kd2i2wt _1sdc1lpd _ydqgmpja"
        ])
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $b65ac72e66820907$var$trackStyles.root,
            strippedProps.disabled && $b65ac72e66820907$var$trackStyles.disabled
        ]),
        children: input
    });
});
$b65ac72e66820907$export$f5b8910cec6cf069.displayName = 'InputRange';

});


parcelRegister("lUDpv", function(module, exports) {

$parcel$export(module.exports, "LINEAR_ZOOM_STEP", () => $f7cdf0243434eb3c$export$242961008b66e9eb);
$parcel$export(module.exports, "MAXIMUM_LINEAR_ZOOM", () => $f7cdf0243434eb3c$export$a03183ee488d90a1);
$parcel$export(module.exports, "MINIMUM_LINEAR_ZOOM", () => $f7cdf0243434eb3c$export$7a22dde642b71bba);
$parcel$export(module.exports, "getLinearZoom", () => $f7cdf0243434eb3c$export$92ad4ab75b1348d7);
$parcel$export(module.exports, "getExponentialZoom", () => $f7cdf0243434eb3c$export$1c090fe1906100fd);
$parcel$export(module.exports, "isMinimumZoom", () => $f7cdf0243434eb3c$export$5927d9e97896a612);
$parcel$export(module.exports, "isMaximumZoom", () => $f7cdf0243434eb3c$export$57b05d706f3e3c4b);

var $7Ir2t = parcelRequire("7Ir2t");
const $f7cdf0243434eb3c$var$EXPONENTIAL_ZOOM_BASE = 2;
const $f7cdf0243434eb3c$var$LOGRAITHMIC_ZOOM_BASE = Math.log(2);
const $f7cdf0243434eb3c$export$242961008b66e9eb = 0.1;
const $f7cdf0243434eb3c$export$a03183ee488d90a1 = 1;
const $f7cdf0243434eb3c$export$7a22dde642b71bba = -1;
const $f7cdf0243434eb3c$export$2f33dadfcecbdcd2 = 5;
const $f7cdf0243434eb3c$export$92ad4ab75b1348d7 = (exponentialZoom)=>Math.log(exponentialZoom) / $f7cdf0243434eb3c$var$LOGRAITHMIC_ZOOM_BASE;
const $f7cdf0243434eb3c$export$1c090fe1906100fd = (linearZoom)=>$f7cdf0243434eb3c$var$EXPONENTIAL_ZOOM_BASE ** linearZoom;
const $f7cdf0243434eb3c$export$5927d9e97896a612 = (exponentialZoom)=>(0, (/*@__PURE__*/$parcel$interopDefault($7Ir2t)))(exponentialZoom, $f7cdf0243434eb3c$export$2f33dadfcecbdcd2) === $f7cdf0243434eb3c$export$7a22dde642b71bba;
const $f7cdf0243434eb3c$export$57b05d706f3e3c4b = (exponentialZoom)=>(0, (/*@__PURE__*/$parcel$interopDefault($7Ir2t)))(exponentialZoom, $f7cdf0243434eb3c$export$2f33dadfcecbdcd2) === $f7cdf0243434eb3c$export$a03183ee488d90a1;

});
parcelRegister("7Ir2t", function(module, exports) {

var $7fwUm = parcelRequire("7fwUm");
/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */ var $59e19dd36f25e1a2$var$round = $7fwUm('round');
module.exports = $59e19dd36f25e1a2$var$round;

});
parcelRegister("7fwUm", function(module, exports) {

var $NROo8 = parcelRequire("NROo8");

var $c9FP3 = parcelRequire("c9FP3");

var $fQnJZ = parcelRequire("fQnJZ");

var $cz1WF = parcelRequire("cz1WF");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $547375f3db519b65$var$nativeIsFinite = $NROo8.isFinite, $547375f3db519b65$var$nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function $547375f3db519b65$var$createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = $fQnJZ(number);
        precision = precision == null ? 0 : $547375f3db519b65$var$nativeMin($c9FP3(precision), 292);
        if (precision && $547375f3db519b65$var$nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = ($cz1WF(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = ($cz1WF(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
    };
}
module.exports = $547375f3db519b65$var$createRound;

});








parcelRegister("1Tehl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAccessRouteEntry", () => $d5ac99ec81eb3322$export$1a764e0ec9764809);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $bAJhM = parcelRequire("bAJhM");

var $9NmsS = parcelRequire("9NmsS");

var $6VM06 = parcelRequire("6VM06");
const $d5ac99ec81eb3322$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $d5ac99ec81eb3322$export$1a764e0ec9764809 = (0, $bAJhM.createLegacyEntry)((0, $6VM06.globalSettingsProductsAccessRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: (0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$d5ac99ec81eb3322$var$pageEntryPoint
    }));

});
parcelRegister("fc9ma", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97f84d2af4da2a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $a97f84d2af4da2a3$var$LazyGlobalProductsSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("4qPhy")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
});
const $a97f84d2af4da2a3$var$GlobalProductsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalProductsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a97f84d2af4da2a3$var$LazyGlobalProductsSettingsSidebar, null)));
$a97f84d2af4da2a3$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
var $a97f84d2af4da2a3$export$2e2bcd8739ae039 = $a97f84d2af4da2a3$var$GlobalProductsSettingsSidebar;

});
parcelRegister("4qPhy", function(module, exports) {

let $33a15eb3830ab369$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $33a15eb3830ab369$var$load("kVX56"),
    $33a15eb3830ab369$var$load("ffQaD"),
    $33a15eb3830ab369$var$load("kvRbA"),
    $33a15eb3830ab369$var$load("76n7a"),
    $33a15eb3830ab369$var$load("l253H"),
    $33a15eb3830ab369$var$load("3oeBN")
]).then(()=>parcelRequire('ixDlv'));

});


parcelRegister("6VM06", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAccessRoute", () => $26c1506a5b5ecf8c$export$622d63534e0526a7);
const $26c1506a5b5ecf8c$export$622d63534e0526a7 = {
    name: 'global-settings-products-access',
    path: '/secure/admin/ApplicationAccess.jspa'
};

});


parcelRegister("dJWtX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRouteEntry", () => $83c6af90c77fa901$export$c3b9f18ebde289c);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $bAJhM = parcelRequire("bAJhM");

var $9NmsS = parcelRequire("9NmsS");

var $ekJpG = parcelRequire("ekJpG");
const $83c6af90c77fa901$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $83c6af90c77fa901$export$c3b9f18ebde289c = (0, $bAJhM.createLegacyEntry)((0, $ekJpG.globalSettingsProductsAdvancedRoadmapsHierarchyRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: (0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$83c6af90c77fa901$var$pageEntryPoint
    }));

});
parcelRegister("ekJpG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsAdvancedRoadmapsHierarchyRoute", () => $d80f77749cee38db$export$40d4fd2626eca72c);
const $d80f77749cee38db$export$40d4fd2626eca72c = {
    name: 'global-settings-products-advanced-roadmaps-hierarchy',
    path: '/secure/PortfolioHierarchy.jspa'
};

});


parcelRegister("aaJF7", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsApplinksRouteEntry", () => $8ee1ea953f073714$export$3dcc4ef9452eebbe);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $bAJhM = parcelRequire("bAJhM");

var $9NmsS = parcelRequire("9NmsS");

var $ckuN0 = parcelRequire("ckuN0");
const $8ee1ea953f073714$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $8ee1ea953f073714$export$3dcc4ef9452eebbe = (0, $bAJhM.createLegacyEntry)((0, $ckuN0.globalSettingsProductsApplinksRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: (0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$8ee1ea953f073714$var$pageEntryPoint
    }));

});
parcelRegister("ckuN0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsApplinksRoute", () => $ab1644c96246de14$export$8ff9863beab5519d);
const $ab1644c96246de14$export$8ff9863beab5519d = {
    name: 'global-settings-products-applinks',
    path: '/plugins/servlet/applinks/listApplicationLinks'
};

});


parcelRegister("4m94G", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRouteEntry", () => $26561e9ddf945def$export$8d7fb911e3ad15ce);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $bAJhM = parcelRequire("bAJhM");

var $9NmsS = parcelRequire("9NmsS");

var $8X3mY = parcelRequire("8X3mY");
const $26561e9ddf945def$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $26561e9ddf945def$export$8d7fb911e3ad15ce = (0, $bAJhM.createLegacyEntry)((0, $8X3mY.globalSettingsProductsDvcsBitbucketRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            // NOTE: the sidebar is rendered for this in Nav V2 too, but there's no corresponding sidebar item?
            sidebar: (0, $fc9ma.default)
        },
        resources: (0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$26561e9ddf945def$var$pageEntryPoint
    }));

});
parcelRegister("8X3mY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsBitbucketRoute", () => $6818adb2f97e1cec$export$463d647a53bdebee);
const $6818adb2f97e1cec$export$463d647a53bdebee = {
    name: 'global-settings-products-dvcs-bitbucket',
    path: '/secure/BitbucketPostInstallApprovalAction.jspa'
};

});


parcelRegister("g5WsZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsRouteEntry", () => $99918c2c6a89de87$export$7970dfc3b824c864);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $bAJhM = parcelRequire("bAJhM");

var $9NmsS = parcelRequire("9NmsS");

var $gaAZt = parcelRequire("gaAZt");
const $99918c2c6a89de87$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $99918c2c6a89de87$export$7970dfc3b824c864 = (0, $bAJhM.createLegacyEntry)((0, $gaAZt.globalSettingsProductsDvcsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: (0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$99918c2c6a89de87$var$pageEntryPoint
    }));

});
parcelRegister("gaAZt", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsDvcsRoute", () => $3c29c25bc2b6c0eb$export$75d086bb3dd16edc);
const $3c29c25bc2b6c0eb$export$75d086bb3dd16edc = {
    name: 'global-settings-products-dvcs',
    path: '/secure/admin/ConfigureDvcsOrganizations!default.jspa'
};

});


parcelRegister("iHmm8", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsJsdStatusRouteEntry", () => $ac916691731889f6$export$5f4b9c737cade2ac);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $bAJhM = parcelRequire("bAJhM");

var $9NmsS = parcelRequire("9NmsS");

var $lqF5v = parcelRequire("lqF5v");
const $ac916691731889f6$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $ac916691731889f6$export$5f4b9c737cade2ac = (0, $bAJhM.createLegacyEntry)((0, $lqF5v.globalSettingsProductsJsdStatusRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: (0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$ac916691731889f6$var$pageEntryPoint
    }));

});
parcelRegister("lqF5v", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsJsdStatusRoute", () => $b3bcd7f1607028c7$export$a0292a772bf703a0);
const $b3bcd7f1607028c7$export$a0292a772bf703a0 = {
    name: 'global-settings-products-jsd-status',
    path: '/plugins/servlet/ac/jsd-status-page'
};

});


parcelRegister("famXV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdconfigRouteEntry", () => $b09e1b010975ef3c$export$cb6362a400fffb25);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $bAJhM = parcelRequire("bAJhM");

var $9NmsS = parcelRequire("9NmsS");

var $4GUAM = parcelRequire("4GUAM");
const $b09e1b010975ef3c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b09e1b010975ef3c$export$cb6362a400fffb25 = (0, $bAJhM.createLegacyEntry)((0, $4GUAM.globalSettingsProductsSdconfigRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: (0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$b09e1b010975ef3c$var$pageEntryPoint
    }));

});
parcelRegister("4GUAM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdconfigRoute", () => $a4d4f0930ead7b05$export$846e5cd0d5151fde);
const $a4d4f0930ead7b05$export$846e5cd0d5151fde = {
    name: 'global-settings-products-sdconfig',
    path: '/secure/admin/SDConfiguration.jspa'
};

});


parcelRegister("5fVfO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdmailRouteEntry", () => $c79574b85f2791e3$export$e296aae86525a621);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $bAJhM = parcelRequire("bAJhM");

var $9NmsS = parcelRequire("9NmsS");

var $4Y05o = parcelRequire("4Y05o");
const $c79574b85f2791e3$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $c79574b85f2791e3$export$e296aae86525a621 = (0, $bAJhM.createLegacyEntry)((0, $4Y05o.globalSettingsProductsSdmailRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: (0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$c79574b85f2791e3$var$pageEntryPoint
    }));

});
parcelRegister("4Y05o", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSdmailRoute", () => $a0bfec88078b78b0$export$e35c6c6fbfbb5111);
const $a0bfec88078b78b0$export$e35c6c6fbfbb5111 = {
    name: 'global-settings-products-sdmail',
    path: '/secure/admin/SDMailInfo.jspa'
};

});


parcelRegister("7tjoT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRouteEntry", () => $26b89c3ec1f6dec6$export$3e9459c1e240d138);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $fc9ma = parcelRequire("fc9ma");

var $bAJhM = parcelRequire("bAJhM");

var $9NmsS = parcelRequire("9NmsS");

var $6DzmV = parcelRequire("6DzmV");
const $26b89c3ec1f6dec6$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $26b89c3ec1f6dec6$export$3e9459c1e240d138 = (0, $bAJhM.createLegacyEntry)((0, $6DzmV.globalSettingsProductsSoftwareConfigRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
            sidebar: (0, $fc9ma.default)
        },
        resources: (0, $9NmsS.getNavigationSidebarProductsSettingResource)(),
        entryPoint: ()=>$26b89c3ec1f6dec6$var$pageEntryPoint
    }));

});
parcelRegister("6DzmV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProductsSoftwareConfigRoute", () => $b51b21a290207fbc$export$5b270f25cf4ae11c);
const $b51b21a290207fbc$export$5b270f25cf4ae11c = {
    name: 'global-settings-products-software-config',
    path: '/secure/SoftwareConfig.jspa',
    query: [
        'decorator=admin'
    ]
};

});


parcelRegister("gzBNt", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRouteEntry", () => $3cf57d9ad13011a4$export$ecfb2cc5a7593980);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $kASOI = parcelRequire("kASOI");
const $3cf57d9ad13011a4$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $3cf57d9ad13011a4$export$ecfb2cc5a7593980 = (0, $bAJhM.createLegacyEntry)((0, $kASOI.globalSettingsProjectsCategoriesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$3cf57d9ad13011a4$var$pageEntryPoint
    }));

});
parcelRegister("vJYlr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b77bce2b95f32c3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Dw1w = parcelRequire("8Dw1w");

var $7DXwW = parcelRequire("7DXwW");

var $bQWwW = parcelRequire("bQWwW");

const $5b77bce2b95f32c3$var$LazyGlobalProjectsSettingsSidebar = (0, $bQWwW.lazyAfterPaint)(()=>{
    (0, $7DXwW.setPerformanceMarkLoadStart)();
    return (parcelRequire("kScbP")).then((bundle)=>{
        (0, $7DXwW.setPerformanceMarkLoadEnd)();
        return bundle;
    });
}, {
    moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
});
const $5b77bce2b95f32c3$var$GlobalProjectsSettingsSidebar = /*#__PURE__*/ (0, $eJOHy.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Dw1w.SidebarBoundary), {
        id: "globalProjectsSettings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5b77bce2b95f32c3$var$LazyGlobalProjectsSettingsSidebar, null)));
$5b77bce2b95f32c3$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
var $5b77bce2b95f32c3$export$2e2bcd8739ae039 = $5b77bce2b95f32c3$var$GlobalProjectsSettingsSidebar;

});
parcelRegister("kScbP", function(module, exports) {

let $f3224e6c608fc5e0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f3224e6c608fc5e0$var$load("iW52P").then(()=>parcelRequire('kdaCi'));

});


parcelRegister("kASOI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesDeleteRoute", () => $8d8e6a4b3524a10b$export$f155c76657570a56);
const $8d8e6a4b3524a10b$export$f155c76657570a56 = {
    name: 'global-settings-projects-categories-delete',
    path: '/secure/admin/projectcategories/DeleteProjectCategory([!%]?[\\w]*).jspa'
};

});


parcelRegister("eXRbc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRouteEntry", () => $2a9614cc062e73c2$export$8364dd961ae6c494);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $hIgzY = parcelRequire("hIgzY");
const $2a9614cc062e73c2$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $2a9614cc062e73c2$export$8364dd961ae6c494 = (0, $bAJhM.createLegacyEntry)((0, $hIgzY.globalSettingsProjectsCategoriesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$2a9614cc062e73c2$var$pageEntryPoint
    }));

});
parcelRegister("hIgzY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesEditRoute", () => $9aa5f51db28bf8fc$export$53d7a3e6e69ec873);
const $9aa5f51db28bf8fc$export$53d7a3e6e69ec873 = {
    name: 'global-settings-projects-categories-edit',
    path: '/secure/admin/projectcategories/EditProjectCategory([!%]?[\\w]*).jspa'
};

});


parcelRegister("dSQ0S", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRouteEntry", () => $8fb2cc190436c162$export$f53b9ac05cdf2fe8);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $vJYlr = parcelRequire("vJYlr");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $1B0C0 = parcelRequire("1B0C0");
const $8fb2cc190436c162$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $8fb2cc190436c162$export$f53b9ac05cdf2fe8 = (0, $bAJhM.createLegacyEntry)((0, $1B0C0.globalSettingsProjectsCategoriesViewRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
            sidebar: (0, $vJYlr.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8fb2cc190436c162$var$pageEntryPoint
    }));

});
parcelRegister("1B0C0", function(module, exports) {

$parcel$export(module.exports, "globalSettingsProjectsCategoriesViewRoute", () => $74ee1461669881ab$export$17ada00b0bde9ebc);
const $74ee1461669881ab$export$17ada00b0bde9ebc = {
    name: 'global-settings-projects-categories-view',
    path: '/secure/admin/projectcategories/ViewProjectCategories([!%]?[\\w]*).jspa'
};

});


parcelRegister("fvbLJ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRouteEntry", () => $ec03b075bed06916$export$48579ce5caedb688);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $4l3RP = parcelRequire("4l3RP");
const $ec03b075bed06916$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $ec03b075bed06916$export$48579ce5caedb688 = (0, $bAJhM.createLegacyEntry)((0, $4l3RP.globalSettingsSystemApplicationAdvancedRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ec03b075bed06916$var$pageEntryPoint
    }));

});
parcelRegister("4l3RP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationAdvancedRoute", () => $7472a6bc0c28a249$export$e79dd086a8ca16b7);
const $7472a6bc0c28a249$export$e79dd086a8ca16b7 = {
    name: 'global-settings-system-application-advanced',
    path: '/secure/admin/AdvancedApplicationProperties.jspa'
};

});


parcelRegister("dQh8f", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationEditRouteEntry", () => $639317e0aff44142$export$cb756194922d59f5);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $ciLBE = parcelRequire("ciLBE");
const $639317e0aff44142$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $639317e0aff44142$export$cb756194922d59f5 = (0, $bAJhM.createLegacyEntry)((0, $ciLBE.globalSettingsSystemApplicationEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$639317e0aff44142$var$pageEntryPoint
    }));

});
parcelRegister("ciLBE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationEditRoute", () => $c281183a27e8c572$export$3cfb7004aee9915c);
const $c281183a27e8c572$export$3cfb7004aee9915c = {
    name: 'global-settings-system-application-edit',
    path: '/secure/admin/EditApplicationProperties([!%]?[\\w]*).jspa'
};

});


parcelRegister("gdeBt", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationViewRouteEntry", () => $ac888983c0eac960$export$c97a0463677004d2);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $joCJu = parcelRequire("joCJu");
const $ac888983c0eac960$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $ac888983c0eac960$export$c97a0463677004d2 = (0, $bAJhM.createLegacyEntry)((0, $joCJu.globalSettingsSystemApplicationViewRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$ac888983c0eac960$var$pageEntryPoint
    }));

});
parcelRegister("joCJu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemApplicationViewRoute", () => $ba43929c1271bc18$export$5ddf1dd9c57a9326);
const $ba43929c1271bc18$export$5ddf1dd9c57a9326 = {
    name: 'global-settings-system-application-view',
    path: '/secure/admin/ViewApplicationProperties.jspa'
};

});


parcelRegister("6nkSg", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAttachmentsRouteEntry", () => $339302b007f4c12c$export$a692196c89a01817);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $fhqRa = parcelRequire("fhqRa");

var $5fjzQ = parcelRequire("5fjzQ");
const $339302b007f4c12c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $339302b007f4c12c$export$a692196c89a01817 = (0, $bAJhM.createLegacyEntry)((0, $fhqRa.globalSettingsSystemAttachmentsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$339302b007f4c12c$var$pageEntryPoint
    }));

});
parcelRegister("fhqRa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAttachmentsRoute", () => $58775bef6b94d1ec$export$717d7ab74cb9ce91);
const $58775bef6b94d1ec$export$717d7ab74cb9ce91 = {
    name: 'global-settings-system-attachments',
    path: '/secure/admin/ViewAttachmentSettings.jspa'
};

});


parcelRegister("3oiql", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAuditingRouteEntry", () => $9116661c62d7f4c5$export$7484cb4db3cfbf3f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $6UTZU = parcelRequire("6UTZU");

var $5fjzQ = parcelRequire("5fjzQ");
const $9116661c62d7f4c5$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $9116661c62d7f4c5$export$7484cb4db3cfbf3f = (0, $bAJhM.createLegacyEntry)((0, $6UTZU.globalSettingsSystemAuditingRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$9116661c62d7f4c5$var$pageEntryPoint
    }));

});
parcelRegister("6UTZU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemAuditingRoute", () => $5532a302da2e4c23$export$b8241cf6a8335186);
const $5532a302da2e4c23$export$b8241cf6a8335186 = {
    name: 'global-settings-system-auditing',
    path: '/auditing/:page'
};

});


parcelRegister("6RA6R", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemCollectorsRouteEntry", () => $330d4ef5b299cdf4$export$a46b2c4865857bde);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $eLcWW = parcelRequire("eLcWW");

var $5fjzQ = parcelRequire("5fjzQ");
const $330d4ef5b299cdf4$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $330d4ef5b299cdf4$export$a46b2c4865857bde = (0, $bAJhM.createLegacyEntry)((0, $eLcWW.globalSettingsSystemCollectorsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$330d4ef5b299cdf4$var$pageEntryPoint
    }));

});
parcelRegister("eLcWW", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemCollectorsRoute", () => $c4d26786702edf8f$export$69ef22f1d54c39dc);
const $c4d26786702edf8f$export$69ef22f1d54c39dc = {
    name: 'global-settings-system-collectors',
    path: '/secure/admin/ViewGlobalCollectors([!%]?[\\w]*).jspa'
};

});


parcelRegister("1XHLb", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRouteEntry", () => $d746a395f0f28d1c$export$3ba7ed3247e0da7);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $cLv7s = parcelRequire("cLv7s");

var $5fjzQ = parcelRequire("5fjzQ");
const $d746a395f0f28d1c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $d746a395f0f28d1c$export$3ba7ed3247e0da7 = (0, $bAJhM.createLegacyEntry)((0, $cLv7s.globalSettingsSystemDefaultSettingsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$d746a395f0f28d1c$var$pageEntryPoint
    }));

});
parcelRegister("cLv7s", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemDefaultSettingsRoute", () => $1a92b84691ad27d2$export$d8f4254e5ee116aa);
const $1a92b84691ad27d2$export$d8f4254e5ee116aa = {
    name: 'global-settings-system-default-settings',
    path: '/secure/admin/ViewUserDefaultSettings([!%]?[\\w]*).jspa'
};

});


parcelRegister("ddtkm", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsAddRouteEntry", () => $b75560479c38cc58$export$18dc7c450d001255);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $lOJvY = parcelRequire("lOJvY");
const $b75560479c38cc58$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b75560479c38cc58$export$18dc7c450d001255 = (0, $bAJhM.createLegacyEntry)((0, $lOJvY.globalSettingsSystemEventsAddRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$b75560479c38cc58$var$pageEntryPoint
    }));

});
parcelRegister("lOJvY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsAddRoute", () => $6d72610607eae0e5$export$3bafc84a5f76a507);
const $6d72610607eae0e5$export$3bafc84a5f76a507 = {
    name: 'global-settings-system-events-add',
    path: '/secure/admin/AddEventType.jspa'
};

});


parcelRegister("g5O1X", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsDeleteRouteEntry", () => $4c1a464bfcda32a1$export$82ec56d45583ff5a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $c9jFl = parcelRequire("c9jFl");
const $4c1a464bfcda32a1$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $4c1a464bfcda32a1$export$82ec56d45583ff5a = (0, $bAJhM.createLegacyEntry)((0, $c9jFl.globalSettingsSystemEventsDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$4c1a464bfcda32a1$var$pageEntryPoint
    }));

});
parcelRegister("c9jFl", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsDeleteRoute", () => $016ad99ff2a58efa$export$cf0c62e05603f7e1);
const $016ad99ff2a58efa$export$cf0c62e05603f7e1 = {
    name: 'global-settings-system-events-delete',
    path: '/secure/admin/DeleteEventType.jspa'
};

});


parcelRegister("d6CiY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsEditRouteEntry", () => $c41a4fc4bb87c615$export$5700f7202370e9c4);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $8UbHF = parcelRequire("8UbHF");
const $c41a4fc4bb87c615$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $c41a4fc4bb87c615$export$5700f7202370e9c4 = (0, $bAJhM.createLegacyEntry)((0, $8UbHF.globalSettingsSystemEventsEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$c41a4fc4bb87c615$var$pageEntryPoint
    }));

});
parcelRegister("8UbHF", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsEditRoute", () => $79c98ab8cd3f044e$export$9bf98baef9abe3eb);
const $79c98ab8cd3f044e$export$9bf98baef9abe3eb = {
    name: 'global-settings-system-events-edit',
    path: '/secure/admin/EditEventType.jspa'
};

});


parcelRegister("2Qjmz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsRouteEntry", () => $a83b79b598549130$export$431e68e0ed553cca);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $5l0te = parcelRequire("5l0te");

var $5fjzQ = parcelRequire("5fjzQ");
const $a83b79b598549130$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $a83b79b598549130$export$431e68e0ed553cca = (0, $bAJhM.createLegacyEntry)((0, $5l0te.globalSettingsSystemEventsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$a83b79b598549130$var$pageEntryPoint
    }));

});
parcelRegister("5l0te", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemEventsRoute", () => $724289f5cf6c4282$export$c294ba50eb736e7b);
const $724289f5cf6c4282$export$c294ba50eb736e7b = {
    name: 'global-settings-system-events',
    path: '/secure/admin/ListEventTypes.jspa'
};

});


parcelRegister("fZo08", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemExportRouteEntry", () => $f66b0299a6975dbb$export$78effb39671690ca);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $imo4J = parcelRequire("imo4J");

var $5fjzQ = parcelRequire("5fjzQ");
const $f66b0299a6975dbb$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $f66b0299a6975dbb$export$78effb39671690ca = (0, $bAJhM.createLegacyEntry)((0, $imo4J.globalSettingsSystemExportRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$f66b0299a6975dbb$var$pageEntryPoint
    }));

});
parcelRegister("imo4J", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemExportRoute", () => $9babfaca78bd748a$export$e398684ea718a2e7);
const $9babfaca78bd748a$export$e398684ea718a2e7 = {
    name: 'global-settings-system-export',
    path: '/secure/admin/CloudExport.jspa'
};

});


parcelRegister("PQv9I", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRouteEntry", () => $25908d69fe97e7a3$export$ebb311f9ff3b5efb);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $jfv6w = parcelRequire("jfv6w");

var $5fjzQ = parcelRequire("5fjzQ");
const $25908d69fe97e7a3$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $25908d69fe97e7a3$export$ebb311f9ff3b5efb = (0, $bAJhM.createLegacyEntry)((0, $jfv6w.globalSettingsSystemGlobalPermissionsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$25908d69fe97e7a3$var$pageEntryPoint
    }));

});
parcelRegister("jfv6w", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemGlobalPermissionsRoute", () => $d2bfd28e85f48107$export$38ac3717b046eb26);
const $d2bfd28e85f48107$export$38ac3717b046eb26 = {
    name: 'global-settings-system-global-permissions',
    path: '/secure/admin/jira/GlobalPermissions!default.jspa'
};

});


parcelRegister("KpHH4", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperNotificationRouteEntry", () => $005d2d6861cc26ad$export$e2befb3c6371d2f2);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $cc6bQ = parcelRequire("cc6bQ");
const $005d2d6861cc26ad$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $005d2d6861cc26ad$export$e2befb3c6371d2f2 = (0, $bAJhM.createLegacyEntry)((0, $cc6bQ.globalSettingsSystemHelperNotificationRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$005d2d6861cc26ad$var$pageEntryPoint
    }));

});
parcelRegister("cc6bQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperNotificationRoute", () => $e9c7d74c240c8028$export$7dab38c28c574395);
const $e9c7d74c240c8028$export$7dab38c28c574395 = {
    name: 'global-settings-system-helper-notification',
    path: '/secure/admin/NotificationHelperAdmin.jspa'
};

});


parcelRegister("4kVCN", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperPermissionRouteEntry", () => $b65d82ce3e3d256a$export$b7f8ebfe77163756);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $jjOxY = parcelRequire("jjOxY");

var $5fjzQ = parcelRequire("5fjzQ");
const $b65d82ce3e3d256a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b65d82ce3e3d256a$export$b7f8ebfe77163756 = (0, $bAJhM.createLegacyEntry)((0, $jjOxY.globalSettingsSystemHelperPermissionRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$b65d82ce3e3d256a$var$pageEntryPoint
    }));

});
parcelRegister("jjOxY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemHelperPermissionRoute", () => $95d5c1a1c4ef54f2$export$5c1770f1a1797fa5);
const $95d5c1a1c4ef54f2$export$5c1770f1a1797fa5 = {
    name: 'global-settings-system-helper-permission',
    path: '/secure/admin/PermissionHelperAdmin.jspa'
};

});


parcelRegister("8a0lz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportBulkRouteEntry", () => $6c35d0dae7915aa8$export$dd20078389577d29);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $cZorz = parcelRequire("cZorz");
const $6c35d0dae7915aa8$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $6c35d0dae7915aa8$export$dd20078389577d29 = (0, $bAJhM.createLegacyEntry)((0, $cZorz.globalSettingsSystemImportBulkRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$6c35d0dae7915aa8$var$pageEntryPoint
    }));

});
parcelRegister("cZorz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportBulkRoute", () => $b2ba83aa9429ed61$export$9de82cbc931fb7d0);
const $b2ba83aa9429ed61$export$9de82cbc931fb7d0 = {
    name: 'global-settings-system-import-bulk',
    path: '/secure/admin/BulkCreate(\\w+)([!%]?[\\w]*).jspa'
};

});


parcelRegister("c7OfH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCloudRouteEntry", () => $a66193272cb643dd$export$9d598c957e5bddde);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $k3Zlp = parcelRequire("k3Zlp");

var $5fjzQ = parcelRequire("5fjzQ");
const $a66193272cb643dd$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $a66193272cb643dd$export$9d598c957e5bddde = (0, $bAJhM.createLegacyEntry)((0, $k3Zlp.globalSettingsSystemImportCloudRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$a66193272cb643dd$var$pageEntryPoint
    }));

});
parcelRegister("k3Zlp", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCloudRoute", () => $cad672a70d4ef990$export$9953342c4b995f8);
const $cad672a70d4ef990$export$9953342c4b995f8 = {
    name: 'global-settings-system-import-cloud',
    path: '/secure/admin/CloudImport([!%]?[\\w]*).jspa'
};

});


parcelRegister("8K8iS", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCsvRouteEntry", () => $1a52040a14a23c2b$export$9e23dd51b331426c);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $cpQzO = parcelRequire("cpQzO");
const $1a52040a14a23c2b$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $1a52040a14a23c2b$export$9e23dd51b331426c = (0, $bAJhM.createLegacyEntry)((0, $cpQzO.globalSettingsSystemImportCsvRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$1a52040a14a23c2b$var$pageEntryPoint
    }));

});
parcelRegister("cpQzO", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportCsvRoute", () => $d9049839e44752f4$export$49f0cc3d88107d6b);
const $d9049839e44752f4$export$49f0cc3d88107d6b = {
    name: 'global-settings-system-import-csv',
    path: '/(secure|secure/admin)/Csv(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("bEivV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalRouteEntry", () => $c3884181cc7d0340$export$bf4a85badc8c82c9);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $4uzIG = parcelRequire("4uzIG");
const $c3884181cc7d0340$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $c3884181cc7d0340$export$bf4a85badc8c82c9 = (0, $bAJhM.createLegacyEntry)((0, $4uzIG.globalSettingsSystemImportExternalRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$c3884181cc7d0340$var$pageEntryPoint
    }));

});
parcelRegister("4uzIG", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalRoute", () => $193f0e8a43a19e01$export$afcc884cbc873f9f);
const $193f0e8a43a19e01$export$afcc884cbc873f9f = {
    name: 'global-settings-system-import-external',
    path: '/secure/admin/ExternalImport1.jspa'
};

});


parcelRegister("hrgNn", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRouteEntry", () => $eaf08309c10c8c71$export$7ca884816be2470a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $3Xc6d = parcelRequire("3Xc6d");
const $eaf08309c10c8c71$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $eaf08309c10c8c71$export$7ca884816be2470a = (0, $bAJhM.createLegacyEntry)((0, $3Xc6d.globalSettingsSystemImportExternalPagesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$eaf08309c10c8c71$var$pageEntryPoint
    }));

});
parcelRegister("3Xc6d", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportExternalPagesRoute", () => $e8805ce91a8e0dc6$export$dffab00ceab69eb2);
const $e8805ce91a8e0dc6$export$dffab00ceab69eb2 = {
    name: 'global-settings-system-import-external-pages',
    path: '/secure/admin/Importer(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("ftzyX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportJsonRouteEntry", () => $87a00fa8982f7408$export$fbac3139112fe654);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $kOzLx = parcelRequire("kOzLx");
const $87a00fa8982f7408$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $87a00fa8982f7408$export$fbac3139112fe654 = (0, $bAJhM.createLegacyEntry)((0, $kOzLx.globalSettingsSystemImportJsonRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$87a00fa8982f7408$var$pageEntryPoint
    }));

});
parcelRegister("kOzLx", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportJsonRoute", () => $04aea29d6cd476bc$export$169bd8bcabed089d);
const $04aea29d6cd476bc$export$169bd8bcabed089d = {
    name: 'global-settings-system-import-json',
    path: '/secure/admin/Json(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("a5xQ5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportTrelloRouteEntry", () => $b106c45ce79267a4$export$19f57ac143eecd95);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $3OxfH = parcelRequire("3OxfH");
const $b106c45ce79267a4$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b106c45ce79267a4$export$19f57ac143eecd95 = (0, $bAJhM.createLegacyEntry)((0, $3OxfH.globalSettingsSystemImportTrelloRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b106c45ce79267a4$var$pageEntryPoint
    }));

});
parcelRegister("3OxfH", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemImportTrelloRoute", () => $fb7e27a5c0b9ce6c$export$b6753e755954098b);
const $fb7e27a5c0b9ce6c$export$b6753e755954098b = {
    name: 'global-settings-system-import-trello',
    path: '/secure/admin/Trello(\\w+)Page([!%]?[\\w]*).jspa'
};

});


parcelRegister("i70uT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLexorankRouteEntry", () => $af164c67ddf602e5$export$5163204c27a4b60f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $cs76U = parcelRequire("cs76U");

var $5fjzQ = parcelRequire("5fjzQ");
const $af164c67ddf602e5$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $af164c67ddf602e5$export$5163204c27a4b60f = (0, $bAJhM.createLegacyEntry)((0, $cs76U.globalSettingsSystemLexorankRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$af164c67ddf602e5$var$pageEntryPoint
    }));

});
parcelRegister("cs76U", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLexorankRoute", () => $0c31eee58690d7e7$export$d4ce3155385fd8cf);
const $0c31eee58690d7e7$export$d4ce3155385fd8cf = {
    name: 'global-settings-system-lexorank',
    path: '/secure/GHLexoRankManage.jspa',
    query: [
        'decorator=admin'
    ]
};

});


parcelRegister("82bzz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLookRouteEntry", () => $bddedf8388440d9c$export$bf366af006cda74e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $8qo9i = parcelRequire("8qo9i");

var $5fjzQ = parcelRequire("5fjzQ");
const $bddedf8388440d9c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $bddedf8388440d9c$export$bf366af006cda74e = (0, $bAJhM.createLegacyEntry)((0, $8qo9i.globalSettingsSystemLookRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$bddedf8388440d9c$var$pageEntryPoint
    }));

});
parcelRegister("8qo9i", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemLookRoute", () => $a3fabb6cfb528958$export$61f7b12ec2ac6aa1);
const $a3fabb6cfb528958$export$61f7b12ec2ac6aa1 = {
    name: 'global-settings-system-look',
    path: '/secure/admin/LookAndFeel!default.jspa'
};

});


parcelRegister("dfOxZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailAddRouteEntry", () => $00f9244c92968fc1$export$c48daf66fa2bb3e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $khsFj = parcelRequire("khsFj");
const $00f9244c92968fc1$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $00f9244c92968fc1$export$c48daf66fa2bb3e = (0, $bAJhM.createLegacyEntry)((0, $khsFj.globalSettingsSystemMailAddRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$00f9244c92968fc1$var$pageEntryPoint
    }));

});
parcelRegister("khsFj", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailAddRoute", () => $691f46467166c819$export$2874a3735d7cb330);
const $691f46467166c819$export$2874a3735d7cb330 = {
    name: 'global-settings-system-mail-add',
    path: '/secure/admin/(Add|Update)PopMailServer!default.jspa'
};

});


parcelRegister("ZVj0Y", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRouteEntry", () => $539845cde11bf0ce$export$a14468794f1b5c83);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $6CwBK = parcelRequire("6CwBK");
const $539845cde11bf0ce$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $539845cde11bf0ce$export$a14468794f1b5c83 = (0, $bAJhM.createLegacyEntry)((0, $6CwBK.globalSettingsSystemMailDeleteMailHandlerRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$539845cde11bf0ce$var$pageEntryPoint
    }));

});
parcelRegister("6CwBK", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailDeleteMailHandlerRoute", () => $f3476e3dc069d686$export$140403398c884f90);
const $f3476e3dc069d686$export$140403398c884f90 = {
    name: 'global-settings-system-delete-mail-handler',
    path: '/secure/admin/DeleteMailHandler.jspa'
};

});


parcelRegister("aN61m", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailIncomingRouteEntry", () => $aea1f2a767d29bdb$export$3ae66df5766592ef);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $5OUmT = parcelRequire("5OUmT");

var $5fjzQ = parcelRequire("5fjzQ");
const $aea1f2a767d29bdb$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $aea1f2a767d29bdb$export$3ae66df5766592ef = (0, $bAJhM.createLegacyEntry)((0, $5OUmT.globalSettingsSystemMailIncomingRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$aea1f2a767d29bdb$var$pageEntryPoint
    }));

});
parcelRegister("5OUmT", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailIncomingRoute", () => $542f056c51e43824$export$90c9c127e433d888);
const $542f056c51e43824$export$90c9c127e433d888 = {
    name: 'global-settings-system-mail-incoming',
    path: '/secure/admin/IncomingMailServers.jspa'
};

});


parcelRegister("5OZoa", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailOutgoingRouteEntry", () => $712b43e5b12b9299$export$cb267b8986031cb7);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $fLGQY = parcelRequire("fLGQY");

var $5fjzQ = parcelRequire("5fjzQ");
const $712b43e5b12b9299$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $712b43e5b12b9299$export$cb267b8986031cb7 = (0, $bAJhM.createLegacyEntry)((0, $fLGQY.globalSettingsSystemMailOutgoingRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$712b43e5b12b9299$var$pageEntryPoint
    }));

});
parcelRegister("fLGQY", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailOutgoingRoute", () => $69023a55d125159c$export$6da120a8b84a7872);
const $69023a55d125159c$export$6da120a8b84a7872 = {
    name: 'global-settings-system-mail-outgoing',
    path: '/secure/admin/OutgoingMailServers.jspa'
};

});


parcelRegister("z3tMU", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSendRouteEntry", () => $e036dabcc362025a$export$bff9c3c6b0aba389);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $aiqEZ = parcelRequire("aiqEZ");

var $5fjzQ = parcelRequire("5fjzQ");
const $e036dabcc362025a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $e036dabcc362025a$export$bff9c3c6b0aba389 = (0, $bAJhM.createLegacyEntry)((0, $aiqEZ.globalSettingsSystemMailSendRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$e036dabcc362025a$var$pageEntryPoint
    }));

});
parcelRegister("aiqEZ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSendRoute", () => $46035c87db432a63$export$a2ae5fa2accd6e5f);
const $46035c87db432a63$export$a2ae5fa2accd6e5f = {
    name: 'global-settings-system-mail-send',
    path: '/secure/admin/SendBulkMail!default.jspa'
};

});


parcelRegister("fSyZo", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSettingsRouteEntry", () => $bf0ef41e3facc4b0$export$3c0d52a24b499e7c);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $3tGun = parcelRequire("3tGun");

var $5fjzQ = parcelRequire("5fjzQ");
const $bf0ef41e3facc4b0$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $bf0ef41e3facc4b0$export$3c0d52a24b499e7c = (0, $bAJhM.createLegacyEntry)((0, $3tGun.globalSettingsSystemMailSettingsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$bf0ef41e3facc4b0$var$pageEntryPoint
    }));

});
parcelRegister("3tGun", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailSettingsRoute", () => $fb1bd7a37d44ef90$export$8423ad7a1177552);
const $fb1bd7a37d44ef90$export$8423ad7a1177552 = {
    name: 'global-settings-system-mail-settings',
    path: '/secure/admin/GlobalMailSettings([!%]?[\\w]*).jspa'
};

});


parcelRegister("iBhRd", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailVerifyRouteEntry", () => $b007f05726610d59$export$2fd491752a9501a2);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $lWAJE = parcelRequire("lWAJE");
const $b007f05726610d59$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b007f05726610d59$export$2fd491752a9501a2 = (0, $bAJhM.createLegacyEntry)((0, $lWAJE.globalSettingsSystemMailVerifyRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$b007f05726610d59$var$pageEntryPoint
    }));

});
parcelRegister("lWAJE", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemMailVerifyRoute", () => $f980d0c5b0eb4936$export$51b4ff8214b9fd7f);
const $f980d0c5b0eb4936$export$51b4ff8214b9fd7f = {
    name: 'global-settings-system-mail-verify',
    path: '/secure/admin/VerifyPopServerConnection([!%]?[\\w]*).jspa'
};

});


parcelRegister("3ftuD", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemPermissionsRouteEntry", () => $b050e0f09e6eb5c7$export$9fe6a3bc70d75bae);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $aoszQ = parcelRequire("aoszQ");

var $5fjzQ = parcelRequire("5fjzQ");
const $b050e0f09e6eb5c7$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b050e0f09e6eb5c7$export$9fe6a3bc70d75bae = (0, $bAJhM.createLegacyEntry)((0, $aoszQ.globalSettingsSystemPermissionsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$b050e0f09e6eb5c7$var$pageEntryPoint
    }));

});
parcelRegister("aoszQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemPermissionsRoute", () => $e1a2126550eaa222$export$1382458fd6826787);
const $e1a2126550eaa222$export$1382458fd6826787 = {
    name: 'global-settings-system-permissions',
    path: '/secure/admin/GlobalPermissions([!%]?[\\w]*).jspa'
};

});


parcelRegister("9ra6q", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRouteEntry", () => $3c3c93553e91c148$export$b78eddbedd30951d);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $hh6Jc = parcelRequire("hh6Jc");
const $3c3c93553e91c148$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $3c3c93553e91c148$export$b78eddbedd30951d = (0, $bAJhM.createLegacyEntry)((0, $hh6Jc.globalSettingsSystemProjectAssignSecurityRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$3c3c93553e91c148$var$pageEntryPoint
    }));

});
parcelRegister("hh6Jc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectAssignSecurityRoute", () => $d603dcaa1894769c$export$f53750f3a4fc2fde);
const $d603dcaa1894769c$export$f53750f3a4fc2fde = {
    name: 'global-settings-system-project-assign-security',
    path: '/secure/project/AssignIssueSecuritySchemeProgress.jspa'
};

});


parcelRegister("lCq28", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectDeleteRouteEntry", () => $47957faea0dd9c61$export$849f3666529d049e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $slfNV = parcelRequire("slfNV");
const $47957faea0dd9c61$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $47957faea0dd9c61$export$849f3666529d049e = (0, $bAJhM.createLegacyEntry)((0, $slfNV.globalSettingsSystemProjectDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$47957faea0dd9c61$var$pageEntryPoint
    }));

});
parcelRegister("slfNV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectDeleteRoute", () => $b4ddee7de4bb1af6$export$f31d8748a56aa638);
const $b4ddee7de4bb1af6$export$f31d8748a56aa638 = {
    name: 'global-settings-system-project-delete',
    path: '/secure/project/DeleteProject.jspa'
};

});


parcelRegister("bS277", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectSelectRouteEntry", () => $1329f9b6a7503e31$export$a1869de90837dac8);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $62T6o = parcelRequire("62T6o");
const $1329f9b6a7503e31$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $1329f9b6a7503e31$export$a1869de90837dac8 = (0, $bAJhM.createLegacyEntry)((0, $62T6o.globalSettingsSystemProjectSelectRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$1329f9b6a7503e31$var$pageEntryPoint
    }));

});
parcelRegister("62T6o", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemProjectSelectRoute", () => $726f1568f5559d50$export$8f44b9e5553dccec);
const $726f1568f5559d50$export$8f44b9e5553dccec = {
    name: 'global-settings-system-project-select',
    path: '/secure/project/SelectProject(\\w*)([!%]?[\\w]*).jspa'
};

});


parcelRegister("aTlDP", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsRouteEntry", () => $63ee37bd809b5687$export$7dc567ad40905890);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $7VIZB = parcelRequire("7VIZB");
const $63ee37bd809b5687$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $63ee37bd809b5687$export$7dc567ad40905890 = (0, $bAJhM.createLegacyEntry)((0, $7VIZB.globalSettingsSystemRolesActorsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$63ee37bd809b5687$var$pageEntryPoint
    }));

});
parcelRegister("7VIZB", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsRoute", () => $13094448a8c7792b$export$3dca5fcf3b98db1e);
const $13094448a8c7792b$export$3dca5fcf3b98db1e = {
    name: 'global-settings-system-roles-actors',
    path: '/secure/project/ViewDefaultProjectRoleActors([!%]?[\\w]*).jspa'
};

});


parcelRegister("jJoxI", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRouteEntry", () => $62640773103b9034$export$ac1028baf6d1bd60);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $bNIZX = parcelRequire("bNIZX");
const $62640773103b9034$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $62640773103b9034$export$ac1028baf6d1bd60 = (0, $bAJhM.createLegacyEntry)((0, $bNIZX.globalSettingsSystemRolesActorsGroupsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$62640773103b9034$var$pageEntryPoint
    }));

});
parcelRegister("bNIZX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsGroupsRoute", () => $a1a8babcf0bf133b$export$836f3cdea3e238a4);
const $a1a8babcf0bf133b$export$836f3cdea3e238a4 = {
    name: 'global-settings-system-roles-actors-groups',
    path: '/secure/project/GroupRoleActorAction.jspa'
};

});


parcelRegister("7ipQX", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRouteEntry", () => $e8611d1d667ef182$export$3186176f09045f35);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $1J3ym = parcelRequire("1J3ym");
const $e8611d1d667ef182$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $e8611d1d667ef182$export$3186176f09045f35 = (0, $bAJhM.createLegacyEntry)((0, $1J3ym.globalSettingsSystemRolesActorsUsersRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$e8611d1d667ef182$var$pageEntryPoint
    }));

});
parcelRegister("1J3ym", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesActorsUsersRoute", () => $7fb5d1ea7a1dc58f$export$119e823548eefd4f);
const $7fb5d1ea7a1dc58f$export$119e823548eefd4f = {
    name: 'global-settings-system-roles-actors-users',
    path: '/secure/project/UserRoleActorAction.jspa'
};

});


parcelRegister("cTtpr", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesDeleteRouteEntry", () => $dccda5252004a018$export$4f2756ef0230f213);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $k07iw = parcelRequire("k07iw");
const $dccda5252004a018$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $dccda5252004a018$export$4f2756ef0230f213 = (0, $bAJhM.createLegacyEntry)((0, $k07iw.globalSettingsSystemRolesDeleteRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$dccda5252004a018$var$pageEntryPoint
    }));

});
parcelRegister("k07iw", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesDeleteRoute", () => $db79c2ac98530205$export$c4b2dba31a4a29c8);
const $db79c2ac98530205$export$c4b2dba31a4a29c8 = {
    name: 'global-settings-system-roles-delete',
    path: '/secure/project/DeleteProjectRole([!%]?[\\w]*).jspa'
};

});


parcelRegister("8JhHW", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesEditRouteEntry", () => $28554950d54dc6fe$export$18cfabcb0c0c21e5);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $bhoJM = parcelRequire("bhoJM");
const $28554950d54dc6fe$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $28554950d54dc6fe$export$18cfabcb0c0c21e5 = (0, $bAJhM.createLegacyEntry)((0, $bhoJM.globalSettingsSystemRolesEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$28554950d54dc6fe$var$pageEntryPoint
    }));

});
parcelRegister("bhoJM", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesEditRoute", () => $e1c663305d772662$export$88917fe447558e55);
const $e1c663305d772662$export$88917fe447558e55 = {
    name: 'global-settings-system-roles-edit',
    path: '/secure/project/EditProjectRole([!%]?[\\w]*).jspa'
};

});


parcelRegister("5Mjim", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesUsageRouteEntry", () => $8892a750da920e96$export$d9f7c60572f36835);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $5AYha = parcelRequire("5AYha");
const $8892a750da920e96$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $8892a750da920e96$export$d9f7c60572f36835 = (0, $bAJhM.createLegacyEntry)((0, $5AYha.globalSettingsSystemRolesUsageRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        entryPoint: ()=>$8892a750da920e96$var$pageEntryPoint
    }));

});
parcelRegister("5AYha", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesUsageRoute", () => $c90824643dbd4d65$export$91305e5cb99eb005);
const $c90824643dbd4d65$export$91305e5cb99eb005 = {
    name: 'global-settings-system-roles-usage',
    path: '/secure/project/ViewProjectRoleUsage([!%]?[\\w]*).jspa'
};

});


parcelRegister("5N6Ai", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesViewRouteEntry", () => $b6f4d06396714e13$export$47efc3b9a4cedfba);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $1LfMC = parcelRequire("1LfMC");

var $5fjzQ = parcelRequire("5fjzQ");
const $b6f4d06396714e13$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b6f4d06396714e13$export$47efc3b9a4cedfba = (0, $bAJhM.createLegacyEntry)((0, $1LfMC.globalSettingsSystemRolesViewRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$b6f4d06396714e13$var$pageEntryPoint
    }));

});
parcelRegister("1LfMC", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemRolesViewRoute", () => $ecc60392ce7a31f5$export$81d6a9112f47a229);
const $ecc60392ce7a31f5$export$81d6a9112f47a229 = {
    name: 'global-settings-system-roles-view',
    path: '/secure/project/ViewProjectRoles([!%]?[\\w]*).jspa'
};

});


parcelRegister("3xHNV", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemServicesRouteEntry", () => $0708a93b195d0e10$export$f08661656eef7ad1);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $7CR25 = parcelRequire("7CR25");

var $5fjzQ = parcelRequire("5fjzQ");
const $0708a93b195d0e10$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $0708a93b195d0e10$export$f08661656eef7ad1 = (0, $bAJhM.createLegacyEntry)((0, $7CR25.globalSettingsSystemServicesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$0708a93b195d0e10$var$pageEntryPoint
    }));

});
parcelRegister("7CR25", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemServicesRoute", () => $2adecb4764083fdd$export$a176af71f8d6d872);
const $2adecb4764083fdd$export$a176af71f8d6d872 = {
    name: 'global-settings-system-services',
    path: '/secure/admin/ViewServices!default.jspa'
};

});


parcelRegister("aw4rz", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRouteEntry", () => $ea6eb1827570d8c4$export$48cce4d971c37598);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $abkmu = parcelRequire("abkmu");

var $5fjzQ = parcelRequire("5fjzQ");
const $ea6eb1827570d8c4$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $ea6eb1827570d8c4$export$48cce4d971c37598 = (0, $bAJhM.createLegacyEntry)((0, $abkmu.globalSettingsSystemSharedDashboardsRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$ea6eb1827570d8c4$var$pageEntryPoint
    }));

});
parcelRegister("abkmu", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedDashboardsRoute", () => $417d2d3251268cd5$export$64739c332d5146ba);
const $417d2d3251268cd5$export$64739c332d5146ba = {
    name: 'global-settings-system-shared-dashboards',
    path: '/secure/admin/dashboards/ViewSharedDashboards.jspa'
};

});


parcelRegister("ihO2a", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedFiltersRouteEntry", () => $c27ce4d36dc6487d$export$6777672075f7d618);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $ksiHe = parcelRequire("ksiHe");

var $5fjzQ = parcelRequire("5fjzQ");
const $c27ce4d36dc6487d$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $c27ce4d36dc6487d$export$6777672075f7d618 = (0, $bAJhM.createLegacyEntry)((0, $ksiHe.globalSettingsSystemSharedFiltersRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$c27ce4d36dc6487d$var$pageEntryPoint
    }));

});
parcelRegister("ksiHe", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemSharedFiltersRoute", () => $295bb490ac99e392$export$684d93e5438fcd69);
const $295bb490ac99e392$export$684d93e5438fcd69 = {
    name: 'global-settings-system-shared-filters',
    path: '/secure/admin/filters/ViewSharedFilters.jspa'
};

});


parcelRegister("5tskD", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRouteEntry", () => $b6dc0f76d7cb0cee$export$dbe314c372e965d4);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $1sKV5 = parcelRequire("1sKV5");
const $b6dc0f76d7cb0cee$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $b6dc0f76d7cb0cee$export$dbe314c372e965d4 = (0, $bAJhM.createLegacyEntry)((0, $1sKV5.globalSettingsSystemUserInterfaceDashboardEditRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$b6dc0f76d7cb0cee$var$pageEntryPoint
    }));

});
parcelRegister("1sKV5", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfaceDashboardEditRoute", () => $edccf4f57e08428a$export$78c9a0475c2f9cd0);
const $edccf4f57e08428a$export$78c9a0475c2f9cd0 = {
    name: 'global-settings-system-ui-dashboard-edit',
    path: '/secure/admin/jira/EditApplicationProperties!default.jspa'
};

});


parcelRegister("9r2BL", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRouteEntry", () => $6aa336f2e1665087$export$7025983c5e996386);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $3dDCQ = parcelRequire("3dDCQ");
const $6aa336f2e1665087$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $6aa336f2e1665087$export$7025983c5e996386 = (0, $bAJhM.createLegacyEntry)((0, $3dDCQ.globalSettingsSystemUserInterfacePreferencesRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource)
        ],
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS
        },
        entryPoint: ()=>$6aa336f2e1665087$var$pageEntryPoint
    }));

});
parcelRegister("3dDCQ", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemUserInterfacePreferencesRoute", () => $3f677b1926d4e7ad$export$6f46032e4fc13ea0);
const $3f677b1926d4e7ad$export$6f46032e4fc13ea0 = {
    name: 'global-settings-system-ui-default-user-preferences-apply',
    path: '/secure/admin/SetGlobalEmailPreference!default.jspa'
};

});


parcelRegister("g3Gcc", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemWebhooksRouteEntry", () => $7667aa34b79f97e0$export$aff2563c719af2aa);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $2nHUF = parcelRequire("2nHUF");

var $bAJhM = parcelRequire("bAJhM");

var $enHI7 = parcelRequire("enHI7");

var $77XLh = parcelRequire("77XLh");

var $5fjzQ = parcelRequire("5fjzQ");
const $7667aa34b79f97e0$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $7667aa34b79f97e0$export$aff2563c719af2aa = (0, $bAJhM.createLegacyEntry)((0, $77XLh.globalSettingsSystemWebhooksRoute), ()=>({
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
            sidebar: (0, $2nHUF.default)
        },
        resources: [
            (0, $enHI7.navigationSidebarGlobalResource),
            (0, $5fjzQ.conditionalPostOfficeJiraTopBannerResource)
        ],
        entryPoint: ()=>$7667aa34b79f97e0$var$pageEntryPoint
    }));

});
parcelRegister("77XLh", function(module, exports) {

$parcel$export(module.exports, "globalSettingsSystemWebhooksRoute", () => $54f996f1a8335b7d$export$2c20f3aef4ea16aa);
const $54f996f1a8335b7d$export$2c20f3aef4ea16aa = {
    name: 'global-settings-system-webhooks',
    path: '/plugins/servlet/webhooks'
};

});


parcelRegister("2IYDs", function(module, exports) {

$parcel$export(module.exports, "legacyIssueRouteEntry", () => $c64f9efe1e6eb7bc$export$e8ba55056b4fde20);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $5zQIb = parcelRequire("5zQIb");

var $dZRaT = parcelRequire("dZRaT");

var $aGQ56 = parcelRequire("aGQ56");

var $bTfc4 = parcelRequire("bTfc4");

var $jdU4L = parcelRequire("jdU4L");

var $iV1yD = parcelRequire("iV1yD");
const $c64f9efe1e6eb7bc$export$e8ba55056b4fde20 = (0, $bAJhM.createLegacyEntry)((0, $jdU4L.legacyIssueRoute), ()=>({
        group: 'legacy',
        layout: (0, $ioHIu.genericProjectLayout),
        component: (0, $iV1yD.LegacyIssueView),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $aGQ56.queuesNavigationItems),
            (0, $5zQIb.newIssueViewTransitionLockInStatusResource),
            (0, $4VIcO.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("jdU4L", function(module, exports) {

$parcel$export(module.exports, "legacyIssueRoute", () => $aa9086faa1ea923c$export$71da6fcc13745fba);
const $aa9086faa1ea923c$export$71da6fcc13745fba = {
    name: 'legacy-issue',
    path: '/browse/:issueKey(\\w+-\\d+)(.*)',
    query: [
        'jql!=(.+)',
        'filter!=(.+)'
    ]
};

});

parcelRegister("iV1yD", function(module, exports) {

$parcel$export(module.exports, "LegacyIssueView", () => $2459c7ef40c6e219$export$34dc6596952b042c);

var $eJOHy = parcelRequire("eJOHy");

var $6tSfI = parcelRequire("6tSfI");
const $2459c7ef40c6e219$export$34dc6596952b042c = (props)=>{
    const { route: route } = props;
    if (!route) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tSfI.LegacyPage), props));
};

});


parcelRegister("d4f3b", function(module, exports) {

$parcel$export(module.exports, "legacyJsdCustomersRouteEntry", () => $578dd36f6e1a77f9$export$f458747db287136e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $k2Lwy = parcelRequire("k2Lwy");

var $aQoXd = parcelRequire("aQoXd");
const $578dd36f6e1a77f9$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $578dd36f6e1a77f9$export$f458747db287136e = (0, $bAJhM.createLegacyEntry)((0, $k2Lwy.legacyJsdCustomersRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$578dd36f6e1a77f9$var$pageEntryPoint
    }));

});
parcelRegister("k2Lwy", function(module, exports) {

$parcel$export(module.exports, "legacyJsdCustomersRoute", () => $bf9e761844fba8f1$export$3af39e70a286821c);
const $bf9e761844fba8f1$export$3af39e70a286821c = {
    name: 'legacy-jsd-customers',
    path: '/projects/:projectKey/customers'
};

});


parcelRegister("dLnvu", function(module, exports) {

$parcel$export(module.exports, "legacyJsdGettingStartedRouteEntry", () => $e26c2e2450868dfb$export$3c4b4abb062b10e3);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $dIO95 = parcelRequire("dIO95");

var $aQoXd = parcelRequire("aQoXd");
const $e26c2e2450868dfb$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $e26c2e2450868dfb$export$3c4b4abb062b10e3 = (0, $bAJhM.createLegacyEntry)((0, $dIO95.legacyJsdGettingStartedRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$e26c2e2450868dfb$var$pageEntryPoint
    }));

});
parcelRegister("dIO95", function(module, exports) {

$parcel$export(module.exports, "legacyJsdGettingStartedRoute", () => $0240d990bfa1d2b2$export$71b946ee427d710);
const $0240d990bfa1d2b2$export$71b946ee427d710 = {
    name: 'legacy-jsd-getting-started',
    path: '/projects/:projectKey/getting-started'
};

});


parcelRegister("kzPtB", function(module, exports) {

$parcel$export(module.exports, "legacyJsdJiraAutomationRouteEntry", () => $ccc530c0a17f7da7$export$d2d1cb3e56d9ba93);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $2BUFa = parcelRequire("2BUFa");

var $aQoXd = parcelRequire("aQoXd");
const $ccc530c0a17f7da7$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $ccc530c0a17f7da7$export$d2d1cb3e56d9ba93 = (0, $bAJhM.createLegacyEntry)((0, $2BUFa.legacyJsdJiraAutomationRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$ccc530c0a17f7da7$var$pageEntryPoint
    }));

});
parcelRegister("2BUFa", function(module, exports) {

$parcel$export(module.exports, "legacyJsdJiraAutomationRoute", () => $b5691a6f001f6c04$export$7d38596d701d5776);
const $b5691a6f001f6c04$export$7d38596d701d5776 = {
    name: 'legacy-jsd-jira-automation',
    path: '/servicedesk/admin/:projectKey/automation'
};

});


parcelRegister("6X7m6", function(module, exports) {

$parcel$export(module.exports, "legacyJsdKnowledgeRouteEntry", () => $02bc3fcb3855dcff$export$352579e39711e17);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $2TbmJ = parcelRequire("2TbmJ");

var $aQoXd = parcelRequire("aQoXd");
const $02bc3fcb3855dcff$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $02bc3fcb3855dcff$export$352579e39711e17 = (0, $bAJhM.createLegacyEntry)((0, $2TbmJ.legacyJsdKnowledgeRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$02bc3fcb3855dcff$var$pageEntryPoint
    }));

});
parcelRegister("2TbmJ", function(module, exports) {

$parcel$export(module.exports, "legacyJsdKnowledgeRoute", () => $52cc697de90f95ae$export$7c7fc282c0c143d);
const $52cc697de90f95ae$export$7c7fc282c0c143d = {
    name: 'legacy-jsd-knowledge',
    path: '/projects/:projectKey/knowledge/:page?'
};

});


parcelRegister("iuhZT", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesRouteEntry", () => $73127d5e86da70c3$export$7c006e8310e2641a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $jJQIp = parcelRequire("jJQIp");

var $aQoXd = parcelRequire("aQoXd");
const $73127d5e86da70c3$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $73127d5e86da70c3$export$7c006e8310e2641a = (0, $bAJhM.createLegacyEntry)((0, $jJQIp.legacyJsdQueuesRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$73127d5e86da70c3$var$pageEntryPoint
    }));

});
parcelRegister("jJQIp", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesRoute", () => $891e81f466212512$export$2d08dc2a8c573cf3);
const $891e81f466212512$export$2d08dc2a8c573cf3 = {
    name: 'legacy-jsd-queues',
    path: '/projects/:projectKey/queues/:custom(custom)?/:id?'
};

});


parcelRegister("663l0", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesManageRouteEntry", () => $0d34d5b80e16754a$export$cdabf798cd8727fd);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $rBW8o = parcelRequire("rBW8o");

var $aQoXd = parcelRequire("aQoXd");
const $0d34d5b80e16754a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $0d34d5b80e16754a$export$cdabf798cd8727fd = (0, $bAJhM.createLegacyEntry)((0, $rBW8o.legacyJsdQueuesManageRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$0d34d5b80e16754a$var$pageEntryPoint
    }));

});
parcelRegister("rBW8o", function(module, exports) {

$parcel$export(module.exports, "legacyJsdQueuesManageRoute", () => $f971ecae561555ff$export$af365e550fae80);
const $f971ecae561555ff$export$af365e550fae80 = {
    name: 'legacy-jsd-queues-manage',
    path: '/projects/:projectKey/queues/manage'
};

});


parcelRegister("1d8tj", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsCustomRouteEntry", () => $05ffc3a7d9e01dad$export$e133645c1a4bdfe7);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $81y2m = parcelRequire("81y2m");

var $aQoXd = parcelRequire("aQoXd");
const $05ffc3a7d9e01dad$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $05ffc3a7d9e01dad$export$e133645c1a4bdfe7 = (0, $bAJhM.createLegacyEntry)((0, $81y2m.legacyJsdReportsCustomRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$05ffc3a7d9e01dad$var$pageEntryPoint
    }));

});
parcelRegister("81y2m", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsCustomRoute", () => $ecc084281c3a5717$export$e5d83d06029b0f71);
const $ecc084281c3a5717$export$e5d83d06029b0f71 = {
    name: 'legacy-jsd-reports-custom',
    path: '/projects/:projectKey/reports/custom/:id?'
};

});


parcelRegister("al2YQ", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsRouteEntry", () => $df57504631d70cdd$export$893692ad278d4aa2);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $hzOsT = parcelRequire("hzOsT");

var $aQoXd = parcelRequire("aQoXd");
const $df57504631d70cdd$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $df57504631d70cdd$export$893692ad278d4aa2 = (0, $bAJhM.createLegacyEntry)((0, $hzOsT.legacyJsdReportsRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$df57504631d70cdd$var$pageEntryPoint
    }));

});
parcelRegister("hzOsT", function(module, exports) {

$parcel$export(module.exports, "legacyJsdReportsRoute", () => $55fecc19b5f39d47$export$253418b9005ff89e);
const $55fecc19b5f39d47$export$253418b9005ff89e = {
    name: 'legacy-jsd-reports',
    path: '/projects/:projectKey/reports/:reportType'
};

});


parcelRegister("4AaBy", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsFallbackRouteEntry", () => $c654888a695b2b7c$export$f0bcff1cea783147);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5P941 = parcelRequire("5P941");

var $aQoXd = parcelRequire("aQoXd");
const $c654888a695b2b7c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $c654888a695b2b7c$export$f0bcff1cea783147 = (0, $bAJhM.createLegacyEntry)((0, $5P941.legacyJsdSettingsFallbackRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$c654888a695b2b7c$var$pageEntryPoint
    }));

});
parcelRegister("5P941", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsFallbackRoute", () => $832b57d5b01e51c1$export$831971c91fbdcd5b);
const $832b57d5b01e51c1$export$831971c91fbdcd5b = {
    name: 'legacy-jsd-settings-fallback',
    path: '/servicedesk/admin/:projectKey/:adminOption'
};

});


parcelRegister("b3dlc", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguageRouteEntry", () => $f91bdc5d15ae6e78$export$d9063e63677bfd5d);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $h3pKg = parcelRequire("h3pKg");

var $aQoXd = parcelRequire("aQoXd");
const $f91bdc5d15ae6e78$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $f91bdc5d15ae6e78$export$d9063e63677bfd5d = (0, $bAJhM.createLegacyEntry)((0, $h3pKg.legacyJsdSettingsLanguageRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f91bdc5d15ae6e78$var$pageEntryPoint
    }));

});
parcelRegister("h3pKg", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguageRoute", () => $bbfacc080b0dc87f$export$453ac1bfce2eb20e);
const $bbfacc080b0dc87f$export$453ac1bfce2eb20e = {
    name: 'legacy-jsd-settings-language',
    path: '/servicedesk/admin/:projectKey/language',
    exact: true
};

});


parcelRegister("gGs6c", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRouteEntry", () => $0536d05022139c35$export$492207df7adc0823);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $6jcPp = parcelRequire("6jcPp");

var $aQoXd = parcelRequire("aQoXd");
const $0536d05022139c35$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $0536d05022139c35$export$492207df7adc0823 = (0, $bAJhM.createLegacyEntry)((0, $6jcPp.legacyJsdSettingsLanguagePagesRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$0536d05022139c35$var$pageEntryPoint
    }));

});
parcelRegister("6jcPp", function(module, exports) {

$parcel$export(module.exports, "legacyJsdSettingsLanguagePagesRoute", () => $f69e8a6fd82c16f5$export$2fd783c1d45b1a9f);
const $f69e8a6fd82c16f5$export$2fd783c1d45b1a9f = {
    name: 'legacy-jsd-settings-language-pages',
    path: '/servicedesk/admin/:projectKey/language/:languageKey/:sidebarItemKey?'
};

});


parcelRegister("fLdjP", function(module, exports) {

$parcel$export(module.exports, "legacyJsdWidgetsRouteEntry", () => $91870cc1d309ff67$export$8b6c493f34b243fb);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $1f2LE = parcelRequire("1f2LE");

var $bAJhM = parcelRequire("bAJhM");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $9FQ0z = parcelRequire("9FQ0z");

var $aQoXd = parcelRequire("aQoXd");
const $91870cc1d309ff67$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $91870cc1d309ff67$export$8b6c493f34b243fb = (0, $bAJhM.createLegacyEntry)((0, $9FQ0z.legacyJsdWidgetsRoute), ()=>({
        layout: (0, $aQoXd.serviceProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $1f2LE.default)
        },
        resources: [
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$91870cc1d309ff67$var$pageEntryPoint
    }));

});
parcelRegister("9FQ0z", function(module, exports) {

$parcel$export(module.exports, "legacyJsdWidgetsRoute", () => $0f67a73309f22726$export$ecfee0d843d9f28a);
const $0f67a73309f22726$export$ecfee0d843d9f28a = {
    name: 'legacy-jsd-widgets',
    path: '/servicedesk/admin/:projectKey/addon/:addonName',
    exact: true
};

});


parcelRegister("kXp5o", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRouteEntry", () => $439143ad7e9d4de7$export$30ce3fd3c9377561);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $bAJhM = parcelRequire("bAJhM");

var $iQq84 = parcelRequire("iQq84");
const $439143ad7e9d4de7$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint)
});
const $439143ad7e9d4de7$export$30ce3fd3c9377561 = (0, $bAJhM.createLegacyEntry)((0, $iQq84.legacyPersonalSettingsAccessTokensRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        entryPoint: ()=>$439143ad7e9d4de7$var$pageEntryPoint
    }));

});
parcelRegister("iQq84", function(module, exports) {

$parcel$export(module.exports, "legacyPersonalSettingsAccessTokensRoute", () => $866b05931e9507e0$export$49a90c7c39db3dd3);
const $866b05931e9507e0$export$49a90c7c39db3dd3 = {
    name: 'legacy-personal-settings-access-tokens',
    path: '/plugins/servlet/oauth/users/access-tokens'
};

});


parcelRegister("e4ly7", function(module, exports) {

$parcel$export(module.exports, "legacyPinRouteEntry", () => $23c024d4cf33e063$export$2311541dfc64683c);

var $9n5I0 = parcelRequire("9n5I0");

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $iZ4PK = parcelRequire("iZ4PK");
const $23c024d4cf33e063$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $23c024d4cf33e063$export$2311541dfc64683c = (0, $bAJhM.createLegacyEntry)((0, $iZ4PK.legacyPinRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$23c024d4cf33e063$var$pageEntryPoint
    }));

});
parcelRegister("iZ4PK", function(module, exports) {

$parcel$export(module.exports, "legacyPinRoute", () => $e636555fc349ab00$export$5600fbce403620b6);
const $e636555fc349ab00$export$5600fbce403620b6 = {
    name: 'legacy-pin',
    path: '/projects/:projectKey/issues/:issueKey?'
};

});


parcelRegister("chIgP", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioPagesRouteEntry", () => $8b79019df97f3907$export$200d6f7de97d1e96);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $hc3YW = parcelRequire("hc3YW");
const $8b79019df97f3907$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS
});
const $8b79019df97f3907$export$200d6f7de97d1e96 = (0, $bAJhM.createLegacyEntry)((0, $hc3YW.legacyPortfolioPagesRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        entryPoint: ()=>$8b79019df97f3907$var$pageEntryPoint
    }));

});
parcelRegister("hc3YW", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioPagesRoute", () => $79122e611cf75c3f$export$c8591b40ac25c22d);
const $79122e611cf75c3f$export$c8591b40ac25c22d = {
    name: 'legacy-portfolio-pages',
    path: '/secure/PortfolioPlan(\\w+).jspa'
};

});


parcelRegister("f4kmu", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioTeamRouteEntry", () => $a3e3194e24bd0cce$export$67d1a57e72c969e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $7h3uc = parcelRequire("7h3uc");

var $5RW99 = parcelRequire("5RW99");

var $bAJhM = parcelRequire("bAJhM");

var $ggFqE = parcelRequire("ggFqE");
const $a3e3194e24bd0cce$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PLANS
});
const $a3e3194e24bd0cce$export$67d1a57e72c969e = (0, $bAJhM.createLegacyEntry)((0, $ggFqE.legacyPortfolioTeamRoute), ()=>({
        layout: (0, $7h3uc.globalLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PLANS
        },
        entryPoint: ()=>$a3e3194e24bd0cce$var$pageEntryPoint
    }));

});
parcelRegister("ggFqE", function(module, exports) {

$parcel$export(module.exports, "legacyPortfolioTeamRoute", () => $751bc2d1194d5ced$export$b61cebfbe2ae0da2);
const $751bc2d1194d5ced$export$b61cebfbe2ae0da2 = {
    name: 'legacy-portfolio-team',
    path: '/secure/TeamManagement.jspa'
};

});


parcelRegister("j7WGc", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesBambooRouteEntry", () => $87c5fd965c84cd04$export$929a483dcf3c101d);

var $9n5I0 = parcelRequire("9n5I0");

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $gcG0w = parcelRequire("gcG0w");
const $87c5fd965c84cd04$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $87c5fd965c84cd04$export$929a483dcf3c101d = (0, $bAJhM.createLegacyEntry)((0, $gcG0w.legacyProjectReleasesBambooRoute), ()=>({
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        layout: (0, $ioHIu.genericProjectLayout),
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$87c5fd965c84cd04$var$pageEntryPoint
    }));

});
parcelRegister("gcG0w", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesBambooRoute", () => $0b058a205a3eacbd$export$df7f0213f2f22fc8);
const $0b058a205a3eacbd$export$df7f0213f2f22fc8 = {
    name: 'legacy-project-releases-bamboo',
    path: '/secure/ConfigureBambooRelease([!%]?[\\w]*).jspa'
};

});


parcelRegister("gYhfA", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesRouteEntry", () => $78078c16cec1e7ab$export$5d0e55986ed5e2c9);

var $9n5I0 = parcelRequire("9n5I0");

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $dtO5C = parcelRequire("dtO5C");
const $78078c16cec1e7ab$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $78078c16cec1e7ab$export$5d0e55986ed5e2c9 = (0, $bAJhM.createLegacyEntry)((0, $dtO5C.legacyProjectReleasesRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$78078c16cec1e7ab$var$pageEntryPoint
    }));

});
parcelRegister("dtO5C", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesRoute", () => $8f411a7d1968abd8$export$577b2cf03e294477);
const $8f411a7d1968abd8$export$577b2cf03e294477 = {
    name: 'legacy-project-releases',
    path: '/projects/:projectKey/versions/:id?'
};

});


parcelRegister("8yWy6", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRouteEntry", () => $1b08e96162574dc1$export$836428e7b33b6c6c);

var $9n5I0 = parcelRequire("9n5I0");

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $jCZyd = parcelRequire("jCZyd");
const $1b08e96162574dc1$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $1b08e96162574dc1$export$836428e7b33b6c6c = (0, $bAJhM.createLegacyEntry)((0, $jCZyd.legacyProjectReleasesNoteConfigRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$1b08e96162574dc1$var$pageEntryPoint
    }));

});
parcelRegister("jCZyd", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", () => $2e356efaf12958d0$export$a9509017cabb1e30);
const $2e356efaf12958d0$export$a9509017cabb1e30 = {
    name: 'legacy-project-releases-note-config',
    path: '/secure/ConfigureReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("iM79t", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRouteEntry", () => $00a7120b13c8f7a6$export$781dd53d465d270d);

var $9n5I0 = parcelRequire("9n5I0");

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $b4jBr = parcelRequire("b4jBr");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $5GVyA = parcelRequire("5GVyA");
const $00a7120b13c8f7a6$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS,
    horizontalNavigation: (0, $9n5I0.jiraHorizontalNavEntrypoint)
});
const $00a7120b13c8f7a6$export$781dd53d465d270d = (0, $bAJhM.createLegacyEntry)((0, $5GVyA.legacyProjectReleasesNoteRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$9ab1d1d726b36319)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            (0, $b4jBr.horizontalNavJiraResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$00a7120b13c8f7a6$var$pageEntryPoint
    }));

});
parcelRegister("5GVyA", function(module, exports) {

$parcel$export(module.exports, "legacyProjectReleasesNoteRoute", () => $f9bb7edd7a33af65$export$6ef734887b6da0c8);
const $f9bb7edd7a33af65$export$6ef734887b6da0c8 = {
    name: 'legacy-project-releases-note',
    path: '/secure/ReleaseNote.jspa',
    query: [
        'projectId',
        'version'
    ]
};

});


parcelRegister("7aCB2", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRouteEntry", () => $4c7761cd319564cc$export$256375c5bbf6166a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $fiav1 = parcelRequire("fiav1");
const $4c7761cd319564cc$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $4c7761cd319564cc$export$256375c5bbf6166a = (0, $bAJhM.createLegacyEntry)((0, $fiav1.legacyProjectSettingsCollectorsAddRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$4c7761cd319564cc$var$pageEntryPoint
    }));

});
parcelRegister("fiav1", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsAddRoute", () => $e33528b2281dfffe$export$a3909b9ad3f61ae6);
const $e33528b2281dfffe$export$a3909b9ad3f61ae6 = {
    name: 'legacy-project-settings-collectors-add',
    path: '/secure/AddCollector([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("4bLXR", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsRouteEntry", () => $19f0958e4bfa9b5d$export$e3a7328abebdc329);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $hJOBm = parcelRequire("hJOBm");
const $19f0958e4bfa9b5d$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $19f0958e4bfa9b5d$export$e3a7328abebdc329 = (0, $bAJhM.createLegacyEntry)((0, $hJOBm.legacyProjectSettingsCollectorsRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$19f0958e4bfa9b5d$var$pageEntryPoint
    }));

});
parcelRegister("hJOBm", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsRoute", () => $a22bf882cc469cf4$export$956a041d0b6694e3);
const $a22bf882cc469cf4$export$956a041d0b6694e3 = {
    name: 'legacy-project-settings-collectors',
    path: '/secure/ViewCollectors([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("kxhjT", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRouteEntry", () => $f5c3164083ff2247$export$10edcec0926752a6);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $42jEz = parcelRequire("42jEz");
const $f5c3164083ff2247$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $f5c3164083ff2247$export$10edcec0926752a6 = (0, $bAJhM.createLegacyEntry)((0, $42jEz.legacyProjectSettingsCollectorsHelpRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f5c3164083ff2247$var$pageEntryPoint
    }));

});
parcelRegister("42jEz", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsHelpRoute", () => $8522cc86a4e90bef$export$7433cef5cafafb17);
const $8522cc86a4e90bef$export$7433cef5cafafb17 = {
    name: 'legacy-project-settings-collectors-help',
    path: '/secure/InsertCollectorHelp([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("eqVHn", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRouteEntry", () => $811b399698fa969e$export$7b10472641e87ea);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $hxb5N = parcelRequire("hxb5N");
const $811b399698fa969e$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $811b399698fa969e$export$7b10472641e87ea = (0, $bAJhM.createLegacyEntry)((0, $hxb5N.legacyProjectSettingsCollectorsViewRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$811b399698fa969e$var$pageEntryPoint
    }));

});
parcelRegister("hxb5N", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsCollectorsViewRoute", () => $de6abd0e28e791b9$export$c3f8831257e68c5a);
const $de6abd0e28e791b9$export$c3f8831257e68c5a = {
    name: 'legacy-project-settings-collectors-view',
    path: '/secure/ViewCollector([!%]?[\\w]*).jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("cwou1", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsConfigRouteEntry", () => $6483c2dc0c8e0f42$export$3c4ea5135028082);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $jpSPO = parcelRequire("jpSPO");
const $6483c2dc0c8e0f42$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $6483c2dc0c8e0f42$export$3c4ea5135028082 = (0, $bAJhM.createLegacyEntry)((0, $jpSPO.legacyProjectSettingsConfigRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$6483c2dc0c8e0f42$var$pageEntryPoint
    }));

});
parcelRegister("jpSPO", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsConfigRoute", () => $c567cd7f70e1f784$export$3403c95bb82037b2);
const $c567cd7f70e1f784$export$3403c95bb82037b2 = {
    name: 'legacy-project-settings-config',
    path: '/plugins/servlet/project-config/:projectKey/:adminOption'
};

});


parcelRegister("5vmJQ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDeleteRouteEntry", () => $87800fe4b4cb7947$export$f5fadab402705bc4);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $aMV0e = parcelRequire("aMV0e");
const $87800fe4b4cb7947$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $87800fe4b4cb7947$export$f5fadab402705bc4 = (0, $bAJhM.createLegacyEntry)((0, $aMV0e.legacyProjectSettingsDeleteRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$87800fe4b4cb7947$var$pageEntryPoint
    }));

});
parcelRegister("aMV0e", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDeleteRoute", () => $f2beb94979bbb773$export$4e8f3a153f80bfa1);
const $f2beb94979bbb773$export$4e8f3a153f80bfa1 = {
    name: 'legacy-project-settings-delete',
    path: '(/secure/|/)project/DeleteProject([!%]?[\\w]*).jspa',
    query: [
        'pid'
    ]
};

});


parcelRegister("5PqnJ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDevRouteEntry", () => $ec76bc9a44322472$export$bb5131b6203b8f3a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $lfnPk = parcelRequire("lfnPk");
const $ec76bc9a44322472$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $ec76bc9a44322472$export$bb5131b6203b8f3a = (0, $bAJhM.createLegacyEntry)((0, $lfnPk.legacyProjectSettingsDevRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$ec76bc9a44322472$var$pageEntryPoint
    }));

});
parcelRegister("lfnPk", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsDevRoute", () => $98ef00d9c4f74131$export$d3fca8ea951ff47f);
const $98ef00d9c4f74131$export$d3fca8ea951ff47f = {
    name: 'legacy-project-settings-dev',
    path: '/secure/ConfigureDevStatus.jspa',
    query: [
        'projectKey'
    ]
};

});


parcelRegister("02xNS", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsEditRouteEntry", () => $5edecdbd130bcd62$export$1b930b1155c7c95d);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $iRXFU = parcelRequire("iRXFU");
const $5edecdbd130bcd62$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $5edecdbd130bcd62$export$1b930b1155c7c95d = (0, $bAJhM.createLegacyEntry)((0, $iRXFU.legacyProjectSettingsEditRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$5edecdbd130bcd62$var$pageEntryPoint
    }));

});
parcelRegister("iRXFU", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsEditRoute", () => $c6fdbecb1a658576$export$69813bfb3aa0feb9);
const $c6fdbecb1a658576$export$69813bfb3aa0feb9 = {
    name: 'legacy-project-settings-edit',
    path: '(/secure/|/)project/EditProject([!%]?[\\w]*).jspa',
    query: [
        'pid'
    ]
};

});


parcelRegister("hBetR", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRouteEntry", () => $35345fe2e2d3d123$export$c7cd1115d3e90593);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $fCN3k = parcelRequire("fCN3k");
const $35345fe2e2d3d123$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $35345fe2e2d3d123$export$c7cd1115d3e90593 = (0, $bAJhM.createLegacyEntry)((0, $fCN3k.legacyProjectSettingsFieldsAssociateRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$35345fe2e2d3d123$var$pageEntryPoint
    }));

});
parcelRegister("fCN3k", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsAssociateRoute", () => $320a73596dc9b99c$export$b45ad52ceda09b54);
const $320a73596dc9b99c$export$b45ad52ceda09b54 = {
    name: 'legacy-project-settings-fields-associate',
    path: '/secure/admin/SelectFieldLayoutScheme!default.jspa'
};

});


parcelRegister("3xDJx", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsRouteEntry", () => $c692c476cd3e5f42$export$cf5230efac88ec18);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $dVSnX = parcelRequire("dVSnX");
const $c692c476cd3e5f42$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $c692c476cd3e5f42$export$cf5230efac88ec18 = (0, $bAJhM.createLegacyEntry)((0, $dVSnX.legacyProjectSettingsFieldsRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$c692c476cd3e5f42$var$pageEntryPoint
    }));

});
parcelRegister("dVSnX", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsFieldsRoute", () => $480d7e397528bc65$export$f8d801c531c09b6e);
const $480d7e397528bc65$export$f8d801c531c09b6e = {
    name: 'legacy-project-settings-fields',
    path: '/plugins/servlet/project-config/:projectKey/fields'
};

});


parcelRegister("9pzoA", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRouteEntry", () => $d240bf91d86e97b7$export$ba112336170e9374);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $l2UMT = parcelRequire("l2UMT");
const $d240bf91d86e97b7$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $d240bf91d86e97b7$export$ba112336170e9374 = (0, $bAJhM.createLegacyEntry)((0, $l2UMT.legacyProjectSettingsIssueLayoutRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d240bf91d86e97b7$var$pageEntryPoint
    }));

});
parcelRegister("l2UMT", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueLayoutRoute", () => $402995c3fb904a9e$export$b9490f2a02690c81);
const $402995c3fb904a9e$export$b9490f2a02690c81 = {
    name: 'legacy-project-settings-issue-layout',
    path: '/plugins/servlet/project-config/:projectKey/issuelayout'
};

});


parcelRegister("5jfUQ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRouteEntry", () => $ec2f27edaf5bb54a$export$31f276ec8affeb65);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $iLcl1 = parcelRequire("iLcl1");
const $ec2f27edaf5bb54a$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $ec2f27edaf5bb54a$export$31f276ec8affeb65 = (0, $bAJhM.createLegacyEntry)((0, $iLcl1.legacyProjectSettingsIssueSecurityAssociateRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$ec2f27edaf5bb54a$var$pageEntryPoint
    }));

});
parcelRegister("iLcl1", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityAssociateRoute", () => $89b8deecff0be603$export$8fb428d7ca4ce850);
const $89b8deecff0be603$export$8fb428d7ca4ce850 = {
    name: 'legacy-project-settings-issue-security-associate',
    path: '/secure/project/SelectProjectIssueSecurityScheme([!%]?[\\w]*).jspa'
};

});


parcelRegister("kvIY1", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRouteEntry", () => $569c89b042698556$export$50c072825de9f7ec);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $1MLCl = parcelRequire("1MLCl");
const $569c89b042698556$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $569c89b042698556$export$50c072825de9f7ec = (0, $bAJhM.createLegacyEntry)((0, $1MLCl.legacyProjectSettingsIssueSecurityRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$569c89b042698556$var$pageEntryPoint
    }));

});
parcelRegister("1MLCl", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueSecurityRoute", () => $5846ebf59399d018$export$71aa1b769739b378);
const $5846ebf59399d018$export$71aa1b769739b378 = {
    name: 'legacy-project-settings-issue-security',
    path: '/plugins/servlet/project-config/:projectKey/issuesecurity'
};

});


parcelRegister("5KgFH", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRouteEntry", () => $c4cf8c37370b1ec2$export$997736bd2e54a14b);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $cJz84 = parcelRequire("cJz84");
const $c4cf8c37370b1ec2$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $c4cf8c37370b1ec2$export$997736bd2e54a14b = (0, $bAJhM.createLegacyEntry)((0, $cJz84.legacyProjectSettingsIssueTypesAssociateRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$c4cf8c37370b1ec2$var$pageEntryPoint
    }));

});
parcelRegister("cJz84", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesAssociateRoute", () => $a9a4f029ce953840$export$64a3a3a4a9e32ab2);
const $a9a4f029ce953840$export$64a3a3a4a9e32ab2 = {
    name: 'legacy-project-settings-issue-types-associate',
    path: '/secure/admin/SelectIssueTypeSchemeForProject!default.jspa'
};

});


parcelRegister("bRjLJ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesRouteEntry", () => $ca7fe88e8be53400$export$664d9bccf509eab1);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $jbFUo = parcelRequire("jbFUo");
const $ca7fe88e8be53400$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $ca7fe88e8be53400$export$664d9bccf509eab1 = (0, $bAJhM.createLegacyEntry)((0, $jbFUo.legacyProjectSettingsIssueTypesRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$ca7fe88e8be53400$var$pageEntryPoint
    }));

});
parcelRegister("jbFUo", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsIssueTypesRoute", () => $427cc60ecb23f3ca$export$f22d4a1fbe6ce2d);
const $427cc60ecb23f3ca$export$f22d4a1fbe6ce2d = {
    name: 'legacy-project-settings-issue-types',
    path: '/plugins/servlet/project-config/:projectKey/issuetypes'
};

});


parcelRegister("gBz9X", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRouteEntry", () => $2dc6db88b96dafd7$export$756ebd18bdb87829);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $9nhdQ = parcelRequire("9nhdQ");
const $2dc6db88b96dafd7$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $2dc6db88b96dafd7$export$756ebd18bdb87829 = (0, $bAJhM.createLegacyEntry)((0, $9nhdQ.legacyProjectSettingsNotificationsAssociateRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$2dc6db88b96dafd7$var$pageEntryPoint
    }));

});
parcelRegister("9nhdQ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsAssociateRoute", () => $55f574dad207f5b3$export$c3b586e70bfcdfe);
const $55f574dad207f5b3$export$c3b586e70bfcdfe = {
    name: 'legacy-project-settings-notifications-associate',
    path: '/secure/project/SelectProjectScheme!default.jspa'
};

});


parcelRegister("kWcpN", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsRouteEntry", () => $19a64886ddbdffcd$export$ec9c71381b367931);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $gYB43 = parcelRequire("gYB43");
const $19a64886ddbdffcd$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $19a64886ddbdffcd$export$ec9c71381b367931 = (0, $bAJhM.createLegacyEntry)((0, $gYB43.legacyProjectSettingsNotificationsRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$19a64886ddbdffcd$var$pageEntryPoint
    }));

});
parcelRegister("gYB43", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsNotificationsRoute", () => $7b54ae040696c2c2$export$3053634181f5a1e4);
const $7b54ae040696c2c2$export$3053634181f5a1e4 = {
    name: 'legacy-project-settings-notifications',
    path: '/plugins/servlet/project-config/:projectKey/notifications'
};

});


parcelRegister("lssFA", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsOpsgenieRouteEntry", () => $9b2a0f0b338c6088$export$a0ee66fa0f02ab9a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $evrgy = parcelRequire("evrgy");
const $9b2a0f0b338c6088$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $9b2a0f0b338c6088$export$a0ee66fa0f02ab9a = (0, $bAJhM.createLegacyEntry)((0, $evrgy.legacyProjectSettingsOpsgenieRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$9b2a0f0b338c6088$var$pageEntryPoint
    }));

});
parcelRegister("evrgy", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsOpsgenieRoute", () => $ddc888d5084c2445$export$9bc923c0dc9a3144);
const $ddc888d5084c2445$export$9bc923c0dc9a3144 = {
    name: 'legacy-project-settings-opsgenie',
    path: '/plugins/servlet/project-config/:projectKey/opsgenie'
};

});


parcelRegister("bdfNi", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPeopleRouteEntry", () => $406dea6c0d5b0808$export$a3355a805216689d);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $6tSfI = parcelRequire("6tSfI");

var $8tbnc = parcelRequire("8tbnc");

var $7HuEl = parcelRequire("7HuEl");
const $406dea6c0d5b0808$export$a3355a805216689d = (0, $bAJhM.createLegacyEntry)((0, $7HuEl.legacyProjectSettingsPeopleRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $6tSfI.LegacyPage),
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("7HuEl", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPeopleRoute", () => $31f7124eb758cc59$export$69b69c5831576686);
const $31f7124eb758cc59$export$69b69c5831576686 = {
    name: 'legacy-project-settings-people',
    path: '/plugins/servlet/project-config/:projectKey/people'
};

});


parcelRegister("2HKmQ", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPermissionsRouteEntry", () => $dbcbde4cc94287f1$export$f941d7668bb5b4b9);

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $6tSfI = parcelRequire("6tSfI");

var $8tbnc = parcelRequire("8tbnc");

var $aMLWD = parcelRequire("aMLWD");
const $dbcbde4cc94287f1$export$f941d7668bb5b4b9 = (0, $bAJhM.createLegacyEntry)((0, $aMLWD.legacyProjectSettingsPermissionsRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        component: (0, $6tSfI.LegacyPage),
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ]
    }));

});
parcelRegister("aMLWD", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsPermissionsRoute", () => $622ea2df7f659984$export$e5e3b10fbd5b967);
const $622ea2df7f659984$export$e5e3b10fbd5b967 = {
    name: 'legacy-project-settings-permissions',
    path: '/plugins/servlet/project-config/:projectKey/permissions'
};

});


parcelRegister("jVhaC", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRouteEntry", () => $f67fa4a7d7928bbc$export$c4a7c46acad95724);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $ccFog = parcelRequire("ccFog");
const $f67fa4a7d7928bbc$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $f67fa4a7d7928bbc$export$c4a7c46acad95724 = (0, $bAJhM.createLegacyEntry)((0, $ccFog.legacyProjectSettingsScreensAssociateRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$f67fa4a7d7928bbc$var$pageEntryPoint
    }));

});
parcelRegister("ccFog", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensAssociateRoute", () => $7eddd14a38153bbb$export$e97df9c9d8af2495);
const $7eddd14a38153bbb$export$e97df9c9d8af2495 = {
    name: 'legacy-project-settings-screens-associate',
    path: '/secure/project/SelectIssueTypeScreenScheme!default.jspa'
};

});


parcelRegister("6zufk", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensRouteEntry", () => $4ae4d35076ee6994$export$f0c4185be35123a4);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $bwuEz = parcelRequire("bwuEz");
const $4ae4d35076ee6994$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $4ae4d35076ee6994$export$f0c4185be35123a4 = (0, $bAJhM.createLegacyEntry)((0, $bwuEz.legacyProjectSettingsScreensRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$4ae4d35076ee6994$var$pageEntryPoint
    }));

});
parcelRegister("bwuEz", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsScreensRoute", () => $361f8a146f100a95$export$a132d85f94cbc75c);
const $361f8a146f100a95$export$a132d85f94cbc75c = {
    name: 'legacy-project-settings-screens',
    path: '/plugins/servlet/project-config/:projectKey/screens'
};

});


parcelRegister("5RKia", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsSummaryRouteEntry", () => $8ab00b5760bedbf8$export$b79434e4cc24dab2);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $6VRY0 = parcelRequire("6VRY0");
const $8ab00b5760bedbf8$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $8ab00b5760bedbf8$export$b79434e4cc24dab2 = (0, $bAJhM.createLegacyEntry)((0, $6VRY0.legacyProjectSettingsSummaryRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$8ab00b5760bedbf8$var$pageEntryPoint
    }));

});
parcelRegister("6VRY0", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsSummaryRoute", () => $12803e342ad1f1ba$export$2c4b88224ff6b238);
const $12803e342ad1f1ba$export$2c4b88224ff6b238 = {
    name: 'legacy-project-settings-summary',
    path: '/plugins/servlet/project-config/:projectKey/summary'
};

});


parcelRegister("kPM2h", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRouteEntry", () => $6d562745e216a296$export$496170aba3d2c90a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $aRrjc = parcelRequire("aRrjc");
const $6d562745e216a296$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $6d562745e216a296$export$496170aba3d2c90a = (0, $bAJhM.createLegacyEntry)((0, $aRrjc.legacyProjectSettingsWorkflowsAssociateRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$6d562745e216a296$var$pageEntryPoint
    }));

});
parcelRegister("aRrjc", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsAssociateRoute", () => $dbc69b01ede64e93$export$c70512e2d6fd53d);
const $dbc69b01ede64e93$export$c70512e2d6fd53d = {
    name: 'legacy-project-settings-workflows-associate',
    path: '/secure/project/SelectProjectWorkflowScheme!default.jspa'
};

});


parcelRegister("bcJKE", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRouteEntry", () => $1b814969b36a427f$export$a69fefbe6504422d);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $7jTnu = parcelRequire("7jTnu");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $9NmsS = parcelRequire("9NmsS");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8tbnc = parcelRequire("8tbnc");

var $dFfRj = parcelRequire("dFfRj");

var $bJscI = parcelRequire("bJscI");

var $greNQ = parcelRequire("greNQ");
const $1b814969b36a427f$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $1b814969b36a427f$export$a69fefbe6504422d = (0, $bAJhM.createLegacyEntry)((0, $dFfRj.legacyProjectSettingsWorkflowsRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba),
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            sidebarId: (0, $5RW99.SIDEBAR_ID).PROJECT_SETTINGS,
            topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            (0, $8tbnc.licenseDetailsResource_DEPRECATED_DO_NOT_USE),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $9NmsS.getNavigationSidebarProjectSettingsResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>!(0, $7jTnu.fg)('hix-7083-modern-read-only-workflow-diagram') ? $1b814969b36a427f$var$pageEntryPoint : undefined,
        component: (0, $bJscI.componentWithFG)('hix-7083-modern-read-only-workflow-diagram', (0, $greNQ.ProjectSettingsWorkflows), ()=>null)
    }));

});
parcelRegister("dFfRj", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $d6f76bba36af0fd3$export$b03606cedffdadf6);
const $d6f76bba36af0fd3$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});

parcelRegister("greNQ", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsWorkflows", () => $5e8aee9e36c9b1a7$export$45cb38e9fa0bbddb);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $1KdDN = parcelRequire("1KdDN");

var $6tSfI = parcelRequire("6tSfI");

var $2CJyb = parcelRequire("2CJyb");
const $5e8aee9e36c9b1a7$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS = 'project-config-workflow-designer-link';
const $5e8aee9e36c9b1a7$var$LEGACY_WORKFLOWS_PANEL_BODY_CLASS = 'project-config-workflow-panel-body';
// This id is the main entry point for the project settings workflows page that can be found in:
// `jira-components/jira-plugins/jira-project-config-plugin/plugin/src/main/resources/jira-project-config-plugin/workflows/templates/workflows-tab.vm#lines-23`
const $5e8aee9e36c9b1a7$var$LEGACY_PROJECT_CONFIG_PANEL_WORKFLOWS_ID = 'project-config-panel-workflows';
const $5e8aee9e36c9b1a7$var$getLegacyWorkflowDiagramLinks = ()=>{
    const workflowDiagramLinksElem = globalThis.document?.getElementsByClassName(`${$5e8aee9e36c9b1a7$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS}`);
    return [
        ...workflowDiagramLinksElem ?? []
    ];
};
const $5e8aee9e36c9b1a7$var$getLegacyWorkflowsPanelBody = ()=>{
    const workflowsPanel = globalThis.document?.getElementsByClassName(`${$5e8aee9e36c9b1a7$var$LEGACY_WORKFLOWS_PANEL_BODY_CLASS}`);
    const workflowsPanelArray = [
        ...workflowsPanel ?? []
    ];
    return workflowsPanelArray.length > 0 ? workflowsPanelArray[0] : undefined;
};
const $5e8aee9e36c9b1a7$var$getLegacyProjectConfigPanelWorkflows = ()=>{
    return globalThis.document?.getElementById($5e8aee9e36c9b1a7$var$LEGACY_PROJECT_CONFIG_PANEL_WORKFLOWS_ID);
};
const $5e8aee9e36c9b1a7$export$45cb38e9fa0bbddb = (props)=>{
    const [selectedWorkflow, setSelectedWorkflow] = (0, $eJOHy.useState)(undefined);
    const handleOnClose = (0, $eJOHy.useCallback)(()=>{
        setSelectedWorkflow(undefined);
    }, [
        setSelectedWorkflow
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let observer = null;
        const handleClicksOnWorkflowDiagramLinks = ()=>{
            const workflowsTable = $5e8aee9e36c9b1a7$var$getLegacyWorkflowsPanelBody();
            if (!workflowsTable) return;
            // Register click handlers to all legacy workflow diagram links
            workflowsTable.addEventListener('click', (event)=>{
                // We only want to handle clicks on the legacy workflow diagram links.
                // by checking the closest ancestor element with the class 'project-config-workflow-designer-link'
                // since the `event.target`can be any element inside the link (span for example)
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const diagramLinkElement = event.target.closest(`.${$5e8aee9e36c9b1a7$var$LEGACY_WORKFLOW_DIAGRAM_LINKS_CLASS}`);
                if (diagramLinkElement) {
                    event.preventDefault();
                    const workflowName = diagramLinkElement?.getAttribute('data-workflowname');
                    if (workflowName) setSelectedWorkflow(workflowName);
                }
            });
        };
        // If there are already legacy workflow diagram links, we register the click handler immediately.
        if ($5e8aee9e36c9b1a7$var$getLegacyWorkflowDiagramLinks().length > 0) handleClicksOnWorkflowDiagramLinks();
        else {
            // We only execute this once, when the LEGACY_PROJECT_CONFIG_PANEL_WORKFLOWS_ID is populated
            // This is because the project settings workflows page is rendered server-side and the links are
            // dynamically added to the DOM after the initial render.
            observer = new MutationObserver(()=>{
                handleClicksOnWorkflowDiagramLinks();
                observer && observer.disconnect();
            });
            const projectConfigPanelWorkflows = $5e8aee9e36c9b1a7$var$getLegacyProjectConfigPanelWorkflows();
            if (projectConfigPanelWorkflows) observer.observe(projectConfigPanelWorkflows, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            $5e8aee9e36c9b1a7$var$getLegacyWorkflowsPanelBody()?.removeEventListener('click', handleClicksOnWorkflowDiagramLinks);
            observer && observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "read-only-workflow-diagram-error-boundary",
        packageName: "jiraRouterRoutesLegacyProjectSettingsWorkflowsEntries",
        teamName: "helix",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tSfI.LegacyPage), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, selectedWorkflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2CJyb.default), {
        workflowIdentifier: {
            workflowName: selectedWorkflow
        },
        onClose: handleOnClose
    })));
};

});


parcelRegister("3W2Ej", function(module, exports) {

$parcel$export(module.exports, "legacyReportsAverageAgeRouteEntry", () => $2fcde7cdcddeac8c$export$dae04c73273ef29a);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $aDJAd = parcelRequire("aDJAd");

var $eDk1z = parcelRequire("eDk1z");
const $2fcde7cdcddeac8c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $2fcde7cdcddeac8c$export$dae04c73273ef29a = (0, $bAJhM.createLegacyEntry)((0, $aDJAd.legacyReportsAverageAgeRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $eDk1z.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$2fcde7cdcddeac8c$var$pageEntryPoint
    }));

});
parcelRegister("aDJAd", function(module, exports) {

$parcel$export(module.exports, "legacyReportsAverageAgeRoute", () => $c209a52f3322c05a$export$b40e93dd1042f869);
const $c209a52f3322c05a$export$b40e93dd1042f869 = {
    name: 'legacy-reports-average-age-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:averageage-report'
    ]
};

});

parcelRegister("eDk1z", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $a1fb11070f6e650b$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $a1fb11070f6e650b$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $a1fb11070f6e650b$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("19juL", function(module, exports) {

$parcel$export(module.exports, "legacyReportsConfigRouteEntry", () => $96a114f5994d25fe$export$6dee3bbbe4ff04f);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $3ACQ7 = parcelRequire("3ACQ7");

var $59PYt = parcelRequire("59PYt");
const $96a114f5994d25fe$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $96a114f5994d25fe$export$6dee3bbbe4ff04f = (0, $bAJhM.createLegacyEntry)((0, $3ACQ7.legacyReportsConfigRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $59PYt.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$96a114f5994d25fe$var$pageEntryPoint
    }));

});
parcelRegister("3ACQ7", function(module, exports) {

$parcel$export(module.exports, "legacyReportsConfigRoute", () => $560bf7dbb65c51b5$export$b2ef61435fecef69);
const $560bf7dbb65c51b5$export$b2ef61435fecef69 = {
    name: 'legacy-reports-configure',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey'
    ]
};

});

parcelRegister("59PYt", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $969c95fbe58e33a6$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $969c95fbe58e33a6$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $969c95fbe58e33a6$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("2I8dT", function(module, exports) {

$parcel$export(module.exports, "legacyReportsCreatedVsResolvedRouteEntry", () => $df3e4ccf47269db8$export$b2ed165752bdb8e5);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $bXC7N = parcelRequire("bXC7N");

var $bcWWK = parcelRequire("bcWWK");
const $df3e4ccf47269db8$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $df3e4ccf47269db8$export$b2ed165752bdb8e5 = (0, $bAJhM.createLegacyEntry)((0, $bXC7N.legacyReportsCreatedVsResolvedRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $bcWWK.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$df3e4ccf47269db8$var$pageEntryPoint
    }));

});
parcelRegister("bXC7N", function(module, exports) {

$parcel$export(module.exports, "legacyReportsCreatedVsResolvedRoute", () => $11743cdec9f5fc84$export$832846047e142646);
const $11743cdec9f5fc84$export$832846047e142646 = {
    name: 'legacy-reports-created-vs-resolved-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:createdvsresolved-report'
    ]
};

});

parcelRegister("bcWWK", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $84ec6de83f68521f$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $84ec6de83f68521f$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $84ec6de83f68521f$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("2y7lL", function(module, exports) {

$parcel$export(module.exports, "legacyReportsDeveloperWorkloadRouteEntry", () => $e2430216eaafe899$export$29e29cddbc430ebe);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $hqfi8 = parcelRequire("hqfi8");

var $ezsVM = parcelRequire("ezsVM");
const $e2430216eaafe899$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $e2430216eaafe899$export$29e29cddbc430ebe = (0, $bAJhM.createLegacyEntry)((0, $hqfi8.legacyReportsDeveloperWorkloadRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $ezsVM.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$e2430216eaafe899$var$pageEntryPoint
    }));

});
parcelRegister("hqfi8", function(module, exports) {

$parcel$export(module.exports, "legacyReportsDeveloperWorkloadRoute", () => $e7049ba6f0a956bf$export$a64e86bcf65b3432);
const $e7049ba6f0a956bf$export$a64e86bcf65b3432 = {
    name: 'legacy-reports-developer-workload-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:developer-workload'
    ]
};

});

parcelRegister("ezsVM", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $a0645d0daf1a8ae3$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $a0645d0daf1a8ae3$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $a0645d0daf1a8ae3$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("g33BY", function(module, exports) {

$parcel$export(module.exports, "legacyReportsPieRouteEntry", () => $210b84c225e973a2$export$fd3a1495328fefba);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $cROCw = parcelRequire("cROCw");

var $k9g0G = parcelRequire("k9g0G");
const $210b84c225e973a2$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $210b84c225e973a2$export$fd3a1495328fefba = (0, $bAJhM.createLegacyEntry)((0, $cROCw.legacyReportsPieRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $k9g0G.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$210b84c225e973a2$var$pageEntryPoint
    }));

});
parcelRegister("cROCw", function(module, exports) {

$parcel$export(module.exports, "legacyReportsPieRoute", () => $7a5849a7d7cace0c$export$327da6ce208593c2);
const $7a5849a7d7cace0c$export$327da6ce208593c2 = {
    name: 'legacy-reports-pie-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:pie-report'
    ]
};

});

parcelRegister("k9g0G", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $f3352e60cd5b1d77$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $f3352e60cd5b1d77$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $f3352e60cd5b1d77$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("66kD6", function(module, exports) {

$parcel$export(module.exports, "legacyReportsRecentlyCreatedRouteEntry", () => $8050ba6efd897657$export$666b8efa07780ffb);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $fW39N = parcelRequire("fW39N");

var $3u8cl = parcelRequire("3u8cl");
const $8050ba6efd897657$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $8050ba6efd897657$export$666b8efa07780ffb = (0, $bAJhM.createLegacyEntry)((0, $fW39N.legacyReportsRecentlyCreatedRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $3u8cl.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$8050ba6efd897657$var$pageEntryPoint
    }));

});
parcelRegister("fW39N", function(module, exports) {

$parcel$export(module.exports, "legacyReportsRecentlyCreatedRoute", () => $3c78d0e9407c72f0$export$f81f42a6de9ebb5a);
const $3c78d0e9407c72f0$export$f81f42a6de9ebb5a = {
    name: 'legacy-reports-recently-created-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:recentlycreated-report'
    ]
};

});

parcelRegister("3u8cl", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $3529c687b7bd0670$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $3529c687b7bd0670$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $3529c687b7bd0670$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("fXeFO", function(module, exports) {

$parcel$export(module.exports, "legacyReportsResolutionTimeRouteEntry", () => $c71e3b1e8c1bf2d5$export$53c5b89c8f6f5d76);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $99IHj = parcelRequire("99IHj");

var $6K0Nd = parcelRequire("6K0Nd");
const $c71e3b1e8c1bf2d5$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $c71e3b1e8c1bf2d5$export$53c5b89c8f6f5d76 = (0, $bAJhM.createLegacyEntry)((0, $99IHj.legacyReportsResolutionTimeRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $6K0Nd.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$c71e3b1e8c1bf2d5$var$pageEntryPoint
    }));

});
parcelRegister("99IHj", function(module, exports) {

$parcel$export(module.exports, "legacyReportsResolutionTimeRoute", () => $c43d8fe1d360890d$export$c27dcd4a756d7860);
const $c43d8fe1d360890d$export$c27dcd4a756d7860 = {
    name: 'legacy-reports-resolution-time-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:resolutiontime-report'
    ]
};

});

parcelRegister("6K0Nd", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $92b4e52f93a62ffb$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $92b4e52f93a62ffb$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $92b4e52f93a62ffb$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("kH2f8", function(module, exports) {

$parcel$export(module.exports, "legacyReportsSingleLevelGroupByRouteEntry", () => $0272cfecfee823fd$export$80cd34d8b30c9fff);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $j5HUi = parcelRequire("j5HUi");

var $8QEiK = parcelRequire("8QEiK");
const $0272cfecfee823fd$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $0272cfecfee823fd$export$80cd34d8b30c9fff = (0, $bAJhM.createLegacyEntry)((0, $j5HUi.legacyReportsSingleLevelGroupByRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $8QEiK.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$0272cfecfee823fd$var$pageEntryPoint
    }));

});
parcelRegister("j5HUi", function(module, exports) {

$parcel$export(module.exports, "legacyReportsSingleLevelGroupByRoute", () => $833a3ee653f251a4$export$4b7de6966d0318ae);
const $833a3ee653f251a4$export$4b7de6966d0318ae = {
    name: 'legacy-reports-single-level-group-by-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:singlelevelgroupby'
    ]
};

});

parcelRegister("8QEiK", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $879d8491d4f25f23$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $879d8491d4f25f23$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $879d8491d4f25f23$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("dyd45", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeSinceRouteEntry", () => $72766936ee70343b$export$c0837717e37bba3b);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $eCwOQ = parcelRequire("eCwOQ");

var $cg8Ra = parcelRequire("cg8Ra");
const $72766936ee70343b$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $72766936ee70343b$export$c0837717e37bba3b = (0, $bAJhM.createLegacyEntry)((0, $eCwOQ.legacyReportsTimeSinceRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $cg8Ra.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$72766936ee70343b$var$pageEntryPoint
    }));

});
parcelRegister("eCwOQ", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeSinceRoute", () => $f143f9638ec50c70$export$e9d8f7977a3e63a8);
const $f143f9638ec50c70$export$e9d8f7977a3e63a8 = {
    name: 'legacy-reports-time-since-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:timesince-report'
    ]
};

});

parcelRegister("cg8Ra", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $c702f5c1403f9488$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $c702f5c1403f9488$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $c702f5c1403f9488$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("ip9nB", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeTrackingReportRouteEntry", () => $d0572424f97f7956$export$d911abc03d9aac0e);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $8kUNP = parcelRequire("8kUNP");

var $a67tR = parcelRequire("a67tR");
const $d0572424f97f7956$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $d0572424f97f7956$export$d911abc03d9aac0e = (0, $bAJhM.createLegacyEntry)((0, $8kUNP.legacyReportsTimeTrackingReportRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $a67tR.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$d0572424f97f7956$var$pageEntryPoint
    }));

});
parcelRegister("8kUNP", function(module, exports) {

$parcel$export(module.exports, "legacyReportsTimeTrackingReportRoute", () => $444b4f55cb5d8abd$export$5c05df6c5a65a436);
const $444b4f55cb5d8abd$export$5c05df6c5a65a436 = {
    name: 'legacy-reports-time-tracking-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugin.system.reports:time-tracking'
    ]
};

});

parcelRegister("a67tR", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $a1593f8230aa1a52$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $a1593f8230aa1a52$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $a1593f8230aa1a52$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("1gXQh", function(module, exports) {

$parcel$export(module.exports, "legacyReportsVersionWorkloadRouteEntry", () => $c959d85f1f51330c$export$225a265884367582);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $ehFi7 = parcelRequire("ehFi7");

var $1zA6J = parcelRequire("1zA6J");
const $c959d85f1f51330c$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $c959d85f1f51330c$export$225a265884367582 = (0, $bAJhM.createLegacyEntry)((0, $ehFi7.legacyReportsVersionWorkloadRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $1zA6J.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$c959d85f1f51330c$var$pageEntryPoint
    }));

});
parcelRegister("ehFi7", function(module, exports) {

$parcel$export(module.exports, "legacyReportsVersionWorkloadRoute", () => $f97ceb9ffc573c1c$export$b7a951738ffd54ac);
const $f97ceb9ffc573c1c$export$b7a951738ffd54ac = {
    name: 'legacy-reports-version-workload-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'
    ]
};

});

parcelRegister("1zA6J", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $b26716261821f18d$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $b26716261821f18d$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $b26716261821f18d$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("aGLmH", function(module, exports) {

$parcel$export(module.exports, "legacyReportsWorkloadPieRouteEntry", () => $b9958d422f0ecadd$export$371af7520206fe98);

var $jPn4m = parcelRequire("jPn4m");

var $g8uYY = parcelRequire("g8uYY");

var $ioHIu = parcelRequire("ioHIu");

var $5RW99 = parcelRequire("5RW99");


var $hHbzj = parcelRequire("hHbzj");

var $6zZVV = parcelRequire("6zZVV");

var $9pJMP = parcelRequire("9pJMP");

var $5ddA0 = parcelRequire("5ddA0");

var $aDtWM = parcelRequire("aDtWM");

var $bAJhM = parcelRequire("bAJhM");

var $kRv8K = parcelRequire("kRv8K");

var $4VIcO = parcelRequire("4VIcO");

var $dZRaT = parcelRequire("dZRaT");

var $bTfc4 = parcelRequire("bTfc4");

var $iH0pL = parcelRequire("iH0pL");

var $iMIHk = parcelRequire("iMIHk");
const $b9958d422f0ecadd$var$pageEntryPoint = (0, $g8uYY.createPageEntryPoint)({
    main: (0, $jPn4m.legacyPageEntrypoint),
    topNavigationMenuId: (0, $5RW99.MENU_ID).PROJECTS
});
const $b9958d422f0ecadd$export$371af7520206fe98 = (0, $bAJhM.createLegacyEntry)((0, $iH0pL.legacyReportsWorkloadPieRoute), ()=>({
        layout: (0, $ioHIu.genericProjectLayout),
        navigation: {
            menuId: (0, $5RW99.MENU_ID).PROJECTS,
            sidebar: (0, $aDtWM.genericProjectSidebars),
            horizontal: (0, $aa97a50ba70be130$export$712453ef44fd2eba)
        },
        resources: [
            ...(0, $kRv8K.getBusinessProjectResources)(),
            // these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
            (0, $bTfc4.incidentExperimentTraitResource),
            (0, $dZRaT.projectContextResource),
            (0, $hHbzj.forgeProjectModuleResource),
            (0, $5ddA0.staticSidebarShortcutsResource),
            (0, $9pJMP.staticProjectSidebarNavigationResource),
            (0, $6zZVV.staticProjectSidebarConnectAddonsNavigationResource),
            // end of resources expanded from getNavigationSidebarProjectResource
            ...(0, $iMIHk.getReportsCommonResource)(),
            (0, $4VIcO.getConsolidationStateResource)()
        ],
        entryPoint: ()=>$b9958d422f0ecadd$var$pageEntryPoint
    }));

});
parcelRegister("iH0pL", function(module, exports) {

$parcel$export(module.exports, "legacyReportsWorkloadPieRoute", () => $a5c6e4446a6a5b4f$export$e8a2e4a5ccbbeff6);
const $a5c6e4446a6a5b4f$export$e8a2e4a5ccbbeff6 = {
    name: 'legacy-reports-workload-pie-report',
    path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
    query: [
        'reportKey=com.atlassian.jira.ext.charting:workloadpie-report'
    ]
};

});

parcelRegister("iMIHk", function(module, exports) {

$parcel$export(module.exports, "getReportsCommonResource", () => $44066cf198f4ce1f$export$8cb713295e6b7204);

var $ho3Tv = parcelRequire("ho3Tv");

var $dHUNm = parcelRequire("dHUNm");

var $hlh4g = parcelRequire("hlh4g");
const $44066cf198f4ce1f$export$8cb713295e6b7204 = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource)
    ];
const $44066cf198f4ce1f$export$f234446c23dc22a = ()=>[
        (0, $hlh4g.devOpsReportPreconditionResource),
        (0, $dHUNm.staticProjectReportsSidebarConnectAddonsNavigationResource),
        (0, $ho3Tv.staticSidebarJSWReportsResource)
    ];

});


parcelRegister("2leDl", function(module, exports) {

$parcel$export(module.exports, "workflowDesignerRouteEntry", () => $a8918035b31ea060$export$5863c71049541219);

var $yRJUA = parcelRequire("yRJUA");

var $5RW99 = parcelRequire("5RW99");

var $hHbzj = parcelRequire("hHbzj");

var $8XpuN = parcelRequire("8XpuN");

var $6xToB = parcelRequire("6xToB");

var $enHI7 = parcelRequire("enHI7");

var $9NmsS = parcelRequire("9NmsS");

var $chRQD = parcelRequire("chRQD");

var $fU2eR = parcelRequire("fU2eR");
const $a8918035b31ea060$export$5863c71049541219 = (0, $6xToB.createEntry)((0, $chRQD.workflowDesignerRoute), ()=>({
        component: (0, $fU2eR.LegacyWorkflowDesigner),
        layout: (0, $yRJUA.globalSettingsLayout),
        navigation: {
            sidebarId: (0, $5RW99.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
            sidebar: (0, $8XpuN.default)
        },
        resources: [
            ...(0, $9NmsS.getNavigationResources)(),
            (0, $enHI7.navigationSidebarGlobalResource),
            ...(0, $hHbzj.getNavigationSidebarGlobalSettingsResources)()
        ]
    }));

});
parcelRegister("chRQD", function(module, exports) {

$parcel$export(module.exports, "workflowDesignerRoute", () => $d79d80e12f9d6a9b$export$7cd61529f5fa5e43);
const $d79d80e12f9d6a9b$export$7cd61529f5fa5e43 = {
    name: 'global-settings-issues-workflows-pages',
    path: '/secure/admin/(workflows/|)(WorkflowDesigner|ViewWorkflowSteps).jspa'
};

});

parcelRegister("fU2eR", function(module, exports) {

$parcel$export(module.exports, "LegacyWorkflowDesigner", () => $f06e1edafc62bf95$export$c264c6032a3fa865);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $1KdDN = parcelRequire("1KdDN");

var $6tSfI = parcelRequire("6tSfI");

var $gVcD2 = parcelRequire("gVcD2");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $joel7 = parcelRequire("joel7");

var $d1waL = parcelRequire("d1waL");
const $f06e1edafc62bf95$var$BLACKLISTED_PATHS_REGEX = [
    // This blacklist any URL within the same Legacy workflow editor containing `/secure/admin/workflows/*`
    '^/secure/admin/workflows/.*',
    // This blacklist redirects from the new workflow editor to the legacy workflow editor containing `/jira/settings/issues/workflows/<anyId>`
    '^/jira/settings/issues/workflows/[^/].*'
];
const $f06e1edafc62bf95$export$6df0153bc79f9d83 = (referrer, hostname)=>{
    if (referrer) {
        const referrerUrl = new URL(referrer);
        if (hostname === referrerUrl.hostname) {
            const referrerPath = referrerUrl.pathname;
            // Check if the referrer path matches any of the blacklisted paths
            const isBlacklisted = $f06e1edafc62bf95$var$BLACKLISTED_PATHS_REGEX.some((pathRegex)=>{
                const regex = new RegExp(pathRegex);
                return regex.test(referrerPath);
            });
            return !isBlacklisted;
        }
    }
    return false;
};
const $f06e1edafc62bf95$export$c264c6032a3fa865 = (props)=>{
    const elm = false ? null : globalThis.document?.getElementById('workflow-editor-preference-dropdown');
    const workflowId = elm?.getAttribute('data-workflow-id') ?? '';
    const workflowName = elm?.getAttribute('data-workflow-name') ?? '';
    const editMode = elm?.getAttribute('data-edit-mode') ?? undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const referrer = globalThis.document?.referrer || '';
        if ($f06e1edafc62bf95$export$6df0153bc79f9d83(referrer, globalThis.window.location.hostname)) (0, $joel7.getUserWorkflowEditorPreference)().then((preference)=>{
            const defaultEditorPreference = preference !== (0, $d1waL.NEW_EDITOR) && preference !== (0, $d1waL.LEGACY_EDITOR) ? 'NONE' : preference;
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'defaultWorkflowEditor applied', {
                defaultEditor: (0, $d1waL.LEGACY_EDITOR),
                defaultEditorPreference: defaultEditorPreference
            });
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jsm-dropdown-error-boundary",
        packageName: "jiraRouterRoutesLegacyWorkflowDesignerEntries",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tSfI.LegacyPage), props), elm && /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gVcD2.WorkflowEditorPreferenceDropdown), {
        workflowId: workflowId,
        workflowName: workflowName,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        editMode: editMode
    }), elm));
};

});
parcelRegister("gVcD2", function(module, exports) {

$parcel$export(module.exports, "WorkflowEditorPreferenceDropdown", () => $0fd876bb8040a0bf$export$7194565c2a06a25d);
$parcel$export(module.exports, "DefaultWorkflowEditorDialog", () => $0fd876bb8040a0bf$export$6e60a479812ee7d6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $7jTnu = parcelRequire("7jTnu");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cXnIM = parcelRequire("cXnIM");

var $bJscI = parcelRequire("bJscI");

var $d1waL = parcelRequire("d1waL");

var $6YrjQ = parcelRequire("6YrjQ");

var $JohF3 = parcelRequire("JohF3");

var $jbiOt = parcelRequire("jbiOt");
const $0fd876bb8040a0bf$var$openInNewEditor = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.open-in-new-editor',
    defaultMessage: 'Open workflow in new editor',
    description: 'Link that opens workflow in new workflow editor'
});
const $0fd876bb8040a0bf$var$changeDefaultEditor = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.change-default-editor',
    defaultMessage: 'Change default editor',
    description: 'Link that allows you to switch default workflow editor to the old workflow editor'
});
const $0fd876bb8040a0bf$var$switchEditorButton = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.switch-editor-button',
    defaultMessage: 'Switch editor',
    description: 'Button that allows you to open dropdown with option to switch editor'
});
const $0fd876bb8040a0bf$export$7194565c2a06a25d = ({ workflowId: workflowId, workflowName: workflowName, editMode: editMode })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [showDialog, setShowDialog] = (0, $eJOHy.useState)(false);
    const openDialog = ()=>setShowDialog(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Show flag when show old editor flag is true in session storage
    (0, $6YrjQ.useChangeToOldEditorSuccessFlag)({
        openDefaultEditorDialog: openDialog
    });
    const fireTrackEvent = (0, $eJOHy.useCallback)((mode)=>{
        const dropdownItemClickEvent = createAnalyticsEvent({
            action: 'click',
            actionSubject: 'dropdownItem'
        });
        (0, $gCeeo.fireUIAnalytics)(dropdownItemClickEvent, 'workflowEditorToolbarNewEditorLink', {
            workflowLegacyEditMode: mode === 'draft' ? 'Draft' : 'Live'
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        testId: "workflow-editor-preference-settings.ui.dropdown-menu",
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                    label: "",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0fd876bb8040a0bf$var$LegacyButtonText, null, formatMessage($0fd876bb8040a0bf$var$switchEditorButton))),
        shouldRenderToParent: (0, $7jTnu.fg)('should-render-to-parent-should-be-true-helix')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        href: (0, $cXnIM.getNewEditorLink)(workflowId),
        onClick: ()=>fireTrackEvent(editMode),
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage($0fd876bb8040a0bf$var$openInNewEditor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: openDialog
    }, formatMessage($0fd876bb8040a0bf$var$changeDefaultEditor)))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0fd876bb8040a0bf$export$6e60a479812ee7d6, {
        workflowName: workflowName,
        workflowId: workflowId,
        workflowPublicationStatus: editMode === 'draft' ? (0, $d1waL.WorkflowPublicationStatus).Draft : (0, $d1waL.WorkflowPublicationStatus).Live,
        onClose: ()=>setShowDialog(false),
        onOpenDefaultEditorDialog: openDialog
    }));
};
const $0fd876bb8040a0bf$export$6e60a479812ee7d6 = (0, $bJscI.componentWithFG)('hix-7095_workflow_editor_selector_refactor', (0, $jbiOt.DefaultWorkflowEditorDialog), (0, $JohF3.DefaultWorkflowEditorDialog)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0fd876bb8040a0bf$var$LegacyButtonText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_k48pi7a9",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cXnIM", function(module, exports) {

$parcel$export(module.exports, "orderStatusesByCategoryAndName", () => $411dfe931bf59896$export$2068d124b6d003c3);
$parcel$export(module.exports, "getLegacyEditorLink", () => $411dfe931bf59896$export$ff5bc033c9b0efb4);
$parcel$export(module.exports, "getLegacyEditorDraftLink", () => $411dfe931bf59896$export$b94e7e81739daa7e);
$parcel$export(module.exports, "getNewEditorLink", () => $411dfe931bf59896$export$540456165b615498);
$parcel$export(module.exports, "openLegacyEditor", () => $411dfe931bf59896$export$766368a57fd33bad);
$parcel$export(module.exports, "buildEditWorkflowJSPUrl", () => $411dfe931bf59896$export$2e17b62c233ea33b);
$parcel$export(module.exports, "findRuleDefinitionForConfiguredRule", () => $411dfe931bf59896$export$5abcac058edd2986);

var $80xRm = parcelRequire("80xRm");

var $b5RwB = parcelRequire("b5RwB");

var $gRw8I = parcelRequire("gRw8I");

var $kIz4h = parcelRequire("kIz4h");

var $200fA = parcelRequire("200fA");
const $411dfe931bf59896$export$2068d124b6d003c3 = (statuses)=>(0, (/*@__PURE__*/$parcel$interopDefault($80xRm)))(statuses, [
        (status)=>(0, $200fA.STATUS_CATEGORY_WEIGHTS)[status.statusCategory],
        'name'
    ]);
const $411dfe931bf59896$export$ff5bc033c9b0efb4 = (workflowName)=>`/secure/admin/workflows/WorkflowDesigner.jspa?workflowMode=live&wfName=${encodeURIComponent(workflowName)}`;
const $411dfe931bf59896$export$b94e7e81739daa7e = (workflowName)=>`/secure/admin/workflows/WorkflowDesigner.jspa?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        workflowMode: 'draft',
        wfName: workflowName
    })}`;
const $411dfe931bf59896$export$540456165b615498 = (workflowId)=>`/jira/settings/issues/workflows/${workflowId}`;
const $411dfe931bf59896$export$766368a57fd33bad = (workflowName)=>{
    (0, $gRw8I.di)(window);
    const url = $411dfe931bf59896$export$ff5bc033c9b0efb4(workflowName);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
};
const $411dfe931bf59896$export$2e17b62c233ea33b = (workflowName)=>`/secure/admin/workflows/EditWorkflowDispatcher.jspa?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        atl_token: (0, $kIz4h.default)(),
        wfName: workflowName
    })}`;
const $411dfe931bf59896$export$1a907429044213b9 = (value, condition)=>condition;
const $411dfe931bf59896$export$5abcac058edd2986 = (rule, availableRules)=>{
    const ruleKey = rule.ruleKey;
    if (ruleKey.startsWith('connect')) return availableRules.find((definition)=>definition.variety === 'connect' && definition.key === ruleKey && definition.id === rule.config.appKey);
    if (ruleKey.startsWith('forge')) return availableRules.find((definition)=>definition.variety === 'forge' && definition.key === ruleKey && definition.id === rule.config.key);
    return availableRules.find((definition)=>definition.key === ruleKey);
};

});

parcelRegister("d1waL", function(module, exports) {

$parcel$export(module.exports, "NEW_EDITOR", () => $e0652d39a85610d8$export$83282786ca4b04f);
$parcel$export(module.exports, "LEGACY_EDITOR", () => $e0652d39a85610d8$export$e2f196e116d3fca2);
$parcel$export(module.exports, "WorkflowPublicationStatus", () => $e0652d39a85610d8$export$8b8b078375514ab6);
const $e0652d39a85610d8$export$83282786ca4b04f = 'NEW';
const $e0652d39a85610d8$export$e2f196e116d3fca2 = 'LEGACY';
var $e0652d39a85610d8$export$8b8b078375514ab6 = /*#__PURE__*/ function(WorkflowPublicationStatus) {
    WorkflowPublicationStatus[WorkflowPublicationStatus["None"] = 0] = "None";
    WorkflowPublicationStatus[WorkflowPublicationStatus["Dirty"] = 1] = "Dirty";
    WorkflowPublicationStatus[WorkflowPublicationStatus["Draft"] = 2] = "Draft";
    WorkflowPublicationStatus[WorkflowPublicationStatus["Live"] = 3] = "Live";
    return WorkflowPublicationStatus;
}({});

});

parcelRegister("6YrjQ", function(module, exports) {

$parcel$export(module.exports, "useChangeToOldEditorSuccessFlag", () => $8db3af68eb59bc1d$export$4a8a957b814cf4be);

var $eJOHy = parcelRequire("eJOHy");

var $gpARp = parcelRequire("gpARp");

var $9MgGx = parcelRequire("9MgGx");
const $8db3af68eb59bc1d$export$4a8a957b814cf4be = ({ openDefaultEditorDialog: openDefaultEditorDialog })=>{
    const { showOldEditorSuccessFlag: showOldEditorSuccessFlag } = (0, $9MgGx.useChangePreferenceFlag)();
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $gpARp.getShouldShowOldEditorSucccessFlag)()) {
            (0, $gpARp.clearShowOldEditorSucccessFlag)();
            showOldEditorSuccessFlag(openDefaultEditorDialog);
        }
    }, [
        openDefaultEditorDialog,
        showOldEditorSuccessFlag
    ]);
    return {
        showOldEditorSuccessFlag: showOldEditorSuccessFlag
    };
};

});
parcelRegister("gpARp", function(module, exports) {

$parcel$export(module.exports, "getShouldShowNewEditorSucccessFlag", () => $f2df7db82cc17282$export$b33dd94e7d4068a9);
$parcel$export(module.exports, "setShowNewEditorSuccessFlag", () => $f2df7db82cc17282$export$38de37b600fe15c7);
$parcel$export(module.exports, "clearShowNewEditorSucccessFlag", () => $f2df7db82cc17282$export$10794e9068b437c1);
$parcel$export(module.exports, "getShouldShowOldEditorSucccessFlag", () => $f2df7db82cc17282$export$b07da7bcc8c25b1a);
$parcel$export(module.exports, "clearShowOldEditorSucccessFlag", () => $f2df7db82cc17282$export$385473acd3052995);
$parcel$export(module.exports, "setShowOldEditorSuccessFlag", () => $f2df7db82cc17282$export$baea524121407210);

var $7jTnu = parcelRequire("7jTnu");

var $4elgJ = parcelRequire("4elgJ");
const $f2df7db82cc17282$var$sessionStorageProvider = (0, $4elgJ.createSessionStorageProvider)('', false);
const $f2df7db82cc17282$var$SHOW_NEW_EDITOR_SUCCESS_FLAG = 'SHOW_NEW_EDITOR_SUCCESS_FLAG';
const $f2df7db82cc17282$var$SHOW_OLD_EDITOR_ERROR_FLAG = 'SHOW_OLD_EDITOR_SUCCESS_FLAG';
// New editor success flag
const $f2df7db82cc17282$var$updateShowNewEditorSucccessFlag = (value)=>{
    (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $f2df7db82cc17282$var$sessionStorageProvider.set($f2df7db82cc17282$var$SHOW_NEW_EDITOR_SUCCESS_FLAG, value.toString()) : sessionStorage.setItem($f2df7db82cc17282$var$SHOW_NEW_EDITOR_SUCCESS_FLAG, value.toString());
};
const $f2df7db82cc17282$export$b33dd94e7d4068a9 = ()=>(0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? Boolean($f2df7db82cc17282$var$sessionStorageProvider.get($f2df7db82cc17282$var$SHOW_NEW_EDITOR_SUCCESS_FLAG)) : Boolean(sessionStorage.getItem($f2df7db82cc17282$var$SHOW_NEW_EDITOR_SUCCESS_FLAG));
const $f2df7db82cc17282$export$38de37b600fe15c7 = ()=>{
    $f2df7db82cc17282$var$updateShowNewEditorSucccessFlag(true);
};
const $f2df7db82cc17282$export$10794e9068b437c1 = ()=>{
    (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $f2df7db82cc17282$var$sessionStorageProvider.remove($f2df7db82cc17282$var$SHOW_NEW_EDITOR_SUCCESS_FLAG) : sessionStorage.removeItem($f2df7db82cc17282$var$SHOW_NEW_EDITOR_SUCCESS_FLAG);
};
// Old editor success flag
const $f2df7db82cc17282$var$updateShowOldEditorSucccessFlag = (value)=>{
    (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $f2df7db82cc17282$var$sessionStorageProvider.set($f2df7db82cc17282$var$SHOW_OLD_EDITOR_ERROR_FLAG, value.toString()) : sessionStorage.setItem($f2df7db82cc17282$var$SHOW_OLD_EDITOR_ERROR_FLAG, value.toString());
};
const $f2df7db82cc17282$export$b07da7bcc8c25b1a = ()=>(0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? Boolean($f2df7db82cc17282$var$sessionStorageProvider.get($f2df7db82cc17282$var$SHOW_OLD_EDITOR_ERROR_FLAG)) : Boolean(sessionStorage.getItem($f2df7db82cc17282$var$SHOW_OLD_EDITOR_ERROR_FLAG));
const $f2df7db82cc17282$export$385473acd3052995 = ()=>{
    (0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration') ? $f2df7db82cc17282$var$sessionStorageProvider.remove($f2df7db82cc17282$var$SHOW_OLD_EDITOR_ERROR_FLAG) : sessionStorage.removeItem($f2df7db82cc17282$var$SHOW_OLD_EDITOR_ERROR_FLAG);
};
const $f2df7db82cc17282$export$baea524121407210 = ()=>{
    $f2df7db82cc17282$var$updateShowOldEditorSucccessFlag(true);
};

});
parcelRegister("4elgJ", function(module, exports) {

$parcel$export(module.exports, "createSessionStorageProvider", () => $f208fb4d7830e639$export$a922b987e648d2fa);
$parcel$export(module.exports, "createSessionExpirableStorageProvider", () => $f208fb4d7830e639$export$e0a2e9a062c6a695);

var $5PQOA = parcelRequire("5PQOA");

var $iuNRp = parcelRequire("iuNRp");

var $agkTI = parcelRequire("agkTI");
const $f208fb4d7830e639$export$a922b987e648d2fa = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix, shouldSerialize = true)=>(0, $iuNRp.createStorageProvider)((0, $iuNRp.WebStorageType).SessionStorage, appPrefix, (0, $agkTI.makeSessionStore)(), shouldSerialize));
const $f208fb4d7830e639$export$e0a2e9a062c6a695 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    return (0, $iuNRp.createExpirableStorageProvider)((0, $iuNRp.WebStorageType).SessionStorage, appPrefix, (0, $agkTI.makeSessionExpirableStore)());
});

});
parcelRegister("agkTI", function(module, exports) {

$parcel$export(module.exports, "makeSessionStore", () => $a7c3f7fc6c065ac0$export$fb690882d627b3b5);
$parcel$export(module.exports, "makeSessionExpirableStore", () => $a7c3f7fc6c065ac0$export$a8f626c8ded9a06c);

var $fsdQg = parcelRequire("fsdQg");

var $252Bx = parcelRequire("252Bx");

var $02LWr = parcelRequire("02LWr");

var $jZWi5 = parcelRequire("jZWi5");

var $asupr = parcelRequire("asupr");

var $iuNRp = parcelRequire("iuNRp");
const $a7c3f7fc6c065ac0$export$fb690882d627b3b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($asupr))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], (0, $iuNRp.plugins));
const $a7c3f7fc6c065ac0$export$a8f626c8ded9a06c = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($02LWr))).createStore([
        (0, (/*@__PURE__*/$parcel$interopDefault($asupr))),
        (0, (/*@__PURE__*/$parcel$interopDefault($jZWi5)))
    ], [
        (0, (/*@__PURE__*/$parcel$interopDefault($fsdQg))),
        (0, (/*@__PURE__*/$parcel$interopDefault($252Bx)))
    ]);

});



parcelRegister("9MgGx", function(module, exports) {

$parcel$export(module.exports, "useChangePreferenceFlag", () => $d017c1cf33596897$export$cb7da29550cd2317);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $bILK0 = parcelRequire("bILK0");

var $7qGN1 = parcelRequire("7qGN1");
const $d017c1cf33596897$var$changeToOldEditorTitle = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.controllers.change-preference-flag.change-to-old-editor-title',
    defaultMessage: "You've changed the default editor",
    description: 'Title for success flag when user successfully updated their editor preference to old editor'
});
const $d017c1cf33596897$var$changeToOldEditorDescription = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.controllers.change-preference-flag.change-to-old-editor-description',
    defaultMessage: 'You can use the old editor as needed while we continue building the new editor.',
    description: 'Description for success flag when user successfully updated their editor preference to old editor'
});
const $d017c1cf33596897$var$learnMore = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.controllers.change-preference-flag.learn-more',
    defaultMessage: 'Learn more',
    description: 'Label for learn more link in success flag'
});
const $d017c1cf33596897$var$switchToNewEditor = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.controllers.change-preference-flag.switch-to-new-editor',
    defaultMessage: 'Switch to new editor',
    description: 'Label for switch to new editor link in success flag'
});
const $d017c1cf33596897$var$changeToNewEditorTitle = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.controllers.change-preference-flag.change-to-new-editor-title',
    defaultMessage: 'Welcome to the new workflow editor',
    description: 'Title for success flag when user successfully updated their editor preference to new editor'
});
const $d017c1cf33596897$var$changeToNewEditorDescription = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.controllers.change-preference-flag.change-to-new-editor-description',
    defaultMessage: 'Enjoy a faster, cleaner, more intuitive experience while creating and editing your workflows.',
    description: 'Description for success flag when user successfully updated their editor preference to new editor'
});
const $d017c1cf33596897$var$ok = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.controllers.change-preference-flag.ok',
    defaultMessage: 'Ok',
    description: 'Label for ok button in success flag'
});
const $d017c1cf33596897$var$updatePreferenceErrorFlagTitle = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.controllers.change-preference-flag.update-preference-error-flag-title',
    defaultMessage: "We couldn't update your default editor",
    description: "Title for error flag when there was a failure updating the user's editor preference"
});
const $d017c1cf33596897$var$updatePreferenceErrorFlagDescription = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.controllers.change-preference-flag.update-preference-error-flag-description',
    defaultMessage: 'Select Confirm to try again.',
    description: "Description for error flag when there was a failure updating the user's editor preference"
});
const $d017c1cf33596897$var$NEW_EDITOR_SUCCESS_FLAG = 'new-editor-success-flag';
const $d017c1cf33596897$var$learnMoreLinkNewEditor = 'https://support.atlassian.com/jira-service-management-cloud/docs/using-the-new-workflow-editor/';
const $d017c1cf33596897$var$learnMoreLinkOldEditor = 'https://support.atlassian.com/jira-service-management-cloud/docs/changing-your-default-workflow-editor/';
const $d017c1cf33596897$export$cb7da29550cd2317 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const onClickLearnMoreOldEditor = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open($d017c1cf33596897$var$learnMoreLinkOldEditor, '_blank');
    };
    const onClickLearnMoreNewEditor = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open($d017c1cf33596897$var$learnMoreLinkNewEditor, '_blank');
    };
    const showNewEditorSuccessFlag = (0, $eJOHy.useCallback)(()=>showFlag({
            id: $d017c1cf33596897$var$NEW_EDITOR_SUCCESS_FLAG,
            testId: 'workflow-editor-preference-settings.ui.success-flag',
            type: 'success',
            title: $d017c1cf33596897$var$changeToNewEditorTitle,
            description: $d017c1cf33596897$var$changeToNewEditorDescription,
            messageId: 'workflow-editor-preference-settings.controllers.change-preference-flag.show-flag.success.change-to-new-editor',
            messageType: 'transactional',
            actions: [
                {
                    content: $d017c1cf33596897$var$learnMore,
                    onClick: onClickLearnMoreNewEditor
                },
                {
                    content: $d017c1cf33596897$var$ok,
                    onClick: ()=>dismissFlag($d017c1cf33596897$var$NEW_EDITOR_SUCCESS_FLAG)
                }
            ]
        }), [
        dismissFlag,
        showFlag
    ]);
    const showOldEditorSuccessFlag = (0, $eJOHy.useCallback)((openDefaultEditorDialog = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))))=>showFlag({
            type: 'success',
            title: $d017c1cf33596897$var$changeToOldEditorTitle,
            description: $d017c1cf33596897$var$changeToOldEditorDescription,
            messageId: 'workflow-editor-preference-settings.controllers.change-preference-flag.show-flag.success.change-to-old-editor',
            messageType: 'transactional',
            actions: [
                {
                    content: $d017c1cf33596897$var$learnMore,
                    onClick: onClickLearnMoreOldEditor
                },
                {
                    content: $d017c1cf33596897$var$switchToNewEditor,
                    onClick: openDefaultEditorDialog
                }
            ]
        }), [
        showFlag
    ]);
    const showErrorFlag = (0, $eJOHy.useCallback)(()=>showFlag({
            type: 'error',
            title: $d017c1cf33596897$var$updatePreferenceErrorFlagTitle,
            description: $d017c1cf33596897$var$updatePreferenceErrorFlagDescription,
            messageId: 'workflow-editor-preference-settings.controllers.change-preference-flag.show-flag.error.update-preference-error',
            messageType: 'transactional'
        }), [
        showFlag
    ]);
    return {
        showNewEditorSuccessFlag: showNewEditorSuccessFlag,
        showOldEditorSuccessFlag: showOldEditorSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};

});


parcelRegister("JohF3", function(module, exports) {

$parcel$export(module.exports, "DefaultWorkflowEditorDialog", () => $2334f6d59347c35f$export$6e60a479812ee7d6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $eJ9f5 = parcelRequire("eJ9f5");

var $goZPP = parcelRequire("goZPP");

var $jkYbX = parcelRequire("jkYbX");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $gPG64 = parcelRequire("gPG64");

var $7jTnu = parcelRequire("7jTnu");

var $aC4Bh = parcelRequire("aC4Bh");

var $2ZGUP = parcelRequire("2ZGUP");

var $1KdDN = parcelRequire("1KdDN");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $cXnIM = parcelRequire("cXnIM");

var $gCY1z = parcelRequire("gCY1z");

var $d1waL = parcelRequire("d1waL");

var $9MgGx = parcelRequire("9MgGx");

var $jwKNV = parcelRequire("jwKNV");

var $2IzSf = parcelRequire("2IzSf");

var $6fUC4 = parcelRequire("6fUC4");

var $gpARp = parcelRequire("gpARp");

var $j7mKb = parcelRequire("j7mKb");

var $6sxbe = parcelRequire("6sxbe");
const $2334f6d59347c35f$var$title = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.title',
    defaultMessage: 'Select a default workflow editor',
    description: 'Heading for the default workflow modal.'
});
const $2334f6d59347c35f$var$body = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.body',
    defaultMessage: "While we continue building the new workflow editor, you can switch between editors as needed. When you select a default, we\u2019ll always open your workflows in that editor.",
    description: 'Warning modal body text to explain changes will be lost on close.'
});
const $2334f6d59347c35f$var$instruction = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.instruction',
    defaultMessage: 'Select a default workflow editor',
    description: 'Instruction text to choose default editor.'
});
const $2334f6d59347c35f$var$learnMoreLinki18n = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.learn-more-link',
    defaultMessage: '<a>Learn more about editing workflows</a>.',
    description: 'Link that open a page helping user understand more about editing workflows.'
});
const $2334f6d59347c35f$var$newWorkflowEditor = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.new-workflow-editor',
    defaultMessage: 'New editor',
    description: 'Label of new editor option.'
});
const $2334f6d59347c35f$var$oldWorkflowEditor = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.old-workflow-editor',
    defaultMessage: 'Old editor',
    description: 'Label of old editor option.'
});
const $2334f6d59347c35f$var$cancelButton = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.cancel-button',
    defaultMessage: 'Cancel',
    description: 'Label for back button.'
});
const $2334f6d59347c35f$var$confirmButton = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.confirm-button',
    defaultMessage: 'Confirm',
    description: 'Label for confirm button.'
});
const $2334f6d59347c35f$var$updateButton = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.update-button',
    defaultMessage: 'Update',
    description: 'Label for update button.'
});
const $2334f6d59347c35f$var$draftUnpublishedWarning = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.draft-unpublished-warning',
    defaultMessage: 'Publish your draft workflow before continuing so that your edits will be visible in the new workflow editor.',
    description: 'A warning message informing users to publish their draft their workflow before switching workflow editors as otherwise the changes will not be reflected in the new editor.'
});
const $2334f6d59347c35f$var$dirtyLossWarning = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.dirty-loss-warning',
    defaultMessage: "You\u2019ve made changes to {workflowName}. To save those changes select {cancel}, then {update} workflow before continuing.",
    description: 'A warning message informing users to save any changes to their workflow before switching workflow editors as they will otherwise be lost.'
}); // remove when cleaning jira-workflow-editor-analytics_53yss
var $2334f6d59347c35f$export$759a75979ec109e2 = /*#__PURE__*/ function(WarningType) {
    WarningType[WarningType["None"] = 0] = "None";
    WarningType[WarningType["Dirty"] = 1] = "Dirty";
    WarningType[WarningType["Draft"] = 2] = "Draft";
    return WarningType;
}({});
const $2334f6d59347c35f$var$DefaultWorkflowEditorDialogInner = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, returnFocusRef: returnFocusRef, workflowPublicationStatus: workflowPublicationStatus = (0, $d1waL.WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
    (0, $gRw8I.di)(window);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [selectedWorkflowEditor, setSelectedWorkflowEditor] = (0, $eJOHy.useState)(null);
    const [{ route: route }] = (0, $gCY1z.useRouter)();
    const { userPreference: userPreference } = (0, $jwKNV.useNewWorkflowEditorPreference)();
    const { showNewEditorSuccessFlag: showNewEditorSuccessFlag, showOldEditorSuccessFlag: showOldEditorSuccessFlag, showErrorFlag: showErrorFlag } = (0, $9MgGx.useChangePreferenceFlag)();
    (0, $eJOHy.useEffect)(()=>{
        setSelectedWorkflowEditor(userPreference);
    }, [
        userPreference,
        setSelectedWorkflowEditor
    ]);
    const redirectToLegacyEditorAndShowSuccessFlag = (0, $eJOHy.useCallback)(()=>{
        if (route?.name === 'global-settings-issues-workflows-pages') showOldEditorSuccessFlag(onOpenDefaultEditorDialog);
        else {
            // set flag to show success flag in session storage when user is redirected to legacy editor
            (0, $gpARp.setShowOldEditorSuccessFlag)(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(shouldRedirectToDraftMode ? (0, $cXnIM.buildEditWorkflowJSPUrl)(workflowName) : (0, $cXnIM.getLegacyEditorLink)(workflowName));
        }
    }, [
        route?.name,
        shouldRedirectToDraftMode,
        showOldEditorSuccessFlag,
        workflowName,
        onOpenDefaultEditorDialog
    ]);
    const redirectToNewEditorAndShowSuccessFlag = (0, $eJOHy.useCallback)(()=>{
        if (route?.name === 'global-settings-issues-workflow-edit') showNewEditorSuccessFlag();
        else {
            // set flag to show success flag in session storage when user is redirected to new editor
            (0, $gpARp.setShowNewEditorSuccessFlag)();
            workflowId && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign((0, $cXnIM.getNewEditorLink)(workflowId));
        }
    }, [
        route?.name,
        showNewEditorSuccessFlag,
        workflowId
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $2IzSf.useOptOutFeedbackDialog)({
        projectType: projectType,
        onClose: redirectToLegacyEditorAndShowSuccessFlag
    });
    const onSelectNew = ()=>setSelectedWorkflowEditor((0, $d1waL.NEW_EDITOR));
    const onSelectOld = ()=>setSelectedWorkflowEditor((0, $d1waL.LEGACY_EDITOR));
    const onConfirmButtonClicked = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (_, analyticsEvent)=>{
        try {
            if (selectedWorkflowEditor === (0, $d1waL.LEGACY_EDITOR)) {
                await (0, $6fUC4.changeDefaultWorkflowEditorToLegacy)(analyticsEvent, workflowPublicationStatus);
                renderFeedbackDialog();
            }
            if (selectedWorkflowEditor === (0, $d1waL.NEW_EDITOR)) {
                await (0, $6fUC4.changeDefaultWorkflowEditorToNew)(analyticsEvent, workflowPublicationStatus);
                redirectToNewEditorAndShowSuccessFlag();
            }
            onClose();
        } catch (error) {
            showErrorFlag();
        }
    }, [
        selectedWorkflowEditor,
        onClose,
        renderFeedbackDialog,
        redirectToNewEditorAndShowSuccessFlag,
        showErrorFlag,
        workflowPublicationStatus
    ]);
    const link = 'https://support.atlassian.com/jira-service-management-cloud/docs/using-the-new-workflow-editor/';
    const learnMoreLink = formatMessage($2334f6d59347c35f$var$learnMoreLinki18n, {
        a: (chunks)=>(0, $7jTnu.fg)('replace-anchor-with-link__jsd-shield') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: link,
                target: "_blank"
            }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                href: link,
                target: "_blank"
            }, chunks)
    });
    const shouldShowWarningMessage = workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Draft || workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Dirty;
    const radioGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100"
    }, (0, $7jTnu.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $2334f6d59347c35f$var$boxStyles,
        onClick: onSelectNew,
        backgroundColor: selectedWorkflowEditor === (0, $d1waL.NEW_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.new-editor-radio"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
        isChecked: selectedWorkflowEditor === (0, $d1waL.NEW_EDITOR),
        ariaLabel: "New editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2334f6d59347c35f$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j7mKb))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), $2334f6d59347c35f$var$newWorkflowEditor))) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2334f6d59347c35f$var$boxStyles,
        onClick: onSelectNew,
        backgroundColor: selectedWorkflowEditor === (0, $d1waL.NEW_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.new-editor-radio"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
        isChecked: selectedWorkflowEditor === (0, $d1waL.NEW_EDITOR),
        ariaLabel: "New editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2334f6d59347c35f$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j7mKb))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), $2334f6d59347c35f$var$newWorkflowEditor))), (0, $7jTnu.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $2334f6d59347c35f$var$boxStyles,
        onClick: onSelectOld,
        padding: "space.200",
        backgroundColor: selectedWorkflowEditor === (0, $d1waL.LEGACY_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
        isChecked: selectedWorkflowEditor === (0, $d1waL.LEGACY_EDITOR),
        ariaLabel: "Old editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2334f6d59347c35f$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6sxbe))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), $2334f6d59347c35f$var$oldWorkflowEditor))) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $2334f6d59347c35f$var$boxStyles,
        onClick: onSelectOld,
        padding: "space.200",
        backgroundColor: selectedWorkflowEditor === (0, $d1waL.LEGACY_EDITOR) ? 'color.background.input.hovered' : 'color.background.neutral.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
        isChecked: selectedWorkflowEditor === (0, $d1waL.LEGACY_EDITOR),
        ariaLabel: "Old editor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2334f6d59347c35f$var$RadioIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6sxbe))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), $2334f6d59347c35f$var$oldWorkflowEditor))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.modal-dialog",
        messageType: "transactional",
        onClose: onClose,
        width: "medium",
        shouldCloseOnOverlayClick: false,
        shouldReturnFocus: returnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.title"
    }, formatMessage($2334f6d59347c35f$var$title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), $2334f6d59347c35f$var$body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2334f6d59347c35f$var$Info, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, learnMoreLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("legend", {
        className: (0, $hcewu.default)([
            "_11c8dcr7 _ca0qpxbi _n3tdu2gc _19bvze3t _u5f3ze3t _syaz131l _k48p1wq8"
        ])
    }, formatMessage($2334f6d59347c35f$var$instruction)), radioGroup), shouldShowWarningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2334f6d59347c35f$var$WarningContainer, {
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: "Warning",
        color: "var(--ds-text-warning, #A54800)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2334f6d59347c35f$var$WarningText, null, workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Draft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), $2334f6d59347c35f$var$draftUnpublishedWarning), workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Dirty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...$2334f6d59347c35f$var$dirtyLossWarning,
        values: {
            workflowName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, workflowName),
            update: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("i", null, formatMessage($2334f6d59347c35f$var$updateButton)),
            cancel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("i", null, formatMessage($2334f6d59347c35f$var$cancelButton))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClose,
        appearance: "subtle"
    }, formatMessage($2334f6d59347c35f$var$cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onConfirmButtonClicked,
        isDisabled: userPreference === selectedWorkflowEditor,
        appearance: "primary",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog.confirm-button"
    }, formatMessage($2334f6d59347c35f$var$confirmButton)))));
};
const $2334f6d59347c35f$export$6e60a479812ee7d6 = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, returnFocusRef: returnFocusRef, workflowPublicationStatus: workflowPublicationStatus = (0, $d1waL.WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jsm-error-boundary-default-workflow-editor-dialog",
        packageName: "workflow-editor-preference-settings",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2334f6d59347c35f$var$DefaultWorkflowEditorDialogInner, {
        workflowName: workflowName,
        projectType: projectType,
        onClose: onClose,
        onOpenDefaultEditorDialog: onOpenDefaultEditorDialog,
        workflowId: workflowId,
        workflowPublicationStatus: workflowPublicationStatus,
        shouldRedirectToDraftMode: shouldRedirectToDraftMode,
        returnFocusRef: returnFocusRef
    }));
};
const $2334f6d59347c35f$var$boxStyles = (0, $1DXK0.xcss)({
    borderStyle: 'solid',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    paddingLeft: 'space.050',
    paddingRight: 'space.500',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2334f6d59347c35f$var$Info = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2334f6d59347c35f$var$RadioIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1epz _u5f3pxbi _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $2334f6d59347c35f$var$legendStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2334f6d59347c35f$var$WarningContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2334f6d59347c35f$var$WarningText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc _16jlkb7n _syazwx40",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gPG64", function(module, exports) {

$parcel$export(module.exports, "default", () => $e69f9767f170f926$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $eGOwo = parcelRequire("eGOwo");
const $e69f9767f170f926$var$packageName = "platform-pkg";
const $e69f9767f170f926$var$packageVersion = "0.0.0-use.local";
const $e69f9767f170f926$var$noop = (0, $3Vuhz.default);
const $e69f9767f170f926$var$labelPaddingStyles = null;
const $e69f9767f170f926$var$labelStyles = null;
const $e69f9767f170f926$var$radioStyles = null;
const $e69f9767f170f926$var$newRadioStyles = null;
const $e69f9767f170f926$var$InnerRadio = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $e69f9767f170f926$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $e69f9767f170f926$var$packageName,
        packageVersion: $e69f9767f170f926$var$packageVersion
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $hcewu.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _4fps13gf _5ry313gf _qep213gf _180n13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _2kbk1y1w _6cyr1y1w _n8t01y1w _1o5r1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1if1zcs9 _bl0ezcs9 _92nazcs9 _awurzcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _wml015t7 _tusm15t7 _1c6f15t7 _qftt15t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $eGOwo.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $e69f9767f170f926$var$Radio = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e69f9767f170f926$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $e69f9767f170f926$export$2e2bcd8739ae039 = $e69f9767f170f926$var$Radio;

});

parcelRegister("2ZGUP", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $a9b037182c8fe3f4$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $a9b037182c8fe3f4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dM9A7 = parcelRequire("dM9A7");
const $a9b037182c8fe3f4$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $dM9A7.rootRegistry));
const $a9b037182c8fe3f4$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eJOHy.useMemo)(()=>new (0, $dM9A7.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eJOHy.useContext)($a9b037182c8fe3f4$export$ebbb59327adb551a) || (0, $dM9A7.rootRegistry);
    (0, $eJOHy.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a9b037182c8fe3f4$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $a9b037182c8fe3f4$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : $a9b037182c8fe3f4$var$ShortcutScope;

});
parcelRegister("dM9A7", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $7a2bff04dfa089d2$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $7a2bff04dfa089d2$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $5spib = parcelRequire("5spib");

var $exWdq = parcelRequire("exWdq");

var $jPROM = parcelRequire("jPROM");

var $f6sJp = parcelRequire("f6sJp");

var $aBrUN = parcelRequire("aBrUN");
const $7a2bff04dfa089d2$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $aBrUN.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $aBrUN.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $aBrUN.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $7a2bff04dfa089d2$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $7a2bff04dfa089d2$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($f6sJp)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($f6sJp)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$7a2bff04dfa089d2$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $7a2bff04dfa089d2$export$1dd4c61d1ce1fa15 = new $7a2bff04dfa089d2$export$ca1c75b575abf5ff();

});
parcelRegister("f6sJp", function(module, exports) {

var $l76qh = parcelRequire("l76qh");

var $d3H6Y = parcelRequire("d3H6Y");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $afedb3fdd807fe80$var$pull = $l76qh($d3H6Y);
module.exports = $afedb3fdd807fe80$var$pull;

});
parcelRegister("d3H6Y", function(module, exports) {

var $6zP82 = parcelRequire("6zP82");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $981cff3a37d3b5ca$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $6zP82(array, values) : array;
}
module.exports = $981cff3a37d3b5ca$var$pullAll;

});
parcelRegister("6zP82", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $kEE3x = parcelRequire("kEE3x");

var $8sQvY = parcelRequire("8sQvY");

var $cUaWv = parcelRequire("cUaWv");

var $k4ZVz = parcelRequire("k4ZVz");
/** Used for built-in method references. */ var $4c9dac120c4a59a8$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $4c9dac120c4a59a8$var$splice = $4c9dac120c4a59a8$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $4c9dac120c4a59a8$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $8sQvY : $kEE3x, index = -1, length = values.length, seen = array;
    if (array === values) values = $k4ZVz(values);
    if (iteratee) seen = $lylkU(array, $cUaWv(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $4c9dac120c4a59a8$var$splice.call(seen, fromIndex, 1);
            $4c9dac120c4a59a8$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $4c9dac120c4a59a8$var$basePullAll;

});
parcelRegister("8sQvY", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6299ac99ae510342$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $6299ac99ae510342$var$baseIndexOfWith;

});




parcelRegister("aBrUN", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $fc8b52be7fea903e$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $fc8b52be7fea903e$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $fc8b52be7fea903e$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $fc8b52be7fea903e$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $fc8b52be7fea903e$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $fc8b52be7fea903e$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $fc8b52be7fea903e$var$toKey = (e)=>{
    if ($fc8b52be7fea903e$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $fc8b52be7fea903e$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $fc8b52be7fea903e$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($fc8b52be7fea903e$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $fc8b52be7fea903e$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $fc8b52be7fea903e$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$fc8b52be7fea903e$var$orSpecialChars}))))?(meta\\+)?(${$fc8b52be7fea903e$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $fc8b52be7fea903e$var$shortcutRegex = RegExp(`^${$fc8b52be7fea903e$var$singleShortcutEntry}( ${$fc8b52be7fea903e$var$singleShortcutEntry})*$`);
const $fc8b52be7fea903e$export$8e231506c5580162 = (shortcut)=>$fc8b52be7fea903e$var$shortcutRegex.test(shortcut);
const $fc8b52be7fea903e$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("jwKNV", function(module, exports) {

$parcel$export(module.exports, "useNewWorkflowEditorPreference", () => $38bada46ecd51f25$export$b59c27df71e5edcf);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $gYnSx = parcelRequire("gYnSx");

var $8KUFq = parcelRequire("8KUFq");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $d1waL = parcelRequire("d1waL");

var $joel7 = parcelRequire("joel7");
const $38bada46ecd51f25$export$b59c27df71e5edcf = ()=>{
    const [editorType, setEditorType] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $joel7.getUserWorkflowEditorPreference)().then((pref)=>{
            setEditorType(pref);
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'getDefaultWorkflowEditorPreferance success');
        }).catch((error)=>{
            setEditorType(null);
            (0, $eSnSE.default).safeErrorWithoutCustomerData('workflow-Editor.preference', 'Unable to fetch workflow editor user preference', error);
            (0, $gYnSx.default)({
                meta: {
                    id: 'getDefaultWorkflowEditorPreference',
                    packageName: 'jiraWorkflowEditorPreferenceSettings'
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                attributes: {
                    isClientFetchError: (0, $8KUFq.isClientFetchError)(error)
                }
            });
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        createAnalyticsEvent
    ]);
    const shouldUseNewWorkFlowEditor = (0, $eJOHy.useMemo)(()=>{
        if (editorType === (0, $d1waL.NEW_EDITOR)) return true;
        if (!editorType && (0, $7jTnu.fg)('hix_new_wfe_as_default')) return true;
        return false;
    }, [
        editorType
    ]);
    return {
        shouldUseNewWorkFlowEditor: shouldUseNewWorkFlowEditor,
        userPreference: editorType,
        isLoading: isLoading
    };
};

});
parcelRegister("joel7", function(module, exports) {

$parcel$export(module.exports, "getUserWorkflowEditorPreference", () => $7429e35d72f4ed38$export$d9664e16e2fb1f27);

var $jGzN3 = parcelRequire("jGzN3");
const $7429e35d72f4ed38$var$workflowEditorPreferenceKey = 'jira.user.workflow.editor.global.scope.enrolment';
const $7429e35d72f4ed38$var$WORKFLOW_EDITOR_PREFERENCE_QUERY = `
query WorkflowEditorPreferenceQuery {
    myPreferences(keys: [
        "${$7429e35d72f4ed38$var$workflowEditorPreferenceKey}"
    ])
}
`;
const $7429e35d72f4ed38$export$d9664e16e2fb1f27 = async ()=>{
    const apiResult = await (0, $jGzN3.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $7429e35d72f4ed38$var$WORKFLOW_EDITOR_PREFERENCE_QUERY
        })
    });
    const preferences = apiResult?.data?.myPreferences;
    if (preferences) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return preferences[`${$7429e35d72f4ed38$var$workflowEditorPreferenceKey}`];
    const errorResponse = apiResult?.errors;
    if (errorResponse) throw new Error(`Error getting user preference: ${$7429e35d72f4ed38$var$workflowEditorPreferenceKey}`, {
        cause: apiResult?.errors?.[0] ?? 'unknown'
    });
    return null;
};

});


parcelRegister("2IzSf", function(module, exports) {

$parcel$export(module.exports, "useOptOutFeedbackDialog", () => $a007af859f476a1b$export$f692fac382bec058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5dqlp = parcelRequire("5dqlp");

var $igGHJ = parcelRequire("igGHJ");

var $lRq8t = parcelRequire("lRq8t");

var $hih5V = parcelRequire("hih5V");

var $kkHo2 = parcelRequire("kkHo2");

var $lvKO5 = parcelRequire("lvKO5");

var $ksXq7 = parcelRequire("ksXq7");
const $a007af859f476a1b$var$unknownAttributeValue = 'unknown';
const $a007af859f476a1b$var$FEEDBACK_GROUP_ID = 'workflow-editor-opt-out'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a007af859f476a1b$export$e4c3d9ebed5d4509 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $a007af859f476a1b$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, projectType: projectType, cloudId: cloudId })=>[
        {
            id: (0, $5dqlp.EntryKeys).LOCATION,
            value: (0, $kkHo2.default)(globalThis.window?.location.href)
        },
        {
            id: (0, $5dqlp.EntryKeys).REFERER,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: document.referrer ? (0, $kkHo2.default)(document.referrer) : ''
        },
        {
            id: (0, $5dqlp.EntryKeys).USER_AGENT,
            value: globalThis.navigator?.userAgent
        },
        {
            id: (0, $5dqlp.EntryKeys).SCREEN_RESOLUTION,
            value: `${globalThis.window?.screen?.width} x ${globalThis.window?.screen?.height}`
        },
        {
            id: (0, $5dqlp.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $5dqlp.EntryKeys).IS_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $5dqlp.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        }
    ];
const $a007af859f476a1b$export$f692fac382bec058 = ({ onClose: onClose = ()=>undefined, projectType: projectType })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $igGHJ.useFeedbackCollectorActions)();
    const route = (0, $hih5V.useCurrentRoute)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $lvKO5.useTenantContext)();
    const routeName = route.name ?? $a007af859f476a1b$var$unknownAttributeValue;
    const renderFeedbackDialog = (0, $eJOHy.useCallback)(()=>{
        openFeedbackCollector({
            entrypointId: (0, $5dqlp.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: $a007af859f476a1b$var$FEEDBACK_GROUP_ID,
            onClose: onClose,
            feedbackContext: $a007af859f476a1b$export$b028e515f8f652e0({
                isSiteAdmin: isSiteAdmin,
                cloudId: cloudId,
                routeName: routeName,
                projectType: projectType || $a007af859f476a1b$var$unknownAttributeValue
            }),
            feedbackGroupLabels: {
                empty: {
                    selectOptionLabel: formatMessage((0, $ksXq7.default).reasonPlaceholder)
                },
                bug: {
                    fieldLabel: formatMessage((0, $ksXq7.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $ksXq7.default).reasonBug)
                },
                comment: {
                    fieldLabel: formatMessage((0, $ksXq7.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $ksXq7.default).reasonComment)
                },
                suggestion: {
                    fieldLabel: formatMessage((0, $ksXq7.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $ksXq7.default).reasonOthers)
                },
                question: {
                    fieldLabel: formatMessage((0, $ksXq7.default).fieldLabel),
                    selectOptionLabel: formatMessage((0, $ksXq7.default).reasonQuestion)
                }
            },
            feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a007af859f476a1b$export$e4c3d9ebed5d4509, null, formatMessage((0, $ksXq7.default).feedbackTitleDetails)),
            selectLabel: formatMessage((0, $ksXq7.default).feedbackTitleDetailsQuestion),
            cancelButtonLabel: formatMessage((0, $ksXq7.default).feedbackCancelButton)
        });
    }, [
        formatMessage,
        openFeedbackCollector,
        onClose,
        isSiteAdmin,
        cloudId,
        routeName,
        projectType
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};

});
parcelRegister("5dqlp", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $ee7e4c92cf35d1d1$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $ee7e4c92cf35d1d1$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $ee7e4c92cf35d1d1$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $ee7e4c92cf35d1d1$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $ee7e4c92cf35d1d1$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $ee7e4c92cf35d1d1$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $ee7e4c92cf35d1d1$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $ee7e4c92cf35d1d1$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", () => $ee7e4c92cf35d1d1$export$5bd148c13bb23f7a);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $ee7e4c92cf35d1d1$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $ee7e4c92cf35d1d1$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $ee7e4c92cf35d1d1$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", () => $ee7e4c92cf35d1d1$export$23f6d7b16d2210c1);
$parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", () => $ee7e4c92cf35d1d1$export$1b65c2053cba0686);
$parcel$export(module.exports, "ENTRYPOINT_ID_PROJECT_BACKGROUNDS", () => $ee7e4c92cf35d1d1$export$9a234699f0515bf);
$parcel$export(module.exports, "ENTRY_POINT_ID_JOURNEY_BUILDER", () => $ee7e4c92cf35d1d1$export$f24169c529e6c9b5);
$parcel$export(module.exports, "EntryKeys", () => $ee7e4c92cf35d1d1$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $ee7e4c92cf35d1d1$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $ee7e4c92cf35d1d1$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $ee7e4c92cf35d1d1$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $ee7e4c92cf35d1d1$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $ee7e4c92cf35d1d1$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $ee7e4c92cf35d1d1$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $ee7e4c92cf35d1d1$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $ee7e4c92cf35d1d1$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $ee7e4c92cf35d1d1$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
const $ee7e4c92cf35d1d1$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $ee7e4c92cf35d1d1$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $ee7e4c92cf35d1d1$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $ee7e4c92cf35d1d1$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
const $ee7e4c92cf35d1d1$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
const $ee7e4c92cf35d1d1$export$86e0eeb08f5b7ea6 = 'ee8a71e7-85aa-4121-b455-e6316922e894';
const $ee7e4c92cf35d1d1$export$9a234699f0515bf = 'd0f0863a-fe78-4d40-b4f0-451c268594cc';
const $ee7e4c92cf35d1d1$export$f24169c529e6c9b5 = 'd5f62dde-d505-413b-a417-c2dd6979cac2';
const $ee7e4c92cf35d1d1$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment',
    SMART_REPLIES: 'smart-replies',
    COLLABORATIVE_SPRINTS: 'collaborative-sprints',
    PROJECT_RECAP_FEEDBACK_GROUP_ID: 'jira-notifications-project-recap'
});

});

parcelRegister("igGHJ", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $c308bdd6cba7f75a$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $c308bdd6cba7f75a$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $c308bdd6cba7f75a$export$c35dbf16ebe9df04);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $c308bdd6cba7f75a$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined,
    customFeedbackOptions: []
};
const $c308bdd6cba7f75a$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($c308bdd6cba7f75a$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$c308bdd6cba7f75a$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $c308bdd6cba7f75a$var$Store = (0, $GtRbT.createStore)({
    name: 'feedback-collector',
    initialState: $c308bdd6cba7f75a$export$d4c72bab9d6cc13a,
    actions: $c308bdd6cba7f75a$export$e324594224ef24da
});
const $c308bdd6cba7f75a$export$4be696be8a3bff13 = (0, $iJq0l.createHook)($c308bdd6cba7f75a$var$Store);
const $c308bdd6cba7f75a$export$dfb2ee2d9e73fa48 = (0, $iJq0l.createActionsHook)($c308bdd6cba7f75a$var$Store);
const $c308bdd6cba7f75a$export$c35dbf16ebe9df04 = (0, $ht3nQ.createSubscriber)($c308bdd6cba7f75a$var$Store, {
    selector: null
});

});

parcelRegister("ksXq7", function(module, exports) {

$parcel$export(module.exports, "default", () => $112be8f9eef4f25d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $112be8f9eef4f25d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    reasonPlaceholder: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-placeholder",
        "defaultMessage": "Select an option"
    },
    reasonQuestion: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-question",
        "defaultMessage": "Missing features"
    },
    reasonBug: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-bug",
        "defaultMessage": "Bugs"
    },
    reasonComment: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-comment",
        "defaultMessage": "Prefer old editor"
    },
    reasonOthers: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.reason-others",
        "defaultMessage": "Other"
    },
    fieldLabel: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.field-label",
        "defaultMessage": "Add details to help us improve the workflow editor for everyone."
    },
    feedbackTitleDetails: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-title-details",
        "defaultMessage": "Help us improve your experience with the new workflow editor."
    },
    feedbackTitleDetailsQuestion: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-title-details-question",
        "defaultMessage": "Let us know why you\u2019re moving to the old editor"
    },
    feedbackCancelButton: {
        "id": "workflow-editor-preference-settings.controllers.opt-out-feedback.feedback-cancel-button",
        "defaultMessage": "Skip step"
    }
});

});


parcelRegister("6fUC4", function(module, exports) {

$parcel$export(module.exports, "changeDefaultWorkflowEditorToLegacy", () => $150a4d883c5983ea$export$f16799cd8f24c0e2);
$parcel$export(module.exports, "changeDefaultWorkflowEditorToNew", () => $150a4d883c5983ea$export$e03a9424d4619803);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $gCeeo = parcelRequire("gCeeo");

var $d1waL = parcelRequire("d1waL");
const $150a4d883c5983ea$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $150a4d883c5983ea$var$setGlobalScopeUserPreference = async (input)=>{
    const result = await (0, $jGzN3.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $150a4d883c5983ea$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
            variables: {
                input: input
            }
        })
    });
    if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
        cause: result.errors?.[0] ?? 'unknown'
    });
};
const $150a4d883c5983ea$export$f16799cd8f24c0e2 = async (analyticsEvent, workflowPublicationStatus)=>{
    try {
        await $150a4d883c5983ea$var$setGlobalScopeUserPreference({
            key: 'jira.user.workflow.editor.global.scope.enrolment',
            value: (0, $d1waL.LEGACY_EDITOR)
        });
        (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'legacyWorkflowEditorUserPreference set', {
            workflowPublicationStatus: workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Dirty ? 'Unsaved' // user-friendly term to use instead of Dirty
             : (0, $d1waL.WorkflowPublicationStatus)[workflowPublicationStatus]
        });
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'changeDefaultWorkflowEditorToLegacy',
                packageName: 'jiraWorkflowEditorPreferenceSettings'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        });
        throw error;
    }
};
const $150a4d883c5983ea$export$e03a9424d4619803 = async (analyticsEvent, workflowPublicationStatus)=>{
    try {
        await $150a4d883c5983ea$var$setGlobalScopeUserPreference({
            key: 'jira.user.workflow.editor.global.scope.enrolment',
            value: (0, $d1waL.NEW_EDITOR)
        });
        (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'newWorkflowEditorUserPreference set', {
            workflowPublicationStatus: workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Dirty ? 'Unsaved' // user-friendly term to use instead of Dirty
             : (0, $d1waL.WorkflowPublicationStatus)[workflowPublicationStatus]
        });
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'changeDefaultWorkflowEditorToNew',
                packageName: 'jiraWorkflowEditorPreferenceSettings'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        });
        throw error;
    }
};

});

parcelRegister("j7mKb", function(module, exports) {
module.exports = new URL("newEditorImage.very-specific-illu.5e606ca1.png", import.meta.url).toString();

});

parcelRegister("6sxbe", function(module, exports) {
module.exports = new URL("oldEditorImage.very-specific-illu.51f0890e.png", import.meta.url).toString();

});


parcelRegister("jbiOt", function(module, exports) {

$parcel$export(module.exports, "DefaultWorkflowEditorDialog", () => $c9abc1c78f144cf1$export$6e60a479812ee7d6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $cDJ0f = parcelRequire("cDJ0f");

var $5CSKW = parcelRequire("5CSKW");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $gPG64 = parcelRequire("gPG64");

var $806LH = parcelRequire("806LH");

var $3cMgR = parcelRequire("3cMgR");

var $jdqdp = parcelRequire("jdqdp");

var $jkYbX = parcelRequire("jkYbX");

var $aC4Bh = parcelRequire("aC4Bh");

var $2ZGUP = parcelRequire("2ZGUP");

var $1KdDN = parcelRequire("1KdDN");

var $7qGN1 = parcelRequire("7qGN1");
var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $cXnIM = parcelRequire("cXnIM");

var $kfvK2 = parcelRequire("kfvK2");

var $astsx = parcelRequire("astsx");

var $7jTnu = parcelRequire("7jTnu");

var $d1waL = parcelRequire("d1waL");

var $9MgGx = parcelRequire("9MgGx");

var $jwKNV = parcelRequire("jwKNV");

var $2IzSf = parcelRequire("2IzSf");

var $6fUC4 = parcelRequire("6fUC4");

var $gpARp = parcelRequire("gpARp");
const $c9abc1c78f144cf1$var$title = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.title',
    defaultMessage: 'Change workflow editor preference',
    description: 'Heading for the default workflow modal.'
});
const $c9abc1c78f144cf1$var$instruction = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.instruction',
    defaultMessage: 'Preferred workflow editor',
    description: 'Instruction text to choose default editor.'
});
const $c9abc1c78f144cf1$var$workflowEditorNewLabel = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-new-label',
    defaultMessage: 'Workflow editor',
    description: 'Label of workflow editor new option.'
});
const $c9abc1c78f144cf1$var$workflowEditorOldLabel = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-old-label',
    defaultMessage: 'Workflow editor',
    description: 'Label of workflow editor old option.'
});
const $c9abc1c78f144cf1$var$workflowEditorNewDescription = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-new-description',
    defaultMessage: 'Simplified setup and changes, all in one screen. Easier updates. Bonus <strong>Workflow builder</strong> agent support for AI enabled sites.',
    description: 'Description of workflow editor new option.'
});
const $c9abc1c78f144cf1$var$workflowEditorOldDescription = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-old-description',
    defaultMessage: "Keep using the old editor until it\u2019s no longer available from  early 2026. Any unsaved drafts in the old editor will be lost after this time.",
    description: 'Description of workflow editor old option.'
});
const $c9abc1c78f144cf1$var$workflowEditorNewLozenge = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-new-lozenge',
    defaultMessage: 'New',
    description: 'Label for workflow editor new icon.'
});
const $c9abc1c78f144cf1$var$workflowEditorOldLozenge = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.workflow-editor-old-lozenge',
    defaultMessage: 'Old',
    description: 'Label for workflow editor old icon.'
});
const $c9abc1c78f144cf1$var$cancelButton = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.cancel-button',
    defaultMessage: 'Cancel',
    description: 'Label for back button.'
});
const $c9abc1c78f144cf1$var$confirmButton = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.confirm-button',
    defaultMessage: 'Confirm',
    description: 'Label for confirm button.'
});
const $c9abc1c78f144cf1$var$updateButton = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.update-button',
    defaultMessage: 'Update',
    description: 'Label for update button.'
});
const $c9abc1c78f144cf1$var$warning = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.warning-label',
    defaultMessage: 'Warning',
    description: 'Label for the warning icon in the workflow editor preference dialog.'
});
const $c9abc1c78f144cf1$var$draftUnpublishedWarning = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.draft-unpublished-warning',
    defaultMessage: 'Publish your draft workflow before continuing so that your edits will be visible in the new workflow editor.',
    description: 'A warning message informing users to publish their draft their workflow before switching workflow editors as otherwise the changes will not be reflected in the new editor.'
});
const $c9abc1c78f144cf1$var$dirtyLossWarning = (0, $7qGN1.defineMessage)({
    id: 'workflow-editor-preference-settings.default-workflow-editor-dialog.dirty-loss-warning',
    defaultMessage: "You\u2019ve made changes to {workflowName}. To save those changes select {cancel}, then {update} workflow before continuing.",
    description: 'A warning message informing users to save any changes to their workflow before switching workflow editors as they will otherwise be lost.'
});
const $c9abc1c78f144cf1$var$DefaultWorkflowEditorDialogInner = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, returnFocusRef: returnFocusRef, workflowPublicationStatus: workflowPublicationStatus = (0, $d1waL.WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
    (0, $gRw8I.di)(window);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [selectedWorkflowEditor, setSelectedWorkflowEditor] = (0, $eJOHy.useState)(null);
    const { route: route } = (0, $kfvK2.createRouterSelector)((state)=>state)();
    const { userPreference: userPreference, shouldUseNewWorkFlowEditor: shouldUseNewWorkFlowEditor, isLoading: isLoading } = (0, $jwKNV.useNewWorkflowEditorPreference)();
    const { showNewEditorSuccessFlag: showNewEditorSuccessFlag, showOldEditorSuccessFlag: showOldEditorSuccessFlag, showErrorFlag: showErrorFlag } = (0, $9MgGx.useChangePreferenceFlag)();
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading) return;
        setSelectedWorkflowEditor(userPreference || (shouldUseNewWorkFlowEditor ? (0, $d1waL.NEW_EDITOR) : (0, $d1waL.LEGACY_EDITOR)));
    }, [
        userPreference,
        setSelectedWorkflowEditor,
        shouldUseNewWorkFlowEditor,
        isLoading
    ]);
    const redirectToLegacyEditorAndShowSuccessFlag = (0, $eJOHy.useCallback)(()=>{
        if (route?.name === 'global-settings-issues-workflows-pages') showOldEditorSuccessFlag(onOpenDefaultEditorDialog);
        else {
            // set flag to show success flag in session storage when user is redirected to legacy editor
            (0, $gpARp.setShowOldEditorSuccessFlag)(); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(shouldRedirectToDraftMode ? (0, $cXnIM.buildEditWorkflowJSPUrl)(workflowName) : (0, $cXnIM.getLegacyEditorLink)(workflowName));
        }
    }, [
        route?.name,
        shouldRedirectToDraftMode,
        showOldEditorSuccessFlag,
        workflowName,
        onOpenDefaultEditorDialog
    ]);
    const redirectToNewEditorAndShowSuccessFlag = (0, $eJOHy.useCallback)(()=>{
        if (route?.name === 'global-settings-issues-workflow-edit') showNewEditorSuccessFlag();
        else {
            // set flag to show success flag in session storage when user is redirected to new editor
            (0, $gpARp.setShowNewEditorSuccessFlag)();
            workflowId && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign((0, $cXnIM.getNewEditorLink)(workflowId));
        }
    }, [
        route?.name,
        showNewEditorSuccessFlag,
        workflowId
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $2IzSf.useOptOutFeedbackDialog)({
        projectType: projectType,
        onClose: redirectToLegacyEditorAndShowSuccessFlag
    });
    const onSelectWorkflowEditor = ()=>setSelectedWorkflowEditor((0, $d1waL.NEW_EDITOR));
    const onSelectWorkflowEditorLegacy = ()=>setSelectedWorkflowEditor((0, $d1waL.LEGACY_EDITOR));
    const onConfirmButtonClicked = (0, $eJOHy.useCallback)(async (_, analyticsEvent)=>{
        try {
            if (selectedWorkflowEditor === (0, $d1waL.LEGACY_EDITOR)) {
                await (0, $6fUC4.changeDefaultWorkflowEditorToLegacy)(analyticsEvent, workflowPublicationStatus);
                renderFeedbackDialog();
            }
            if (selectedWorkflowEditor === (0, $d1waL.NEW_EDITOR)) {
                await (0, $6fUC4.changeDefaultWorkflowEditorToNew)(analyticsEvent, workflowPublicationStatus);
                redirectToNewEditorAndShowSuccessFlag();
            }
            onClose();
        } catch (error) {
            showErrorFlag();
        }
    }, [
        selectedWorkflowEditor,
        onClose,
        renderFeedbackDialog,
        redirectToNewEditorAndShowSuccessFlag,
        showErrorFlag,
        workflowPublicationStatus
    ]);
    const shouldShowWarningMessage = workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Draft || workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Dirty;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog-new.modal-dialog.default-workflow-editor-dialog-new2.modal-dialog.default-workflow-editor-dialog.modal-dialog",
        messageType: "transactional",
        onClose: onClose,
        width: "531px",
        shouldCloseOnOverlayClick: (0, $7jTnu.fg)('jif_jam_wfe_ui_fixes'),
        shouldReturnFocus: returnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog-new.title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c9abc1c78f144cf1$var$headingStyles
    }, formatMessage($c9abc1c78f144cf1$var$title)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("legend", {
        className: (0, $hcewu.default)([
            "_ca0qpxbi _n3tdpxbi _19bvze3t _u5f3ze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage($c9abc1c78f144cf1$var$instruction))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
        isChecked: selectedWorkflowEditor === (0, $d1waL.NEW_EDITOR),
        id: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog-new.workflow-editor-new",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog-new.workflow-editor-new",
        onClick: onSelectWorkflowEditor,
        value: (0, $d1waL.NEW_EDITOR),
        name: "workflowEditor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog-new.workflow-editor-new"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: $c9abc1c78f144cf1$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h3"
    }, formatMessage($c9abc1c78f144cf1$var$workflowEditorNewLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage($c9abc1c78f144cf1$var$workflowEditorNewLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "p"
    }, formatMessage($c9abc1c78f144cf1$var$workflowEditorNewDescription, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $astsx.default), {
        alt: "",
        width: "96"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPG64.default), {
        isChecked: selectedWorkflowEditor === (0, $d1waL.LEGACY_EDITOR),
        id: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog-new.workflow-editor-old",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog-new.workflow-editor-old",
        onClick: onSelectWorkflowEditorLegacy,
        value: (0, $d1waL.LEGACY_EDITOR),
        name: "workflowEditor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog-new.workflow-editor-old"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        xcss: $c9abc1c78f144cf1$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h3"
    }, formatMessage($c9abc1c78f144cf1$var$workflowEditorOldLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), null, formatMessage($c9abc1c78f144cf1$var$workflowEditorOldLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "p"
    }, formatMessage($c9abc1c78f144cf1$var$workflowEditorOldDescription))))))), shouldShowWarningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        role: "alert",
        xcss: $c9abc1c78f144cf1$var$warningContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: formatMessage($c9abc1c78f144cf1$var$warning),
        color: "var(--ds-text-warning, #A54800)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c9abc1c78f144cf1$var$warningTextStyles
    }, workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Draft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), $c9abc1c78f144cf1$var$draftUnpublishedWarning), workflowPublicationStatus === (0, $d1waL.WorkflowPublicationStatus).Dirty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...$c9abc1c78f144cf1$var$dirtyLossWarning,
        values: {
            workflowName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, workflowName),
            update: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("i", null, formatMessage($c9abc1c78f144cf1$var$updateButton)),
            cancel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("i", null, formatMessage($c9abc1c78f144cf1$var$cancelButton))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: onClose,
        appearance: "subtle"
    }, formatMessage($c9abc1c78f144cf1$var$cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: onConfirmButtonClicked,
        isDisabled: userPreference === selectedWorkflowEditor,
        appearance: "primary",
        testId: "workflow-editor-preference-settings.ui.default-workflow-editor-dialog-new.confirm-button"
    }, formatMessage($c9abc1c78f144cf1$var$confirmButton)))));
};
const $c9abc1c78f144cf1$export$6e60a479812ee7d6 = ({ workflowName: workflowName, projectType: projectType, onClose: onClose, onOpenDefaultEditorDialog: onOpenDefaultEditorDialog, workflowId: workflowId, returnFocusRef: returnFocusRef, workflowPublicationStatus: workflowPublicationStatus = (0, $d1waL.WorkflowPublicationStatus).None, shouldRedirectToDraftMode: shouldRedirectToDraftMode = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "jsm-error-boundary-default-workflow-editor-dialog",
        packageName: "workflow-editor-preference-settings",
        teamName: "jsd-shield",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9abc1c78f144cf1$var$DefaultWorkflowEditorDialogInner, {
        workflowName: workflowName,
        projectType: projectType,
        onClose: onClose,
        onOpenDefaultEditorDialog: onOpenDefaultEditorDialog,
        workflowId: workflowId,
        workflowPublicationStatus: workflowPublicationStatus,
        shouldRedirectToDraftMode: shouldRedirectToDraftMode,
        returnFocusRef: returnFocusRef
    }));
};
const $c9abc1c78f144cf1$var$headingStyles = (0, $1DXK0.xcss)({
    fontWeight: 'font.weight.medium'
});
const $c9abc1c78f144cf1$var$boxStyles = (0, $1DXK0.xcss)({
    borderStyle: 'solid',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    flex: 1
});
const $c9abc1c78f144cf1$var$legendStyles = null;
const $c9abc1c78f144cf1$var$warningContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    paddingTop: 'space.100',
    paddingRight: 'space.0',
    paddingBottom: 'space.100',
    paddingLeft: 'space.0'
});
const $c9abc1c78f144cf1$var$warningTextStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.100',
    flexGrow: 1,
    color: 'color.text.warning'
});

});
parcelRegister("cDJ0f", function(module, exports) {

$parcel$export(module.exports, "Label", () => $ed0e34f34427bb25$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $ed0e34f34427bb25$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $ed0e34f34427bb25$var$fieldsetLabelStyles = null;
const $ed0e34f34427bb25$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $ed0e34f34427bb25$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("legend", {
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("astsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc6278c832b7558$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $cMl8Z = parcelRequire("cMl8Z");

var $7MuCh = parcelRequire("7MuCh");
const $7cc6278c832b7558$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cMl8Z)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7MuCh))
});
var $7cc6278c832b7558$export$2e2bcd8739ae039 = $7cc6278c832b7558$var$Illustration;
const $7cc6278c832b7558$export$a179c88182cb9d56 = [
    0,
    0,
    42,
    48
];

});
parcelRegister("cMl8Z", function(module, exports) {
module.exports = new URL("workflow-builder-splash.9f5889b8.svg", import.meta.url).toString();

});

parcelRegister("7MuCh", function(module, exports) {
module.exports = new URL("workflow-builder-splash-darkmode.7000c4e5.svg", import.meta.url).toString();

});






parcelRegister("51bMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $81393134c264c44b$export$2e2bcd8739ae039);
const $81393134c264c44b$var$applyLazyOpts = (route)=>{
    if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
        const hydratedRoute = {
            ...route,
            ...route.lazyOpts()
        };
        delete hydratedRoute.lazyOpts;
        return hydratedRoute;
    }
    return route;
};
var $81393134c264c44b$export$2e2bcd8739ae039 = $81393134c264c44b$var$applyLazyOpts;

});


parcelRegister("lZMpx", function(module, exports) {

$parcel$export(module.exports, "getSpaRouterContext", () => $80de4900a6305c9e$export$1f61c5e3f6410afa);
const $80de4900a6305c9e$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
        tenantContext: tenantContext
    });

});

parcelRegister("9aXOX", function(module, exports) {

$parcel$export(module.exports, "visualRefreshResolverOverride", () => $d5b8ada04860b81e$export$73a94df81a7c0f2c);

var $6XJko = parcelRequire("6XJko");
const $d5b8ada04860b81e$var$visualRefreshPlatformFlags = [
    'platform-component-visual-refresh',
    'platform-visual-refresh-icons-legacy-facade',
    'platform-visual-refresh-icons'
];
const $d5b8ada04860b81e$export$73a94df81a7c0f2c = [
    (flagKey)=>$d5b8ada04860b81e$var$visualRefreshPlatformFlags.includes(flagKey),
    (0, $6XJko.isVisualRefreshEnabled)
];

});
parcelRegister("6XJko", function(module, exports) {

$parcel$export(module.exports, "isVisualRefreshEnabled", () => $ac9280cd0f5c90b2$export$48345cb467db19b6);

var $6zXPf = parcelRequire("6zXPf");
const $ac9280cd0f5c90b2$export$48345cb467db19b6 = ()=>(0, $6zXPf.getWillShowNav4)();

});


parcelRegister("5lCDr", function(module, exports) {

let $3e4ce20d71278fe3$var$load = (parcelRequire("gLHA4"))(4);



module.exports = Promise.all([
    (parcelRequire("g81qY"))('edition_awareness_upsell_jira_ab_fg', function() {
        return Promise.all([
            $3e4ce20d71278fe3$var$load("dHAND")
        ]);
    }, function() {
        return Promise.all([
            $3e4ce20d71278fe3$var$load("aQyvI")
        ]);
    }),
    (parcelRequire("g81qY"))('edition_awareness_upsell_jira_ab_fg', function() {
        return Promise.all([
            $3e4ce20d71278fe3$var$load("dHAND")
        ]);
    }, function() {
        return Promise.all([
            $3e4ce20d71278fe3$var$load("aQyvI")
        ]);
    }),
    (parcelRequire("g81qY"))('jira-concurrent-update-while-rendering', function() {
        return Promise.all([
            $3e4ce20d71278fe3$var$load("cY2SU")
        ]);
    }, function() {
        return Promise.all([
            $3e4ce20d71278fe3$var$load("74PVH")
        ]);
    }),
    $3e4ce20d71278fe3$var$load("7mIf9"),
    $3e4ce20d71278fe3$var$load("jXweD"),
    $3e4ce20d71278fe3$var$load("kNFvF"),
    $3e4ce20d71278fe3$var$load("ffQaD"),
    $3e4ce20d71278fe3$var$load("kvRbA"),
    $3e4ce20d71278fe3$var$load("kVX56"),
    $3e4ce20d71278fe3$var$load("76n7a"),
    $3e4ce20d71278fe3$var$load("l253H"),
    $3e4ce20d71278fe3$var$load("3u1oh")
]).then(()=>parcelRequire('hGILB'));

});



$parcel$global.rwr("8l96k", () => { parcelRequire("3gZ8E");
parcelRequire("dUYS2");

var $fWKP5 = parcelRequire("fWKP5");

var $13dJw = parcelRequire("13dJw");
(0, $13dJw.default).install();
(0, $fWKP5.provideHealthcheck)();
 }, ["kVX56","jXweD","7mIf9","fliVL","kNFvF","b3QiB","isfJL","7imUH","jbxE1","3yAl4","l253H","76n7a","kvRbA","ffQaD","5CZJs"]);

$parcel$global.rlb("8l96k")
//# sourceMappingURL=global-single-fragment.b4dedddc.js.map
